
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3981"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3981"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("h2IFn", function(module, exports) {
module.exports = $parcel$import("gQ9Hr").then(()=>parcelRequire('fM4uO'));

});

parcelRegister("4TJBG", function(module, exports) {
module.exports = $parcel$import("bBXqk").then(()=>parcelRequire('49uHQ'));

});

var $73d35774ebd2cda2$exports = {};
$parcel$extendImportMap({
    "gQ9Hr": "replay-V6FXES7X.9d4d893e.js",
    "1jVtq": "sleep-melody.11def170.mp3",
    "8pkWx": "sw.js",
    "bBXqk": "seo-content.a8d56f9c.js"
});

class $5b93b93a09fbaeb8$var$$e8379818650e2442$export$93654d4f2d6cd524 {
    append_buffer(data) {
        this.flush();
        this._parts.push(data);
    }
    append(data) {
        this._pieces.push(data);
    }
    flush() {
        if (this._pieces.length > 0) {
            const buf = new Uint8Array(this._pieces);
            this._parts.push(buf);
            this._pieces = [];
        }
    }
    toArrayBuffer() {
        const buffer = [];
        for (const part of this._parts)buffer.push(part);
        return $5b93b93a09fbaeb8$var$$e8379818650e2442$var$concatArrayBuffers(buffer).buffer;
    }
    constructor(){
        this.encoder = new TextEncoder();
        this._pieces = [];
        this._parts = [];
    }
}
function $5b93b93a09fbaeb8$var$$e8379818650e2442$var$concatArrayBuffers(bufs) {
    let size = 0;
    for (const buf of bufs)size += buf.byteLength;
    const result = new Uint8Array(size);
    let offset = 0;
    for (const buf of bufs){
        const view = new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
        result.set(view, offset);
        offset += buf.byteLength;
    }
    return result;
}
function $5b93b93a09fbaeb8$export$417857010dc9287f(data) {
    const unpacker = new $5b93b93a09fbaeb8$var$$0cfd7828ad59115f$var$Unpacker(data);
    return unpacker.unpack();
}
function $5b93b93a09fbaeb8$export$2a703dbb0cb35339(data) {
    const packer = new $5b93b93a09fbaeb8$export$b9ec4b114aa40074();
    const res = packer.pack(data);
    if (res instanceof Promise) return res.then(()=>packer.getBuffer());
    return packer.getBuffer();
}
class $5b93b93a09fbaeb8$var$$0cfd7828ad59115f$var$Unpacker {
    unpack() {
        const type = this.unpack_uint8();
        if (type < 0x80) return type;
        else if ((type ^ 0xe0) < 0x20) return (type ^ 0xe0) - 0x20;
        let size;
        if ((size = type ^ 0xa0) <= 0x0f) return this.unpack_raw(size);
        else if ((size = type ^ 0xb0) <= 0x0f) return this.unpack_string(size);
        else if ((size = type ^ 0x90) <= 0x0f) return this.unpack_array(size);
        else if ((size = type ^ 0x80) <= 0x0f) return this.unpack_map(size);
        switch(type){
            case 0xc0:
                return null;
            case 0xc1:
                return undefined;
            case 0xc2:
                return false;
            case 0xc3:
                return true;
            case 0xca:
                return this.unpack_float();
            case 0xcb:
                return this.unpack_double();
            case 0xcc:
                return this.unpack_uint8();
            case 0xcd:
                return this.unpack_uint16();
            case 0xce:
                return this.unpack_uint32();
            case 0xcf:
                return this.unpack_uint64();
            case 0xd0:
                return this.unpack_int8();
            case 0xd1:
                return this.unpack_int16();
            case 0xd2:
                return this.unpack_int32();
            case 0xd3:
                return this.unpack_int64();
            case 0xd4:
                return undefined;
            case 0xd5:
                return undefined;
            case 0xd6:
                return undefined;
            case 0xd7:
                return undefined;
            case 0xd8:
                size = this.unpack_uint16();
                return this.unpack_string(size);
            case 0xd9:
                size = this.unpack_uint32();
                return this.unpack_string(size);
            case 0xda:
                size = this.unpack_uint16();
                return this.unpack_raw(size);
            case 0xdb:
                size = this.unpack_uint32();
                return this.unpack_raw(size);
            case 0xdc:
                size = this.unpack_uint16();
                return this.unpack_array(size);
            case 0xdd:
                size = this.unpack_uint32();
                return this.unpack_array(size);
            case 0xde:
                size = this.unpack_uint16();
                return this.unpack_map(size);
            case 0xdf:
                size = this.unpack_uint32();
                return this.unpack_map(size);
        }
    }
    unpack_uint8() {
        const byte = this.dataView[this.index] & 0xff;
        this.index++;
        return byte;
    }
    unpack_uint16() {
        const bytes = this.read(2);
        const uint16 = (bytes[0] & 0xff) * 256 + (bytes[1] & 0xff);
        this.index += 2;
        return uint16;
    }
    unpack_uint32() {
        const bytes = this.read(4);
        const uint32 = ((bytes[0] * 256 + bytes[1]) * 256 + bytes[2]) * 256 + bytes[3];
        this.index += 4;
        return uint32;
    }
    unpack_uint64() {
        const bytes = this.read(8);
        const uint64 = ((((((bytes[0] * 256 + bytes[1]) * 256 + bytes[2]) * 256 + bytes[3]) * 256 + bytes[4]) * 256 + bytes[5]) * 256 + bytes[6]) * 256 + bytes[7];
        this.index += 8;
        return uint64;
    }
    unpack_int8() {
        const uint8 = this.unpack_uint8();
        return uint8 < 0x80 ? uint8 : uint8 - 256;
    }
    unpack_int16() {
        const uint16 = this.unpack_uint16();
        return uint16 < 0x8000 ? uint16 : uint16 - 65536;
    }
    unpack_int32() {
        const uint32 = this.unpack_uint32();
        return uint32 < 2 ** 31 ? uint32 : uint32 - 2 ** 32;
    }
    unpack_int64() {
        const uint64 = this.unpack_uint64();
        return uint64 < 2 ** 63 ? uint64 : uint64 - 2 ** 64;
    }
    unpack_raw(size) {
        if (this.length < this.index + size) throw new Error(`BinaryPackFailure: index is out of range ${this.index} ${size} ${this.length}`);
        const buf = this.dataBuffer.slice(this.index, this.index + size);
        this.index += size;
        return buf;
    }
    unpack_string(size) {
        const bytes = this.read(size);
        let i = 0;
        let str = "";
        let c;
        let code;
        while(i < size){
            c = bytes[i];
            // The length of a UTF-8 sequence is specified in the first byte:
            // 0xxxxxxx means length 1,
            // 110xxxxx means length 2,
            // 1110xxxx means length 3,
            // 11110xxx means length 4.
            // 10xxxxxx is for non-initial bytes.
            if (c < 0xa0) {
                // One-byte sequence: bits 0xxxxxxx
                code = c;
                i++;
            } else if ((c ^ 0xc0) < 0x20) {
                // Two-byte sequence: bits 110xxxxx 10xxxxxx
                code = (c & 0x1f) << 6 | bytes[i + 1] & 0x3f;
                i += 2;
            } else if ((c ^ 0xe0) < 0x10) {
                // Three-byte sequence: bits 1110xxxx 10xxxxxx 10xxxxxx
                code = (c & 0x0f) << 12 | (bytes[i + 1] & 0x3f) << 6 | bytes[i + 2] & 0x3f;
                i += 3;
            } else {
                // Four-byte sequence: bits 11110xxx 10xxxxxx 10xxxxxx 10xxxxxx
                code = (c & 0x07) << 18 | (bytes[i + 1] & 0x3f) << 12 | (bytes[i + 2] & 0x3f) << 6 | bytes[i + 3] & 0x3f;
                i += 4;
            }
            str += String.fromCodePoint(code);
        }
        this.index += size;
        return str;
    }
    unpack_array(size) {
        const objects = new Array(size);
        for(let i = 0; i < size; i++)objects[i] = this.unpack();
        return objects;
    }
    unpack_map(size) {
        const map = {};
        for(let i = 0; i < size; i++){
            const key = this.unpack();
            map[key] = this.unpack();
        }
        return map;
    }
    unpack_float() {
        const uint32 = this.unpack_uint32();
        const sign = uint32 >> 31;
        const exp = (uint32 >> 23 & 0xff) - 127;
        const fraction = uint32 & 0x7fffff | 0x800000;
        return (sign === 0 ? 1 : -1) * fraction * 2 ** (exp - 23);
    }
    unpack_double() {
        const h32 = this.unpack_uint32();
        const l32 = this.unpack_uint32();
        const sign = h32 >> 31;
        const exp = (h32 >> 20 & 0x7ff) - 1023;
        const hfrac = h32 & 0xfffff | 0x100000;
        const frac = hfrac * 2 ** (exp - 20) + l32 * 2 ** (exp - 52);
        return (sign === 0 ? 1 : -1) * frac;
    }
    read(length) {
        const j = this.index;
        if (j + length <= this.length) return this.dataView.subarray(j, j + length);
        else throw new Error("BinaryPackFailure: read index out of range");
    }
    constructor(data){
        this.index = 0;
        this.dataBuffer = data;
        this.dataView = new Uint8Array(this.dataBuffer);
        this.length = this.dataBuffer.byteLength;
    }
}
class $5b93b93a09fbaeb8$export$b9ec4b114aa40074 {
    getBuffer() {
        return this._bufferBuilder.toArrayBuffer();
    }
    pack(value) {
        if (typeof value === "string") this.pack_string(value);
        else if (typeof value === "number") {
            if (Math.floor(value) === value) this.pack_integer(value);
            else this.pack_double(value);
        } else if (typeof value === "boolean") {
            if (value === true) this._bufferBuilder.append(0xc3);
            else if (value === false) this._bufferBuilder.append(0xc2);
        } else if (value === undefined) this._bufferBuilder.append(0xc0);
        else if (typeof value === "object") {
            if (value === null) this._bufferBuilder.append(0xc0);
            else {
                const constructor = value.constructor;
                if (value instanceof Array) {
                    const res = this.pack_array(value);
                    if (res instanceof Promise) return res.then(()=>this._bufferBuilder.flush());
                } else if (value instanceof ArrayBuffer) this.pack_bin(new Uint8Array(value));
                else if ("BYTES_PER_ELEMENT" in value) {
                    const v = value;
                    this.pack_bin(new Uint8Array(v.buffer, v.byteOffset, v.byteLength));
                } else if (value instanceof Date) this.pack_string(value.toString());
                else if (value instanceof Blob) return value.arrayBuffer().then((buffer)=>{
                    this.pack_bin(new Uint8Array(buffer));
                    this._bufferBuilder.flush();
                });
                else if (constructor == Object || constructor.toString().startsWith("class")) {
                    const res = this.pack_object(value);
                    if (res instanceof Promise) return res.then(()=>this._bufferBuilder.flush());
                } else throw new Error(`Type "${constructor.toString()}" not yet supported`);
            }
        } else throw new Error(`Type "${typeof value}" not yet supported`);
        this._bufferBuilder.flush();
    }
    pack_bin(blob) {
        const length = blob.length;
        if (length <= 0x0f) this.pack_uint8(0xa0 + length);
        else if (length <= 0xffff) {
            this._bufferBuilder.append(0xda);
            this.pack_uint16(length);
        } else if (length <= 0xffffffff) {
            this._bufferBuilder.append(0xdb);
            this.pack_uint32(length);
        } else throw new Error("Invalid length");
        this._bufferBuilder.append_buffer(blob);
    }
    pack_string(str) {
        const encoded = this._textEncoder.encode(str);
        const length = encoded.length;
        if (length <= 0x0f) this.pack_uint8(0xb0 + length);
        else if (length <= 0xffff) {
            this._bufferBuilder.append(0xd8);
            this.pack_uint16(length);
        } else if (length <= 0xffffffff) {
            this._bufferBuilder.append(0xd9);
            this.pack_uint32(length);
        } else throw new Error("Invalid length");
        this._bufferBuilder.append_buffer(encoded);
    }
    pack_array(ary) {
        const length = ary.length;
        if (length <= 0x0f) this.pack_uint8(0x90 + length);
        else if (length <= 0xffff) {
            this._bufferBuilder.append(0xdc);
            this.pack_uint16(length);
        } else if (length <= 0xffffffff) {
            this._bufferBuilder.append(0xdd);
            this.pack_uint32(length);
        } else throw new Error("Invalid length");
        const packNext = (index)=>{
            if (index < length) {
                const res = this.pack(ary[index]);
                if (res instanceof Promise) return res.then(()=>packNext(index + 1));
                return packNext(index + 1);
            }
        };
        return packNext(0);
    }
    pack_integer(num) {
        if (num >= -32 && num <= 0x7f) this._bufferBuilder.append(num & 0xff);
        else if (num >= 0x00 && num <= 0xff) {
            this._bufferBuilder.append(0xcc);
            this.pack_uint8(num);
        } else if (num >= -128 && num <= 0x7f) {
            this._bufferBuilder.append(0xd0);
            this.pack_int8(num);
        } else if (num >= 0x0000 && num <= 0xffff) {
            this._bufferBuilder.append(0xcd);
            this.pack_uint16(num);
        } else if (num >= -32768 && num <= 0x7fff) {
            this._bufferBuilder.append(0xd1);
            this.pack_int16(num);
        } else if (num >= 0x00000000 && num <= 0xffffffff) {
            this._bufferBuilder.append(0xce);
            this.pack_uint32(num);
        } else if (num >= -2147483648 && num <= 0x7fffffff) {
            this._bufferBuilder.append(0xd2);
            this.pack_int32(num);
        } else if (num >= -9223372036854776000 && num <= 0x7fffffffffffffff) {
            this._bufferBuilder.append(0xd3);
            this.pack_int64(num);
        } else if (num >= 0x0000000000000000 && num <= 0xffffffffffffffff) {
            this._bufferBuilder.append(0xcf);
            this.pack_uint64(num);
        } else throw new Error("Invalid integer");
    }
    pack_double(num) {
        let sign = 0;
        if (num < 0) {
            sign = 1;
            num = -num;
        }
        const exp = Math.floor(Math.log(num) / Math.LN2);
        const frac0 = num / 2 ** exp - 1;
        const frac1 = Math.floor(frac0 * 2 ** 52);
        const b32 = 2 ** 32;
        const h32 = sign << 31 | exp + 1023 << 20 | frac1 / b32 & 0x0fffff;
        const l32 = frac1 % b32;
        this._bufferBuilder.append(0xcb);
        this.pack_int32(h32);
        this.pack_int32(l32);
    }
    pack_object(obj) {
        const keys = Object.keys(obj);
        const length = keys.length;
        if (length <= 0x0f) this.pack_uint8(0x80 + length);
        else if (length <= 0xffff) {
            this._bufferBuilder.append(0xde);
            this.pack_uint16(length);
        } else if (length <= 0xffffffff) {
            this._bufferBuilder.append(0xdf);
            this.pack_uint32(length);
        } else throw new Error("Invalid length");
        const packNext = (index)=>{
            if (index < keys.length) {
                const prop = keys[index];
                // eslint-disable-next-line no-prototype-builtins
                if (obj.hasOwnProperty(prop)) {
                    this.pack(prop);
                    const res = this.pack(obj[prop]);
                    if (res instanceof Promise) return res.then(()=>packNext(index + 1));
                }
                return packNext(index + 1);
            }
        };
        return packNext(0);
    }
    pack_uint8(num) {
        this._bufferBuilder.append(num);
    }
    pack_uint16(num) {
        this._bufferBuilder.append(num >> 8);
        this._bufferBuilder.append(num & 0xff);
    }
    pack_uint32(num) {
        const n = num & 0xffffffff;
        this._bufferBuilder.append((n & 0xff000000) >>> 24);
        this._bufferBuilder.append((n & 0x00ff0000) >>> 16);
        this._bufferBuilder.append((n & 0x0000ff00) >>> 8);
        this._bufferBuilder.append(n & 0x000000ff);
    }
    pack_uint64(num) {
        const high = num / 2 ** 32;
        const low = num % 2 ** 32;
        this._bufferBuilder.append((high & 0xff000000) >>> 24);
        this._bufferBuilder.append((high & 0x00ff0000) >>> 16);
        this._bufferBuilder.append((high & 0x0000ff00) >>> 8);
        this._bufferBuilder.append(high & 0x000000ff);
        this._bufferBuilder.append((low & 0xff000000) >>> 24);
        this._bufferBuilder.append((low & 0x00ff0000) >>> 16);
        this._bufferBuilder.append((low & 0x0000ff00) >>> 8);
        this._bufferBuilder.append(low & 0x000000ff);
    }
    pack_int8(num) {
        this._bufferBuilder.append(num & 0xff);
    }
    pack_int16(num) {
        this._bufferBuilder.append((num & 0xff00) >> 8);
        this._bufferBuilder.append(num & 0xff);
    }
    pack_int32(num) {
        this._bufferBuilder.append(num >>> 24 & 0xff);
        this._bufferBuilder.append((num & 0x00ff0000) >>> 16);
        this._bufferBuilder.append((num & 0x0000ff00) >>> 8);
        this._bufferBuilder.append(num & 0x000000ff);
    }
    pack_int64(num) {
        const high = Math.floor(num / 2 ** 32);
        const low = num % 2 ** 32;
        this._bufferBuilder.append((high & 0xff000000) >>> 24);
        this._bufferBuilder.append((high & 0x00ff0000) >>> 16);
        this._bufferBuilder.append((high & 0x0000ff00) >>> 8);
        this._bufferBuilder.append(high & 0x000000ff);
        this._bufferBuilder.append((low & 0xff000000) >>> 24);
        this._bufferBuilder.append((low & 0x00ff0000) >>> 16);
        this._bufferBuilder.append((low & 0x0000ff00) >>> 8);
        this._bufferBuilder.append(low & 0x000000ff);
    }
    constructor(){
        this._bufferBuilder = new $5b93b93a09fbaeb8$var$$e8379818650e2442$export$93654d4f2d6cd524();
        this._textEncoder = new TextEncoder();
    }
}


/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 'use strict';
let $8509fcc13e9d709d$var$logDisabled_ = true;
let $8509fcc13e9d709d$var$deprecationWarnings_ = true;
function $8509fcc13e9d709d$export$e3c02be309be1f23(uastring, expr, pos) {
    const match = uastring.match(expr);
    return match && match.length >= pos && parseFloat(match[pos], 10);
}
function $8509fcc13e9d709d$export$1f48841962b828b1(window1, eventNameToWrap, wrapper) {
    if (!window1.RTCPeerConnection) return;
    const addEventListener = Object.getOwnPropertyDescriptor(EventTarget.prototype, 'addEventListener');
    if (!addEventListener.writable) {
        $8509fcc13e9d709d$export$bef1f36f5486a6a3('Unable to polyfill events');
        return;
    }
    const proto = window1.RTCPeerConnection.prototype;
    const nativeAddEventListener = proto.addEventListener;
    proto.addEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap) return nativeAddEventListener.apply(this, arguments);
        const wrappedCallback = (e)=>{
            const modifiedEvent = wrapper(e);
            if (modifiedEvent) {
                if (cb.handleEvent) cb.handleEvent(modifiedEvent);
                else cb(modifiedEvent);
            }
        };
        this._eventMap = this._eventMap || {};
        if (!this._eventMap[eventNameToWrap]) this._eventMap[eventNameToWrap] = new Map();
        this._eventMap[eventNameToWrap].set(cb, wrappedCallback);
        return nativeAddEventListener.apply(this, [
            nativeEventName,
            wrappedCallback
        ]);
    };
    const nativeRemoveEventListener = proto.removeEventListener;
    proto.removeEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap || !this._eventMap || !this._eventMap[eventNameToWrap]) return nativeRemoveEventListener.apply(this, arguments);
        if (!this._eventMap[eventNameToWrap].has(cb)) return nativeRemoveEventListener.apply(this, arguments);
        const unwrappedCb = this._eventMap[eventNameToWrap].get(cb);
        this._eventMap[eventNameToWrap].delete(cb);
        if (this._eventMap[eventNameToWrap].size === 0) delete this._eventMap[eventNameToWrap];
        if (Object.keys(this._eventMap).length === 0) delete this._eventMap;
        return nativeRemoveEventListener.apply(this, [
            nativeEventName,
            unwrappedCb
        ]);
    };
    Object.defineProperty(proto, 'on' + eventNameToWrap, {
        get () {
            return this['_on' + eventNameToWrap];
        },
        set (cb) {
            if (this['_on' + eventNameToWrap]) {
                this.removeEventListener(eventNameToWrap, this['_on' + eventNameToWrap]);
                delete this['_on' + eventNameToWrap];
            }
            if (cb) this.addEventListener(eventNameToWrap, this['_on' + eventNameToWrap] = cb);
        },
        enumerable: true,
        configurable: true
    });
}
function $8509fcc13e9d709d$export$afbfee8cc06fd3e4(bool) {
    if (typeof bool !== 'boolean') return new Error('Argument type: ' + typeof bool + '. Please use a boolean.');
    $8509fcc13e9d709d$var$logDisabled_ = bool;
    return bool ? 'adapter.js logging disabled' : 'adapter.js logging enabled';
}
function $8509fcc13e9d709d$export$51516be4b019e41e(bool) {
    if (typeof bool !== 'boolean') return new Error('Argument type: ' + typeof bool + '. Please use a boolean.');
    $8509fcc13e9d709d$var$deprecationWarnings_ = !bool;
    return 'adapter.js deprecation warnings ' + (bool ? 'disabled' : 'enabled');
}
function $8509fcc13e9d709d$export$bef1f36f5486a6a3() {
    if (typeof window === 'object') {
        if ($8509fcc13e9d709d$var$logDisabled_) return;
        if (typeof console !== 'undefined' && typeof console.log === 'function') console.log.apply(console, arguments);
    }
}
function $8509fcc13e9d709d$export$cdd73fc4100a6ef4(oldMethod, newMethod) {
    if (!$8509fcc13e9d709d$var$deprecationWarnings_) return;
    console.warn(oldMethod + ' is deprecated, please use ' + newMethod + ' instead.');
}
function $8509fcc13e9d709d$export$2d31490a0c05f094(window1) {
    // Returned result object.
    const result = {
        browser: null,
        version: null
    };
    // Fail early if it's not a browser
    if (typeof window1 === 'undefined' || !window1.navigator || !window1.navigator.userAgent) {
        result.browser = 'Not a browser.';
        return result;
    }
    const { navigator: navigator } = window1;
    // Prefer navigator.userAgentData.
    if (navigator.userAgentData && navigator.userAgentData.brands) {
        const chromium = navigator.userAgentData.brands.find((brand)=>{
            return brand.brand === 'Chromium';
        });
        if (chromium) {
            const version = parseInt(chromium.version, 10);
            // navigator.userAgentData was introduced in Chromium 90
            // so any Chromium brand reporting a version below 90 is invalid
            if (version >= 90) return {
                browser: 'chrome',
                version: version
            };
        }
    }
    if (navigator.mozGetUserMedia) {
        result.browser = 'firefox';
        result.version = parseInt($8509fcc13e9d709d$export$e3c02be309be1f23(navigator.userAgent, /Firefox\/(\d+)\./, 1));
    } else if (navigator.webkitGetUserMedia || window1.isSecureContext === false && window1.webkitRTCPeerConnection) {
        // Chrome, Chromium, Webview, Opera.
        // Version matches Chrome/WebRTC version.
        // Chrome 74 removed webkitGetUserMedia on http as well so we need the
        // more complicated fallback to webkitRTCPeerConnection.
        result.browser = 'chrome';
        result.version = parseInt($8509fcc13e9d709d$export$e3c02be309be1f23(navigator.userAgent, /Chrom(e|ium)\/(\d+)\./, 2)) || null;
    } else if (window1.RTCPeerConnection && navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) {
        result.browser = 'safari';
        result.version = parseInt($8509fcc13e9d709d$export$e3c02be309be1f23(navigator.userAgent, /AppleWebKit\/(\d+)\./, 1));
        result.supportsUnifiedPlan = window1.RTCRtpTransceiver && 'currentDirection' in window1.RTCRtpTransceiver.prototype;
        // Only for internal usage.
        result._safariVersion = $8509fcc13e9d709d$export$e3c02be309be1f23(navigator.userAgent, /Version\/(\d+(\.?\d+))/, 1);
    } else {
        result.browser = 'Not a supported browser.';
        return result;
    }
    return result;
}
/**
 * Checks if something is an object.
 *
 * @param {*} val The something you want to check.
 * @return true if val is an object, false otherwise.
 */ function $8509fcc13e9d709d$var$isObject(val) {
    return Object.prototype.toString.call(val) === '[object Object]';
}
function $8509fcc13e9d709d$export$15384eac40dc88c8(data) {
    if (!$8509fcc13e9d709d$var$isObject(data)) return data;
    return Object.keys(data).reduce(function(accumulator, key) {
        const isObj = $8509fcc13e9d709d$var$isObject(data[key]);
        const value = isObj ? $8509fcc13e9d709d$export$15384eac40dc88c8(data[key]) : data[key];
        const isEmptyObject = isObj && !Object.keys(value).length;
        if (value === undefined || isEmptyObject) return accumulator;
        return Object.assign(accumulator, {
            [key]: value
        });
    }, {});
}
function $8509fcc13e9d709d$export$571b373e75babb58(stats, base, resultSet) {
    if (!base || resultSet.has(base.id)) return;
    resultSet.set(base.id, base);
    Object.keys(base).forEach((name)=>{
        if (name.endsWith('Id')) $8509fcc13e9d709d$export$571b373e75babb58(stats, stats.get(base[name]), resultSet);
        else if (name.endsWith('Ids')) base[name].forEach((id)=>{
            $8509fcc13e9d709d$export$571b373e75babb58(stats, stats.get(id), resultSet);
        });
    });
}
function $8509fcc13e9d709d$export$93439ffc3f787d51(result, track, outbound) {
    const streamStatsType = outbound ? 'outbound-rtp' : 'inbound-rtp';
    const filteredResult = new Map();
    if (track === null) return filteredResult;
    const trackStats = [];
    result.forEach((value)=>{
        if (value.type === 'track' && value.trackIdentifier === track.id) trackStats.push(value);
    });
    trackStats.forEach((trackStat)=>{
        result.forEach((stats)=>{
            if (stats.type === streamStatsType && stats.trackId === trackStat.id) $8509fcc13e9d709d$export$571b373e75babb58(result, stats, filteredResult);
        });
    });
    return filteredResult;
}


var $f654d4fc883bc56e$exports = {};

$parcel$export($f654d4fc883bc56e$exports, "shimMediaStream", () => $f654d4fc883bc56e$export$33ee24e7a300bcd1);
$parcel$export($f654d4fc883bc56e$exports, "shimOnTrack", () => $f654d4fc883bc56e$export$f358708f68ab068);
$parcel$export($f654d4fc883bc56e$exports, "shimGetSendersWithDtmf", () => $f654d4fc883bc56e$export$a41a030a2842f5d6);
$parcel$export($f654d4fc883bc56e$exports, "shimSenderReceiverGetStats", () => $f654d4fc883bc56e$export$f2f0f2338114eb4b);
$parcel$export($f654d4fc883bc56e$exports, "shimAddTrackRemoveTrackWithNative", () => $f654d4fc883bc56e$export$30e3cdd46f8d5100);
$parcel$export($f654d4fc883bc56e$exports, "shimAddTrackRemoveTrack", () => $f654d4fc883bc56e$export$9588259fcf4ebc91);
$parcel$export($f654d4fc883bc56e$exports, "shimPeerConnection", () => $f654d4fc883bc56e$export$852a08dda9a55ea7);
$parcel$export($f654d4fc883bc56e$exports, "fixNegotiationNeeded", () => $f654d4fc883bc56e$export$341293bbeaae37cb);
$parcel$export($f654d4fc883bc56e$exports, "shimGetUserMedia", () => $a32760d74be598cd$export$1ed4910f4d37dc5e);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
'use strict';
const $a32760d74be598cd$var$logging = $8509fcc13e9d709d$export$bef1f36f5486a6a3;
function $a32760d74be598cd$export$1ed4910f4d37dc5e(window, browserDetails) {
    if (browserDetails.version >= 64) return;
    const navigator = window && window.navigator;
    if (!navigator.mediaDevices) return;
    const constraintsToChrome_ = function(c) {
        if (typeof c !== 'object' || c.mandatory || c.optional) return c;
        const cc = {};
        Object.keys(c).forEach((key)=>{
            if (key === 'require' || key === 'advanced' || key === 'mediaSource') return;
            const r = typeof c[key] === 'object' ? c[key] : {
                ideal: c[key]
            };
            if (r.exact !== undefined && typeof r.exact === 'number') r.min = r.max = r.exact;
            const oldname_ = function(prefix, name) {
                if (prefix) return prefix + name.charAt(0).toUpperCase() + name.slice(1);
                return name === 'deviceId' ? 'sourceId' : name;
            };
            if (r.ideal !== undefined) {
                cc.optional = cc.optional || [];
                let oc = {};
                if (typeof r.ideal === 'number') {
                    oc[oldname_('min', key)] = r.ideal;
                    cc.optional.push(oc);
                    oc = {};
                    oc[oldname_('max', key)] = r.ideal;
                    cc.optional.push(oc);
                } else {
                    oc[oldname_('', key)] = r.ideal;
                    cc.optional.push(oc);
                }
            }
            if (r.exact !== undefined && typeof r.exact !== 'number') {
                cc.mandatory = cc.mandatory || {};
                cc.mandatory[oldname_('', key)] = r.exact;
            } else [
                'min',
                'max'
            ].forEach((mix)=>{
                if (r[mix] !== undefined) {
                    cc.mandatory = cc.mandatory || {};
                    cc.mandatory[oldname_(mix, key)] = r[mix];
                }
            });
        });
        if (c.advanced) cc.optional = (cc.optional || []).concat(c.advanced);
        return cc;
    };
    const shimConstraints_ = function(constraints, func) {
        if (browserDetails.version >= 61) return func(constraints);
        constraints = JSON.parse(JSON.stringify(constraints));
        if (constraints && typeof constraints.audio === 'object') {
            const remap = function(obj, a, b) {
                if (a in obj && !(b in obj)) {
                    obj[b] = obj[a];
                    delete obj[a];
                }
            };
            constraints = JSON.parse(JSON.stringify(constraints));
            remap(constraints.audio, 'autoGainControl', 'googAutoGainControl');
            remap(constraints.audio, 'noiseSuppression', 'googNoiseSuppression');
            constraints.audio = constraintsToChrome_(constraints.audio);
        }
        if (constraints && typeof constraints.video === 'object') {
            // Shim facingMode for mobile & surface pro.
            let face = constraints.video.facingMode;
            face = face && (typeof face === 'object' ? face : {
                ideal: face
            });
            const getSupportedFacingModeLies = browserDetails.version < 66;
            if (face && (face.exact === 'user' || face.exact === 'environment' || face.ideal === 'user' || face.ideal === 'environment') && !(navigator.mediaDevices.getSupportedConstraints && navigator.mediaDevices.getSupportedConstraints().facingMode && !getSupportedFacingModeLies)) {
                delete constraints.video.facingMode;
                let matches;
                if (face.exact === 'environment' || face.ideal === 'environment') matches = [
                    'back',
                    'rear'
                ];
                else if (face.exact === 'user' || face.ideal === 'user') matches = [
                    'front'
                ];
                if (matches) // Look for matches in label, or use last cam for back (typical).
                return navigator.mediaDevices.enumerateDevices().then((devices)=>{
                    devices = devices.filter((d)=>d.kind === 'videoinput');
                    let dev = devices.find((d)=>matches.some((match)=>d.label.toLowerCase().includes(match)));
                    if (!dev && devices.length && matches.includes('back')) dev = devices[devices.length - 1]; // more likely the back cam
                    if (dev) constraints.video.deviceId = face.exact ? {
                        exact: dev.deviceId
                    } : {
                        ideal: dev.deviceId
                    };
                    constraints.video = constraintsToChrome_(constraints.video);
                    $a32760d74be598cd$var$logging('chrome: ' + JSON.stringify(constraints));
                    return func(constraints);
                });
            }
            constraints.video = constraintsToChrome_(constraints.video);
        }
        $a32760d74be598cd$var$logging('chrome: ' + JSON.stringify(constraints));
        return func(constraints);
    };
    const shimError_ = function(e) {
        if (browserDetails.version >= 64) return e;
        return {
            name: ({
                PermissionDeniedError: 'NotAllowedError',
                PermissionDismissedError: 'NotAllowedError',
                InvalidStateError: 'NotAllowedError',
                DevicesNotFoundError: 'NotFoundError',
                ConstraintNotSatisfiedError: 'OverconstrainedError',
                TrackStartError: 'NotReadableError',
                MediaDeviceFailedDueToShutdown: 'NotAllowedError',
                MediaDeviceKillSwitchOn: 'NotAllowedError',
                TabCaptureError: 'AbortError',
                ScreenCaptureError: 'AbortError',
                DeviceCaptureError: 'AbortError'
            })[e.name] || e.name,
            message: e.message,
            constraint: e.constraint || e.constraintName,
            toString () {
                return this.name + (this.message && ': ') + this.message;
            }
        };
    };
    const getUserMedia_ = function(constraints, onSuccess, onError) {
        shimConstraints_(constraints, (c)=>{
            navigator.webkitGetUserMedia(c, onSuccess, (e)=>{
                if (onError) onError(shimError_(e));
            });
        });
    };
    navigator.getUserMedia = getUserMedia_.bind(navigator);
    // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
    // function which returns a Promise, it does not accept spec-style
    // constraints.
    // Fixed in M64 too, see
    //   https://groups.google.com/g/discuss-webrtc/c/DMPTKcXVUQ4/m/85FaASoFBwAJ?
    if (navigator.mediaDevices.getUserMedia) {
        const origGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
        navigator.mediaDevices.getUserMedia = function(cs) {
            return shimConstraints_(cs, (c)=>origGetUserMedia(c).then((stream)=>{
                    if (c.audio && !stream.getAudioTracks().length || c.video && !stream.getVideoTracks().length) {
                        stream.getTracks().forEach((track)=>{
                            track.stop();
                        });
                        throw new DOMException('', 'NotFoundError');
                    }
                    return stream;
                }, (e)=>Promise.reject(shimError_(e))));
        };
    }
}


'use strict';
function $f654d4fc883bc56e$export$33ee24e7a300bcd1(window) {
    window.MediaStream = window.MediaStream || window.webkitMediaStream;
}
function $f654d4fc883bc56e$export$f358708f68ab068(window, browserDetails) {
    if (browserDetails.version > 102) // Unified plan is supported so no need to do anything.
    return;
    if (typeof window === 'object' && window.RTCPeerConnection && !('ontrack' in window.RTCPeerConnection.prototype)) {
        Object.defineProperty(window.RTCPeerConnection.prototype, 'ontrack', {
            get () {
                return this._ontrack;
            },
            set (f) {
                if (this._ontrack) this.removeEventListener('track', this._ontrack);
                this.addEventListener('track', this._ontrack = f);
            },
            enumerable: true,
            configurable: true
        });
        const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
        window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            if (!this._ontrackpoly) {
                this._ontrackpoly = (e)=>{
                    // onaddstream does not fire when a track is added to an existing
                    // stream. But stream.onaddtrack is implemented so we use that.
                    e.stream.addEventListener('addtrack', (te)=>{
                        let receiver;
                        if (window.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === te.track.id);
                        else receiver = {
                            track: te.track
                        };
                        const event = new Event('track');
                        event.track = te.track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                    e.stream.getTracks().forEach((track)=>{
                        let receiver;
                        if (window.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === track.id);
                        else receiver = {
                            track: track
                        };
                        const event = new Event('track');
                        event.track = track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                };
                this.addEventListener('addstream', this._ontrackpoly);
            }
            return origSetRemoteDescription.apply(this, arguments);
        };
    } else // even if RTCRtpTransceiver is in window, it is only used and
    // emitted in unified-plan. Unfortunately this means we need
    // to unconditionally wrap the event.
    $8509fcc13e9d709d$export$1f48841962b828b1(window, 'track', (e)=>{
        if (!e.transceiver) Object.defineProperty(e, 'transceiver', {
            value: {
                receiver: e.receiver
            }
        });
        return e;
    });
}
function $f654d4fc883bc56e$export$a41a030a2842f5d6(window) {
    // Overrides addTrack/removeTrack, depends on shimAddTrackRemoveTrack.
    if (typeof window === 'object' && window.RTCPeerConnection && !('getSenders' in window.RTCPeerConnection.prototype) && 'createDTMFSender' in window.RTCPeerConnection.prototype) {
        const shimSenderWithDtmf = function(pc, track) {
            return {
                track: track,
                get dtmf () {
                    if (this._dtmf === undefined) {
                        if (track.kind === 'audio') this._dtmf = pc.createDTMFSender(track);
                        else this._dtmf = null;
                    }
                    return this._dtmf;
                },
                _pc: pc
            };
        };
        // augment addTrack when getSenders is not available.
        if (!window.RTCPeerConnection.prototype.getSenders) {
            window.RTCPeerConnection.prototype.getSenders = function getSenders() {
                this._senders = this._senders || [];
                return this._senders.slice(); // return a copy of the internal state.
            };
            const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
            window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
                let sender = origAddTrack.apply(this, arguments);
                if (!sender) {
                    sender = shimSenderWithDtmf(this, track);
                    this._senders.push(sender);
                }
                return sender;
            };
            const origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
            window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
                origRemoveTrack.apply(this, arguments);
                const idx = this._senders.indexOf(sender);
                if (idx !== -1) this._senders.splice(idx, 1);
            };
        }
        const origAddStream = window.RTCPeerConnection.prototype.addStream;
        window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            this._senders = this._senders || [];
            origAddStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                this._senders.push(shimSenderWithDtmf(this, track));
            });
        };
        const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
        window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
            this._senders = this._senders || [];
            origRemoveStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                const sender = this._senders.find((s)=>s.track === track);
                if (sender) this._senders.splice(this._senders.indexOf(sender), 1);
            });
        };
    } else if (typeof window === 'object' && window.RTCPeerConnection && 'getSenders' in window.RTCPeerConnection.prototype && 'createDTMFSender' in window.RTCPeerConnection.prototype && window.RTCRtpSender && !('dtmf' in window.RTCRtpSender.prototype)) {
        const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
        window.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        Object.defineProperty(window.RTCRtpSender.prototype, 'dtmf', {
            get () {
                if (this._dtmf === undefined) {
                    if (this.track.kind === 'audio') this._dtmf = this._pc.createDTMFSender(this.track);
                    else this._dtmf = null;
                }
                return this._dtmf;
            }
        });
    }
}
function $f654d4fc883bc56e$export$f2f0f2338114eb4b(window, browserDetails) {
    if (browserDetails.version >= 67) return;
    if (!(typeof window === 'object' && window.RTCPeerConnection && window.RTCRtpSender && window.RTCRtpReceiver)) return;
    // shim sender stats.
    if (!('getStats' in window.RTCRtpSender.prototype)) {
        const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
        if (origGetSenders) window.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
        if (origAddTrack) window.RTCPeerConnection.prototype.addTrack = function addTrack() {
            const sender = origAddTrack.apply(this, arguments);
            sender._pc = this;
            return sender;
        };
        window.RTCRtpSender.prototype.getStats = function getStats() {
            const sender = this;
            return this._pc.getStats().then((result)=>/* Note: this will include stats of all senders that
         *   send a track with the same id as sender.track as
         *   it is not possible to identify the RTCRtpSender.
         */ $8509fcc13e9d709d$export$93439ffc3f787d51(result, sender.track, true));
        };
    }
    // shim receiver stats.
    if (!('getStats' in window.RTCRtpReceiver.prototype)) {
        const origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
        if (origGetReceivers) window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
            const receivers = origGetReceivers.apply(this, []);
            receivers.forEach((receiver)=>receiver._pc = this);
            return receivers;
        };
        $8509fcc13e9d709d$export$1f48841962b828b1(window, 'track', (e)=>{
            e.receiver._pc = e.srcElement;
            return e;
        });
        window.RTCRtpReceiver.prototype.getStats = function getStats() {
            const receiver = this;
            return this._pc.getStats().then((result)=>$8509fcc13e9d709d$export$93439ffc3f787d51(result, receiver.track, false));
        };
    }
    if (!('getStats' in window.RTCRtpSender.prototype && 'getStats' in window.RTCRtpReceiver.prototype)) return;
    // shim RTCPeerConnection.getStats(track).
    const origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        if (arguments.length > 0 && arguments[0] instanceof window.MediaStreamTrack) {
            const track = arguments[0];
            let sender;
            let receiver;
            let err;
            this.getSenders().forEach((s)=>{
                if (s.track === track) {
                    if (sender) err = true;
                    else sender = s;
                }
            });
            this.getReceivers().forEach((r)=>{
                if (r.track === track) {
                    if (receiver) err = true;
                    else receiver = r;
                }
                return r.track === track;
            });
            if (err || sender && receiver) return Promise.reject(new DOMException('There are more than one sender or receiver for the track.', 'InvalidAccessError'));
            else if (sender) return sender.getStats();
            else if (receiver) return receiver.getStats();
            return Promise.reject(new DOMException('There is no sender or receiver for the track.', 'InvalidAccessError'));
        }
        return origGetStats.apply(this, arguments);
    };
}
function $f654d4fc883bc56e$export$30e3cdd46f8d5100(window) {
    // shim addTrack/removeTrack with native variants in order to make
    // the interactions with legacy getLocalStreams behave as in other browsers.
    // Keeps a mapping stream.id => [stream, rtpsenders...]
    window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        return Object.keys(this._shimmedLocalStreams).map((streamId)=>this._shimmedLocalStreams[streamId][0]);
    };
    const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (!stream) return origAddTrack.apply(this, arguments);
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        const sender = origAddTrack.apply(this, arguments);
        if (!this._shimmedLocalStreams[stream.id]) this._shimmedLocalStreams[stream.id] = [
            stream,
            sender
        ];
        else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) this._shimmedLocalStreams[stream.id].push(sender);
        return sender;
    };
    const origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException('Track already exists.', 'InvalidAccessError');
        });
        const existingSenders = this.getSenders();
        origAddStream.apply(this, arguments);
        const newSenders = this.getSenders().filter((newSender)=>existingSenders.indexOf(newSender) === -1);
        this._shimmedLocalStreams[stream.id] = [
            stream
        ].concat(newSenders);
    };
    const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        delete this._shimmedLocalStreams[stream.id];
        return origRemoveStream.apply(this, arguments);
    };
    const origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
    window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        if (sender) Object.keys(this._shimmedLocalStreams).forEach((streamId)=>{
            const idx = this._shimmedLocalStreams[streamId].indexOf(sender);
            if (idx !== -1) this._shimmedLocalStreams[streamId].splice(idx, 1);
            if (this._shimmedLocalStreams[streamId].length === 1) delete this._shimmedLocalStreams[streamId];
        });
        return origRemoveTrack.apply(this, arguments);
    };
}
function $f654d4fc883bc56e$export$9588259fcf4ebc91(window, browserDetails) {
    if (!window.RTCPeerConnection) return;
    // shim addTrack and removeTrack.
    if (window.RTCPeerConnection.prototype.addTrack && browserDetails.version >= 65) return $f654d4fc883bc56e$export$30e3cdd46f8d5100(window);
    // also shim pc.getLocalStreams when addTrack is shimmed
    // to return the original streams.
    const origGetLocalStreams = window.RTCPeerConnection.prototype.getLocalStreams;
    window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        const nativeStreams = origGetLocalStreams.apply(this);
        this._reverseStreams = this._reverseStreams || {};
        return nativeStreams.map((stream)=>this._reverseStreams[stream.id]);
    };
    const origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException('Track already exists.', 'InvalidAccessError');
        });
        // Add identity mapping for consistency with addTrack.
        // Unless this is being used with a stream from addTrack.
        if (!this._reverseStreams[stream.id]) {
            const newStream = new window.MediaStream(stream.getTracks());
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            stream = newStream;
        }
        origAddStream.apply(this, [
            stream
        ]);
    };
    const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        origRemoveStream.apply(this, [
            this._streams[stream.id] || stream
        ]);
        delete this._reverseStreams[this._streams[stream.id] ? this._streams[stream.id].id : stream.id];
        delete this._streams[stream.id];
    };
    window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (this.signalingState === 'closed') throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
        const streams = [].slice.call(arguments, 1);
        if (streams.length !== 1 || !streams[0].getTracks().find((t)=>t === track)) // this is not fully correct but all we can manage without
        // [[associated MediaStreams]] internal slot.
        throw new DOMException("The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.", 'NotSupportedError');
        const alreadyExists = this.getSenders().find((s)=>s.track === track);
        if (alreadyExists) throw new DOMException('Track already exists.', 'InvalidAccessError');
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        const oldStream = this._streams[stream.id];
        if (oldStream) {
            // this is using odd Chrome behaviour, use with caution:
            // https://bugs.chromium.org/p/webrtc/issues/detail?id=7815
            // Note: we rely on the high-level addTrack/dtmf shim to
            // create the sender with a dtmf sender.
            oldStream.addTrack(track);
            // Trigger ONN async.
            Promise.resolve().then(()=>{
                this.dispatchEvent(new Event('negotiationneeded'));
            });
        } else {
            const newStream = new window.MediaStream([
                track
            ]);
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            this.addStream(newStream);
        }
        return this.getSenders().find((s)=>s.track === track);
    };
    // replace the internal stream id with the external one and
    // vice versa.
    function replaceInternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(internalStream.id, 'g'), externalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    function replaceExternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(externalStream.id, 'g'), internalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    [
        'createOffer',
        'createAnswer'
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                const args = arguments;
                const isLegacyCall = arguments.length && typeof arguments[0] === 'function';
                if (isLegacyCall) return nativeMethod.apply(this, [
                    (description)=>{
                        const desc = replaceInternalStreamId(this, description);
                        args[0].apply(null, [
                            desc
                        ]);
                    },
                    (err)=>{
                        if (args[1]) args[1].apply(null, err);
                    },
                    arguments[2]
                ]);
                return nativeMethod.apply(this, arguments).then((description)=>replaceInternalStreamId(this, description));
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
    const origSetLocalDescription = window.RTCPeerConnection.prototype.setLocalDescription;
    window.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
        if (!arguments.length || !arguments[0].type) return origSetLocalDescription.apply(this, arguments);
        arguments[0] = replaceExternalStreamId(this, arguments[0]);
        return origSetLocalDescription.apply(this, arguments);
    };
    // TODO: mangle getStats: https://w3c.github.io/webrtc-stats/#dom-rtcmediastreamstats-streamidentifier
    const origLocalDescription = Object.getOwnPropertyDescriptor(window.RTCPeerConnection.prototype, 'localDescription');
    Object.defineProperty(window.RTCPeerConnection.prototype, 'localDescription', {
        get () {
            const description = origLocalDescription.get.apply(this);
            if (description.type === '') return description;
            return replaceInternalStreamId(this, description);
        }
    });
    window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        if (this.signalingState === 'closed') throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
        // We can not yet check for sender instanceof RTCRtpSender
        // since we shim RTPSender. So we check if sender._pc is set.
        if (!sender._pc) throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.", 'TypeError');
        const isLocal = sender._pc === this;
        if (!isLocal) throw new DOMException('Sender was not created by this connection.', 'InvalidAccessError');
        // Search for the native stream the senders track belongs to.
        this._streams = this._streams || {};
        let stream;
        Object.keys(this._streams).forEach((streamid)=>{
            const hasTrack = this._streams[streamid].getTracks().find((track)=>sender.track === track);
            if (hasTrack) stream = this._streams[streamid];
        });
        if (stream) {
            if (stream.getTracks().length === 1) // if this is the last track of the stream, remove the stream. This
            // takes care of any shimmed _senders.
            this.removeStream(this._reverseStreams[stream.id]);
            else // relying on the same odd chrome behaviour as above.
            stream.removeTrack(sender.track);
            this.dispatchEvent(new Event('negotiationneeded'));
        }
    };
}
function $f654d4fc883bc56e$export$852a08dda9a55ea7(window, browserDetails) {
    if (!window.RTCPeerConnection && window.webkitRTCPeerConnection) // very basic support for old versions.
    window.RTCPeerConnection = window.webkitRTCPeerConnection;
    if (!window.RTCPeerConnection) return;
    // shim implicit creation of RTCSessionDescription/RTCIceCandidate
    if (browserDetails.version < 53) [
        'setLocalDescription',
        'setRemoteDescription',
        'addIceCandidate'
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === 'addIceCandidate' ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
}
function $f654d4fc883bc56e$export$341293bbeaae37cb(window, browserDetails) {
    if (browserDetails.version > 102) // Plan-B is no longer supported.
    return;
    $8509fcc13e9d709d$export$1f48841962b828b1(window, 'negotiationneeded', (e)=>{
        const pc = e.target;
        if (browserDetails.version < 72 || pc.getConfiguration && pc.getConfiguration().sdpSemantics === 'plan-b') {
            if (pc.signalingState !== 'stable') return;
        }
        return e;
    });
}


var $2ab4b9558f0161ae$exports = {};

$parcel$export($2ab4b9558f0161ae$exports, "shimOnTrack", () => $2ab4b9558f0161ae$export$f358708f68ab068);
$parcel$export($2ab4b9558f0161ae$exports, "shimPeerConnection", () => $2ab4b9558f0161ae$export$852a08dda9a55ea7);
$parcel$export($2ab4b9558f0161ae$exports, "shimGetStats", () => $2ab4b9558f0161ae$export$90608323826f0b17);
$parcel$export($2ab4b9558f0161ae$exports, "shimSenderGetStats", () => $2ab4b9558f0161ae$export$f0525502095c04ef);
$parcel$export($2ab4b9558f0161ae$exports, "shimReceiverGetStats", () => $2ab4b9558f0161ae$export$83d69126527b1171);
$parcel$export($2ab4b9558f0161ae$exports, "shimRemoveStream", () => $2ab4b9558f0161ae$export$825e523ef749bd8c);
$parcel$export($2ab4b9558f0161ae$exports, "shimRTCDataChannel", () => $2ab4b9558f0161ae$export$ff9cb3bc8990e8f7);
$parcel$export($2ab4b9558f0161ae$exports, "shimAddTransceiver", () => $2ab4b9558f0161ae$export$70c77533b6e9908d);
$parcel$export($2ab4b9558f0161ae$exports, "shimGetParameters", () => $2ab4b9558f0161ae$export$66238223c298fbaa);
$parcel$export($2ab4b9558f0161ae$exports, "shimCreateOffer", () => $2ab4b9558f0161ae$export$51beccf0e777b843);
$parcel$export($2ab4b9558f0161ae$exports, "shimCreateAnswer", () => $2ab4b9558f0161ae$export$df0b46e7cef08150);
$parcel$export($2ab4b9558f0161ae$exports, "shimGetUserMedia", () => $1834faf020c214b0$export$1ed4910f4d37dc5e);
$parcel$export($2ab4b9558f0161ae$exports, "shimGetDisplayMedia", () => $8aa1bb3ce76cc7f1$export$97270b87351d9c04);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
'use strict';
function $1834faf020c214b0$export$1ed4910f4d37dc5e(window, browserDetails) {
    const navigator = window && window.navigator;
    if (!navigator.mediaDevices) return;
    const MediaStreamTrack = window && window.MediaStreamTrack;
    navigator.getUserMedia = function(constraints, onSuccess, onError) {
        // Replace Firefox 44+'s deprecation warning with unprefixed version.
        $8509fcc13e9d709d$export$cdd73fc4100a6ef4('navigator.getUserMedia', 'navigator.mediaDevices.getUserMedia');
        navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
    };
    if (!(browserDetails.version > 55 && 'autoGainControl' in navigator.mediaDevices.getSupportedConstraints())) {
        const remap = function(obj, a, b) {
            if (a in obj && !(b in obj)) {
                obj[b] = obj[a];
                delete obj[a];
            }
        };
        const nativeGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
        navigator.mediaDevices.getUserMedia = function(c) {
            if (typeof c === 'object' && typeof c.audio === 'object') {
                c = JSON.parse(JSON.stringify(c));
                remap(c.audio, 'autoGainControl', 'mozAutoGainControl');
                remap(c.audio, 'noiseSuppression', 'mozNoiseSuppression');
            }
            return nativeGetUserMedia(c);
        };
        if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
            const nativeGetSettings = MediaStreamTrack.prototype.getSettings;
            MediaStreamTrack.prototype.getSettings = function() {
                const obj = nativeGetSettings.apply(this, arguments);
                remap(obj, 'mozAutoGainControl', 'autoGainControl');
                remap(obj, 'mozNoiseSuppression', 'noiseSuppression');
                return obj;
            };
        }
        if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
            const nativeApplyConstraints = MediaStreamTrack.prototype.applyConstraints;
            MediaStreamTrack.prototype.applyConstraints = function(c) {
                if (this.kind === 'audio' && typeof c === 'object') {
                    c = JSON.parse(JSON.stringify(c));
                    remap(c, 'autoGainControl', 'mozAutoGainControl');
                    remap(c, 'noiseSuppression', 'mozNoiseSuppression');
                }
                return nativeApplyConstraints.apply(this, [
                    c
                ]);
            };
        }
    }
}


/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 'use strict';
function $8aa1bb3ce76cc7f1$export$97270b87351d9c04(window, preferredMediaSource) {
    if (!window.navigator.mediaDevices) return;
    if (window.navigator.mediaDevices && 'getDisplayMedia' in window.navigator.mediaDevices) return;
    window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
        if (!(constraints && constraints.video)) {
            const err = new DOMException("getDisplayMedia without video constraints is undefined");
            err.name = 'NotFoundError';
            // from https://heycam.github.io/webidl/#idl-DOMException-error-names
            err.code = 8;
            return Promise.reject(err);
        }
        if (constraints.video === true) constraints.video = {
            mediaSource: preferredMediaSource
        };
        else constraints.video.mediaSource = preferredMediaSource;
        return window.navigator.mediaDevices.getUserMedia(constraints);
    };
}


'use strict';
function $2ab4b9558f0161ae$export$f358708f68ab068(window) {
    if (typeof window === 'object' && window.RTCTrackEvent && 'receiver' in window.RTCTrackEvent.prototype && !('transceiver' in window.RTCTrackEvent.prototype)) Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $2ab4b9558f0161ae$export$852a08dda9a55ea7(window, browserDetails) {
    if (typeof window !== 'object' || !(window.RTCPeerConnection || window.mozRTCPeerConnection)) return; // probably media.peerconnection.enabled=false in about:config
    if (!window.RTCPeerConnection && window.mozRTCPeerConnection) // very basic support for old versions.
    window.RTCPeerConnection = window.mozRTCPeerConnection;
    if (browserDetails.version < 53) // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
    [
        'setLocalDescription',
        'setRemoteDescription',
        'addIceCandidate'
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === 'addIceCandidate' ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
}
function $2ab4b9558f0161ae$export$90608323826f0b17(window, browserDetails) {
    if (typeof window !== 'object' || !(window.RTCPeerConnection || window.mozRTCPeerConnection)) return; // probably media.peerconnection.enabled=false in about:config
    if (browserDetails.version >= 151) // https://bugzilla.mozilla.org/show_bug.cgi?id=1056433
    return;
    const modernStatsTypes = {
        inboundrtp: 'inbound-rtp',
        outboundrtp: 'outbound-rtp',
        candidatepair: 'candidate-pair',
        localcandidate: 'local-candidate',
        remotecandidate: 'remote-candidate'
    };
    const nativeGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        const [selector, onSucc, onErr] = arguments;
        if (this.signalingState === 'closed') // No longer required in FF151+
        return Promise.resolve(new Map());
        return nativeGetStats.apply(this, [
            selector || null
        ]).then((stats)=>{
            if (browserDetails.version < 53 && !onSucc) // Shim only promise getStats with spec-hyphens in type names
            // Leave callback version alone; misc old uses of forEach before Map
            try {
                stats.forEach((stat)=>{
                    stat.type = modernStatsTypes[stat.type] || stat.type;
                });
            } catch (e) {
                if (e.name !== 'TypeError') throw e;
                // Avoid TypeError: "type" is read-only, in old versions. 34-43ish
                stats.forEach((stat, i)=>{
                    stats.set(i, Object.assign({}, stat, {
                        type: modernStatsTypes[stat.type] || stat.type
                    }));
                });
            }
            return stats;
        }).then(onSucc, onErr);
    };
}
function $2ab4b9558f0161ae$export$f0525502095c04ef(window) {
    if (!(typeof window === 'object' && window.RTCPeerConnection && window.RTCRtpSender)) return;
    if (window.RTCRtpSender && 'getStats' in window.RTCRtpSender.prototype) return;
    const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
    if (origGetSenders) window.RTCPeerConnection.prototype.getSenders = function getSenders() {
        const senders = origGetSenders.apply(this, []);
        senders.forEach((sender)=>sender._pc = this);
        return senders;
    };
    const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    if (origAddTrack) window.RTCPeerConnection.prototype.addTrack = function addTrack() {
        const sender = origAddTrack.apply(this, arguments);
        sender._pc = this;
        return sender;
    };
    window.RTCRtpSender.prototype.getStats = function getStats() {
        return this.track ? this._pc.getStats(this.track) : Promise.resolve(new Map());
    };
}
function $2ab4b9558f0161ae$export$83d69126527b1171(window) {
    if (!(typeof window === 'object' && window.RTCPeerConnection && window.RTCRtpSender)) return;
    if (window.RTCRtpSender && 'getStats' in window.RTCRtpReceiver.prototype) return;
    const origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
    if (origGetReceivers) window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
        const receivers = origGetReceivers.apply(this, []);
        receivers.forEach((receiver)=>receiver._pc = this);
        return receivers;
    };
    $8509fcc13e9d709d$export$1f48841962b828b1(window, 'track', (e)=>{
        e.receiver._pc = e.srcElement;
        return e;
    });
    window.RTCRtpReceiver.prototype.getStats = function getStats() {
        return this._pc.getStats(this.track);
    };
}
function $2ab4b9558f0161ae$export$825e523ef749bd8c(window) {
    if (!window.RTCPeerConnection || 'removeStream' in window.RTCPeerConnection.prototype) return;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        $8509fcc13e9d709d$export$cdd73fc4100a6ef4('removeStream', 'removeTrack');
        this.getSenders().forEach((sender)=>{
            if (sender.track && stream.getTracks().includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $2ab4b9558f0161ae$export$ff9cb3bc8990e8f7(window) {
    // rename DataChannel to RTCDataChannel (native fix in FF60):
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1173851
    if (window.DataChannel && !window.RTCDataChannel) window.RTCDataChannel = window.DataChannel;
}
function $2ab4b9558f0161ae$export$70c77533b6e9908d(window, browserDetails) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === 'object' && window.RTCPeerConnection)) return;
    // Fixed by https://bugzilla.mozilla.org/show_bug.cgi?id=1401592 in FF110.
    if (browserDetails.version >= 110) return;
    const origAddTransceiver = window.RTCPeerConnection.prototype.addTransceiver;
    if (origAddTransceiver) window.RTCPeerConnection.prototype.addTransceiver = function addTransceiver() {
        this.setParametersPromises = [];
        // WebIDL input coercion and validation
        let sendEncodings = arguments[1] && arguments[1].sendEncodings;
        if (sendEncodings === undefined) sendEncodings = [];
        sendEncodings = [
            ...sendEncodings
        ];
        const shouldPerformCheck = sendEncodings.length > 0;
        if (shouldPerformCheck) // If sendEncodings params are provided, validate grammar
        sendEncodings.forEach((encodingParam)=>{
            if ('rid' in encodingParam) {
                const ridRegex = /^[a-z0-9]{0,16}$/i;
                if (!ridRegex.test(encodingParam.rid)) throw new TypeError('Invalid RID value provided.');
            }
            if ('scaleResolutionDownBy' in encodingParam) {
                if (!(parseFloat(encodingParam.scaleResolutionDownBy) >= 1.0)) throw new RangeError('scale_resolution_down_by must be >= 1.0');
            }
            if ('maxFramerate' in encodingParam) {
                if (!(parseFloat(encodingParam.maxFramerate) >= 0)) throw new RangeError('max_framerate must be >= 0.0');
            }
        });
        const transceiver = origAddTransceiver.apply(this, arguments);
        if (shouldPerformCheck) {
            // Check if the init options were applied. If not we do this in an
            // asynchronous way and save the promise reference in a global object.
            // This is an ugly hack, but at the same time is way more robust than
            // checking the sender parameters before and after the createOffer
            // Also note that after the createoffer we are not 100% sure that
            // the params were asynchronously applied so we might miss the
            // opportunity to recreate offer.
            const { sender: sender } = transceiver;
            const params = sender.getParameters();
            if (!('encodings' in params) || // Avoid being fooled by patched getParameters() below.
            params.encodings.length === 1 && Object.keys(params.encodings[0]).length === 0) {
                params.encodings = sendEncodings;
                sender.sendEncodings = sendEncodings;
                this.setParametersPromises.push(sender.setParameters(params).then(()=>{
                    delete sender.sendEncodings;
                }).catch(()=>{
                    delete sender.sendEncodings;
                }));
            }
        }
        return transceiver;
    };
}
function $2ab4b9558f0161ae$export$66238223c298fbaa(window, browserDetails) {
    if (!(typeof window === 'object' && window.RTCRtpSender)) return;
    // Fixed by https://bugzilla.mozilla.org/show_bug.cgi?id=1401592 in FF110.
    if (browserDetails.version >= 110) return;
    const origGetParameters = window.RTCRtpSender.prototype.getParameters;
    if (origGetParameters) window.RTCRtpSender.prototype.getParameters = function getParameters() {
        const params = origGetParameters.apply(this, arguments);
        if (!('encodings' in params)) params.encodings = [].concat(this.sendEncodings || [
            {}
        ]);
        return params;
    };
}
function $2ab4b9558f0161ae$export$51beccf0e777b843(window, browserDetails) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === 'object' && window.RTCPeerConnection)) return;
    // Fixed by https://bugzilla.mozilla.org/show_bug.cgi?id=1401592 in FF110.
    if (browserDetails.version >= 110) return;
    const origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
    window.RTCPeerConnection.prototype.createOffer = function createOffer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateOffer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateOffer.apply(this, arguments);
    };
}
function $2ab4b9558f0161ae$export$df0b46e7cef08150(window, browserDetails) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === 'object' && window.RTCPeerConnection)) return;
    // Fixed by https://bugzilla.mozilla.org/show_bug.cgi?id=1401592 in FF110.
    if (browserDetails.version >= 110) return;
    const origCreateAnswer = window.RTCPeerConnection.prototype.createAnswer;
    window.RTCPeerConnection.prototype.createAnswer = function createAnswer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateAnswer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateAnswer.apply(this, arguments);
    };
}


var $c6527a23987e4bf9$exports = {};

$parcel$export($c6527a23987e4bf9$exports, "shimLocalStreamsAPI", () => $c6527a23987e4bf9$export$8df41282f4fdcea2);
$parcel$export($c6527a23987e4bf9$exports, "shimRemoteStreamsAPI", () => $c6527a23987e4bf9$export$762aa4cbb4f2f857);
$parcel$export($c6527a23987e4bf9$exports, "shimCallbacksAPI", () => $c6527a23987e4bf9$export$da31df245debdd3);
$parcel$export($c6527a23987e4bf9$exports, "shimGetUserMedia", () => $c6527a23987e4bf9$export$1ed4910f4d37dc5e);
$parcel$export($c6527a23987e4bf9$exports, "shimConstraints", () => $c6527a23987e4bf9$export$494a01ac68ba81ac);
$parcel$export($c6527a23987e4bf9$exports, "shimRTCIceServerUrls", () => $c6527a23987e4bf9$export$671a8b47b41b6f41);
$parcel$export($c6527a23987e4bf9$exports, "shimTrackEventTransceiver", () => $c6527a23987e4bf9$export$85d53da088cb1b14);
$parcel$export($c6527a23987e4bf9$exports, "shimCreateOfferLegacy", () => $c6527a23987e4bf9$export$d444266503fdd2d4);
$parcel$export($c6527a23987e4bf9$exports, "shimAudioContext", () => $c6527a23987e4bf9$export$857cd739a7b795d2);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ 
'use strict';
function $c6527a23987e4bf9$export$8df41282f4fdcea2(window) {
    if (typeof window !== 'object' || !window.RTCPeerConnection) return;
    if (!('getLocalStreams' in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        if (!this._localStreams) this._localStreams = [];
        return this._localStreams;
    };
    if (!('addStream' in window.RTCPeerConnection.prototype)) {
        const _addTrack = window.RTCPeerConnection.prototype.addTrack;
        window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            if (!this._localStreams) this._localStreams = [];
            if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            // Try to emulate Chrome's behaviour of adding in audio-video order.
            // Safari orders by track id.
            stream.getAudioTracks().forEach((track)=>_addTrack.call(this, track, stream));
            stream.getVideoTracks().forEach((track)=>_addTrack.call(this, track, stream));
        };
        window.RTCPeerConnection.prototype.addTrack = function addTrack(track, ...streams) {
            if (streams) streams.forEach((stream)=>{
                if (!this._localStreams) this._localStreams = [
                    stream
                ];
                else if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            });
            return _addTrack.apply(this, arguments);
        };
    }
    if (!('removeStream' in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        if (!this._localStreams) this._localStreams = [];
        const index = this._localStreams.indexOf(stream);
        if (index === -1) return;
        this._localStreams.splice(index, 1);
        const tracks = stream.getTracks();
        this.getSenders().forEach((sender)=>{
            if (tracks.includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $c6527a23987e4bf9$export$762aa4cbb4f2f857(window) {
    if (typeof window !== 'object' || !window.RTCPeerConnection) return;
    if (!('getRemoteStreams' in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.getRemoteStreams = function getRemoteStreams() {
        return this._remoteStreams ? this._remoteStreams : [];
    };
    if (!('onaddstream' in window.RTCPeerConnection.prototype)) {
        Object.defineProperty(window.RTCPeerConnection.prototype, 'onaddstream', {
            get () {
                return this._onaddstream;
            },
            set (f) {
                if (this._onaddstream) {
                    this.removeEventListener('addstream', this._onaddstream);
                    this.removeEventListener('track', this._onaddstreampoly);
                }
                this.addEventListener('addstream', this._onaddstream = f);
                this.addEventListener('track', this._onaddstreampoly = (e)=>{
                    e.streams.forEach((stream)=>{
                        if (!this._remoteStreams) this._remoteStreams = [];
                        if (this._remoteStreams.includes(stream)) return;
                        this._remoteStreams.push(stream);
                        const event = new Event('addstream');
                        event.stream = stream;
                        this.dispatchEvent(event);
                    });
                });
            }
        });
        const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
        window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            const pc = this;
            if (!this._onaddstreampoly) this.addEventListener('track', this._onaddstreampoly = function(e) {
                e.streams.forEach((stream)=>{
                    if (!pc._remoteStreams) pc._remoteStreams = [];
                    if (pc._remoteStreams.indexOf(stream) >= 0) return;
                    pc._remoteStreams.push(stream);
                    const event = new Event('addstream');
                    event.stream = stream;
                    pc.dispatchEvent(event);
                });
            });
            return origSetRemoteDescription.apply(pc, arguments);
        };
    }
}
function $c6527a23987e4bf9$export$da31df245debdd3(window) {
    if (typeof window !== 'object' || !window.RTCPeerConnection) return;
    const prototype = window.RTCPeerConnection.prototype;
    const origCreateOffer = prototype.createOffer;
    const origCreateAnswer = prototype.createAnswer;
    const setLocalDescription = prototype.setLocalDescription;
    const setRemoteDescription = prototype.setRemoteDescription;
    const addIceCandidate = prototype.addIceCandidate;
    prototype.createOffer = function createOffer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateOffer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.createAnswer = function createAnswer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateAnswer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    let withCallback = function(description, successCallback, failureCallback) {
        const promise = setLocalDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setLocalDescription = withCallback;
    withCallback = function(description, successCallback, failureCallback) {
        const promise = setRemoteDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setRemoteDescription = withCallback;
    withCallback = function(candidate, successCallback, failureCallback) {
        const promise = addIceCandidate.apply(this, [
            candidate
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.addIceCandidate = withCallback;
}
function $c6527a23987e4bf9$export$1ed4910f4d37dc5e(window) {
    const navigator = window && window.navigator;
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // shim not needed in Safari 12.1
        const mediaDevices = navigator.mediaDevices;
        const _getUserMedia = mediaDevices.getUserMedia.bind(mediaDevices);
        navigator.mediaDevices.getUserMedia = (constraints)=>{
            return _getUserMedia($c6527a23987e4bf9$export$494a01ac68ba81ac(constraints));
        };
    }
    if (!navigator.getUserMedia && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) navigator.getUserMedia = (function getUserMedia(constraints, cb, errcb) {
        navigator.mediaDevices.getUserMedia(constraints).then(cb, errcb);
    }).bind(navigator);
}
function $c6527a23987e4bf9$export$494a01ac68ba81ac(constraints) {
    if (constraints && constraints.video !== undefined) return Object.assign({}, constraints, {
        video: $8509fcc13e9d709d$export$15384eac40dc88c8(constraints.video)
    });
    return constraints;
}
function $c6527a23987e4bf9$export$671a8b47b41b6f41(window) {
    if (!window.RTCPeerConnection) return;
    // migrate from non-spec RTCIceServer.url to RTCIceServer.urls
    const OrigPeerConnection = window.RTCPeerConnection;
    window.RTCPeerConnection = function RTCPeerConnection(pcConfig, pcConstraints) {
        if (pcConfig && pcConfig.iceServers) {
            const newIceServers = [];
            for(let i = 0; i < pcConfig.iceServers.length; i++){
                let server = pcConfig.iceServers[i];
                if (server.urls === undefined && server.url) {
                    $8509fcc13e9d709d$export$cdd73fc4100a6ef4('RTCIceServer.url', 'RTCIceServer.urls');
                    server = JSON.parse(JSON.stringify(server));
                    server.urls = server.url;
                    delete server.url;
                    newIceServers.push(server);
                } else newIceServers.push(pcConfig.iceServers[i]);
            }
            pcConfig.iceServers = newIceServers;
        }
        return new OrigPeerConnection(pcConfig, pcConstraints);
    };
    window.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
    // wrap static methods. Currently just generateCertificate.
    if ('generateCertificate' in OrigPeerConnection) Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
        get () {
            return OrigPeerConnection.generateCertificate;
        }
    });
}
function $c6527a23987e4bf9$export$85d53da088cb1b14(window) {
    // Add event.transceiver member over deprecated event.receiver
    if (typeof window === 'object' && window.RTCTrackEvent && 'receiver' in window.RTCTrackEvent.prototype && !('transceiver' in window.RTCTrackEvent.prototype)) Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $c6527a23987e4bf9$export$d444266503fdd2d4(window) {
    const origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
    window.RTCPeerConnection.prototype.createOffer = function createOffer(offerOptions) {
        if (offerOptions) {
            if (typeof offerOptions.offerToReceiveAudio !== 'undefined') // support bit values
            offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
            const audioTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === 'audio');
            if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
                if (audioTransceiver.direction === 'sendrecv') {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection('sendonly');
                    else audioTransceiver.direction = 'sendonly';
                } else if (audioTransceiver.direction === 'recvonly') {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection('inactive');
                    else audioTransceiver.direction = 'inactive';
                }
            } else if (offerOptions.offerToReceiveAudio === true && !audioTransceiver) this.addTransceiver('audio', {
                direction: 'recvonly'
            });
            if (typeof offerOptions.offerToReceiveVideo !== 'undefined') // support bit values
            offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
            const videoTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === 'video');
            if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
                if (videoTransceiver.direction === 'sendrecv') {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection('sendonly');
                    else videoTransceiver.direction = 'sendonly';
                } else if (videoTransceiver.direction === 'recvonly') {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection('inactive');
                    else videoTransceiver.direction = 'inactive';
                }
            } else if (offerOptions.offerToReceiveVideo === true && !videoTransceiver) this.addTransceiver('video', {
                direction: 'recvonly'
            });
        }
        return origCreateOffer.apply(this, arguments);
    };
}
function $c6527a23987e4bf9$export$857cd739a7b795d2(window) {
    if (typeof window !== 'object' || window.AudioContext) return;
    window.AudioContext = window.webkitAudioContext;
}


var $c85666dbc9b714a9$exports = {};

$parcel$export($c85666dbc9b714a9$exports, "shimRTCIceCandidate", () => $c85666dbc9b714a9$export$cf133661e444ccfe);
$parcel$export($c85666dbc9b714a9$exports, "shimRTCIceCandidateRelayProtocol", () => $c85666dbc9b714a9$export$fdafb8d8280e29b5);
$parcel$export($c85666dbc9b714a9$exports, "shimMaxMessageSize", () => $c85666dbc9b714a9$export$a99147c78a56edc4);
$parcel$export($c85666dbc9b714a9$exports, "shimSendThrowTypeError", () => $c85666dbc9b714a9$export$d461c8d5c5db5da7);
$parcel$export($c85666dbc9b714a9$exports, "shimConnectionState", () => $c85666dbc9b714a9$export$63bb816cc75460);
$parcel$export($c85666dbc9b714a9$exports, "removeExtmapAllowMixed", () => $c85666dbc9b714a9$export$a57d114344295149);
$parcel$export($c85666dbc9b714a9$exports, "shimAddIceCandidateNullOrEmpty", () => $c85666dbc9b714a9$export$51d5e40b48c771c7);
$parcel$export($c85666dbc9b714a9$exports, "shimParameterlessSetLocalDescription", () => $c85666dbc9b714a9$export$7170d04e59f9d553);
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ var $42755665452acf1f$exports = {};
/* eslint-env node */ 'use strict';
// SDP helpers.
const $42755665452acf1f$var$SDPUtils = {};
// Generate an alphanumeric identifier for cname or mids.
// TODO: use UUIDs instead? https://gist.github.com/jed/982883
$42755665452acf1f$var$SDPUtils.generateIdentifier = function() {
    return Math.random().toString(36).substring(2, 12);
};
// The RTCP CNAME used by all peerconnections from the same JS.
$42755665452acf1f$var$SDPUtils.localCName = $42755665452acf1f$var$SDPUtils.generateIdentifier();
// Splits SDP into lines, dealing with both CRLF and LF.
$42755665452acf1f$var$SDPUtils.splitLines = function(blob) {
    return blob.trim().split('\n').map((line)=>line.trim());
};
// Splits SDP into sessionpart and mediasections. Ensures CRLF.
$42755665452acf1f$var$SDPUtils.splitSections = function(blob) {
    const parts = blob.split('\nm=');
    return parts.map((part, index)=>(index > 0 ? 'm=' + part : part).trim() + '\r\n');
};
// Returns the session description.
$42755665452acf1f$var$SDPUtils.getDescription = function(blob) {
    const sections = $42755665452acf1f$var$SDPUtils.splitSections(blob);
    return sections && sections[0];
};
// Returns the individual media sections.
$42755665452acf1f$var$SDPUtils.getMediaSections = function(blob) {
    const sections = $42755665452acf1f$var$SDPUtils.splitSections(blob);
    sections.shift();
    return sections;
};
// Returns lines that start with a certain prefix.
$42755665452acf1f$var$SDPUtils.matchPrefix = function(blob, prefix) {
    return $42755665452acf1f$var$SDPUtils.splitLines(blob).filter((line)=>line.indexOf(prefix) === 0);
};
// Parses an ICE candidate line. Sample input:
// candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
// rport 55996"
// Input can be prefixed with a=.
$42755665452acf1f$var$SDPUtils.parseCandidate = function(line) {
    let parts;
    // Parse both variants.
    if (line.indexOf('a=candidate:') === 0) parts = line.substring(12).split(' ');
    else parts = line.substring(10).split(' ');
    const candidate = {
        foundation: parts[0],
        component: {
            1: 'rtp',
            2: 'rtcp'
        }[parts[1]] || parts[1],
        protocol: parts[2].toLowerCase(),
        priority: parseInt(parts[3], 10),
        ip: parts[4],
        address: parts[4],
        port: parseInt(parts[5], 10),
        // skip parts[6] == 'typ'
        type: parts[7]
    };
    for(let i = 8; i < parts.length; i += 2)switch(parts[i]){
        case 'raddr':
            candidate.relatedAddress = parts[i + 1];
            break;
        case 'rport':
            candidate.relatedPort = parseInt(parts[i + 1], 10);
            break;
        case 'tcptype':
            candidate.tcpType = parts[i + 1];
            break;
        case 'ufrag':
            candidate.ufrag = parts[i + 1]; // for backward compatibility.
            candidate.usernameFragment = parts[i + 1];
            break;
        default:
            if (candidate[parts[i]] === undefined) candidate[parts[i]] = parts[i + 1];
            break;
    }
    return candidate;
};
// Translates a candidate object into SDP candidate attribute.
// This does not include the a= prefix!
$42755665452acf1f$var$SDPUtils.writeCandidate = function(candidate) {
    const sdp = [];
    sdp.push(candidate.foundation);
    const component = candidate.component;
    if (component === 'rtp') sdp.push(1);
    else if (component === 'rtcp') sdp.push(2);
    else sdp.push(component);
    sdp.push(candidate.protocol.toUpperCase());
    sdp.push(candidate.priority);
    sdp.push(candidate.address || candidate.ip);
    sdp.push(candidate.port);
    const type = candidate.type;
    sdp.push('typ');
    sdp.push(type);
    if (type !== 'host' && candidate.relatedAddress && candidate.relatedPort !== undefined) {
        sdp.push('raddr');
        sdp.push(candidate.relatedAddress);
        sdp.push('rport');
        sdp.push(candidate.relatedPort);
    }
    if (candidate.tcpType && candidate.protocol.toLowerCase() === 'tcp') {
        sdp.push('tcptype');
        sdp.push(candidate.tcpType);
    }
    if (candidate.usernameFragment || candidate.ufrag) {
        sdp.push('ufrag');
        sdp.push(candidate.usernameFragment || candidate.ufrag);
    }
    return 'candidate:' + sdp.join(' ');
};
// Parses an ice-options line, returns an array of option tags.
// Sample input:
// a=ice-options:foo bar
$42755665452acf1f$var$SDPUtils.parseIceOptions = function(line) {
    return line.substring(14).split(' ');
};
// Parses a rtpmap line, returns RTCRtpCoddecParameters. Sample input:
// a=rtpmap:111 opus/48000/2
$42755665452acf1f$var$SDPUtils.parseRtpMap = function(line) {
    let parts = line.substring(9).split(' ');
    const parsed = {
        payloadType: parseInt(parts.shift(), 10)
    };
    parts = parts[0].split('/');
    parsed.name = parts[0];
    parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
    parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
    // legacy alias, got renamed back to channels in ORTC.
    parsed.numChannels = parsed.channels;
    return parsed;
};
// Generates a rtpmap line from RTCRtpCodecCapability or
// RTCRtpCodecParameters.
$42755665452acf1f$var$SDPUtils.writeRtpMap = function(codec) {
    let pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    const channels = codec.channels || codec.numChannels || 1;
    return 'a=rtpmap:' + pt + ' ' + codec.name + '/' + codec.clockRate + (channels !== 1 ? '/' + channels : '') + '\r\n';
};
// Parses a extmap line (headerextension from RFC 5285). Sample input:
// a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
// a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
$42755665452acf1f$var$SDPUtils.parseExtmap = function(line) {
    const parts = line.substring(9).split(' ');
    return {
        id: parseInt(parts[0], 10),
        direction: parts[0].indexOf('/') > 0 ? parts[0].split('/')[1] : 'sendrecv',
        uri: parts[1],
        attributes: parts.slice(2).join(' ')
    };
};
// Generates an extmap line from RTCRtpHeaderExtensionParameters or
// RTCRtpHeaderExtension.
$42755665452acf1f$var$SDPUtils.writeExtmap = function(headerExtension) {
    return 'a=extmap:' + (headerExtension.id || headerExtension.preferredId) + (headerExtension.direction && headerExtension.direction !== 'sendrecv' ? '/' + headerExtension.direction : '') + ' ' + headerExtension.uri + (headerExtension.attributes ? ' ' + headerExtension.attributes : '') + '\r\n';
};
// Parses a fmtp line, returns dictionary. Sample input:
// a=fmtp:96 vbr=on;cng=on
// Also deals with vbr=on; cng=on
// Non-key-value such as telephone-events `0-15` get parsed as
// {`0-15`:undefined}
$42755665452acf1f$var$SDPUtils.parseFmtp = function(line) {
    const parsed = {};
    let kv;
    const parts = line.substring(line.indexOf(' ') + 1).split(';');
    for(let j = 0; j < parts.length; j++){
        kv = parts[j].trim().split('=');
        parsed[kv[0].trim()] = kv[1];
    }
    return parsed;
};
// Generates a fmtp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
$42755665452acf1f$var$SDPUtils.writeFmtp = function(codec) {
    let line = '';
    let pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.parameters && Object.keys(codec.parameters).length) {
        const params = [];
        Object.keys(codec.parameters).forEach((param)=>{
            if (codec.parameters[param] !== undefined) params.push(param + '=' + codec.parameters[param]);
            else params.push(param);
        });
        line += 'a=fmtp:' + pt + ' ' + params.join(';') + '\r\n';
    }
    return line;
};
// Parses a rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
// a=rtcp-fb:98 nack rpsi
$42755665452acf1f$var$SDPUtils.parseRtcpFb = function(line) {
    const parts = line.substring(line.indexOf(' ') + 1).split(' ');
    return {
        type: parts.shift(),
        parameter: parts.join(' ')
    };
};
// Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
$42755665452acf1f$var$SDPUtils.writeRtcpFb = function(codec) {
    let lines = '';
    let pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.rtcpFeedback && codec.rtcpFeedback.length) // FIXME: special handling for trr-int?
    codec.rtcpFeedback.forEach((fb)=>{
        lines += 'a=rtcp-fb:' + pt + ' ' + fb.type + (fb.parameter && fb.parameter.length ? ' ' + fb.parameter : '') + '\r\n';
    });
    return lines;
};
// Parses a RFC 5576 ssrc media attribute. Sample input:
// a=ssrc:3735928559 cname:something
$42755665452acf1f$var$SDPUtils.parseSsrcMedia = function(line) {
    const sp = line.indexOf(' ');
    const parts = {
        ssrc: parseInt(line.substring(7, sp), 10)
    };
    const colon = line.indexOf(':', sp);
    if (colon > -1) {
        parts.attribute = line.substring(sp + 1, colon);
        parts.value = line.substring(colon + 1);
    } else parts.attribute = line.substring(sp + 1);
    return parts;
};
// Parse a ssrc-group line (see RFC 5576). Sample input:
// a=ssrc-group:semantics 12 34
$42755665452acf1f$var$SDPUtils.parseSsrcGroup = function(line) {
    const parts = line.substring(13).split(' ');
    return {
        semantics: parts.shift(),
        ssrcs: parts.map((ssrc)=>parseInt(ssrc, 10))
    };
};
// Extracts the MID (RFC 5888) from a media section.
// Returns the MID or undefined if no mid line was found.
$42755665452acf1f$var$SDPUtils.getMid = function(mediaSection) {
    const mid = $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection, 'a=mid:')[0];
    if (mid) return mid.substring(6);
};
// Parses a fingerprint line for DTLS-SRTP.
$42755665452acf1f$var$SDPUtils.parseFingerprint = function(line) {
    const parts = line.substring(14).split(' ');
    return {
        algorithm: parts[0].toLowerCase(),
        value: parts[1].toUpperCase()
    };
};
// Extracts DTLS parameters from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the fingerprint line as input. See also getIceParameters.
$42755665452acf1f$var$SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
    const lines = $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=fingerprint:');
    // Note: a=setup line is ignored since we use the 'auto' role in Edge.
    return {
        role: 'auto',
        fingerprints: lines.map($42755665452acf1f$var$SDPUtils.parseFingerprint)
    };
};
// Serializes DTLS parameters to SDP.
$42755665452acf1f$var$SDPUtils.writeDtlsParameters = function(params, setupType) {
    let sdp = 'a=setup:' + setupType + '\r\n';
    params.fingerprints.forEach((fp)=>{
        sdp += 'a=fingerprint:' + fp.algorithm + ' ' + fp.value + '\r\n';
    });
    return sdp;
};
// Parses a=crypto lines into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members
$42755665452acf1f$var$SDPUtils.parseCryptoLine = function(line) {
    const parts = line.substring(9).split(' ');
    return {
        tag: parseInt(parts[0], 10),
        cryptoSuite: parts[1],
        keyParams: parts[2],
        sessionParams: parts.slice(3)
    };
};
$42755665452acf1f$var$SDPUtils.writeCryptoLine = function(parameters) {
    return 'a=crypto:' + parameters.tag + ' ' + parameters.cryptoSuite + ' ' + (typeof parameters.keyParams === 'object' ? $42755665452acf1f$var$SDPUtils.writeCryptoKeyParams(parameters.keyParams) : parameters.keyParams) + (parameters.sessionParams ? ' ' + parameters.sessionParams.join(' ') : '') + '\r\n';
};
// Parses the crypto key parameters into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*
$42755665452acf1f$var$SDPUtils.parseCryptoKeyParams = function(keyParams) {
    if (keyParams.indexOf('inline:') !== 0) return null;
    const parts = keyParams.substring(7).split('|');
    return {
        keyMethod: 'inline',
        keySalt: parts[0],
        lifeTime: parts[1],
        mkiValue: parts[2] ? parts[2].split(':')[0] : undefined,
        mkiLength: parts[2] ? parts[2].split(':')[1] : undefined
    };
};
$42755665452acf1f$var$SDPUtils.writeCryptoKeyParams = function(keyParams) {
    return keyParams.keyMethod + ':' + keyParams.keySalt + (keyParams.lifeTime ? '|' + keyParams.lifeTime : '') + (keyParams.mkiValue && keyParams.mkiLength ? '|' + keyParams.mkiValue + ':' + keyParams.mkiLength : '');
};
// Extracts all SDES parameters.
$42755665452acf1f$var$SDPUtils.getCryptoParameters = function(mediaSection, sessionpart) {
    const lines = $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=crypto:');
    return lines.map($42755665452acf1f$var$SDPUtils.parseCryptoLine);
};
// Parses ICE information from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the ice-ufrag and ice-pwd lines as input.
$42755665452acf1f$var$SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
    const ufrag = $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=ice-ufrag:')[0];
    const pwd = $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=ice-pwd:')[0];
    if (!(ufrag && pwd)) return null;
    return {
        usernameFragment: ufrag.substring(12),
        password: pwd.substring(10)
    };
};
// Serializes ICE parameters to SDP.
$42755665452acf1f$var$SDPUtils.writeIceParameters = function(params) {
    let sdp = 'a=ice-ufrag:' + params.usernameFragment + '\r\n' + 'a=ice-pwd:' + params.password + '\r\n';
    if (params.iceLite) sdp += 'a=ice-lite\r\n';
    return sdp;
};
// Parses the SDP media section and returns RTCRtpParameters.
$42755665452acf1f$var$SDPUtils.parseRtpParameters = function(mediaSection) {
    const description = {
        codecs: [],
        headerExtensions: [],
        fecMechanisms: [],
        rtcp: []
    };
    const lines = $42755665452acf1f$var$SDPUtils.splitLines(mediaSection);
    const mline = lines[0].split(' ');
    description.profile = mline[2];
    for(let i = 3; i < mline.length; i++){
        const pt = mline[i];
        const rtpmapline = $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection, 'a=rtpmap:' + pt + ' ')[0];
        if (rtpmapline) {
            const codec = $42755665452acf1f$var$SDPUtils.parseRtpMap(rtpmapline);
            const fmtps = $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection, 'a=fmtp:' + pt + ' ');
            // Only the first a=fmtp:<pt> is considered.
            codec.parameters = fmtps.length ? $42755665452acf1f$var$SDPUtils.parseFmtp(fmtps[0]) : {};
            codec.rtcpFeedback = $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection, 'a=rtcp-fb:' + pt + ' ').map($42755665452acf1f$var$SDPUtils.parseRtcpFb);
            description.codecs.push(codec);
            // parse FEC mechanisms from rtpmap lines.
            switch(codec.name.toUpperCase()){
                case 'RED':
                case 'ULPFEC':
                    description.fecMechanisms.push(codec.name.toUpperCase());
                    break;
                default:
                    break;
            }
        }
    }
    $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection, 'a=extmap:').forEach((line)=>{
        description.headerExtensions.push($42755665452acf1f$var$SDPUtils.parseExtmap(line));
    });
    const wildcardRtcpFb = $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection, 'a=rtcp-fb:* ').map($42755665452acf1f$var$SDPUtils.parseRtcpFb);
    description.codecs.forEach((codec)=>{
        wildcardRtcpFb.forEach((fb)=>{
            const duplicate = codec.rtcpFeedback.find((existingFeedback)=>{
                return existingFeedback.type === fb.type && existingFeedback.parameter === fb.parameter;
            });
            if (!duplicate) codec.rtcpFeedback.push(fb);
        });
    });
    // FIXME: parse rtcp.
    return description;
};
// Generates parts of the SDP media section describing the capabilities /
// parameters.
$42755665452acf1f$var$SDPUtils.writeRtpDescription = function(kind, caps) {
    let sdp = '';
    // Build the mline.
    sdp += 'm=' + kind + ' ';
    sdp += caps.codecs.length > 0 ? '9' : '0'; // reject if no codecs.
    sdp += ' ' + (caps.profile || 'UDP/TLS/RTP/SAVPF') + ' ';
    sdp += caps.codecs.map((codec)=>{
        if (codec.preferredPayloadType !== undefined) return codec.preferredPayloadType;
        return codec.payloadType;
    }).join(' ') + '\r\n';
    sdp += 'c=IN IP4 0.0.0.0\r\n';
    sdp += 'a=rtcp:9 IN IP4 0.0.0.0\r\n';
    // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
    caps.codecs.forEach((codec)=>{
        sdp += $42755665452acf1f$var$SDPUtils.writeRtpMap(codec);
        sdp += $42755665452acf1f$var$SDPUtils.writeFmtp(codec);
        sdp += $42755665452acf1f$var$SDPUtils.writeRtcpFb(codec);
    });
    let maxptime = 0;
    caps.codecs.forEach((codec)=>{
        if (codec.maxptime > maxptime) maxptime = codec.maxptime;
    });
    if (maxptime > 0) sdp += 'a=maxptime:' + maxptime + '\r\n';
    if (caps.headerExtensions) caps.headerExtensions.forEach((extension)=>{
        sdp += $42755665452acf1f$var$SDPUtils.writeExtmap(extension);
    });
    // FIXME: write fecMechanisms.
    return sdp;
};
// Parses the SDP media section and returns an array of
// RTCRtpEncodingParameters.
$42755665452acf1f$var$SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
    const encodingParameters = [];
    const description = $42755665452acf1f$var$SDPUtils.parseRtpParameters(mediaSection);
    const hasRed = description.fecMechanisms.indexOf('RED') !== -1;
    const hasUlpfec = description.fecMechanisms.indexOf('ULPFEC') !== -1;
    // filter a=ssrc:... cname:, ignore PlanB-msid
    const ssrcs = $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map((line)=>$42755665452acf1f$var$SDPUtils.parseSsrcMedia(line)).filter((parts)=>parts.attribute === 'cname');
    const primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
    let secondarySsrc;
    const flows = $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection, 'a=ssrc-group:FID').map((line)=>{
        const parts = line.substring(17).split(' ');
        return parts.map((part)=>parseInt(part, 10));
    });
    if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) secondarySsrc = flows[0][1];
    description.codecs.forEach((codec)=>{
        if (codec.name.toUpperCase() === 'RTX' && codec.parameters.apt) {
            let encParam = {
                ssrc: primarySsrc,
                codecPayloadType: parseInt(codec.parameters.apt, 10)
            };
            if (primarySsrc && secondarySsrc) encParam.rtx = {
                ssrc: secondarySsrc
            };
            encodingParameters.push(encParam);
            if (hasRed) {
                encParam = JSON.parse(JSON.stringify(encParam));
                encParam.fec = {
                    ssrc: primarySsrc,
                    mechanism: hasUlpfec ? 'red+ulpfec' : 'red'
                };
                encodingParameters.push(encParam);
            }
        }
    });
    if (encodingParameters.length === 0 && primarySsrc) encodingParameters.push({
        ssrc: primarySsrc
    });
    // we support both b=AS and b=TIAS but interpret AS as TIAS.
    let bandwidth = $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection, 'b=');
    if (bandwidth.length) {
        if (bandwidth[0].indexOf('b=TIAS:') === 0) bandwidth = parseInt(bandwidth[0].substring(7), 10);
        else if (bandwidth[0].indexOf('b=AS:') === 0) // use formula from JSEP to convert b=AS to TIAS value.
        bandwidth = parseInt(bandwidth[0].substring(5), 10) * 950 - 16000;
        else bandwidth = undefined;
        encodingParameters.forEach((params)=>{
            params.maxBitrate = bandwidth;
        });
    }
    return encodingParameters;
};
// parses http://draft.ortc.org/#rtcrtcpparameters*
$42755665452acf1f$var$SDPUtils.parseRtcpParameters = function(mediaSection) {
    const rtcpParameters = {};
    // Gets the first SSRC. Note that with RTX there might be multiple
    // SSRCs.
    const remoteSsrc = $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map((line)=>$42755665452acf1f$var$SDPUtils.parseSsrcMedia(line)).filter((obj)=>obj.attribute === 'cname')[0];
    if (remoteSsrc) {
        rtcpParameters.cname = remoteSsrc.value;
        rtcpParameters.ssrc = remoteSsrc.ssrc;
    }
    // Edge uses the compound attribute instead of reducedSize
    // compound is !reducedSize
    const rsize = $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection, 'a=rtcp-rsize');
    rtcpParameters.reducedSize = rsize.length > 0;
    rtcpParameters.compound = rsize.length === 0;
    // parses the rtcp-mux attrіbute.
    // Note that Edge does not support unmuxed RTCP.
    const mux = $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection, 'a=rtcp-mux');
    rtcpParameters.mux = mux.length > 0;
    return rtcpParameters;
};
$42755665452acf1f$var$SDPUtils.writeRtcpParameters = function(rtcpParameters) {
    let sdp = '';
    if (rtcpParameters.reducedSize) sdp += 'a=rtcp-rsize\r\n';
    if (rtcpParameters.mux) sdp += 'a=rtcp-mux\r\n';
    if (rtcpParameters.ssrc !== undefined && rtcpParameters.cname) sdp += 'a=ssrc:' + rtcpParameters.ssrc + ' cname:' + rtcpParameters.cname + '\r\n';
    return sdp;
};
// parses either a=msid: or a=ssrc:... msid lines and returns
// the id of the MediaStream and MediaStreamTrack.
$42755665452acf1f$var$SDPUtils.parseMsid = function(mediaSection) {
    let parts;
    const spec = $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection, 'a=msid:');
    if (spec.length === 1) {
        parts = spec[0].substring(7).split(' ');
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
    const planB = $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map((line)=>$42755665452acf1f$var$SDPUtils.parseSsrcMedia(line)).filter((msidParts)=>msidParts.attribute === 'msid');
    if (planB.length > 0) {
        parts = planB[0].value.split(' ');
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
};
// SCTP
// parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
// to draft-ietf-mmusic-sctp-sdp-05
$42755665452acf1f$var$SDPUtils.parseSctpDescription = function(mediaSection) {
    const mline = $42755665452acf1f$var$SDPUtils.parseMLine(mediaSection);
    const maxSizeLine = $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection, 'a=max-message-size:');
    let maxMessageSize;
    if (maxSizeLine.length > 0) maxMessageSize = parseInt(maxSizeLine[0].substring(19), 10);
    if (isNaN(maxMessageSize)) maxMessageSize = 65536;
    const sctpPort = $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection, 'a=sctp-port:');
    if (sctpPort.length > 0) return {
        port: parseInt(sctpPort[0].substring(12), 10),
        protocol: mline.fmt,
        maxMessageSize: maxMessageSize
    };
    const sctpMapLines = $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection, 'a=sctpmap:');
    if (sctpMapLines.length > 0) {
        const parts = sctpMapLines[0].substring(10).split(' ');
        return {
            port: parseInt(parts[0], 10),
            protocol: parts[1],
            maxMessageSize: maxMessageSize
        };
    }
};
// SCTP
// outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
// support by now receiving in this format, unless we originally parsed
// as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
// protocol of DTLS/SCTP -- without UDP/ or TCP/)
$42755665452acf1f$var$SDPUtils.writeSctpDescription = function(media, sctp) {
    let output = [];
    if (media.protocol !== 'DTLS/SCTP') output = [
        'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.protocol + '\r\n',
        'c=IN IP4 0.0.0.0\r\n',
        'a=sctp-port:' + sctp.port + '\r\n'
    ];
    else output = [
        'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.port + '\r\n',
        'c=IN IP4 0.0.0.0\r\n',
        'a=sctpmap:' + sctp.port + ' ' + sctp.protocol + ' 65535\r\n'
    ];
    if (sctp.maxMessageSize !== undefined) output.push('a=max-message-size:' + sctp.maxMessageSize + '\r\n');
    return output.join('');
};
// Generate a session ID for SDP.
// https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
// recommends using a cryptographically random +ve 64-bit value
// but right now this should be acceptable and within the right range
$42755665452acf1f$var$SDPUtils.generateSessionId = function() {
    return Math.random().toString().substr(2, 22);
};
// Write boiler plate for start of SDP
// sessId argument is optional - if not supplied it will
// be generated randomly
// sessVersion is optional and defaults to 2
// sessUser is optional and defaults to 'thisisadapterortc'
$42755665452acf1f$var$SDPUtils.writeSessionBoilerplate = function(sessId, sessVer, sessUser) {
    let sessionId;
    const version = sessVer !== undefined ? sessVer : 2;
    if (sessId) sessionId = sessId;
    else sessionId = $42755665452acf1f$var$SDPUtils.generateSessionId();
    const user = sessUser || 'thisisadapterortc';
    // FIXME: sess-id should be an NTP timestamp.
    return "v=0\r\no=" + user + ' ' + sessionId + ' ' + version + ' IN IP4 127.0.0.1\r\n' + 's=-\r\n' + 't=0 0\r\n';
};
// Gets the direction from the mediaSection or the sessionpart.
$42755665452acf1f$var$SDPUtils.getDirection = function(mediaSection, sessionpart) {
    // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
    const lines = $42755665452acf1f$var$SDPUtils.splitLines(mediaSection);
    for(let i = 0; i < lines.length; i++)switch(lines[i]){
        case 'a=sendrecv':
        case 'a=sendonly':
        case 'a=recvonly':
        case 'a=inactive':
            return lines[i].substring(2);
        default:
    }
    if (sessionpart) return $42755665452acf1f$var$SDPUtils.getDirection(sessionpart);
    return 'sendrecv';
};
$42755665452acf1f$var$SDPUtils.getKind = function(mediaSection) {
    const lines = $42755665452acf1f$var$SDPUtils.splitLines(mediaSection);
    const mline = lines[0].split(' ');
    return mline[0].substring(2);
};
$42755665452acf1f$var$SDPUtils.isRejected = function(mediaSection) {
    return mediaSection.split(' ', 2)[1] === '0';
};
$42755665452acf1f$var$SDPUtils.parseMLine = function(mediaSection) {
    const lines = $42755665452acf1f$var$SDPUtils.splitLines(mediaSection);
    const parts = lines[0].substring(2).split(' ');
    return {
        kind: parts[0],
        port: parseInt(parts[1], 10),
        protocol: parts[2],
        fmt: parts.slice(3).join(' ')
    };
};
$42755665452acf1f$var$SDPUtils.parseOLine = function(mediaSection) {
    const line = $42755665452acf1f$var$SDPUtils.matchPrefix(mediaSection, 'o=')[0];
    const parts = line.substring(2).split(' ');
    return {
        username: parts[0],
        sessionId: parts[1],
        sessionVersion: parseInt(parts[2], 10),
        netType: parts[3],
        addressType: parts[4],
        address: parts[5]
    };
};
// a very naive interpretation of a valid SDP.
$42755665452acf1f$var$SDPUtils.isValidSDP = function(blob) {
    if (typeof blob !== 'string' || blob.length === 0) return false;
    const lines = $42755665452acf1f$var$SDPUtils.splitLines(blob);
    for(let i = 0; i < lines.length; i++){
        if (lines[i].length < 2 || lines[i].charAt(1) !== '=') return false;
    // TODO: check the modifier a bit more.
    }
    return true;
};
$42755665452acf1f$exports = $42755665452acf1f$var$SDPUtils;



'use strict';
function $c85666dbc9b714a9$export$cf133661e444ccfe(window) {
    // foundation is arbitrarily chosen as an indicator for full support for
    // https://w3c.github.io/webrtc-pc/#rtcicecandidate-interface
    if (!window.RTCIceCandidate || window.RTCIceCandidate && 'foundation' in window.RTCIceCandidate.prototype) return;
    const NativeRTCIceCandidate = window.RTCIceCandidate;
    window.RTCIceCandidate = function RTCIceCandidate(args) {
        // Remove the a= which shouldn't be part of the candidate string.
        if (typeof args === 'object' && args.candidate && args.candidate.indexOf('a=') === 0) {
            args = JSON.parse(JSON.stringify(args));
            args.candidate = args.candidate.substring(2);
        }
        if (args.candidate && args.candidate.length) {
            // Augment the native candidate with the parsed fields.
            const nativeCandidate = new NativeRTCIceCandidate(args);
            const parsedCandidate = (0, (/*@__PURE__*/$parcel$interopDefault($42755665452acf1f$exports))).parseCandidate(args.candidate);
            for(const key in parsedCandidate)if (!(key in nativeCandidate)) Object.defineProperty(nativeCandidate, key, {
                value: parsedCandidate[key]
            });
            // Override serializer to not serialize the extra attributes.
            nativeCandidate.toJSON = function toJSON() {
                return {
                    candidate: nativeCandidate.candidate,
                    sdpMid: nativeCandidate.sdpMid,
                    sdpMLineIndex: nativeCandidate.sdpMLineIndex,
                    usernameFragment: nativeCandidate.usernameFragment
                };
            };
            return nativeCandidate;
        }
        return new NativeRTCIceCandidate(args);
    };
    window.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype;
    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    $8509fcc13e9d709d$export$1f48841962b828b1(window, 'icecandidate', (e)=>{
        if (e.candidate) Object.defineProperty(e, 'candidate', {
            value: new window.RTCIceCandidate(e.candidate),
            writable: 'false'
        });
        return e;
    });
}
function $c85666dbc9b714a9$export$fdafb8d8280e29b5(window) {
    if (!window.RTCIceCandidate || window.RTCIceCandidate && 'relayProtocol' in window.RTCIceCandidate.prototype) return;
    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    $8509fcc13e9d709d$export$1f48841962b828b1(window, 'icecandidate', (e)=>{
        if (e.candidate) {
            const parsedCandidate = (0, (/*@__PURE__*/$parcel$interopDefault($42755665452acf1f$exports))).parseCandidate(e.candidate.candidate);
            if (parsedCandidate.type === 'relay') // This is a libwebrtc-specific mapping of local type preference
            // to relayProtocol.
            e.candidate.relayProtocol = ({
                0: 'tls',
                1: 'tcp',
                2: 'udp'
            })[parsedCandidate.priority >> 24];
        }
        return e;
    });
}
function $c85666dbc9b714a9$export$a99147c78a56edc4(window, browserDetails) {
    if (!window.RTCPeerConnection) return;
    if (browserDetails.browser === 'chrome' && browserDetails.version > 102) // Unified plan is supported so no need to do anything.
    return;
    if (browserDetails.browser === 'firefox' && browserDetails.version >= 113) // Native RTCSctpTransport, see
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1278299
    return;
    if (!('sctp' in window.RTCPeerConnection.prototype)) Object.defineProperty(window.RTCPeerConnection.prototype, 'sctp', {
        get () {
            return typeof this._sctp === 'undefined' ? null : this._sctp;
        }
    });
    const sctpInDescription = function(description) {
        if (!description || !description.sdp) return false;
        const sections = (0, (/*@__PURE__*/$parcel$interopDefault($42755665452acf1f$exports))).splitSections(description.sdp);
        sections.shift();
        return sections.some((mediaSection)=>{
            const mLine = (0, (/*@__PURE__*/$parcel$interopDefault($42755665452acf1f$exports))).parseMLine(mediaSection);
            return mLine && mLine.kind === 'application' && mLine.protocol.indexOf('SCTP') !== -1;
        });
    };
    const getRemoteFirefoxVersion = function(description) {
        // TODO: Is there a better solution for detecting Firefox?
        const match = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
        if (match === null || match.length < 2) return -1;
        const version = parseInt(match[1], 10);
        // Test for NaN (yes, this is ugly)
        return version !== version ? -1 : version;
    };
    const getCanSendMaxMessageSize = function(remoteIsFirefox) {
        // Every implementation we know can send at least 64 KiB.
        // Note: Although Chrome is technically able to send up to 256 KiB, the
        //       data does not reach the other peer reliably.
        //       See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8419
        let canSendMaxMessageSize = 65536;
        if (browserDetails.browser === 'firefox') {
            if (browserDetails.version < 57) {
                if (remoteIsFirefox === -1) // FF < 57 will send in 16 KiB chunks using the deprecated PPID
                // fragmentation.
                canSendMaxMessageSize = 16384;
                else // However, other FF (and RAWRTC) can reassemble PPID-fragmented
                // messages. Thus, supporting ~2 GiB when sending.
                canSendMaxMessageSize = 2147483637;
            } else if (browserDetails.version < 60) // Currently, all FF >= 57 will reset the remote maximum message size
            // to the default value when a data channel is created at a later
            // stage. :(
            // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
            canSendMaxMessageSize = browserDetails.version === 57 ? 65535 : 65536;
            else // FF >= 60 supports sending ~2 GiB
            canSendMaxMessageSize = 2147483637;
        }
        return canSendMaxMessageSize;
    };
    const getMaxMessageSize = function(description, remoteIsFirefox) {
        // Note: 65536 bytes is the default value from the SDP spec. Also,
        //       every implementation we know supports receiving 65536 bytes.
        let maxMessageSize = 65536;
        // FF 57 has a slightly incorrect default remote max message size, so
        // we need to adjust it here to avoid a failure when sending.
        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1425697
        if (browserDetails.browser === 'firefox' && browserDetails.version === 57) maxMessageSize = 65535;
        const match = (0, (/*@__PURE__*/$parcel$interopDefault($42755665452acf1f$exports))).matchPrefix(description.sdp, 'a=max-message-size:');
        if (match.length > 0) maxMessageSize = parseInt(match[0].substring(19), 10);
        else if (browserDetails.browser === 'firefox' && remoteIsFirefox !== -1) // If the maximum message size is not present in the remote SDP and
        // both local and remote are Firefox, the remote peer can receive
        // ~2 GiB.
        maxMessageSize = 2147483637;
        return maxMessageSize;
    };
    const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
        this._sctp = null;
        // Chrome decided to not expose .sctp in plan-b mode.
        // As usual, adapter.js has to do an 'ugly worakaround'
        // to cover up the mess.
        if (browserDetails.browser === 'chrome' && browserDetails.version >= 76) {
            const { sdpSemantics: sdpSemantics } = this.getConfiguration();
            if (sdpSemantics === 'plan-b') Object.defineProperty(this, 'sctp', {
                get () {
                    return typeof this._sctp === 'undefined' ? null : this._sctp;
                },
                enumerable: true,
                configurable: true
            });
        }
        if (sctpInDescription(arguments[0])) {
            // Check if the remote is FF.
            const isFirefox = getRemoteFirefoxVersion(arguments[0]);
            // Get the maximum message size the local peer is capable of sending
            const canSendMMS = getCanSendMaxMessageSize(isFirefox);
            // Get the maximum message size of the remote peer.
            const remoteMMS = getMaxMessageSize(arguments[0], isFirefox);
            // Determine final maximum message size
            let maxMessageSize;
            if (canSendMMS === 0 && remoteMMS === 0) maxMessageSize = Number.POSITIVE_INFINITY;
            else if (canSendMMS === 0 || remoteMMS === 0) maxMessageSize = Math.max(canSendMMS, remoteMMS);
            else maxMessageSize = Math.min(canSendMMS, remoteMMS);
            // Create a dummy RTCSctpTransport object and the 'maxMessageSize'
            // attribute.
            const sctp = {};
            Object.defineProperty(sctp, 'maxMessageSize', {
                get () {
                    return maxMessageSize;
                }
            });
            this._sctp = sctp;
        }
        return origSetRemoteDescription.apply(this, arguments);
    };
}
function $c85666dbc9b714a9$export$d461c8d5c5db5da7(window, browserDetails) {
    if (!(window.RTCPeerConnection && 'createDataChannel' in window.RTCPeerConnection.prototype)) return;
    if (browserDetails.browser === 'chrome' && browserDetails.version >= 149) // Fixed by https://issues.chromium.org/issues/490588131
    return;
    // Note: Although Firefox >= 57 has a native implementation, the maximum
    //       message size can be reset for all data channels at a later stage.
    //       See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
    if (browserDetails.browser === 'firefox' && browserDetails.version > 60) return;
    function wrapDcSend(dc, pc) {
        const origDataChannelSend = dc.send;
        dc.send = function send() {
            const data = arguments[0];
            const length = data.length || data.size || data.byteLength;
            if (dc.readyState === 'open' && pc.sctp && length > pc.sctp.maxMessageSize) throw new TypeError('Message too large (can send a maximum of ' + pc.sctp.maxMessageSize + ' bytes)');
            return origDataChannelSend.apply(dc, arguments);
        };
    }
    const origCreateDataChannel = window.RTCPeerConnection.prototype.createDataChannel;
    window.RTCPeerConnection.prototype.createDataChannel = function createDataChannel() {
        const dataChannel = origCreateDataChannel.apply(this, arguments);
        wrapDcSend(dataChannel, this);
        return dataChannel;
    };
    $8509fcc13e9d709d$export$1f48841962b828b1(window, 'datachannel', (e)=>{
        wrapDcSend(e.channel, e.target);
        return e;
    });
}
function $c85666dbc9b714a9$export$63bb816cc75460(window) {
    if (!window.RTCPeerConnection || 'connectionState' in window.RTCPeerConnection.prototype) return;
    const proto = window.RTCPeerConnection.prototype;
    Object.defineProperty(proto, 'connectionState', {
        get () {
            return ({
                completed: 'connected',
                checking: 'connecting'
            })[this.iceConnectionState] || this.iceConnectionState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(proto, 'onconnectionstatechange', {
        get () {
            return this._onconnectionstatechange || null;
        },
        set (cb) {
            if (this._onconnectionstatechange) {
                this.removeEventListener('connectionstatechange', this._onconnectionstatechange);
                delete this._onconnectionstatechange;
            }
            if (cb) this.addEventListener('connectionstatechange', this._onconnectionstatechange = cb);
        },
        enumerable: true,
        configurable: true
    });
    [
        'setLocalDescription',
        'setRemoteDescription'
    ].forEach((method)=>{
        const origMethod = proto[method];
        proto[method] = function() {
            if (!this._connectionstatechangepoly) {
                this._connectionstatechangepoly = (e)=>{
                    const pc = e.target;
                    if (pc._lastConnectionState !== pc.connectionState) {
                        pc._lastConnectionState = pc.connectionState;
                        const newEvent = new Event('connectionstatechange', e);
                        pc.dispatchEvent(newEvent);
                    }
                    return e;
                };
                this.addEventListener('iceconnectionstatechange', this._connectionstatechangepoly);
            }
            return origMethod.apply(this, arguments);
        };
    });
}
function $c85666dbc9b714a9$export$a57d114344295149(window, browserDetails) {
    /* remove a=extmap-allow-mixed for webrtc.org < M71 */ if (!window.RTCPeerConnection) return;
    if (browserDetails.browser === 'chrome' && browserDetails.version >= 71) return;
    if (browserDetails.browser === 'safari' && browserDetails._safariVersion >= 13.1) return;
    const nativeSRD = window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription(desc) {
        if (desc && desc.sdp && desc.sdp.indexOf('\na=extmap-allow-mixed') !== -1) {
            const sdp = desc.sdp.split('\n').filter((line)=>{
                return line.trim() !== 'a=extmap-allow-mixed';
            }).join('\n');
            // Safari enforces read-only-ness of RTCSessionDescription fields.
            if (window.RTCSessionDescription && desc instanceof window.RTCSessionDescription) arguments[0] = new window.RTCSessionDescription({
                type: desc.type,
                sdp: sdp
            });
            else desc.sdp = sdp;
        }
        return nativeSRD.apply(this, arguments);
    };
}
function $c85666dbc9b714a9$export$51d5e40b48c771c7(window, browserDetails) {
    // Support for addIceCandidate(null or undefined)
    // as well as addIceCandidate({candidate: "", ...})
    // https://bugs.chromium.org/p/chromium/issues/detail?id=978582
    // Note: must be called before other polyfills which change the signature.
    if (!(window.RTCPeerConnection && window.RTCPeerConnection.prototype)) return;
    const nativeAddIceCandidate = window.RTCPeerConnection.prototype.addIceCandidate;
    if (!nativeAddIceCandidate || nativeAddIceCandidate.length === 0) return;
    window.RTCPeerConnection.prototype.addIceCandidate = function addIceCandidate() {
        if (!arguments[0]) {
            if (arguments[1]) arguments[1].apply(null);
            return Promise.resolve();
        }
        // Firefox 68+ emits and processes {candidate: "", ...}, ignore
        // in older versions.
        // Native support for ignoring exists for Chrome M77+.
        // Safari ignores as well, exact version unknown but works in the same
        // version that also ignores addIceCandidate(null).
        if ((browserDetails.browser === 'chrome' && browserDetails.version < 78 || browserDetails.browser === 'firefox' && browserDetails.version < 68 || browserDetails.browser === 'safari') && arguments[0] && arguments[0].candidate === '') return Promise.resolve();
        return nativeAddIceCandidate.apply(this, arguments);
    };
}
function $c85666dbc9b714a9$export$7170d04e59f9d553(window, browserDetails) {
    if (!(window.RTCPeerConnection && window.RTCPeerConnection.prototype)) return;
    const nativeSetLocalDescription = window.RTCPeerConnection.prototype.setLocalDescription;
    if (!nativeSetLocalDescription || nativeSetLocalDescription.length === 0) return;
    window.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
        let desc = arguments[0] || {};
        if (typeof desc !== 'object' || desc.type && desc.sdp) return nativeSetLocalDescription.apply(this, arguments);
        // The remaining steps should technically happen when SLD comes off the
        // RTCPeerConnection's operations chain (not ahead of going on it), but
        // this is too difficult to shim. Instead, this shim only covers the
        // common case where the operations chain is empty. This is imperfect, but
        // should cover many cases. Rationale: Even if we can't reduce the glare
        // window to zero on imperfect implementations, there's value in tapping
        // into the perfect negotiation pattern that several browsers support.
        desc = {
            type: desc.type,
            sdp: desc.sdp
        };
        if (!desc.type) switch(this.signalingState){
            case 'stable':
            case 'have-local-offer':
            case 'have-remote-pranswer':
                desc.type = 'offer';
                break;
            default:
                desc.type = 'answer';
                break;
        }
        if (desc.sdp || desc.type !== 'offer' && desc.type !== 'answer') return nativeSetLocalDescription.apply(this, [
            desc
        ]);
        const func = desc.type === 'offer' ? this.createOffer : this.createAnswer;
        return func.apply(this).then((d)=>nativeSetLocalDescription.apply(this, [
                d
            ]));
    };
}



function $b35e03e37a214519$export$e77bf46c04ac7d12({ window: window } = {}, options = {
    shimChrome: true,
    shimFirefox: true,
    shimSafari: true
}) {
    // Utils.
    const logging = $8509fcc13e9d709d$export$bef1f36f5486a6a3;
    const browserDetails = $8509fcc13e9d709d$export$2d31490a0c05f094(window);
    const adapter = {
        browserDetails: browserDetails,
        commonShim: $c85666dbc9b714a9$exports,
        extractVersion: $8509fcc13e9d709d$export$e3c02be309be1f23,
        disableLog: $8509fcc13e9d709d$export$afbfee8cc06fd3e4,
        disableWarnings: $8509fcc13e9d709d$export$51516be4b019e41e,
        sdp: // Expose sdp as a convenience. For production apps include directly.
        $42755665452acf1f$exports
    };
    // Shim browser if found.
    switch(browserDetails.browser){
        case 'chrome':
            if (!$f654d4fc883bc56e$exports || !$f654d4fc883bc56e$exports.shimPeerConnection || !options.shimChrome) {
                logging('Chrome shim is not included in this adapter release.');
                return adapter;
            }
            if (browserDetails.version === null) {
                logging('Chrome shim can not determine version, not shimming.');
                return adapter;
            }
            logging('adapter.js shimming chrome.');
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $f654d4fc883bc56e$exports;
            // Must be called before shimPeerConnection.
            $c85666dbc9b714a9$export$51d5e40b48c771c7(window, browserDetails);
            $c85666dbc9b714a9$export$7170d04e59f9d553(window, browserDetails);
            $f654d4fc883bc56e$exports.shimGetUserMedia(window, browserDetails);
            $f654d4fc883bc56e$exports.shimMediaStream(window, browserDetails);
            $f654d4fc883bc56e$exports.shimPeerConnection(window, browserDetails);
            $f654d4fc883bc56e$exports.shimOnTrack(window, browserDetails);
            $f654d4fc883bc56e$exports.shimAddTrackRemoveTrack(window, browserDetails);
            $f654d4fc883bc56e$exports.shimGetSendersWithDtmf(window, browserDetails);
            $f654d4fc883bc56e$exports.shimSenderReceiverGetStats(window, browserDetails);
            $f654d4fc883bc56e$exports.fixNegotiationNeeded(window, browserDetails);
            $c85666dbc9b714a9$export$cf133661e444ccfe(window, browserDetails);
            $c85666dbc9b714a9$export$fdafb8d8280e29b5(window, browserDetails);
            $c85666dbc9b714a9$export$63bb816cc75460(window, browserDetails);
            $c85666dbc9b714a9$export$a99147c78a56edc4(window, browserDetails);
            $c85666dbc9b714a9$export$d461c8d5c5db5da7(window, browserDetails);
            $c85666dbc9b714a9$export$a57d114344295149(window, browserDetails);
            break;
        case 'firefox':
            if (!$2ab4b9558f0161ae$exports || !$2ab4b9558f0161ae$exports.shimPeerConnection || !options.shimFirefox) {
                logging('Firefox shim is not included in this adapter release.');
                return adapter;
            }
            logging('adapter.js shimming firefox.');
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $2ab4b9558f0161ae$exports;
            // Must be called before shimPeerConnection.
            $c85666dbc9b714a9$export$51d5e40b48c771c7(window, browserDetails);
            $c85666dbc9b714a9$export$7170d04e59f9d553(window, browserDetails);
            $2ab4b9558f0161ae$exports.shimGetUserMedia(window, browserDetails);
            $2ab4b9558f0161ae$exports.shimPeerConnection(window, browserDetails);
            $2ab4b9558f0161ae$exports.shimGetStats(window, browserDetails);
            $2ab4b9558f0161ae$exports.shimOnTrack(window, browserDetails);
            $2ab4b9558f0161ae$exports.shimRemoveStream(window, browserDetails);
            $2ab4b9558f0161ae$exports.shimSenderGetStats(window, browserDetails);
            $2ab4b9558f0161ae$exports.shimReceiverGetStats(window, browserDetails);
            $2ab4b9558f0161ae$exports.shimRTCDataChannel(window, browserDetails);
            $2ab4b9558f0161ae$exports.shimAddTransceiver(window, browserDetails);
            $2ab4b9558f0161ae$exports.shimGetParameters(window, browserDetails);
            $2ab4b9558f0161ae$exports.shimCreateOffer(window, browserDetails);
            $2ab4b9558f0161ae$exports.shimCreateAnswer(window, browserDetails);
            $c85666dbc9b714a9$export$cf133661e444ccfe(window, browserDetails);
            $c85666dbc9b714a9$export$63bb816cc75460(window, browserDetails);
            $c85666dbc9b714a9$export$a99147c78a56edc4(window, browserDetails);
            $c85666dbc9b714a9$export$d461c8d5c5db5da7(window, browserDetails);
            break;
        case 'safari':
            if (!$c6527a23987e4bf9$exports || !options.shimSafari) {
                logging('Safari shim is not included in this adapter release.');
                return adapter;
            }
            logging('adapter.js shimming safari.');
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $c6527a23987e4bf9$exports;
            // Must be called before shimCallbackAPI.
            $c85666dbc9b714a9$export$51d5e40b48c771c7(window, browserDetails);
            $c85666dbc9b714a9$export$7170d04e59f9d553(window, browserDetails);
            $c6527a23987e4bf9$exports.shimRTCIceServerUrls(window, browserDetails);
            $c6527a23987e4bf9$exports.shimCreateOfferLegacy(window, browserDetails);
            $c6527a23987e4bf9$exports.shimCallbacksAPI(window, browserDetails);
            $c6527a23987e4bf9$exports.shimLocalStreamsAPI(window, browserDetails);
            $c6527a23987e4bf9$exports.shimRemoteStreamsAPI(window, browserDetails);
            $c6527a23987e4bf9$exports.shimTrackEventTransceiver(window, browserDetails);
            $c6527a23987e4bf9$exports.shimGetUserMedia(window, browserDetails);
            $c6527a23987e4bf9$exports.shimAudioContext(window, browserDetails);
            $c85666dbc9b714a9$export$cf133661e444ccfe(window, browserDetails);
            $c85666dbc9b714a9$export$fdafb8d8280e29b5(window, browserDetails);
            $c85666dbc9b714a9$export$a99147c78a56edc4(window, browserDetails);
            $c85666dbc9b714a9$export$d461c8d5c5db5da7(window, browserDetails);
            $c85666dbc9b714a9$export$a57d114344295149(window, browserDetails);
            break;
        default:
            logging('Unsupported browser!');
            break;
    }
    return adapter;
}


'use strict';
const $0c297cbc3d949fec$var$adapter = (0, $b35e03e37a214519$export$e77bf46c04ac7d12)({
    window: typeof window === 'undefined' ? undefined : window
});
var $0c297cbc3d949fec$export$2e2bcd8739ae039 = $0c297cbc3d949fec$var$adapter;


function $d2b946db4d58d993$export$78406e843f5312da(byte) {
    return "".concat(byte < 0 ? "-" : "", "0x").concat(Math.abs(byte).toString(16).padStart(2, "0"));
}


// ExtensionCodec to handle MessagePack extensions
/**
 * ExtData is used to handle Extension Types that are not registered to ExtensionCodec.
 */ var $4b94de0eddf033fc$export$bcbeb236456bc779 = /** @class */ function() {
    function ExtData(type, data) {
        this.type = type;
        this.data = data;
    }
    return ExtData;
}();


// https://github.com/msgpack/msgpack/blob/master/spec.md#timestamp-extension-type
var $efa0a4d232d38314$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $efa0a4d232d38314$export$ef3eed12d06c0285 = /** @class */ function(_super) {
    $efa0a4d232d38314$var$__extends(DecodeError, _super);
    function DecodeError(message) {
        var _this = _super.call(this, message) || this;
        // fix the prototype chain in a cross-platform way
        var proto = Object.create(DecodeError.prototype);
        Object.setPrototypeOf(_this, proto);
        Object.defineProperty(_this, "name", {
            configurable: true,
            enumerable: false,
            value: DecodeError.name
        });
        return _this;
    }
    return DecodeError;
}(Error);


// Integer Utility
var $fba4db372ae69f54$export$3314b2c271c86d70 = 4294967295;
function $fba4db372ae69f54$export$20f71c4c8b0f96c3(view, offset, value) {
    var high = value / 4294967296;
    var low = value; // high bits are truncated by DataView
    view.setUint32(offset, high);
    view.setUint32(offset + 4, low);
}
function $fba4db372ae69f54$export$8532a5209571c04a(view, offset, value) {
    var high = Math.floor(value / 4294967296);
    var low = value; // high bits are truncated by DataView
    view.setUint32(offset, high);
    view.setUint32(offset + 4, low);
}
function $fba4db372ae69f54$export$69825c7adcc820c6(view, offset) {
    var high = view.getInt32(offset);
    var low = view.getUint32(offset + 4);
    return high * 4294967296 + low;
}
function $fba4db372ae69f54$export$59a2dbf579ff9568(view, offset) {
    var high = view.getUint32(offset);
    var low = view.getUint32(offset + 4);
    return high * 4294967296 + low;
}


var $b2e57b95c95fe135$export$f18369fc203f4e13 = -1;
var $b2e57b95c95fe135$var$TIMESTAMP32_MAX_SEC = 4294967295; // 32-bit unsigned int
var $b2e57b95c95fe135$var$TIMESTAMP64_MAX_SEC = 17179869183; // 34-bit unsigned int
function $b2e57b95c95fe135$export$2fd05b828dd81159(_a) {
    var sec = _a.sec, nsec = _a.nsec;
    if (sec >= 0 && nsec >= 0 && sec <= $b2e57b95c95fe135$var$TIMESTAMP64_MAX_SEC) {
        // Here sec >= 0 && nsec >= 0
        if (nsec === 0 && sec <= $b2e57b95c95fe135$var$TIMESTAMP32_MAX_SEC) {
            // timestamp 32 = { sec32 (unsigned) }
            var rv = new Uint8Array(4);
            var view = new DataView(rv.buffer);
            view.setUint32(0, sec);
            return rv;
        } else {
            // timestamp 64 = { nsec30 (unsigned), sec34 (unsigned) }
            var secHigh = sec / 0x100000000;
            var secLow = sec & 0xffffffff;
            var rv = new Uint8Array(8);
            var view = new DataView(rv.buffer);
            // nsec30 | secHigh2
            view.setUint32(0, nsec << 2 | secHigh & 0x3);
            // secLow32
            view.setUint32(4, secLow);
            return rv;
        }
    } else {
        // timestamp 96 = { nsec32 (unsigned), sec64 (signed) }
        var rv = new Uint8Array(12);
        var view = new DataView(rv.buffer);
        view.setUint32(0, nsec);
        (0, $fba4db372ae69f54$export$8532a5209571c04a)(view, 4, sec);
        return rv;
    }
}
function $b2e57b95c95fe135$export$221d97b3b00b03c2(date) {
    var msec = date.getTime();
    var sec = Math.floor(msec / 1e3);
    var nsec = (msec - sec * 1e3) * 1e6;
    // Normalizes { sec, nsec } to ensure nsec is unsigned.
    var nsecInSec = Math.floor(nsec / 1e9);
    return {
        sec: sec + nsecInSec,
        nsec: nsec - nsecInSec * 1e9
    };
}
function $b2e57b95c95fe135$export$32420f352fe0fc83(object) {
    if (object instanceof Date) {
        var timeSpec = $b2e57b95c95fe135$export$221d97b3b00b03c2(object);
        return $b2e57b95c95fe135$export$2fd05b828dd81159(timeSpec);
    } else return null;
}
function $b2e57b95c95fe135$export$abfc8800a5159711(data) {
    var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
    // data may be 32, 64, or 96 bits
    switch(data.byteLength){
        case 4:
            // timestamp 32 = { sec32 }
            var sec = view.getUint32(0);
            var nsec = 0;
            return {
                sec: sec,
                nsec: nsec
            };
        case 8:
            // timestamp 64 = { nsec30, sec34 }
            var nsec30AndSecHigh2 = view.getUint32(0);
            var secLow32 = view.getUint32(4);
            var sec = (nsec30AndSecHigh2 & 0x3) * 0x100000000 + secLow32;
            var nsec = nsec30AndSecHigh2 >>> 2;
            return {
                sec: sec,
                nsec: nsec
            };
        case 12:
            // timestamp 96 = { nsec32 (unsigned), sec64 (signed) }
            var sec = (0, $fba4db372ae69f54$export$69825c7adcc820c6)(view, 4);
            var nsec = view.getUint32(0);
            return {
                sec: sec,
                nsec: nsec
            };
        default:
            throw new (0, $efa0a4d232d38314$export$ef3eed12d06c0285)("Unrecognized data size for timestamp (expected 4, 8, or 12): ".concat(data.length));
    }
}
function $b2e57b95c95fe135$export$80b8ff9315e4298f(data) {
    var timeSpec = $b2e57b95c95fe135$export$abfc8800a5159711(data);
    return new Date(timeSpec.sec * 1e3 + timeSpec.nsec / 1e6);
}
var $b2e57b95c95fe135$export$8654479533463da1 = {
    type: $b2e57b95c95fe135$export$f18369fc203f4e13,
    encode: $b2e57b95c95fe135$export$32420f352fe0fc83,
    decode: $b2e57b95c95fe135$export$80b8ff9315e4298f
};


var $8910db2cff065116$export$12677a794dbd89d7 = /** @class */ function() {
    function ExtensionCodec() {
        // built-in extensions
        this.builtInEncoders = [];
        this.builtInDecoders = [];
        // custom extensions
        this.encoders = [];
        this.decoders = [];
        this.register((0, $b2e57b95c95fe135$export$8654479533463da1));
    }
    ExtensionCodec.prototype.register = function(_a) {
        var type = _a.type, encode = _a.encode, decode = _a.decode;
        if (type >= 0) {
            // custom extensions
            this.encoders[type] = encode;
            this.decoders[type] = decode;
        } else {
            // built-in extensions
            var index = 1 + type;
            this.builtInEncoders[index] = encode;
            this.builtInDecoders[index] = decode;
        }
    };
    ExtensionCodec.prototype.tryToEncode = function(object, context) {
        // built-in extensions
        for(var i = 0; i < this.builtInEncoders.length; i++){
            var encodeExt = this.builtInEncoders[i];
            if (encodeExt != null) {
                var data = encodeExt(object, context);
                if (data != null) {
                    var type = -1 - i;
                    return new (0, $4b94de0eddf033fc$export$bcbeb236456bc779)(type, data);
                }
            }
        }
        // custom extensions
        for(var i = 0; i < this.encoders.length; i++){
            var encodeExt = this.encoders[i];
            if (encodeExt != null) {
                var data = encodeExt(object, context);
                if (data != null) {
                    var type = i;
                    return new (0, $4b94de0eddf033fc$export$bcbeb236456bc779)(type, data);
                }
            }
        }
        if (object instanceof (0, $4b94de0eddf033fc$export$bcbeb236456bc779)) // to keep ExtData as is
        return object;
        return null;
    };
    ExtensionCodec.prototype.decode = function(data, type, context) {
        var decodeExt = type < 0 ? this.builtInDecoders[-1 - type] : this.decoders[type];
        if (decodeExt) return decodeExt(data, type, context);
        else // decode() does not fail, returns ExtData instead.
        return new (0, $4b94de0eddf033fc$export$bcbeb236456bc779)(type, data);
    };
    ExtensionCodec.defaultCodec = new ExtensionCodec();
    return ExtensionCodec;
}();




var $3a6835e34f5ad41c$var$_a, $3a6835e34f5ad41c$var$_b, $3a6835e34f5ad41c$var$_c;
var $3a6835e34f5ad41c$var$TEXT_ENCODING_AVAILABLE = typeof TextEncoder !== "undefined" && typeof TextDecoder !== "undefined";
function $3a6835e34f5ad41c$export$b61de95301265227(str) {
    var strLength = str.length;
    var byteLength = 0;
    var pos = 0;
    while(pos < strLength){
        var value = str.charCodeAt(pos++);
        if ((value & 0xffffff80) === 0) {
            // 1-byte
            byteLength++;
            continue;
        } else if ((value & 0xfffff800) === 0) // 2-bytes
        byteLength += 2;
        else {
            // handle surrogate pair
            if (value >= 0xd800 && value <= 0xdbff) // high surrogate
            {
                if (pos < strLength) {
                    var extra = str.charCodeAt(pos);
                    if ((extra & 0xfc00) === 0xdc00) {
                        ++pos;
                        value = ((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000;
                    }
                }
            }
            if ((value & 0xffff0000) === 0) // 3-byte
            byteLength += 3;
            else // 4-byte
            byteLength += 4;
        }
    }
    return byteLength;
}
function $3a6835e34f5ad41c$export$1042e4338f1ef853(str, output, outputOffset) {
    var strLength = str.length;
    var offset = outputOffset;
    var pos = 0;
    while(pos < strLength){
        var value = str.charCodeAt(pos++);
        if ((value & 0xffffff80) === 0) {
            // 1-byte
            output[offset++] = value;
            continue;
        } else if ((value & 0xfffff800) === 0) // 2-bytes
        output[offset++] = value >> 6 & 0x1f | 0xc0;
        else {
            // handle surrogate pair
            if (value >= 0xd800 && value <= 0xdbff) // high surrogate
            {
                if (pos < strLength) {
                    var extra = str.charCodeAt(pos);
                    if ((extra & 0xfc00) === 0xdc00) {
                        ++pos;
                        value = ((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000;
                    }
                }
            }
            if ((value & 0xffff0000) === 0) {
                // 3-byte
                output[offset++] = value >> 12 & 0x0f | 0xe0;
                output[offset++] = value >> 6 & 0x3f | 0x80;
            } else {
                // 4-byte
                output[offset++] = value >> 18 & 0x07 | 0xf0;
                output[offset++] = value >> 12 & 0x3f | 0x80;
                output[offset++] = value >> 6 & 0x3f | 0x80;
            }
        }
        output[offset++] = value & 0x3f | 0x80;
    }
}
var $3a6835e34f5ad41c$var$sharedTextEncoder = $3a6835e34f5ad41c$var$TEXT_ENCODING_AVAILABLE ? new TextEncoder() : undefined;
var $3a6835e34f5ad41c$export$ed34c0622b397238 = !$3a6835e34f5ad41c$var$TEXT_ENCODING_AVAILABLE ? (0, $fba4db372ae69f54$export$3314b2c271c86d70) : 0;
function $3a6835e34f5ad41c$var$utf8EncodeTEencode(str, output, outputOffset) {
    output.set($3a6835e34f5ad41c$var$sharedTextEncoder.encode(str), outputOffset);
}
function $3a6835e34f5ad41c$var$utf8EncodeTEencodeInto(str, output, outputOffset) {
    $3a6835e34f5ad41c$var$sharedTextEncoder.encodeInto(str, output.subarray(outputOffset));
}
var $3a6835e34f5ad41c$export$34cfdc82d430524 = ($3a6835e34f5ad41c$var$sharedTextEncoder === null || $3a6835e34f5ad41c$var$sharedTextEncoder === void 0 ? void 0 : $3a6835e34f5ad41c$var$sharedTextEncoder.encodeInto) ? $3a6835e34f5ad41c$var$utf8EncodeTEencodeInto : $3a6835e34f5ad41c$var$utf8EncodeTEencode;
var $3a6835e34f5ad41c$var$CHUNK_SIZE = 4096;
function $3a6835e34f5ad41c$export$551117984c2adf4f(bytes, inputOffset, byteLength) {
    var offset = inputOffset;
    var end = offset + byteLength;
    var units = [];
    var result = "";
    while(offset < end){
        var byte1 = bytes[offset++];
        if ((byte1 & 0x80) === 0) // 1 byte
        units.push(byte1);
        else if ((byte1 & 0xe0) === 0xc0) {
            // 2 bytes
            var byte2 = bytes[offset++] & 0x3f;
            units.push((byte1 & 0x1f) << 6 | byte2);
        } else if ((byte1 & 0xf0) === 0xe0) {
            // 3 bytes
            var byte2 = bytes[offset++] & 0x3f;
            var byte3 = bytes[offset++] & 0x3f;
            units.push((byte1 & 0x1f) << 12 | byte2 << 6 | byte3);
        } else if ((byte1 & 0xf8) === 0xf0) {
            // 4 bytes
            var byte2 = bytes[offset++] & 0x3f;
            var byte3 = bytes[offset++] & 0x3f;
            var byte4 = bytes[offset++] & 0x3f;
            var unit = (byte1 & 0x07) << 0x12 | byte2 << 0x0c | byte3 << 0x06 | byte4;
            if (unit > 0xffff) {
                unit -= 0x10000;
                units.push(unit >>> 10 & 0x3ff | 0xd800);
                unit = 0xdc00 | unit & 0x3ff;
            }
            units.push(unit);
        } else units.push(byte1);
        if (units.length >= $3a6835e34f5ad41c$var$CHUNK_SIZE) {
            result += String.fromCharCode.apply(String, units);
            units.length = 0;
        }
    }
    if (units.length > 0) result += String.fromCharCode.apply(String, units);
    return result;
}
var $3a6835e34f5ad41c$var$sharedTextDecoder = $3a6835e34f5ad41c$var$TEXT_ENCODING_AVAILABLE ? new TextDecoder() : null;
var $3a6835e34f5ad41c$export$d866281c5a66d1ef = !$3a6835e34f5ad41c$var$TEXT_ENCODING_AVAILABLE ? (0, $fba4db372ae69f54$export$3314b2c271c86d70) : 0;
function $3a6835e34f5ad41c$export$6ed79e41309992dc(bytes, inputOffset, byteLength) {
    var stringBytes = bytes.subarray(inputOffset, inputOffset + byteLength);
    return $3a6835e34f5ad41c$var$sharedTextDecoder.decode(stringBytes);
}


function $1654631896d25994$export$f8d669c2a17882f2(buffer) {
    if (buffer instanceof Uint8Array) return buffer;
    else if (ArrayBuffer.isView(buffer)) return new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    else if (buffer instanceof ArrayBuffer) return new Uint8Array(buffer);
    else // ArrayLike<number>
    return Uint8Array.from(buffer);
}
function $1654631896d25994$export$7277868462c1ba02(buffer) {
    if (buffer instanceof ArrayBuffer) return new DataView(buffer);
    var bufferView = $1654631896d25994$export$f8d669c2a17882f2(buffer);
    return new DataView(bufferView.buffer, bufferView.byteOffset, bufferView.byteLength);
}



var $0c6d84b6db4e80aa$var$DEFAULT_MAX_KEY_LENGTH = 16;
var $0c6d84b6db4e80aa$var$DEFAULT_MAX_LENGTH_PER_KEY = 16;
var $0c6d84b6db4e80aa$export$529b830450faf29c = /** @class */ function() {
    function CachedKeyDecoder(maxKeyLength, maxLengthPerKey) {
        if (maxKeyLength === void 0) maxKeyLength = $0c6d84b6db4e80aa$var$DEFAULT_MAX_KEY_LENGTH;
        if (maxLengthPerKey === void 0) maxLengthPerKey = $0c6d84b6db4e80aa$var$DEFAULT_MAX_LENGTH_PER_KEY;
        this.maxKeyLength = maxKeyLength;
        this.maxLengthPerKey = maxLengthPerKey;
        this.hit = 0;
        this.miss = 0;
        // avoid `new Array(N)`, which makes a sparse array,
        // because a sparse array is typically slower than a non-sparse array.
        this.caches = [];
        for(var i = 0; i < this.maxKeyLength; i++)this.caches.push([]);
    }
    CachedKeyDecoder.prototype.canBeCached = function(byteLength) {
        return byteLength > 0 && byteLength <= this.maxKeyLength;
    };
    CachedKeyDecoder.prototype.find = function(bytes, inputOffset, byteLength) {
        var records = this.caches[byteLength - 1];
        FIND_CHUNK: for(var _i = 0, records_1 = records; _i < records_1.length; _i++){
            var record = records_1[_i];
            var recordBytes = record.bytes;
            for(var j = 0; j < byteLength; j++){
                if (recordBytes[j] !== bytes[inputOffset + j]) continue FIND_CHUNK;
            }
            return record.str;
        }
        return null;
    };
    CachedKeyDecoder.prototype.store = function(bytes, value) {
        var records = this.caches[bytes.length - 1];
        var record = {
            bytes: bytes,
            str: value
        };
        if (records.length >= this.maxLengthPerKey) // `records` are full!
        // Set `record` to an arbitrary position.
        records[Math.random() * records.length | 0] = record;
        else records.push(record);
    };
    CachedKeyDecoder.prototype.decode = function(bytes, inputOffset, byteLength) {
        var cachedValue = this.find(bytes, inputOffset, byteLength);
        if (cachedValue != null) {
            this.hit++;
            return cachedValue;
        }
        this.miss++;
        var str = (0, $3a6835e34f5ad41c$export$551117984c2adf4f)(bytes, inputOffset, byteLength);
        // Ensure to copy a slice of bytes because the byte may be NodeJS Buffer and Buffer#slice() returns a reference to its internal ArrayBuffer.
        var slicedCopyOfBytes = Uint8Array.prototype.slice.call(bytes, inputOffset, inputOffset + byteLength);
        this.store(slicedCopyOfBytes, str);
        return str;
    };
    return CachedKeyDecoder;
}();



var $dad63d07492d8492$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $dad63d07492d8492$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $dad63d07492d8492$var$__asyncValues = undefined && undefined.__asyncValues || function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $dad63d07492d8492$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $dad63d07492d8492$var$__await ? (this.v = v, this) : new $dad63d07492d8492$var$__await(v);
};
var $dad63d07492d8492$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $dad63d07492d8492$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $dad63d07492d8492$var$isValidMapKeyType = function(key) {
    var keyType = typeof key;
    return keyType === "string" || keyType === "number";
};
var $dad63d07492d8492$var$HEAD_BYTE_REQUIRED = -1;
var $dad63d07492d8492$var$EMPTY_VIEW = new DataView(new ArrayBuffer(0));
var $dad63d07492d8492$var$EMPTY_BYTES = new Uint8Array($dad63d07492d8492$var$EMPTY_VIEW.buffer);
var $dad63d07492d8492$export$449c37eaf7093493 = function() {
    try {
        // IE11: The spec says it should throw RangeError,
        // IE11: but in IE11 it throws TypeError.
        $dad63d07492d8492$var$EMPTY_VIEW.getInt8(0);
    } catch (e) {
        return e.constructor;
    }
    throw new Error("never reached");
}();
var $dad63d07492d8492$var$MORE_DATA = new $dad63d07492d8492$export$449c37eaf7093493("Insufficient data");
var $dad63d07492d8492$var$sharedCachedKeyDecoder = new (0, $0c6d84b6db4e80aa$export$529b830450faf29c)();
var $dad63d07492d8492$export$f9de6ca0bc043724 = /** @class */ function() {
    function Decoder(extensionCodec, context, maxStrLength, maxBinLength, maxArrayLength, maxMapLength, maxExtLength, keyDecoder) {
        if (extensionCodec === void 0) extensionCodec = (0, $8910db2cff065116$export$12677a794dbd89d7).defaultCodec;
        if (context === void 0) context = undefined;
        if (maxStrLength === void 0) maxStrLength = (0, $fba4db372ae69f54$export$3314b2c271c86d70);
        if (maxBinLength === void 0) maxBinLength = (0, $fba4db372ae69f54$export$3314b2c271c86d70);
        if (maxArrayLength === void 0) maxArrayLength = (0, $fba4db372ae69f54$export$3314b2c271c86d70);
        if (maxMapLength === void 0) maxMapLength = (0, $fba4db372ae69f54$export$3314b2c271c86d70);
        if (maxExtLength === void 0) maxExtLength = (0, $fba4db372ae69f54$export$3314b2c271c86d70);
        if (keyDecoder === void 0) keyDecoder = $dad63d07492d8492$var$sharedCachedKeyDecoder;
        this.extensionCodec = extensionCodec;
        this.context = context;
        this.maxStrLength = maxStrLength;
        this.maxBinLength = maxBinLength;
        this.maxArrayLength = maxArrayLength;
        this.maxMapLength = maxMapLength;
        this.maxExtLength = maxExtLength;
        this.keyDecoder = keyDecoder;
        this.totalPos = 0;
        this.pos = 0;
        this.view = $dad63d07492d8492$var$EMPTY_VIEW;
        this.bytes = $dad63d07492d8492$var$EMPTY_BYTES;
        this.headByte = $dad63d07492d8492$var$HEAD_BYTE_REQUIRED;
        this.stack = [];
    }
    Decoder.prototype.reinitializeState = function() {
        this.totalPos = 0;
        this.headByte = $dad63d07492d8492$var$HEAD_BYTE_REQUIRED;
        this.stack.length = 0;
    // view, bytes, and pos will be re-initialized in setBuffer()
    };
    Decoder.prototype.setBuffer = function(buffer) {
        this.bytes = (0, $1654631896d25994$export$f8d669c2a17882f2)(buffer);
        this.view = (0, $1654631896d25994$export$7277868462c1ba02)(this.bytes);
        this.pos = 0;
    };
    Decoder.prototype.appendBuffer = function(buffer) {
        if (this.headByte === $dad63d07492d8492$var$HEAD_BYTE_REQUIRED && !this.hasRemaining(1)) this.setBuffer(buffer);
        else {
            var remainingData = this.bytes.subarray(this.pos);
            var newData = (0, $1654631896d25994$export$f8d669c2a17882f2)(buffer);
            // concat remainingData + newData
            var newBuffer = new Uint8Array(remainingData.length + newData.length);
            newBuffer.set(remainingData);
            newBuffer.set(newData, remainingData.length);
            this.setBuffer(newBuffer);
        }
    };
    Decoder.prototype.hasRemaining = function(size) {
        return this.view.byteLength - this.pos >= size;
    };
    Decoder.prototype.createExtraByteError = function(posToShow) {
        var _a = this, view = _a.view, pos = _a.pos;
        return new RangeError("Extra ".concat(view.byteLength - pos, " of ").concat(view.byteLength, " byte(s) found at buffer[").concat(posToShow, "]"));
    };
    /**
     * @throws {@link DecodeError}
     * @throws {@link RangeError}
     */ Decoder.prototype.decode = function(buffer) {
        this.reinitializeState();
        this.setBuffer(buffer);
        var object = this.doDecodeSync();
        if (this.hasRemaining(1)) throw this.createExtraByteError(this.pos);
        return object;
    };
    Decoder.prototype.decodeMulti = function(buffer) {
        return $dad63d07492d8492$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    this.reinitializeState();
                    this.setBuffer(buffer);
                    _a.label = 1;
                case 1:
                    if (!this.hasRemaining(1)) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        this.doDecodeSync()
                    ];
                case 2:
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    Decoder.prototype.decodeAsync = function(stream) {
        var stream_1, stream_1_1;
        var e_1, _a;
        return $dad63d07492d8492$var$__awaiter(this, void 0, void 0, function() {
            var decoded, object, buffer, e_1_1, _b, headByte, pos, totalPos;
            return $dad63d07492d8492$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        decoded = false;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            6,
                            7,
                            12
                        ]);
                        stream_1 = $dad63d07492d8492$var$__asyncValues(stream);
                        _c.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            stream_1.next()
                        ];
                    case 3:
                        if (!(stream_1_1 = _c.sent(), !stream_1_1.done)) return [
                            3 /*break*/ ,
                            5
                        ];
                        buffer = stream_1_1.value;
                        if (decoded) throw this.createExtraByteError(this.totalPos);
                        this.appendBuffer(buffer);
                        try {
                            object = this.doDecodeSync();
                            decoded = true;
                        } catch (e) {
                            if (!(e instanceof $dad63d07492d8492$export$449c37eaf7093493)) throw e; // rethrow
                        // fallthrough
                        }
                        this.totalPos += this.pos;
                        _c.label = 4;
                    case 4:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 6:
                        e_1_1 = _c.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 7:
                        _c.trys.push([
                            7,
                            ,
                            10,
                            11
                        ]);
                        if (!(stream_1_1 && !stream_1_1.done && (_a = stream_1.return))) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(stream_1)
                        ];
                    case 8:
                        _c.sent();
                        _c.label = 9;
                    case 9:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        if (e_1) throw e_1.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 11:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 12:
                        if (decoded) {
                            if (this.hasRemaining(1)) throw this.createExtraByteError(this.totalPos);
                            return [
                                2 /*return*/ ,
                                object
                            ];
                        }
                        _b = this, headByte = _b.headByte, pos = _b.pos, totalPos = _b.totalPos;
                        throw new RangeError("Insufficient data in parsing ".concat((0, $d2b946db4d58d993$export$78406e843f5312da)(headByte), " at ").concat(totalPos, " (").concat(pos, " in the current buffer)"));
                }
            });
        });
    };
    Decoder.prototype.decodeArrayStream = function(stream) {
        return this.decodeMultiAsync(stream, true);
    };
    Decoder.prototype.decodeStream = function(stream) {
        return this.decodeMultiAsync(stream, false);
    };
    Decoder.prototype.decodeMultiAsync = function(stream, isArray) {
        return $dad63d07492d8492$var$__asyncGenerator(this, arguments, function decodeMultiAsync_1() {
            var isArrayHeaderRequired, arrayItemsLeft, stream_2, stream_2_1, buffer, e_2, e_3_1;
            var e_3, _a;
            return $dad63d07492d8492$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        isArrayHeaderRequired = isArray;
                        arrayItemsLeft = -1;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            13,
                            14,
                            19
                        ]);
                        stream_2 = $dad63d07492d8492$var$__asyncValues(stream);
                        _b.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            $dad63d07492d8492$var$__await(stream_2.next())
                        ];
                    case 3:
                        if (!(stream_2_1 = _b.sent(), !stream_2_1.done)) return [
                            3 /*break*/ ,
                            12
                        ];
                        buffer = stream_2_1.value;
                        if (isArray && arrayItemsLeft === 0) throw this.createExtraByteError(this.totalPos);
                        this.appendBuffer(buffer);
                        if (isArrayHeaderRequired) {
                            arrayItemsLeft = this.readArraySize();
                            isArrayHeaderRequired = false;
                            this.complete();
                        }
                        _b.label = 4;
                    case 4:
                        _b.trys.push([
                            4,
                            9,
                            ,
                            10
                        ]);
                        _b.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            $dad63d07492d8492$var$__await(this.doDecodeSync())
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 7:
                        _b.sent();
                        if (--arrayItemsLeft === 0) return [
                            3 /*break*/ ,
                            8
                        ];
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        e_2 = _b.sent();
                        if (!(e_2 instanceof $dad63d07492d8492$export$449c37eaf7093493)) throw e_2; // rethrow
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 10:
                        this.totalPos += this.pos;
                        _b.label = 11;
                    case 11:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 12:
                        return [
                            3 /*break*/ ,
                            19
                        ];
                    case 13:
                        e_3_1 = _b.sent();
                        e_3 = {
                            error: e_3_1
                        };
                        return [
                            3 /*break*/ ,
                            19
                        ];
                    case 14:
                        _b.trys.push([
                            14,
                            ,
                            17,
                            18
                        ]);
                        if (!(stream_2_1 && !stream_2_1.done && (_a = stream_2.return))) return [
                            3 /*break*/ ,
                            16
                        ];
                        return [
                            4 /*yield*/ ,
                            $dad63d07492d8492$var$__await(_a.call(stream_2))
                        ];
                    case 15:
                        _b.sent();
                        _b.label = 16;
                    case 16:
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 17:
                        if (e_3) throw e_3.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 18:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 19:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Decoder.prototype.doDecodeSync = function() {
        DECODE: while(true){
            var headByte = this.readHeadByte();
            var object = void 0;
            if (headByte >= 0xe0) // negative fixint (111x xxxx) 0xe0 - 0xff
            object = headByte - 0x100;
            else if (headByte < 0xc0) {
                if (headByte < 0x80) // positive fixint (0xxx xxxx) 0x00 - 0x7f
                object = headByte;
                else if (headByte < 0x90) {
                    // fixmap (1000 xxxx) 0x80 - 0x8f
                    var size = headByte - 0x80;
                    if (size !== 0) {
                        this.pushMapState(size);
                        this.complete();
                        continue DECODE;
                    } else object = {};
                } else if (headByte < 0xa0) {
                    // fixarray (1001 xxxx) 0x90 - 0x9f
                    var size = headByte - 0x90;
                    if (size !== 0) {
                        this.pushArrayState(size);
                        this.complete();
                        continue DECODE;
                    } else object = [];
                } else {
                    // fixstr (101x xxxx) 0xa0 - 0xbf
                    var byteLength = headByte - 0xa0;
                    object = this.decodeUtf8String(byteLength, 0);
                }
            } else if (headByte === 0xc0) // nil
            object = null;
            else if (headByte === 0xc2) // false
            object = false;
            else if (headByte === 0xc3) // true
            object = true;
            else if (headByte === 0xca) // float 32
            object = this.readF32();
            else if (headByte === 0xcb) // float 64
            object = this.readF64();
            else if (headByte === 0xcc) // uint 8
            object = this.readU8();
            else if (headByte === 0xcd) // uint 16
            object = this.readU16();
            else if (headByte === 0xce) // uint 32
            object = this.readU32();
            else if (headByte === 0xcf) // uint 64
            object = this.readU64();
            else if (headByte === 0xd0) // int 8
            object = this.readI8();
            else if (headByte === 0xd1) // int 16
            object = this.readI16();
            else if (headByte === 0xd2) // int 32
            object = this.readI32();
            else if (headByte === 0xd3) // int 64
            object = this.readI64();
            else if (headByte === 0xd9) {
                // str 8
                var byteLength = this.lookU8();
                object = this.decodeUtf8String(byteLength, 1);
            } else if (headByte === 0xda) {
                // str 16
                var byteLength = this.lookU16();
                object = this.decodeUtf8String(byteLength, 2);
            } else if (headByte === 0xdb) {
                // str 32
                var byteLength = this.lookU32();
                object = this.decodeUtf8String(byteLength, 4);
            } else if (headByte === 0xdc) {
                // array 16
                var size = this.readU16();
                if (size !== 0) {
                    this.pushArrayState(size);
                    this.complete();
                    continue DECODE;
                } else object = [];
            } else if (headByte === 0xdd) {
                // array 32
                var size = this.readU32();
                if (size !== 0) {
                    this.pushArrayState(size);
                    this.complete();
                    continue DECODE;
                } else object = [];
            } else if (headByte === 0xde) {
                // map 16
                var size = this.readU16();
                if (size !== 0) {
                    this.pushMapState(size);
                    this.complete();
                    continue DECODE;
                } else object = {};
            } else if (headByte === 0xdf) {
                // map 32
                var size = this.readU32();
                if (size !== 0) {
                    this.pushMapState(size);
                    this.complete();
                    continue DECODE;
                } else object = {};
            } else if (headByte === 0xc4) {
                // bin 8
                var size = this.lookU8();
                object = this.decodeBinary(size, 1);
            } else if (headByte === 0xc5) {
                // bin 16
                var size = this.lookU16();
                object = this.decodeBinary(size, 2);
            } else if (headByte === 0xc6) {
                // bin 32
                var size = this.lookU32();
                object = this.decodeBinary(size, 4);
            } else if (headByte === 0xd4) // fixext 1
            object = this.decodeExtension(1, 0);
            else if (headByte === 0xd5) // fixext 2
            object = this.decodeExtension(2, 0);
            else if (headByte === 0xd6) // fixext 4
            object = this.decodeExtension(4, 0);
            else if (headByte === 0xd7) // fixext 8
            object = this.decodeExtension(8, 0);
            else if (headByte === 0xd8) // fixext 16
            object = this.decodeExtension(16, 0);
            else if (headByte === 0xc7) {
                // ext 8
                var size = this.lookU8();
                object = this.decodeExtension(size, 1);
            } else if (headByte === 0xc8) {
                // ext 16
                var size = this.lookU16();
                object = this.decodeExtension(size, 2);
            } else if (headByte === 0xc9) {
                // ext 32
                var size = this.lookU32();
                object = this.decodeExtension(size, 4);
            } else throw new (0, $efa0a4d232d38314$export$ef3eed12d06c0285)("Unrecognized type byte: ".concat((0, $d2b946db4d58d993$export$78406e843f5312da)(headByte)));
            this.complete();
            var stack = this.stack;
            while(stack.length > 0){
                // arrays and maps
                var state = stack[stack.length - 1];
                if (state.type === 0 /* State.ARRAY */ ) {
                    state.array[state.position] = object;
                    state.position++;
                    if (state.position === state.size) {
                        stack.pop();
                        object = state.array;
                    } else continue DECODE;
                } else if (state.type === 1 /* State.MAP_KEY */ ) {
                    if (!$dad63d07492d8492$var$isValidMapKeyType(object)) throw new (0, $efa0a4d232d38314$export$ef3eed12d06c0285)("The type of key must be string or number but " + typeof object);
                    if (object === "__proto__") throw new (0, $efa0a4d232d38314$export$ef3eed12d06c0285)("The key __proto__ is not allowed");
                    state.key = object;
                    state.type = 2 /* State.MAP_VALUE */ ;
                    continue DECODE;
                } else {
                    // it must be `state.type === State.MAP_VALUE` here
                    state.map[state.key] = object;
                    state.readCount++;
                    if (state.readCount === state.size) {
                        stack.pop();
                        object = state.map;
                    } else {
                        state.key = null;
                        state.type = 1 /* State.MAP_KEY */ ;
                        continue DECODE;
                    }
                }
            }
            return object;
        }
    };
    Decoder.prototype.readHeadByte = function() {
        if (this.headByte === $dad63d07492d8492$var$HEAD_BYTE_REQUIRED) this.headByte = this.readU8();
        return this.headByte;
    };
    Decoder.prototype.complete = function() {
        this.headByte = $dad63d07492d8492$var$HEAD_BYTE_REQUIRED;
    };
    Decoder.prototype.readArraySize = function() {
        var headByte = this.readHeadByte();
        switch(headByte){
            case 0xdc:
                return this.readU16();
            case 0xdd:
                return this.readU32();
            default:
                if (headByte < 0xa0) return headByte - 0x90;
                else throw new (0, $efa0a4d232d38314$export$ef3eed12d06c0285)("Unrecognized array type byte: ".concat((0, $d2b946db4d58d993$export$78406e843f5312da)(headByte)));
        }
    };
    Decoder.prototype.pushMapState = function(size) {
        if (size > this.maxMapLength) throw new (0, $efa0a4d232d38314$export$ef3eed12d06c0285)("Max length exceeded: map length (".concat(size, ") > maxMapLengthLength (").concat(this.maxMapLength, ")"));
        this.stack.push({
            type: 1 /* State.MAP_KEY */ ,
            size: size,
            key: null,
            readCount: 0,
            map: {}
        });
    };
    Decoder.prototype.pushArrayState = function(size) {
        if (size > this.maxArrayLength) throw new (0, $efa0a4d232d38314$export$ef3eed12d06c0285)("Max length exceeded: array length (".concat(size, ") > maxArrayLength (").concat(this.maxArrayLength, ")"));
        this.stack.push({
            type: 0 /* State.ARRAY */ ,
            size: size,
            array: new Array(size),
            position: 0
        });
    };
    Decoder.prototype.decodeUtf8String = function(byteLength, headerOffset) {
        var _a;
        if (byteLength > this.maxStrLength) throw new (0, $efa0a4d232d38314$export$ef3eed12d06c0285)("Max length exceeded: UTF-8 byte length (".concat(byteLength, ") > maxStrLength (").concat(this.maxStrLength, ")"));
        if (this.bytes.byteLength < this.pos + headerOffset + byteLength) throw $dad63d07492d8492$var$MORE_DATA;
        var offset = this.pos + headerOffset;
        var object;
        if (this.stateIsMapKey() && ((_a = this.keyDecoder) === null || _a === void 0 ? void 0 : _a.canBeCached(byteLength))) object = this.keyDecoder.decode(this.bytes, offset, byteLength);
        else if (byteLength > (0, $3a6835e34f5ad41c$export$d866281c5a66d1ef)) object = (0, $3a6835e34f5ad41c$export$6ed79e41309992dc)(this.bytes, offset, byteLength);
        else object = (0, $3a6835e34f5ad41c$export$551117984c2adf4f)(this.bytes, offset, byteLength);
        this.pos += headerOffset + byteLength;
        return object;
    };
    Decoder.prototype.stateIsMapKey = function() {
        if (this.stack.length > 0) {
            var state = this.stack[this.stack.length - 1];
            return state.type === 1 /* State.MAP_KEY */ ;
        }
        return false;
    };
    Decoder.prototype.decodeBinary = function(byteLength, headOffset) {
        if (byteLength > this.maxBinLength) throw new (0, $efa0a4d232d38314$export$ef3eed12d06c0285)("Max length exceeded: bin length (".concat(byteLength, ") > maxBinLength (").concat(this.maxBinLength, ")"));
        if (!this.hasRemaining(byteLength + headOffset)) throw $dad63d07492d8492$var$MORE_DATA;
        var offset = this.pos + headOffset;
        var object = this.bytes.subarray(offset, offset + byteLength);
        this.pos += headOffset + byteLength;
        return object;
    };
    Decoder.prototype.decodeExtension = function(size, headOffset) {
        if (size > this.maxExtLength) throw new (0, $efa0a4d232d38314$export$ef3eed12d06c0285)("Max length exceeded: ext length (".concat(size, ") > maxExtLength (").concat(this.maxExtLength, ")"));
        var extType = this.view.getInt8(this.pos + headOffset);
        var data = this.decodeBinary(size, headOffset + 1 /* extType */ );
        return this.extensionCodec.decode(data, extType, this.context);
    };
    Decoder.prototype.lookU8 = function() {
        return this.view.getUint8(this.pos);
    };
    Decoder.prototype.lookU16 = function() {
        return this.view.getUint16(this.pos);
    };
    Decoder.prototype.lookU32 = function() {
        return this.view.getUint32(this.pos);
    };
    Decoder.prototype.readU8 = function() {
        var value = this.view.getUint8(this.pos);
        this.pos++;
        return value;
    };
    Decoder.prototype.readI8 = function() {
        var value = this.view.getInt8(this.pos);
        this.pos++;
        return value;
    };
    Decoder.prototype.readU16 = function() {
        var value = this.view.getUint16(this.pos);
        this.pos += 2;
        return value;
    };
    Decoder.prototype.readI16 = function() {
        var value = this.view.getInt16(this.pos);
        this.pos += 2;
        return value;
    };
    Decoder.prototype.readU32 = function() {
        var value = this.view.getUint32(this.pos);
        this.pos += 4;
        return value;
    };
    Decoder.prototype.readI32 = function() {
        var value = this.view.getInt32(this.pos);
        this.pos += 4;
        return value;
    };
    Decoder.prototype.readU64 = function() {
        var value = (0, $fba4db372ae69f54$export$59a2dbf579ff9568)(this.view, this.pos);
        this.pos += 8;
        return value;
    };
    Decoder.prototype.readI64 = function() {
        var value = (0, $fba4db372ae69f54$export$69825c7adcc820c6)(this.view, this.pos);
        this.pos += 8;
        return value;
    };
    Decoder.prototype.readF32 = function() {
        var value = this.view.getFloat32(this.pos);
        this.pos += 4;
        return value;
    };
    Decoder.prototype.readF64 = function() {
        var value = this.view.getFloat64(this.pos);
        this.pos += 8;
        return value;
    };
    return Decoder;
}();


// utility for whatwg streams
var $c2208fd8eecae6ec$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $c2208fd8eecae6ec$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $c2208fd8eecae6ec$var$__await ? (this.v = v, this) : new $c2208fd8eecae6ec$var$__await(v);
};
var $c2208fd8eecae6ec$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c2208fd8eecae6ec$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $c2208fd8eecae6ec$export$edb10ab8dd75a915(object) {
    return object[Symbol.asyncIterator] != null;
}
function $c2208fd8eecae6ec$var$assertNonNull(value) {
    if (value == null) throw new Error("Assertion Failure: value must not be null nor undefined");
}
function $c2208fd8eecae6ec$export$f62cf0e66867a58e(stream) {
    return $c2208fd8eecae6ec$var$__asyncGenerator(this, arguments, function asyncIterableFromStream_1() {
        var reader, _a, done, value;
        return $c2208fd8eecae6ec$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = stream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4 /*yield*/ ,
                        $c2208fd8eecae6ec$var$__await(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (!done) return [
                        3 /*break*/ ,
                        5
                    ];
                    return [
                        4 /*yield*/ ,
                        $c2208fd8eecae6ec$var$__await(void 0)
                    ];
                case 4:
                    return [
                        2 /*return*/ ,
                        _b.sent()
                    ];
                case 5:
                    $c2208fd8eecae6ec$var$assertNonNull(value);
                    return [
                        4 /*yield*/ ,
                        $c2208fd8eecae6ec$var$__await(value)
                    ];
                case 6:
                    return [
                        4 /*yield*/ ,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 8:
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 10:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $c2208fd8eecae6ec$export$bf99ef56e8bd104(streamLike) {
    if ($c2208fd8eecae6ec$export$edb10ab8dd75a915(streamLike)) return streamLike;
    else return $c2208fd8eecae6ec$export$f62cf0e66867a58e(streamLike);
}



var $039f599b710b3602$export$ca6ec972f712a9eb = {};
function $039f599b710b3602$export$2f872c0f2117be69(buffer, options) {
    if (options === void 0) options = $039f599b710b3602$export$ca6ec972f712a9eb;
    var decoder = new (0, $dad63d07492d8492$export$f9de6ca0bc043724)(options.extensionCodec, options.context, options.maxStrLength, options.maxBinLength, options.maxArrayLength, options.maxMapLength, options.maxExtLength);
    return decoder.decode(buffer);
}
function $039f599b710b3602$export$43cc91859d9fdc54(buffer, options) {
    if (options === void 0) options = $039f599b710b3602$export$ca6ec972f712a9eb;
    var decoder = new (0, $dad63d07492d8492$export$f9de6ca0bc043724)(options.extensionCodec, options.context, options.maxStrLength, options.maxBinLength, options.maxArrayLength, options.maxMapLength, options.maxExtLength);
    return decoder.decodeMulti(buffer);
}


var $95417b30ac7b0011$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $95417b30ac7b0011$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function $95417b30ac7b0011$export$e4c183687a6ff9b(streamLike, options) {
    if (options === void 0) options = (0, $039f599b710b3602$export$ca6ec972f712a9eb);
    return $95417b30ac7b0011$var$__awaiter(this, void 0, void 0, function() {
        var stream, decoder;
        return $95417b30ac7b0011$var$__generator(this, function(_a) {
            stream = (0, $c2208fd8eecae6ec$export$bf99ef56e8bd104)(streamLike);
            decoder = new (0, $dad63d07492d8492$export$f9de6ca0bc043724)(options.extensionCodec, options.context, options.maxStrLength, options.maxBinLength, options.maxArrayLength, options.maxMapLength, options.maxExtLength);
            return [
                2 /*return*/ ,
                decoder.decodeAsync(stream)
            ];
        });
    });
}
function $95417b30ac7b0011$export$b1b94ac44d9853a4(streamLike, options) {
    if (options === void 0) options = (0, $039f599b710b3602$export$ca6ec972f712a9eb);
    var stream = (0, $c2208fd8eecae6ec$export$bf99ef56e8bd104)(streamLike);
    var decoder = new (0, $dad63d07492d8492$export$f9de6ca0bc043724)(options.extensionCodec, options.context, options.maxStrLength, options.maxBinLength, options.maxArrayLength, options.maxMapLength, options.maxExtLength);
    return decoder.decodeArrayStream(stream);
}
function $95417b30ac7b0011$export$bf87d8a088c760fb(streamLike, options) {
    if (options === void 0) options = (0, $039f599b710b3602$export$ca6ec972f712a9eb);
    var stream = (0, $c2208fd8eecae6ec$export$bf99ef56e8bd104)(streamLike);
    var decoder = new (0, $dad63d07492d8492$export$f9de6ca0bc043724)(options.extensionCodec, options.context, options.maxStrLength, options.maxBinLength, options.maxArrayLength, options.maxMapLength, options.maxExtLength);
    return decoder.decodeStream(stream);
}
function $95417b30ac7b0011$export$7fb0f205e4fd0bbe(streamLike, options) {
    if (options === void 0) options = (0, $039f599b710b3602$export$ca6ec972f712a9eb);
    return $95417b30ac7b0011$export$bf87d8a088c760fb(streamLike, options);
}





var $1076902c8ed47882$export$2c6de1218fe0e46d = 100;
var $1076902c8ed47882$export$29659805a45f979c = 2048;
var $1076902c8ed47882$export$a50aceb0e02a00aa = /** @class */ function() {
    function Encoder(extensionCodec, context, maxDepth, initialBufferSize, sortKeys, forceFloat32, ignoreUndefined, forceIntegerToFloat) {
        if (extensionCodec === void 0) extensionCodec = (0, $8910db2cff065116$export$12677a794dbd89d7).defaultCodec;
        if (context === void 0) context = undefined;
        if (maxDepth === void 0) maxDepth = $1076902c8ed47882$export$2c6de1218fe0e46d;
        if (initialBufferSize === void 0) initialBufferSize = $1076902c8ed47882$export$29659805a45f979c;
        if (sortKeys === void 0) sortKeys = false;
        if (forceFloat32 === void 0) forceFloat32 = false;
        if (ignoreUndefined === void 0) ignoreUndefined = false;
        if (forceIntegerToFloat === void 0) forceIntegerToFloat = false;
        this.extensionCodec = extensionCodec;
        this.context = context;
        this.maxDepth = maxDepth;
        this.initialBufferSize = initialBufferSize;
        this.sortKeys = sortKeys;
        this.forceFloat32 = forceFloat32;
        this.ignoreUndefined = ignoreUndefined;
        this.forceIntegerToFloat = forceIntegerToFloat;
        this.pos = 0;
        this.view = new DataView(new ArrayBuffer(this.initialBufferSize));
        this.bytes = new Uint8Array(this.view.buffer);
    }
    Encoder.prototype.reinitializeState = function() {
        this.pos = 0;
    };
    /**
     * This is almost equivalent to {@link Encoder#encode}, but it returns an reference of the encoder's internal buffer and thus much faster than {@link Encoder#encode}.
     *
     * @returns Encodes the object and returns a shared reference the encoder's internal buffer.
     */ Encoder.prototype.encodeSharedRef = function(object) {
        this.reinitializeState();
        this.doEncode(object, 1);
        return this.bytes.subarray(0, this.pos);
    };
    /**
     * @returns Encodes the object and returns a copy of the encoder's internal buffer.
     */ Encoder.prototype.encode = function(object) {
        this.reinitializeState();
        this.doEncode(object, 1);
        return this.bytes.slice(0, this.pos);
    };
    Encoder.prototype.doEncode = function(object, depth) {
        if (depth > this.maxDepth) throw new Error("Too deep objects in depth ".concat(depth));
        if (object == null) this.encodeNil();
        else if (typeof object === "boolean") this.encodeBoolean(object);
        else if (typeof object === "number") this.encodeNumber(object);
        else if (typeof object === "string") this.encodeString(object);
        else this.encodeObject(object, depth);
    };
    Encoder.prototype.ensureBufferSizeToWrite = function(sizeToWrite) {
        var requiredSize = this.pos + sizeToWrite;
        if (this.view.byteLength < requiredSize) this.resizeBuffer(requiredSize * 2);
    };
    Encoder.prototype.resizeBuffer = function(newSize) {
        var newBuffer = new ArrayBuffer(newSize);
        var newBytes = new Uint8Array(newBuffer);
        var newView = new DataView(newBuffer);
        newBytes.set(this.bytes);
        this.view = newView;
        this.bytes = newBytes;
    };
    Encoder.prototype.encodeNil = function() {
        this.writeU8(0xc0);
    };
    Encoder.prototype.encodeBoolean = function(object) {
        if (object === false) this.writeU8(0xc2);
        else this.writeU8(0xc3);
    };
    Encoder.prototype.encodeNumber = function(object) {
        if (Number.isSafeInteger(object) && !this.forceIntegerToFloat) {
            if (object >= 0) {
                if (object < 0x80) // positive fixint
                this.writeU8(object);
                else if (object < 0x100) {
                    // uint 8
                    this.writeU8(0xcc);
                    this.writeU8(object);
                } else if (object < 0x10000) {
                    // uint 16
                    this.writeU8(0xcd);
                    this.writeU16(object);
                } else if (object < 0x100000000) {
                    // uint 32
                    this.writeU8(0xce);
                    this.writeU32(object);
                } else {
                    // uint 64
                    this.writeU8(0xcf);
                    this.writeU64(object);
                }
            } else {
                if (object >= -32) // negative fixint
                this.writeU8(0xe0 | object + 0x20);
                else if (object >= -128) {
                    // int 8
                    this.writeU8(0xd0);
                    this.writeI8(object);
                } else if (object >= -32768) {
                    // int 16
                    this.writeU8(0xd1);
                    this.writeI16(object);
                } else if (object >= -2147483648) {
                    // int 32
                    this.writeU8(0xd2);
                    this.writeI32(object);
                } else {
                    // int 64
                    this.writeU8(0xd3);
                    this.writeI64(object);
                }
            }
        } else // non-integer numbers
        if (this.forceFloat32) {
            // float 32
            this.writeU8(0xca);
            this.writeF32(object);
        } else {
            // float 64
            this.writeU8(0xcb);
            this.writeF64(object);
        }
    };
    Encoder.prototype.writeStringHeader = function(byteLength) {
        if (byteLength < 32) // fixstr
        this.writeU8(0xa0 + byteLength);
        else if (byteLength < 0x100) {
            // str 8
            this.writeU8(0xd9);
            this.writeU8(byteLength);
        } else if (byteLength < 0x10000) {
            // str 16
            this.writeU8(0xda);
            this.writeU16(byteLength);
        } else if (byteLength < 0x100000000) {
            // str 32
            this.writeU8(0xdb);
            this.writeU32(byteLength);
        } else throw new Error("Too long string: ".concat(byteLength, " bytes in UTF-8"));
    };
    Encoder.prototype.encodeString = function(object) {
        var maxHeaderSize = 5;
        var strLength = object.length;
        if (strLength > (0, $3a6835e34f5ad41c$export$ed34c0622b397238)) {
            var byteLength = (0, $3a6835e34f5ad41c$export$b61de95301265227)(object);
            this.ensureBufferSizeToWrite(maxHeaderSize + byteLength);
            this.writeStringHeader(byteLength);
            (0, $3a6835e34f5ad41c$export$34cfdc82d430524)(object, this.bytes, this.pos);
            this.pos += byteLength;
        } else {
            var byteLength = (0, $3a6835e34f5ad41c$export$b61de95301265227)(object);
            this.ensureBufferSizeToWrite(maxHeaderSize + byteLength);
            this.writeStringHeader(byteLength);
            (0, $3a6835e34f5ad41c$export$1042e4338f1ef853)(object, this.bytes, this.pos);
            this.pos += byteLength;
        }
    };
    Encoder.prototype.encodeObject = function(object, depth) {
        // try to encode objects with custom codec first of non-primitives
        var ext = this.extensionCodec.tryToEncode(object, this.context);
        if (ext != null) this.encodeExtension(ext);
        else if (Array.isArray(object)) this.encodeArray(object, depth);
        else if (ArrayBuffer.isView(object)) this.encodeBinary(object);
        else if (typeof object === "object") this.encodeMap(object, depth);
        else // symbol, function and other special object come here unless extensionCodec handles them.
        throw new Error("Unrecognized object: ".concat(Object.prototype.toString.apply(object)));
    };
    Encoder.prototype.encodeBinary = function(object) {
        var size = object.byteLength;
        if (size < 0x100) {
            // bin 8
            this.writeU8(0xc4);
            this.writeU8(size);
        } else if (size < 0x10000) {
            // bin 16
            this.writeU8(0xc5);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // bin 32
            this.writeU8(0xc6);
            this.writeU32(size);
        } else throw new Error("Too large binary: ".concat(size));
        var bytes = (0, $1654631896d25994$export$f8d669c2a17882f2)(object);
        this.writeU8a(bytes);
    };
    Encoder.prototype.encodeArray = function(object, depth) {
        var size = object.length;
        if (size < 16) // fixarray
        this.writeU8(0x90 + size);
        else if (size < 0x10000) {
            // array 16
            this.writeU8(0xdc);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // array 32
            this.writeU8(0xdd);
            this.writeU32(size);
        } else throw new Error("Too large array: ".concat(size));
        for(var _i = 0, object_1 = object; _i < object_1.length; _i++){
            var item = object_1[_i];
            this.doEncode(item, depth + 1);
        }
    };
    Encoder.prototype.countWithoutUndefined = function(object, keys) {
        var count = 0;
        for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
            var key = keys_1[_i];
            if (object[key] !== undefined) count++;
        }
        return count;
    };
    Encoder.prototype.encodeMap = function(object, depth) {
        var keys = Object.keys(object);
        if (this.sortKeys) keys.sort();
        var size = this.ignoreUndefined ? this.countWithoutUndefined(object, keys) : keys.length;
        if (size < 16) // fixmap
        this.writeU8(0x80 + size);
        else if (size < 0x10000) {
            // map 16
            this.writeU8(0xde);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // map 32
            this.writeU8(0xdf);
            this.writeU32(size);
        } else throw new Error("Too large map object: ".concat(size));
        for(var _i = 0, keys_2 = keys; _i < keys_2.length; _i++){
            var key = keys_2[_i];
            var value = object[key];
            if (!(this.ignoreUndefined && value === undefined)) {
                this.encodeString(key);
                this.doEncode(value, depth + 1);
            }
        }
    };
    Encoder.prototype.encodeExtension = function(ext) {
        var size = ext.data.length;
        if (size === 1) // fixext 1
        this.writeU8(0xd4);
        else if (size === 2) // fixext 2
        this.writeU8(0xd5);
        else if (size === 4) // fixext 4
        this.writeU8(0xd6);
        else if (size === 8) // fixext 8
        this.writeU8(0xd7);
        else if (size === 16) // fixext 16
        this.writeU8(0xd8);
        else if (size < 0x100) {
            // ext 8
            this.writeU8(0xc7);
            this.writeU8(size);
        } else if (size < 0x10000) {
            // ext 16
            this.writeU8(0xc8);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // ext 32
            this.writeU8(0xc9);
            this.writeU32(size);
        } else throw new Error("Too large extension object: ".concat(size));
        this.writeI8(ext.type);
        this.writeU8a(ext.data);
    };
    Encoder.prototype.writeU8 = function(value) {
        this.ensureBufferSizeToWrite(1);
        this.view.setUint8(this.pos, value);
        this.pos++;
    };
    Encoder.prototype.writeU8a = function(values) {
        var size = values.length;
        this.ensureBufferSizeToWrite(size);
        this.bytes.set(values, this.pos);
        this.pos += size;
    };
    Encoder.prototype.writeI8 = function(value) {
        this.ensureBufferSizeToWrite(1);
        this.view.setInt8(this.pos, value);
        this.pos++;
    };
    Encoder.prototype.writeU16 = function(value) {
        this.ensureBufferSizeToWrite(2);
        this.view.setUint16(this.pos, value);
        this.pos += 2;
    };
    Encoder.prototype.writeI16 = function(value) {
        this.ensureBufferSizeToWrite(2);
        this.view.setInt16(this.pos, value);
        this.pos += 2;
    };
    Encoder.prototype.writeU32 = function(value) {
        this.ensureBufferSizeToWrite(4);
        this.view.setUint32(this.pos, value);
        this.pos += 4;
    };
    Encoder.prototype.writeI32 = function(value) {
        this.ensureBufferSizeToWrite(4);
        this.view.setInt32(this.pos, value);
        this.pos += 4;
    };
    Encoder.prototype.writeF32 = function(value) {
        this.ensureBufferSizeToWrite(4);
        this.view.setFloat32(this.pos, value);
        this.pos += 4;
    };
    Encoder.prototype.writeF64 = function(value) {
        this.ensureBufferSizeToWrite(8);
        this.view.setFloat64(this.pos, value);
        this.pos += 8;
    };
    Encoder.prototype.writeU64 = function(value) {
        this.ensureBufferSizeToWrite(8);
        (0, $fba4db372ae69f54$export$20f71c4c8b0f96c3)(this.view, this.pos, value);
        this.pos += 8;
    };
    Encoder.prototype.writeI64 = function(value) {
        this.ensureBufferSizeToWrite(8);
        (0, $fba4db372ae69f54$export$8532a5209571c04a)(this.view, this.pos, value);
        this.pos += 8;
    };
    return Encoder;
}();


function $43f09feeac71c3ff$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
class $43f09feeac71c3ff$var$$fcbcc7538a6776d5$export$f1c5f4c9cb95390b {
    constructor(){
        this.chunkedMTU = 16300 // The original 60000 bytes setting does not work when sending data from Firefox to Chrome, which is "cut off" after 16384 bytes and delivered individually.
        ;
        // Binary stuff
        this._dataCount = 1;
        this.chunk = (blob)=>{
            const chunks = [];
            const size = blob.byteLength;
            const total = Math.ceil(size / this.chunkedMTU);
            let index = 0;
            let start = 0;
            while(start < size){
                const end = Math.min(size, start + this.chunkedMTU);
                const b = blob.slice(start, end);
                const chunk = {
                    __peerData: this._dataCount,
                    n: index,
                    data: b,
                    total: total
                };
                chunks.push(chunk);
                start = end;
                index++;
            }
            this._dataCount++;
            return chunks;
        };
    }
}
function $43f09feeac71c3ff$var$$fcbcc7538a6776d5$export$52c89ebcdc4f53f2(bufs) {
    let size = 0;
    for (const buf of bufs)size += buf.byteLength;
    const result = new Uint8Array(size);
    let offset = 0;
    for (const buf of bufs){
        result.set(buf, offset);
        offset += buf.byteLength;
    }
    return result;
}
const $43f09feeac71c3ff$var$$fb63e766cfafaab9$var$webRTCAdapter = (0, $0c297cbc3d949fec$export$2e2bcd8739ae039).default || (0, $0c297cbc3d949fec$export$2e2bcd8739ae039);
const $43f09feeac71c3ff$var$$fb63e766cfafaab9$export$25be9502477c137d = new class {
    isWebRTCSupported() {
        return typeof RTCPeerConnection !== "undefined";
    }
    isBrowserSupported() {
        const browser = this.getBrowser();
        const version = this.getVersion();
        const validBrowser = this.supportedBrowsers.includes(browser);
        if (!validBrowser) return false;
        if (browser === "chrome") return version >= this.minChromeVersion;
        if (browser === "firefox") return version >= this.minFirefoxVersion;
        if (browser === "safari") return !this.isIOS && version >= this.minSafariVersion;
        return false;
    }
    getBrowser() {
        return $43f09feeac71c3ff$var$$fb63e766cfafaab9$var$webRTCAdapter.browserDetails.browser;
    }
    getVersion() {
        return $43f09feeac71c3ff$var$$fb63e766cfafaab9$var$webRTCAdapter.browserDetails.version || 0;
    }
    isUnifiedPlanSupported() {
        const browser = this.getBrowser();
        const version = $43f09feeac71c3ff$var$$fb63e766cfafaab9$var$webRTCAdapter.browserDetails.version || 0;
        if (browser === "chrome" && version < this.minChromeVersion) return false;
        if (browser === "firefox" && version >= this.minFirefoxVersion) return true;
        if (!window.RTCRtpTransceiver || !("currentDirection" in RTCRtpTransceiver.prototype)) return false;
        let tempPc;
        let supported = false;
        try {
            tempPc = new RTCPeerConnection();
            tempPc.addTransceiver("audio");
            supported = true;
        } catch (e) {} finally{
            if (tempPc) tempPc.close();
        }
        return supported;
    }
    toString() {
        return `Supports:
    browser:${this.getBrowser()}
    version:${this.getVersion()}
    isIOS:${this.isIOS}
    isWebRTCSupported:${this.isWebRTCSupported()}
    isBrowserSupported:${this.isBrowserSupported()}
    isUnifiedPlanSupported:${this.isUnifiedPlanSupported()}`;
    }
    constructor(){
        this.isIOS = typeof navigator !== "undefined" ? [
            "iPad",
            "iPhone",
            "iPod"
        ].includes(navigator.platform) : false;
        this.supportedBrowsers = [
            "firefox",
            "chrome",
            "safari"
        ];
        this.minFirefoxVersion = 59;
        this.minChromeVersion = 72;
        this.minSafariVersion = 605;
    }
}();
const $43f09feeac71c3ff$var$$9a84a32bf0bf36bb$export$f35f128fd59ea256 = (id)=>{
    // Allow empty ids
    return !id || /^[A-Za-z0-9]+(?:[ _-][A-Za-z0-9]+)*$/.test(id);
};
const $43f09feeac71c3ff$var$$0e5fd1585784c252$export$4e61f672936bec77 = ()=>Math.random().toString(36).slice(2);
const $43f09feeac71c3ff$var$$4f4134156c446392$var$DEFAULT_CONFIG = {
    iceServers: [
        {
            urls: "stun:stun.l.google.com:19302"
        },
        {
            urls: [
                "turn:eu-0.turn.peerjs.com:3478",
                "turn:us-0.turn.peerjs.com:3478"
            ],
            username: "peerjs",
            credential: "peerjsp"
        }
    ],
    sdpSemantics: "unified-plan"
};
class $43f09feeac71c3ff$var$$4f4134156c446392$export$f8f26dd395d7e1bd extends $43f09feeac71c3ff$var$$fcbcc7538a6776d5$export$f1c5f4c9cb95390b {
    noop() {}
    blobToArrayBuffer(blob, cb) {
        const fr = new FileReader();
        fr.onload = function(evt) {
            if (evt.target) cb(evt.target.result);
        };
        fr.readAsArrayBuffer(blob);
        return fr;
    }
    binaryStringToArrayBuffer(binary) {
        const byteArray = new Uint8Array(binary.length);
        for(let i = 0; i < binary.length; i++)byteArray[i] = binary.charCodeAt(i) & 0xff;
        return byteArray.buffer;
    }
    isSecure() {
        return location.protocol === "https:";
    }
    constructor(...args){
        super(...args), this.CLOUD_HOST = "0.peerjs.com", this.CLOUD_PORT = 443, this.chunkedBrowsers = {
            Chrome: 1,
            chrome: 1
        }, this.defaultConfig = $43f09feeac71c3ff$var$$4f4134156c446392$var$DEFAULT_CONFIG, this.browser = $43f09feeac71c3ff$var$$fb63e766cfafaab9$export$25be9502477c137d.getBrowser(), this.browserVersion = $43f09feeac71c3ff$var$$fb63e766cfafaab9$export$25be9502477c137d.getVersion(), this.pack = (0, $5b93b93a09fbaeb8$export$2a703dbb0cb35339), this.unpack = (0, $5b93b93a09fbaeb8$export$417857010dc9287f), /**
	 * A hash of WebRTC features mapped to booleans that correspond to whether the feature is supported by the current browser.
	 *
	 * :::caution
	 * Only the properties documented here are guaranteed to be present on `util.supports`
	 * :::
	 */ this.supports = function() {
            const supported = {
                browser: $43f09feeac71c3ff$var$$fb63e766cfafaab9$export$25be9502477c137d.isBrowserSupported(),
                webRTC: $43f09feeac71c3ff$var$$fb63e766cfafaab9$export$25be9502477c137d.isWebRTCSupported(),
                audioVideo: false,
                data: false,
                binaryBlob: false,
                reliable: false
            };
            if (!supported.webRTC) return supported;
            let pc;
            try {
                pc = new RTCPeerConnection($43f09feeac71c3ff$var$$4f4134156c446392$var$DEFAULT_CONFIG);
                supported.audioVideo = true;
                let dc;
                try {
                    dc = pc.createDataChannel("_PEERJSTEST", {
                        ordered: true
                    });
                    supported.data = true;
                    supported.reliable = !!dc.ordered;
                    // Binary test
                    try {
                        dc.binaryType = "blob";
                        supported.binaryBlob = !$43f09feeac71c3ff$var$$fb63e766cfafaab9$export$25be9502477c137d.isIOS;
                    } catch (e) {}
                } catch (e) {} finally{
                    if (dc) dc.close();
                }
            } catch (e) {} finally{
                if (pc) pc.close();
            }
            return supported;
        }(), this.validateId = $43f09feeac71c3ff$var$$9a84a32bf0bf36bb$export$f35f128fd59ea256, this.randomToken = $43f09feeac71c3ff$var$$0e5fd1585784c252$export$4e61f672936bec77;
    }
}
const $43f09feeac71c3ff$export$7debb50ef11d5e0b = new $43f09feeac71c3ff$var$$4f4134156c446392$export$f8f26dd395d7e1bd();
const $43f09feeac71c3ff$var$$257947e92926277a$var$LOG_PREFIX = "PeerJS: ";
var $43f09feeac71c3ff$var$$257947e92926277a$export$243e62d78d3b544d = /*#__PURE__*/ function(LogLevel) {
    /**
	 * Prints no logs.
	 */ LogLevel[LogLevel["Disabled"] = 0] = "Disabled";
    /**
	 * Prints only errors.
	 */ LogLevel[LogLevel["Errors"] = 1] = "Errors";
    /**
	 * Prints errors and warnings.
	 */ LogLevel[LogLevel["Warnings"] = 2] = "Warnings";
    /**
	 * Prints all logs.
	 */ LogLevel[LogLevel["All"] = 3] = "All";
    return LogLevel;
}({});
class $43f09feeac71c3ff$var$$257947e92926277a$var$Logger {
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(logLevel) {
        this._logLevel = logLevel;
    }
    log(...args) {
        if (this._logLevel >= 3) this._print(3, ...args);
    }
    warn(...args) {
        if (this._logLevel >= 2) this._print(2, ...args);
    }
    error(...args) {
        if (this._logLevel >= 1) this._print(1, ...args);
    }
    setLogFunction(fn) {
        this._print = fn;
    }
    _print(logLevel, ...rest) {
        const copy = [
            $43f09feeac71c3ff$var$$257947e92926277a$var$LOG_PREFIX,
            ...rest
        ];
        for(const i in copy)if (copy[i] instanceof Error) copy[i] = "(" + copy[i].name + ") " + copy[i].message;
        if (logLevel >= 3) console.log(...copy);
        else if (logLevel >= 2) console.warn("WARNING", ...copy);
        else if (logLevel >= 1) console.error("ERROR", ...copy);
    }
    constructor(){
        this._logLevel = 0;
    }
}
var $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039 = new $43f09feeac71c3ff$var$$257947e92926277a$var$Logger();
var $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$exports = {};
'use strict';
var $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$has = Object.prototype.hasOwnProperty, $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$Events().__proto__) $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$EE(fn, context || emitter, once), evt = $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$prefix ? $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$EventEmitter() {
    this._events = new $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$has.call(events, name)) names.push($43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$prefix ? $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$prefix ? $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$prefix ? $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$prefix ? $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$prefix ? $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$prefix + event : event;
        if (this._events[evt]) $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$clearEvent(this, evt);
    } else {
        this._events = new $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.off = $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.removeListener;
$43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.addListener = $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$EventEmitter.prefixed = $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$EventEmitter.EventEmitter = $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$EventEmitter;
$43f09feeac71c3ff$var$$c4dcfd1d1ea86647$exports = $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$var$EventEmitter;
var $43f09feeac71c3ff$var$$78455e22dea96b8c$exports = {};
$43f09feeac71c3ff$var$$parcel$export($43f09feeac71c3ff$var$$78455e22dea96b8c$exports, "ConnectionType", ()=>$43f09feeac71c3ff$export$3157d57b4135e3bc);
$43f09feeac71c3ff$var$$parcel$export($43f09feeac71c3ff$var$$78455e22dea96b8c$exports, "PeerErrorType", ()=>$43f09feeac71c3ff$export$9547aaa2e39030ff);
$43f09feeac71c3ff$var$$parcel$export($43f09feeac71c3ff$var$$78455e22dea96b8c$exports, "BaseConnectionErrorType", ()=>$43f09feeac71c3ff$export$7974935686149686);
$43f09feeac71c3ff$var$$parcel$export($43f09feeac71c3ff$var$$78455e22dea96b8c$exports, "DataConnectionErrorType", ()=>$43f09feeac71c3ff$export$49ae800c114df41d);
$43f09feeac71c3ff$var$$parcel$export($43f09feeac71c3ff$var$$78455e22dea96b8c$exports, "SerializationType", ()=>$43f09feeac71c3ff$export$89f507cf986a947);
$43f09feeac71c3ff$var$$parcel$export($43f09feeac71c3ff$var$$78455e22dea96b8c$exports, "SocketEventType", ()=>$43f09feeac71c3ff$export$3b5c4a4b6354f023);
$43f09feeac71c3ff$var$$parcel$export($43f09feeac71c3ff$var$$78455e22dea96b8c$exports, "ServerMessageType", ()=>$43f09feeac71c3ff$export$adb4a1754da6f10d);
var $43f09feeac71c3ff$export$3157d57b4135e3bc = /*#__PURE__*/ function(ConnectionType) {
    ConnectionType["Data"] = "data";
    ConnectionType["Media"] = "media";
    return ConnectionType;
}({});
var $43f09feeac71c3ff$export$9547aaa2e39030ff = /*#__PURE__*/ function(PeerErrorType) {
    /**
	 * The client's browser does not support some or all WebRTC features that you are trying to use.
	 */ PeerErrorType["BrowserIncompatible"] = "browser-incompatible";
    /**
	 * You've already disconnected this peer from the server and can no longer make any new connections on it.
	 */ PeerErrorType["Disconnected"] = "disconnected";
    /**
	 * The ID passed into the Peer constructor contains illegal characters.
	 */ PeerErrorType["InvalidID"] = "invalid-id";
    /**
	 * The API key passed into the Peer constructor contains illegal characters or is not in the system (cloud server only).
	 */ PeerErrorType["InvalidKey"] = "invalid-key";
    /**
	 * Lost or cannot establish a connection to the signalling server.
	 */ PeerErrorType["Network"] = "network";
    /**
	 * The peer you're trying to connect to does not exist.
	 */ PeerErrorType["PeerUnavailable"] = "peer-unavailable";
    /**
	 * PeerJS is being used securely, but the cloud server does not support SSL. Use a custom PeerServer.
	 */ PeerErrorType["SslUnavailable"] = "ssl-unavailable";
    /**
	 * Unable to reach the server.
	 */ PeerErrorType["ServerError"] = "server-error";
    /**
	 * An error from the underlying socket.
	 */ PeerErrorType["SocketError"] = "socket-error";
    /**
	 * The underlying socket closed unexpectedly.
	 */ PeerErrorType["SocketClosed"] = "socket-closed";
    /**
	 * The ID passed into the Peer constructor is already taken.
	 *
	 * :::caution
	 * This error is not fatal if your peer has open peer-to-peer connections.
	 * This can happen if you attempt to {@apilink Peer.reconnect} a peer that has been disconnected from the server,
	 * but its old ID has now been taken.
	 * :::
	 */ PeerErrorType["UnavailableID"] = "unavailable-id";
    /**
	 * Native WebRTC errors.
	 */ PeerErrorType["WebRTC"] = "webrtc";
    return PeerErrorType;
}({});
var $43f09feeac71c3ff$export$7974935686149686 = /*#__PURE__*/ function(BaseConnectionErrorType) {
    BaseConnectionErrorType["NegotiationFailed"] = "negotiation-failed";
    BaseConnectionErrorType["ConnectionClosed"] = "connection-closed";
    return BaseConnectionErrorType;
}({});
var $43f09feeac71c3ff$export$49ae800c114df41d = /*#__PURE__*/ function(DataConnectionErrorType) {
    DataConnectionErrorType["NotOpenYet"] = "not-open-yet";
    DataConnectionErrorType["MessageToBig"] = "message-too-big";
    return DataConnectionErrorType;
}({});
var $43f09feeac71c3ff$export$89f507cf986a947 = /*#__PURE__*/ function(SerializationType) {
    SerializationType["Binary"] = "binary";
    SerializationType["BinaryUTF8"] = "binary-utf8";
    SerializationType["JSON"] = "json";
    SerializationType["None"] = "raw";
    return SerializationType;
}({});
var $43f09feeac71c3ff$export$3b5c4a4b6354f023 = /*#__PURE__*/ function(SocketEventType) {
    SocketEventType["Message"] = "message";
    SocketEventType["Disconnected"] = "disconnected";
    SocketEventType["Error"] = "error";
    SocketEventType["Close"] = "close";
    return SocketEventType;
}({});
var $43f09feeac71c3ff$export$adb4a1754da6f10d = /*#__PURE__*/ function(ServerMessageType) {
    ServerMessageType["Heartbeat"] = "HEARTBEAT";
    ServerMessageType["Candidate"] = "CANDIDATE";
    ServerMessageType["Offer"] = "OFFER";
    ServerMessageType["Answer"] = "ANSWER";
    ServerMessageType["Open"] = "OPEN";
    ServerMessageType["Error"] = "ERROR";
    ServerMessageType["IdTaken"] = "ID-TAKEN";
    ServerMessageType["InvalidKey"] = "INVALID-KEY";
    ServerMessageType["Leave"] = "LEAVE";
    ServerMessageType["Expire"] = "EXPIRE";
    return ServerMessageType;
}({});
const $43f09feeac71c3ff$var$$520832d44ba058c8$export$83d89fbfd8236492 = "1.5.5";
class $43f09feeac71c3ff$var$$8f5bfa60836d261d$export$4798917dbf149b79 extends $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$exports.EventEmitter {
    start(id, token) {
        this._id = id;
        const wsUrl = `${this._baseUrl}&id=${id}&token=${token}`;
        if (!!this._socket || !this._disconnected) return;
        this._socket = new WebSocket(wsUrl + "&version=" + $43f09feeac71c3ff$var$$520832d44ba058c8$export$83d89fbfd8236492);
        this._disconnected = false;
        this._socket.onmessage = (event)=>{
            let data;
            try {
                data = JSON.parse(event.data);
                $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Server message received:", data);
            } catch (e) {
                $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Invalid server message", event.data);
                return;
            }
            this.emit($43f09feeac71c3ff$export$3b5c4a4b6354f023.Message, data);
        };
        this._socket.onclose = (event)=>{
            if (this._disconnected) return;
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Socket closed.", event);
            this._cleanup();
            this._disconnected = true;
            this.emit($43f09feeac71c3ff$export$3b5c4a4b6354f023.Disconnected);
        };
        // Take care of the queue of connections if necessary and make sure Peer knows
        // socket is open.
        this._socket.onopen = ()=>{
            if (this._disconnected) return;
            this._sendQueuedMessages();
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Socket open");
            this._scheduleHeartbeat();
        };
    }
    _scheduleHeartbeat() {
        this._wsPingTimer = setTimeout(()=>{
            this._sendHeartbeat();
        }, this.pingInterval);
    }
    _sendHeartbeat() {
        if (!this._wsOpen()) {
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Cannot send heartbeat, because socket closed`);
            return;
        }
        const message = JSON.stringify({
            type: $43f09feeac71c3ff$export$adb4a1754da6f10d.Heartbeat
        });
        this._socket.send(message);
        this._scheduleHeartbeat();
    }
    /** Is the websocket currently open? */ _wsOpen() {
        return !!this._socket && this._socket.readyState === 1;
    }
    /** Send queued messages. */ _sendQueuedMessages() {
        //Create copy of queue and clear it,
        //because send method push the message back to queue if smth will go wrong
        const copiedQueue = [
            ...this._messagesQueue
        ];
        this._messagesQueue = [];
        for (const message of copiedQueue)this.send(message);
    }
    /** Exposed send for DC & Peer. */ send(data) {
        if (this._disconnected) return;
        // If we didn't get an ID yet, we can't yet send anything so we should queue
        // up these messages.
        if (!this._id) {
            this._messagesQueue.push(data);
            return;
        }
        if (!data.type) {
            this.emit($43f09feeac71c3ff$export$3b5c4a4b6354f023.Error, "Invalid message");
            return;
        }
        if (!this._wsOpen()) return;
        const message = JSON.stringify(data);
        this._socket.send(message);
    }
    close() {
        if (this._disconnected) return;
        this._cleanup();
        this._disconnected = true;
    }
    _cleanup() {
        if (this._socket) {
            this._socket.onopen = this._socket.onmessage = this._socket.onclose = null;
            this._socket.close();
            this._socket = undefined;
        }
        clearTimeout(this._wsPingTimer);
    }
    constructor(secure, host, port, path, key, pingInterval = 5000){
        super(), this.pingInterval = pingInterval, this._disconnected = true, this._messagesQueue = [];
        const wsProtocol = secure ? "wss://" : "ws://";
        this._baseUrl = wsProtocol + host + ":" + port + path + "peerjs?key=" + key;
    }
}
class $43f09feeac71c3ff$var$$b82fb8fc0514bfc1$export$89e6bb5ad64bf4a {
    /** Returns a PeerConnection object set up correctly (for data, media). */ startConnection(options) {
        const peerConnection = this._startPeerConnection();
        // Set the connection's PC.
        this.connection.peerConnection = peerConnection;
        if (this.connection.type === $43f09feeac71c3ff$export$3157d57b4135e3bc.Media && options._stream) this._addTracksToConnection(options._stream, peerConnection);
        // What do we need to do now?
        if (options.originator) {
            const dataConnection = this.connection;
            const config = {
                ordered: !!options.reliable
            };
            const dataChannel = peerConnection.createDataChannel(dataConnection.label, config);
            dataConnection._initializeDataChannel(dataChannel);
            this._makeOffer();
        } else this.handleSDP("OFFER", options.sdp);
    }
    /** Start a PC. */ _startPeerConnection() {
        $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Creating RTCPeerConnection.");
        const peerConnection = new RTCPeerConnection(this.connection.provider.options.config);
        this._setupListeners(peerConnection);
        return peerConnection;
    }
    /** Set up various WebRTC listeners. */ _setupListeners(peerConnection) {
        const peerId = this.connection.peer;
        const connectionId = this.connection.connectionId;
        const connectionType = this.connection.type;
        const provider = this.connection.provider;
        $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Listening for ICE candidates.");
        peerConnection.onicecandidate = (evt)=>{
            if (!evt.candidate || !evt.candidate.candidate) return;
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Received ICE candidates for ${peerId}:`, evt.candidate);
            provider.socket.send({
                type: $43f09feeac71c3ff$export$adb4a1754da6f10d.Candidate,
                payload: {
                    candidate: evt.candidate,
                    type: connectionType,
                    connectionId: connectionId
                },
                dst: peerId
            });
        };
        peerConnection.oniceconnectionstatechange = ()=>{
            switch(peerConnection.iceConnectionState){
                case "failed":
                    $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("iceConnectionState is failed, closing connections to " + peerId);
                    this.connection.emitError($43f09feeac71c3ff$export$7974935686149686.NegotiationFailed, "Negotiation of connection to " + peerId + " failed.");
                    this.connection.close();
                    break;
                case "closed":
                    $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("iceConnectionState is closed, closing connections to " + peerId);
                    this.connection.emitError($43f09feeac71c3ff$export$7974935686149686.ConnectionClosed, "Connection to " + peerId + " closed.");
                    this.connection.close();
                    break;
                case "disconnected":
                    $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("iceConnectionState changed to disconnected on the connection with " + peerId);
                    break;
                case "completed":
                    peerConnection.onicecandidate = ()=>{};
                    break;
            }
            this.connection.emit("iceStateChanged", peerConnection.iceConnectionState);
        };
        $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Listening for data channel");
        // Fired between offer and answer, so options should already be saved
        // in the options hash.
        peerConnection.ondatachannel = (evt)=>{
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Received data channel");
            const dataChannel = evt.channel;
            const connection = provider.getConnection(peerId, connectionId);
            connection._initializeDataChannel(dataChannel);
        };
        $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Listening for remote stream");
        peerConnection.ontrack = (evt)=>{
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Received remote stream");
            const stream = evt.streams[0];
            const connection = provider.getConnection(peerId, connectionId);
            if (connection.type === $43f09feeac71c3ff$export$3157d57b4135e3bc.Media) {
                const mediaConnection = connection;
                this._addStreamToMediaConnection(stream, mediaConnection);
            }
        };
    }
    cleanup() {
        $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Cleaning up PeerConnection to " + this.connection.peer);
        const peerConnection = this.connection.peerConnection;
        if (!peerConnection) return;
        this.connection.peerConnection = null;
        //unsubscribe from all PeerConnection's events
        peerConnection.onicecandidate = peerConnection.oniceconnectionstatechange = peerConnection.ondatachannel = peerConnection.ontrack = ()=>{};
        const peerConnectionNotClosed = peerConnection.signalingState !== "closed";
        let dataChannelNotClosed = false;
        const dataChannel = this.connection.dataChannel;
        if (dataChannel) dataChannelNotClosed = !!dataChannel.readyState && dataChannel.readyState !== "closed";
        if (peerConnectionNotClosed || dataChannelNotClosed) peerConnection.close();
    }
    async _makeOffer() {
        const peerConnection = this.connection.peerConnection;
        const provider = this.connection.provider;
        try {
            const offer = await peerConnection.createOffer(this.connection.options.constraints);
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Created offer.");
            if (this.connection.options.sdpTransform && typeof this.connection.options.sdpTransform === "function") offer.sdp = this.connection.options.sdpTransform(offer.sdp) || offer.sdp;
            try {
                await peerConnection.setLocalDescription(offer);
                $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Set localDescription:", offer, `for:${this.connection.peer}`);
                let payload = {
                    sdp: offer,
                    type: this.connection.type,
                    connectionId: this.connection.connectionId,
                    metadata: this.connection.metadata
                };
                if (this.connection.type === $43f09feeac71c3ff$export$3157d57b4135e3bc.Data) {
                    const dataConnection = this.connection;
                    payload = {
                        ...payload,
                        label: dataConnection.label,
                        reliable: dataConnection.reliable,
                        serialization: dataConnection.serialization
                    };
                }
                provider.socket.send({
                    type: $43f09feeac71c3ff$export$adb4a1754da6f10d.Offer,
                    payload: payload,
                    dst: this.connection.peer
                });
            } catch (err) {
                // TODO: investigate why _makeOffer is being called from the answer
                if (err != "OperationError: Failed to set local offer sdp: Called in wrong state: kHaveRemoteOffer") {
                    provider.emitError($43f09feeac71c3ff$export$9547aaa2e39030ff.WebRTC, err);
                    $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Failed to setLocalDescription, ", err);
                }
            }
        } catch (err_1) {
            provider.emitError($43f09feeac71c3ff$export$9547aaa2e39030ff.WebRTC, err_1);
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Failed to createOffer, ", err_1);
        }
    }
    async _makeAnswer() {
        const peerConnection = this.connection.peerConnection;
        const provider = this.connection.provider;
        try {
            const answer = await peerConnection.createAnswer();
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Created answer.");
            if (this.connection.options.sdpTransform && typeof this.connection.options.sdpTransform === "function") answer.sdp = this.connection.options.sdpTransform(answer.sdp) || answer.sdp;
            try {
                await peerConnection.setLocalDescription(answer);
                $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Set localDescription:`, answer, `for:${this.connection.peer}`);
                provider.socket.send({
                    type: $43f09feeac71c3ff$export$adb4a1754da6f10d.Answer,
                    payload: {
                        sdp: answer,
                        type: this.connection.type,
                        connectionId: this.connection.connectionId
                    },
                    dst: this.connection.peer
                });
            } catch (err) {
                provider.emitError($43f09feeac71c3ff$export$9547aaa2e39030ff.WebRTC, err);
                $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Failed to setLocalDescription, ", err);
            }
        } catch (err_1) {
            provider.emitError($43f09feeac71c3ff$export$9547aaa2e39030ff.WebRTC, err_1);
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Failed to create answer, ", err_1);
        }
    }
    /** Handle an SDP. */ async handleSDP(type, sdp) {
        sdp = new RTCSessionDescription(sdp);
        const peerConnection = this.connection.peerConnection;
        const provider = this.connection.provider;
        $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Setting remote description", sdp);
        const self = this;
        try {
            await peerConnection.setRemoteDescription(sdp);
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Set remoteDescription:${type} for:${this.connection.peer}`);
            if (type === "OFFER") await self._makeAnswer();
        } catch (err) {
            provider.emitError($43f09feeac71c3ff$export$9547aaa2e39030ff.WebRTC, err);
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Failed to setRemoteDescription, ", err);
        }
    }
    /** Handle a candidate. */ async handleCandidate(ice) {
        $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log(`handleCandidate:`, ice);
        try {
            await this.connection.peerConnection.addIceCandidate(ice);
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Added ICE candidate for:${this.connection.peer}`);
        } catch (err) {
            this.connection.provider.emitError($43f09feeac71c3ff$export$9547aaa2e39030ff.WebRTC, err);
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Failed to handleCandidate, ", err);
        }
    }
    _addTracksToConnection(stream, peerConnection) {
        $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log(`add tracks from stream ${stream.id} to peer connection`);
        if (!peerConnection.addTrack) return $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.error(`Your browser does't support RTCPeerConnection#addTrack. Ignored.`);
        stream.getTracks().forEach((track)=>{
            peerConnection.addTrack(track, stream);
        });
    }
    _addStreamToMediaConnection(stream, mediaConnection) {
        $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log(`add stream ${stream.id} to media connection ${mediaConnection.connectionId}`);
        mediaConnection.addStream(stream);
    }
    constructor(connection){
        this.connection = connection;
    }
}
class $43f09feeac71c3ff$var$$23779d1881157a18$export$6a678e589c8a4542 extends $43f09feeac71c3ff$var$$c4dcfd1d1ea86647$exports.EventEmitter {
    /**
	 * Emits a typed error message.
	 *
	 * @internal
	 */ emitError(type, err) {
        $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.error("Error:", err);
        // @ts-ignore
        this.emit("error", new $43f09feeac71c3ff$export$98871882f492de82(`${type}`, err));
    }
}
class $43f09feeac71c3ff$export$98871882f492de82 extends Error {
    /**
	 * @internal
	 */ constructor(type, err){
        if (typeof err === "string") super(err);
        else {
            super();
            Object.assign(this, err);
        }
        this.type = type;
    }
}
class $43f09feeac71c3ff$var$$5045192fc6d387ba$export$23a2a68283c24d80 extends $43f09feeac71c3ff$var$$23779d1881157a18$export$6a678e589c8a4542 {
    /**
	 * Whether the media connection is active (e.g. your call has been answered).
	 * You can check this if you want to set a maximum wait time for a one-sided call.
	 */ get open() {
        return this._open;
    }
    constructor(/**
		 * The ID of the peer on the other end of this connection.
		 */ peer, provider, options){
        super(), this.peer = peer, this.provider = provider, this.options = options, this._open = false;
        this.metadata = options.metadata;
    }
}
class $43f09feeac71c3ff$var$$5c1d08c7c57da9a3$export$4a84e95a2324ac29 extends $43f09feeac71c3ff$var$$5045192fc6d387ba$export$23a2a68283c24d80 {
    /**
	 * For media connections, this is always 'media'.
	 */ get type() {
        return $43f09feeac71c3ff$export$3157d57b4135e3bc.Media;
    }
    get localStream() {
        return this._localStream;
    }
    get remoteStream() {
        return this._remoteStream;
    }
    /** Called by the Negotiator when the DataChannel is ready. */ _initializeDataChannel(dc) {
        this.dataChannel = dc;
        this.dataChannel.onopen = ()=>{
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log(`DC#${this.connectionId} dc connection success`);
            this.emit("willCloseOnRemote");
        };
        this.dataChannel.onclose = ()=>{
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log(`DC#${this.connectionId} dc closed for:`, this.peer);
            this.close();
        };
    }
    addStream(remoteStream) {
        $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log("Receiving stream", remoteStream);
        this._remoteStream = remoteStream;
        super.emit("stream", remoteStream); // Should we call this `open`?
    }
    /**
	 * @internal
	 */ handleMessage(message) {
        const type = message.type;
        const payload = message.payload;
        switch(message.type){
            case $43f09feeac71c3ff$export$adb4a1754da6f10d.Answer:
                // Forward to negotiator
                this._negotiator.handleSDP(type, payload.sdp);
                this._open = true;
                break;
            case $43f09feeac71c3ff$export$adb4a1754da6f10d.Candidate:
                this._negotiator.handleCandidate(payload.candidate);
                break;
            default:
                $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.warn(`Unrecognized message type:${type} from peer:${this.peer}`);
                break;
        }
    }
    /**
     * When receiving a {@apilink PeerEvents | `call`} event on a peer, you can call
     * `answer` on the media connection provided by the callback to accept the call
     * and optionally send your own media stream.

     *
     * @param stream A WebRTC media stream.
     * @param options
     * @returns
     */ answer(stream, options = {}) {
        if (this._localStream) {
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.warn("Local stream already exists on this MediaConnection. Are you answering a call twice?");
            return;
        }
        this._localStream = stream;
        if (options && options.sdpTransform) this.options.sdpTransform = options.sdpTransform;
        this._negotiator.startConnection({
            ...this.options._payload,
            _stream: stream
        });
        // Retrieve lost messages stored because PeerConnection not set up.
        const messages = this.provider._getMessages(this.connectionId);
        for (const message of messages)this.handleMessage(message);
        this._open = true;
    }
    /**
	 * Exposed functionality for users.
	 */ /**
	 * Closes the media connection.
	 */ close() {
        if (this._negotiator) {
            this._negotiator.cleanup();
            this._negotiator = null;
        }
        this._localStream = null;
        this._remoteStream = null;
        if (this.provider) {
            this.provider._removeConnection(this);
            this.provider = null;
        }
        if (this.options && this.options._stream) this.options._stream = null;
        if (!this.open) return;
        this._open = false;
        super.emit("close");
    }
    constructor(peerId, provider, options){
        super(peerId, provider, options);
        this._localStream = this.options._stream;
        this.connectionId = this.options.connectionId || $43f09feeac71c3ff$var$$5c1d08c7c57da9a3$export$4a84e95a2324ac29.ID_PREFIX + $43f09feeac71c3ff$export$7debb50ef11d5e0b.randomToken();
        this._negotiator = new $43f09feeac71c3ff$var$$b82fb8fc0514bfc1$export$89e6bb5ad64bf4a(this);
        if (this._localStream) this._negotiator.startConnection({
            _stream: this._localStream,
            originator: true
        });
    }
}
var $43f09feeac71c3ff$var$__ = {
    writable: true,
    value: $43f09feeac71c3ff$var$$5c1d08c7c57da9a3$export$4a84e95a2324ac29.ID_PREFIX = "mc_"
};
class $43f09feeac71c3ff$var$$abf266641927cd89$export$2c4e825dc9120f87 {
    _buildRequest(method) {
        const protocol = this._options.secure ? "https" : "http";
        const { host: host, port: port, path: path, key: key } = this._options;
        const url = new URL(`${protocol}://${host}:${port}${path}${key}/${method}`);
        // TODO: Why timestamp, why random?
        url.searchParams.set("ts", `${Date.now()}${Math.random()}`);
        url.searchParams.set("version", $43f09feeac71c3ff$var$$520832d44ba058c8$export$83d89fbfd8236492);
        return fetch(url.href, {
            referrerPolicy: this._options.referrerPolicy
        });
    }
    /** Get a unique ID from the server via XHR and initialize with it. */ async retrieveId() {
        try {
            const response = await this._buildRequest("id");
            if (response.status !== 200) throw new Error(`Error. Status:${response.status}`);
            return response.text();
        } catch (error) {
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.error("Error retrieving ID", error);
            let pathError = "";
            if (this._options.path === "/" && this._options.host !== $43f09feeac71c3ff$export$7debb50ef11d5e0b.CLOUD_HOST) pathError = " If you passed in a `path` to your self-hosted PeerServer, you'll also need to pass in that same path when creating a new Peer.";
            throw new Error("Could not get an ID from the server." + pathError);
        }
    }
    /** @deprecated */ async listAllPeers() {
        try {
            const response = await this._buildRequest("peers");
            if (response.status !== 200) {
                if (response.status === 401) {
                    let helpfulError = "";
                    if (this._options.host === $43f09feeac71c3ff$export$7debb50ef11d5e0b.CLOUD_HOST) helpfulError = "It looks like you're using the cloud server. You can email team@peerjs.com to enable peer listing for your API key.";
                    else helpfulError = "You need to enable `allow_discovery` on your self-hosted PeerServer to use this feature.";
                    throw new Error("It doesn't look like you have permission to list peers IDs. " + helpfulError);
                }
                throw new Error(`Error. Status:${response.status}`);
            }
            return response.json();
        } catch (error) {
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.error("Error retrieving list peers", error);
            throw new Error("Could not get list peers from the server." + error);
        }
    }
    constructor(_options){
        this._options = _options;
    }
}
class $43f09feeac71c3ff$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9 extends $43f09feeac71c3ff$var$$5045192fc6d387ba$export$23a2a68283c24d80 {
    get type() {
        return $43f09feeac71c3ff$export$3157d57b4135e3bc.Data;
    }
    /** Called by the Negotiator when the DataChannel is ready. */ _initializeDataChannel(dc) {
        this.dataChannel = dc;
        this.dataChannel.onopen = ()=>{
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log(`DC#${this.connectionId} dc connection success`);
            this._open = true;
            this.emit("open");
        };
        this.dataChannel.onmessage = (e)=>{
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log(`DC#${this.connectionId} dc onmessage:`, e.data);
        // this._handleDataMessage(e);
        };
        this.dataChannel.onclose = ()=>{
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log(`DC#${this.connectionId} dc closed for:`, this.peer);
            this.close();
        };
    }
    /**
	 * Exposed functionality for users.
	 */ /** Allows user to close connection. */ close(options) {
        if (options === null || options === void 0 ? void 0 : options.flush) {
            this.send({
                __peerData: {
                    type: "close"
                }
            });
            return;
        }
        if (this._negotiator) {
            this._negotiator.cleanup();
            this._negotiator = null;
        }
        if (this.provider) {
            this.provider._removeConnection(this);
            this.provider = null;
        }
        if (this.dataChannel) {
            this.dataChannel.onopen = null;
            this.dataChannel.onmessage = null;
            this.dataChannel.onclose = null;
            this.dataChannel = null;
        }
        if (!this.open) return;
        this._open = false;
        super.emit("close");
    }
    /** Allows user to send data. */ send(data, chunked = false) {
        if (!this.open) {
            this.emitError($43f09feeac71c3ff$export$49ae800c114df41d.NotOpenYet, "Connection is not open. You should listen for the `open` event before sending messages.");
            return;
        }
        return this._send(data, chunked);
    }
    async handleMessage(message) {
        const payload = message.payload;
        switch(message.type){
            case $43f09feeac71c3ff$export$adb4a1754da6f10d.Answer:
                await this._negotiator.handleSDP(message.type, payload.sdp);
                break;
            case $43f09feeac71c3ff$export$adb4a1754da6f10d.Candidate:
                await this._negotiator.handleCandidate(payload.candidate);
                break;
            default:
                $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.warn("Unrecognized message type:", message.type, "from peer:", this.peer);
                break;
        }
    }
    constructor(peerId, provider, options){
        super(peerId, provider, options);
        this.connectionId = this.options.connectionId || $43f09feeac71c3ff$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9.ID_PREFIX + $43f09feeac71c3ff$var$$0e5fd1585784c252$export$4e61f672936bec77();
        this.label = this.options.label || this.connectionId;
        this.reliable = !!this.options.reliable;
        this._negotiator = new $43f09feeac71c3ff$var$$b82fb8fc0514bfc1$export$89e6bb5ad64bf4a(this);
        this._negotiator.startConnection(this.options._payload || {
            originator: true,
            reliable: this.reliable
        });
    }
}
var $43f09feeac71c3ff$var$__1 = {
    writable: true,
    value: $43f09feeac71c3ff$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9.ID_PREFIX = "dc_"
};
var $43f09feeac71c3ff$var$__2 = {
    writable: true,
    value: $43f09feeac71c3ff$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9.MAX_BUFFERED_AMOUNT = 8388608
};
class $43f09feeac71c3ff$export$ff7c9d4c11d94e8b extends $43f09feeac71c3ff$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9 {
    get bufferSize() {
        return this._bufferSize;
    }
    _initializeDataChannel(dc) {
        super._initializeDataChannel(dc);
        this.dataChannel.binaryType = "arraybuffer";
        this.dataChannel.addEventListener("message", (e)=>this._handleDataMessage(e));
    }
    _bufferedSend(msg) {
        if (this._buffering || !this._trySend(msg)) {
            this._buffer.push(msg);
            this._bufferSize = this._buffer.length;
        }
    }
    // Returns true if the send succeeds.
    _trySend(msg) {
        if (!this.open) return false;
        if (this.dataChannel.bufferedAmount > $43f09feeac71c3ff$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9.MAX_BUFFERED_AMOUNT) {
            this._buffering = true;
            setTimeout(()=>{
                this._buffering = false;
                this._tryBuffer();
            }, 50);
            return false;
        }
        try {
            this.dataChannel.send(msg);
        } catch (e) {
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.error(`DC#:${this.connectionId} Error when sending:`, e);
            this._buffering = true;
            this.close();
            return false;
        }
        return true;
    }
    // Try to send the first message in the buffer.
    _tryBuffer() {
        if (!this.open) return;
        if (this._buffer.length === 0) return;
        const msg = this._buffer[0];
        if (this._trySend(msg)) {
            this._buffer.shift();
            this._bufferSize = this._buffer.length;
            this._tryBuffer();
        }
    }
    close(options) {
        if (options === null || options === void 0 ? void 0 : options.flush) {
            this.send({
                __peerData: {
                    type: "close"
                }
            });
            return;
        }
        this._buffer = [];
        this._bufferSize = 0;
        super.close();
    }
    constructor(...args){
        super(...args), this._buffer = [], this._bufferSize = 0, this._buffering = false;
    }
}
class $43f09feeac71c3ff$var$$9fcfddb3ae148f88$export$f0a5a64d5bb37108 extends $43f09feeac71c3ff$export$ff7c9d4c11d94e8b {
    close(options) {
        super.close(options);
        this._chunkedData = {};
    }
    // Handles a DataChannel message.
    _handleDataMessage({ data: data }) {
        const deserializedData = (0, $5b93b93a09fbaeb8$export$417857010dc9287f)(data);
        // PeerJS specific message
        const peerData = deserializedData["__peerData"];
        if (peerData) {
            if (peerData.type === "close") {
                this.close();
                return;
            }
            // Chunked data -- piece things back together.
            // @ts-ignore
            this._handleChunk(deserializedData);
            return;
        }
        this.emit("data", deserializedData);
    }
    _handleChunk(data) {
        const id = data.__peerData;
        const chunkInfo = this._chunkedData[id] || {
            data: [],
            count: 0,
            total: data.total
        };
        chunkInfo.data[data.n] = new Uint8Array(data.data);
        chunkInfo.count++;
        this._chunkedData[id] = chunkInfo;
        if (chunkInfo.total === chunkInfo.count) {
            // Clean up before making the recursive call to `_handleDataMessage`.
            delete this._chunkedData[id];
            // We've received all the chunks--time to construct the complete data.
            // const data = new Blob(chunkInfo.data);
            const data = $43f09feeac71c3ff$var$$fcbcc7538a6776d5$export$52c89ebcdc4f53f2(chunkInfo.data);
            this._handleDataMessage({
                data: data
            });
        }
    }
    _send(data, chunked) {
        const blob = (0, $5b93b93a09fbaeb8$export$2a703dbb0cb35339)(data);
        if (blob instanceof Promise) return this._send_blob(blob);
        if (!chunked && blob.byteLength > this.chunker.chunkedMTU) {
            this._sendChunks(blob);
            return;
        }
        this._bufferedSend(blob);
    }
    async _send_blob(blobPromise) {
        const blob = await blobPromise;
        if (blob.byteLength > this.chunker.chunkedMTU) {
            this._sendChunks(blob);
            return;
        }
        this._bufferedSend(blob);
    }
    _sendChunks(blob) {
        const blobs = this.chunker.chunk(blob);
        $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log(`DC#${this.connectionId} Try to send ${blobs.length} chunks...`);
        for (const blob of blobs)this.send(blob, true);
    }
    constructor(peerId, provider, options){
        super(peerId, provider, options), this.chunker = new $43f09feeac71c3ff$var$$fcbcc7538a6776d5$export$f1c5f4c9cb95390b(), this.serialization = $43f09feeac71c3ff$export$89f507cf986a947.Binary, this._chunkedData = {};
    }
}
class $43f09feeac71c3ff$var$$bbaee3f15f714663$export$6f88fe47d32c9c94 extends $43f09feeac71c3ff$export$ff7c9d4c11d94e8b {
    _handleDataMessage({ data: data }) {
        super.emit("data", data);
    }
    _send(data, _chunked) {
        this._bufferedSend(data);
    }
    constructor(...args){
        super(...args), this.serialization = $43f09feeac71c3ff$export$89f507cf986a947.None;
    }
}
class $43f09feeac71c3ff$var$$817f931e3f9096cf$export$48880ac635f47186 extends $43f09feeac71c3ff$export$ff7c9d4c11d94e8b {
    // Handles a DataChannel message.
    _handleDataMessage({ data: data }) {
        const deserializedData = this.parse(this.decoder.decode(data));
        // PeerJS specific message
        const peerData = deserializedData["__peerData"];
        if (peerData && peerData.type === "close") {
            this.close();
            return;
        }
        this.emit("data", deserializedData);
    }
    _send(data, _chunked) {
        const encodedData = this.encoder.encode(this.stringify(data));
        if (encodedData.byteLength >= $43f09feeac71c3ff$export$7debb50ef11d5e0b.chunkedMTU) {
            this.emitError($43f09feeac71c3ff$export$49ae800c114df41d.MessageToBig, "Message too big for JSON channel");
            return;
        }
        this._bufferedSend(encodedData);
    }
    constructor(...args){
        super(...args), this.serialization = $43f09feeac71c3ff$export$89f507cf986a947.JSON, this.encoder = new TextEncoder(), this.decoder = new TextDecoder(), this.stringify = JSON.stringify, this.parse = JSON.parse;
    }
}
class $43f09feeac71c3ff$var$$416260bce337df90$var$PeerOptions {
}
class $43f09feeac71c3ff$export$ecd1fc136c422448 extends $43f09feeac71c3ff$var$$23779d1881157a18$export$6a678e589c8a4542 {
    /**
	 * The brokering ID of this peer
	 *
	 * If no ID was specified in {@apilink Peer | the constructor},
	 * this will be `undefined` until the {@apilink PeerEvents | `open`} event is emitted.
	 */ get id() {
        return this._id;
    }
    get options() {
        return this._options;
    }
    get open() {
        return this._open;
    }
    /**
	 * @internal
	 */ get socket() {
        return this._socket;
    }
    /**
	 * A hash of all connections associated with this peer, keyed by the remote peer's ID.
	 * @deprecated
	 * Return type will change from Object to Map<string,[]>
	 */ get connections() {
        const plainConnections = Object.create(null);
        for (const [k, v] of this._connections)plainConnections[k] = v;
        return plainConnections;
    }
    /**
	 * true if this peer and all of its connections can no longer be used.
	 */ get destroyed() {
        return this._destroyed;
    }
    /**
	 * false if there is an active connection to the PeerServer.
	 */ get disconnected() {
        return this._disconnected;
    }
    _createServerConnection() {
        const socket = new $43f09feeac71c3ff$var$$8f5bfa60836d261d$export$4798917dbf149b79(this._options.secure, this._options.host, this._options.port, this._options.path, this._options.key, this._options.pingInterval);
        socket.on($43f09feeac71c3ff$export$3b5c4a4b6354f023.Message, (data)=>{
            this._handleMessage(data);
        });
        socket.on($43f09feeac71c3ff$export$3b5c4a4b6354f023.Error, (error)=>{
            this._abort($43f09feeac71c3ff$export$9547aaa2e39030ff.SocketError, error);
        });
        socket.on($43f09feeac71c3ff$export$3b5c4a4b6354f023.Disconnected, ()=>{
            if (this.disconnected) return;
            this.emitError($43f09feeac71c3ff$export$9547aaa2e39030ff.Network, "Lost connection to server.");
            this.disconnect();
        });
        socket.on($43f09feeac71c3ff$export$3b5c4a4b6354f023.Close, ()=>{
            if (this.disconnected) return;
            this._abort($43f09feeac71c3ff$export$9547aaa2e39030ff.SocketClosed, "Underlying socket is already closed.");
        });
        return socket;
    }
    /** Initialize a connection with the server. */ _initialize(id) {
        this._id = id;
        this.socket.start(id, this._options.token);
    }
    /** Handles messages from the server. */ _handleMessage(message) {
        const type = message.type;
        const payload = message.payload;
        const peerId = message.src;
        switch(type){
            case $43f09feeac71c3ff$export$adb4a1754da6f10d.Open:
                this._lastServerId = this.id;
                this._open = true;
                this.emit("open", this.id);
                break;
            case $43f09feeac71c3ff$export$adb4a1754da6f10d.Error:
                this._abort($43f09feeac71c3ff$export$9547aaa2e39030ff.ServerError, payload.msg);
                break;
            case $43f09feeac71c3ff$export$adb4a1754da6f10d.IdTaken:
                this._abort($43f09feeac71c3ff$export$9547aaa2e39030ff.UnavailableID, `ID "${this.id}" is taken`);
                break;
            case $43f09feeac71c3ff$export$adb4a1754da6f10d.InvalidKey:
                this._abort($43f09feeac71c3ff$export$9547aaa2e39030ff.InvalidKey, `API KEY "${this._options.key}" is invalid`);
                break;
            case $43f09feeac71c3ff$export$adb4a1754da6f10d.Leave:
                $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Received leave message from ${peerId}`);
                this._cleanupPeer(peerId);
                this._connections.delete(peerId);
                break;
            case $43f09feeac71c3ff$export$adb4a1754da6f10d.Expire:
                this.emitError($43f09feeac71c3ff$export$9547aaa2e39030ff.PeerUnavailable, `Could not connect to peer ${peerId}`);
                break;
            case $43f09feeac71c3ff$export$adb4a1754da6f10d.Offer:
                {
                    // we should consider switching this to CALL/CONNECT, but this is the least breaking option.
                    const connectionId = payload.connectionId;
                    let connection = this.getConnection(peerId, connectionId);
                    if (connection) {
                        connection.close();
                        $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.warn(`Offer received for existing Connection ID:${connectionId}`);
                    }
                    // Create a new connection.
                    if (payload.type === $43f09feeac71c3ff$export$3157d57b4135e3bc.Media) {
                        const mediaConnection = new $43f09feeac71c3ff$var$$5c1d08c7c57da9a3$export$4a84e95a2324ac29(peerId, this, {
                            connectionId: connectionId,
                            _payload: payload,
                            metadata: payload.metadata
                        });
                        connection = mediaConnection;
                        this._addConnection(peerId, connection);
                        this.emit("call", mediaConnection);
                    } else if (payload.type === $43f09feeac71c3ff$export$3157d57b4135e3bc.Data) {
                        const dataConnection = new this._serializers[payload.serialization](peerId, this, {
                            connectionId: connectionId,
                            _payload: payload,
                            metadata: payload.metadata,
                            label: payload.label,
                            serialization: payload.serialization,
                            reliable: payload.reliable
                        });
                        connection = dataConnection;
                        this._addConnection(peerId, connection);
                        this.emit("connection", dataConnection);
                    } else {
                        $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.warn(`Received malformed connection type:${payload.type}`);
                        return;
                    }
                    // Find messages.
                    const messages = this._getMessages(connectionId);
                    for (const message of messages)connection.handleMessage(message);
                    break;
                }
            default:
                {
                    if (!payload) {
                        $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.warn(`You received a malformed message from ${peerId} of type ${type}`);
                        return;
                    }
                    const connectionId = payload.connectionId;
                    const connection = this.getConnection(peerId, connectionId);
                    if (connection && connection.peerConnection) connection.handleMessage(message);
                    else if (connectionId) this._storeMessage(connectionId, message);
                    else $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.warn("You received an unrecognized message:", message);
                    break;
                }
        }
    }
    /** Stores messages without a set up connection, to be claimed later. */ _storeMessage(connectionId, message) {
        if (!this._lostMessages.has(connectionId)) this._lostMessages.set(connectionId, []);
        this._lostMessages.get(connectionId).push(message);
    }
    /**
	 * Retrieve messages from lost message store
	 * @internal
	 */ //TODO Change it to private
    _getMessages(connectionId) {
        const messages = this._lostMessages.get(connectionId);
        if (messages) {
            this._lostMessages.delete(connectionId);
            return messages;
        }
        return [];
    }
    /**
	 * Connects to the remote peer specified by id and returns a data connection.
	 * @param peer The brokering ID of the remote peer (their {@apilink Peer.id}).
	 * @param options for specifying details about Peer Connection
	 */ connect(peer, options = {}) {
        options = {
            serialization: "default",
            ...options
        };
        if (this.disconnected) {
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.warn("You cannot connect to a new Peer because you called .disconnect() on this Peer and ended your connection with the server. You can create a new Peer to reconnect, or call reconnect on this peer if you believe its ID to still be available.");
            this.emitError($43f09feeac71c3ff$export$9547aaa2e39030ff.Disconnected, "Cannot connect to new Peer after disconnecting from server.");
            return;
        }
        const dataConnection = new this._serializers[options.serialization](peer, this, options);
        this._addConnection(peer, dataConnection);
        return dataConnection;
    }
    /**
	 * Calls the remote peer specified by id and returns a media connection.
	 * @param peer The brokering ID of the remote peer (their peer.id).
	 * @param stream The caller's media stream
	 * @param options Metadata associated with the connection, passed in by whoever initiated the connection.
	 */ call(peer, stream, options = {}) {
        if (this.disconnected) {
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.warn("You cannot connect to a new Peer because you called .disconnect() on this Peer and ended your connection with the server. You can create a new Peer to reconnect.");
            this.emitError($43f09feeac71c3ff$export$9547aaa2e39030ff.Disconnected, "Cannot connect to new Peer after disconnecting from server.");
            return;
        }
        if (!stream) {
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.error("To call a peer, you must provide a stream from your browser's `getUserMedia`.");
            return;
        }
        const mediaConnection = new $43f09feeac71c3ff$var$$5c1d08c7c57da9a3$export$4a84e95a2324ac29(peer, this, {
            ...options,
            _stream: stream
        });
        this._addConnection(peer, mediaConnection);
        return mediaConnection;
    }
    /** Add a data/media connection to this peer. */ _addConnection(peerId, connection) {
        $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log(`add connection ${connection.type}:${connection.connectionId} to peerId:${peerId}`);
        if (!this._connections.has(peerId)) this._connections.set(peerId, []);
        this._connections.get(peerId).push(connection);
    }
    //TODO should be private
    _removeConnection(connection) {
        const connections = this._connections.get(connection.peer);
        if (connections) {
            const index = connections.indexOf(connection);
            if (index !== -1) connections.splice(index, 1);
        }
        //remove from lost messages
        this._lostMessages.delete(connection.connectionId);
    }
    /** Retrieve a data/media connection for this peer. */ getConnection(peerId, connectionId) {
        const connections = this._connections.get(peerId);
        if (!connections) return null;
        for (const connection of connections){
            if (connection.connectionId === connectionId) return connection;
        }
        return null;
    }
    _delayedAbort(type, message) {
        setTimeout(()=>{
            this._abort(type, message);
        }, 0);
    }
    /**
	 * Emits an error message and destroys the Peer.
	 * The Peer is not destroyed if it's in a disconnected state, in which case
	 * it retains its disconnected state and its existing connections.
	 */ _abort(type, message) {
        $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.error("Aborting!");
        this.emitError(type, message);
        if (!this._lastServerId) this.destroy();
        else this.disconnect();
    }
    /**
	 * Destroys the Peer: closes all active connections as well as the connection
	 * to the server.
	 *
	 * :::caution
	 * This cannot be undone; the respective peer object will no longer be able
	 * to create or receive any connections, its ID will be forfeited on the server,
	 * and all of its data and media connections will be closed.
	 * :::
	 */ destroy() {
        if (this.destroyed) return;
        $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Destroy peer with ID:${this.id}`);
        this.disconnect();
        this._cleanup();
        this._destroyed = true;
        this.emit("close");
    }
    /** Disconnects every connection on this peer. */ _cleanup() {
        for (const peerId of this._connections.keys()){
            this._cleanupPeer(peerId);
            this._connections.delete(peerId);
        }
        this.socket.removeAllListeners();
    }
    /** Closes all connections to this peer. */ _cleanupPeer(peerId) {
        const connections = this._connections.get(peerId);
        if (!connections) return;
        for (const connection of connections)connection.close();
    }
    /**
	 * Disconnects the Peer's connection to the PeerServer. Does not close any
	 *  active connections.
	 * Warning: The peer can no longer create or accept connections after being
	 *  disconnected. It also cannot reconnect to the server.
	 */ disconnect() {
        if (this.disconnected) return;
        const currentId = this.id;
        $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Disconnect peer with ID:${currentId}`);
        this._disconnected = true;
        this._open = false;
        this.socket.close();
        this._lastServerId = currentId;
        this._id = null;
        this.emit("disconnected", currentId);
    }
    /** Attempts to reconnect with the same ID.
	 *
	 * Only {@apilink Peer.disconnect | disconnected peers} can be reconnected.
	 * Destroyed peers cannot be reconnected.
	 * If the connection fails (as an example, if the peer's old ID is now taken),
	 * the peer's existing connections will not close, but any associated errors events will fire.
	 */ reconnect() {
        if (this.disconnected && !this.destroyed) {
            $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Attempting reconnection to server with ID ${this._lastServerId}`);
            this._disconnected = false;
            this._initialize(this._lastServerId);
        } else if (this.destroyed) throw new Error("This peer cannot reconnect to the server. It has already been destroyed.");
        else if (!this.disconnected && !this.open) $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.error("In a hurry? We're still trying to make the initial connection!");
        else throw new Error(`Peer ${this.id} cannot reconnect because it is not disconnected from the server!`);
    }
    /**
	 * Get a list of available peer IDs. If you're running your own server, you'll
	 * want to set allow_discovery: true in the PeerServer options. If you're using
	 * the cloud server, email team@peerjs.com to get the functionality enabled for
	 * your key.
	 */ listAllPeers(cb = (_)=>{}) {
        this._api.listAllPeers().then((peers)=>cb(peers)).catch((error)=>this._abort($43f09feeac71c3ff$export$9547aaa2e39030ff.ServerError, error));
    }
    constructor(id, options){
        super(), this._serializers = {
            raw: $43f09feeac71c3ff$var$$bbaee3f15f714663$export$6f88fe47d32c9c94,
            json: $43f09feeac71c3ff$var$$817f931e3f9096cf$export$48880ac635f47186,
            binary: $43f09feeac71c3ff$var$$9fcfddb3ae148f88$export$f0a5a64d5bb37108,
            "binary-utf8": $43f09feeac71c3ff$var$$9fcfddb3ae148f88$export$f0a5a64d5bb37108,
            default: $43f09feeac71c3ff$var$$9fcfddb3ae148f88$export$f0a5a64d5bb37108
        }, this._id = null, this._lastServerId = null, this._destroyed = false // Connections have been killed
        , this._disconnected = false // Connection to PeerServer killed but P2P connections still active
        , this._open = false // Sockets and such are not yet open.
        , this._connections = new Map() // All connections for this peer.
        , this._lostMessages = new Map() // src => [list of messages]
        ;
        let userId;
        // Deal with overloading
        if (id && id.constructor == Object) options = id;
        else if (id) userId = id.toString();
        // Configurize options
        options = {
            debug: 0,
            host: $43f09feeac71c3ff$export$7debb50ef11d5e0b.CLOUD_HOST,
            port: $43f09feeac71c3ff$export$7debb50ef11d5e0b.CLOUD_PORT,
            path: "/",
            key: $43f09feeac71c3ff$export$ecd1fc136c422448.DEFAULT_KEY,
            token: $43f09feeac71c3ff$export$7debb50ef11d5e0b.randomToken(),
            config: $43f09feeac71c3ff$export$7debb50ef11d5e0b.defaultConfig,
            referrerPolicy: "strict-origin-when-cross-origin",
            serializers: {},
            ...options
        };
        this._options = options;
        this._serializers = {
            ...this._serializers,
            ...this.options.serializers
        };
        // Detect relative URL host.
        if (this._options.host === "/") this._options.host = window.location.hostname;
        // Set path correctly.
        if (this._options.path) {
            if (this._options.path[0] !== "/") this._options.path = "/" + this._options.path;
            if (this._options.path[this._options.path.length - 1] !== "/") this._options.path += "/";
        }
        // Set whether we use SSL to same as current host
        if (this._options.secure === undefined && this._options.host !== $43f09feeac71c3ff$export$7debb50ef11d5e0b.CLOUD_HOST) this._options.secure = $43f09feeac71c3ff$export$7debb50ef11d5e0b.isSecure();
        else if (this._options.host == $43f09feeac71c3ff$export$7debb50ef11d5e0b.CLOUD_HOST) this._options.secure = true;
        // Set a custom log function if present
        if (this._options.logFunction) $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.setLogFunction(this._options.logFunction);
        $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.logLevel = this._options.debug || 0;
        this._api = new $43f09feeac71c3ff$var$$abf266641927cd89$export$2c4e825dc9120f87(options);
        this._socket = this._createServerConnection();
        // Sanity checks
        // Ensure WebRTC supported
        if (!$43f09feeac71c3ff$export$7debb50ef11d5e0b.supports.audioVideo && !$43f09feeac71c3ff$export$7debb50ef11d5e0b.supports.data) {
            this._delayedAbort($43f09feeac71c3ff$export$9547aaa2e39030ff.BrowserIncompatible, "The current browser does not support WebRTC");
            return;
        }
        // Ensure alphanumeric id
        if (!!userId && !$43f09feeac71c3ff$export$7debb50ef11d5e0b.validateId(userId)) {
            this._delayedAbort($43f09feeac71c3ff$export$9547aaa2e39030ff.InvalidID, `ID "${userId}" is invalid`);
            return;
        }
        if (userId) this._initialize(userId);
        else this._api.retrieveId().then((id)=>this._initialize(id)).catch((error)=>this._abort($43f09feeac71c3ff$export$9547aaa2e39030ff.ServerError, error));
    }
}
var $43f09feeac71c3ff$var$__3 = {
    writable: true,
    value: $43f09feeac71c3ff$export$ecd1fc136c422448.DEFAULT_KEY = "peerjs"
};
class $43f09feeac71c3ff$export$72aa44612e2200cd extends $43f09feeac71c3ff$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9 {
    _initializeDataChannel(dc) {
        super._initializeDataChannel(dc);
        this.dataChannel.binaryType = "arraybuffer";
        this.dataChannel.bufferedAmountLowThreshold = $43f09feeac71c3ff$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9.MAX_BUFFERED_AMOUNT / 2;
    }
    constructor(peerId, provider, options){
        super(peerId, provider, {
            ...options,
            reliable: true
        }), this._CHUNK_SIZE = 32768, this._splitStream = new TransformStream({
            transform: (chunk, controller)=>{
                for(let split = 0; split < chunk.length; split += this._CHUNK_SIZE)controller.enqueue(chunk.subarray(split, split + this._CHUNK_SIZE));
            }
        }), this._rawSendStream = new WritableStream({
            write: async (chunk, controller)=>{
                const openEvent = new Promise((resolve)=>this.dataChannel.addEventListener("bufferedamountlow", resolve, {
                        once: true
                    }));
                // if we can send the chunk now, send it
                // if not, we wait until at least half of the sending buffer is free again
                await (this.dataChannel.bufferedAmount <= $43f09feeac71c3ff$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9.MAX_BUFFERED_AMOUNT - chunk.byteLength || openEvent);
                // TODO: what can go wrong here?
                try {
                    this.dataChannel.send(chunk);
                } catch (e) {
                    $43f09feeac71c3ff$var$$257947e92926277a$export$2e2bcd8739ae039.error(`DC#:${this.connectionId} Error when sending:`, e);
                    controller.error(e);
                    this.close();
                }
            }
        }), this.writer = this._splitStream.writable.getWriter(), this._rawReadStream = new ReadableStream({
            start: (controller)=>{
                this.once("open", ()=>{
                    this.dataChannel.addEventListener("message", (e)=>{
                        controller.enqueue(e.data);
                    });
                });
            }
        });
        this._splitStream.readable.pipeTo(this._rawSendStream);
    }
}
class $43f09feeac71c3ff$export$80f5de1a66c4d624 extends $43f09feeac71c3ff$export$72aa44612e2200cd {
    _send(data) {
        return this.writer.write(this._encoder.encode(data));
    }
    constructor(peerId, provider, options){
        super(peerId, provider, options), this.serialization = "MsgPack", this._encoder = new (0, $1076902c8ed47882$export$a50aceb0e02a00aa)();
        (async ()=>{
            for await (const msg of (0, $95417b30ac7b0011$export$bf87d8a088c760fb)(this._rawReadStream)){
                var _msg___peerData;
                // @ts-ignore
                if (((_msg___peerData = msg.__peerData) === null || _msg___peerData === void 0 ? void 0 : _msg___peerData.type) === "close") {
                    this.close();
                    return;
                }
                this.emit("data", msg);
            }
        })();
    }
}
class $43f09feeac71c3ff$export$d72c7bf8eef50853 extends $43f09feeac71c3ff$export$ecd1fc136c422448 {
    constructor(...args){
        super(...args), this._serializers = {
            MsgPack: $43f09feeac71c3ff$export$80f5de1a66c4d624,
            default: $43f09feeac71c3ff$export$80f5de1a66c4d624
        };
    }
}
var $43f09feeac71c3ff$export$2e2bcd8739ae039 = $43f09feeac71c3ff$export$ecd1fc136c422448;


/*
 jquery-qrcode v0.14.0 - https://larsjung.de/jquery-qrcode/ */ 'use strict';
let $0929d12b0e7ce7ee$var$G = null;
class $0929d12b0e7ce7ee$var$H {
}
$0929d12b0e7ce7ee$var$H.render = function(w, B) {
    $0929d12b0e7ce7ee$var$G(w, B);
};
self.QrCreator = $0929d12b0e7ce7ee$var$H;
(function(w) {
    function B(t, c, a, e) {
        var b = {}, h = w(a, c);
        h.u(t);
        h.J();
        e = e || 0;
        var r = h.h(), d = h.h() + 2 * e;
        b.text = t;
        b.level = c;
        b.version = a;
        b.O = d;
        b.a = function(b, a) {
            b -= e;
            a -= e;
            return 0 > b || b >= r || 0 > a || a >= r ? !1 : h.a(b, a);
        };
        return b;
    }
    function C(t, c, a, e, b, h, r, d, g, x) {
        function u(b, a, f, c, d, r, g) {
            b ? (t.lineTo(a + r, f + g), t.arcTo(a, f, c, d, h)) : t.lineTo(a, f);
        }
        r ? t.moveTo(c + h, a) : t.moveTo(c, a);
        u(d, e, a, e, b, -h, 0);
        u(g, e, b, c, b, 0, -h);
        u(x, c, b, c, a, h, 0);
        u(r, c, a, e, a, 0, h);
    }
    function z(t, c, a, e, b, h, r, d, g, x) {
        function u(b, a, c, d) {
            t.moveTo(b + c, a);
            t.lineTo(b, a);
            t.lineTo(b, a + d);
            t.arcTo(b, a, b + c, a, h);
        }
        r && u(c, a, h, h);
        d && u(e, a, -h, h);
        g && u(e, b, -h, -h);
        x && u(c, b, h, -h);
    }
    function A(t, c) {
        var a = c.fill;
        if ("string" === typeof a) t.fillStyle = a;
        else {
            var e = a.type, b = a.colorStops;
            a = a.position.map((b)=>Math.round(b * c.size));
            if ("linear-gradient" === e) var h = t.createLinearGradient.apply(t, a);
            else if ("radial-gradient" === e) h = t.createRadialGradient.apply(t, a);
            else throw Error("Unsupported fill");
            b.forEach(([b, a])=>{
                h.addColorStop(b, a);
            });
            t.fillStyle = h;
        }
    }
    function y(t, c) {
        a: {
            var a = c.text, e = c.v, b = c.N, h = c.K, r = c.P;
            b = Math.max(1, b || 1);
            for(h = Math.min(40, h || 40); b <= h; b += 1)try {
                var d = B(a, e, b, r);
                break a;
            } catch (J) {}
            d = void 0;
        }
        if (!d) return null;
        a = t.getContext("2d");
        c.background && (a.fillStyle = c.background, a.fillRect(c.left, c.top, c.size, c.size));
        e = d.O;
        h = c.size / e;
        a.beginPath();
        for(r = 0; r < e; r += 1)for(b = 0; b < e; b += 1){
            var g = a, x = c.left + b * h, u = c.top + r * h, p = r, q = b, f = d.a, k = x + h, m = u + h, D = p - 1, E = p + 1, n = q - 1, l = q + 1, y = Math.floor(Math.min(.5, Math.max(0, c.R)) * h), v = f(p, q), I = f(D, n), w = f(D, q);
            D = f(D, l);
            var F = f(p, l);
            l = f(E, l);
            q = f(E, q);
            E = f(E, n);
            p = f(p, n);
            x = Math.round(x);
            u = Math.round(u);
            k = Math.round(k);
            m = Math.round(m);
            v ? C(g, x, u, k, m, y, !w && !p, !w && !F, !q && !F, !q && !p) : z(g, x, u, k, m, y, w && p && I, w && F && D, q && F && l, q && p && E);
        }
        A(a, c);
        a.fill();
        return t;
    }
    var v = {
        minVersion: 1,
        maxVersion: 40,
        ecLevel: "L",
        left: 0,
        top: 0,
        size: 200,
        fill: "#000",
        background: null,
        text: "no text",
        radius: .5,
        quiet: 0
    };
    $0929d12b0e7ce7ee$var$G = function(t, c) {
        var a = {};
        Object.assign(a, v, t);
        a.N = a.minVersion;
        a.K = a.maxVersion;
        a.v = a.ecLevel;
        a.left = a.left;
        a.top = a.top;
        a.size = a.size;
        a.fill = a.fill;
        a.background = a.background;
        a.text = a.text;
        a.R = a.radius;
        a.P = a.quiet;
        if (c instanceof HTMLCanvasElement) {
            if (c.width !== a.size || c.height !== a.size) c.width = a.size, c.height = a.size;
            c.getContext("2d").clearRect(0, 0, c.width, c.height);
            y(c, a);
        } else t = document.createElement("canvas"), t.width = a.size, t.height = a.size, a = y(t, a), c.appendChild(a);
    };
})(function() {
    function w(c) {
        var a = C.s(c);
        return {
            S: function() {
                return 4;
            },
            b: function() {
                return a.length;
            },
            write: function(c) {
                for(var b = 0; b < a.length; b += 1)c.put(a[b], 8);
            }
        };
    }
    function B() {
        var c = [], a = 0, e = {
            B: function() {
                return c;
            },
            c: function(b) {
                return 1 == (c[Math.floor(b / 8)] >>> 7 - b % 8 & 1);
            },
            put: function(b, h) {
                for(var a = 0; a < h; a += 1)e.m(1 == (b >>> h - a - 1 & 1));
            },
            f: function() {
                return a;
            },
            m: function(b) {
                var h = Math.floor(a / 8);
                c.length <= h && c.push(0);
                b && (c[h] |= 128 >>> a % 8);
                a += 1;
            }
        };
        return e;
    }
    function C(c, a) {
        function e(b, h) {
            for(var a = -1; 7 >= a; a += 1)if (!(-1 >= b + a || d <= b + a)) for(var c = -1; 7 >= c; c += 1)-1 >= h + c || d <= h + c || (r[b + a][h + c] = 0 <= a && 6 >= a && (0 == c || 6 == c) || 0 <= c && 6 >= c && (0 == a || 6 == a) || 2 <= a && 4 >= a && 2 <= c && 4 >= c ? !0 : !1);
        }
        function b(b, a) {
            for(var f = d = 4 * c + 17, k = Array(f), m = 0; m < f; m += 1){
                k[m] = Array(f);
                for(var p = 0; p < f; p += 1)k[m][p] = null;
            }
            r = k;
            e(0, 0);
            e(d - 7, 0);
            e(0, d - 7);
            f = y.G(c);
            for(k = 0; k < f.length; k += 1)for(m = 0; m < f.length; m += 1){
                p = f[k];
                var q = f[m];
                if (null == r[p][q]) for(var n = -2; 2 >= n; n += 1)for(var l = -2; 2 >= l; l += 1)r[p + n][q + l] = -2 == n || 2 == n || -2 == l || 2 == l || 0 == n && 0 == l;
            }
            for(f = 8; f < d - 8; f += 1)null == r[f][6] && (r[f][6] = 0 == f % 2);
            for(f = 8; f < d - 8; f += 1)null == r[6][f] && (r[6][f] = 0 == f % 2);
            f = y.w(h << 3 | a);
            for(k = 0; 15 > k; k += 1)m = !b && 1 == (f >> k & 1), r[6 > k ? k : 8 > k ? k + 1 : d - 15 + k][8] = m, r[8][8 > k ? d - k - 1 : 9 > k ? 15 - k : 14 - k] = m;
            r[d - 8][8] = !b;
            if (7 <= c) {
                f = y.A(c);
                for(k = 0; 18 > k; k += 1)m = !b && 1 == (f >> k & 1), r[Math.floor(k / 3)][k % 3 + d - 8 - 3] = m;
                for(k = 0; 18 > k; k += 1)m = !b && 1 == (f >> k & 1), r[k % 3 + d - 8 - 3][Math.floor(k / 3)] = m;
            }
            if (null == g) {
                b = t.I(c, h);
                f = B();
                for(k = 0; k < x.length; k += 1)m = x[k], f.put(4, 4), f.put(m.b(), y.f(4, c)), m.write(f);
                for(k = m = 0; k < b.length; k += 1)m += b[k].j;
                if (f.f() > 8 * m) throw Error("code length overflow. (" + f.f() + ">" + 8 * m + ")");
                for(f.f() + 4 <= 8 * m && f.put(0, 4); 0 != f.f() % 8;)f.m(!1);
                for(; !(f.f() >= 8 * m);){
                    f.put(236, 8);
                    if (f.f() >= 8 * m) break;
                    f.put(17, 8);
                }
                var u = 0;
                m = k = 0;
                p = Array(b.length);
                q = Array(b.length);
                for(n = 0; n < b.length; n += 1){
                    var v = b[n].j, w = b[n].o - v;
                    k = Math.max(k, v);
                    m = Math.max(m, w);
                    p[n] = Array(v);
                    for(l = 0; l < p[n].length; l += 1)p[n][l] = 255 & f.B()[l + u];
                    u += v;
                    l = y.C(w);
                    v = z(p[n], l.b() - 1).l(l);
                    q[n] = Array(l.b() - 1);
                    for(l = 0; l < q[n].length; l += 1)w = l + v.b() - q[n].length, q[n][l] = 0 <= w ? v.c(w) : 0;
                }
                for(l = f = 0; l < b.length; l += 1)f += b[l].o;
                f = Array(f);
                for(l = u = 0; l < k; l += 1)for(n = 0; n < b.length; n += 1)l < p[n].length && (f[u] = p[n][l], u += 1);
                for(l = 0; l < m; l += 1)for(n = 0; n < b.length; n += 1)l < q[n].length && (f[u] = q[n][l], u += 1);
                g = f;
            }
            b = g;
            f = -1;
            k = d - 1;
            m = 7;
            p = 0;
            a = y.F(a);
            for(q = d - 1; 0 < q; q -= 2)for(6 == q && --q;;){
                for(n = 0; 2 > n; n += 1)null == r[k][q - n] && (l = !1, p < b.length && (l = 1 == (b[p] >>> m & 1)), a(k, q - n) && (l = !l), r[k][q - n] = l, --m, -1 == m && (p += 1, m = 7));
                k += f;
                if (0 > k || d <= k) {
                    k -= f;
                    f = -f;
                    break;
                }
            }
        }
        var h = A[a], r = null, d = 0, g = null, x = [], u = {
            u: function(b) {
                b = w(b);
                x.push(b);
                g = null;
            },
            a: function(b, a) {
                if (0 > b || d <= b || 0 > a || d <= a) throw Error(b + "," + a);
                return r[b][a];
            },
            h: function() {
                return d;
            },
            J: function() {
                for(var a = 0, h = 0, c = 0; 8 > c; c += 1){
                    b(!0, c);
                    var d = y.D(u);
                    if (0 == c || a > d) a = d, h = c;
                }
                b(!1, h);
            }
        };
        return u;
    }
    function z(c, a) {
        if ("undefined" == typeof c.length) throw Error(c.length + "/" + a);
        var e = function() {
            for(var b = 0; b < c.length && 0 == c[b];)b += 1;
            for(var r = Array(c.length - b + a), d = 0; d < c.length - b; d += 1)r[d] = c[d + b];
            return r;
        }(), b = {
            c: function(b) {
                return e[b];
            },
            b: function() {
                return e.length;
            },
            multiply: function(a) {
                for(var h = Array(b.b() + a.b() - 1), c = 0; c < b.b(); c += 1)for(var g = 0; g < a.b(); g += 1)h[c + g] ^= v.i(v.g(b.c(c)) + v.g(a.c(g)));
                return z(h, 0);
            },
            l: function(a) {
                if (0 > b.b() - a.b()) return b;
                for(var c = v.g(b.c(0)) - v.g(a.c(0)), h = Array(b.b()), g = 0; g < b.b(); g += 1)h[g] = b.c(g);
                for(g = 0; g < a.b(); g += 1)h[g] ^= v.i(v.g(a.c(g)) + c);
                return z(h, 0).l(a);
            }
        };
        return b;
    }
    C.s = function(c) {
        for(var a = [], e = 0; e < c.length; e++){
            var b = c.charCodeAt(e);
            128 > b ? a.push(b) : 2048 > b ? a.push(192 | b >> 6, 128 | b & 63) : 55296 > b || 57344 <= b ? a.push(224 | b >> 12, 128 | b >> 6 & 63, 128 | b & 63) : (e++, b = 65536 + ((b & 1023) << 10 | c.charCodeAt(e) & 1023), a.push(240 | b >> 18, 128 | b >> 12 & 63, 128 | b >> 6 & 63, 128 | b & 63));
        }
        return a;
    };
    var A = {
        L: 1,
        M: 0,
        Q: 3,
        H: 2
    }, y = function() {
        function c(b) {
            for(var a = 0; 0 != b;)a += 1, b >>>= 1;
            return a;
        }
        var a = [
            [],
            [
                6,
                18
            ],
            [
                6,
                22
            ],
            [
                6,
                26
            ],
            [
                6,
                30
            ],
            [
                6,
                34
            ],
            [
                6,
                22,
                38
            ],
            [
                6,
                24,
                42
            ],
            [
                6,
                26,
                46
            ],
            [
                6,
                28,
                50
            ],
            [
                6,
                30,
                54
            ],
            [
                6,
                32,
                58
            ],
            [
                6,
                34,
                62
            ],
            [
                6,
                26,
                46,
                66
            ],
            [
                6,
                26,
                48,
                70
            ],
            [
                6,
                26,
                50,
                74
            ],
            [
                6,
                30,
                54,
                78
            ],
            [
                6,
                30,
                56,
                82
            ],
            [
                6,
                30,
                58,
                86
            ],
            [
                6,
                34,
                62,
                90
            ],
            [
                6,
                28,
                50,
                72,
                94
            ],
            [
                6,
                26,
                50,
                74,
                98
            ],
            [
                6,
                30,
                54,
                78,
                102
            ],
            [
                6,
                28,
                54,
                80,
                106
            ],
            [
                6,
                32,
                58,
                84,
                110
            ],
            [
                6,
                30,
                58,
                86,
                114
            ],
            [
                6,
                34,
                62,
                90,
                118
            ],
            [
                6,
                26,
                50,
                74,
                98,
                122
            ],
            [
                6,
                30,
                54,
                78,
                102,
                126
            ],
            [
                6,
                26,
                52,
                78,
                104,
                130
            ],
            [
                6,
                30,
                56,
                82,
                108,
                134
            ],
            [
                6,
                34,
                60,
                86,
                112,
                138
            ],
            [
                6,
                30,
                58,
                86,
                114,
                142
            ],
            [
                6,
                34,
                62,
                90,
                118,
                146
            ],
            [
                6,
                30,
                54,
                78,
                102,
                126,
                150
            ],
            [
                6,
                24,
                50,
                76,
                102,
                128,
                154
            ],
            [
                6,
                28,
                54,
                80,
                106,
                132,
                158
            ],
            [
                6,
                32,
                58,
                84,
                110,
                136,
                162
            ],
            [
                6,
                26,
                54,
                82,
                110,
                138,
                166
            ],
            [
                6,
                30,
                58,
                86,
                114,
                142,
                170
            ]
        ], e = {
            w: function(b) {
                for(var a = b << 10; 0 <= c(a) - c(1335);)a ^= 1335 << c(a) - c(1335);
                return (b << 10 | a) ^ 21522;
            },
            A: function(b) {
                for(var a = b << 12; 0 <= c(a) - c(7973);)a ^= 7973 << c(a) - c(7973);
                return b << 12 | a;
            },
            G: function(b) {
                return a[b - 1];
            },
            F: function(b) {
                switch(b){
                    case 0:
                        return function(b, a) {
                            return 0 == (b + a) % 2;
                        };
                    case 1:
                        return function(b) {
                            return 0 == b % 2;
                        };
                    case 2:
                        return function(b, a) {
                            return 0 == a % 3;
                        };
                    case 3:
                        return function(b, a) {
                            return 0 == (b + a) % 3;
                        };
                    case 4:
                        return function(b, a) {
                            return 0 == (Math.floor(b / 2) + Math.floor(a / 3)) % 2;
                        };
                    case 5:
                        return function(b, a) {
                            return 0 == b * a % 2 + b * a % 3;
                        };
                    case 6:
                        return function(b, a) {
                            return 0 == (b * a % 2 + b * a % 3) % 2;
                        };
                    case 7:
                        return function(b, a) {
                            return 0 == (b * a % 3 + (b + a) % 2) % 2;
                        };
                    default:
                        throw Error("bad maskPattern:" + b);
                }
            },
            C: function(b) {
                for(var a = z([
                    1
                ], 0), c = 0; c < b; c += 1)a = a.multiply(z([
                    1,
                    v.i(c)
                ], 0));
                return a;
            },
            f: function(b, a) {
                if (4 != b || 1 > a || 40 < a) throw Error("mode: " + b + "; type: " + a);
                return 10 > a ? 8 : 16;
            },
            D: function(b) {
                for(var a = b.h(), c = 0, d = 0; d < a; d += 1)for(var g = 0; g < a; g += 1){
                    for(var e = 0, t = b.a(d, g), p = -1; 1 >= p; p += 1)if (!(0 > d + p || a <= d + p)) for(var q = -1; 1 >= q; q += 1)0 > g + q || a <= g + q || (0 != p || 0 != q) && t == b.a(d + p, g + q) && (e += 1);
                    5 < e && (c += 3 + e - 5);
                }
                for(d = 0; d < a - 1; d += 1)for(g = 0; g < a - 1; g += 1)if (e = 0, b.a(d, g) && (e += 1), b.a(d + 1, g) && (e += 1), b.a(d, g + 1) && (e += 1), b.a(d + 1, g + 1) && (e += 1), 0 == e || 4 == e) c += 3;
                for(d = 0; d < a; d += 1)for(g = 0; g < a - 6; g += 1)b.a(d, g) && !b.a(d, g + 1) && b.a(d, g + 2) && b.a(d, g + 3) && b.a(d, g + 4) && !b.a(d, g + 5) && b.a(d, g + 6) && (c += 40);
                for(g = 0; g < a; g += 1)for(d = 0; d < a - 6; d += 1)b.a(d, g) && !b.a(d + 1, g) && b.a(d + 2, g) && b.a(d + 3, g) && b.a(d + 4, g) && !b.a(d + 5, g) && b.a(d + 6, g) && (c += 40);
                for(g = e = 0; g < a; g += 1)for(d = 0; d < a; d += 1)b.a(d, g) && (e += 1);
                return c += Math.abs(100 * e / a / a - 50) / 5 * 10;
            }
        };
        return e;
    }(), v = function() {
        for(var c = Array(256), a = Array(256), e = 0; 8 > e; e += 1)c[e] = 1 << e;
        for(e = 8; 256 > e; e += 1)c[e] = c[e - 4] ^ c[e - 5] ^ c[e - 6] ^ c[e - 8];
        for(e = 0; 255 > e; e += 1)a[c[e]] = e;
        return {
            g: function(b) {
                if (1 > b) throw Error("glog(" + b + ")");
                return a[b];
            },
            i: function(b) {
                for(; 0 > b;)b += 255;
                for(; 256 <= b;)b -= 255;
                return c[b];
            }
        };
    }(), t = function() {
        function c(b, c) {
            switch(c){
                case A.L:
                    return a[4 * (b - 1)];
                case A.M:
                    return a[4 * (b - 1) + 1];
                case A.Q:
                    return a[4 * (b - 1) + 2];
                case A.H:
                    return a[4 * (b - 1) + 3];
            }
        }
        var a = [
            [
                1,
                26,
                19
            ],
            [
                1,
                26,
                16
            ],
            [
                1,
                26,
                13
            ],
            [
                1,
                26,
                9
            ],
            [
                1,
                44,
                34
            ],
            [
                1,
                44,
                28
            ],
            [
                1,
                44,
                22
            ],
            [
                1,
                44,
                16
            ],
            [
                1,
                70,
                55
            ],
            [
                1,
                70,
                44
            ],
            [
                2,
                35,
                17
            ],
            [
                2,
                35,
                13
            ],
            [
                1,
                100,
                80
            ],
            [
                2,
                50,
                32
            ],
            [
                2,
                50,
                24
            ],
            [
                4,
                25,
                9
            ],
            [
                1,
                134,
                108
            ],
            [
                2,
                67,
                43
            ],
            [
                2,
                33,
                15,
                2,
                34,
                16
            ],
            [
                2,
                33,
                11,
                2,
                34,
                12
            ],
            [
                2,
                86,
                68
            ],
            [
                4,
                43,
                27
            ],
            [
                4,
                43,
                19
            ],
            [
                4,
                43,
                15
            ],
            [
                2,
                98,
                78
            ],
            [
                4,
                49,
                31
            ],
            [
                2,
                32,
                14,
                4,
                33,
                15
            ],
            [
                4,
                39,
                13,
                1,
                40,
                14
            ],
            [
                2,
                121,
                97
            ],
            [
                2,
                60,
                38,
                2,
                61,
                39
            ],
            [
                4,
                40,
                18,
                2,
                41,
                19
            ],
            [
                4,
                40,
                14,
                2,
                41,
                15
            ],
            [
                2,
                146,
                116
            ],
            [
                3,
                58,
                36,
                2,
                59,
                37
            ],
            [
                4,
                36,
                16,
                4,
                37,
                17
            ],
            [
                4,
                36,
                12,
                4,
                37,
                13
            ],
            [
                2,
                86,
                68,
                2,
                87,
                69
            ],
            [
                4,
                69,
                43,
                1,
                70,
                44
            ],
            [
                6,
                43,
                19,
                2,
                44,
                20
            ],
            [
                6,
                43,
                15,
                2,
                44,
                16
            ],
            [
                4,
                101,
                81
            ],
            [
                1,
                80,
                50,
                4,
                81,
                51
            ],
            [
                4,
                50,
                22,
                4,
                51,
                23
            ],
            [
                3,
                36,
                12,
                8,
                37,
                13
            ],
            [
                2,
                116,
                92,
                2,
                117,
                93
            ],
            [
                6,
                58,
                36,
                2,
                59,
                37
            ],
            [
                4,
                46,
                20,
                6,
                47,
                21
            ],
            [
                7,
                42,
                14,
                4,
                43,
                15
            ],
            [
                4,
                133,
                107
            ],
            [
                8,
                59,
                37,
                1,
                60,
                38
            ],
            [
                8,
                44,
                20,
                4,
                45,
                21
            ],
            [
                12,
                33,
                11,
                4,
                34,
                12
            ],
            [
                3,
                145,
                115,
                1,
                146,
                116
            ],
            [
                4,
                64,
                40,
                5,
                65,
                41
            ],
            [
                11,
                36,
                16,
                5,
                37,
                17
            ],
            [
                11,
                36,
                12,
                5,
                37,
                13
            ],
            [
                5,
                109,
                87,
                1,
                110,
                88
            ],
            [
                5,
                65,
                41,
                5,
                66,
                42
            ],
            [
                5,
                54,
                24,
                7,
                55,
                25
            ],
            [
                11,
                36,
                12,
                7,
                37,
                13
            ],
            [
                5,
                122,
                98,
                1,
                123,
                99
            ],
            [
                7,
                73,
                45,
                3,
                74,
                46
            ],
            [
                15,
                43,
                19,
                2,
                44,
                20
            ],
            [
                3,
                45,
                15,
                13,
                46,
                16
            ],
            [
                1,
                135,
                107,
                5,
                136,
                108
            ],
            [
                10,
                74,
                46,
                1,
                75,
                47
            ],
            [
                1,
                50,
                22,
                15,
                51,
                23
            ],
            [
                2,
                42,
                14,
                17,
                43,
                15
            ],
            [
                5,
                150,
                120,
                1,
                151,
                121
            ],
            [
                9,
                69,
                43,
                4,
                70,
                44
            ],
            [
                17,
                50,
                22,
                1,
                51,
                23
            ],
            [
                2,
                42,
                14,
                19,
                43,
                15
            ],
            [
                3,
                141,
                113,
                4,
                142,
                114
            ],
            [
                3,
                70,
                44,
                11,
                71,
                45
            ],
            [
                17,
                47,
                21,
                4,
                48,
                22
            ],
            [
                9,
                39,
                13,
                16,
                40,
                14
            ],
            [
                3,
                135,
                107,
                5,
                136,
                108
            ],
            [
                3,
                67,
                41,
                13,
                68,
                42
            ],
            [
                15,
                54,
                24,
                5,
                55,
                25
            ],
            [
                15,
                43,
                15,
                10,
                44,
                16
            ],
            [
                4,
                144,
                116,
                4,
                145,
                117
            ],
            [
                17,
                68,
                42
            ],
            [
                17,
                50,
                22,
                6,
                51,
                23
            ],
            [
                19,
                46,
                16,
                6,
                47,
                17
            ],
            [
                2,
                139,
                111,
                7,
                140,
                112
            ],
            [
                17,
                74,
                46
            ],
            [
                7,
                54,
                24,
                16,
                55,
                25
            ],
            [
                34,
                37,
                13
            ],
            [
                4,
                151,
                121,
                5,
                152,
                122
            ],
            [
                4,
                75,
                47,
                14,
                76,
                48
            ],
            [
                11,
                54,
                24,
                14,
                55,
                25
            ],
            [
                16,
                45,
                15,
                14,
                46,
                16
            ],
            [
                6,
                147,
                117,
                4,
                148,
                118
            ],
            [
                6,
                73,
                45,
                14,
                74,
                46
            ],
            [
                11,
                54,
                24,
                16,
                55,
                25
            ],
            [
                30,
                46,
                16,
                2,
                47,
                17
            ],
            [
                8,
                132,
                106,
                4,
                133,
                107
            ],
            [
                8,
                75,
                47,
                13,
                76,
                48
            ],
            [
                7,
                54,
                24,
                22,
                55,
                25
            ],
            [
                22,
                45,
                15,
                13,
                46,
                16
            ],
            [
                10,
                142,
                114,
                2,
                143,
                115
            ],
            [
                19,
                74,
                46,
                4,
                75,
                47
            ],
            [
                28,
                50,
                22,
                6,
                51,
                23
            ],
            [
                33,
                46,
                16,
                4,
                47,
                17
            ],
            [
                8,
                152,
                122,
                4,
                153,
                123
            ],
            [
                22,
                73,
                45,
                3,
                74,
                46
            ],
            [
                8,
                53,
                23,
                26,
                54,
                24
            ],
            [
                12,
                45,
                15,
                28,
                46,
                16
            ],
            [
                3,
                147,
                117,
                10,
                148,
                118
            ],
            [
                3,
                73,
                45,
                23,
                74,
                46
            ],
            [
                4,
                54,
                24,
                31,
                55,
                25
            ],
            [
                11,
                45,
                15,
                31,
                46,
                16
            ],
            [
                7,
                146,
                116,
                7,
                147,
                117
            ],
            [
                21,
                73,
                45,
                7,
                74,
                46
            ],
            [
                1,
                53,
                23,
                37,
                54,
                24
            ],
            [
                19,
                45,
                15,
                26,
                46,
                16
            ],
            [
                5,
                145,
                115,
                10,
                146,
                116
            ],
            [
                19,
                75,
                47,
                10,
                76,
                48
            ],
            [
                15,
                54,
                24,
                25,
                55,
                25
            ],
            [
                23,
                45,
                15,
                25,
                46,
                16
            ],
            [
                13,
                145,
                115,
                3,
                146,
                116
            ],
            [
                2,
                74,
                46,
                29,
                75,
                47
            ],
            [
                42,
                54,
                24,
                1,
                55,
                25
            ],
            [
                23,
                45,
                15,
                28,
                46,
                16
            ],
            [
                17,
                145,
                115
            ],
            [
                10,
                74,
                46,
                23,
                75,
                47
            ],
            [
                10,
                54,
                24,
                35,
                55,
                25
            ],
            [
                19,
                45,
                15,
                35,
                46,
                16
            ],
            [
                17,
                145,
                115,
                1,
                146,
                116
            ],
            [
                14,
                74,
                46,
                21,
                75,
                47
            ],
            [
                29,
                54,
                24,
                19,
                55,
                25
            ],
            [
                11,
                45,
                15,
                46,
                46,
                16
            ],
            [
                13,
                145,
                115,
                6,
                146,
                116
            ],
            [
                14,
                74,
                46,
                23,
                75,
                47
            ],
            [
                44,
                54,
                24,
                7,
                55,
                25
            ],
            [
                59,
                46,
                16,
                1,
                47,
                17
            ],
            [
                12,
                151,
                121,
                7,
                152,
                122
            ],
            [
                12,
                75,
                47,
                26,
                76,
                48
            ],
            [
                39,
                54,
                24,
                14,
                55,
                25
            ],
            [
                22,
                45,
                15,
                41,
                46,
                16
            ],
            [
                6,
                151,
                121,
                14,
                152,
                122
            ],
            [
                6,
                75,
                47,
                34,
                76,
                48
            ],
            [
                46,
                54,
                24,
                10,
                55,
                25
            ],
            [
                2,
                45,
                15,
                64,
                46,
                16
            ],
            [
                17,
                152,
                122,
                4,
                153,
                123
            ],
            [
                29,
                74,
                46,
                14,
                75,
                47
            ],
            [
                49,
                54,
                24,
                10,
                55,
                25
            ],
            [
                24,
                45,
                15,
                46,
                46,
                16
            ],
            [
                4,
                152,
                122,
                18,
                153,
                123
            ],
            [
                13,
                74,
                46,
                32,
                75,
                47
            ],
            [
                48,
                54,
                24,
                14,
                55,
                25
            ],
            [
                42,
                45,
                15,
                32,
                46,
                16
            ],
            [
                20,
                147,
                117,
                4,
                148,
                118
            ],
            [
                40,
                75,
                47,
                7,
                76,
                48
            ],
            [
                43,
                54,
                24,
                22,
                55,
                25
            ],
            [
                10,
                45,
                15,
                67,
                46,
                16
            ],
            [
                19,
                148,
                118,
                6,
                149,
                119
            ],
            [
                18,
                75,
                47,
                31,
                76,
                48
            ],
            [
                34,
                54,
                24,
                34,
                55,
                25
            ],
            [
                20,
                45,
                15,
                61,
                46,
                16
            ]
        ], e = {
            I: function(b, a) {
                var e = c(b, a);
                if ("undefined" == typeof e) throw Error("bad rs block @ typeNumber:" + b + "/errorCorrectLevel:" + a);
                b = e.length / 3;
                a = [];
                for(var d = 0; d < b; d += 1)for(var g = e[3 * d], h = e[3 * d + 1], t = e[3 * d + 2], p = 0; p < g; p += 1){
                    var q = t, f = {};
                    f.o = h;
                    f.j = q;
                    a.push(f);
                }
                return a;
            }
        };
        return e;
    }();
    return C;
}());
var $0929d12b0e7ce7ee$export$2e2bcd8739ae039 = QrCreator;


// Lightweight, dependency-free i18n for the app UI.
//
// - Locale comes from the URL path prefix the build emits (/de/, /nl/, ...) when
//   there is one, otherwise it's auto-detected from the browser
//   (navigator.languages), matched by primary subtag against the supported set,
//   falling back to English. The path wins so a visitor arriving on an indexed
//   localized URL sees the language that URL claims to be.
// - Static markup is translated by tagging elements with data-i18n* attributes
//   and calling applyDom(); dynamic strings use t()/tCount() at runtime.
// - Plurals use Intl.PluralRules so each locale picks the right form.
//
// A ?lang=xx query param overrides detection (handy for testing without
// changing OS/browser settings). There is intentionally no in-app switcher.
const $03c039b69e20a322$export$4c4b683c586ca56e = [
    'en',
    'es',
    'fr',
    'de',
    'pt',
    'nl'
];
const $03c039b69e20a322$export$1af4c7e47ad72f44 = 'en';
const $03c039b69e20a322$export$defe85febe8b728c = {
    en: {
        'common.copyLink': 'Copy link',
        'common.reset': 'Reset',
        'common.back': 'Back',
        'common.retry': 'Retry',
        'common.copied': 'Copied!',
        'common.gotIt': 'Got it',
        'common.close': 'Close',
        'resume.button': 'Resume watching',
        'role.host': 'Baby monitor',
        'role.parent': 'Parent',
        'safety.badge': 'Safe & secure.',
        'safety.why': 'Why?',
        'intro.short': 'Choose what this device becomes: baby monitor beside your child, or parent screen to watch from.',
        'intro.medium': 'A baby monitor in your browser, with no app or account. Pick Baby monitor for the device beside your child, or Parent to watch from. Scan the QR code to link them.',
        'intro.long.title': 'How Peekababy works',
        'intro.long.p1': 'Open peekababy.app on two devices. Choose Baby monitor beside your child, and Parent on the device you watch from.',
        'intro.long.p2': 'Scan the QR code to link them. No app or account, and the connection is encrypted.',
        'connect.status': 'This phone is now your baby monitor. Scan the QR code on another device to watch.',
        'hostStatus.waiting': "Waiting for a parent\u2026",
        'hostStatus.count.one': '{count} parent watching',
        'hostStatus.count.other': '{count} parents watching',
        'scan.hint': 'Point your camera at the QR code shown on the baby monitor.',
        'scan.openCamera': 'Open camera',
        'scan.scanning': "Scanning\u2026",
        'scan.cameraNeeded': 'Camera access is needed to scan the code.',
        'status.connecting': "Connecting\u2026",
        'status.connected': 'Connected',
        'status.live': 'Live',
        'status.reconnecting': "Reconnecting\u2026",
        'status.notFound': "Can\u2019t reach this monitor. Check the link or scan again.",
        'reconnect.title': "Reconnecting\u2026",
        'reconnect.hint': 'Connection interrupted. Restoring the live view.',
        'status.cameraStopped': 'Camera stopped',
        'cameraFrozen.title': 'Monitor camera stopped',
        'cameraFrozen.hint': 'The picture is frozen, but the connection is fine. Waiting for the camera to resume.',
        'sound.quiet': 'Quiet',
        'sound.none': 'No sound yet',
        'sound.level.low': 'Low',
        'sound.level.medium': 'Medium',
        'sound.level.loud': 'Loud',
        'sound.past.low': 'Was low',
        'sound.past.medium': 'Was medium',
        'sound.past.loud': 'Was loud',
        'sound.ago': '{time} ago',
        'install.text': 'Works better when installed',
        'install.action': 'Install',
        'install.dismiss': 'Dismiss',
        'install.iosHint': "Install: tap Share, then \u201CAdd to Home Screen\u201D",
        'update.available': 'A new version is available',
        'update.action': 'Refresh',
        'toolbar.switch': 'Switch',
        'toolbar.switchAria': 'Switch camera',
        'toolbar.screen': 'Screen',
        'toolbar.screenAria': 'Dim screen to save battery',
        'toolbar.addParent': 'Add parent',
        'toolbar.addParentAria': 'Add another parent',
        'toolbar.melody': 'Melody',
        'toolbar.melodyAria': 'Play a soothing melody for your baby',
        'melody.playing': 'Lullaby playing',
        'melody.alertsPaused': 'Cry alerts paused',
        'battery.low': 'Monitor battery low',
        'battery.level': '{level}% left',
        'toolbar.sound': 'Sound',
        'toolbar.soundAria': 'Toggle sound',
        'toolbar.talk': 'Talk',
        'toolbar.talkAria': 'Hold to talk',
        'toolbar.alerts': 'Alerts',
        'toolbar.alertsAria': 'Sound alerts when the app is closed',
        'toolbar.invite': 'Invite',
        'toolbar.inviteAria': 'Invite another parent',
        'toolbar.fill': 'Fill',
        'toolbar.fit': 'Fit',
        'toolbar.frameAria': 'Fit or fill the screen',
        'safety.title': 'Private & secure by design',
        'safety.item1': 'Video and audio travel <strong>directly</strong> between your two devices: peer-to-peer, encrypted end to end (WebRTC / DTLS-SRTP).',
        'safety.item2': "No account, no sign-up, nothing stored on a server. There's no recording anywhere.",
        'safety.item3': 'The connection link is a random one-time id: only a device that scans your QR can watch.',
        'safety.author': "Built by Harm Jan L. \u2192",
        'safety.melodyCredit': 'Melody by <a href="https://pixabay.com/users/alex-morgan/" target="_blank" rel="noopener noreferrer">Alex Morgan</a> from <a href="https://pixabay.com/" target="_blank" rel="noopener noreferrer">Pixabay</a>',
        'invite.title': 'Invite another parent',
        'invite.sub': 'Let someone else watch too: they scan this code or open the link.',
        'videoOff.status': 'Streaming, screen dimmed to save battery',
        'videoOff.hint': 'Tap anywhere to show the picture',
        'error.camera.denied': 'Allow camera & microphone access in your browser settings, then try again.',
        'error.camera.busy': 'Your camera is in use by another app. Close it and try again.',
        'error.camera.notFound': 'No camera found. Connect one and try again.',
        'error.camera.generic': "Couldn't start your camera. Please try again.",
        'error.connection': 'Connection failed. Check your internet and try again.',
        'alerts.enabled': "Alerts on. You'll be notified even when the app is closed.",
        'alerts.disabled': 'Alerts off.',
        'alerts.denied': 'Notifications are blocked. Allow them in your browser settings to get alerts.',
        'alerts.unsupported': "This browser can't send background alerts.",
        'alerts.unsupportedIos': 'Add the app to your Home Screen first to get background alerts.',
        'alerts.failed': "Couldn't turn on alerts. Check your connection and try again.",
        'trust.defaultName': 'Parent-{suffix}',
        'trust.newParent': 'A new parent connected',
        'trust.newParentNamed': '{name} connected',
        'trust.allow': 'Always allow',
        'trust.ignore': 'Ignore',
        'trust.manage': 'Trusted parents',
        'trust.title': 'Trusted parents',
        'trust.sub': 'Devices this monitor recognizes connect without a prompt. Remove any you no longer trust.',
        'trust.empty': 'No trusted parents yet.',
        'trust.remove': 'Remove',
        'trust.nameAria': 'Parent name'
    },
    es: {
        'common.copyLink': 'Copiar enlace',
        'common.reset': 'Reiniciar',
        'common.back': "Atr\xe1s",
        'common.retry': 'Reintentar',
        'common.copied': "\xa1Copiado!",
        'common.gotIt': 'Entendido',
        'common.close': 'Cerrar',
        'resume.button': 'Seguir viendo',
        'role.host': "Monitor de beb\xe9",
        'role.parent': 'Padres',
        'safety.badge': 'Seguro y privado.',
        'safety.why': "\xbfPor qu\xe9?",
        'intro.short': "Elige en qu\xe9 se convierte este dispositivo: monitor junto a tu beb\xe9, o pantalla de padres para vigilar.",
        'intro.medium': "Un monitor de beb\xe9 en tu navegador, sin app ni cuenta. Elige Monitor de beb\xe9 para el dispositivo junto a tu beb\xe9, o Padres para vigilar. Escanea el c\xf3digo QR para vincularlos.",
        'intro.long.title': "C\xf3mo funciona Peekababy",
        'intro.long.p1': "Abre peekababy.app en dos dispositivos. Elige Monitor de beb\xe9 junto a tu beb\xe9 y Padres en el dispositivo desde el que vigilas.",
        'intro.long.p2': "Escanea el c\xf3digo QR para vincularlos. Sin app ni cuenta, y la conexi\xf3n est\xe1 cifrada.",
        'connect.status': "Este tel\xe9fono es ahora tu monitor de beb\xe9. Escanea el c\xf3digo QR con otro dispositivo para verlo.",
        'hostStatus.waiting': "Esperando a un padre\u2026",
        'hostStatus.count.one': '{count} padre viendo',
        'hostStatus.count.other': '{count} padres viendo',
        'scan.hint': "Apunta la c\xe1mara al c\xf3digo QR que aparece en el monitor de beb\xe9.",
        'scan.openCamera': "Abrir c\xe1mara",
        'scan.scanning': "Escaneando\u2026",
        'scan.cameraNeeded': "Se necesita acceso a la c\xe1mara para escanear el c\xf3digo.",
        'status.connecting': "Conectando\u2026",
        'status.connected': 'Conectado',
        'status.live': 'En directo',
        'status.reconnecting': "Reconectando\u2026",
        'status.notFound': 'No se puede conectar con el monitor. Revisa el enlace o vuelve a escanear.',
        'reconnect.title': "Reconectando\u2026",
        'reconnect.hint': "Conexi\xf3n interrumpida: restaurando la vista en directo.",
        'status.cameraStopped': "C\xe1mara detenida",
        'cameraFrozen.title': "La c\xe1mara del monitor se detuvo",
        'cameraFrozen.hint': "La imagen est\xe1 congelada, pero la conexi\xf3n funciona. Esperando a que la c\xe1mara se reanude.",
        'sound.quiet': 'Silencio',
        'sound.none': "A\xfan sin sonido",
        'sound.level.low': 'Bajo',
        'sound.level.medium': 'Medio',
        'sound.level.loud': 'Alto',
        'sound.past.low': 'Fue bajo',
        'sound.past.medium': 'Fue medio',
        'sound.past.loud': 'Fue alto',
        'sound.ago': 'hace {time}',
        'install.text': 'Funciona mejor instalada',
        'install.action': 'Instalar',
        'install.dismiss': 'Descartar',
        'install.iosHint': "Instalar: toca Compartir y luego \u201CA\xf1adir a pantalla de inicio\u201D",
        'update.available': "Hay una nueva versi\xf3n disponible",
        'update.action': 'Actualizar',
        'toolbar.switch': 'Cambiar',
        'toolbar.switchAria': "Cambiar c\xe1mara",
        'toolbar.screen': 'Pantalla',
        'toolbar.screenAria': "Atenuar pantalla para ahorrar bater\xeda",
        'toolbar.addParent': "A\xf1adir padre",
        'toolbar.addParentAria': "A\xf1adir otro padre",
        'toolbar.melody': "Melod\xeda",
        'toolbar.melodyAria': "Reproducir una melod\xeda relajante para tu beb\xe9",
        'melody.playing': 'Sonando nana',
        'melody.alertsPaused': 'Alertas de llanto en pausa',
        'battery.low': "Bater\xeda del monitor baja",
        'battery.level': 'Queda {level}%',
        'toolbar.sound': 'Sonido',
        'toolbar.soundAria': 'Activar o silenciar el sonido',
        'toolbar.talk': 'Hablar',
        'toolbar.talkAria': "Mant\xe9n pulsado para hablar",
        'toolbar.alerts': 'Alertas',
        'toolbar.alertsAria': "Alertas sonoras cuando la app est\xe1 cerrada",
        'toolbar.invite': 'Invitar',
        'toolbar.inviteAria': 'Invitar a otro padre',
        'toolbar.fill': 'Llenar',
        'toolbar.fit': 'Ajustar',
        'toolbar.frameAria': 'Ajustar o llenar la pantalla',
        'safety.title': "Privado y seguro por dise\xf1o",
        'safety.item1': "El v\xeddeo y el audio viajan <strong>directamente</strong> entre tus dos dispositivos: de igual a igual, cifrados de extremo a extremo (WebRTC / DTLS-SRTP).",
        'safety.item2': "Sin cuenta, sin registro, nada se guarda en un servidor. No se graba en ning\xfan sitio.",
        'safety.item3': "El enlace de conexi\xf3n es un id \xfanico y aleatorio: solo un dispositivo que escanee tu QR puede ver.",
        'safety.author': "Creado por Harm Jan L. \u2192",
        'safety.melodyCredit': 'Melod\xeda de <a href="https://pixabay.com/users/alex-morgan/" target="_blank" rel="noopener noreferrer">Alex Morgan</a> en <a href="https://pixabay.com/" target="_blank" rel="noopener noreferrer">Pixabay</a>',
        'invite.title': 'Invitar a otro padre',
        'invite.sub': "Deja que otra persona tambi\xe9n mire: escanea este c\xf3digo o abre el enlace.",
        'videoOff.status': "Transmitiendo: pantalla atenuada para ahorrar bater\xeda",
        'videoOff.hint': 'Toca en cualquier parte para mostrar la imagen',
        'error.camera.denied': "Permite el acceso a la c\xe1mara y el micr\xf3fono en los ajustes del navegador e int\xe9ntalo de nuevo.",
        'error.camera.busy': "Otra app est\xe1 usando la c\xe1mara. Ci\xe9rrala e int\xe9ntalo de nuevo.",
        'error.camera.notFound': "No se encontr\xf3 ninguna c\xe1mara. Conecta una e int\xe9ntalo de nuevo.",
        'error.camera.generic': "No se pudo iniciar la c\xe1mara. Int\xe9ntalo de nuevo.",
        'error.connection': "Fallo de conexi\xf3n. Revisa tu conexi\xf3n a internet e int\xe9ntalo de nuevo.",
        'alerts.enabled': "Alertas activadas: te avisaremos aunque la app est\xe9 cerrada.",
        'alerts.disabled': 'Alertas desactivadas.',
        'alerts.denied': "Las notificaciones est\xe1n bloqueadas. Act\xedvalas en los ajustes del navegador.",
        'alerts.unsupported': 'Este navegador no admite alertas en segundo plano.',
        'alerts.unsupportedIos': "A\xf1ade la app a la pantalla de inicio para recibir alertas.",
        'alerts.failed': "No se pudieron activar las alertas. Revisa tu conexi\xf3n e int\xe9ntalo de nuevo.",
        'trust.defaultName': 'Padre-{suffix}',
        'trust.newParent': 'Se ha conectado un nuevo padre',
        'trust.newParentNamed': '{name} se ha conectado',
        'trust.allow': 'Permitir siempre',
        'trust.ignore': 'Ignorar',
        'trust.manage': 'Padres de confianza',
        'trust.title': 'Padres de confianza',
        'trust.sub': 'Los dispositivos que este monitor reconoce se conectan sin aviso. Elimina los que ya no sean de confianza.',
        'trust.empty': "A\xfan no hay padres de confianza.",
        'trust.remove': 'Eliminar',
        'trust.nameAria': 'Nombre del padre'
    },
    fr: {
        'common.copyLink': 'Copier le lien',
        'common.reset': "R\xe9initialiser",
        'common.back': 'Retour',
        'common.retry': "R\xe9essayer",
        'common.copied': "Copi\xe9 !",
        'common.gotIt': 'Compris',
        'common.close': 'Fermer',
        'resume.button': "Continuer \xe0 regarder",
        'role.host': "\xc9coute-b\xe9b\xe9",
        'role.parent': 'Parent',
        'safety.badge': "S\xfbr et s\xe9curis\xe9.",
        'safety.why': 'Pourquoi ?',
        'intro.short': "Choisissez ce que devient cet appareil : \xe9coute-b\xe9b\xe9 pr\xe8s de votre enfant, ou \xe9cran parent pour surveiller.",
        'intro.medium': "Un \xe9coute-b\xe9b\xe9 dans votre navigateur, sans application ni compte. Choisissez \xc9coute-b\xe9b\xe9 pour l\u2019appareil pr\xe8s de votre enfant, ou Parent pour surveiller. Scannez le code QR pour les relier.",
        'intro.long.title': 'Comment fonctionne Peekababy',
        'intro.long.p1': "Ouvrez peekababy.app sur deux appareils. Choisissez \xc9coute-b\xe9b\xe9 pr\xe8s de votre enfant et Parent sur l\u2019appareil depuis lequel vous surveillez.",
        'intro.long.p2': "Scannez le code QR pour les relier. Sans application ni compte, et la connexion est chiffr\xe9e.",
        'connect.status': "Ce t\xe9l\xe9phone est maintenant votre \xe9coute-b\xe9b\xe9. Scannez le code QR avec un autre appareil pour regarder.",
        'hostStatus.waiting': "En attente d\u2019un parent\u2026",
        'hostStatus.count.one': "{count} parent connect\xe9",
        'hostStatus.count.other': "{count} parents connect\xe9s",
        'scan.hint': "Dirigez votre cam\xe9ra vers le code QR affich\xe9 sur l\u2019\xe9coute-b\xe9b\xe9.",
        'scan.openCamera': "Ouvrir la cam\xe9ra",
        'scan.scanning': "Analyse\u2026",
        'scan.cameraNeeded': "L\u2019acc\xe8s \xe0 la cam\xe9ra est n\xe9cessaire pour scanner le code.",
        'status.connecting': "Connexion\u2026",
        'status.connected': "Connect\xe9",
        'status.live': 'En direct',
        'status.reconnecting': "Reconnexion\u2026",
        'status.notFound': "Moniteur injoignable. V\xe9rifiez le lien ou rescannez.",
        'reconnect.title': "Reconnexion\u2026",
        'reconnect.hint': "Connexion interrompue. R\xe9tablissement de la vue en direct.",
        'status.cameraStopped': "Cam\xe9ra arr\xeat\xe9e",
        'cameraFrozen.title': "La cam\xe9ra du moniteur s\u2019est arr\xeat\xe9e",
        'cameraFrozen.hint': "L\u2019image est fig\xe9e, mais la connexion fonctionne. En attente de la reprise de la cam\xe9ra.",
        'sound.quiet': 'Silence',
        'sound.none': 'Pas encore de son',
        'sound.level.low': 'Faible',
        'sound.level.medium': 'Moyen',
        'sound.level.loud': 'Fort',
        'sound.past.low': "\xc9tait faible",
        'sound.past.medium': "\xc9tait moyen",
        'sound.past.loud': "\xc9tait fort",
        'sound.ago': 'il y a {time}',
        'install.text': "Fonctionne mieux une fois install\xe9e",
        'install.action': 'Installer',
        'install.dismiss': 'Fermer',
        'install.iosHint': "Installer : appuyez sur Partager, puis \u201CSur l\u2019\xe9cran d\u2019accueil\u201D",
        'update.available': 'Une nouvelle version est disponible',
        'update.action': 'Actualiser',
        'toolbar.switch': 'Changer',
        'toolbar.switchAria': "Changer de cam\xe9ra",
        'toolbar.screen': "\xc9cran",
        'toolbar.screenAria': "R\xe9duire l\u2019\xe9cran pour \xe9conomiser la batterie",
        'toolbar.addParent': 'Ajouter un parent',
        'toolbar.addParentAria': 'Ajouter un autre parent',
        'toolbar.melody': "M\xe9lodie",
        'toolbar.melodyAria': "Jouer une m\xe9lodie apaisante pour votre b\xe9b\xe9",
        'melody.playing': 'Berceuse en cours',
        'melody.alertsPaused': 'Alertes de pleurs en pause',
        'battery.low': "Batterie de l\u2019\xe9coute-b\xe9b\xe9 faible",
        'battery.level': '{level}% restants',
        'toolbar.sound': 'Son',
        'toolbar.soundAria': 'Activer ou couper le son',
        'toolbar.talk': 'Parler',
        'toolbar.talkAria': 'Maintenir pour parler',
        'toolbar.alerts': 'Alertes',
        'toolbar.alertsAria': "Alertes sonores quand l\u2019appli est ferm\xe9e",
        'toolbar.invite': 'Inviter',
        'toolbar.inviteAria': 'Inviter un autre parent',
        'toolbar.fill': 'Remplir',
        'toolbar.fit': 'Ajuster',
        'toolbar.frameAria': "Ajuster ou remplir l\u2019\xe9cran",
        'safety.title': "Priv\xe9 et s\xe9curis\xe9 par conception",
        'safety.item1': "La vid\xe9o et l\u2019audio circulent <strong>directement</strong> entre vos deux appareils : pair \xe0 pair, chiffr\xe9s de bout en bout (WebRTC / DTLS-SRTP).",
        'safety.item2': "Pas de compte, pas d\u2019inscription, rien n\u2019est stock\xe9 sur un serveur. Aucun enregistrement nulle part.",
        'safety.item3': "Le lien de connexion est un identifiant unique et al\xe9atoire : seul un appareil qui scanne votre QR peut regarder.",
        'safety.author': "Con\xe7u par Harm Jan L. \u2192",
        'safety.melodyCredit': 'M\xe9lodie par <a href="https://pixabay.com/users/alex-morgan/" target="_blank" rel="noopener noreferrer">Alex Morgan</a> sur <a href="https://pixabay.com/" target="_blank" rel="noopener noreferrer">Pixabay</a>',
        'invite.title': 'Inviter un autre parent',
        'invite.sub': "Laissez quelqu\u2019un d\u2019autre regarder aussi : il scanne ce code ou ouvre le lien.",
        'videoOff.status': "Diffusion en cours, \xe9cran att\xe9nu\xe9 pour \xe9conomiser la batterie",
        'videoOff.hint': "Touchez n\u2019importe o\xf9 pour afficher l\u2019image",
        'error.camera.denied': "Autorisez l'acc\xe8s \xe0 la cam\xe9ra et au micro dans les r\xe9glages du navigateur, puis r\xe9essayez.",
        'error.camera.busy': "Une autre appli utilise la cam\xe9ra. Fermez-la et r\xe9essayez.",
        'error.camera.notFound': "Aucune cam\xe9ra d\xe9tect\xe9e. Branchez-en une et r\xe9essayez.",
        'error.camera.generic': "Impossible de d\xe9marrer la cam\xe9ra. R\xe9essayez.",
        'error.connection': "\xc9chec de la connexion. V\xe9rifiez votre connexion internet et r\xe9essayez.",
        'alerts.enabled': "Alertes activ\xe9es : vous serez pr\xe9venu m\xeame quand l\u2019appli est ferm\xe9e.",
        'alerts.disabled': "Alertes d\xe9sactiv\xe9es.",
        'alerts.denied': "Les notifications sont bloqu\xe9es. Autorisez-les dans les r\xe9glages du navigateur.",
        'alerts.unsupported': "Ce navigateur ne prend pas en charge les alertes en arri\xe8re-plan.",
        'alerts.unsupportedIos': "Ajoutez l\u2019appli \xe0 l\u2019\xe9cran d\u2019accueil pour recevoir les alertes.",
        'alerts.failed': "Impossible d\u2019activer les alertes. V\xe9rifiez votre connexion et r\xe9essayez.",
        'trust.defaultName': 'Parent-{suffix}',
        'trust.newParent': "Un nouveau parent s\u2019est connect\xe9",
        'trust.newParentNamed': "{name} s\u2019est connect\xe9",
        'trust.allow': 'Toujours autoriser',
        'trust.ignore': 'Ignorer',
        'trust.manage': 'Parents de confiance',
        'trust.title': 'Parents de confiance',
        'trust.sub': "Les appareils que ce moniteur reconna\xeet se connectent sans demande. Retirez ceux en qui vous n\u2019avez plus confiance.",
        'trust.empty': "Aucun parent de confiance pour l\u2019instant.",
        'trust.remove': 'Retirer',
        'trust.nameAria': 'Nom du parent'
    },
    de: {
        'common.copyLink': 'Link kopieren',
        'common.reset': "Zur\xfccksetzen",
        'common.back': "Zur\xfcck",
        'common.retry': 'Erneut versuchen',
        'common.copied': 'Kopiert!',
        'common.gotIt': 'Verstanden',
        'common.close': "Schlie\xdfen",
        'resume.button': 'Weiter ansehen',
        'role.host': 'Babyphone',
        'role.parent': 'Elternteil',
        'safety.badge': "Sicher & gesch\xfctzt.",
        'safety.why': 'Warum?',
        'intro.short': "W\xe4hle, was dieses Ger\xe4t wird: Babyphone bei deinem Kind oder Elternbildschirm zum Mitschauen.",
        'intro.medium': "Ein Babyphone im Browser, ohne App und ohne Konto. W\xe4hle Babyphone f\xfcr das Ger\xe4t bei deinem Kind oder Elternteil zum Mitschauen. Scanne den QR-Code, um sie zu verbinden.",
        'intro.long.title': 'So funktioniert Peekababy',
        'intro.long.p1': "\xd6ffne peekababy.app auf zwei Ger\xe4ten. W\xe4hle Babyphone beim Kind und Elternteil auf dem Ger\xe4t, auf dem du mitschaust.",
        'intro.long.p2': "Scanne den QR-Code, um sie zu verbinden. Ohne App und Konto, und die Verbindung ist verschl\xfcsselt.",
        'connect.status': "Dieses Telefon ist jetzt dein Babyphone. Scanne den QR-Code mit einem anderen Ger\xe4t, um zuzusehen.",
        'hostStatus.waiting': "Warten auf ein Elternteil\u2026",
        'hostStatus.count.one': '{count} Elternteil sieht zu',
        'hostStatus.count.other': '{count} Eltern sehen zu',
        'scan.hint': 'Richte die Kamera auf den QR-Code, der auf dem Babyphone angezeigt wird.',
        'scan.openCamera': "Kamera \xf6ffnen",
        'scan.scanning': "Scannen\u2026",
        'scan.cameraNeeded': "F\xfcr das Scannen des Codes wird Kamerazugriff ben\xf6tigt.",
        'status.connecting': "Verbinden\u2026",
        'status.connected': 'Verbunden',
        'status.live': 'Live',
        'status.reconnecting': "Neu verbinden\u2026",
        'status.notFound': "Babyphone nicht erreichbar. Link pr\xfcfen oder erneut scannen.",
        'reconnect.title': "Neu verbinden\u2026",
        'reconnect.hint': 'Verbindung unterbrochen. Live-Bild wird wiederhergestellt.',
        'status.cameraStopped': 'Kamera angehalten',
        'cameraFrozen.title': 'Kamera des Babyphones angehalten',
        'cameraFrozen.hint': "Das Bild ist eingefroren, aber die Verbindung steht. Warten, bis die Kamera wieder l\xe4uft.",
        'sound.quiet': 'Ruhig',
        'sound.none': 'Noch kein Ton',
        'sound.level.low': 'Leise',
        'sound.level.medium': 'Mittel',
        'sound.level.loud': 'Laut',
        'sound.past.low': 'War leise',
        'sound.past.medium': 'War mittel',
        'sound.past.loud': 'War laut',
        'sound.ago': 'vor {time}',
        'install.text': 'Funktioniert besser als App',
        'install.action': 'Installieren',
        'install.dismiss': "Schlie\xdfen",
        'install.iosHint': "Installieren: auf Teilen tippen, dann \u201EZum Home-Bildschirm\u201C",
        'update.available': "Eine neue Version ist verf\xfcgbar",
        'update.action': 'Aktualisieren',
        'toolbar.switch': 'Wechseln',
        'toolbar.switchAria': 'Kamera wechseln',
        'toolbar.screen': 'Bildschirm',
        'toolbar.screenAria': 'Bildschirm abdunkeln, um Akku zu sparen',
        'toolbar.addParent': "Elternteil hinzuf\xfcgen",
        'toolbar.addParentAria': "Weiteres Elternteil hinzuf\xfcgen",
        'toolbar.melody': 'Melodie',
        'toolbar.melodyAria': "Eine beruhigende Melodie f\xfcr dein Baby abspielen",
        'melody.playing': "Schlaflied l\xe4uft",
        'melody.alertsPaused': 'Schrei-Warnungen pausiert',
        'battery.low': 'Akku des Babyphones niedrig',
        'battery.level': "{level}% \xfcbrig",
        'toolbar.sound': 'Ton',
        'toolbar.soundAria': 'Ton ein- oder ausschalten',
        'toolbar.talk': 'Sprechen',
        'toolbar.talkAria': 'Zum Sprechen halten',
        'toolbar.alerts': 'Warnungen',
        'toolbar.alertsAria': 'Tonhinweise, wenn die App geschlossen ist',
        'toolbar.invite': 'Einladen',
        'toolbar.inviteAria': 'Weiteres Elternteil einladen',
        'toolbar.fill': "F\xfcllen",
        'toolbar.fit': 'Anpassen',
        'toolbar.frameAria': "Bild anpassen oder Bildschirm f\xfcllen",
        'safety.title': 'Privat & sicher konzipiert',
        'safety.item1': "Video und Audio werden <strong>direkt</strong> zwischen deinen beiden Ger\xe4ten \xfcbertragen: Peer-to-Peer, Ende-zu-Ende verschl\xfcsselt (WebRTC / DTLS-SRTP).",
        'safety.item2': 'Kein Konto, keine Anmeldung, nichts wird auf einem Server gespeichert. Es gibt keine Aufzeichnung.',
        'safety.item3': "Der Verbindungslink ist eine zuf\xe4llige Einmal-ID: nur ein Ger\xe4t, das deinen QR-Code scannt, kann zusehen.",
        'safety.author': "Entwickelt von Harm Jan L. \u2192",
        'safety.melodyCredit': 'Melodie von <a href="https://pixabay.com/users/alex-morgan/" target="_blank" rel="noopener noreferrer">Alex Morgan</a> auf <a href="https://pixabay.com/" target="_blank" rel="noopener noreferrer">Pixabay</a>',
        'invite.title': 'Weiteres Elternteil einladen',
        'invite.sub': "Lass jemand anderen mitschauen: einfach diesen Code scannen oder den Link \xf6ffnen.",
        'videoOff.status': "\xdcbertragung l\xe4uft, Bildschirm abgedunkelt, um Akku zu sparen",
        'videoOff.hint': 'Tippe irgendwo, um das Bild anzuzeigen',
        'error.camera.denied': 'Erlaube den Kamera- und Mikrofonzugriff in den Browsereinstellungen und versuche es erneut.',
        'error.camera.busy': "Eine andere App nutzt die Kamera. Schlie\xdfe sie und versuche es erneut.",
        'error.camera.notFound': "Keine Kamera gefunden. Schlie\xdfe eine an und versuche es erneut.",
        'error.camera.generic': 'Kamera konnte nicht gestartet werden. Bitte versuche es erneut.',
        'error.connection': "Verbindung fehlgeschlagen. Pr\xfcfe deine Internetverbindung und versuche es erneut.",
        'alerts.enabled': 'Warnungen aktiv. Du wirst benachrichtigt, auch wenn die App geschlossen ist.',
        'alerts.disabled': 'Warnungen aus.',
        'alerts.denied': 'Benachrichtigungen sind blockiert. Erlaube sie in den Browsereinstellungen.',
        'alerts.unsupported': "Dieser Browser unterst\xfctzt keine Hintergrundwarnungen.",
        'alerts.unsupportedIos': "F\xfcge die App zum Home-Bildschirm hinzu, um Warnungen zu erhalten.",
        'alerts.failed': "Warnungen konnten nicht aktiviert werden. Pr\xfcfe deine Verbindung und versuch es erneut.",
        'trust.defaultName': 'Elternteil-{suffix}',
        'trust.newParent': 'Ein neues Elternteil hat sich verbunden',
        'trust.newParentNamed': '{name} hat sich verbunden',
        'trust.allow': 'Immer erlauben',
        'trust.ignore': 'Ignorieren',
        'trust.manage': 'Vertraute Eltern',
        'trust.title': 'Vertraute Eltern',
        'trust.sub': "Ger\xe4te, die dieses Babyphone erkennt, verbinden sich ohne Nachfrage. Entferne alle, denen du nicht mehr vertraust.",
        'trust.empty': 'Noch keine vertrauten Eltern.',
        'trust.remove': 'Entfernen',
        'trust.nameAria': 'Name des Elternteils'
    },
    pt: {
        'common.copyLink': 'Copiar link',
        'common.reset': 'Reiniciar',
        'common.back': 'Voltar',
        'common.retry': 'Tentar novamente',
        'common.copied': 'Copiado!',
        'common.gotIt': 'Entendi',
        'common.close': 'Fechar',
        'resume.button': 'Continuar assistindo',
        'role.host': "Monitor de beb\xea",
        'role.parent': 'Pais',
        'safety.badge': 'Seguro e privado.',
        'safety.why': "Porqu\xea?",
        'intro.short': "Escolha o que este aparelho ser\xe1: monitor perto do seu beb\xea, ou tela dos pais para acompanhar.",
        'intro.medium': "Um monitor de beb\xea no navegador, sem aplicativo nem conta. Escolha Monitor de beb\xea para o aparelho perto do seu beb\xea, ou Pais para acompanhar. Escaneie o c\xf3digo QR para conect\xe1-los.",
        'intro.long.title': 'Como o Peekababy funciona',
        'intro.long.p1': "Abra peekababy.app em dois aparelhos. Escolha Monitor de beb\xea perto do seu beb\xea e Pais no aparelho de onde voc\xea acompanha.",
        'intro.long.p2': "Escaneie o c\xf3digo QR para conect\xe1-los. Sem aplicativo nem conta, e a conex\xe3o \xe9 criptografada.",
        'connect.status': "Este telefone agora \xe9 o seu monitor de beb\xea. Escaneie o c\xf3digo QR em outro dispositivo para assistir.",
        'hostStatus.waiting': "Aguardando um pai/m\xe3e\u2026",
        'hostStatus.count.one': "{count} pai/m\xe3e assistindo",
        'hostStatus.count.other': '{count} pais assistindo',
        'scan.hint': "Aponte a c\xe2mera para o c\xf3digo QR exibido no monitor de beb\xea.",
        'scan.openCamera': "Abrir c\xe2mera",
        'scan.scanning': "Escaneando\u2026",
        'scan.cameraNeeded': "\xc9 necess\xe1rio acesso \xe0 c\xe2mera para escanear o c\xf3digo.",
        'status.connecting': "Conectando\u2026",
        'status.connected': 'Conectado',
        'status.live': 'Ao vivo',
        'status.reconnecting': "Reconectando\u2026",
        'status.notFound': "N\xe3o foi poss\xedvel acessar o monitor. Verifique o link ou escaneie novamente.",
        'reconnect.title': "Reconectando\u2026",
        'reconnect.hint': "Conex\xe3o interrompida. Restaurando a visualiza\xe7\xe3o ao vivo.",
        'status.cameraStopped': "C\xe2mera parada",
        'cameraFrozen.title': "A c\xe2mera do monitor parou",
        'cameraFrozen.hint': "A imagem est\xe1 congelada, mas a conex\xe3o est\xe1 boa. Aguardando a c\xe2mera voltar.",
        'sound.quiet': "Sil\xeancio",
        'sound.none': 'Ainda sem som',
        'sound.level.low': 'Baixo',
        'sound.level.medium': "M\xe9dio",
        'sound.level.loud': 'Alto',
        'sound.past.low': 'Foi baixo',
        'sound.past.medium': "Foi m\xe9dio",
        'sound.past.loud': 'Foi alto',
        'sound.ago': "h\xe1 {time}",
        'install.text': 'Funciona melhor instalado',
        'install.action': 'Instalar',
        'install.dismiss': 'Dispensar',
        'install.iosHint': "Instalar: toque em Compartilhar e depois \u201CAdicionar \xe0 Tela de In\xedcio\u201D",
        'update.available': "Uma nova vers\xe3o est\xe1 dispon\xedvel",
        'update.action': 'Atualizar',
        'toolbar.switch': 'Trocar',
        'toolbar.switchAria': "Trocar c\xe2mera",
        'toolbar.screen': 'Tela',
        'toolbar.screenAria': 'Escurecer a tela para poupar bateria',
        'toolbar.addParent': 'Adicionar',
        'toolbar.addParentAria': "Adicionar outro pai/m\xe3e",
        'toolbar.melody': 'Melodia',
        'toolbar.melodyAria': "Tocar uma melodia relaxante para o seu beb\xea",
        'melody.playing': 'Cantiga tocando',
        'melody.alertsPaused': 'Alertas de choro pausados',
        'battery.low': 'Bateria do monitor fraca',
        'battery.level': 'Resta {level}%',
        'toolbar.sound': 'Som',
        'toolbar.soundAria': 'Ativar ou desativar o som',
        'toolbar.talk': 'Falar',
        'toolbar.talkAria': 'Segure para falar',
        'toolbar.alerts': 'Alertas',
        'toolbar.alertsAria': "Alertas sonoros quando o app est\xe1 fechado",
        'toolbar.invite': 'Convidar',
        'toolbar.inviteAria': "Convidar outro pai/m\xe3e",
        'toolbar.fill': 'Preencher',
        'toolbar.fit': 'Ajustar',
        'toolbar.frameAria': 'Ajustar ou preencher a tela',
        'safety.title': 'Privado e seguro por design',
        'safety.item1': "O v\xeddeo e o \xe1udio trafegam <strong>diretamente</strong> entre seus dois dispositivos: ponto a ponto, criptografados de ponta a ponta (WebRTC / DTLS-SRTP).",
        'safety.item2': "Sem conta, sem cadastro, nada \xe9 armazenado em um servidor. N\xe3o h\xe1 grava\xe7\xe3o em lugar nenhum.",
        'safety.item3': "O link de conex\xe3o \xe9 um id \xfanico e aleat\xf3rio: s\xf3 um dispositivo que escanear seu QR pode assistir.",
        'safety.author': "Criado por Harm Jan L. \u2192",
        'safety.melodyCredit': 'Melodia de <a href="https://pixabay.com/users/alex-morgan/" target="_blank" rel="noopener noreferrer">Alex Morgan</a> no <a href="https://pixabay.com/" target="_blank" rel="noopener noreferrer">Pixabay</a>',
        'invite.title': "Convidar outro pai/m\xe3e",
        'invite.sub': "Deixe outra pessoa assistir tamb\xe9m: basta escanear este c\xf3digo ou abrir o link.",
        'videoOff.status': 'Transmitindo, tela escurecida para poupar bateria',
        'videoOff.hint': 'Toque em qualquer lugar para mostrar a imagem',
        'error.camera.denied': "Permita o acesso \xe0 c\xe2mera e ao microfone nas configura\xe7\xf5es do navegador e tente de novo.",
        'error.camera.busy': "Outro app est\xe1 usando a c\xe2mera. Feche-o e tente de novo.",
        'error.camera.notFound': "Nenhuma c\xe2mera encontrada. Conecte uma e tente de novo.",
        'error.camera.generic': "N\xe3o foi poss\xedvel iniciar a c\xe2mera. Tente de novo.",
        'error.connection': "Falha na conex\xe3o. Verifique sua internet e tente de novo.",
        'alerts.enabled': "Alertas ativados: voc\xea ser\xe1 avisado mesmo com o app fechado.",
        'alerts.disabled': 'Alertas desativados.',
        'alerts.denied': "As notifica\xe7\xf5es est\xe3o bloqueadas. Ative-as nas configura\xe7\xf5es do navegador.",
        'alerts.unsupported': "Este navegador n\xe3o oferece alertas em segundo plano.",
        'alerts.unsupportedIos': "Adicione o app \xe0 Tela de In\xedcio para receber alertas.",
        'alerts.failed': "N\xe3o foi poss\xedvel ativar os alertas. Verifique sua conex\xe3o e tente novamente.",
        'trust.defaultName': "Respons\xe1vel-{suffix}",
        'trust.newParent': "Um novo respons\xe1vel conectou-se",
        'trust.newParentNamed': '{name} conectou-se',
        'trust.allow': 'Permitir sempre',
        'trust.ignore': 'Ignorar',
        'trust.manage': "Respons\xe1veis de confian\xe7a",
        'trust.title': "Respons\xe1veis de confian\xe7a",
        'trust.sub': "Os dispositivos que este monitor reconhece conectam-se sem aviso. Remova os que j\xe1 n\xe3o s\xe3o de confian\xe7a.",
        'trust.empty': "Ainda n\xe3o h\xe1 respons\xe1veis de confian\xe7a.",
        'trust.remove': 'Remover',
        'trust.nameAria': "Nome do respons\xe1vel"
    },
    nl: {
        'common.copyLink': "Link kopi\xebren",
        'common.reset': 'Opnieuw',
        'common.back': 'Terug',
        'common.retry': 'Opnieuw proberen',
        'common.copied': 'Gekopieerd!',
        'common.gotIt': 'Begrepen',
        'common.close': 'Sluiten',
        'resume.button': 'Verder kijken',
        'role.host': 'Babyfoon',
        'role.parent': 'Ouder',
        'safety.badge': 'Veilig & beschermd.',
        'safety.why': 'Waarom?',
        'intro.short': 'Kies wat dit apparaat wordt: babyfoon bij je kindje, of ouder-scherm om mee te kijken.',
        'intro.medium': 'Een babyfoon in je browser, zonder app of account. Kies Babyfoon voor het apparaat bij je kindje, of Ouder om mee te kijken. Scan de QR-code om ze te koppelen.',
        'intro.long.title': 'Zo werkt Peekababy',
        'intro.long.p1': 'Open peekababy.app op twee apparaten. Kies Babyfoon bij je kindje en Ouder op het apparaat waarop je meekijkt.',
        'intro.long.p2': 'Scan de QR-code om ze te koppelen. Zonder app of account, en de verbinding is versleuteld.',
        'connect.status': 'Deze telefoon is nu je babyfoon. Scan de QR-code op een ander apparaat om mee te kijken.',
        'hostStatus.waiting': "Wachten op een ouder\u2026",
        'hostStatus.count.one': '{count} ouder kijkt mee',
        'hostStatus.count.other': '{count} ouders kijken mee',
        'scan.hint': 'Richt je camera op de QR-code op de babyfoon.',
        'scan.openCamera': 'Camera openen',
        'scan.scanning': "Scannen\u2026",
        'scan.cameraNeeded': 'Cameratoegang is nodig om de code te scannen.',
        'status.connecting': "Verbinden\u2026",
        'status.connected': 'Verbonden',
        'status.live': 'Live',
        'status.reconnecting': "Opnieuw verbinden\u2026",
        'status.notFound': 'Kan de babyfoon niet bereiken. Controleer de link of scan opnieuw.',
        'reconnect.title': "Opnieuw verbinden\u2026",
        'reconnect.hint': 'Verbinding onderbroken. Livebeeld wordt hersteld.',
        'status.cameraStopped': 'Camera gestopt',
        'cameraFrozen.title': 'Camera van de babyfoon gestopt',
        'cameraFrozen.hint': 'Het beeld is bevroren, maar de verbinding is in orde. Wachten tot de camera hervat.',
        'sound.quiet': 'Stil',
        'sound.none': 'Nog geen geluid',
        'sound.level.low': 'Laag',
        'sound.level.medium': 'Gemiddeld',
        'sound.level.loud': 'Luid',
        'sound.past.low': 'Was laag',
        'sound.past.medium': 'Was gemiddeld',
        'sound.past.loud': 'Was luid',
        'sound.ago': '{time} geleden',
        'install.text': 'Werkt beter als app',
        'install.action': 'Installeren',
        'install.dismiss': 'Sluiten',
        'install.iosHint': "Installeren: tik op Deel en dan \u201CZet op beginscherm\u201D",
        'update.available': 'Er is een nieuwe versie beschikbaar',
        'update.action': 'Vernieuwen',
        'toolbar.switch': 'Wisselen',
        'toolbar.switchAria': 'Camera wisselen',
        'toolbar.screen': 'Scherm',
        'toolbar.screenAria': 'Scherm dimmen om batterij te sparen',
        'toolbar.addParent': 'Ouder toevoegen',
        'toolbar.addParentAria': 'Nog een ouder toevoegen',
        'toolbar.melody': 'Melodie',
        'toolbar.melodyAria': 'Een rustgevend melodietje voor je baby afspelen',
        'melody.playing': 'Slaapliedje speelt',
        'melody.alertsPaused': 'Huilmeldingen gepauzeerd',
        'battery.low': 'Batterij babyfoon bijna leeg',
        'battery.level': '{level}% over',
        'toolbar.sound': 'Geluid',
        'toolbar.soundAria': 'Geluid aan- of uitzetten',
        'toolbar.talk': 'Praten',
        'toolbar.talkAria': 'Ingedrukt houden om te praten',
        'toolbar.alerts': 'Meldingen',
        'toolbar.alertsAria': 'Geluidsmeldingen als de app gesloten is',
        'toolbar.invite': 'Uitnodigen',
        'toolbar.inviteAria': 'Nog een ouder uitnodigen',
        'toolbar.fill': 'Vullen',
        'toolbar.fit': 'Passend',
        'toolbar.frameAria': 'Beeld passend maken of scherm vullen',
        'safety.title': "Priv\xe9 & veilig van opzet",
        'safety.item1': 'Video en audio gaan <strong>rechtstreeks</strong> tussen je twee apparaten: peer-to-peer, end-to-end versleuteld (WebRTC / DTLS-SRTP).',
        'safety.item2': 'Geen account, geen registratie, niets wordt op een server bewaard. Er wordt nergens opgenomen.',
        'safety.item3': 'De verbindingslink is een willekeurige eenmalige id: alleen een apparaat dat je QR scant, kan meekijken.',
        'safety.author': "Gemaakt door Harm Jan L. \u2192",
        'safety.melodyCredit': 'Melodie van <a href="https://pixabay.com/users/alex-morgan/" target="_blank" rel="noopener noreferrer">Alex Morgan</a> op <a href="https://pixabay.com/" target="_blank" rel="noopener noreferrer">Pixabay</a>',
        'invite.title': 'Nog een ouder uitnodigen',
        'invite.sub': 'Laat iemand anders ook meekijken: scan deze code of open de link.',
        'videoOff.status': 'Streamen, scherm gedimd om batterij te sparen',
        'videoOff.hint': 'Tik ergens om het beeld te tonen',
        'error.camera.denied': 'Geef in je browserinstellingen toegang tot camera en microfoon en probeer opnieuw.',
        'error.camera.busy': 'De camera is in gebruik door een andere app. Sluit die en probeer opnieuw.',
        'error.camera.notFound': 'Geen camera gevonden. Sluit er een aan en probeer opnieuw.',
        'error.camera.generic': 'Kan de camera niet starten. Probeer het opnieuw.',
        'error.connection': 'Verbinding mislukt. Controleer je internet en probeer opnieuw.',
        'alerts.enabled': 'Meldingen aan. Je krijgt bericht, ook als de app gesloten is.',
        'alerts.disabled': 'Meldingen uit.',
        'alerts.denied': 'Meldingen zijn geblokkeerd. Sta ze toe in je browserinstellingen.',
        'alerts.unsupported': 'Deze browser ondersteunt geen achtergrondmeldingen.',
        'alerts.unsupportedIos': 'Zet de app op je beginscherm om meldingen te krijgen.',
        'alerts.failed': 'Meldingen konden niet worden ingeschakeld. Controleer je verbinding en probeer opnieuw.',
        'trust.defaultName': 'Ouder-{suffix}',
        'trust.newParent': 'Een nieuwe ouder heeft verbinding gemaakt',
        'trust.newParentNamed': '{name} heeft verbinding gemaakt',
        'trust.allow': 'Altijd toestaan',
        'trust.ignore': 'Negeren',
        'trust.manage': 'Vertrouwde ouders',
        'trust.title': 'Vertrouwde ouders',
        'trust.sub': 'Apparaten die deze babyfoon herkent, maken verbinding zonder melding. Verwijder ouders die je niet meer vertrouwt.',
        'trust.empty': 'Nog geen vertrouwde ouders.',
        'trust.remove': 'Verwijderen',
        'trust.nameAria': 'Naam van ouder'
    }
};
function $03c039b69e20a322$var$primarySubtag(tag) {
    return String(tag || '').split('-')[0].toLowerCase();
}
// Locale baked into the URL by the build: /de/, /nl/, ... (English is the root).
// Takes priority over the browser's own languages because these paths are what
// search engines index and what people share — a visitor who follows a German
// result has to get the German page, or the rendered content stops matching the
// page's declared lang/hreflang.
function $03c039b69e20a322$var$pathLocale() {
    try {
        const seg = window.location.pathname.split('/').filter(Boolean)[0];
        const sub = $03c039b69e20a322$var$primarySubtag(seg);
        if (sub && $03c039b69e20a322$export$4c4b683c586ca56e.includes(sub)) return sub;
    } catch (e) {
    /* ignore */ }
    return null;
}
function $03c039b69e20a322$var$detectLocale() {
    // Explicit override for testing, e.g. ?lang=de.
    try {
        const override = new URLSearchParams(window.location.search).get('lang');
        if (override && $03c039b69e20a322$export$4c4b683c586ca56e.includes($03c039b69e20a322$var$primarySubtag(override))) return $03c039b69e20a322$var$primarySubtag(override);
    } catch (e) {
    /* ignore malformed query */ }
    const fromPath = $03c039b69e20a322$var$pathLocale();
    if (fromPath) return fromPath;
    const candidates = navigator.languages && navigator.languages.length ? navigator.languages : [
        navigator.language
    ];
    for (const cand of candidates){
        const sub = $03c039b69e20a322$var$primarySubtag(cand);
        if ($03c039b69e20a322$export$4c4b683c586ca56e.includes(sub)) return sub;
    }
    return $03c039b69e20a322$export$1af4c7e47ad72f44;
}
let $03c039b69e20a322$var$current = $03c039b69e20a322$export$1af4c7e47ad72f44;
function $03c039b69e20a322$export$180605366c04f0cd() {
    return $03c039b69e20a322$var$current;
}
function $03c039b69e20a322$var$interpolate(str, params) {
    if (!params) return str;
    return str.replace(/\{(\w+)\}/g, (m, key)=>key in params ? String(params[key]) : m);
}
function $03c039b69e20a322$export$625550452a3fa3ec(key, params) {
    const dict = $03c039b69e20a322$export$defe85febe8b728c[$03c039b69e20a322$var$current] || $03c039b69e20a322$export$defe85febe8b728c.en;
    const str = dict[key] != null ? dict[key] : $03c039b69e20a322$export$defe85febe8b728c.en[key] != null ? $03c039b69e20a322$export$defe85febe8b728c.en[key] : key;
    return $03c039b69e20a322$var$interpolate(str, params);
}
function $03c039b69e20a322$export$ac8a90d2a5e68c45(baseKey, count, params) {
    let category = 'other';
    try {
        category = new Intl.PluralRules($03c039b69e20a322$var$current).select(count);
    } catch (e) {
    /* fall back to 'other' */ }
    const dict = $03c039b69e20a322$export$defe85febe8b728c[$03c039b69e20a322$var$current] || $03c039b69e20a322$export$defe85febe8b728c.en;
    const key = dict[`${baseKey}.${category}`] != null ? `${baseKey}.${category}` : `${baseKey}.other`;
    let formatted = String(count);
    try {
        formatted = new Intl.NumberFormat($03c039b69e20a322$var$current).format(count);
    } catch (e) {
    /* keep plain number */ }
    return $03c039b69e20a322$export$625550452a3fa3ec(key, {
        count: formatted,
        ...params
    });
}
// Attribute -> DOM property/attribute setters used by applyDom().
const $03c039b69e20a322$var$ATTR_TARGETS = [
    [
        'data-i18n',
        (el, val)=>{
            el.textContent = val;
        }
    ],
    [
        'data-i18n-html',
        (el, val)=>{
            el.innerHTML = val;
        }
    ],
    [
        'data-i18n-aria-label',
        (el, val)=>el.setAttribute('aria-label', val)
    ],
    [
        'data-i18n-title',
        (el, val)=>el.setAttribute('title', val)
    ],
    [
        'data-i18n-placeholder',
        (el, val)=>el.setAttribute('placeholder', val)
    ]
];
function $03c039b69e20a322$export$84fe29aa6a4f9a43(root = document) {
    $03c039b69e20a322$var$ATTR_TARGETS.forEach(([attr, set])=>{
        root.querySelectorAll(`[${attr}]`).forEach((el)=>{
            const key = el.getAttribute(attr);
            if (key) set(el, $03c039b69e20a322$export$625550452a3fa3ec(key));
        });
    });
}
function $03c039b69e20a322$export$8464cdd050ea8737() {
    $03c039b69e20a322$var$current = $03c039b69e20a322$var$detectLocale();
    try {
        document.documentElement.lang = $03c039b69e20a322$var$current;
    } catch (e) {
    /* ignore */ }
    $03c039b69e20a322$export$84fe29aa6a4f9a43(document);
    return $03c039b69e20a322$var$current;
}


function $b68ecd39b69a2afc$export$43b36d76881373cf(key) {
    try {
        return window.localStorage.getItem(key);
    } catch (e) {
        return null;
    }
}
function $b68ecd39b69a2afc$export$b6f24a8024dbaa15(key, value) {
    try {
        window.localStorage.setItem(key, value);
        return true;
    } catch (e) {
        return false;
    }
}
function $b68ecd39b69a2afc$export$1af2c3526d162e49(key) {
    try {
        window.localStorage.removeItem(key);
    } catch (e) {
    /* storage unavailable — nothing to remove */ }
}
function $b68ecd39b69a2afc$export$ff7706047246b98b() {
    return typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
function $b68ecd39b69a2afc$export$20ac98a4b4fe8b85(mutate) {
    if ($b68ecd39b69a2afc$export$ff7706047246b98b() || typeof document.startViewTransition !== 'function') {
        mutate();
        return;
    }
    try {
        document.startViewTransition(()=>mutate());
    } catch (e) {
        // A failure to start a transition must never swallow the state change.
        mutate();
    }
}
function $b68ecd39b69a2afc$export$17a1bc44f8c202b5(key, fallback = null) {
    const raw = $b68ecd39b69a2afc$export$43b36d76881373cf(key);
    if (raw == null) return fallback;
    try {
        return JSON.parse(raw);
    } catch (e) {
        return fallback;
    }
}
function $b68ecd39b69a2afc$export$ea0874f14a833321(key, value) {
    return $b68ecd39b69a2afc$export$b6f24a8024dbaa15(key, JSON.stringify(value));
}
// --- Parent identity + trusted-parents list ---------------------------------
// A baby monitor can remember which parent devices it has seen before so a
// recognized parent connects silently while a new one raises a heads-up. The
// parent keeps a stable random id (never a PeerJS id, which is per-load) so the
// same phone is recognized across reloads; the monitor keeps the trusted list.
// This is a recognition aid, NOT access control: the id is client-supplied, so
// it can be spoofed or omitted. Everything lives in localStorage only.
const $b68ecd39b69a2afc$var$CLIENT_ID_KEY = 'cammirror:client-id';
const $b68ecd39b69a2afc$var$CLIENT_NAME_KEY = 'cammirror:client-name';
const $b68ecd39b69a2afc$var$TRUSTED_PARENTS_KEY = 'cammirror:trusted-parents';
function $b68ecd39b69a2afc$var$randomId() {
    try {
        if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    } catch (e) {
    /* fall through to the Math.random fallback below */ }
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
function $b68ecd39b69a2afc$export$3b0073deb71e8e8d() {
    let id = $b68ecd39b69a2afc$export$43b36d76881373cf($b68ecd39b69a2afc$var$CLIENT_ID_KEY);
    if (!id) {
        id = $b68ecd39b69a2afc$var$randomId();
        $b68ecd39b69a2afc$export$b6f24a8024dbaa15($b68ecd39b69a2afc$var$CLIENT_ID_KEY, id);
    }
    let name = $b68ecd39b69a2afc$export$43b36d76881373cf($b68ecd39b69a2afc$var$CLIENT_NAME_KEY);
    if (!name) {
        const suffix = id.replace(/[^a-z0-9]/gi, '').slice(-4).toUpperCase() || 'XXXX';
        name = (0, $03c039b69e20a322$export$625550452a3fa3ec)('trust.defaultName', {
            suffix: suffix
        });
        $b68ecd39b69a2afc$export$b6f24a8024dbaa15($b68ecd39b69a2afc$var$CLIENT_NAME_KEY, name);
    }
    return {
        id: id,
        name: name
    };
}
function $b68ecd39b69a2afc$export$46bb5b97e62dc42() {
    const list = $b68ecd39b69a2afc$export$17a1bc44f8c202b5($b68ecd39b69a2afc$var$TRUSTED_PARENTS_KEY, []);
    return Array.isArray(list) ? list : [];
}
function $b68ecd39b69a2afc$export$9394b6ae1d59f447(id) {
    if (!id) return false;
    return $b68ecd39b69a2afc$export$46bb5b97e62dc42().some((p)=>p && p.id === id);
}
function $b68ecd39b69a2afc$export$490f701ed48c171(id, name) {
    if (!id) return false;
    const list = $b68ecd39b69a2afc$export$46bb5b97e62dc42().filter((p)=>p && p.id !== id);
    list.push({
        id: id,
        name: name || id,
        addedAt: Date.now()
    });
    return $b68ecd39b69a2afc$export$ea0874f14a833321($b68ecd39b69a2afc$var$TRUSTED_PARENTS_KEY, list);
}
function $b68ecd39b69a2afc$export$22c6639596c9db5(id) {
    if (!id) return false;
    const list = $b68ecd39b69a2afc$export$46bb5b97e62dc42().filter((p)=>p && p.id !== id);
    return $b68ecd39b69a2afc$export$ea0874f14a833321($b68ecd39b69a2afc$var$TRUSTED_PARENTS_KEY, list);
}
function $b68ecd39b69a2afc$export$1b3dfc800d9a80c3(id, name) {
    const clean = (name || '').trim();
    if (!id || !clean) return false;
    const list = $b68ecd39b69a2afc$export$46bb5b97e62dc42().map((p)=>p && p.id === id ? {
            ...p,
            name: clean
        } : p);
    return $b68ecd39b69a2afc$export$ea0874f14a833321($b68ecd39b69a2afc$var$TRUSTED_PARENTS_KEY, list);
}
// --- Last-watched monitor (parent resume) -----------------------------------
// A parent remembers the last monitor it actually watched so a fully closed app
// can rejoin on reopen (the "Resume watching" shortcut) without walking back to
// the room to re-scan the QR. Kept for a day only: a monitor that's "still on /
// in the room" is a same-session/overnight thing, so we don't dial a long-dead
// id much later. The key + record shape live here so the writer (client.js) and
// the reader (app.js) can never drift apart.
const $b68ecd39b69a2afc$var$LAST_HOST_KEY = 'cammirror:last-host';
const $b68ecd39b69a2afc$var$LAST_HOST_MAX_AGE_MS = 86400000;
function $b68ecd39b69a2afc$export$17fead10eae298d1(id) {
    if (!id) return;
    $b68ecd39b69a2afc$export$ea0874f14a833321($b68ecd39b69a2afc$var$LAST_HOST_KEY, {
        id: id,
        ts: Date.now()
    });
}
function $b68ecd39b69a2afc$export$1b79c76d26fa31e6() {
    const rec = $b68ecd39b69a2afc$export$17a1bc44f8c202b5($b68ecd39b69a2afc$var$LAST_HOST_KEY, null);
    if (!rec || !rec.id) return null;
    if (typeof rec.ts === 'number' && Date.now() - rec.ts > $b68ecd39b69a2afc$var$LAST_HOST_MAX_AGE_MS) return null;
    return rec.id;
}
function $b68ecd39b69a2afc$export$4e19848623c50785(id) {
    return `${window.location.origin}${window.location.pathname}#${id}`;
}
function $b68ecd39b69a2afc$export$b48da2f84c900c96(el, text) {
    if (!el) return;
    el.replaceChildren();
    (0, $0929d12b0e7ce7ee$export$2e2bcd8739ae039).render({
        text: text,
        radius: 0.1,
        ecLevel: 'H',
        fill: '#000',
        background: '#fff',
        size: 400
    }, el);
}
async function $b68ecd39b69a2afc$export$8dff4cfd26f76003(text, labelEl) {
    try {
        await navigator.clipboard.writeText(text);
        if (labelEl) {
            const prev = labelEl.textContent;
            labelEl.textContent = (0, $03c039b69e20a322$export$625550452a3fa3ec)('common.copied');
            setTimeout(()=>{
                labelEl.textContent = prev;
            }, 1600);
        }
        return true;
    } catch (e) {
        console.warn('[CAMMIRROR] clipboard write failed', e && e.name);
        return false;
    }
}
function $b68ecd39b69a2afc$export$27972cfaa3ad15e9(el, on) {
    if (el) el.setAttribute('aria-pressed', String(!!on));
}
// --- Toasts -----------------------------------------------------------------
// A toast is a `hidden` element that fades in/out via a `.show` class (see
// styles.css). Both the parent's transient messages and the "update available"
// prompt use this same reveal/dismiss dance, so it lives here once.
// Must match the toast fade duration in styles.css so we only set `hidden`
// after the fade-out has finished.
const $b68ecd39b69a2afc$var$TOAST_FADE_MS = 220;
function $b68ecd39b69a2afc$export$39c365eaabfb0a68(el) {
    if (!el) return;
    el.hidden = false;
    el.offsetWidth; // force reflow so the .show transition runs
    el.classList.add('show');
}
function $b68ecd39b69a2afc$export$c96659240d08478b(el, onHidden) {
    if (!el) return;
    el.classList.remove('show');
    setTimeout(()=>{
        if (el.classList.contains('show')) return;
        el.hidden = true;
        if (onHidden) onHidden();
    }, $b68ecd39b69a2afc$var$TOAST_FADE_MS);
}
function $b68ecd39b69a2afc$export$41a665f744414057() {
    const ua = navigator.userAgent || '';
    if (/iphone|ipad|ipod/i.test(ua)) return true;
    const macLike = /Macintosh/.test(ua) || navigator.platform === 'MacIntel';
    return macLike && navigator.maxTouchPoints > 1;
}
function $b68ecd39b69a2afc$export$bd70983939bfdb5c(message, options = {}) {
    console.error('[CAMMIRROR]', message);
    const $connect = document.getElementById('connect');
    if (!$connect) return;
    $connect.classList.remove('connected');
    $connect.classList.add('is-error');
    // Hide (don't destroy) the existing card content — including the already
    // rendered QR and its wired buttons — so a Retry that succeeds can restore it
    // intact via clearConnectError() instead of rebuilding markup + listeners.
    Array.from($connect.children).forEach((el)=>{
        if (el.classList.contains('connect-error-box')) return;
        el.dataset.hiddenByError = '1';
        el.hidden = true;
    });
    const existing = $connect.querySelector('.connect-error-box');
    if (existing) existing.remove();
    const $box = document.createElement('div');
    $box.className = 'connect-error-box';
    const $msg = document.createElement('p');
    $msg.className = 'connect-error-msg';
    $msg.textContent = message;
    $box.appendChild($msg);
    // Optional in-place Retry: re-run the caller's recovery (e.g. re-request the
    // camera) without a full reload, so a resolved hiccup restores the monitor.
    if (options.retryLabel && typeof options.onRetry === 'function') {
        const $retry = document.createElement('button');
        $retry.type = 'button';
        $retry.className = 'btn';
        $retry.textContent = options.retryLabel;
        $retry.addEventListener('click', ()=>options.onRetry());
        $box.appendChild($retry);
    }
    // A dead-end error needs a way out: offer Back to the role picker. Reloading at
    // the bare path tears down every peer/camera/timer cleanly (mirrors resetToRole).
    if (options.backLabel) {
        const $back = document.createElement('button');
        $back.type = 'button';
        $back.className = 'btn subtle reset-btn';
        $back.textContent = options.backLabel;
        $back.addEventListener('click', ()=>window.location.assign(window.location.pathname));
        $box.appendChild($back);
    }
    $connect.appendChild($box);
    // flex (not block) keeps the card's centered column layout + even padding.
    $connect.style.display = 'flex';
}
function $b68ecd39b69a2afc$export$40f72c43f20f0f8f() {
    const $connect = document.getElementById('connect');
    if (!$connect) return;
    const $box = $connect.querySelector('.connect-error-box');
    if ($box) $box.remove();
    $connect.classList.remove('is-error');
    Array.from($connect.children).forEach((el)=>{
        if (el.dataset && el.dataset.hiddenByError) {
            delete el.dataset.hiddenByError;
            el.hidden = false;
        }
    });
}
function $b68ecd39b69a2afc$export$ebb907d1f7711853(err) {
    switch(err && err.name){
        case 'NotAllowedError':
        case 'SecurityError':
        case 'PermissionDeniedError':
            return 'error.camera.denied';
        case 'NotFoundError':
        case 'DevicesNotFoundError':
        case 'OverconstrainedError':
        case 'ConstraintNotSatisfiedError':
            return 'error.camera.notFound';
        case 'NotReadableError':
        case 'TrackStartError':
        case 'AbortError':
            return 'error.camera.busy';
        default:
            return 'error.camera.generic';
    }
}
let $b68ecd39b69a2afc$var$wakeLock = null;
function $b68ecd39b69a2afc$export$be0877e53743fab2() {
    if (!('wakeLock' in navigator)) return;
    const acquire = async ()=>{
        try {
            $b68ecd39b69a2afc$var$wakeLock = await navigator.wakeLock.request('screen');
            $b68ecd39b69a2afc$var$wakeLock.addEventListener('release', ()=>{
                $b68ecd39b69a2afc$var$wakeLock = null;
            });
        } catch (err) {
            console.warn('[CAMMIRROR] Screen wake lock unavailable:', err && err.name);
        }
    };
    acquire();
    document.addEventListener('visibilitychange', ()=>{
        if ($b68ecd39b69a2afc$var$wakeLock === null && document.visibilityState === 'visible') acquire();
    });
}
function $b68ecd39b69a2afc$export$77f6ac6e8a39e870($video) {
    const playPromise = $video.play();
    if (playPromise && playPromise.catch) playPromise.catch((error)=>console.log("[ERROR] Couldn't play..", error));
}
function $b68ecd39b69a2afc$export$a356d195f00e8338(cameras) {
    var constraints1 = [];
    cameras.forEach((camera)=>{
        let isActive = activeVideoStream.getVideoTracks()[0].getSettings().deviceId === camera.deviceId;
        constraints1.push({
            video: {
                deviceId: {
                    exact: camera.deviceId
                },
                isActive: isActive
            }
        });
    });
    return constraints1;
}
function $b68ecd39b69a2afc$export$7c94d6f03205391b() {
    if (!constraints || constraints.length <= 1) return null;
    // Rotate to the device after the active one (wrapping around) so phones that
    // expose three or more cameras cycle through all of them, instead of just
    // ping-ponging between the first two. A missing active flag (-1) wraps to 0.
    const activeIndex = constraints.findIndex((c)=>c.video.isActive);
    const nextCameraIndex = (activeIndex + 1) % constraints.length;
    constraints.forEach((constraint)=>{
        constraint.video.isActive = false;
    });
    constraints[nextCameraIndex].video.isActive = true;
    return {
        video: {
            deviceId: constraints[nextCameraIndex].video.deviceId,
            frameRate: {
                ideal: 15,
                max: 20
            }
        },
        audio: {
            echoCancellation: true
        }
    };
}
// A single shared AudioContext is reused across streams. Creating a new one
// per call (the previous behaviour) leaked contexts until the browser refused
// to create more (~6), silently breaking the meter. The meter is driven by
// requestAnimationFrame (throttled to ~90ms) so it pauses in background tabs.
let $b68ecd39b69a2afc$var$sharedAudioContext = null;
let $b68ecd39b69a2afc$var$currentAnalyserSource = null;
let $b68ecd39b69a2afc$var$volumeRafId = null;
function $b68ecd39b69a2afc$export$d6b8db0c5911d42e(stream, onLevel) {
    const $levels = document.getElementById('volume-levels');
    const spans = $levels ? Array.from($levels.querySelectorAll('.group span')) : [];
    if (!$b68ecd39b69a2afc$var$sharedAudioContext) $b68ecd39b69a2afc$var$sharedAudioContext = new AudioContext();
    if ($b68ecd39b69a2afc$var$sharedAudioContext.state === 'suspended') $b68ecd39b69a2afc$var$sharedAudioContext.resume();
    if ($b68ecd39b69a2afc$var$currentAnalyserSource) try {
        $b68ecd39b69a2afc$var$currentAnalyserSource.disconnect();
    } catch (e) {}
    const audioSource = $b68ecd39b69a2afc$var$sharedAudioContext.createMediaStreamSource(stream);
    const analyser = $b68ecd39b69a2afc$var$sharedAudioContext.createAnalyser();
    analyser.fftSize = 512;
    analyser.minDecibels = -127;
    analyser.maxDecibels = 0;
    analyser.smoothingTimeConstant = 0.4;
    audioSource.connect(analyser);
    $b68ecd39b69a2afc$var$currentAnalyserSource = audioSource;
    const volumes = new Uint8Array(analyser.frequencyBinCount);
    let count = 0;
    let lastTick = 0;
    if ($b68ecd39b69a2afc$var$volumeRafId) cancelAnimationFrame($b68ecd39b69a2afc$var$volumeRafId);
    const render = (now)=>{
        $b68ecd39b69a2afc$var$volumeRafId = requestAnimationFrame(render);
        if (now - lastTick < 90) return;
        lastTick = now;
        analyser.getByteFrequencyData(volumes);
        let volumeSum = 0;
        for (const volume of volumes)volumeSum += volume;
        const averageVolume = volumeSum / volumes.length;
        if (spans.length) {
            const volume = averageVolume * 100 / 312; // / 127;
            spans[count].style.height = volume + 'px';
            count = (count + 1) % spans.length;
        }
        if (onLevel) onLevel(Math.min(1, averageVolume / 90));
    };
    $b68ecd39b69a2afc$var$volumeRafId = requestAnimationFrame(render);
}


// Anonymous, non-blocking event tracking via OpenPanel.
//
// Two hard rules shape this module:
//   1. Production only. Events fire solely on peekababy.app so preview deploys,
//      tunnels, staging and a locally-served build stay silent even though
//      .env carries a real client id.
//   2. No PII, ever. The viewer URL is `${origin}${pathname}#<hostPeerId>`, so
//      we never send peer ids, connection ids or the URL hash — only roles,
//      counts, coarse states and error names.
//
// Tracking is fire-and-forget: OpenPanel's track() already queues and sends
// asynchronously, and every call here is additionally wrapped so it can never
// throw or delay the WebRTC path.
var $5f7853cf87b17a16$var$o = class {
    async resolveHeaders() {
        let e = {};
        for (let [r, t] of Object.entries(this.headers)){
            let s = await t;
            s !== null && (e[r] = s);
        }
        return e;
    }
    addHeader(e, r) {
        this.headers[e] = r;
    }
    async post(e, r, t, s) {
        try {
            let i = await fetch(e, {
                method: "POST",
                headers: await this.resolveHeaders(),
                body: r ? JSON.stringify(r !== null && r !== void 0 ? r : {}) : void 0,
                keepalive: !0,
                ...t
            });
            if (i.status === 401) return null;
            if (i.status !== 200 && i.status !== 202) throw new Error(`HTTP error! status: ${i.status}`);
            let n = await i.text();
            return n ? JSON.parse(n) : null;
        } catch (i) {
            if (s < this.maxRetries) {
                let n = this.initialRetryDelay * 2 ** s;
                return await new Promise((l)=>setTimeout(l, n)), this.post(e, r, t, s + 1);
            }
            return console.error("Max retries reached:", i), null;
        }
    }
    async fetch(e, r, t = {}) {
        let s = `${this.baseUrl}${e}`;
        return this.post(s, r, t, 0);
    }
    constructor(e){
        var _e_maxRetries, _e_initialRetryDelay;
        this.baseUrl = e.baseUrl, this.headers = {
            "Content-Type": "application/json",
            ...e.defaultHeaders
        }, this.maxRetries = (_e_maxRetries = e.maxRetries) !== null && _e_maxRetries !== void 0 ? _e_maxRetries : 3, this.initialRetryDelay = (_e_initialRetryDelay = e.initialRetryDelay) !== null && _e_initialRetryDelay !== void 0 ? _e_initialRetryDelay : 500;
    }
};
var $5f7853cf87b17a16$export$5ea5fea0727da6e2 = class {
    init() {}
    ready() {
        this.options.disabled = !1, this.options.waitForProfile = !1, this.flush();
    }
    shouldQueue(e) {
        return !!(this.options.disabled || this.options.waitForProfile && !this.profileId || e.type === "replay" && !this.sessionId);
    }
    addQueue(e) {
        var _e_payload_properties;
        e.type === "track" && (e.payload.properties = {
            ...(_e_payload_properties = e.payload.properties) !== null && _e_payload_properties !== void 0 ? _e_payload_properties : {},
            __timestamp: new Date().toISOString()
        }), this.queue.push(e);
    }
    async send(e) {
        if (this.options.filter && !this.options.filter(e)) return Promise.resolve();
        if (this.shouldQueue(e)) return this.addQueue(e), Promise.resolve();
        let r = await this.api.fetch("/track", e, {
            keepalive: e.type !== "replay"
        });
        this.deviceId = r === null || r === void 0 ? void 0 : r.deviceId;
        let t = !!this.sessionId;
        return this.sessionId = r === null || r === void 0 ? void 0 : r.sessionId, !t && this.sessionId && this.flush(), r;
    }
    setGlobalProperties(e) {
        this.global = {
            ...this.global,
            ...e
        };
    }
    track(e, r) {
        this.log("track event", e, r);
        let { groups: t, profileId: s, ...i } = r !== null && r !== void 0 ? r : {}, n = [
            ...new Set([
                ...this.groups,
                ...t !== null && t !== void 0 ? t : []
            ])
        ];
        var _this_global;
        return this.send({
            type: "track",
            payload: {
                name: e,
                profileId: s !== null && s !== void 0 ? s : this.profileId,
                groups: n.length > 0 ? n : void 0,
                properties: {
                    ...(_this_global = this.global) !== null && _this_global !== void 0 ? _this_global : {},
                    ...i
                }
            }
        });
    }
    identify(e) {
        if (this.log("identify user", e), e.profileId && (this.profileId = e.profileId, this.flush()), e.profileId && Object.keys(e).length > 1) return this.send({
            type: "identify",
            payload: {
                ...e,
                properties: {
                    ...this.global,
                    ...e.properties
                }
            }
        });
    }
    upsertGroup(e) {
        return this.log("upsert group", e), this.send({
            type: "group",
            payload: e
        });
    }
    setGroup(e) {
        return this.log("set group", e), this.groups.includes(e) || (this.groups = [
            ...this.groups,
            e
        ]), this.send({
            type: "assign_group",
            payload: {
                groupIds: [
                    e
                ],
                profileId: this.profileId
            }
        });
    }
    setGroups(e) {
        return this.log("set groups", e), this.groups = [
            ...new Set([
                ...this.groups,
                ...e
            ])
        ], this.send({
            type: "assign_group",
            payload: {
                groupIds: e,
                profileId: this.profileId
            }
        });
    }
    alias(e) {}
    increment(e) {
        return this.send({
            type: "increment",
            payload: e
        });
    }
    decrement(e) {
        return this.send({
            type: "decrement",
            payload: e
        });
    }
    revenue(e, r) {
        let t = r === null || r === void 0 ? void 0 : r.deviceId;
        return r === null || r === void 0 ? true : delete r.deviceId, this.track("revenue", {
            ...r !== null && r !== void 0 ? r : {},
            ...t ? {
                __deviceId: t
            } : {},
            __revenue: e
        });
    }
    getDeviceId() {
        var _this_deviceId;
        return (_this_deviceId = this.deviceId) !== null && _this_deviceId !== void 0 ? _this_deviceId : "";
    }
    getSessionId() {
        var _this_sessionId;
        return (_this_sessionId = this.sessionId) !== null && _this_sessionId !== void 0 ? _this_sessionId : "";
    }
    fetchDeviceId() {
        var _this_deviceId;
        return Promise.resolve((_this_deviceId = this.deviceId) !== null && _this_deviceId !== void 0 ? _this_deviceId : "");
    }
    clear() {
        this.profileId = void 0, this.groups = [], this.deviceId = void 0, this.sessionId = void 0;
    }
    buildFlushPayload(e) {
        if (e.type === "replay") return e.payload;
        if (e.type === "track") {
            var _e_payload_groups;
            let r = "groups" in e.payload ? (_e_payload_groups = e.payload.groups) !== null && _e_payload_groups !== void 0 ? _e_payload_groups : [] : [], t = [
                ...new Set([
                    ...this.groups,
                    ...r
                ])
            ];
            var _e_payload_profileId;
            return {
                ...e.payload,
                profileId: (_e_payload_profileId = e.payload.profileId) !== null && _e_payload_profileId !== void 0 ? _e_payload_profileId : this.profileId,
                groups: t.length > 0 ? t : void 0
            };
        }
        var _e_payload_profileId1, _e_payload_profileId2;
        return e.type === "identify" || e.type === "increment" || e.type === "decrement" ? {
            ...e.payload,
            profileId: (_e_payload_profileId1 = e.payload.profileId) !== null && _e_payload_profileId1 !== void 0 ? _e_payload_profileId1 : this.profileId
        } : e.type === "assign_group" ? {
            ...e.payload,
            profileId: (_e_payload_profileId2 = e.payload.profileId) !== null && _e_payload_profileId2 !== void 0 ? _e_payload_profileId2 : this.profileId
        } : e.payload;
    }
    flush() {
        let e = [];
        for (let r of this.queue){
            if (this.shouldQueue(r)) {
                e.push(r);
                continue;
            }
            let t = this.buildFlushPayload(r);
            this.send({
                ...r,
                payload: t
            });
        }
        this.queue = e;
    }
    log(...e) {
        this.options.debug && console.log("[OpenPanel.dev]", ...e);
    }
    constructor(e){
        this.groups = [];
        this.queue = [];
        this.options = e;
        let r = {
            "openpanel-client-id": e.clientId
        };
        e.clientSecret && (r["openpanel-client-secret"] = e.clientSecret), r["openpanel-sdk-name"] = e.sdk || "node", r["openpanel-sdk-version"] = e.sdkVersion || "1.3.1", this.api = new $5f7853cf87b17a16$var$o({
            baseUrl: e.apiUrl || "https://api.openpanel.dev",
            defaultHeaders: r
        });
    }
};


var $24814a9736169cd8$var$d = typeof document < "u" ? document.currentScript : null;
function $24814a9736169cd8$var$h(o) {
    return o.replace(/([-_][a-z])/gi, (p)=>p.toUpperCase().replace("-", "").replace("_", ""));
}

var $24814a9736169cd8$export$5ea5fea0727da6e2 = class extends (0, $5f7853cf87b17a16$export$5ea5fea0727da6e2) {
    async loadReplayModule() {
        try {
            if (typeof __OPENPANEL_REPLAY_URL__ < "u") {
                var _this_options_sessionReplay, _t_src;
                let t = $24814a9736169cd8$var$d, e = ((_this_options_sessionReplay = this.options.sessionReplay) === null || _this_options_sessionReplay === void 0 ? void 0 : _this_options_sessionReplay.scriptUrl) || (t === null || t === void 0 ? void 0 : (_t_src = t.src) === null || _t_src === void 0 ? void 0 : _t_src.replace(".js", "-replay.js")) || "https://openpanel.dev/op1-replay.js";
                return window.__openpanel_replay ? window.__openpanel_replay : new Promise((n)=>{
                    let r = document.createElement("script");
                    r.src = e, r.onload = ()=>{
                        var _window___openpanel_replay;
                        n((_window___openpanel_replay = window.__openpanel_replay) !== null && _window___openpanel_replay !== void 0 ? _window___openpanel_replay : null);
                    }, r.onerror = ()=>{
                        console.warn("[OpenPanel] Failed to load replay script from", e), n(null);
                    }, document.head.appendChild(r);
                });
            }
            return await (parcelRequire("h2IFn"));
        } catch (t) {
            return console.warn("[OpenPanel] Failed to load replay module", t), null;
        }
    }
    debounce(t, e) {
        clearTimeout(this.debounceTimer), this.debounceTimer = setTimeout(t, e);
    }
    isServer() {
        return typeof document > "u";
    }
    trackOutgoingLinks() {
        this.isServer() || document.addEventListener("click", (t)=>{
            let e = t.target, n = e.closest("a");
            if (n && e) {
                let r = n.getAttribute("href");
                if (r === null || r === void 0 ? void 0 : r.startsWith("http")) try {
                    let s = new URL(r), i = window.location.hostname;
                    s.hostname !== i && super.track("link_out", {
                        href: r,
                        text: n.innerText || n.getAttribute("title") || e.getAttribute("alt") || e.getAttribute("title")
                    });
                } catch  {}
            }
        });
    }
    trackScreenViews() {
        if (this.isServer()) return;
        let t = history.pushState;
        history.pushState = function(...s) {
            let i = t.apply(this, s);
            return window.dispatchEvent(new Event("pushstate")), window.dispatchEvent(new Event("locationchange")), i;
        };
        let e = history.replaceState;
        history.replaceState = function(...s) {
            let i = e.apply(this, s);
            return window.dispatchEvent(new Event("replacestate")), window.dispatchEvent(new Event("locationchange")), i;
        }, window.addEventListener("popstate", ()=>{
            window.dispatchEvent(new Event("locationchange"));
        });
        let n = ()=>this.debounce(()=>this.screenView(), 50);
        this.options.trackHashChanges ? window.addEventListener("hashchange", n) : window.addEventListener("locationchange", n);
    }
    trackAttributes() {
        this.isServer() || document.addEventListener("click", (t)=>{
            let e = t.target, n = e.closest("button"), r = e.closest("a"), s = (n === null || n === void 0 ? void 0 : n.getAttribute("data-track")) ? n : (r === null || r === void 0 ? void 0 : r.getAttribute("data-track")) ? r : null;
            if (s) {
                let i = {};
                for (let a of s.attributes)a.name.startsWith("data-") && a.name !== "data-track" && (i[$24814a9736169cd8$var$h(a.name.replace(/^data-/, ""))] = a.value);
                let c = s.getAttribute("data-track");
                c && super.track(c, i);
            }
        });
    }
    track(t, e) {
        return super.track(t, {
            ...e,
            __path: this.lastPath
        });
    }
    screenView(t, e) {
        if (this.isServer()) return;
        let n, r;
        typeof t == "string" ? (n = t, r = e) : (n = window.location.href, r = t), this.lastPath !== n && (this.lastPath = n, super.track("screen_view", {
            ...r !== null && r !== void 0 ? r : {},
            __path: n,
            __title: document.title
        }));
    }
    async flushRevenue() {
        let t = this.pendingRevenues.map((e)=>super.revenue(e.amount, e.properties));
        await Promise.all(t), this.clearRevenue();
    }
    clearRevenue() {
        if (this.pendingRevenues = [], !this.isServer()) try {
            sessionStorage.removeItem("openpanel-pending-revenues");
        } catch  {}
    }
    pendingRevenue(t, e) {
        if (this.pendingRevenues.push({
            amount: t,
            properties: e
        }), !this.isServer()) try {
            sessionStorage.setItem("openpanel-pending-revenues", JSON.stringify(this.pendingRevenues));
        } catch  {}
    }
    constructor(t){
        super({
            sdk: "web",
            sdkVersion: "1.4.1",
            ...t
        });
        this.options = t;
        this.lastPath = "";
        this.pendingRevenues = [];
        if (!this.isServer()) {
            var _this_options_sessionReplay;
            try {
                let e = sessionStorage.getItem("openpanel-pending-revenues");
                if (e) {
                    let n = JSON.parse(e);
                    Array.isArray(n) && (this.pendingRevenues = n);
                }
            } catch  {
                this.pendingRevenues = [];
            }
            if (this.setGlobalProperties({
                __referrer: document.referrer
            }), this.options.trackScreenViews && (this.trackScreenViews(), setTimeout(()=>this.screenView(), 0)), this.options.trackOutgoingLinks && this.trackOutgoingLinks(), this.options.trackAttributes && this.trackAttributes(), (_this_options_sessionReplay = this.options.sessionReplay) === null || _this_options_sessionReplay === void 0 ? void 0 : _this_options_sessionReplay.enabled) {
                var _this_options_sessionReplay_sampleRate;
                let e = (_this_options_sessionReplay_sampleRate = this.options.sessionReplay.sampleRate) !== null && _this_options_sessionReplay_sampleRate !== void 0 ? _this_options_sessionReplay_sampleRate : 1;
                Math.random() < e && this.loadReplayModule().then((r)=>{
                    r && r.startReplayRecorder(this.options.sessionReplay, (s)=>{
                        this.send({
                            type: "replay",
                            payload: {
                                ...s
                            }
                        });
                    });
                });
            }
        }
    }
};
function $24814a9736169cd8$export$25c36ce29f48d69e() {
    return 'window.op=window.op||function(){var n=[];return new Proxy(function(){arguments.length&&n.push([].slice.call(arguments))},{get:function(t,r){return"q"===r?n:function(){n.push([r].concat([].slice.call(arguments)))}} ,has:function(t,r){return"q"===r}}) }();';
}


const $4a7db14ce90fb7a4$var$PROD_HOSTS = new Set([
    'peekababy.app',
    'www.peekababy.app'
]);
// Parcel inlines this from .env at build time. Only the *public* client id is
// ever referenced, so OPENPANEL_SECRET can never end up in the bundle.
const $4a7db14ce90fb7a4$var$CLIENT_ID = "b3ede638-aba8-4a1a-9c30-a2d639ef08f6";
const $4a7db14ce90fb7a4$var$enabled = typeof window !== 'undefined' && !!$4a7db14ce90fb7a4$var$CLIENT_ID && $4a7db14ce90fb7a4$var$PROD_HOSTS.has(window.location.hostname);
// Drop anything from the first '#' onward so a peer id in the URL hash can
// never ride along on a reserved property value.
function $4a7db14ce90fb7a4$var$stripHash(value) {
    return typeof value === 'string' ? value.split('#')[0] : value;
}
let $4a7db14ce90fb7a4$var$op = null;
if ($4a7db14ce90fb7a4$var$enabled) try {
    $4a7db14ce90fb7a4$var$op = new (0, $24814a9736169cd8$export$5ea5fea0727da6e2)({
        clientId: $4a7db14ce90fb7a4$var$CLIENT_ID,
        // Explicit events only. No auto screen views/links/attributes — this also
        // keeps the SDK's reserved `__path` empty so the hash never leaks.
        trackScreenViews: false,
        trackOutgoingLinks: false,
        trackAttributes: false,
        // Defense in depth: scrub the URL hash out of the reserved path/referrer
        // props on every outgoing event. Always returns true — host gating above,
        // not this filter, decides whether we track at all.
        filter: (payload)=>{
            const props = payload && payload.payload && payload.payload.properties;
            if (props) {
                if ('__path' in props) props.__path = $4a7db14ce90fb7a4$var$stripHash(props.__path);
                if ('__referrer' in props) props.__referrer = $4a7db14ce90fb7a4$var$stripHash(props.__referrer);
            }
            return true;
        }
    });
    // The SDK seeds __referrer from document.referrer on init; blank it so we
    // never report where the viewer came from.
    $4a7db14ce90fb7a4$var$op.setGlobalProperties({
        __referrer: ''
    });
} catch (e) {
    $4a7db14ce90fb7a4$var$op = null;
}
const $4a7db14ce90fb7a4$export$fa3d5b535a2458a1 = {
    APP_OPENED: 'app_opened',
    ROLE_SELECTED: 'role_selected',
    QR_SCANNED: 'qr_scanned',
    LINK_COPIED: 'link_copied',
    VIDEO_DIMMED: 'video_dimmed',
    MELODY_TOGGLED: 'melody_toggled',
    PEER_ERROR: 'peer_error',
    PWA_INSTALL_PROMPT_SHOWN: 'pwa_install_prompt_shown',
    PWA_INSTALLED: 'pwa_installed',
    APP_UPDATE_AVAILABLE: 'app_update_available',
    APP_UPDATE_APPLIED: 'app_update_applied',
    CAMERA_STARTED: 'camera_started',
    CAMERA_ERROR: 'camera_error',
    CAMERA_RECOVERED: 'camera_recovered',
    CAMERA_SWITCHED: 'camera_switched',
    VIEWER_CONNECTED: 'viewer_connected',
    VIEWER_DISCONNECTED: 'viewer_disconnected',
    STREAM_ESTABLISHED: 'stream_established',
    CONNECTION_LOST: 'connection_lost',
    MIC_ERROR: 'mic_error',
    TALKBACK_USED: 'talkback_used',
    VIDEO_FIT_CHANGED: 'video_fit_changed',
    ICE_FALLBACK: 'ice_fallback',
    ICE_CONNECTED: 'ice_connected',
    ICE_RESTART: 'ice_restart',
    TRUSTED_PARENT_ADDED: 'trusted_parent_added',
    TRUSTED_PARENT_REMOVED: 'trusted_parent_removed',
    BATTERY_LOW: 'battery_low',
    OUTAGE_ALARM: 'outage_alarm',
    CAMERA_FROZEN: 'camera_frozen',
    CAMERA_INTERRUPTED: 'camera_interrupted'
};
function $4a7db14ce90fb7a4$export$6b2a7d5132615086(name, properties) {
    if (!$4a7db14ce90fb7a4$var$op) return;
    try {
        const result = $4a7db14ce90fb7a4$var$op.track(name, properties);
        if (result && typeof result.catch === 'function') result.catch(()=>{});
    } catch (e) {
    /* analytics must never break the app */ }
}
// Peer errors are dominated by *non-fatal* conditions — chiefly a parent's
// auto-reconnect loop dialing a monitor that is momentarily offline, which
// makes PeerJS emit a `peer-unavailable` error on every single retry. Tracking
// each one buries real problems under thousands of "still waiting for the
// monitor" events. Instead we record only the *rising edge* of an ongoing
// non-fatal condition (one per outage, per type); notePeerRecovery() re-arms it
// once a connection is (re)established so a genuinely new outage is captured.
// Fatal errors are rare and user-blocking, so those are always tracked.
let $4a7db14ce90fb7a4$var$lastNonFatalPeerErrorType = null;
function $4a7db14ce90fb7a4$export$34ebde691a789a74(type, fatal) {
    if (fatal) {
        $4a7db14ce90fb7a4$export$6b2a7d5132615086($4a7db14ce90fb7a4$export$fa3d5b535a2458a1.PEER_ERROR, {
            type: type,
            fatal: true
        });
        return;
    }
    if (type === $4a7db14ce90fb7a4$var$lastNonFatalPeerErrorType) return; // same ongoing condition — already reported
    $4a7db14ce90fb7a4$var$lastNonFatalPeerErrorType = type;
    $4a7db14ce90fb7a4$export$6b2a7d5132615086($4a7db14ce90fb7a4$export$fa3d5b535a2458a1.PEER_ERROR, {
        type: type,
        fatal: false
    });
}
function $4a7db14ce90fb7a4$export$733dd075a3dd9ee5() {
    $4a7db14ce90fb7a4$var$lastNonFatalPeerErrorType = null;
}


// Cry detector for the baby monitor. Give it a MediaStream plus callbacks and it
// watches the microphone for the acoustic signature of a crying baby, firing
// `onCry` (which the host turns into a Web Push) and then rate-limiting itself.
//
// This is deliberately *not* a plain loudness gate. A volume threshold fires on
// doors, fans, TV and passing traffic while missing a muffled cry, which makes
// alerts feel random. Instead each frame is judged on three cheap signals taken
// from a single FFT:
//
//   1. Band energy — infant cries put most of their energy around 250-800 Hz, so
//      we measure that band rather than the whole spectrum. Rumble (HVAC, traffic)
//      and hiss (taps, static) land outside it and no longer count as "loud".
//   2. Adaptive floor — the trigger level tracks the room's own ambient level, so
//      the same code works in a quiet nursery and next to a noisy street without
//      a per-room sensitivity setting. Frames that look like a cry are excluded
//      from the floor, so a long wail can never teach the room to ignore it.
//   3. Shape — the band has to hold a meaningful share of the total energy, the
//      spectral centroid has to sit in a voice-like range, and the level has to
//      wobble. Steady in-band machine noise stays flat; a cry rises and falls.
//
// A cry then has to win a majority of frames in a ~2 s window (rather than an
// unbroken run), which tolerates the pauses between wails while still ignoring
// one-off bangs.
//
// `onLevel(level, trigger)` is called every frame so a UI can draw a live meter.
// A single shared AudioContext for all cry detectors. It must be created and
// resumed from a genuine user gesture (see unlockCryAudio), because iOS Safari
// leaves a context created outside activation in the 'suspended' state — and a
// suspended context never advances the analyser, so the host's mic is never
// examined and cry alerts silently never fire. The host's detector attaches its
// stream long after the tap (behind the async ICE fetch + peer open), so the
// gesture-time unlock is what keeps detection alive. Shared so we don't leak a
// context per detector either.
let $0b811e50742f6e70$var$sharedCtx = null;
function $0b811e50742f6e70$var$getSharedCtx() {
    if ($0b811e50742f6e70$var$sharedCtx) return $0b811e50742f6e70$var$sharedCtx;
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    try {
        $0b811e50742f6e70$var$sharedCtx = new Ctx();
    } catch (e) {
        $0b811e50742f6e70$var$sharedCtx = null;
    }
    return $0b811e50742f6e70$var$sharedCtx;
}
function $0b811e50742f6e70$export$6af181c0eda16843() {
    const ctx = $0b811e50742f6e70$var$getSharedCtx();
    if (ctx && ctx.state === 'suspended') ctx.resume().catch(()=>{});
    return ctx;
}
// The cry band itself, and the wider band we compare it against. The context
// band stops at 2.5 kHz because everything above it is hiss as far as this
// decision goes, and starts at 60 Hz to drop mains hum and handling thumps.
const $0b811e50742f6e70$var$CRY_LO_HZ = 250;
const $0b811e50742f6e70$var$CRY_HI_HZ = 800;
const $0b811e50742f6e70$var$CTX_LO_HZ = 60;
const $0b811e50742f6e70$var$CTX_HI_HZ = 2500;
// Decision window: 20 frames at ~10 Hz ≈ 2 s of history.
const $0b811e50742f6e70$var$WINDOW = 20;
// How fast the ambient floor follows the room. Downwards it moves quickly (the
// room really did go quiet); upwards it crawls, so a new steady noise is
// absorbed over ~10 s while a short cry never drags the floor up behind it.
const $0b811e50742f6e70$var$ADAPT_DOWN = 0.3;
const $0b811e50742f6e70$var$ADAPT_UP = 0.01;
function $0b811e50742f6e70$export$30232bc23eb59341(options = {}) {
    const opts = {
        // Absolute floor. Purely a "is there any real sound at all" guard so that in
        // a near-silent room the relative test can't promote faint rustling into a
        // cry. Band amplitudes run ~0.0003 (silent room) through ~0.007 (a muffled
        // cry heard across the room) to ~0.15 (a baby crying next to the phone), so
        // this sits well under a faint cry while staying far above room noise. In any
        // room louder than that, the adaptive gates below are what actually decide.
        minLevel: 0.003,
        // Relative gates: the band has to clear both a multiple of ambient and a
        // margin above its usual variation before the frame counts.
        floorMult: 2.5,
        devMult: 4,
        // Share of 60-2500 Hz energy that must sit inside the cry band.
        minRatio: 0.35,
        // Voice-like brightness window for the spectral centroid, in Hz.
        centroidLoHz: 180,
        centroidHiHz: 2200,
        // Peak-to-trough variation required across the window, as a fraction of the
        // peak. Rejects flat, unchanging in-band noise. Waived once the band is this
        // many times over the trigger, so a full-throated sustained scream — loud and
        // genuinely steady — still gets through.
        minModulation: 0.12,
        flatBypassMult: 2.5,
        // Frames of the window that must look like a cry before we fire.
        minCryFrames: 10,
        // Ignore the first moments after the mic opens while the floor is learned.
        warmupMs: 2000,
        // Quiet period after an alert. The shorter repeat applies while the room
        // still sounds like an actively crying baby, so ongoing distress isn't
        // silenced for the full cooldown.
        cooldownMs: 30000,
        repeatCooldownMs: 15000,
        ongoingRatio: 0.7,
        onCry: null,
        onLevel: null,
        ...options
    };
    let sourceNode = null;
    let analyser = null;
    let freq = null;
    let rafId = 0;
    let lastFrame = 0;
    let stream = null;
    let running = false;
    // Bin geometry, derived once per analyser from the context's sample rate.
    let binHz = 0;
    let ctxLoBin = 0;
    let ctxHiBin = 0;
    let cryLoBin = 0;
    let cryHiBin = 0;
    // Ambient model and decision window. These deliberately survive re-wiring: a
    // camera switch or reconnect shouldn't throw away what we know about the room
    // and blind us mid-cry.
    let floor = 0;
    let dev = 0;
    let calibrated = false;
    let calibratedAt = 0;
    const histCry = new Uint8Array($0b811e50742f6e70$var$WINDOW);
    const histLevel = new Float32Array($0b811e50742f6e70$var$WINDOW);
    let histAt = 0;
    let histLen = 0;
    let cryFrames = 0;
    let lastTrigger = 0;
    let lastCry = 0;
    function attach(mediaStream) {
        stream = mediaStream;
        if (running) wire();
    }
    // Sets the absolute minimum band level. The room-relative part of the decision
    // adapts on its own, so this only shifts the "any sound at all" guard.
    function setThreshold(t) {
        opts.minLevel = t;
    }
    function start() {
        running = true;
        wire();
    }
    function stop() {
        running = false;
        if (rafId) cancelAnimationFrame(rafId);
        rafId = 0;
        if (sourceNode) try {
            sourceNode.disconnect();
        } catch (e) {
        /* already disconnected */ }
        if (opts.onLevel) opts.onLevel(0, opts.minLevel);
    }
    function wire() {
        if (!stream) return;
        const ctx = $0b811e50742f6e70$var$getSharedCtx();
        if (!ctx) return;
        // Resume every time we wire: the context can slip back to 'suspended' after
        // the tab is backgrounded, and a suspended context silently stops analysis.
        if (ctx.state === 'suspended') ctx.resume().catch(()=>{});
        if (!analyser) {
            analyser = ctx.createAnalyser();
            // 2048 gives ~23 Hz bins at 48 kHz, enough to resolve the cry band. The
            // built-in smoothing is dialled back because the window below does our
            // time-domain reasoning and we want each frame to be current.
            analyser.fftSize = 2048;
            analyser.smoothingTimeConstant = 0.3;
            freq = new Float32Array(analyser.frequencyBinCount);
            binHz = ctx.sampleRate / analyser.fftSize;
            const lastBin = analyser.frequencyBinCount - 1;
            const bin = (hz)=>Math.min(lastBin, Math.max(0, Math.round(hz / binHz)));
            ctxLoBin = bin($0b811e50742f6e70$var$CTX_LO_HZ);
            ctxHiBin = bin($0b811e50742f6e70$var$CTX_HI_HZ);
            cryLoBin = bin($0b811e50742f6e70$var$CRY_LO_HZ);
            cryHiBin = bin($0b811e50742f6e70$var$CRY_HI_HZ);
        }
        // Re-point at the (possibly new, post-reconnect) stream. The analyser is
        // never connected to `destination`, so this taps the audio without echoing
        // it back out.
        if (sourceNode) try {
            sourceNode.disconnect();
        } catch (e) {
        /* already disconnected */ }
        try {
            sourceNode = ctx.createMediaStreamSource(stream);
            sourceNode.connect(analyser);
        } catch (e) {
            return;
        }
        loop();
    }
    // Pull one frame of spectrum and reduce it to the three signals we judge on.
    function measure() {
        analyser.getFloatFrequencyData(freq);
        let cryPow = 0;
        let totalPow = 0;
        let weighted = 0;
        for(let i = ctxLoBin; i <= ctxHiBin; i++){
            // getFloatFrequencyData reports dB relative to full scale; silence comes
            // back as -Infinity, which converts to a harmless 0.
            const p = Math.pow(10, freq[i] / 10);
            totalPow += p;
            weighted += i * binHz * p;
            if (i >= cryLoBin && i <= cryHiBin) cryPow += p;
        }
        return {
            level: Math.sqrt(cryPow),
            ratio: totalPow > 0 ? cryPow / totalPow : 0,
            centroid: totalPow > 0 ? weighted / totalPow : 0
        };
    }
    function pushHistory(cryish, level) {
        if (histLen === $0b811e50742f6e70$var$WINDOW) cryFrames -= histCry[histAt];
        else histLen++;
        histCry[histAt] = cryish ? 1 : 0;
        histLevel[histAt] = level;
        cryFrames += cryish ? 1 : 0;
        histAt = (histAt + 1) % $0b811e50742f6e70$var$WINDOW;
    }
    // Loudest frame in the window, plus its peak-to-trough spread as a fraction of
    // that peak.
    function windowStats() {
        let min = Infinity;
        let max = 0;
        for(let i = 0; i < histLen; i++){
            const v = histLevel[i];
            if (v < min) min = v;
            if (v > max) max = v;
        }
        return {
            peak: max,
            range: max > 0 ? (max - min) / max : 0
        };
    }
    function loop() {
        if (rafId) return;
        const tick = (now)=>{
            rafId = requestAnimationFrame(tick);
            if (now - lastFrame < 100) return; // ~10 Hz is plenty, easy on battery
            lastFrame = now;
            if (!analyser) return;
            const { level: level, ratio: ratio, centroid: centroid } = measure();
            // Seed the ambient model from the first frame we ever see, so the floor
            // starts somewhere sane instead of climbing from zero.
            if (!calibrated) {
                calibrated = true;
                floor = level;
                dev = level * 0.5;
                calibratedAt = now;
            }
            const trigger = Math.max(opts.minLevel, floor * opts.floorMult, floor + opts.devMult * dev);
            lastTrigger = trigger;
            const cryish = level >= trigger && ratio >= opts.minRatio && centroid >= opts.centroidLoHz && centroid <= opts.centroidHiHz;
            // Only quiet, non-cry frames teach the ambient model. Excluding cry-like
            // frames is what stops a long wail from being normalised into the floor.
            if (!cryish) {
                const rate = level < floor ? $0b811e50742f6e70$var$ADAPT_DOWN : $0b811e50742f6e70$var$ADAPT_UP;
                floor += (level - floor) * rate;
                dev += (Math.abs(level - floor) - dev) * rate;
            }
            pushHistory(cryish, level);
            if (opts.onLevel) opts.onLevel(level, trigger);
            detect(now);
        };
        rafId = requestAnimationFrame(tick);
    }
    function detect(now) {
        if (histLen < $0b811e50742f6e70$var$WINDOW) return;
        if (now - calibratedAt < opts.warmupMs) return;
        if (cryFrames < opts.minCryFrames) return;
        const { peak: peak, range: range } = windowStats();
        if (range < opts.minModulation && peak < lastTrigger * opts.flatBypassMult) return;
        // Still mostly cry-like? Treat this as the same episode continuing and allow
        // the shorter repeat interval rather than the full cooldown.
        const ongoing = cryFrames / $0b811e50742f6e70$var$WINDOW >= opts.ongoingRatio;
        const cooldown = ongoing ? opts.repeatCooldownMs : opts.cooldownMs;
        if (now - lastCry < cooldown) return;
        lastCry = now;
        if (opts.onCry) opts.onCry();
    }
    function resume() {
        if (running) wire();
    }
    return {
        attach: attach,
        start: start,
        stop: stop,
        setThreshold: setThreshold,
        resume: resume
    };
}


// Outbound video encoder caps for the monitor.
//
// Left to browser defaults, each viewer's encoder ramps from a conservative
// bitrate (mushy first seconds, exactly when a parent glances at the baby) and
// prefers framerate over resolution — backwards for a near-static nursery where
// the parent wants to read position and breathing, not motion. Because PeerJS
// builds one RTCPeerConnection per viewer, an uncapped monitor also runs one
// full-rate encoder per parent for hours, which heats the phone and can itself
// trip the camera-freeze recovery path.
//
// Caps chosen for an overnight monitor: a firm bitrate ceiling for a stable
// picture, a low framerate (a sleeping baby needs no more), and resolution held
// over framerate when bandwidth dips.
const $9697a5d72bef5841$export$6f6284428cf502f8 = 700000; // ~3 GB over a 10-hour night
const $9697a5d72bef5841$export$e84570e118533e42 = 15;
async function $9697a5d72bef5841$export$a75a266ae9ba7f11(pc) {
    if (!pc || typeof pc.getSenders !== 'function') return;
    const sender = pc.getSenders().find((s)=>s.track && s.track.kind === 'video');
    if (!sender || typeof sender.getParameters !== 'function') return;
    try {
        const params = sender.getParameters();
        // Firefox leaves encodings empty until negotiation completes; seed one so the
        // caps land instead of silently no-op'ing.
        if (!params.encodings || !params.encodings.length) params.encodings = [
            {}
        ];
        params.encodings[0].maxBitrate = $9697a5d72bef5841$export$6f6284428cf502f8;
        params.encodings[0].maxFramerate = $9697a5d72bef5841$export$e84570e118533e42;
        // A still scene should lose frames, not sharpness, before it drops resolution.
        params.degradationPreference = 'maintain-resolution';
        await sender.setParameters(params);
    } catch (e) {
    /* transient — caps reapply on the next connect / track replace */ }
}


// In-place ICE restart for a live media call, so a network blip (Wi-Fi <-> LTE
// handoff, NAT rebind) recovers in about a second instead of a full re-dial.
//
// PeerJS has no renegotiation path and, worse, tears the peer connection down
// the instant ICE fails (its oniceconnectionstatechange closes the connection).
// We work around both without forking it:
//   - Override pc.oniceconnectionstatechange so a failure drives a restart
//     instead of a teardown. PeerJS assigns it as a property, so our assignment
//     wins; we keep a reference and forward the harmless states.
//   - Carry the renegotiation SDP over the signaling broker as custom message
//     types. The broker relays any type verbatim and PeerJS surfaces every
//     inbound frame on peer.socket 'message', so this needs no PeerJS changes.
//
// The parent is always the offerer (peer.call) and the monitor always answers,
// so there is no glare: the parent owns the restart, the monitor responds. Both
// sides attach a controller — the monitor's is passive (it waits for the offer)
// but still needed to stop PeerJS closing the monitor's side on ICE failure.
//
// If anything goes wrong — an old peer that ignores the custom messages, a
// restart that doesn't reach `connected` in time, or repeated failures — we call
// onGiveUp(), which is the caller's existing full re-dial / drop path. Worst case
// is today's behaviour plus a few seconds, only on connections already failing.

const $d16014fbca14af38$var$MSG_OFFER = 'PB-ICE-RESTART-OFFER';
const $d16014fbca14af38$var$MSG_ANSWER = 'PB-ICE-RESTART-ANSWER';
const $d16014fbca14af38$var$DISCONNECT_GRACE_MS = 1500; // let a brief 'disconnected' self-heal first
const $d16014fbca14af38$var$RESTART_TIMEOUT_MS = 6000; // offerer: give up on a restart that stalls
const $d16014fbca14af38$var$ANSWERER_WAIT_MS = 10000; // answerer: give up if no offer ever arrives
const $d16014fbca14af38$var$MAX_ATTEMPTS = 2; // offerer restart attempts before onGiveUp
// connectionId -> controller, so a single per-peer socket listener can route an
// inbound offer/answer to the right call among many (the monitor fans out).
const $d16014fbca14af38$var$controllers = new Map();
const $d16014fbca14af38$var$boundPeers = new WeakSet();
function $d16014fbca14af38$var$bindSocket(peer) {
    if (!peer || !peer.socket || $d16014fbca14af38$var$boundPeers.has(peer)) return;
    $d16014fbca14af38$var$boundPeers.add(peer);
    peer.socket.on('message', (msg)=>{
        if (!msg || msg.type !== $d16014fbca14af38$var$MSG_OFFER && msg.type !== $d16014fbca14af38$var$MSG_ANSWER) return;
        const payload = msg.payload || {};
        const ctrl = payload.connectionId && $d16014fbca14af38$var$controllers.get(payload.connectionId);
        if (!ctrl) return;
        if (msg.type === $d16014fbca14af38$var$MSG_OFFER) ctrl._onRemoteOffer(msg.src, payload);
        else ctrl._onRemoteAnswer(msg.src, payload);
    });
}
function $d16014fbca14af38$export$2a8b0ce368e0bd6c(pc, { peer: peer, remoteId: remoteId, connectionId: connectionId, role: role, onGiveUp: onGiveUp, onRecovered: onRecovered }) {
    if (!pc || !peer || !connectionId) return null;
    $d16014fbca14af38$var$bindSocket(peer);
    const savedIceState = pc.oniceconnectionstatechange;
    const savedIceCandidate = pc.onicecandidate;
    let destroyed = false;
    let recovering = false;
    let attempts = 0;
    let graceTimer = null;
    let watchdog = null;
    const clearTimers = ()=>{
        clearTimeout(graceTimer);
        graceTimer = null;
        clearTimeout(watchdog);
        watchdog = null;
    };
    const giveUp = (reason)=>{
        if (destroyed) return;
        clearTimers();
        recovering = false;
        (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).ICE_RESTART, {
            role: role,
            outcome: 'give_up',
            reason: reason
        });
        if (typeof onGiveUp === 'function') onGiveUp(reason);
    };
    const succeed = ()=>{
        clearTimers();
        const wasRecovering = recovering;
        recovering = false;
        attempts = 0;
        if (wasRecovering) {
            (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).ICE_RESTART, {
                role: role,
                outcome: 'recovered'
            });
            if (typeof onRecovered === 'function') onRecovered();
        }
    };
    // Re-arm PeerJS's own candidate sender (it clears it on ICE 'completed') so the
    // restart's fresh candidates trickle out over the normal CANDIDATE path.
    const rearmCandidates = ()=>{
        if (savedIceCandidate) pc.onicecandidate = savedIceCandidate;
    };
    const send = (type, payload)=>{
        try {
            peer.socket.send({
                type: type,
                payload: payload,
                dst: remoteId
            });
            return true;
        } catch (e) {
            return false;
        }
    };
    const armWatchdog = ()=>{
        clearTimeout(watchdog);
        watchdog = setTimeout(()=>{
            if (destroyed || !recovering) return;
            const st = pc.iceConnectionState;
            if (st === 'connected' || st === 'completed') {
                succeed();
                return;
            }
            // Offerer may retry; answerer just gives up (the offerer drives).
            if (role === 'offerer' && attempts < $d16014fbca14af38$var$MAX_ATTEMPTS) {
                recovering = false;
                startOffer('watchdog-retry');
            } else giveUp('watchdog');
        }, role === 'offerer' ? $d16014fbca14af38$var$RESTART_TIMEOUT_MS : $d16014fbca14af38$var$ANSWERER_WAIT_MS);
    };
    async function startOffer(reason) {
        if (destroyed || recovering) return;
        if (attempts >= $d16014fbca14af38$var$MAX_ATTEMPTS) return giveUp('attempts-exhausted');
        recovering = true;
        attempts += 1;
        (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).ICE_RESTART, {
            role: role,
            outcome: 'attempt',
            attempt: attempts,
            reason: reason
        });
        try {
            rearmCandidates();
            // Push the peer's current ICE servers onto this live connection before
            // restarting. ice.js keeps peer.options.config fresh but PeerJS only reads
            // it when building a *new* connection, so without this a restart would
            // reuse possibly-expired TURN credentials.
            if (typeof pc.setConfiguration === 'function' && peer.options && peer.options.config) try {
                pc.setConfiguration(peer.options.config);
            } catch (e) {}
            if (typeof pc.restartIce === 'function') pc.restartIce();
            // iceRestart covers browsers without restartIce(). The transceivers set up
            // by the original peer.call are already on the pc, so a plain offer
            // preserves them — no legacy offerToReceive* flags, which only risk quirks
            // when mixed with transceivers (notably on Safari).
            const offer = await pc.createOffer({
                iceRestart: true
            });
            if (destroyed) return;
            await pc.setLocalDescription(offer);
            if (destroyed) return;
            if (!send($d16014fbca14af38$var$MSG_OFFER, {
                connectionId: connectionId,
                sdp: pc.localDescription
            })) return giveUp('send-failed');
            armWatchdog();
        } catch (e) {
            giveUp('offer-error');
        }
    }
    const controller = {
        isRecovering: ()=>recovering,
        // Called by the app's connection-state handlers (and internally from the ICE
        // override) when the link looks down. Idempotent while a restart is in flight.
        recover (reason) {
            if (destroyed || recovering) return;
            if (role === 'offerer') startOffer(reason);
            else {
                // Answerer: wait for the offerer's restart offer; give up if none lands.
                recovering = true;
                (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).ICE_RESTART, {
                    role: role,
                    outcome: 'await_offer',
                    reason: reason
                });
                armWatchdog();
            }
        },
        async _onRemoteOffer (src, payload) {
            if (destroyed || role !== 'answerer') return;
            if (src && remoteId && src !== remoteId) return;
            recovering = true;
            try {
                rearmCandidates();
                await pc.setRemoteDescription(payload.sdp);
                if (destroyed) return;
                const answer = await pc.createAnswer();
                await pc.setLocalDescription(answer);
                if (destroyed) return;
                send($d16014fbca14af38$var$MSG_ANSWER, {
                    connectionId: connectionId,
                    sdp: pc.localDescription
                });
                armWatchdog();
            } catch (e) {
                giveUp('answer-error');
            }
        },
        async _onRemoteAnswer (src, payload) {
            if (destroyed || role !== 'offerer' || !recovering) return;
            if (src && remoteId && src !== remoteId) return;
            try {
                await pc.setRemoteDescription(payload.sdp);
            // Success is confirmed by the ICE state reaching 'connected'; the
            // watchdog is the backstop if it never does.
            } catch (e) {
                giveUp('set-answer-error');
            }
        },
        destroy () {
            if (destroyed) return;
            destroyed = true;
            clearTimers();
            if ($d16014fbca14af38$var$controllers.get(connectionId) === controller) $d16014fbca14af38$var$controllers.delete(connectionId);
            // Best-effort restore so a lingering pc behaves as PeerJS expects.
            try {
                pc.oniceconnectionstatechange = savedIceState;
            } catch (e) {}
        }
    };
    pc.oniceconnectionstatechange = (event)=>{
        const st = pc.iceConnectionState;
        if (st === 'failed') {
            controller.recover('ice-failed');
            return; // never forward: PeerJS's handler would close the connection
        }
        if (st === 'disconnected') {
            clearTimeout(graceTimer);
            graceTimer = setTimeout(()=>{
                const now = pc.iceConnectionState;
                if (now === 'disconnected' || now === 'failed') controller.recover('ice-disconnected');
            }, $d16014fbca14af38$var$DISCONNECT_GRACE_MS);
            return; // PeerJS only logs 'disconnected'; safe not to forward
        }
        if (st === 'connected' || st === 'completed') {
            if (recovering) succeed();
            else attempts = 0; // a healthy stretch refreshes the restart budget
        }
        if (typeof savedIceState === 'function') savedIceState.call(pc, event);
    };
    $d16014fbca14af38$var$controllers.set(connectionId, controller);
    return controller;
}


// Web Push wiring for the client.
//
// - The viewer subscribes (enablePush) and registers its subscription with the
//   Worker, keyed by the host it's watching.
// - The host calls notifyCry() when it detects crying; the Worker then fans the
//   push out to every viewer subscribed to that host.
//
// The VAPID public key is not a secret — it's the applicationServerKey the push
// service uses to verify the Worker's signed requests. The matching private key
// lives only in the Worker (turn-worker/.dev.vars locally, a secret in prod).
const $02d65636a04e74fb$var$VAPID_PUBLIC_KEY = 'BJb6yFmAvl5d1i6hO1nDRaePQfdYKwTCV4qDfbOvJeapu2jUxlTGtA2-GHsQ1_JYc3aXus4TXmUqfstEJiD2Bu0';
function $02d65636a04e74fb$export$677e3fefb97c4374() {
    if (window.PEEKABABY_WORKER_URL) return $02d65636a04e74fb$var$stripPath(window.PEEKABABY_WORKER_URL);
    const meta = document.querySelector('meta[name="turn-credentials-url"]');
    const fromMeta = meta && meta.content && meta.content.trim();
    if (fromMeta) return fromMeta.replace(/\/turn-credentials\/?$/, '');
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') return 'http://localhost:8787';
    return '';
}
function $02d65636a04e74fb$var$stripPath(url) {
    try {
        const u = new URL(url);
        return u.origin;
    } catch (e) {
        return url.replace(/\/+$/, '');
    }
}
function $02d65636a04e74fb$var$urlBase64ToUint8Array(base64) {
    const padding = '='.repeat((4 - base64.length % 4) % 4);
    const normalized = (base64 + padding).replace(/-/g, '+').replace(/_/g, '/');
    const raw = atob(normalized);
    const out = new Uint8Array(raw.length);
    for(let i = 0; i < raw.length; i++)out[i] = raw.charCodeAt(i);
    return out;
}
function $02d65636a04e74fb$var$pushSupported() {
    return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}
async function $02d65636a04e74fb$export$a7ae20dceff8fa2e(hostId) {
    if (!$02d65636a04e74fb$var$pushSupported()) return 'unsupported';
    if (Notification.permission === 'denied') return 'denied';
    if (Notification.permission !== 'granted') {
        const perm = await Notification.requestPermission();
        if (perm !== 'granted') return 'denied';
    }
    try {
        const reg = await navigator.serviceWorker.ready;
        let sub = await reg.pushManager.getSubscription();
        if (!sub) sub = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: $02d65636a04e74fb$var$urlBase64ToUint8Array($02d65636a04e74fb$var$VAPID_PUBLIC_KEY)
        });
        const res = await fetch(`${$02d65636a04e74fb$export$677e3fefb97c4374()}/subscribe`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                hostId: hostId,
                subscription: sub.toJSON()
            })
        });
        return res.ok ? 'ok' : 'error';
    } catch (e) {
        console.warn('[CAMMIRROR] enablePush failed:', e && e.message);
        return 'error';
    }
}
async function $02d65636a04e74fb$export$3860423f821f687f() {
    if (!$02d65636a04e74fb$var$pushSupported()) return;
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return;
    try {
        await fetch(`${$02d65636a04e74fb$export$677e3fefb97c4374()}/unsubscribe`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                endpoint: sub.endpoint
            })
        });
    } catch (e) {
    /* ignore — we still unsubscribe locally below */ }
    try {
        await sub.unsubscribe();
    } catch (e) {
    /* already gone */ }
}
async function $02d65636a04e74fb$export$b125ac0187639473(hostId) {
    if (!hostId) return;
    try {
        await fetch(`${$02d65636a04e74fb$export$677e3fefb97c4374()}/notify`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                hostId: hostId
            })
        });
    } catch (e) {
        console.warn('[CAMMIRROR] notify failed:', e && e.message);
    }
}
async function $02d65636a04e74fb$export$be60aaa86914f312(hostId) {
    if (!hostId) return null;
    try {
        const res = await fetch(`${$02d65636a04e74fb$export$677e3fefb97c4374()}/presence?hostId=${encodeURIComponent(hostId)}`, {
            method: 'GET'
        });
        if (!res.ok) return null;
        const data = await res.json();
        return typeof data.live === 'boolean' ? data.live : null;
    } catch (e) {
        return null;
    }
}
function $02d65636a04e74fb$export$2d15c207f65bc2bd(hostId) {
    if (!hostId) return;
    const url = `${$02d65636a04e74fb$export$677e3fefb97c4374()}/goodbye`;
    const body = JSON.stringify({
        hostId: hostId
    });
    try {
        if (navigator.sendBeacon) {
            const blob = new Blob([
                body
            ], {
                type: 'text/plain'
            });
            if (navigator.sendBeacon(url, blob)) return;
        }
    } catch (e) {
    /* fall through to fetch */ }
    try {
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: body,
            keepalive: true
        }).catch(()=>{});
    } catch (e) {
    /* best-effort */ }
}



var $7f9c3ae467f9b3e6$exports = {};
$7f9c3ae467f9b3e6$exports = $parcel$resolve("1jVtq");


// Parcel resolves this to the hashed, bundled asset URL at build time.
const $63e260cbcedef6c4$var$MELODY_URL = new URL($7f9c3ae467f9b3e6$exports);
// Auto-stop the lullaby after this long. It loops, and cry detection is muted
// while it plays (the melody would trip it), so an unbounded lullaby could
// silence cry alerts indefinitely. Capping it keeps that blind spot bounded.
const $63e260cbcedef6c4$var$MELODY_MAX_MS = 600000;
// Auto-dismiss an unanswered "new parent" heads-up (as if Ignored) so it can't
// linger on screen or stall the queue behind it if the host never taps. The
// parent keeps watching either way; they'll simply prompt again next session.
const $63e260cbcedef6c4$var$TRUST_PROMPT_MS = 15000;
// Warn parents once the monitor's battery drops below this (and isn't charging).
// A dying monitor silently kills the whole feed, so parents — who are away from
// the room — get a heads-up while there's still time to plug it in.
const $63e260cbcedef6c4$var$BATTERY_LOW = 0.20;
// How often the monitor broadcasts a live-video heartbeat to parents. It carries
// a counter of genuine camera frames (see startLiveHeartbeat), so a parent can
// confirm the *source* is actually producing new pictures — not just that bytes
// or decoded frames are arriving (a re-encoded frozen frame would fake those).
const $63e260cbcedef6c4$var$LIVE_HEARTBEAT_MS = 2000;
// The lullaby plays out of the baby monitor's speaker, but a parent can start
// it remotely. A remote command carries no user gesture on the monitor, so the
// browser's autoplay policy would reject the very first Audio.play() unless the
// element was already "unblocked" by an earlier gesture on this device. That's
// why, before this priming, a parent could only start the melody *after* the
// monitor had played it once locally. We keep the element as a module-level
// singleton so it can be unlocked at role-pick time (a real tap) and reused by
// the Host instance created moments later.
let $63e260cbcedef6c4$var$melodyAudio = null;
// A camera/mic stream acquired during the "baby monitor" tap. iOS Safari only
// shows the getUserMedia permission prompt under transient user activation, and
// that activation is gone by the time the peer has opened and Host is built (it
// sits behind an async ICE fetch + a signalling round-trip). Requesting the
// camera there — as we used to — makes iOS reject with NotAllowedError on the
// first run. Priming it inside the real tap keeps the prompt within activation;
// Host.startCamera() then adopts this stream instead of re-requesting.
let $63e260cbcedef6c4$var$cameraPrime = null;
function $63e260cbcedef6c4$export$927a79cc45f962c6() {
    if ($63e260cbcedef6c4$var$cameraPrime) return $63e260cbcedef6c4$var$cameraPrime;
    try {
        $63e260cbcedef6c4$var$cameraPrime = navigator.mediaDevices.getUserMedia({
            video: {
                frameRate: {
                    ideal: 15,
                    max: 20
                }
            },
            audio: {
                echoCancellation: true
            }
        });
        // startCamera() awaits this same promise and surfaces any error properly;
        // this no-op handler just prevents an "unhandled rejection" in the window
        // between priming and Host being constructed.
        $63e260cbcedef6c4$var$cameraPrime.catch(()=>{});
    } catch (e) {
        $63e260cbcedef6c4$var$cameraPrime = null;
    }
    return $63e260cbcedef6c4$var$cameraPrime;
}
// Hand the primed stream promise (if any) to the Host, clearing it so the
// stream is owned in exactly one place.
function $63e260cbcedef6c4$var$takePrimedCamera() {
    const primed = $63e260cbcedef6c4$var$cameraPrime;
    $63e260cbcedef6c4$var$cameraPrime = null;
    return primed;
}
function $63e260cbcedef6c4$export$249b5faa0753441b() {
    const primed = $63e260cbcedef6c4$var$cameraPrime;
    $63e260cbcedef6c4$var$cameraPrime = null;
    if (!primed) return;
    primed.then((stream)=>stream.getTracks().forEach((tr)=>tr.stop())).catch(()=>{});
}
function $63e260cbcedef6c4$var$getMelodyAudio() {
    if (!$63e260cbcedef6c4$var$melodyAudio) {
        $63e260cbcedef6c4$var$melodyAudio = new Audio($63e260cbcedef6c4$var$MELODY_URL);
        $63e260cbcedef6c4$var$melodyAudio.loop = true;
        $63e260cbcedef6c4$var$melodyAudio.preload = 'auto';
    }
    return $63e260cbcedef6c4$var$melodyAudio;
}
// A ~0-length silent WAV. We play THIS on the melody element (not the lullaby)
// to satisfy the autoplay gate, so priming is guaranteed silent and can't
// buffer/loop the real track.
const $63e260cbcedef6c4$var$SILENT_WAV = 'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQAAAAA=';
function $63e260cbcedef6c4$export$4ed10ee742b6ee53() {
    const audio = $63e260cbcedef6c4$var$getMelodyAudio();
    try {
        const restore = ()=>{
            try {
                audio.pause();
                audio.loop = true;
                audio.muted = false; // setMelody controls audibility from here on
                audio.src = $63e260cbcedef6c4$var$MELODY_URL.toString();
                audio.load();
            } catch (e) {}
        };
        audio.loop = false;
        audio.muted = true;
        audio.src = $63e260cbcedef6c4$var$SILENT_WAV;
        const p = audio.play();
        if (p && p.then) p.then(restore).catch(restore);
        else restore();
    } catch (e) {
    /* If play() throws we simply skip priming; local playback still works. */ }
}
const $63e260cbcedef6c4$var$$connect = document.getElementById('connect');
const $63e260cbcedef6c4$var$$switchCamera = document.getElementById('switch-camera');
const $63e260cbcedef6c4$var$$toggleVideo = document.getElementById('toggle-video');
const $63e260cbcedef6c4$var$$videoOff = document.getElementById('video-off');
const $63e260cbcedef6c4$var$$addParent = document.getElementById('add-parent');
const $63e260cbcedef6c4$var$$melodyToggle = document.getElementById('melody-toggle');
const $63e260cbcedef6c4$var$$copyLink = document.getElementById('copy-link');
const $63e260cbcedef6c4$var$$hostStatus = document.getElementById('host-status');
const $63e260cbcedef6c4$var$$trustPrompt = document.getElementById('trust-prompt');
const $63e260cbcedef6c4$var$$manageTrusted = document.getElementById('manage-trusted');
const $63e260cbcedef6c4$var$$trustedOverlay = document.getElementById('trusted-overlay');
class $63e260cbcedef6c4$export$2e2bcd8739ae039 {
    bindControls() {
        $63e260cbcedef6c4$var$$switchCamera.addEventListener('click', ()=>this.switchCamera());
        $63e260cbcedef6c4$var$$copyLink.addEventListener('click', ()=>this.copyLink());
        $63e260cbcedef6c4$var$$toggleVideo.addEventListener('click', ()=>this.setVideoDimmed(!this.videoDimmed));
        if ($63e260cbcedef6c4$var$$videoOff) $63e260cbcedef6c4$var$$videoOff.addEventListener('click', ()=>this.setVideoDimmed(false));
        if ($63e260cbcedef6c4$var$$melodyToggle) $63e260cbcedef6c4$var$$melodyToggle.addEventListener('click', ()=>this.toggleMelody());
        // "Add another parent" re-shows the QR card while live; tapping again hides.
        // Transition it so the QR card scales in/out over the live view rather than
        // popping, matching the morph used on the initial connect screen.
        $63e260cbcedef6c4$var$$addParent.addEventListener('click', ()=>{
            // Decide the next state up front: the View Transitions update callback runs
            // asynchronously, so reading the toggle's result after it would be stale.
            // Flip the class and the button's pressed state together inside the
            // callback so the two can never desync.
            const showing = !document.body.classList.contains('show-qr');
            (0, $b68ecd39b69a2afc$export$20ac98a4b4fe8b85)(()=>{
                document.body.classList.toggle('show-qr', showing);
                (0, $b68ecd39b69a2afc$export$27972cfaa3ad15e9)($63e260cbcedef6c4$var$$addParent, showing);
            });
        });
        if ($63e260cbcedef6c4$var$$manageTrusted) $63e260cbcedef6c4$var$$manageTrusted.addEventListener('click', ()=>this.openTrustedOverlay());
        if ($63e260cbcedef6c4$var$$trustedOverlay) {
            $63e260cbcedef6c4$var$$trustedOverlay.addEventListener('click', (e)=>{
                if (e.target === $63e260cbcedef6c4$var$$trustedOverlay || e.target.closest('.overlay-close')) $63e260cbcedef6c4$var$$trustedOverlay.hidden = true;
                const removeBtn = e.target.closest('[data-remove-id]');
                if (removeBtn) this.removeTrusted(removeBtn.getAttribute('data-remove-id'));
            });
            // Persist a rename when the field loses focus or the value commits. Uses
            // 'change' (bubbles) so a single delegated listener covers every row.
            $63e260cbcedef6c4$var$$trustedOverlay.addEventListener('change', (e)=>{
                const input = e.target.closest('[data-rename-id]');
                if (input) this.renameTrusted(input.getAttribute('data-rename-id'), input.value);
            });
            // Enter commits (and blurs) the rename rather than doing nothing.
            $63e260cbcedef6c4$var$$trustedOverlay.addEventListener('keydown', (e)=>{
                if (e.key === 'Enter' && e.target.closest('[data-rename-id]')) e.target.blur();
            });
        }
    }
    // ---- Trusted-parent recognition -----------------------------------------
    // Decide whether an incoming parent needs a heads-up. Trusted or
    // already-prompted parents (and metadata-less clients, which we can't save)
    // pass silently; a genuinely new parent is queued for a prompt.
    considerTrust(clientId, name) {
        if (!clientId) return; // metadata-less client: nothing to persist, stay silent
        if ((0, $b68ecd39b69a2afc$export$9394b6ae1d59f447)(clientId)) return;
        if (this.promptedIds.has(clientId)) return;
        if (this.trustQueue.some((q)=>q.id === clientId)) return;
        this.promptedIds.add(clientId);
        this.trustQueue.push({
            id: clientId,
            name: name
        });
        this.pumpTrustQueue();
    }
    // Show queued prompts one at a time so several new parents don't stack.
    pumpTrustQueue() {
        if (this.trustActive || !this.trustQueue.length) return;
        this.trustActive = this.trustQueue.shift();
        this.showTrustPrompt(this.trustActive.id, this.trustActive.name);
    }
    showTrustPrompt(clientId, name) {
        if (!$63e260cbcedef6c4$var$$trustPrompt) return;
        const $text = $63e260cbcedef6c4$var$$trustPrompt.querySelector('.trust-text');
        if ($text) $text.textContent = name ? (0, $03c039b69e20a322$export$625550452a3fa3ec)('trust.newParentNamed', {
            name: name
        }) : (0, $03c039b69e20a322$export$625550452a3fa3ec)('trust.newParent');
        const $allow = $63e260cbcedef6c4$var$$trustPrompt.querySelector('.trust-allow');
        const $ignore = $63e260cbcedef6c4$var$$trustPrompt.querySelector('.trust-ignore');
        // Detach BOTH handlers on either choice, then fade out and (once hidden)
        // release the slot and reveal the next queued parent. Detaching both is
        // what keeps the unchosen button from firing for the next queued prompt.
        const onAllow = ()=>{
            (0, $b68ecd39b69a2afc$export$490f701ed48c171)(clientId, name);
            (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).TRUSTED_PARENT_ADDED, {
                total: (0, $b68ecd39b69a2afc$export$46bb5b97e62dc42)().length
            });
            if ($63e260cbcedef6c4$var$$trustedOverlay && !$63e260cbcedef6c4$var$$trustedOverlay.hidden) this.renderTrustedList();
            resolve();
        };
        const resolve = ()=>{
            clearTimeout(this.trustPromptTimer);
            if ($allow) $allow.removeEventListener('click', onAllow);
            if ($ignore) $ignore.removeEventListener('click', resolve);
            (0, $b68ecd39b69a2afc$export$c96659240d08478b)($63e260cbcedef6c4$var$$trustPrompt, ()=>{
                this.trustActive = null;
                this.pumpTrustQueue();
            });
        };
        if ($allow) $allow.addEventListener('click', onAllow);
        if ($ignore) $ignore.addEventListener('click', resolve);
        // Falls through to the Ignore path so an unattended prompt never blocks the
        // queue or sticks on screen.
        this.trustPromptTimer = setTimeout(resolve, $63e260cbcedef6c4$var$TRUST_PROMPT_MS);
        (0, $b68ecd39b69a2afc$export$39c365eaabfb0a68)($63e260cbcedef6c4$var$$trustPrompt);
    }
    openTrustedOverlay() {
        if (!$63e260cbcedef6c4$var$$trustedOverlay) return;
        this.renderTrustedList();
        $63e260cbcedef6c4$var$$trustedOverlay.hidden = false;
    }
    // Render the saved trusted parents into the overlay, each with a Remove
    // button, or an empty-state line when none are saved yet.
    renderTrustedList() {
        if (!$63e260cbcedef6c4$var$$trustedOverlay) return;
        const $list = $63e260cbcedef6c4$var$$trustedOverlay.querySelector('.trusted-list');
        if (!$list) return;
        const parents = (0, $b68ecd39b69a2afc$export$46bb5b97e62dc42)();
        $list.replaceChildren();
        if (!parents.length) {
            const $empty = document.createElement('li');
            $empty.className = 'trusted-empty';
            $empty.textContent = (0, $03c039b69e20a322$export$625550452a3fa3ec)('trust.empty');
            $list.appendChild($empty);
            return;
        }
        parents.forEach((p)=>{
            const $row = document.createElement('li');
            $row.className = 'trusted-row';
            // Editable label so the host can name each device something recognizable.
            const $name = document.createElement('input');
            $name.type = 'text';
            $name.className = 'trusted-name';
            $name.value = p.name || p.id;
            $name.setAttribute('data-rename-id', p.id);
            $name.setAttribute('aria-label', (0, $03c039b69e20a322$export$625550452a3fa3ec)('trust.nameAria'));
            $row.appendChild($name);
            const $remove = document.createElement('button');
            $remove.type = 'button';
            $remove.className = 'trusted-remove';
            $remove.setAttribute('data-remove-id', p.id);
            $remove.textContent = (0, $03c039b69e20a322$export$625550452a3fa3ec)('trust.remove');
            $row.appendChild($remove);
            $list.appendChild($row);
        });
    }
    // Forget a trusted parent. They can still connect (link possession is enough)
    // but will raise a fresh heads-up next time — so clear any session dedupe too.
    removeTrusted(id) {
        if (!id) return;
        (0, $b68ecd39b69a2afc$export$22c6639596c9db5)(id);
        this.promptedIds.delete(id);
        (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).TRUSTED_PARENT_REMOVED, {
            total: (0, $b68ecd39b69a2afc$export$46bb5b97e62dc42)().length
        });
        this.renderTrustedList();
    }
    // Save a host-chosen label. A blank value is ignored by the store; re-render
    // so the field snaps back to the persisted name rather than showing the blank.
    renameTrusted(id, name) {
        if (!id) return;
        (0, $b68ecd39b69a2afc$export$1b3dfc800d9a80c3)(id, name);
        this.renderTrustedList();
    }
    // Register an answered viewer call: give it its own audio sink (so several
    // phones can be heard at once) and watch its connection so it's removed from
    // the count when it drops.
    //
    // Viewers are keyed by their peer id — which is STABLE across that parent's
    // network changes — rather than the per-call connectionId. When a parent's
    // phone hands off (e.g. Wi-Fi -> mobile) it tears down the old media call and
    // places a brand-new one with a fresh connectionId but the same peer id. Key
    // by peer id and adopt the replacement in place so the live count stays put
    // instead of briefly showing the same parent twice or flickering the number.
    trackViewer(call, meta = {}) {
        const id = call.peer;
        let entry = this.connections.get(id);
        if (entry) {
            // Keep the recognized identity fresh if the parent re-announced it.
            if (meta.clientId) {
                entry.clientId = meta.clientId;
                entry.name = meta.name || entry.name;
            }
            // Same parent reconnecting: swap in the new call, keep the existing audio
            // sink and the "active" flag so the count doesn't dip and recover.
            clearTimeout(entry.graceTimer);
            entry.graceTimer = null;
            const previous = entry.call;
            // Adopt the new call BEFORE closing the old one: MediaConnection.close()
            // emits 'close' synchronously, and dropViewer only bails when the closing
            // call is no longer the current one — so we must reassign first or we'd
            // evict the very viewer we're trying to keep.
            entry.call = call;
            if (previous && previous !== call) try {
                previous.close();
            } catch (e) {}
        } else {
            const audioEl = document.createElement('audio');
            audioEl.autoplay = true;
            audioEl.setAttribute('playsinline', '');
            entry = {
                call: call,
                audioEl: audioEl,
                active: false,
                graceTimer: null,
                iceRecovery: null,
                clientId: meta.clientId || null,
                name: meta.name || null
            };
            this.connections.set(id, entry);
        }
        this.bindCall(id, entry, call);
    }
    // Wire a (possibly replacement) call's media + connection-state events. Every
    // handler first checks it still owns the current call for this viewer, so a
    // late event from a superseded call can't disturb the live reconnection.
    bindCall(id, entry, call) {
        call.on('stream', (remoteStream)=>{
            if (entry.call !== call) return;
            entry.audioEl.srcObject = remoteStream;
            if (!entry.audioEl.isConnected) document.body.appendChild(entry.audioEl);
            const wasActive = entry.active;
            entry.active = true;
            this.updateConnections();
            if (!wasActive) (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).VIEWER_CONNECTED, {
                count: this.activeCount()
            });
        });
        const pc = call.peerConnection;
        if (pc) {
            // Answerer side of the ICE restart: the parent drives it, but we still need
            // this so PeerJS doesn't close our side on ICE failure, and so we answer the
            // parent's restart offer. onGiveUp is the normal viewer drop.
            if (entry.iceRecovery) entry.iceRecovery.destroy();
            entry.iceRecovery = (0, $d16014fbca14af38$export$2a8b0ce368e0bd6c)(pc, {
                peer: this.peer,
                remoteId: call.peer,
                connectionId: call.connectionId,
                role: 'answerer',
                onGiveUp: ()=>this.dropViewer(id, call)
            });
            pc.addEventListener('connectionstatechange', ()=>{
                if (entry.call !== call) return;
                const state = pc.connectionState;
                const recover = ()=>entry.iceRecovery ? entry.iceRecovery.recover('conn-' + state) : this.dropViewer(id, call);
                if (state === 'connected') {
                    clearTimeout(entry.graceTimer);
                    // Cap this viewer's encoder now that negotiation is done (encodings are
                    // only populated post-negotiation on some browsers).
                    (0, $9697a5d72bef5841$export$a75a266ae9ba7f11)(pc);
                } else if (state === 'closed') // A real teardown (tab closed / hung up): drop immediately so the count
                // doesn't sit inflated for the grace window on every normal exit.
                this.dropViewer(id, call);
                else if (state === 'failed') recover();
                else if (state === 'disconnected') {
                    clearTimeout(entry.graceTimer);
                    entry.graceTimer = setTimeout(()=>{
                        if (entry.call === call && [
                            'disconnected',
                            'failed'
                        ].includes(pc.connectionState)) recover();
                    }, 4000);
                }
            });
        }
        call.on('close', ()=>{
            if (entry.iceRecovery && entry.iceRecovery.isRecovering()) return;
            this.dropViewer(id, call);
        });
    }
    dropViewer(id, call) {
        const entry = this.connections.get(id);
        if (!entry) return;
        // Ignore a late close/failed from a call the parent has already replaced —
        // dropping here would wrongly evict the viewer that's now live again.
        if (call && entry.call !== call) return;
        const wasActive = entry.active;
        clearTimeout(entry.graceTimer);
        if (entry.iceRecovery) {
            entry.iceRecovery.destroy();
            entry.iceRecovery = null;
        }
        try {
            entry.audioEl.srcObject = null;
            entry.audioEl.remove();
        } catch (e) {}
        try {
            entry.call.close();
        } catch (e) {}
        this.connections.delete(id);
        this.updateConnections();
        if (wasActive) (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).VIEWER_DISCONNECTED, {
            count: this.activeCount()
        });
    }
    activeCount() {
        return [
            ...this.connections.values()
        ].filter((e)=>e.active).length;
    }
    sendCount(conn) {
        try {
            if (conn && conn.open) conn.send({
                type: 'count',
                count: this.activeCount()
            });
        } catch (e) {
        /* best-effort */ }
    }
    // Reflect the number of live viewers: hide the QR card once someone is
    // watching (re-openable via "Add parent"), show the status pill, and push the
    // count to every connected parent.
    updateConnections() {
        const count = this.activeCount();
        // Only animate when the live view itself appears/disappears (the 0<->1
        // boundary); a parent merely joining/leaving while others watch changes no
        // screen, so it must not trigger a needless cross-fade flash.
        const wasLive = document.body.classList.contains('has-stream');
        const nowLive = count > 0;
        const swap = ()=>{
            document.body.classList.toggle('has-stream', nowLive);
            if (count === 0) document.body.classList.remove('show-qr');
        };
        if (wasLive !== nowLive) (0, $b68ecd39b69a2afc$export$20ac98a4b4fe8b85)(swap);
        else swap();
        if ($63e260cbcedef6c4$var$$hostStatus) {
            $63e260cbcedef6c4$var$$hostStatus.classList.toggle('live', count > 0);
            const $text = $63e260cbcedef6c4$var$$hostStatus.querySelector('.status-text');
            if ($text) $text.textContent = count === 0 ? (0, $03c039b69e20a322$export$625550452a3fa3ec)('hostStatus.waiting') : (0, $03c039b69e20a322$export$ac8a90d2a5e68c45)('hostStatus.count', count);
        }
        this.dataConns.forEach((conn)=>this.sendCount(conn));
    }
    async startCamera() {
        try {
            // Prefer the stream primed during the role tap (see primeCamera); only
            // request fresh if there wasn't one (e.g. an unexpected entry path).
            const primed = $63e260cbcedef6c4$var$takePrimedCamera();
            const stream = primed ? await primed : await navigator.mediaDevices.getUserMedia({
                video: {
                    frameRate: {
                        ideal: 15,
                        max: 20
                    }
                },
                audio: {
                    echoCancellation: true
                }
            });
            // A prior error screen (denied/busy camera) gets restored to the normal
            // QR card here, so a successful retry doesn't leave the error stuck up.
            this.cameraError = false;
            (0, $b68ecd39b69a2afc$export$40f72c43f20f0f8f)();
            this.useStream(stream);
            this.createConstraints();
            (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).CAMERA_STARTED);
        } catch (err) {
            console.error('[HOST] Could not access camera/microphone', err);
            (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).CAMERA_ERROR, {
                name: err && err.name
            });
            this.cameraError = true;
            this.armCameraRefocusRetry(err);
            (0, $b68ecd39b69a2afc$export$bd70983939bfdb5c)((0, $03c039b69e20a322$export$625550452a3fa3ec)((0, $b68ecd39b69a2afc$export$ebb907d1f7711853)(err)), {
                retryLabel: (0, $03c039b69e20a322$export$625550452a3fa3ec)('common.retry'),
                onRetry: ()=>this.startCamera(),
                backLabel: (0, $03c039b69e20a322$export$625550452a3fa3ec)('common.back')
            });
        }
    }
    // A "camera busy" failure (another app holds it, or the OS suspended it) is
    // usually transient: the user closes the other app and comes back. Retry
    // automatically the moment the monitor tab is foregrounded again, so they
    // don't have to notice and tap Retry. Bound once; guarded by cameraError so
    // it only fires while an error is actually showing.
    armCameraRefocusRetry(err) {
        const name = err && err.name;
        const busy = name === 'NotReadableError' || name === 'AbortError' || name === 'TrackStartError';
        if (!busy || this._cameraRetryBound) return;
        this._cameraRetryBound = true;
        document.addEventListener('visibilitychange', ()=>{
            if (document.visibilityState === 'visible' && this.cameraError) this.startCamera();
        });
    }
    useStream(stream) {
        (0, $b68ecd39b69a2afc$export$d6b8db0c5911d42e)(stream);
        $video.muted = true;
        $video.srcObject = stream;
        activeVideoStream = stream;
        (0, $b68ecd39b69a2afc$export$77f6ac6e8a39e870)($video);
        this.watchStreamHealth(stream);
        this.startLiveHeartbeat();
        if (this.cryDetector) this.cryDetector.attach(stream);
    }
    // Broadcast a "live video" heartbeat carrying a counter of genuine camera
    // frames, so parents can verify the source is producing new pictures rather
    // than a frozen frame being re-encoded (which would still advance byte and
    // decoded-frame counters on their side).
    //
    // The counter comes from requestVideoFrameCallback on the local preview, which
    // ticks once per frame the capture pipeline actually delivers: a still, quiet
    // nursery still counts (frames keep arriving), but a stalled/frozen camera does
    // not. Where rVFC isn't available we fall back to the encoder's framesEncoded
    // from getStats, which stops climbing the same way when the source freezes.
    // rVFC is bound to the <video> element, so it keeps counting across camera
    // switches/recovery without re-arming; the guard makes repeat calls a no-op.
    startLiveHeartbeat() {
        if (this._liveHeartbeatStarted) return;
        this._liveHeartbeatStarted = true;
        this.frameSeq = 0;
        const v = $video;
        if (v && typeof v.requestVideoFrameCallback === 'function') {
            this._frameSource = 'rvfc';
            const onFrame = ()=>{
                this.frameSeq += 1;
                try {
                    v.requestVideoFrameCallback(onFrame);
                } catch (e) {}
            };
            try {
                v.requestVideoFrameCallback(onFrame);
            } catch (e) {}
        } else this._frameSource = 'stats';
        this.liveHeartbeatTimer = setInterval(()=>this.broadcastLive(), $63e260cbcedef6c4$var$LIVE_HEARTBEAT_MS);
    }
    async broadcastLive() {
        // Only vouch for a live source while the camera track is actually live and
        // the preview is playing. Otherwise (paused, or a track ended and being
        // recovered) stay silent: a heartbeat whose counter isn't advancing would
        // wrongly read as a frozen camera on the parent, so we'd rather send nothing
        // and let the parent fall back to its own inbound-frame check.
        const vtrack = activeVideoStream && activeVideoStream.getVideoTracks && activeVideoStream.getVideoTracks()[0];
        const sourceUp = vtrack && vtrack.readyState === 'live' && $video && !$video.paused;
        if (!sourceUp) return;
        // rVFC only ticks while the page is actually presenting frames, so it stalls
        // when the monitor runs with its screen off / backgrounded — the *normal* way
        // a baby unit is left — even though the camera keeps streaming real frames to
        // parents. Trusting the frozen rVFC counter then raises a false "camera
        // frozen" over a visibly moving picture. Whenever rVFC can't be trusted (no
        // rVFC support, or the page is hidden) sample the encoder's framesEncoded
        // instead: it keeps climbing as long as frames are genuinely going out, and
        // still flattens on a real source freeze.
        if (this._frameSource === 'stats' || document.hidden) {
            const encoded = await this.readEncodedFrames();
            if (encoded != null) this.frameSeq = encoded;
        }
        this.dataConns.forEach((conn)=>this.sendLive(conn));
    }
    // Highest framesEncoded across any active outbound video sender. Any live
    // parent connection encodes the same camera, so the first usable number wins.
    async readEncodedFrames() {
        const byPeer = this.peer && this.peer.connections || {};
        for (const conns of Object.values(byPeer))for (const conn of conns || []){
            const pc = conn && conn.peerConnection;
            if (!pc || typeof pc.getStats !== 'function') continue;
            try {
                const stats = await pc.getStats();
                let frames = null;
                stats.forEach((r)=>{
                    if (r.type === 'outbound-rtp' && (r.kind || r.mediaType) === 'video' && typeof r.framesEncoded === 'number') frames = Math.max(frames || 0, r.framesEncoded);
                });
                if (frames != null) return frames;
            } catch (e) {}
        }
        return null;
    }
    // Best-effort, mirrors sendCount: tell one parent the current camera frame
    // counter so it can confirm the source is genuinely live.
    sendLive(conn) {
        try {
            if (conn && conn.open) conn.send({
                type: 'live',
                seq: this.frameSeq
            });
        } catch (e) {
        /* best-effort */ }
    }
    // Battery saver: cover the local preview with a black overlay so the phone's
    // own screen stops rendering the picture (helps a lot on OLED). The camera
    // track keeps running and streaming to parents — mobile browsers pause
    // getUserMedia if the screen truly sleeps, so we dim rather than sleep, and
    // the wake lock stays on.
    setVideoDimmed(on) {
        this.videoDimmed = on;
        document.body.classList.toggle('video-dim', on);
        if ($63e260cbcedef6c4$var$$videoOff) $63e260cbcedef6c4$var$$videoOff.hidden = !on;
        (0, $b68ecd39b69a2afc$export$27972cfaa3ad15e9)($63e260cbcedef6c4$var$$toggleVideo, on);
        if (on) (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).VIDEO_DIMMED);
    }
    async copyLink() {
        const label = $63e260cbcedef6c4$var$$copyLink.querySelector('.copy-label');
        if (await (0, $b68ecd39b69a2afc$export$8dff4cfd26f76003)((0, $b68ecd39b69a2afc$export$4e19848623c50785)(this.peer.id), label)) (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).LINK_COPIED);
    }
    // Play a soothing lullaby out of the baby monitor's own speaker so it reaches
    // the baby in the room. It loops until stopped. Either the baby monitor or any
    // connected parent can start/stop it: the host owns the audio and the playing
    // state and broadcasts every change to all parents so their controls and the
    // subtle "playing" indicator stay in sync (see afterMelodyChange).
    ensureMelody() {
        if (this.melody) return;
        // Reuse the singleton primed at role-pick time (see primeMelody). That
        // earlier gesture is what lets a parent's remote command start playback;
        // without it, only a local tap on the monitor could.
        this.melody = $63e260cbcedef6c4$var$getMelodyAudio();
        // Reflect any state change (including the OS pausing us) everywhere.
        this.melody.addEventListener('play', ()=>this.afterMelodyChange(true));
        this.melody.addEventListener('pause', ()=>this.afterMelodyChange(false));
    }
    melodyPlaying() {
        return !!(this.melody && !this.melody.paused);
    }
    // The baby monitor's own button: flip to the opposite of the current state.
    toggleMelody() {
        const next = !this.melodyPlaying();
        (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).MELODY_TOGGLED, {
            playing: next,
            source: 'host'
        });
        this.setMelody(next);
    }
    setMelody(on) {
        this.ensureMelody();
        if (on) {
            // Priming (see primeMelody) leaves the element muted-then-restored; make
            // sure real playback is audible regardless of any in-flight priming state.
            this.melody.muted = false;
            // A parent's remote request isn't a local gesture; if the host browser
            // ever blocks playback, fall back to "stopped" so no control lies. Success
            // is handled by the 'play' listener, so we only correct on failure here.
            this.melody.play().catch((err)=>{
                console.warn('[HOST] Melody playback failed', err && err.name);
                this.afterMelodyChange(false);
            });
        } else // Success flows through the 'pause' listener; nothing else to do.
        this.melody.pause();
    }
    // Single funnel for every state change (button, remote command, the auto-stop
    // timer, or the OS pausing us), so it runs exactly once per change.
    afterMelodyChange(playing) {
        this.reflectMelody(playing);
        this.broadcastMelody(playing);
        // Mute cry detection while the lullaby plays: the melody bleeds into the
        // host mic and would otherwise be flagged as sustained crying, pushing false
        // alerts to parents. Resume detection the moment it stops.
        this.setCryDetection(!playing);
        this.armMelodyAutoStop(playing);
    }
    // Since cry alerts are paused while the lullaby plays, don't let it run
    // forever — stop it after MELODY_MAX_MS so detection always comes back.
    armMelodyAutoStop(playing) {
        clearTimeout(this.melodyTimer);
        this.melodyTimer = playing ? setTimeout(()=>this.setMelody(false), $63e260cbcedef6c4$var$MELODY_MAX_MS) : null;
    }
    setCryDetection(on) {
        if (!this.cryDetector) return;
        if (on) this.cryDetector.start();
        else this.cryDetector.stop();
    }
    reflectMelody(playing) {
        (0, $b68ecd39b69a2afc$export$27972cfaa3ad15e9)($63e260cbcedef6c4$var$$melodyToggle, playing);
        // Drives the shared "lullaby playing / cry alerts paused" indicator, shown
        // on the baby monitor too (not just parents).
        document.body.classList.toggle('melody-playing', playing);
    }
    broadcastMelody(playing) {
        this.dataConns.forEach((conn)=>this.sendMelody(conn, playing));
    }
    // Best-effort, mirrors sendCount: tell one parent whether the lullaby is on.
    sendMelody(conn, playing) {
        const state = playing != null ? playing : this.melodyPlaying();
        try {
            if (conn && conn.open) conn.send({
                type: 'melody',
                playing: state
            });
        } catch (e) {
        /* best-effort */ }
    }
    watchStreamHealth(stream) {
        stream.getTracks().forEach((track)=>{
            track.addEventListener('ended', ()=>this.recoverCamera(), {
                once: true
            });
        });
        // iOS interrupts the capture session — the system Low Battery alert (at 20%
        // and 10%), an incoming call, Control Centre — by MUTING the video track
        // rather than ending it, then UNMUTES it once the interruption clears. The
        // 'ended' handler above never fires for this, so without handling mute the
        // preview and every viewer sit frozen until someone physically wakes the
        // baby monitor (exactly the battery-alert problem). Resume automatically the
        // instant iOS lets go, and if it stays muted, force a re-acquire.
        const video = stream.getVideoTracks()[0];
        if (video) {
            video.addEventListener('mute', ()=>this.onCameraInterrupted());
            video.addEventListener('unmute', ()=>this.onCameraResumed());
        }
    }
    // Capture interruption began. Give iOS a brief grace to clear it on its own
    // (the battery alert auto-dismisses after a few seconds), then, if the track is
    // still muted, force recovery — retrying on a short cadence because
    // getUserMedia keeps rejecting while the device is held by the interruption.
    onCameraInterrupted() {
        (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).CAMERA_INTERRUPTED);
        clearTimeout(this._camInterruptTimer);
        this._camInterruptRetries = 0;
        this._camInterruptTimer = setTimeout(()=>this.pollCameraRecovery(), 1800);
    }
    async pollCameraRecovery() {
        const vtrack = activeVideoStream && activeVideoStream.getVideoTracks()[0];
        // Resumed on its own (the unmute handler ran) — nothing to force.
        if (!vtrack || !vtrack.muted && vtrack.readyState === 'live') return;
        // Don't hammer getUserMedia while backgrounded: it can't succeed there and
        // the visibility/unmute handlers already cover coming back. Keep the retry
        // loop alive so we act as soon as we're foreground again.
        if (document.visibilityState !== 'visible') {
            if (this._camInterruptRetries < 15) this._camInterruptTimer = setTimeout(()=>this.pollCameraRecovery(), 2000);
            return;
        }
        this._camInterruptRetries += 1;
        // getUserMedia rejects with NotReadableError while the device is still held;
        // recoverCamera swallows that, so we just re-check and retry.
        await this.recoverCamera();
        const still = activeVideoStream && activeVideoStream.getVideoTracks()[0];
        const recovered = still && !still.muted && still.readyState === 'live';
        if (!recovered && this._camInterruptRetries < 15) this._camInterruptTimer = setTimeout(()=>this.pollCameraRecovery(), 2000);
    }
    // Interruption cleared and iOS handed the original track back. It usually
    // leaves the <video> paused, so just make sure the preview is playing again;
    // the same track keeps flowing to every viewer, so nothing needs re-negotiating.
    onCameraResumed() {
        clearTimeout(this._camInterruptTimer);
        this._camInterruptRetries = 0;
        (0, $b68ecd39b69a2afc$export$77f6ac6e8a39e870)($video);
    }
    async recoverCamera() {
        if (this.recovering) return;
        this.recovering = true;
        const previous = activeVideoStream;
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    frameRate: {
                        ideal: 15,
                        max: 20
                    }
                },
                audio: {
                    echoCancellation: true
                }
            });
            this.replaceOutgoingTracks(stream);
            this.useStream(stream);
            if (previous && previous !== stream) previous.getTracks().forEach((t)=>t.stop());
            (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).CAMERA_RECOVERED);
        } catch (err) {
            console.warn('[HOST] Camera recovery failed, will retry on next focus:', err && err.name);
        } finally{
            this.recovering = false;
        }
    }
    replaceOutgoingTracks(stream) {
        const connectionsByPeer = this.peer && this.peer.connections || {};
        Object.values(connectionsByPeer).forEach((connections)=>{
            (connections || []).forEach((conn)=>{
                const pc = conn && conn.peerConnection;
                if (!pc || !pc.getSenders) return;
                pc.getSenders().forEach((sender)=>{
                    if (!sender.track) return;
                    const replacement = stream.getTracks().find((t)=>t.kind === sender.track.kind);
                    if (replacement) sender.replaceTrack(replacement).catch(()=>{});
                });
                // replaceTrack resets sender parameters, so re-assert the caps on the new
                // track (camera switch / recovery both route through here).
                (0, $9697a5d72bef5841$export$a75a266ae9ba7f11)(pc);
            });
        });
    }
    async switchCamera() {
        if (this.recovering) return;
        const next = (0, $b68ecd39b69a2afc$export$7c94d6f03205391b)();
        if (!next) return;
        this.recovering = true;
        const previous = activeVideoStream;
        // Android (e.g. Pixel 5) refuses to open the second camera while the first
        // is still live, so release the current video device before requesting the
        // next one.
        if (previous) previous.getVideoTracks().forEach((t)=>t.stop());
        let switched = false;
        try {
            const stream = await navigator.mediaDevices.getUserMedia(next);
            // We now hold a live camera. Mark the switch done before adopting it so an
            // (unlikely) throw in the swap/adopt path can't drop us into the recovery
            // fallback below, which would acquire a second stream and leak this one.
            switched = true;
            this.replaceOutgoingTracks(stream);
            this.useStream(stream);
            if (previous && previous !== stream) previous.getTracks().forEach((t)=>t.stop());
            (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).CAMERA_SWITCHED);
        } catch (err) {
            console.error('[HOST] Camera switch failed', err);
            (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).CAMERA_ERROR, {
                name: err && err.name
            });
        } finally{
            this.recovering = false;
        }
        // We already stopped the old camera, so a failed switch would otherwise
        // leave the preview and every viewer black until the next focus event.
        // Re-acquire an available camera right away instead of waiting. (The guard
        // was cleared above, so recoverCamera can run.)
        if (!switched) await this.recoverCamera();
    }
    ensureCameraLive() {
        // While a camera error is showing, startCamera()'s own refocus retry owns
        // recovery (and restores the error card on success) — don't also fire
        // recoverCamera here, or we'd request the camera twice on the same focus.
        if (this.cameraError) return;
        const track = activeVideoStream && activeVideoStream.getVideoTracks()[0];
        if (!track || track.readyState === 'ended') this.recoverCamera();
    }
    // Analyse the host's own microphone and ask the Worker to push a cry alert to
    // every subscribed viewer, even when no viewer is connected — the Worker
    // simply has no subscriptions to notify — so background alerts don't depend
    // on the app being open anywhere. The detector calibrates itself against the
    // room's ambient level, so there's nothing to tune here (viewer sensitivity no
    // longer exists) and background reliability is unaffected by the UI.
    initCryDetection() {
        this.cryDetector = (0, $0b811e50742f6e70$export$30232bc23eb59341)({
            onCry: ()=>(0, $02d65636a04e74fb$export$b125ac0187639473)(this.peer.id)
        });
        this.cryDetector.start();
    }
    // ---- Battery warning -----------------------------------------------------
    // The Battery Status API is Android/Chrome-only (iOS/Safari removed it), so on
    // an iOS monitor getBattery is absent and no warning is ever emitted — which
    // is fine: the feature targets Android monitors. We only push state to parents
    // over the data channel; the monitor itself stays silent (no local UI/sound).
    initBattery() {
        if (!navigator.getBattery) return;
        navigator.getBattery().then((b)=>{
            this.battery = b;
            // Seed the "was it low?" edge tracker, then broadcast only on transitions
            // so a healthy battery ticking down 1% at a time doesn't spam the channel.
            this.batteryWasLow = this.batteryLow();
            [
                'levelchange',
                'chargingchange'
            ].forEach((e)=>b.addEventListener(e, ()=>this.onBatteryChange()));
            this.onBatteryChange();
        }).catch(()=>{});
    }
    batteryLow() {
        return !!(this.battery && !this.battery.charging && this.battery.level < $63e260cbcedef6c4$var$BATTERY_LOW);
    }
    batteryState() {
        return {
            type: 'battery',
            low: this.batteryLow(),
            level: this.battery ? Math.round(this.battery.level * 100) : null,
            charging: !!(this.battery && this.battery.charging)
        };
    }
    // Keep the data channel quiet at healthy levels. levelchange fires every 1%,
    // so we only broadcast when it matters: while low (to keep the parent's
    // percentage fresh) and on the single false transition that clears the pill.
    // A steady, healthy battery ticking down sends nothing.
    onBatteryChange() {
        const low = this.batteryLow();
        const flipped = low !== this.batteryWasLow;
        if (flipped && low) (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).BATTERY_LOW, {
            level: Math.round(this.battery.level * 100)
        });
        this.batteryWasLow = low;
        if (low || flipped) this.broadcastBattery();
    }
    broadcastBattery() {
        this.dataConns.forEach((conn)=>this.sendBattery(conn));
    }
    // ---- Presence ------------------------------------------------------------
    // Presence is inferred server-side from the live signaling socket (the
    // PeerSignal DO reports the monitor as present while it holds that socket), so
    // there's no periodic heartbeat to send. We only announce a *clean* exit as the
    // page unloads, so a deliberate close isn't mistaken for an outage. pagehide is
    // the most reliable "page going away" signal on mobile (fires for unload and
    // bfcache); a crash / power loss / dead battery fires nothing, so the socket
    // simply drops and the scheduled sweep surfaces it as "monitor offline".
    initPresence() {
        window.addEventListener('pagehide', ()=>(0, $02d65636a04e74fb$export$2d15c207f65bc2bd)(this.peer.id));
    }
    // Best-effort, mirrors sendMelody/sendCount. A parent that connects before
    // getBattery() resolves gets low:false/level:null here; onBatteryChange()
    // corrects it once the promise settles.
    sendBattery(conn) {
        try {
            if (conn && conn.open) conn.send(this.batteryState());
        } catch (e) {
        /* best-effort */ }
    }
    showQR(connectId) {
        (0, $b68ecd39b69a2afc$export$b48da2f84c900c96)($63e260cbcedef6c4$var$$connect.querySelector('.qr'), (0, $b68ecd39b69a2afc$export$4e19848623c50785)(connectId));
    }
    createConstraints() {
        navigator.mediaDevices.enumerateDevices().then((devices)=>{
            let cameras = devices.filter((device)=>device.kind == 'videoinput');
            constraints = (0, $b68ecd39b69a2afc$export$a356d195f00e8338)(cameras);
            if (cameras.length > 1) document.body.classList.add('multi-camera');
        }).catch(function(err) {
            console.log(err.name + ': ' + err.message);
        });
    }
    constructor(peer){
        this.peer = peer;
        // Every viewer that checks in gets an entry here so the host can broadcast
        // to several phones at once and show a live count. The QR stays available
        // the whole time (via "Add parent") so more phones can keep joining.
        this.connections = new Map();
        // Lightweight data channels used only to push the live viewer count to each
        // parent so they can see how many others are watching. Cosmetic, best-effort.
        this.dataConns = new Set();
        // Trusted-parent recognition. `promptedIds` dedupes prompts within this host
        // session (so reconnects/handoffs don't respam); `trustQueue` holds unknown
        // parents awaiting a heads-up prompt and `trustActive` is the one shown now,
        // so several unknown parents are surfaced one at a time (FIFO).
        this.promptedIds = new Set();
        this.trustQueue = [];
        this.trustActive = null;
        this.showQR(peer.id);
        this.initCryDetection();
        this.initBattery();
        this.initPresence();
        this.startCamera();
        this.bindControls();
        peer.on('call', (call)=>{
            const meta = call.metadata || {};
            const answerWith = ()=>activeVideoStream ? Promise.resolve(activeVideoStream) : navigator.mediaDevices.getUserMedia({
                    video: {
                        frameRate: {
                            ideal: 15,
                            max: 20
                        }
                    },
                    audio: {
                        echoCancellation: true
                    }
                });
            answerWith().then((stream)=>{
                call.answer(stream);
                // A viewer got through: re-arm peer-error tracking so a later
                // non-fatal blip is logged as a fresh event, not suppressed.
                (0, $4a7db14ce90fb7a4$export$733dd075a3dd9ee5)();
                this.trackViewer(call, meta);
                this.considerTrust(meta.clientId, meta.name);
            }).catch((err)=>console.error('[HOST] Failed to answer call', err));
        });
        // Parents open a data connection after connecting; use it to broadcast the
        // live viewer count so each parent can see how many others are watching.
        peer.on('connection', (conn)=>{
            this.dataConns.add(conn);
            conn.on('open', ()=>{
                this.sendCount(conn);
                this.sendMelody(conn);
                this.sendBattery(conn);
                this.sendLive(conn);
            });
            // Parents can start/stop the lullaby remotely. The host owns the audio and
            // the authoritative "playing" state, so we just apply the request and
            // afterMelodyChange() broadcasts the result back to every parent. The
            // parent's own client already logged the analytics event, so we don't.
            conn.on('data', (msg)=>{
                if (msg && msg.type === 'melody') this.setMelody(!!msg.playing);
            });
            conn.on('close', ()=>this.dataConns.delete(conn));
            conn.on('error', ()=>this.dataConns.delete(conn));
        });
        // A camera can stop on its own — the device sleeps, another app grabs it, or
        // the OS suspends the tab. When the page comes back to the foreground, make
        // sure the camera is still live and re-acquire it if not (see recoverCamera).
        // Also re-wire the cry detector: its shared AudioContext can slip to
        // 'suspended' while backgrounded, which would silently stop cry analysis.
        document.addEventListener('visibilitychange', ()=>{
            if (document.visibilityState === 'visible') {
                this.ensureCameraLive();
                if (this.cryDetector) this.cryDetector.resume();
            }
        });
    }
}





// Coarse, privacy-safe description of how a peer connection was actually
// established, for analytics. We only ever surface enumerated candidate types
// (host / srflx / prflx / relay), the transport protocol and a rounded RTT —
// never IPs, ports, peer ids or anything that could identify a network. This is
// what turns "it sometimes doesn't connect" into a distribution, and shows what
// share of sessions run over a TURN relay (a direct Cloudflare cost).
// Find the candidate pair the connection settled on. Prefer the transport's
// explicit pointer; fall back to the nominated/selected succeeded pair, which is
// how browsers without `selectedCandidatePairId` expose it.
function $779ebb5208b6fff2$var$selectedPair(stats) {
    let transportPairId = null;
    stats.forEach((r)=>{
        if (r.type === 'transport' && r.selectedCandidatePairId) transportPairId = r.selectedCandidatePairId;
    });
    if (transportPairId) {
        const pair = stats.get(transportPairId);
        if (pair) return pair;
    }
    let fallback = null;
    stats.forEach((r)=>{
        if (r.type !== 'candidate-pair') return;
        if (r.state !== 'succeeded') return;
        if (r.nominated || r.selected) fallback = fallback || r;
    });
    return fallback;
}
async function $779ebb5208b6fff2$export$ea89b1e82df1a14f(pc) {
    if (!pc || typeof pc.getStats !== 'function') return null;
    let stats;
    try {
        stats = await pc.getStats();
    } catch (e) {
        return null;
    }
    const pair = $779ebb5208b6fff2$var$selectedPair(stats);
    if (!pair) return null;
    const local = stats.get(pair.localCandidateId);
    const remote = stats.get(pair.remoteCandidateId);
    const rtt = typeof pair.currentRoundTripTime === 'number' ? Math.round(pair.currentRoundTripTime * 1000) : null;
    return {
        local: local && local.candidateType || 'unknown',
        remote: remote && remote.candidateType || 'unknown',
        protocol: local && local.protocol || 'unknown',
        rtt: rtt
    };
}
function $779ebb5208b6fff2$export$1af83275ca9f024e(desc) {
    return !!desc && (desc.local === 'relay' || desc.remote === 'relay');
}




// Subtle connection cues for the parent (viewer): a soft, descending two-note
// tone when the link to the monitor drops, and a gentle rising three-note tone
// when it comes back. Deliberately quiet and short so a night-time monitor
// nudges the parent without ever feeling like an alarm.
//
// Tones are synthesised with the Web Audio API — no audio files to ship, and it
// works offline. A single AudioContext is created lazily and reused. Mobile
// browsers start a context 'suspended' until a user gesture, so we unlock it on
// the first interaction and also resume() right before playing.
let $1333db90c8a58227$var$ctx = null;
let $1333db90c8a58227$var$unlockBound = false;
function $1333db90c8a58227$var$getContext() {
    if ($1333db90c8a58227$var$ctx) return $1333db90c8a58227$var$ctx;
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    try {
        $1333db90c8a58227$var$ctx = new Ctx();
    } catch (e) {
        return null;
    }
    $1333db90c8a58227$var$bindUnlock();
    return $1333db90c8a58227$var$ctx;
}
// A context is 'suspended' until a user gesture. Create (if needed) and resume
// it on the first interaction so a later cue isn't silently dropped. Creating it
// inside the gesture means it starts in the 'running' state on iOS rather than
// stuck suspended.
function $1333db90c8a58227$var$bindUnlock() {
    if ($1333db90c8a58227$var$unlockBound) return;
    $1333db90c8a58227$var$unlockBound = true;
    const unlock = ()=>{
        const c = $1333db90c8a58227$var$getContext();
        if (c && c.state === 'suspended') c.resume().catch(()=>{});
    };
    [
        'pointerdown',
        'touchend',
        'click',
        'keydown'
    ].forEach((evt)=>window.addEventListener(evt, unlock, {
            passive: true
        }));
}
function $1333db90c8a58227$export$78505759b9b0302b() {
    $1333db90c8a58227$var$bindUnlock();
}
// Play a short sequence of soft notes. Each note gets a gentle attack/release
// envelope (no clicks) and a low peak gain so the whole thing stays subtle.
// `type` picks the oscillator waveform: 'sine' for the calm cues, or a brighter
// waveform (e.g. 'square') for the outage alarm so it cuts through across a room.
function $1333db90c8a58227$var$playSequence(notes, peak, type = 'sine') {
    const c = $1333db90c8a58227$var$getContext();
    if (!c) return;
    if (c.state === 'suspended') c.resume().catch(()=>{});
    let t = c.currentTime + 0.02;
    notes.forEach(({ freq: freq, dur: dur })=>{
        const osc = c.createOscillator();
        const gain = c.createGain();
        osc.type = type;
        osc.frequency.setValueAtTime(freq, t);
        gain.gain.setValueAtTime(0.0001, t);
        gain.gain.exponentialRampToValueAtTime(peak, t + 0.03);
        gain.gain.exponentialRampToValueAtTime(0.0001, t + dur);
        osc.connect(gain);
        gain.connect(c.destination);
        osc.start(t);
        osc.stop(t + dur + 0.02);
        t += dur + 0.03; // small gap between notes keeps it calm, not a trill
    });
}
function $1333db90c8a58227$export$5bd7536aa57f2374() {
    $1333db90c8a58227$var$playSequence([
        {
            freq: 523.25,
            dur: 0.2
        },
        {
            freq: 392.0,
            dur: 0.32
        }
    ], 0.11);
}
function $1333db90c8a58227$export$3ba4ec205653abe3() {
    $1333db90c8a58227$var$playSequence([
        {
            freq: 392.0,
            dur: 0.14
        },
        {
            freq: 523.25,
            dur: 0.14
        },
        {
            freq: 659.25,
            dur: 0.26
        }
    ], 0.1);
}
function $1333db90c8a58227$export$5da07a0f010c502e() {
    $1333db90c8a58227$var$playSequence([
        {
            freq: 440.0,
            dur: 0.16
        },
        {
            freq: 587.33,
            dur: 0.16
        },
        {
            freq: 440.0,
            dur: 0.28
        }
    ], 0.12);
}
function $1333db90c8a58227$export$3f13a3f5264bdf37() {
    $1333db90c8a58227$var$playSequence([
        {
            freq: 988.0,
            dur: 0.18
        },
        {
            freq: 784.0,
            dur: 0.18
        },
        {
            freq: 988.0,
            dur: 0.18
        },
        {
            freq: 784.0,
            dur: 0.28
        }
    ], 0.3, 'square');
}



var $643776b5d2f2433f$exports = {};
(function webpackUniversalModuleDefinition(root, factory) {
    $643776b5d2f2433f$exports = factory();
})(typeof self !== 'undefined' ? self : $643776b5d2f2433f$exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 3);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var BitMatrix = /** @class */ function() {
                function BitMatrix(data, width) {
                    this.width = width;
                    this.height = data.length / width;
                    this.data = data;
                }
                BitMatrix.createEmpty = function(width, height) {
                    return new BitMatrix(new Uint8ClampedArray(width * height), width);
                };
                BitMatrix.prototype.get = function(x, y) {
                    if (x < 0 || x >= this.width || y < 0 || y >= this.height) return false;
                    return !!this.data[y * this.width + x];
                };
                BitMatrix.prototype.set = function(x, y, v) {
                    this.data[y * this.width + x] = v ? 1 : 0;
                };
                BitMatrix.prototype.setRegion = function(left, top, width, height, v) {
                    for(var y = top; y < top + height; y++)for(var x = left; x < left + width; x++)this.set(x, y, !!v);
                };
                return BitMatrix;
            }();
            exports.BitMatrix = BitMatrix;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var GenericGFPoly_1 = __webpack_require__(2);
            function addOrSubtractGF(a, b) {
                return a ^ b; // tslint:disable-line:no-bitwise
            }
            exports.addOrSubtractGF = addOrSubtractGF;
            var GenericGF = /** @class */ function() {
                function GenericGF(primitive, size, genBase) {
                    this.primitive = primitive;
                    this.size = size;
                    this.generatorBase = genBase;
                    this.expTable = new Array(this.size);
                    this.logTable = new Array(this.size);
                    var x = 1;
                    for(var i = 0; i < this.size; i++){
                        this.expTable[i] = x;
                        x = x * 2;
                        if (x >= this.size) x = (x ^ this.primitive) & this.size - 1; // tslint:disable-line:no-bitwise
                    }
                    for(var i = 0; i < this.size - 1; i++)this.logTable[this.expTable[i]] = i;
                    this.zero = new GenericGFPoly_1.default(this, Uint8ClampedArray.from([
                        0
                    ]));
                    this.one = new GenericGFPoly_1.default(this, Uint8ClampedArray.from([
                        1
                    ]));
                }
                GenericGF.prototype.multiply = function(a, b) {
                    if (a === 0 || b === 0) return 0;
                    return this.expTable[(this.logTable[a] + this.logTable[b]) % (this.size - 1)];
                };
                GenericGF.prototype.inverse = function(a) {
                    if (a === 0) throw new Error("Can't invert 0");
                    return this.expTable[this.size - this.logTable[a] - 1];
                };
                GenericGF.prototype.buildMonomial = function(degree, coefficient) {
                    if (degree < 0) throw new Error("Invalid monomial degree less than 0");
                    if (coefficient === 0) return this.zero;
                    var coefficients = new Uint8ClampedArray(degree + 1);
                    coefficients[0] = coefficient;
                    return new GenericGFPoly_1.default(this, coefficients);
                };
                GenericGF.prototype.log = function(a) {
                    if (a === 0) throw new Error("Can't take log(0)");
                    return this.logTable[a];
                };
                GenericGF.prototype.exp = function(a) {
                    return this.expTable[a];
                };
                return GenericGF;
            }();
            exports.default = GenericGF;
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var GenericGF_1 = __webpack_require__(1);
            var GenericGFPoly = /** @class */ function() {
                function GenericGFPoly(field, coefficients) {
                    if (coefficients.length === 0) throw new Error("No coefficients.");
                    this.field = field;
                    var coefficientsLength = coefficients.length;
                    if (coefficientsLength > 1 && coefficients[0] === 0) {
                        // Leading term must be non-zero for anything except the constant polynomial "0"
                        var firstNonZero = 1;
                        while(firstNonZero < coefficientsLength && coefficients[firstNonZero] === 0)firstNonZero++;
                        if (firstNonZero === coefficientsLength) this.coefficients = field.zero.coefficients;
                        else {
                            this.coefficients = new Uint8ClampedArray(coefficientsLength - firstNonZero);
                            for(var i = 0; i < this.coefficients.length; i++)this.coefficients[i] = coefficients[firstNonZero + i];
                        }
                    } else this.coefficients = coefficients;
                }
                GenericGFPoly.prototype.degree = function() {
                    return this.coefficients.length - 1;
                };
                GenericGFPoly.prototype.isZero = function() {
                    return this.coefficients[0] === 0;
                };
                GenericGFPoly.prototype.getCoefficient = function(degree) {
                    return this.coefficients[this.coefficients.length - 1 - degree];
                };
                GenericGFPoly.prototype.addOrSubtract = function(other) {
                    var _a;
                    if (this.isZero()) return other;
                    if (other.isZero()) return this;
                    var smallerCoefficients = this.coefficients;
                    var largerCoefficients = other.coefficients;
                    if (smallerCoefficients.length > largerCoefficients.length) _a = [
                        largerCoefficients,
                        smallerCoefficients
                    ], smallerCoefficients = _a[0], largerCoefficients = _a[1];
                    var sumDiff = new Uint8ClampedArray(largerCoefficients.length);
                    var lengthDiff = largerCoefficients.length - smallerCoefficients.length;
                    for(var i = 0; i < lengthDiff; i++)sumDiff[i] = largerCoefficients[i];
                    for(var i = lengthDiff; i < largerCoefficients.length; i++)sumDiff[i] = GenericGF_1.addOrSubtractGF(smallerCoefficients[i - lengthDiff], largerCoefficients[i]);
                    return new GenericGFPoly(this.field, sumDiff);
                };
                GenericGFPoly.prototype.multiply = function(scalar) {
                    if (scalar === 0) return this.field.zero;
                    if (scalar === 1) return this;
                    var size = this.coefficients.length;
                    var product = new Uint8ClampedArray(size);
                    for(var i = 0; i < size; i++)product[i] = this.field.multiply(this.coefficients[i], scalar);
                    return new GenericGFPoly(this.field, product);
                };
                GenericGFPoly.prototype.multiplyPoly = function(other) {
                    if (this.isZero() || other.isZero()) return this.field.zero;
                    var aCoefficients = this.coefficients;
                    var aLength = aCoefficients.length;
                    var bCoefficients = other.coefficients;
                    var bLength = bCoefficients.length;
                    var product = new Uint8ClampedArray(aLength + bLength - 1);
                    for(var i = 0; i < aLength; i++){
                        var aCoeff = aCoefficients[i];
                        for(var j = 0; j < bLength; j++)product[i + j] = GenericGF_1.addOrSubtractGF(product[i + j], this.field.multiply(aCoeff, bCoefficients[j]));
                    }
                    return new GenericGFPoly(this.field, product);
                };
                GenericGFPoly.prototype.multiplyByMonomial = function(degree, coefficient) {
                    if (degree < 0) throw new Error("Invalid degree less than 0");
                    if (coefficient === 0) return this.field.zero;
                    var size = this.coefficients.length;
                    var product = new Uint8ClampedArray(size + degree);
                    for(var i = 0; i < size; i++)product[i] = this.field.multiply(this.coefficients[i], coefficient);
                    return new GenericGFPoly(this.field, product);
                };
                GenericGFPoly.prototype.evaluateAt = function(a) {
                    var result = 0;
                    if (a === 0) // Just return the x^0 coefficient
                    return this.getCoefficient(0);
                    var size = this.coefficients.length;
                    if (a === 1) {
                        // Just the sum of the coefficients
                        this.coefficients.forEach(function(coefficient) {
                            result = GenericGF_1.addOrSubtractGF(result, coefficient);
                        });
                        return result;
                    }
                    result = this.coefficients[0];
                    for(var i = 1; i < size; i++)result = GenericGF_1.addOrSubtractGF(this.field.multiply(a, result), this.coefficients[i]);
                    return result;
                };
                return GenericGFPoly;
            }();
            exports.default = GenericGFPoly;
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var binarizer_1 = __webpack_require__(4);
            var decoder_1 = __webpack_require__(5);
            var extractor_1 = __webpack_require__(11);
            var locator_1 = __webpack_require__(12);
            function scan(matrix) {
                var locations = locator_1.locate(matrix);
                if (!locations) return null;
                for(var _i = 0, locations_1 = locations; _i < locations_1.length; _i++){
                    var location_1 = locations_1[_i];
                    var extracted = extractor_1.extract(matrix, location_1);
                    var decoded = decoder_1.decode(extracted.matrix);
                    if (decoded) return {
                        binaryData: decoded.bytes,
                        data: decoded.text,
                        chunks: decoded.chunks,
                        version: decoded.version,
                        location: {
                            topRightCorner: extracted.mappingFunction(location_1.dimension, 0),
                            topLeftCorner: extracted.mappingFunction(0, 0),
                            bottomRightCorner: extracted.mappingFunction(location_1.dimension, location_1.dimension),
                            bottomLeftCorner: extracted.mappingFunction(0, location_1.dimension),
                            topRightFinderPattern: location_1.topRight,
                            topLeftFinderPattern: location_1.topLeft,
                            bottomLeftFinderPattern: location_1.bottomLeft,
                            bottomRightAlignmentPattern: location_1.alignmentPattern
                        }
                    };
                }
                return null;
            }
            var defaultOptions = {
                inversionAttempts: "attemptBoth"
            };
            function jsQR(data, width, height, providedOptions) {
                if (providedOptions === void 0) providedOptions = {};
                var options = defaultOptions;
                Object.keys(options || {}).forEach(function(opt) {
                    options[opt] = providedOptions[opt] || options[opt];
                });
                var shouldInvert = options.inversionAttempts === "attemptBoth" || options.inversionAttempts === "invertFirst";
                var tryInvertedFirst = options.inversionAttempts === "onlyInvert" || options.inversionAttempts === "invertFirst";
                var _a = binarizer_1.binarize(data, width, height, shouldInvert), binarized = _a.binarized, inverted = _a.inverted;
                var result = scan(tryInvertedFirst ? inverted : binarized);
                if (!result && (options.inversionAttempts === "attemptBoth" || options.inversionAttempts === "invertFirst")) result = scan(tryInvertedFirst ? binarized : inverted);
                return result;
            }
            jsQR.default = jsQR;
            exports.default = jsQR;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var BitMatrix_1 = __webpack_require__(0);
            var REGION_SIZE = 8;
            var MIN_DYNAMIC_RANGE = 24;
            function numBetween(value, min, max) {
                return value < min ? min : value > max ? max : value;
            }
            // Like BitMatrix but accepts arbitry Uint8 values
            var Matrix = /** @class */ function() {
                function Matrix(width, height) {
                    this.width = width;
                    this.data = new Uint8ClampedArray(width * height);
                }
                Matrix.prototype.get = function(x, y) {
                    return this.data[y * this.width + x];
                };
                Matrix.prototype.set = function(x, y, value) {
                    this.data[y * this.width + x] = value;
                };
                return Matrix;
            }();
            function binarize(data, width, height, returnInverted) {
                if (data.length !== width * height * 4) throw new Error("Malformed data passed to binarizer.");
                // Convert image to greyscale
                var greyscalePixels = new Matrix(width, height);
                for(var x = 0; x < width; x++)for(var y = 0; y < height; y++){
                    var r = data[(y * width + x) * 4 + 0];
                    var g = data[(y * width + x) * 4 + 1];
                    var b = data[(y * width + x) * 4 + 2];
                    greyscalePixels.set(x, y, 0.2126 * r + 0.7152 * g + 0.0722 * b);
                }
                var horizontalRegionCount = Math.ceil(width / REGION_SIZE);
                var verticalRegionCount = Math.ceil(height / REGION_SIZE);
                var blackPoints = new Matrix(horizontalRegionCount, verticalRegionCount);
                for(var verticalRegion = 0; verticalRegion < verticalRegionCount; verticalRegion++)for(var hortizontalRegion = 0; hortizontalRegion < horizontalRegionCount; hortizontalRegion++){
                    var sum = 0;
                    var min = Infinity;
                    var max = 0;
                    for(var y = 0; y < REGION_SIZE; y++)for(var x = 0; x < REGION_SIZE; x++){
                        var pixelLumosity = greyscalePixels.get(hortizontalRegion * REGION_SIZE + x, verticalRegion * REGION_SIZE + y);
                        sum += pixelLumosity;
                        min = Math.min(min, pixelLumosity);
                        max = Math.max(max, pixelLumosity);
                    }
                    var average = sum / Math.pow(REGION_SIZE, 2);
                    if (max - min <= MIN_DYNAMIC_RANGE) {
                        // If variation within the block is low, assume this is a block with only light or only
                        // dark pixels. In that case we do not want to use the average, as it would divide this
                        // low contrast area into black and white pixels, essentially creating data out of noise.
                        //
                        // Default the blackpoint for these blocks to be half the min - effectively white them out
                        average = min / 2;
                        if (verticalRegion > 0 && hortizontalRegion > 0) {
                            // Correct the "white background" assumption for blocks that have neighbors by comparing
                            // the pixels in this block to the previously calculated black points. This is based on
                            // the fact that dark barcode symbology is always surrounded by some amount of light
                            // background for which reasonable black point estimates were made. The bp estimated at
                            // the boundaries is used for the interior.
                            // The (min < bp) is arbitrary but works better than other heuristics that were tried.
                            var averageNeighborBlackPoint = (blackPoints.get(hortizontalRegion, verticalRegion - 1) + 2 * blackPoints.get(hortizontalRegion - 1, verticalRegion) + blackPoints.get(hortizontalRegion - 1, verticalRegion - 1)) / 4;
                            if (min < averageNeighborBlackPoint) average = averageNeighborBlackPoint;
                        }
                    }
                    blackPoints.set(hortizontalRegion, verticalRegion, average);
                }
                var binarized = BitMatrix_1.BitMatrix.createEmpty(width, height);
                var inverted = null;
                if (returnInverted) inverted = BitMatrix_1.BitMatrix.createEmpty(width, height);
                for(var verticalRegion = 0; verticalRegion < verticalRegionCount; verticalRegion++)for(var hortizontalRegion = 0; hortizontalRegion < horizontalRegionCount; hortizontalRegion++){
                    var left = numBetween(hortizontalRegion, 2, horizontalRegionCount - 3);
                    var top_1 = numBetween(verticalRegion, 2, verticalRegionCount - 3);
                    var sum = 0;
                    for(var xRegion = -2; xRegion <= 2; xRegion++)for(var yRegion = -2; yRegion <= 2; yRegion++)sum += blackPoints.get(left + xRegion, top_1 + yRegion);
                    var threshold = sum / 25;
                    for(var xRegion = 0; xRegion < REGION_SIZE; xRegion++)for(var yRegion = 0; yRegion < REGION_SIZE; yRegion++){
                        var x = hortizontalRegion * REGION_SIZE + xRegion;
                        var y = verticalRegion * REGION_SIZE + yRegion;
                        var lum = greyscalePixels.get(x, y);
                        binarized.set(x, y, lum <= threshold);
                        if (returnInverted) inverted.set(x, y, !(lum <= threshold));
                    }
                }
                if (returnInverted) return {
                    binarized: binarized,
                    inverted: inverted
                };
                return {
                    binarized: binarized
                };
            }
            exports.binarize = binarize;
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var BitMatrix_1 = __webpack_require__(0);
            var decodeData_1 = __webpack_require__(6);
            var reedsolomon_1 = __webpack_require__(9);
            var version_1 = __webpack_require__(10);
            // tslint:disable:no-bitwise
            function numBitsDiffering(x, y) {
                var z = x ^ y;
                var bitCount = 0;
                while(z){
                    bitCount++;
                    z &= z - 1;
                }
                return bitCount;
            }
            function pushBit(bit, byte) {
                return byte << 1 | bit;
            }
            // tslint:enable:no-bitwise
            var FORMAT_INFO_TABLE = [
                {
                    bits: 0x5412,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 0
                    }
                },
                {
                    bits: 0x5125,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 1
                    }
                },
                {
                    bits: 0x5E7C,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 2
                    }
                },
                {
                    bits: 0x5B4B,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 3
                    }
                },
                {
                    bits: 0x45F9,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 4
                    }
                },
                {
                    bits: 0x40CE,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 5
                    }
                },
                {
                    bits: 0x4F97,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 6
                    }
                },
                {
                    bits: 0x4AA0,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 7
                    }
                },
                {
                    bits: 0x77C4,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 0
                    }
                },
                {
                    bits: 0x72F3,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 1
                    }
                },
                {
                    bits: 0x7DAA,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 2
                    }
                },
                {
                    bits: 0x789D,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 3
                    }
                },
                {
                    bits: 0x662F,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 4
                    }
                },
                {
                    bits: 0x6318,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 5
                    }
                },
                {
                    bits: 0x6C41,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 6
                    }
                },
                {
                    bits: 0x6976,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 7
                    }
                },
                {
                    bits: 0x1689,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 0
                    }
                },
                {
                    bits: 0x13BE,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 1
                    }
                },
                {
                    bits: 0x1CE7,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 2
                    }
                },
                {
                    bits: 0x19D0,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 3
                    }
                },
                {
                    bits: 0x0762,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 4
                    }
                },
                {
                    bits: 0x0255,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 5
                    }
                },
                {
                    bits: 0x0D0C,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 6
                    }
                },
                {
                    bits: 0x083B,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 7
                    }
                },
                {
                    bits: 0x355F,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 0
                    }
                },
                {
                    bits: 0x3068,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 1
                    }
                },
                {
                    bits: 0x3F31,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 2
                    }
                },
                {
                    bits: 0x3A06,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 3
                    }
                },
                {
                    bits: 0x24B4,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 4
                    }
                },
                {
                    bits: 0x2183,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 5
                    }
                },
                {
                    bits: 0x2EDA,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 6
                    }
                },
                {
                    bits: 0x2BED,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 7
                    }
                }
            ];
            var DATA_MASKS = [
                function(p) {
                    return (p.y + p.x) % 2 === 0;
                },
                function(p) {
                    return p.y % 2 === 0;
                },
                function(p) {
                    return p.x % 3 === 0;
                },
                function(p) {
                    return (p.y + p.x) % 3 === 0;
                },
                function(p) {
                    return (Math.floor(p.y / 2) + Math.floor(p.x / 3)) % 2 === 0;
                },
                function(p) {
                    return p.x * p.y % 2 + p.x * p.y % 3 === 0;
                },
                function(p) {
                    return (p.y * p.x % 2 + p.y * p.x % 3) % 2 === 0;
                },
                function(p) {
                    return ((p.y + p.x) % 2 + p.y * p.x % 3) % 2 === 0;
                }
            ];
            function buildFunctionPatternMask(version) {
                var dimension = 17 + 4 * version.versionNumber;
                var matrix = BitMatrix_1.BitMatrix.createEmpty(dimension, dimension);
                matrix.setRegion(0, 0, 9, 9, true); // Top left finder pattern + separator + format
                matrix.setRegion(dimension - 8, 0, 8, 9, true); // Top right finder pattern + separator + format
                matrix.setRegion(0, dimension - 8, 9, 8, true); // Bottom left finder pattern + separator + format
                // Alignment patterns
                for(var _i = 0, _a = version.alignmentPatternCenters; _i < _a.length; _i++){
                    var x = _a[_i];
                    for(var _b = 0, _c = version.alignmentPatternCenters; _b < _c.length; _b++){
                        var y = _c[_b];
                        if (!(x === 6 && y === 6 || x === 6 && y === dimension - 7 || x === dimension - 7 && y === 6)) matrix.setRegion(x - 2, y - 2, 5, 5, true);
                    }
                }
                matrix.setRegion(6, 9, 1, dimension - 17, true); // Vertical timing pattern
                matrix.setRegion(9, 6, dimension - 17, 1, true); // Horizontal timing pattern
                if (version.versionNumber > 6) {
                    matrix.setRegion(dimension - 11, 0, 3, 6, true); // Version info, top right
                    matrix.setRegion(0, dimension - 11, 6, 3, true); // Version info, bottom left
                }
                return matrix;
            }
            function readCodewords(matrix, version, formatInfo) {
                var dataMask = DATA_MASKS[formatInfo.dataMask];
                var dimension = matrix.height;
                var functionPatternMask = buildFunctionPatternMask(version);
                var codewords = [];
                var currentByte = 0;
                var bitsRead = 0;
                // Read columns in pairs, from right to left
                var readingUp = true;
                for(var columnIndex = dimension - 1; columnIndex > 0; columnIndex -= 2){
                    if (columnIndex === 6) columnIndex--;
                    for(var i = 0; i < dimension; i++){
                        var y = readingUp ? dimension - 1 - i : i;
                        for(var columnOffset = 0; columnOffset < 2; columnOffset++){
                            var x = columnIndex - columnOffset;
                            if (!functionPatternMask.get(x, y)) {
                                bitsRead++;
                                var bit = matrix.get(x, y);
                                if (dataMask({
                                    y: y,
                                    x: x
                                })) bit = !bit;
                                currentByte = pushBit(bit, currentByte);
                                if (bitsRead === 8) {
                                    codewords.push(currentByte);
                                    bitsRead = 0;
                                    currentByte = 0;
                                }
                            }
                        }
                    }
                    readingUp = !readingUp;
                }
                return codewords;
            }
            function readVersion(matrix) {
                var dimension = matrix.height;
                var provisionalVersion = Math.floor((dimension - 17) / 4);
                if (provisionalVersion <= 6) return version_1.VERSIONS[provisionalVersion - 1];
                var topRightVersionBits = 0;
                for(var y = 5; y >= 0; y--)for(var x = dimension - 9; x >= dimension - 11; x--)topRightVersionBits = pushBit(matrix.get(x, y), topRightVersionBits);
                var bottomLeftVersionBits = 0;
                for(var x = 5; x >= 0; x--)for(var y = dimension - 9; y >= dimension - 11; y--)bottomLeftVersionBits = pushBit(matrix.get(x, y), bottomLeftVersionBits);
                var bestDifference = Infinity;
                var bestVersion;
                for(var _i = 0, VERSIONS_1 = version_1.VERSIONS; _i < VERSIONS_1.length; _i++){
                    var version = VERSIONS_1[_i];
                    if (version.infoBits === topRightVersionBits || version.infoBits === bottomLeftVersionBits) return version;
                    var difference = numBitsDiffering(topRightVersionBits, version.infoBits);
                    if (difference < bestDifference) {
                        bestVersion = version;
                        bestDifference = difference;
                    }
                    difference = numBitsDiffering(bottomLeftVersionBits, version.infoBits);
                    if (difference < bestDifference) {
                        bestVersion = version;
                        bestDifference = difference;
                    }
                }
                // We can tolerate up to 3 bits of error since no two version info codewords will
                // differ in less than 8 bits.
                if (bestDifference <= 3) return bestVersion;
            }
            function readFormatInformation(matrix) {
                var topLeftFormatInfoBits = 0;
                for(var x = 0; x <= 8; x++)if (x !== 6) topLeftFormatInfoBits = pushBit(matrix.get(x, 8), topLeftFormatInfoBits);
                for(var y = 7; y >= 0; y--)if (y !== 6) topLeftFormatInfoBits = pushBit(matrix.get(8, y), topLeftFormatInfoBits);
                var dimension = matrix.height;
                var topRightBottomRightFormatInfoBits = 0;
                for(var y = dimension - 1; y >= dimension - 7; y--)topRightBottomRightFormatInfoBits = pushBit(matrix.get(8, y), topRightBottomRightFormatInfoBits);
                for(var x = dimension - 8; x < dimension; x++)topRightBottomRightFormatInfoBits = pushBit(matrix.get(x, 8), topRightBottomRightFormatInfoBits);
                var bestDifference = Infinity;
                var bestFormatInfo = null;
                for(var _i = 0, FORMAT_INFO_TABLE_1 = FORMAT_INFO_TABLE; _i < FORMAT_INFO_TABLE_1.length; _i++){
                    var _a = FORMAT_INFO_TABLE_1[_i], bits = _a.bits, formatInfo = _a.formatInfo;
                    if (bits === topLeftFormatInfoBits || bits === topRightBottomRightFormatInfoBits) return formatInfo;
                    var difference = numBitsDiffering(topLeftFormatInfoBits, bits);
                    if (difference < bestDifference) {
                        bestFormatInfo = formatInfo;
                        bestDifference = difference;
                    }
                    if (topLeftFormatInfoBits !== topRightBottomRightFormatInfoBits) {
                        difference = numBitsDiffering(topRightBottomRightFormatInfoBits, bits);
                        if (difference < bestDifference) {
                            bestFormatInfo = formatInfo;
                            bestDifference = difference;
                        }
                    }
                }
                // Hamming distance of the 32 masked codes is 7, by construction, so <= 3 bits differing means we found a match
                if (bestDifference <= 3) return bestFormatInfo;
                return null;
            }
            function getDataBlocks(codewords, version, ecLevel) {
                var ecInfo = version.errorCorrectionLevels[ecLevel];
                var dataBlocks = [];
                var totalCodewords = 0;
                ecInfo.ecBlocks.forEach(function(block) {
                    for(var i = 0; i < block.numBlocks; i++){
                        dataBlocks.push({
                            numDataCodewords: block.dataCodewordsPerBlock,
                            codewords: []
                        });
                        totalCodewords += block.dataCodewordsPerBlock + ecInfo.ecCodewordsPerBlock;
                    }
                });
                // In some cases the QR code will be malformed enough that we pull off more or less than we should.
                // If we pull off less there's nothing we can do.
                // If we pull off more we can safely truncate
                if (codewords.length < totalCodewords) return null;
                codewords = codewords.slice(0, totalCodewords);
                var shortBlockSize = ecInfo.ecBlocks[0].dataCodewordsPerBlock;
                // Pull codewords to fill the blocks up to the minimum size
                for(var i = 0; i < shortBlockSize; i++)for(var _i = 0, dataBlocks_1 = dataBlocks; _i < dataBlocks_1.length; _i++){
                    var dataBlock = dataBlocks_1[_i];
                    dataBlock.codewords.push(codewords.shift());
                }
                // If there are any large blocks, pull codewords to fill the last element of those
                if (ecInfo.ecBlocks.length > 1) {
                    var smallBlockCount = ecInfo.ecBlocks[0].numBlocks;
                    var largeBlockCount = ecInfo.ecBlocks[1].numBlocks;
                    for(var i = 0; i < largeBlockCount; i++)dataBlocks[smallBlockCount + i].codewords.push(codewords.shift());
                }
                // Add the rest of the codewords to the blocks. These are the error correction codewords.
                while(codewords.length > 0)for(var _a = 0, dataBlocks_2 = dataBlocks; _a < dataBlocks_2.length; _a++){
                    var dataBlock = dataBlocks_2[_a];
                    dataBlock.codewords.push(codewords.shift());
                }
                return dataBlocks;
            }
            function decodeMatrix(matrix) {
                var version = readVersion(matrix);
                if (!version) return null;
                var formatInfo = readFormatInformation(matrix);
                if (!formatInfo) return null;
                var codewords = readCodewords(matrix, version, formatInfo);
                var dataBlocks = getDataBlocks(codewords, version, formatInfo.errorCorrectionLevel);
                if (!dataBlocks) return null;
                // Count total number of data bytes
                var totalBytes = dataBlocks.reduce(function(a, b) {
                    return a + b.numDataCodewords;
                }, 0);
                var resultBytes = new Uint8ClampedArray(totalBytes);
                var resultIndex = 0;
                for(var _i = 0, dataBlocks_3 = dataBlocks; _i < dataBlocks_3.length; _i++){
                    var dataBlock = dataBlocks_3[_i];
                    var correctedBytes = reedsolomon_1.decode(dataBlock.codewords, dataBlock.codewords.length - dataBlock.numDataCodewords);
                    if (!correctedBytes) return null;
                    for(var i = 0; i < dataBlock.numDataCodewords; i++)resultBytes[resultIndex++] = correctedBytes[i];
                }
                try {
                    return decodeData_1.decode(resultBytes, version.versionNumber);
                } catch (_a) {
                    return null;
                }
            }
            function decode(matrix) {
                if (matrix == null) return null;
                var result = decodeMatrix(matrix);
                if (result) return result;
                // Decoding didn't work, try mirroring the QR across the topLeft -> bottomRight line.
                for(var x = 0; x < matrix.width; x++){
                    for(var y = x + 1; y < matrix.height; y++)if (matrix.get(x, y) !== matrix.get(y, x)) {
                        matrix.set(x, y, !matrix.get(x, y));
                        matrix.set(y, x, !matrix.get(y, x));
                    }
                }
                return decodeMatrix(matrix);
            }
            exports.decode = decode;
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            // tslint:disable:no-bitwise
            var BitStream_1 = __webpack_require__(7);
            var shiftJISTable_1 = __webpack_require__(8);
            var Mode;
            (function(Mode) {
                Mode["Numeric"] = "numeric";
                Mode["Alphanumeric"] = "alphanumeric";
                Mode["Byte"] = "byte";
                Mode["Kanji"] = "kanji";
                Mode["ECI"] = "eci";
            })(Mode = exports.Mode || (exports.Mode = {}));
            var ModeByte;
            (function(ModeByte) {
                ModeByte[ModeByte["Terminator"] = 0] = "Terminator";
                ModeByte[ModeByte["Numeric"] = 1] = "Numeric";
                ModeByte[ModeByte["Alphanumeric"] = 2] = "Alphanumeric";
                ModeByte[ModeByte["Byte"] = 4] = "Byte";
                ModeByte[ModeByte["Kanji"] = 8] = "Kanji";
                ModeByte[ModeByte["ECI"] = 7] = "ECI";
            // StructuredAppend = 0x3,
            // FNC1FirstPosition = 0x5,
            // FNC1SecondPosition = 0x9,
            })(ModeByte || (ModeByte = {}));
            function decodeNumeric(stream, size) {
                var bytes = [];
                var text = "";
                var characterCountSize = [
                    10,
                    12,
                    14
                ][size];
                var length = stream.readBits(characterCountSize);
                // Read digits in groups of 3
                while(length >= 3){
                    var num = stream.readBits(10);
                    if (num >= 1000) throw new Error("Invalid numeric value above 999");
                    var a = Math.floor(num / 100);
                    var b = Math.floor(num / 10) % 10;
                    var c = num % 10;
                    bytes.push(48 + a, 48 + b, 48 + c);
                    text += a.toString() + b.toString() + c.toString();
                    length -= 3;
                }
                // If the number of digits aren't a multiple of 3, the remaining digits are special cased.
                if (length === 2) {
                    var num = stream.readBits(7);
                    if (num >= 100) throw new Error("Invalid numeric value above 99");
                    var a = Math.floor(num / 10);
                    var b = num % 10;
                    bytes.push(48 + a, 48 + b);
                    text += a.toString() + b.toString();
                } else if (length === 1) {
                    var num = stream.readBits(4);
                    if (num >= 10) throw new Error("Invalid numeric value above 9");
                    bytes.push(48 + num);
                    text += num.toString();
                }
                return {
                    bytes: bytes,
                    text: text
                };
            }
            var AlphanumericCharacterCodes = [
                "0",
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "A",
                "B",
                "C",
                "D",
                "E",
                "F",
                "G",
                "H",
                "I",
                "J",
                "K",
                "L",
                "M",
                "N",
                "O",
                "P",
                "Q",
                "R",
                "S",
                "T",
                "U",
                "V",
                "W",
                "X",
                "Y",
                "Z",
                " ",
                "$",
                "%",
                "*",
                "+",
                "-",
                ".",
                "/",
                ":"
            ];
            function decodeAlphanumeric(stream, size) {
                var bytes = [];
                var text = "";
                var characterCountSize = [
                    9,
                    11,
                    13
                ][size];
                var length = stream.readBits(characterCountSize);
                while(length >= 2){
                    var v = stream.readBits(11);
                    var a = Math.floor(v / 45);
                    var b = v % 45;
                    bytes.push(AlphanumericCharacterCodes[a].charCodeAt(0), AlphanumericCharacterCodes[b].charCodeAt(0));
                    text += AlphanumericCharacterCodes[a] + AlphanumericCharacterCodes[b];
                    length -= 2;
                }
                if (length === 1) {
                    var a = stream.readBits(6);
                    bytes.push(AlphanumericCharacterCodes[a].charCodeAt(0));
                    text += AlphanumericCharacterCodes[a];
                }
                return {
                    bytes: bytes,
                    text: text
                };
            }
            function decodeByte(stream, size) {
                var bytes = [];
                var text = "";
                var characterCountSize = [
                    8,
                    16,
                    16
                ][size];
                var length = stream.readBits(characterCountSize);
                for(var i = 0; i < length; i++){
                    var b = stream.readBits(8);
                    bytes.push(b);
                }
                try {
                    text += decodeURIComponent(bytes.map(function(b) {
                        return "%" + ("0" + b.toString(16)).substr(-2);
                    }).join(""));
                } catch (_a) {
                // failed to decode
                }
                return {
                    bytes: bytes,
                    text: text
                };
            }
            function decodeKanji(stream, size) {
                var bytes = [];
                var text = "";
                var characterCountSize = [
                    8,
                    10,
                    12
                ][size];
                var length = stream.readBits(characterCountSize);
                for(var i = 0; i < length; i++){
                    var k = stream.readBits(13);
                    var c = Math.floor(k / 0xC0) << 8 | k % 0xC0;
                    if (c < 0x1F00) c += 0x8140;
                    else c += 0xC140;
                    bytes.push(c >> 8, c & 0xFF);
                    text += String.fromCharCode(shiftJISTable_1.shiftJISTable[c]);
                }
                return {
                    bytes: bytes,
                    text: text
                };
            }
            function decode(data, version) {
                var _a, _b, _c, _d;
                var stream = new BitStream_1.BitStream(data);
                // There are 3 'sizes' based on the version. 1-9 is small (0), 10-26 is medium (1) and 27-40 is large (2).
                var size = version <= 9 ? 0 : version <= 26 ? 1 : 2;
                var result = {
                    text: "",
                    bytes: [],
                    chunks: [],
                    version: version
                };
                while(stream.available() >= 4){
                    var mode = stream.readBits(4);
                    if (mode === ModeByte.Terminator) return result;
                    else if (mode === ModeByte.ECI) {
                        if (stream.readBits(1) === 0) result.chunks.push({
                            type: Mode.ECI,
                            assignmentNumber: stream.readBits(7)
                        });
                        else if (stream.readBits(1) === 0) result.chunks.push({
                            type: Mode.ECI,
                            assignmentNumber: stream.readBits(14)
                        });
                        else if (stream.readBits(1) === 0) result.chunks.push({
                            type: Mode.ECI,
                            assignmentNumber: stream.readBits(21)
                        });
                        else // ECI data seems corrupted
                        result.chunks.push({
                            type: Mode.ECI,
                            assignmentNumber: -1
                        });
                    } else if (mode === ModeByte.Numeric) {
                        var numericResult = decodeNumeric(stream, size);
                        result.text += numericResult.text;
                        (_a = result.bytes).push.apply(_a, numericResult.bytes);
                        result.chunks.push({
                            type: Mode.Numeric,
                            text: numericResult.text
                        });
                    } else if (mode === ModeByte.Alphanumeric) {
                        var alphanumericResult = decodeAlphanumeric(stream, size);
                        result.text += alphanumericResult.text;
                        (_b = result.bytes).push.apply(_b, alphanumericResult.bytes);
                        result.chunks.push({
                            type: Mode.Alphanumeric,
                            text: alphanumericResult.text
                        });
                    } else if (mode === ModeByte.Byte) {
                        var byteResult = decodeByte(stream, size);
                        result.text += byteResult.text;
                        (_c = result.bytes).push.apply(_c, byteResult.bytes);
                        result.chunks.push({
                            type: Mode.Byte,
                            bytes: byteResult.bytes,
                            text: byteResult.text
                        });
                    } else if (mode === ModeByte.Kanji) {
                        var kanjiResult = decodeKanji(stream, size);
                        result.text += kanjiResult.text;
                        (_d = result.bytes).push.apply(_d, kanjiResult.bytes);
                        result.chunks.push({
                            type: Mode.Kanji,
                            bytes: kanjiResult.bytes,
                            text: kanjiResult.text
                        });
                    }
                }
                // If there is no data left, or the remaining bits are all 0, then that counts as a termination marker
                if (stream.available() === 0 || stream.readBits(stream.available()) === 0) return result;
            }
            exports.decode = decode;
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // tslint:disable:no-bitwise
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var BitStream = /** @class */ function() {
                function BitStream(bytes) {
                    this.byteOffset = 0;
                    this.bitOffset = 0;
                    this.bytes = bytes;
                }
                BitStream.prototype.readBits = function(numBits) {
                    if (numBits < 1 || numBits > 32 || numBits > this.available()) throw new Error("Cannot read " + numBits.toString() + " bits");
                    var result = 0;
                    // First, read remainder from current byte
                    if (this.bitOffset > 0) {
                        var bitsLeft = 8 - this.bitOffset;
                        var toRead = numBits < bitsLeft ? numBits : bitsLeft;
                        var bitsToNotRead = bitsLeft - toRead;
                        var mask = 0xFF >> 8 - toRead << bitsToNotRead;
                        result = (this.bytes[this.byteOffset] & mask) >> bitsToNotRead;
                        numBits -= toRead;
                        this.bitOffset += toRead;
                        if (this.bitOffset === 8) {
                            this.bitOffset = 0;
                            this.byteOffset++;
                        }
                    }
                    // Next read whole bytes
                    if (numBits > 0) {
                        while(numBits >= 8){
                            result = result << 8 | this.bytes[this.byteOffset] & 0xFF;
                            this.byteOffset++;
                            numBits -= 8;
                        }
                        // Finally read a partial byte
                        if (numBits > 0) {
                            var bitsToNotRead = 8 - numBits;
                            var mask = 0xFF >> bitsToNotRead << bitsToNotRead;
                            result = result << numBits | (this.bytes[this.byteOffset] & mask) >> bitsToNotRead;
                            this.bitOffset += numBits;
                        }
                    }
                    return result;
                };
                BitStream.prototype.available = function() {
                    return 8 * (this.bytes.length - this.byteOffset) - this.bitOffset;
                };
                return BitStream;
            }();
            exports.BitStream = BitStream;
        /***/ },
        /* 8 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.shiftJISTable = {
                0x20: 0x0020,
                0x21: 0x0021,
                0x22: 0x0022,
                0x23: 0x0023,
                0x24: 0x0024,
                0x25: 0x0025,
                0x26: 0x0026,
                0x27: 0x0027,
                0x28: 0x0028,
                0x29: 0x0029,
                0x2A: 0x002A,
                0x2B: 0x002B,
                0x2C: 0x002C,
                0x2D: 0x002D,
                0x2E: 0x002E,
                0x2F: 0x002F,
                0x30: 0x0030,
                0x31: 0x0031,
                0x32: 0x0032,
                0x33: 0x0033,
                0x34: 0x0034,
                0x35: 0x0035,
                0x36: 0x0036,
                0x37: 0x0037,
                0x38: 0x0038,
                0x39: 0x0039,
                0x3A: 0x003A,
                0x3B: 0x003B,
                0x3C: 0x003C,
                0x3D: 0x003D,
                0x3E: 0x003E,
                0x3F: 0x003F,
                0x40: 0x0040,
                0x41: 0x0041,
                0x42: 0x0042,
                0x43: 0x0043,
                0x44: 0x0044,
                0x45: 0x0045,
                0x46: 0x0046,
                0x47: 0x0047,
                0x48: 0x0048,
                0x49: 0x0049,
                0x4A: 0x004A,
                0x4B: 0x004B,
                0x4C: 0x004C,
                0x4D: 0x004D,
                0x4E: 0x004E,
                0x4F: 0x004F,
                0x50: 0x0050,
                0x51: 0x0051,
                0x52: 0x0052,
                0x53: 0x0053,
                0x54: 0x0054,
                0x55: 0x0055,
                0x56: 0x0056,
                0x57: 0x0057,
                0x58: 0x0058,
                0x59: 0x0059,
                0x5A: 0x005A,
                0x5B: 0x005B,
                0x5C: 0x00A5,
                0x5D: 0x005D,
                0x5E: 0x005E,
                0x5F: 0x005F,
                0x60: 0x0060,
                0x61: 0x0061,
                0x62: 0x0062,
                0x63: 0x0063,
                0x64: 0x0064,
                0x65: 0x0065,
                0x66: 0x0066,
                0x67: 0x0067,
                0x68: 0x0068,
                0x69: 0x0069,
                0x6A: 0x006A,
                0x6B: 0x006B,
                0x6C: 0x006C,
                0x6D: 0x006D,
                0x6E: 0x006E,
                0x6F: 0x006F,
                0x70: 0x0070,
                0x71: 0x0071,
                0x72: 0x0072,
                0x73: 0x0073,
                0x74: 0x0074,
                0x75: 0x0075,
                0x76: 0x0076,
                0x77: 0x0077,
                0x78: 0x0078,
                0x79: 0x0079,
                0x7A: 0x007A,
                0x7B: 0x007B,
                0x7C: 0x007C,
                0x7D: 0x007D,
                0x7E: 0x203E,
                0x8140: 0x3000,
                0x8141: 0x3001,
                0x8142: 0x3002,
                0x8143: 0xFF0C,
                0x8144: 0xFF0E,
                0x8145: 0x30FB,
                0x8146: 0xFF1A,
                0x8147: 0xFF1B,
                0x8148: 0xFF1F,
                0x8149: 0xFF01,
                0x814A: 0x309B,
                0x814B: 0x309C,
                0x814C: 0x00B4,
                0x814D: 0xFF40,
                0x814E: 0x00A8,
                0x814F: 0xFF3E,
                0x8150: 0xFFE3,
                0x8151: 0xFF3F,
                0x8152: 0x30FD,
                0x8153: 0x30FE,
                0x8154: 0x309D,
                0x8155: 0x309E,
                0x8156: 0x3003,
                0x8157: 0x4EDD,
                0x8158: 0x3005,
                0x8159: 0x3006,
                0x815A: 0x3007,
                0x815B: 0x30FC,
                0x815C: 0x2015,
                0x815D: 0x2010,
                0x815E: 0xFF0F,
                0x815F: 0x005C,
                0x8160: 0x301C,
                0x8161: 0x2016,
                0x8162: 0xFF5C,
                0x8163: 0x2026,
                0x8164: 0x2025,
                0x8165: 0x2018,
                0x8166: 0x2019,
                0x8167: 0x201C,
                0x8168: 0x201D,
                0x8169: 0xFF08,
                0x816A: 0xFF09,
                0x816B: 0x3014,
                0x816C: 0x3015,
                0x816D: 0xFF3B,
                0x816E: 0xFF3D,
                0x816F: 0xFF5B,
                0x8170: 0xFF5D,
                0x8171: 0x3008,
                0x8172: 0x3009,
                0x8173: 0x300A,
                0x8174: 0x300B,
                0x8175: 0x300C,
                0x8176: 0x300D,
                0x8177: 0x300E,
                0x8178: 0x300F,
                0x8179: 0x3010,
                0x817A: 0x3011,
                0x817B: 0xFF0B,
                0x817C: 0x2212,
                0x817D: 0x00B1,
                0x817E: 0x00D7,
                0x8180: 0x00F7,
                0x8181: 0xFF1D,
                0x8182: 0x2260,
                0x8183: 0xFF1C,
                0x8184: 0xFF1E,
                0x8185: 0x2266,
                0x8186: 0x2267,
                0x8187: 0x221E,
                0x8188: 0x2234,
                0x8189: 0x2642,
                0x818A: 0x2640,
                0x818B: 0x00B0,
                0x818C: 0x2032,
                0x818D: 0x2033,
                0x818E: 0x2103,
                0x818F: 0xFFE5,
                0x8190: 0xFF04,
                0x8191: 0x00A2,
                0x8192: 0x00A3,
                0x8193: 0xFF05,
                0x8194: 0xFF03,
                0x8195: 0xFF06,
                0x8196: 0xFF0A,
                0x8197: 0xFF20,
                0x8198: 0x00A7,
                0x8199: 0x2606,
                0x819A: 0x2605,
                0x819B: 0x25CB,
                0x819C: 0x25CF,
                0x819D: 0x25CE,
                0x819E: 0x25C7,
                0x819F: 0x25C6,
                0x81A0: 0x25A1,
                0x81A1: 0x25A0,
                0x81A2: 0x25B3,
                0x81A3: 0x25B2,
                0x81A4: 0x25BD,
                0x81A5: 0x25BC,
                0x81A6: 0x203B,
                0x81A7: 0x3012,
                0x81A8: 0x2192,
                0x81A9: 0x2190,
                0x81AA: 0x2191,
                0x81AB: 0x2193,
                0x81AC: 0x3013,
                0x81B8: 0x2208,
                0x81B9: 0x220B,
                0x81BA: 0x2286,
                0x81BB: 0x2287,
                0x81BC: 0x2282,
                0x81BD: 0x2283,
                0x81BE: 0x222A,
                0x81BF: 0x2229,
                0x81C8: 0x2227,
                0x81C9: 0x2228,
                0x81CA: 0x00AC,
                0x81CB: 0x21D2,
                0x81CC: 0x21D4,
                0x81CD: 0x2200,
                0x81CE: 0x2203,
                0x81DA: 0x2220,
                0x81DB: 0x22A5,
                0x81DC: 0x2312,
                0x81DD: 0x2202,
                0x81DE: 0x2207,
                0x81DF: 0x2261,
                0x81E0: 0x2252,
                0x81E1: 0x226A,
                0x81E2: 0x226B,
                0x81E3: 0x221A,
                0x81E4: 0x223D,
                0x81E5: 0x221D,
                0x81E6: 0x2235,
                0x81E7: 0x222B,
                0x81E8: 0x222C,
                0x81F0: 0x212B,
                0x81F1: 0x2030,
                0x81F2: 0x266F,
                0x81F3: 0x266D,
                0x81F4: 0x266A,
                0x81F5: 0x2020,
                0x81F6: 0x2021,
                0x81F7: 0x00B6,
                0x81FC: 0x25EF,
                0x824F: 0xFF10,
                0x8250: 0xFF11,
                0x8251: 0xFF12,
                0x8252: 0xFF13,
                0x8253: 0xFF14,
                0x8254: 0xFF15,
                0x8255: 0xFF16,
                0x8256: 0xFF17,
                0x8257: 0xFF18,
                0x8258: 0xFF19,
                0x8260: 0xFF21,
                0x8261: 0xFF22,
                0x8262: 0xFF23,
                0x8263: 0xFF24,
                0x8264: 0xFF25,
                0x8265: 0xFF26,
                0x8266: 0xFF27,
                0x8267: 0xFF28,
                0x8268: 0xFF29,
                0x8269: 0xFF2A,
                0x826A: 0xFF2B,
                0x826B: 0xFF2C,
                0x826C: 0xFF2D,
                0x826D: 0xFF2E,
                0x826E: 0xFF2F,
                0x826F: 0xFF30,
                0x8270: 0xFF31,
                0x8271: 0xFF32,
                0x8272: 0xFF33,
                0x8273: 0xFF34,
                0x8274: 0xFF35,
                0x8275: 0xFF36,
                0x8276: 0xFF37,
                0x8277: 0xFF38,
                0x8278: 0xFF39,
                0x8279: 0xFF3A,
                0x8281: 0xFF41,
                0x8282: 0xFF42,
                0x8283: 0xFF43,
                0x8284: 0xFF44,
                0x8285: 0xFF45,
                0x8286: 0xFF46,
                0x8287: 0xFF47,
                0x8288: 0xFF48,
                0x8289: 0xFF49,
                0x828A: 0xFF4A,
                0x828B: 0xFF4B,
                0x828C: 0xFF4C,
                0x828D: 0xFF4D,
                0x828E: 0xFF4E,
                0x828F: 0xFF4F,
                0x8290: 0xFF50,
                0x8291: 0xFF51,
                0x8292: 0xFF52,
                0x8293: 0xFF53,
                0x8294: 0xFF54,
                0x8295: 0xFF55,
                0x8296: 0xFF56,
                0x8297: 0xFF57,
                0x8298: 0xFF58,
                0x8299: 0xFF59,
                0x829A: 0xFF5A,
                0x829F: 0x3041,
                0x82A0: 0x3042,
                0x82A1: 0x3043,
                0x82A2: 0x3044,
                0x82A3: 0x3045,
                0x82A4: 0x3046,
                0x82A5: 0x3047,
                0x82A6: 0x3048,
                0x82A7: 0x3049,
                0x82A8: 0x304A,
                0x82A9: 0x304B,
                0x82AA: 0x304C,
                0x82AB: 0x304D,
                0x82AC: 0x304E,
                0x82AD: 0x304F,
                0x82AE: 0x3050,
                0x82AF: 0x3051,
                0x82B0: 0x3052,
                0x82B1: 0x3053,
                0x82B2: 0x3054,
                0x82B3: 0x3055,
                0x82B4: 0x3056,
                0x82B5: 0x3057,
                0x82B6: 0x3058,
                0x82B7: 0x3059,
                0x82B8: 0x305A,
                0x82B9: 0x305B,
                0x82BA: 0x305C,
                0x82BB: 0x305D,
                0x82BC: 0x305E,
                0x82BD: 0x305F,
                0x82BE: 0x3060,
                0x82BF: 0x3061,
                0x82C0: 0x3062,
                0x82C1: 0x3063,
                0x82C2: 0x3064,
                0x82C3: 0x3065,
                0x82C4: 0x3066,
                0x82C5: 0x3067,
                0x82C6: 0x3068,
                0x82C7: 0x3069,
                0x82C8: 0x306A,
                0x82C9: 0x306B,
                0x82CA: 0x306C,
                0x82CB: 0x306D,
                0x82CC: 0x306E,
                0x82CD: 0x306F,
                0x82CE: 0x3070,
                0x82CF: 0x3071,
                0x82D0: 0x3072,
                0x82D1: 0x3073,
                0x82D2: 0x3074,
                0x82D3: 0x3075,
                0x82D4: 0x3076,
                0x82D5: 0x3077,
                0x82D6: 0x3078,
                0x82D7: 0x3079,
                0x82D8: 0x307A,
                0x82D9: 0x307B,
                0x82DA: 0x307C,
                0x82DB: 0x307D,
                0x82DC: 0x307E,
                0x82DD: 0x307F,
                0x82DE: 0x3080,
                0x82DF: 0x3081,
                0x82E0: 0x3082,
                0x82E1: 0x3083,
                0x82E2: 0x3084,
                0x82E3: 0x3085,
                0x82E4: 0x3086,
                0x82E5: 0x3087,
                0x82E6: 0x3088,
                0x82E7: 0x3089,
                0x82E8: 0x308A,
                0x82E9: 0x308B,
                0x82EA: 0x308C,
                0x82EB: 0x308D,
                0x82EC: 0x308E,
                0x82ED: 0x308F,
                0x82EE: 0x3090,
                0x82EF: 0x3091,
                0x82F0: 0x3092,
                0x82F1: 0x3093,
                0x8340: 0x30A1,
                0x8341: 0x30A2,
                0x8342: 0x30A3,
                0x8343: 0x30A4,
                0x8344: 0x30A5,
                0x8345: 0x30A6,
                0x8346: 0x30A7,
                0x8347: 0x30A8,
                0x8348: 0x30A9,
                0x8349: 0x30AA,
                0x834A: 0x30AB,
                0x834B: 0x30AC,
                0x834C: 0x30AD,
                0x834D: 0x30AE,
                0x834E: 0x30AF,
                0x834F: 0x30B0,
                0x8350: 0x30B1,
                0x8351: 0x30B2,
                0x8352: 0x30B3,
                0x8353: 0x30B4,
                0x8354: 0x30B5,
                0x8355: 0x30B6,
                0x8356: 0x30B7,
                0x8357: 0x30B8,
                0x8358: 0x30B9,
                0x8359: 0x30BA,
                0x835A: 0x30BB,
                0x835B: 0x30BC,
                0x835C: 0x30BD,
                0x835D: 0x30BE,
                0x835E: 0x30BF,
                0x835F: 0x30C0,
                0x8360: 0x30C1,
                0x8361: 0x30C2,
                0x8362: 0x30C3,
                0x8363: 0x30C4,
                0x8364: 0x30C5,
                0x8365: 0x30C6,
                0x8366: 0x30C7,
                0x8367: 0x30C8,
                0x8368: 0x30C9,
                0x8369: 0x30CA,
                0x836A: 0x30CB,
                0x836B: 0x30CC,
                0x836C: 0x30CD,
                0x836D: 0x30CE,
                0x836E: 0x30CF,
                0x836F: 0x30D0,
                0x8370: 0x30D1,
                0x8371: 0x30D2,
                0x8372: 0x30D3,
                0x8373: 0x30D4,
                0x8374: 0x30D5,
                0x8375: 0x30D6,
                0x8376: 0x30D7,
                0x8377: 0x30D8,
                0x8378: 0x30D9,
                0x8379: 0x30DA,
                0x837A: 0x30DB,
                0x837B: 0x30DC,
                0x837C: 0x30DD,
                0x837D: 0x30DE,
                0x837E: 0x30DF,
                0x8380: 0x30E0,
                0x8381: 0x30E1,
                0x8382: 0x30E2,
                0x8383: 0x30E3,
                0x8384: 0x30E4,
                0x8385: 0x30E5,
                0x8386: 0x30E6,
                0x8387: 0x30E7,
                0x8388: 0x30E8,
                0x8389: 0x30E9,
                0x838A: 0x30EA,
                0x838B: 0x30EB,
                0x838C: 0x30EC,
                0x838D: 0x30ED,
                0x838E: 0x30EE,
                0x838F: 0x30EF,
                0x8390: 0x30F0,
                0x8391: 0x30F1,
                0x8392: 0x30F2,
                0x8393: 0x30F3,
                0x8394: 0x30F4,
                0x8395: 0x30F5,
                0x8396: 0x30F6,
                0x839F: 0x0391,
                0x83A0: 0x0392,
                0x83A1: 0x0393,
                0x83A2: 0x0394,
                0x83A3: 0x0395,
                0x83A4: 0x0396,
                0x83A5: 0x0397,
                0x83A6: 0x0398,
                0x83A7: 0x0399,
                0x83A8: 0x039A,
                0x83A9: 0x039B,
                0x83AA: 0x039C,
                0x83AB: 0x039D,
                0x83AC: 0x039E,
                0x83AD: 0x039F,
                0x83AE: 0x03A0,
                0x83AF: 0x03A1,
                0x83B0: 0x03A3,
                0x83B1: 0x03A4,
                0x83B2: 0x03A5,
                0x83B3: 0x03A6,
                0x83B4: 0x03A7,
                0x83B5: 0x03A8,
                0x83B6: 0x03A9,
                0x83BF: 0x03B1,
                0x83C0: 0x03B2,
                0x83C1: 0x03B3,
                0x83C2: 0x03B4,
                0x83C3: 0x03B5,
                0x83C4: 0x03B6,
                0x83C5: 0x03B7,
                0x83C6: 0x03B8,
                0x83C7: 0x03B9,
                0x83C8: 0x03BA,
                0x83C9: 0x03BB,
                0x83CA: 0x03BC,
                0x83CB: 0x03BD,
                0x83CC: 0x03BE,
                0x83CD: 0x03BF,
                0x83CE: 0x03C0,
                0x83CF: 0x03C1,
                0x83D0: 0x03C3,
                0x83D1: 0x03C4,
                0x83D2: 0x03C5,
                0x83D3: 0x03C6,
                0x83D4: 0x03C7,
                0x83D5: 0x03C8,
                0x83D6: 0x03C9,
                0x8440: 0x0410,
                0x8441: 0x0411,
                0x8442: 0x0412,
                0x8443: 0x0413,
                0x8444: 0x0414,
                0x8445: 0x0415,
                0x8446: 0x0401,
                0x8447: 0x0416,
                0x8448: 0x0417,
                0x8449: 0x0418,
                0x844A: 0x0419,
                0x844B: 0x041A,
                0x844C: 0x041B,
                0x844D: 0x041C,
                0x844E: 0x041D,
                0x844F: 0x041E,
                0x8450: 0x041F,
                0x8451: 0x0420,
                0x8452: 0x0421,
                0x8453: 0x0422,
                0x8454: 0x0423,
                0x8455: 0x0424,
                0x8456: 0x0425,
                0x8457: 0x0426,
                0x8458: 0x0427,
                0x8459: 0x0428,
                0x845A: 0x0429,
                0x845B: 0x042A,
                0x845C: 0x042B,
                0x845D: 0x042C,
                0x845E: 0x042D,
                0x845F: 0x042E,
                0x8460: 0x042F,
                0x8470: 0x0430,
                0x8471: 0x0431,
                0x8472: 0x0432,
                0x8473: 0x0433,
                0x8474: 0x0434,
                0x8475: 0x0435,
                0x8476: 0x0451,
                0x8477: 0x0436,
                0x8478: 0x0437,
                0x8479: 0x0438,
                0x847A: 0x0439,
                0x847B: 0x043A,
                0x847C: 0x043B,
                0x847D: 0x043C,
                0x847E: 0x043D,
                0x8480: 0x043E,
                0x8481: 0x043F,
                0x8482: 0x0440,
                0x8483: 0x0441,
                0x8484: 0x0442,
                0x8485: 0x0443,
                0x8486: 0x0444,
                0x8487: 0x0445,
                0x8488: 0x0446,
                0x8489: 0x0447,
                0x848A: 0x0448,
                0x848B: 0x0449,
                0x848C: 0x044A,
                0x848D: 0x044B,
                0x848E: 0x044C,
                0x848F: 0x044D,
                0x8490: 0x044E,
                0x8491: 0x044F,
                0x849F: 0x2500,
                0x84A0: 0x2502,
                0x84A1: 0x250C,
                0x84A2: 0x2510,
                0x84A3: 0x2518,
                0x84A4: 0x2514,
                0x84A5: 0x251C,
                0x84A6: 0x252C,
                0x84A7: 0x2524,
                0x84A8: 0x2534,
                0x84A9: 0x253C,
                0x84AA: 0x2501,
                0x84AB: 0x2503,
                0x84AC: 0x250F,
                0x84AD: 0x2513,
                0x84AE: 0x251B,
                0x84AF: 0x2517,
                0x84B0: 0x2523,
                0x84B1: 0x2533,
                0x84B2: 0x252B,
                0x84B3: 0x253B,
                0x84B4: 0x254B,
                0x84B5: 0x2520,
                0x84B6: 0x252F,
                0x84B7: 0x2528,
                0x84B8: 0x2537,
                0x84B9: 0x253F,
                0x84BA: 0x251D,
                0x84BB: 0x2530,
                0x84BC: 0x2525,
                0x84BD: 0x2538,
                0x84BE: 0x2542,
                0x889F: 0x4E9C,
                0x88A0: 0x5516,
                0x88A1: 0x5A03,
                0x88A2: 0x963F,
                0x88A3: 0x54C0,
                0x88A4: 0x611B,
                0x88A5: 0x6328,
                0x88A6: 0x59F6,
                0x88A7: 0x9022,
                0x88A8: 0x8475,
                0x88A9: 0x831C,
                0x88AA: 0x7A50,
                0x88AB: 0x60AA,
                0x88AC: 0x63E1,
                0x88AD: 0x6E25,
                0x88AE: 0x65ED,
                0x88AF: 0x8466,
                0x88B0: 0x82A6,
                0x88B1: 0x9BF5,
                0x88B2: 0x6893,
                0x88B3: 0x5727,
                0x88B4: 0x65A1,
                0x88B5: 0x6271,
                0x88B6: 0x5B9B,
                0x88B7: 0x59D0,
                0x88B8: 0x867B,
                0x88B9: 0x98F4,
                0x88BA: 0x7D62,
                0x88BB: 0x7DBE,
                0x88BC: 0x9B8E,
                0x88BD: 0x6216,
                0x88BE: 0x7C9F,
                0x88BF: 0x88B7,
                0x88C0: 0x5B89,
                0x88C1: 0x5EB5,
                0x88C2: 0x6309,
                0x88C3: 0x6697,
                0x88C4: 0x6848,
                0x88C5: 0x95C7,
                0x88C6: 0x978D,
                0x88C7: 0x674F,
                0x88C8: 0x4EE5,
                0x88C9: 0x4F0A,
                0x88CA: 0x4F4D,
                0x88CB: 0x4F9D,
                0x88CC: 0x5049,
                0x88CD: 0x56F2,
                0x88CE: 0x5937,
                0x88CF: 0x59D4,
                0x88D0: 0x5A01,
                0x88D1: 0x5C09,
                0x88D2: 0x60DF,
                0x88D3: 0x610F,
                0x88D4: 0x6170,
                0x88D5: 0x6613,
                0x88D6: 0x6905,
                0x88D7: 0x70BA,
                0x88D8: 0x754F,
                0x88D9: 0x7570,
                0x88DA: 0x79FB,
                0x88DB: 0x7DAD,
                0x88DC: 0x7DEF,
                0x88DD: 0x80C3,
                0x88DE: 0x840E,
                0x88DF: 0x8863,
                0x88E0: 0x8B02,
                0x88E1: 0x9055,
                0x88E2: 0x907A,
                0x88E3: 0x533B,
                0x88E4: 0x4E95,
                0x88E5: 0x4EA5,
                0x88E6: 0x57DF,
                0x88E7: 0x80B2,
                0x88E8: 0x90C1,
                0x88E9: 0x78EF,
                0x88EA: 0x4E00,
                0x88EB: 0x58F1,
                0x88EC: 0x6EA2,
                0x88ED: 0x9038,
                0x88EE: 0x7A32,
                0x88EF: 0x8328,
                0x88F0: 0x828B,
                0x88F1: 0x9C2F,
                0x88F2: 0x5141,
                0x88F3: 0x5370,
                0x88F4: 0x54BD,
                0x88F5: 0x54E1,
                0x88F6: 0x56E0,
                0x88F7: 0x59FB,
                0x88F8: 0x5F15,
                0x88F9: 0x98F2,
                0x88FA: 0x6DEB,
                0x88FB: 0x80E4,
                0x88FC: 0x852D,
                0x8940: 0x9662,
                0x8941: 0x9670,
                0x8942: 0x96A0,
                0x8943: 0x97FB,
                0x8944: 0x540B,
                0x8945: 0x53F3,
                0x8946: 0x5B87,
                0x8947: 0x70CF,
                0x8948: 0x7FBD,
                0x8949: 0x8FC2,
                0x894A: 0x96E8,
                0x894B: 0x536F,
                0x894C: 0x9D5C,
                0x894D: 0x7ABA,
                0x894E: 0x4E11,
                0x894F: 0x7893,
                0x8950: 0x81FC,
                0x8951: 0x6E26,
                0x8952: 0x5618,
                0x8953: 0x5504,
                0x8954: 0x6B1D,
                0x8955: 0x851A,
                0x8956: 0x9C3B,
                0x8957: 0x59E5,
                0x8958: 0x53A9,
                0x8959: 0x6D66,
                0x895A: 0x74DC,
                0x895B: 0x958F,
                0x895C: 0x5642,
                0x895D: 0x4E91,
                0x895E: 0x904B,
                0x895F: 0x96F2,
                0x8960: 0x834F,
                0x8961: 0x990C,
                0x8962: 0x53E1,
                0x8963: 0x55B6,
                0x8964: 0x5B30,
                0x8965: 0x5F71,
                0x8966: 0x6620,
                0x8967: 0x66F3,
                0x8968: 0x6804,
                0x8969: 0x6C38,
                0x896A: 0x6CF3,
                0x896B: 0x6D29,
                0x896C: 0x745B,
                0x896D: 0x76C8,
                0x896E: 0x7A4E,
                0x896F: 0x9834,
                0x8970: 0x82F1,
                0x8971: 0x885B,
                0x8972: 0x8A60,
                0x8973: 0x92ED,
                0x8974: 0x6DB2,
                0x8975: 0x75AB,
                0x8976: 0x76CA,
                0x8977: 0x99C5,
                0x8978: 0x60A6,
                0x8979: 0x8B01,
                0x897A: 0x8D8A,
                0x897B: 0x95B2,
                0x897C: 0x698E,
                0x897D: 0x53AD,
                0x897E: 0x5186,
                0x8980: 0x5712,
                0x8981: 0x5830,
                0x8982: 0x5944,
                0x8983: 0x5BB4,
                0x8984: 0x5EF6,
                0x8985: 0x6028,
                0x8986: 0x63A9,
                0x8987: 0x63F4,
                0x8988: 0x6CBF,
                0x8989: 0x6F14,
                0x898A: 0x708E,
                0x898B: 0x7114,
                0x898C: 0x7159,
                0x898D: 0x71D5,
                0x898E: 0x733F,
                0x898F: 0x7E01,
                0x8990: 0x8276,
                0x8991: 0x82D1,
                0x8992: 0x8597,
                0x8993: 0x9060,
                0x8994: 0x925B,
                0x8995: 0x9D1B,
                0x8996: 0x5869,
                0x8997: 0x65BC,
                0x8998: 0x6C5A,
                0x8999: 0x7525,
                0x899A: 0x51F9,
                0x899B: 0x592E,
                0x899C: 0x5965,
                0x899D: 0x5F80,
                0x899E: 0x5FDC,
                0x899F: 0x62BC,
                0x89A0: 0x65FA,
                0x89A1: 0x6A2A,
                0x89A2: 0x6B27,
                0x89A3: 0x6BB4,
                0x89A4: 0x738B,
                0x89A5: 0x7FC1,
                0x89A6: 0x8956,
                0x89A7: 0x9D2C,
                0x89A8: 0x9D0E,
                0x89A9: 0x9EC4,
                0x89AA: 0x5CA1,
                0x89AB: 0x6C96,
                0x89AC: 0x837B,
                0x89AD: 0x5104,
                0x89AE: 0x5C4B,
                0x89AF: 0x61B6,
                0x89B0: 0x81C6,
                0x89B1: 0x6876,
                0x89B2: 0x7261,
                0x89B3: 0x4E59,
                0x89B4: 0x4FFA,
                0x89B5: 0x5378,
                0x89B6: 0x6069,
                0x89B7: 0x6E29,
                0x89B8: 0x7A4F,
                0x89B9: 0x97F3,
                0x89BA: 0x4E0B,
                0x89BB: 0x5316,
                0x89BC: 0x4EEE,
                0x89BD: 0x4F55,
                0x89BE: 0x4F3D,
                0x89BF: 0x4FA1,
                0x89C0: 0x4F73,
                0x89C1: 0x52A0,
                0x89C2: 0x53EF,
                0x89C3: 0x5609,
                0x89C4: 0x590F,
                0x89C5: 0x5AC1,
                0x89C6: 0x5BB6,
                0x89C7: 0x5BE1,
                0x89C8: 0x79D1,
                0x89C9: 0x6687,
                0x89CA: 0x679C,
                0x89CB: 0x67B6,
                0x89CC: 0x6B4C,
                0x89CD: 0x6CB3,
                0x89CE: 0x706B,
                0x89CF: 0x73C2,
                0x89D0: 0x798D,
                0x89D1: 0x79BE,
                0x89D2: 0x7A3C,
                0x89D3: 0x7B87,
                0x89D4: 0x82B1,
                0x89D5: 0x82DB,
                0x89D6: 0x8304,
                0x89D7: 0x8377,
                0x89D8: 0x83EF,
                0x89D9: 0x83D3,
                0x89DA: 0x8766,
                0x89DB: 0x8AB2,
                0x89DC: 0x5629,
                0x89DD: 0x8CA8,
                0x89DE: 0x8FE6,
                0x89DF: 0x904E,
                0x89E0: 0x971E,
                0x89E1: 0x868A,
                0x89E2: 0x4FC4,
                0x89E3: 0x5CE8,
                0x89E4: 0x6211,
                0x89E5: 0x7259,
                0x89E6: 0x753B,
                0x89E7: 0x81E5,
                0x89E8: 0x82BD,
                0x89E9: 0x86FE,
                0x89EA: 0x8CC0,
                0x89EB: 0x96C5,
                0x89EC: 0x9913,
                0x89ED: 0x99D5,
                0x89EE: 0x4ECB,
                0x89EF: 0x4F1A,
                0x89F0: 0x89E3,
                0x89F1: 0x56DE,
                0x89F2: 0x584A,
                0x89F3: 0x58CA,
                0x89F4: 0x5EFB,
                0x89F5: 0x5FEB,
                0x89F6: 0x602A,
                0x89F7: 0x6094,
                0x89F8: 0x6062,
                0x89F9: 0x61D0,
                0x89FA: 0x6212,
                0x89FB: 0x62D0,
                0x89FC: 0x6539,
                0x8A40: 0x9B41,
                0x8A41: 0x6666,
                0x8A42: 0x68B0,
                0x8A43: 0x6D77,
                0x8A44: 0x7070,
                0x8A45: 0x754C,
                0x8A46: 0x7686,
                0x8A47: 0x7D75,
                0x8A48: 0x82A5,
                0x8A49: 0x87F9,
                0x8A4A: 0x958B,
                0x8A4B: 0x968E,
                0x8A4C: 0x8C9D,
                0x8A4D: 0x51F1,
                0x8A4E: 0x52BE,
                0x8A4F: 0x5916,
                0x8A50: 0x54B3,
                0x8A51: 0x5BB3,
                0x8A52: 0x5D16,
                0x8A53: 0x6168,
                0x8A54: 0x6982,
                0x8A55: 0x6DAF,
                0x8A56: 0x788D,
                0x8A57: 0x84CB,
                0x8A58: 0x8857,
                0x8A59: 0x8A72,
                0x8A5A: 0x93A7,
                0x8A5B: 0x9AB8,
                0x8A5C: 0x6D6C,
                0x8A5D: 0x99A8,
                0x8A5E: 0x86D9,
                0x8A5F: 0x57A3,
                0x8A60: 0x67FF,
                0x8A61: 0x86CE,
                0x8A62: 0x920E,
                0x8A63: 0x5283,
                0x8A64: 0x5687,
                0x8A65: 0x5404,
                0x8A66: 0x5ED3,
                0x8A67: 0x62E1,
                0x8A68: 0x64B9,
                0x8A69: 0x683C,
                0x8A6A: 0x6838,
                0x8A6B: 0x6BBB,
                0x8A6C: 0x7372,
                0x8A6D: 0x78BA,
                0x8A6E: 0x7A6B,
                0x8A6F: 0x899A,
                0x8A70: 0x89D2,
                0x8A71: 0x8D6B,
                0x8A72: 0x8F03,
                0x8A73: 0x90ED,
                0x8A74: 0x95A3,
                0x8A75: 0x9694,
                0x8A76: 0x9769,
                0x8A77: 0x5B66,
                0x8A78: 0x5CB3,
                0x8A79: 0x697D,
                0x8A7A: 0x984D,
                0x8A7B: 0x984E,
                0x8A7C: 0x639B,
                0x8A7D: 0x7B20,
                0x8A7E: 0x6A2B,
                0x8A80: 0x6A7F,
                0x8A81: 0x68B6,
                0x8A82: 0x9C0D,
                0x8A83: 0x6F5F,
                0x8A84: 0x5272,
                0x8A85: 0x559D,
                0x8A86: 0x6070,
                0x8A87: 0x62EC,
                0x8A88: 0x6D3B,
                0x8A89: 0x6E07,
                0x8A8A: 0x6ED1,
                0x8A8B: 0x845B,
                0x8A8C: 0x8910,
                0x8A8D: 0x8F44,
                0x8A8E: 0x4E14,
                0x8A8F: 0x9C39,
                0x8A90: 0x53F6,
                0x8A91: 0x691B,
                0x8A92: 0x6A3A,
                0x8A93: 0x9784,
                0x8A94: 0x682A,
                0x8A95: 0x515C,
                0x8A96: 0x7AC3,
                0x8A97: 0x84B2,
                0x8A98: 0x91DC,
                0x8A99: 0x938C,
                0x8A9A: 0x565B,
                0x8A9B: 0x9D28,
                0x8A9C: 0x6822,
                0x8A9D: 0x8305,
                0x8A9E: 0x8431,
                0x8A9F: 0x7CA5,
                0x8AA0: 0x5208,
                0x8AA1: 0x82C5,
                0x8AA2: 0x74E6,
                0x8AA3: 0x4E7E,
                0x8AA4: 0x4F83,
                0x8AA5: 0x51A0,
                0x8AA6: 0x5BD2,
                0x8AA7: 0x520A,
                0x8AA8: 0x52D8,
                0x8AA9: 0x52E7,
                0x8AAA: 0x5DFB,
                0x8AAB: 0x559A,
                0x8AAC: 0x582A,
                0x8AAD: 0x59E6,
                0x8AAE: 0x5B8C,
                0x8AAF: 0x5B98,
                0x8AB0: 0x5BDB,
                0x8AB1: 0x5E72,
                0x8AB2: 0x5E79,
                0x8AB3: 0x60A3,
                0x8AB4: 0x611F,
                0x8AB5: 0x6163,
                0x8AB6: 0x61BE,
                0x8AB7: 0x63DB,
                0x8AB8: 0x6562,
                0x8AB9: 0x67D1,
                0x8ABA: 0x6853,
                0x8ABB: 0x68FA,
                0x8ABC: 0x6B3E,
                0x8ABD: 0x6B53,
                0x8ABE: 0x6C57,
                0x8ABF: 0x6F22,
                0x8AC0: 0x6F97,
                0x8AC1: 0x6F45,
                0x8AC2: 0x74B0,
                0x8AC3: 0x7518,
                0x8AC4: 0x76E3,
                0x8AC5: 0x770B,
                0x8AC6: 0x7AFF,
                0x8AC7: 0x7BA1,
                0x8AC8: 0x7C21,
                0x8AC9: 0x7DE9,
                0x8ACA: 0x7F36,
                0x8ACB: 0x7FF0,
                0x8ACC: 0x809D,
                0x8ACD: 0x8266,
                0x8ACE: 0x839E,
                0x8ACF: 0x89B3,
                0x8AD0: 0x8ACC,
                0x8AD1: 0x8CAB,
                0x8AD2: 0x9084,
                0x8AD3: 0x9451,
                0x8AD4: 0x9593,
                0x8AD5: 0x9591,
                0x8AD6: 0x95A2,
                0x8AD7: 0x9665,
                0x8AD8: 0x97D3,
                0x8AD9: 0x9928,
                0x8ADA: 0x8218,
                0x8ADB: 0x4E38,
                0x8ADC: 0x542B,
                0x8ADD: 0x5CB8,
                0x8ADE: 0x5DCC,
                0x8ADF: 0x73A9,
                0x8AE0: 0x764C,
                0x8AE1: 0x773C,
                0x8AE2: 0x5CA9,
                0x8AE3: 0x7FEB,
                0x8AE4: 0x8D0B,
                0x8AE5: 0x96C1,
                0x8AE6: 0x9811,
                0x8AE7: 0x9854,
                0x8AE8: 0x9858,
                0x8AE9: 0x4F01,
                0x8AEA: 0x4F0E,
                0x8AEB: 0x5371,
                0x8AEC: 0x559C,
                0x8AED: 0x5668,
                0x8AEE: 0x57FA,
                0x8AEF: 0x5947,
                0x8AF0: 0x5B09,
                0x8AF1: 0x5BC4,
                0x8AF2: 0x5C90,
                0x8AF3: 0x5E0C,
                0x8AF4: 0x5E7E,
                0x8AF5: 0x5FCC,
                0x8AF6: 0x63EE,
                0x8AF7: 0x673A,
                0x8AF8: 0x65D7,
                0x8AF9: 0x65E2,
                0x8AFA: 0x671F,
                0x8AFB: 0x68CB,
                0x8AFC: 0x68C4,
                0x8B40: 0x6A5F,
                0x8B41: 0x5E30,
                0x8B42: 0x6BC5,
                0x8B43: 0x6C17,
                0x8B44: 0x6C7D,
                0x8B45: 0x757F,
                0x8B46: 0x7948,
                0x8B47: 0x5B63,
                0x8B48: 0x7A00,
                0x8B49: 0x7D00,
                0x8B4A: 0x5FBD,
                0x8B4B: 0x898F,
                0x8B4C: 0x8A18,
                0x8B4D: 0x8CB4,
                0x8B4E: 0x8D77,
                0x8B4F: 0x8ECC,
                0x8B50: 0x8F1D,
                0x8B51: 0x98E2,
                0x8B52: 0x9A0E,
                0x8B53: 0x9B3C,
                0x8B54: 0x4E80,
                0x8B55: 0x507D,
                0x8B56: 0x5100,
                0x8B57: 0x5993,
                0x8B58: 0x5B9C,
                0x8B59: 0x622F,
                0x8B5A: 0x6280,
                0x8B5B: 0x64EC,
                0x8B5C: 0x6B3A,
                0x8B5D: 0x72A0,
                0x8B5E: 0x7591,
                0x8B5F: 0x7947,
                0x8B60: 0x7FA9,
                0x8B61: 0x87FB,
                0x8B62: 0x8ABC,
                0x8B63: 0x8B70,
                0x8B64: 0x63AC,
                0x8B65: 0x83CA,
                0x8B66: 0x97A0,
                0x8B67: 0x5409,
                0x8B68: 0x5403,
                0x8B69: 0x55AB,
                0x8B6A: 0x6854,
                0x8B6B: 0x6A58,
                0x8B6C: 0x8A70,
                0x8B6D: 0x7827,
                0x8B6E: 0x6775,
                0x8B6F: 0x9ECD,
                0x8B70: 0x5374,
                0x8B71: 0x5BA2,
                0x8B72: 0x811A,
                0x8B73: 0x8650,
                0x8B74: 0x9006,
                0x8B75: 0x4E18,
                0x8B76: 0x4E45,
                0x8B77: 0x4EC7,
                0x8B78: 0x4F11,
                0x8B79: 0x53CA,
                0x8B7A: 0x5438,
                0x8B7B: 0x5BAE,
                0x8B7C: 0x5F13,
                0x8B7D: 0x6025,
                0x8B7E: 0x6551,
                0x8B80: 0x673D,
                0x8B81: 0x6C42,
                0x8B82: 0x6C72,
                0x8B83: 0x6CE3,
                0x8B84: 0x7078,
                0x8B85: 0x7403,
                0x8B86: 0x7A76,
                0x8B87: 0x7AAE,
                0x8B88: 0x7B08,
                0x8B89: 0x7D1A,
                0x8B8A: 0x7CFE,
                0x8B8B: 0x7D66,
                0x8B8C: 0x65E7,
                0x8B8D: 0x725B,
                0x8B8E: 0x53BB,
                0x8B8F: 0x5C45,
                0x8B90: 0x5DE8,
                0x8B91: 0x62D2,
                0x8B92: 0x62E0,
                0x8B93: 0x6319,
                0x8B94: 0x6E20,
                0x8B95: 0x865A,
                0x8B96: 0x8A31,
                0x8B97: 0x8DDD,
                0x8B98: 0x92F8,
                0x8B99: 0x6F01,
                0x8B9A: 0x79A6,
                0x8B9B: 0x9B5A,
                0x8B9C: 0x4EA8,
                0x8B9D: 0x4EAB,
                0x8B9E: 0x4EAC,
                0x8B9F: 0x4F9B,
                0x8BA0: 0x4FA0,
                0x8BA1: 0x50D1,
                0x8BA2: 0x5147,
                0x8BA3: 0x7AF6,
                0x8BA4: 0x5171,
                0x8BA5: 0x51F6,
                0x8BA6: 0x5354,
                0x8BA7: 0x5321,
                0x8BA8: 0x537F,
                0x8BA9: 0x53EB,
                0x8BAA: 0x55AC,
                0x8BAB: 0x5883,
                0x8BAC: 0x5CE1,
                0x8BAD: 0x5F37,
                0x8BAE: 0x5F4A,
                0x8BAF: 0x602F,
                0x8BB0: 0x6050,
                0x8BB1: 0x606D,
                0x8BB2: 0x631F,
                0x8BB3: 0x6559,
                0x8BB4: 0x6A4B,
                0x8BB5: 0x6CC1,
                0x8BB6: 0x72C2,
                0x8BB7: 0x72ED,
                0x8BB8: 0x77EF,
                0x8BB9: 0x80F8,
                0x8BBA: 0x8105,
                0x8BBB: 0x8208,
                0x8BBC: 0x854E,
                0x8BBD: 0x90F7,
                0x8BBE: 0x93E1,
                0x8BBF: 0x97FF,
                0x8BC0: 0x9957,
                0x8BC1: 0x9A5A,
                0x8BC2: 0x4EF0,
                0x8BC3: 0x51DD,
                0x8BC4: 0x5C2D,
                0x8BC5: 0x6681,
                0x8BC6: 0x696D,
                0x8BC7: 0x5C40,
                0x8BC8: 0x66F2,
                0x8BC9: 0x6975,
                0x8BCA: 0x7389,
                0x8BCB: 0x6850,
                0x8BCC: 0x7C81,
                0x8BCD: 0x50C5,
                0x8BCE: 0x52E4,
                0x8BCF: 0x5747,
                0x8BD0: 0x5DFE,
                0x8BD1: 0x9326,
                0x8BD2: 0x65A4,
                0x8BD3: 0x6B23,
                0x8BD4: 0x6B3D,
                0x8BD5: 0x7434,
                0x8BD6: 0x7981,
                0x8BD7: 0x79BD,
                0x8BD8: 0x7B4B,
                0x8BD9: 0x7DCA,
                0x8BDA: 0x82B9,
                0x8BDB: 0x83CC,
                0x8BDC: 0x887F,
                0x8BDD: 0x895F,
                0x8BDE: 0x8B39,
                0x8BDF: 0x8FD1,
                0x8BE0: 0x91D1,
                0x8BE1: 0x541F,
                0x8BE2: 0x9280,
                0x8BE3: 0x4E5D,
                0x8BE4: 0x5036,
                0x8BE5: 0x53E5,
                0x8BE6: 0x533A,
                0x8BE7: 0x72D7,
                0x8BE8: 0x7396,
                0x8BE9: 0x77E9,
                0x8BEA: 0x82E6,
                0x8BEB: 0x8EAF,
                0x8BEC: 0x99C6,
                0x8BED: 0x99C8,
                0x8BEE: 0x99D2,
                0x8BEF: 0x5177,
                0x8BF0: 0x611A,
                0x8BF1: 0x865E,
                0x8BF2: 0x55B0,
                0x8BF3: 0x7A7A,
                0x8BF4: 0x5076,
                0x8BF5: 0x5BD3,
                0x8BF6: 0x9047,
                0x8BF7: 0x9685,
                0x8BF8: 0x4E32,
                0x8BF9: 0x6ADB,
                0x8BFA: 0x91E7,
                0x8BFB: 0x5C51,
                0x8BFC: 0x5C48,
                0x8C40: 0x6398,
                0x8C41: 0x7A9F,
                0x8C42: 0x6C93,
                0x8C43: 0x9774,
                0x8C44: 0x8F61,
                0x8C45: 0x7AAA,
                0x8C46: 0x718A,
                0x8C47: 0x9688,
                0x8C48: 0x7C82,
                0x8C49: 0x6817,
                0x8C4A: 0x7E70,
                0x8C4B: 0x6851,
                0x8C4C: 0x936C,
                0x8C4D: 0x52F2,
                0x8C4E: 0x541B,
                0x8C4F: 0x85AB,
                0x8C50: 0x8A13,
                0x8C51: 0x7FA4,
                0x8C52: 0x8ECD,
                0x8C53: 0x90E1,
                0x8C54: 0x5366,
                0x8C55: 0x8888,
                0x8C56: 0x7941,
                0x8C57: 0x4FC2,
                0x8C58: 0x50BE,
                0x8C59: 0x5211,
                0x8C5A: 0x5144,
                0x8C5B: 0x5553,
                0x8C5C: 0x572D,
                0x8C5D: 0x73EA,
                0x8C5E: 0x578B,
                0x8C5F: 0x5951,
                0x8C60: 0x5F62,
                0x8C61: 0x5F84,
                0x8C62: 0x6075,
                0x8C63: 0x6176,
                0x8C64: 0x6167,
                0x8C65: 0x61A9,
                0x8C66: 0x63B2,
                0x8C67: 0x643A,
                0x8C68: 0x656C,
                0x8C69: 0x666F,
                0x8C6A: 0x6842,
                0x8C6B: 0x6E13,
                0x8C6C: 0x7566,
                0x8C6D: 0x7A3D,
                0x8C6E: 0x7CFB,
                0x8C6F: 0x7D4C,
                0x8C70: 0x7D99,
                0x8C71: 0x7E4B,
                0x8C72: 0x7F6B,
                0x8C73: 0x830E,
                0x8C74: 0x834A,
                0x8C75: 0x86CD,
                0x8C76: 0x8A08,
                0x8C77: 0x8A63,
                0x8C78: 0x8B66,
                0x8C79: 0x8EFD,
                0x8C7A: 0x981A,
                0x8C7B: 0x9D8F,
                0x8C7C: 0x82B8,
                0x8C7D: 0x8FCE,
                0x8C7E: 0x9BE8,
                0x8C80: 0x5287,
                0x8C81: 0x621F,
                0x8C82: 0x6483,
                0x8C83: 0x6FC0,
                0x8C84: 0x9699,
                0x8C85: 0x6841,
                0x8C86: 0x5091,
                0x8C87: 0x6B20,
                0x8C88: 0x6C7A,
                0x8C89: 0x6F54,
                0x8C8A: 0x7A74,
                0x8C8B: 0x7D50,
                0x8C8C: 0x8840,
                0x8C8D: 0x8A23,
                0x8C8E: 0x6708,
                0x8C8F: 0x4EF6,
                0x8C90: 0x5039,
                0x8C91: 0x5026,
                0x8C92: 0x5065,
                0x8C93: 0x517C,
                0x8C94: 0x5238,
                0x8C95: 0x5263,
                0x8C96: 0x55A7,
                0x8C97: 0x570F,
                0x8C98: 0x5805,
                0x8C99: 0x5ACC,
                0x8C9A: 0x5EFA,
                0x8C9B: 0x61B2,
                0x8C9C: 0x61F8,
                0x8C9D: 0x62F3,
                0x8C9E: 0x6372,
                0x8C9F: 0x691C,
                0x8CA0: 0x6A29,
                0x8CA1: 0x727D,
                0x8CA2: 0x72AC,
                0x8CA3: 0x732E,
                0x8CA4: 0x7814,
                0x8CA5: 0x786F,
                0x8CA6: 0x7D79,
                0x8CA7: 0x770C,
                0x8CA8: 0x80A9,
                0x8CA9: 0x898B,
                0x8CAA: 0x8B19,
                0x8CAB: 0x8CE2,
                0x8CAC: 0x8ED2,
                0x8CAD: 0x9063,
                0x8CAE: 0x9375,
                0x8CAF: 0x967A,
                0x8CB0: 0x9855,
                0x8CB1: 0x9A13,
                0x8CB2: 0x9E78,
                0x8CB3: 0x5143,
                0x8CB4: 0x539F,
                0x8CB5: 0x53B3,
                0x8CB6: 0x5E7B,
                0x8CB7: 0x5F26,
                0x8CB8: 0x6E1B,
                0x8CB9: 0x6E90,
                0x8CBA: 0x7384,
                0x8CBB: 0x73FE,
                0x8CBC: 0x7D43,
                0x8CBD: 0x8237,
                0x8CBE: 0x8A00,
                0x8CBF: 0x8AFA,
                0x8CC0: 0x9650,
                0x8CC1: 0x4E4E,
                0x8CC2: 0x500B,
                0x8CC3: 0x53E4,
                0x8CC4: 0x547C,
                0x8CC5: 0x56FA,
                0x8CC6: 0x59D1,
                0x8CC7: 0x5B64,
                0x8CC8: 0x5DF1,
                0x8CC9: 0x5EAB,
                0x8CCA: 0x5F27,
                0x8CCB: 0x6238,
                0x8CCC: 0x6545,
                0x8CCD: 0x67AF,
                0x8CCE: 0x6E56,
                0x8CCF: 0x72D0,
                0x8CD0: 0x7CCA,
                0x8CD1: 0x88B4,
                0x8CD2: 0x80A1,
                0x8CD3: 0x80E1,
                0x8CD4: 0x83F0,
                0x8CD5: 0x864E,
                0x8CD6: 0x8A87,
                0x8CD7: 0x8DE8,
                0x8CD8: 0x9237,
                0x8CD9: 0x96C7,
                0x8CDA: 0x9867,
                0x8CDB: 0x9F13,
                0x8CDC: 0x4E94,
                0x8CDD: 0x4E92,
                0x8CDE: 0x4F0D,
                0x8CDF: 0x5348,
                0x8CE0: 0x5449,
                0x8CE1: 0x543E,
                0x8CE2: 0x5A2F,
                0x8CE3: 0x5F8C,
                0x8CE4: 0x5FA1,
                0x8CE5: 0x609F,
                0x8CE6: 0x68A7,
                0x8CE7: 0x6A8E,
                0x8CE8: 0x745A,
                0x8CE9: 0x7881,
                0x8CEA: 0x8A9E,
                0x8CEB: 0x8AA4,
                0x8CEC: 0x8B77,
                0x8CED: 0x9190,
                0x8CEE: 0x4E5E,
                0x8CEF: 0x9BC9,
                0x8CF0: 0x4EA4,
                0x8CF1: 0x4F7C,
                0x8CF2: 0x4FAF,
                0x8CF3: 0x5019,
                0x8CF4: 0x5016,
                0x8CF5: 0x5149,
                0x8CF6: 0x516C,
                0x8CF7: 0x529F,
                0x8CF8: 0x52B9,
                0x8CF9: 0x52FE,
                0x8CFA: 0x539A,
                0x8CFB: 0x53E3,
                0x8CFC: 0x5411,
                0x8D40: 0x540E,
                0x8D41: 0x5589,
                0x8D42: 0x5751,
                0x8D43: 0x57A2,
                0x8D44: 0x597D,
                0x8D45: 0x5B54,
                0x8D46: 0x5B5D,
                0x8D47: 0x5B8F,
                0x8D48: 0x5DE5,
                0x8D49: 0x5DE7,
                0x8D4A: 0x5DF7,
                0x8D4B: 0x5E78,
                0x8D4C: 0x5E83,
                0x8D4D: 0x5E9A,
                0x8D4E: 0x5EB7,
                0x8D4F: 0x5F18,
                0x8D50: 0x6052,
                0x8D51: 0x614C,
                0x8D52: 0x6297,
                0x8D53: 0x62D8,
                0x8D54: 0x63A7,
                0x8D55: 0x653B,
                0x8D56: 0x6602,
                0x8D57: 0x6643,
                0x8D58: 0x66F4,
                0x8D59: 0x676D,
                0x8D5A: 0x6821,
                0x8D5B: 0x6897,
                0x8D5C: 0x69CB,
                0x8D5D: 0x6C5F,
                0x8D5E: 0x6D2A,
                0x8D5F: 0x6D69,
                0x8D60: 0x6E2F,
                0x8D61: 0x6E9D,
                0x8D62: 0x7532,
                0x8D63: 0x7687,
                0x8D64: 0x786C,
                0x8D65: 0x7A3F,
                0x8D66: 0x7CE0,
                0x8D67: 0x7D05,
                0x8D68: 0x7D18,
                0x8D69: 0x7D5E,
                0x8D6A: 0x7DB1,
                0x8D6B: 0x8015,
                0x8D6C: 0x8003,
                0x8D6D: 0x80AF,
                0x8D6E: 0x80B1,
                0x8D6F: 0x8154,
                0x8D70: 0x818F,
                0x8D71: 0x822A,
                0x8D72: 0x8352,
                0x8D73: 0x884C,
                0x8D74: 0x8861,
                0x8D75: 0x8B1B,
                0x8D76: 0x8CA2,
                0x8D77: 0x8CFC,
                0x8D78: 0x90CA,
                0x8D79: 0x9175,
                0x8D7A: 0x9271,
                0x8D7B: 0x783F,
                0x8D7C: 0x92FC,
                0x8D7D: 0x95A4,
                0x8D7E: 0x964D,
                0x8D80: 0x9805,
                0x8D81: 0x9999,
                0x8D82: 0x9AD8,
                0x8D83: 0x9D3B,
                0x8D84: 0x525B,
                0x8D85: 0x52AB,
                0x8D86: 0x53F7,
                0x8D87: 0x5408,
                0x8D88: 0x58D5,
                0x8D89: 0x62F7,
                0x8D8A: 0x6FE0,
                0x8D8B: 0x8C6A,
                0x8D8C: 0x8F5F,
                0x8D8D: 0x9EB9,
                0x8D8E: 0x514B,
                0x8D8F: 0x523B,
                0x8D90: 0x544A,
                0x8D91: 0x56FD,
                0x8D92: 0x7A40,
                0x8D93: 0x9177,
                0x8D94: 0x9D60,
                0x8D95: 0x9ED2,
                0x8D96: 0x7344,
                0x8D97: 0x6F09,
                0x8D98: 0x8170,
                0x8D99: 0x7511,
                0x8D9A: 0x5FFD,
                0x8D9B: 0x60DA,
                0x8D9C: 0x9AA8,
                0x8D9D: 0x72DB,
                0x8D9E: 0x8FBC,
                0x8D9F: 0x6B64,
                0x8DA0: 0x9803,
                0x8DA1: 0x4ECA,
                0x8DA2: 0x56F0,
                0x8DA3: 0x5764,
                0x8DA4: 0x58BE,
                0x8DA5: 0x5A5A,
                0x8DA6: 0x6068,
                0x8DA7: 0x61C7,
                0x8DA8: 0x660F,
                0x8DA9: 0x6606,
                0x8DAA: 0x6839,
                0x8DAB: 0x68B1,
                0x8DAC: 0x6DF7,
                0x8DAD: 0x75D5,
                0x8DAE: 0x7D3A,
                0x8DAF: 0x826E,
                0x8DB0: 0x9B42,
                0x8DB1: 0x4E9B,
                0x8DB2: 0x4F50,
                0x8DB3: 0x53C9,
                0x8DB4: 0x5506,
                0x8DB5: 0x5D6F,
                0x8DB6: 0x5DE6,
                0x8DB7: 0x5DEE,
                0x8DB8: 0x67FB,
                0x8DB9: 0x6C99,
                0x8DBA: 0x7473,
                0x8DBB: 0x7802,
                0x8DBC: 0x8A50,
                0x8DBD: 0x9396,
                0x8DBE: 0x88DF,
                0x8DBF: 0x5750,
                0x8DC0: 0x5EA7,
                0x8DC1: 0x632B,
                0x8DC2: 0x50B5,
                0x8DC3: 0x50AC,
                0x8DC4: 0x518D,
                0x8DC5: 0x6700,
                0x8DC6: 0x54C9,
                0x8DC7: 0x585E,
                0x8DC8: 0x59BB,
                0x8DC9: 0x5BB0,
                0x8DCA: 0x5F69,
                0x8DCB: 0x624D,
                0x8DCC: 0x63A1,
                0x8DCD: 0x683D,
                0x8DCE: 0x6B73,
                0x8DCF: 0x6E08,
                0x8DD0: 0x707D,
                0x8DD1: 0x91C7,
                0x8DD2: 0x7280,
                0x8DD3: 0x7815,
                0x8DD4: 0x7826,
                0x8DD5: 0x796D,
                0x8DD6: 0x658E,
                0x8DD7: 0x7D30,
                0x8DD8: 0x83DC,
                0x8DD9: 0x88C1,
                0x8DDA: 0x8F09,
                0x8DDB: 0x969B,
                0x8DDC: 0x5264,
                0x8DDD: 0x5728,
                0x8DDE: 0x6750,
                0x8DDF: 0x7F6A,
                0x8DE0: 0x8CA1,
                0x8DE1: 0x51B4,
                0x8DE2: 0x5742,
                0x8DE3: 0x962A,
                0x8DE4: 0x583A,
                0x8DE5: 0x698A,
                0x8DE6: 0x80B4,
                0x8DE7: 0x54B2,
                0x8DE8: 0x5D0E,
                0x8DE9: 0x57FC,
                0x8DEA: 0x7895,
                0x8DEB: 0x9DFA,
                0x8DEC: 0x4F5C,
                0x8DED: 0x524A,
                0x8DEE: 0x548B,
                0x8DEF: 0x643E,
                0x8DF0: 0x6628,
                0x8DF1: 0x6714,
                0x8DF2: 0x67F5,
                0x8DF3: 0x7A84,
                0x8DF4: 0x7B56,
                0x8DF5: 0x7D22,
                0x8DF6: 0x932F,
                0x8DF7: 0x685C,
                0x8DF8: 0x9BAD,
                0x8DF9: 0x7B39,
                0x8DFA: 0x5319,
                0x8DFB: 0x518A,
                0x8DFC: 0x5237,
                0x8E40: 0x5BDF,
                0x8E41: 0x62F6,
                0x8E42: 0x64AE,
                0x8E43: 0x64E6,
                0x8E44: 0x672D,
                0x8E45: 0x6BBA,
                0x8E46: 0x85A9,
                0x8E47: 0x96D1,
                0x8E48: 0x7690,
                0x8E49: 0x9BD6,
                0x8E4A: 0x634C,
                0x8E4B: 0x9306,
                0x8E4C: 0x9BAB,
                0x8E4D: 0x76BF,
                0x8E4E: 0x6652,
                0x8E4F: 0x4E09,
                0x8E50: 0x5098,
                0x8E51: 0x53C2,
                0x8E52: 0x5C71,
                0x8E53: 0x60E8,
                0x8E54: 0x6492,
                0x8E55: 0x6563,
                0x8E56: 0x685F,
                0x8E57: 0x71E6,
                0x8E58: 0x73CA,
                0x8E59: 0x7523,
                0x8E5A: 0x7B97,
                0x8E5B: 0x7E82,
                0x8E5C: 0x8695,
                0x8E5D: 0x8B83,
                0x8E5E: 0x8CDB,
                0x8E5F: 0x9178,
                0x8E60: 0x9910,
                0x8E61: 0x65AC,
                0x8E62: 0x66AB,
                0x8E63: 0x6B8B,
                0x8E64: 0x4ED5,
                0x8E65: 0x4ED4,
                0x8E66: 0x4F3A,
                0x8E67: 0x4F7F,
                0x8E68: 0x523A,
                0x8E69: 0x53F8,
                0x8E6A: 0x53F2,
                0x8E6B: 0x55E3,
                0x8E6C: 0x56DB,
                0x8E6D: 0x58EB,
                0x8E6E: 0x59CB,
                0x8E6F: 0x59C9,
                0x8E70: 0x59FF,
                0x8E71: 0x5B50,
                0x8E72: 0x5C4D,
                0x8E73: 0x5E02,
                0x8E74: 0x5E2B,
                0x8E75: 0x5FD7,
                0x8E76: 0x601D,
                0x8E77: 0x6307,
                0x8E78: 0x652F,
                0x8E79: 0x5B5C,
                0x8E7A: 0x65AF,
                0x8E7B: 0x65BD,
                0x8E7C: 0x65E8,
                0x8E7D: 0x679D,
                0x8E7E: 0x6B62,
                0x8E80: 0x6B7B,
                0x8E81: 0x6C0F,
                0x8E82: 0x7345,
                0x8E83: 0x7949,
                0x8E84: 0x79C1,
                0x8E85: 0x7CF8,
                0x8E86: 0x7D19,
                0x8E87: 0x7D2B,
                0x8E88: 0x80A2,
                0x8E89: 0x8102,
                0x8E8A: 0x81F3,
                0x8E8B: 0x8996,
                0x8E8C: 0x8A5E,
                0x8E8D: 0x8A69,
                0x8E8E: 0x8A66,
                0x8E8F: 0x8A8C,
                0x8E90: 0x8AEE,
                0x8E91: 0x8CC7,
                0x8E92: 0x8CDC,
                0x8E93: 0x96CC,
                0x8E94: 0x98FC,
                0x8E95: 0x6B6F,
                0x8E96: 0x4E8B,
                0x8E97: 0x4F3C,
                0x8E98: 0x4F8D,
                0x8E99: 0x5150,
                0x8E9A: 0x5B57,
                0x8E9B: 0x5BFA,
                0x8E9C: 0x6148,
                0x8E9D: 0x6301,
                0x8E9E: 0x6642,
                0x8E9F: 0x6B21,
                0x8EA0: 0x6ECB,
                0x8EA1: 0x6CBB,
                0x8EA2: 0x723E,
                0x8EA3: 0x74BD,
                0x8EA4: 0x75D4,
                0x8EA5: 0x78C1,
                0x8EA6: 0x793A,
                0x8EA7: 0x800C,
                0x8EA8: 0x8033,
                0x8EA9: 0x81EA,
                0x8EAA: 0x8494,
                0x8EAB: 0x8F9E,
                0x8EAC: 0x6C50,
                0x8EAD: 0x9E7F,
                0x8EAE: 0x5F0F,
                0x8EAF: 0x8B58,
                0x8EB0: 0x9D2B,
                0x8EB1: 0x7AFA,
                0x8EB2: 0x8EF8,
                0x8EB3: 0x5B8D,
                0x8EB4: 0x96EB,
                0x8EB5: 0x4E03,
                0x8EB6: 0x53F1,
                0x8EB7: 0x57F7,
                0x8EB8: 0x5931,
                0x8EB9: 0x5AC9,
                0x8EBA: 0x5BA4,
                0x8EBB: 0x6089,
                0x8EBC: 0x6E7F,
                0x8EBD: 0x6F06,
                0x8EBE: 0x75BE,
                0x8EBF: 0x8CEA,
                0x8EC0: 0x5B9F,
                0x8EC1: 0x8500,
                0x8EC2: 0x7BE0,
                0x8EC3: 0x5072,
                0x8EC4: 0x67F4,
                0x8EC5: 0x829D,
                0x8EC6: 0x5C61,
                0x8EC7: 0x854A,
                0x8EC8: 0x7E1E,
                0x8EC9: 0x820E,
                0x8ECA: 0x5199,
                0x8ECB: 0x5C04,
                0x8ECC: 0x6368,
                0x8ECD: 0x8D66,
                0x8ECE: 0x659C,
                0x8ECF: 0x716E,
                0x8ED0: 0x793E,
                0x8ED1: 0x7D17,
                0x8ED2: 0x8005,
                0x8ED3: 0x8B1D,
                0x8ED4: 0x8ECA,
                0x8ED5: 0x906E,
                0x8ED6: 0x86C7,
                0x8ED7: 0x90AA,
                0x8ED8: 0x501F,
                0x8ED9: 0x52FA,
                0x8EDA: 0x5C3A,
                0x8EDB: 0x6753,
                0x8EDC: 0x707C,
                0x8EDD: 0x7235,
                0x8EDE: 0x914C,
                0x8EDF: 0x91C8,
                0x8EE0: 0x932B,
                0x8EE1: 0x82E5,
                0x8EE2: 0x5BC2,
                0x8EE3: 0x5F31,
                0x8EE4: 0x60F9,
                0x8EE5: 0x4E3B,
                0x8EE6: 0x53D6,
                0x8EE7: 0x5B88,
                0x8EE8: 0x624B,
                0x8EE9: 0x6731,
                0x8EEA: 0x6B8A,
                0x8EEB: 0x72E9,
                0x8EEC: 0x73E0,
                0x8EED: 0x7A2E,
                0x8EEE: 0x816B,
                0x8EEF: 0x8DA3,
                0x8EF0: 0x9152,
                0x8EF1: 0x9996,
                0x8EF2: 0x5112,
                0x8EF3: 0x53D7,
                0x8EF4: 0x546A,
                0x8EF5: 0x5BFF,
                0x8EF6: 0x6388,
                0x8EF7: 0x6A39,
                0x8EF8: 0x7DAC,
                0x8EF9: 0x9700,
                0x8EFA: 0x56DA,
                0x8EFB: 0x53CE,
                0x8EFC: 0x5468,
                0x8F40: 0x5B97,
                0x8F41: 0x5C31,
                0x8F42: 0x5DDE,
                0x8F43: 0x4FEE,
                0x8F44: 0x6101,
                0x8F45: 0x62FE,
                0x8F46: 0x6D32,
                0x8F47: 0x79C0,
                0x8F48: 0x79CB,
                0x8F49: 0x7D42,
                0x8F4A: 0x7E4D,
                0x8F4B: 0x7FD2,
                0x8F4C: 0x81ED,
                0x8F4D: 0x821F,
                0x8F4E: 0x8490,
                0x8F4F: 0x8846,
                0x8F50: 0x8972,
                0x8F51: 0x8B90,
                0x8F52: 0x8E74,
                0x8F53: 0x8F2F,
                0x8F54: 0x9031,
                0x8F55: 0x914B,
                0x8F56: 0x916C,
                0x8F57: 0x96C6,
                0x8F58: 0x919C,
                0x8F59: 0x4EC0,
                0x8F5A: 0x4F4F,
                0x8F5B: 0x5145,
                0x8F5C: 0x5341,
                0x8F5D: 0x5F93,
                0x8F5E: 0x620E,
                0x8F5F: 0x67D4,
                0x8F60: 0x6C41,
                0x8F61: 0x6E0B,
                0x8F62: 0x7363,
                0x8F63: 0x7E26,
                0x8F64: 0x91CD,
                0x8F65: 0x9283,
                0x8F66: 0x53D4,
                0x8F67: 0x5919,
                0x8F68: 0x5BBF,
                0x8F69: 0x6DD1,
                0x8F6A: 0x795D,
                0x8F6B: 0x7E2E,
                0x8F6C: 0x7C9B,
                0x8F6D: 0x587E,
                0x8F6E: 0x719F,
                0x8F6F: 0x51FA,
                0x8F70: 0x8853,
                0x8F71: 0x8FF0,
                0x8F72: 0x4FCA,
                0x8F73: 0x5CFB,
                0x8F74: 0x6625,
                0x8F75: 0x77AC,
                0x8F76: 0x7AE3,
                0x8F77: 0x821C,
                0x8F78: 0x99FF,
                0x8F79: 0x51C6,
                0x8F7A: 0x5FAA,
                0x8F7B: 0x65EC,
                0x8F7C: 0x696F,
                0x8F7D: 0x6B89,
                0x8F7E: 0x6DF3,
                0x8F80: 0x6E96,
                0x8F81: 0x6F64,
                0x8F82: 0x76FE,
                0x8F83: 0x7D14,
                0x8F84: 0x5DE1,
                0x8F85: 0x9075,
                0x8F86: 0x9187,
                0x8F87: 0x9806,
                0x8F88: 0x51E6,
                0x8F89: 0x521D,
                0x8F8A: 0x6240,
                0x8F8B: 0x6691,
                0x8F8C: 0x66D9,
                0x8F8D: 0x6E1A,
                0x8F8E: 0x5EB6,
                0x8F8F: 0x7DD2,
                0x8F90: 0x7F72,
                0x8F91: 0x66F8,
                0x8F92: 0x85AF,
                0x8F93: 0x85F7,
                0x8F94: 0x8AF8,
                0x8F95: 0x52A9,
                0x8F96: 0x53D9,
                0x8F97: 0x5973,
                0x8F98: 0x5E8F,
                0x8F99: 0x5F90,
                0x8F9A: 0x6055,
                0x8F9B: 0x92E4,
                0x8F9C: 0x9664,
                0x8F9D: 0x50B7,
                0x8F9E: 0x511F,
                0x8F9F: 0x52DD,
                0x8FA0: 0x5320,
                0x8FA1: 0x5347,
                0x8FA2: 0x53EC,
                0x8FA3: 0x54E8,
                0x8FA4: 0x5546,
                0x8FA5: 0x5531,
                0x8FA6: 0x5617,
                0x8FA7: 0x5968,
                0x8FA8: 0x59BE,
                0x8FA9: 0x5A3C,
                0x8FAA: 0x5BB5,
                0x8FAB: 0x5C06,
                0x8FAC: 0x5C0F,
                0x8FAD: 0x5C11,
                0x8FAE: 0x5C1A,
                0x8FAF: 0x5E84,
                0x8FB0: 0x5E8A,
                0x8FB1: 0x5EE0,
                0x8FB2: 0x5F70,
                0x8FB3: 0x627F,
                0x8FB4: 0x6284,
                0x8FB5: 0x62DB,
                0x8FB6: 0x638C,
                0x8FB7: 0x6377,
                0x8FB8: 0x6607,
                0x8FB9: 0x660C,
                0x8FBA: 0x662D,
                0x8FBB: 0x6676,
                0x8FBC: 0x677E,
                0x8FBD: 0x68A2,
                0x8FBE: 0x6A1F,
                0x8FBF: 0x6A35,
                0x8FC0: 0x6CBC,
                0x8FC1: 0x6D88,
                0x8FC2: 0x6E09,
                0x8FC3: 0x6E58,
                0x8FC4: 0x713C,
                0x8FC5: 0x7126,
                0x8FC6: 0x7167,
                0x8FC7: 0x75C7,
                0x8FC8: 0x7701,
                0x8FC9: 0x785D,
                0x8FCA: 0x7901,
                0x8FCB: 0x7965,
                0x8FCC: 0x79F0,
                0x8FCD: 0x7AE0,
                0x8FCE: 0x7B11,
                0x8FCF: 0x7CA7,
                0x8FD0: 0x7D39,
                0x8FD1: 0x8096,
                0x8FD2: 0x83D6,
                0x8FD3: 0x848B,
                0x8FD4: 0x8549,
                0x8FD5: 0x885D,
                0x8FD6: 0x88F3,
                0x8FD7: 0x8A1F,
                0x8FD8: 0x8A3C,
                0x8FD9: 0x8A54,
                0x8FDA: 0x8A73,
                0x8FDB: 0x8C61,
                0x8FDC: 0x8CDE,
                0x8FDD: 0x91A4,
                0x8FDE: 0x9266,
                0x8FDF: 0x937E,
                0x8FE0: 0x9418,
                0x8FE1: 0x969C,
                0x8FE2: 0x9798,
                0x8FE3: 0x4E0A,
                0x8FE4: 0x4E08,
                0x8FE5: 0x4E1E,
                0x8FE6: 0x4E57,
                0x8FE7: 0x5197,
                0x8FE8: 0x5270,
                0x8FE9: 0x57CE,
                0x8FEA: 0x5834,
                0x8FEB: 0x58CC,
                0x8FEC: 0x5B22,
                0x8FED: 0x5E38,
                0x8FEE: 0x60C5,
                0x8FEF: 0x64FE,
                0x8FF0: 0x6761,
                0x8FF1: 0x6756,
                0x8FF2: 0x6D44,
                0x8FF3: 0x72B6,
                0x8FF4: 0x7573,
                0x8FF5: 0x7A63,
                0x8FF6: 0x84B8,
                0x8FF7: 0x8B72,
                0x8FF8: 0x91B8,
                0x8FF9: 0x9320,
                0x8FFA: 0x5631,
                0x8FFB: 0x57F4,
                0x8FFC: 0x98FE,
                0x9040: 0x62ED,
                0x9041: 0x690D,
                0x9042: 0x6B96,
                0x9043: 0x71ED,
                0x9044: 0x7E54,
                0x9045: 0x8077,
                0x9046: 0x8272,
                0x9047: 0x89E6,
                0x9048: 0x98DF,
                0x9049: 0x8755,
                0x904A: 0x8FB1,
                0x904B: 0x5C3B,
                0x904C: 0x4F38,
                0x904D: 0x4FE1,
                0x904E: 0x4FB5,
                0x904F: 0x5507,
                0x9050: 0x5A20,
                0x9051: 0x5BDD,
                0x9052: 0x5BE9,
                0x9053: 0x5FC3,
                0x9054: 0x614E,
                0x9055: 0x632F,
                0x9056: 0x65B0,
                0x9057: 0x664B,
                0x9058: 0x68EE,
                0x9059: 0x699B,
                0x905A: 0x6D78,
                0x905B: 0x6DF1,
                0x905C: 0x7533,
                0x905D: 0x75B9,
                0x905E: 0x771F,
                0x905F: 0x795E,
                0x9060: 0x79E6,
                0x9061: 0x7D33,
                0x9062: 0x81E3,
                0x9063: 0x82AF,
                0x9064: 0x85AA,
                0x9065: 0x89AA,
                0x9066: 0x8A3A,
                0x9067: 0x8EAB,
                0x9068: 0x8F9B,
                0x9069: 0x9032,
                0x906A: 0x91DD,
                0x906B: 0x9707,
                0x906C: 0x4EBA,
                0x906D: 0x4EC1,
                0x906E: 0x5203,
                0x906F: 0x5875,
                0x9070: 0x58EC,
                0x9071: 0x5C0B,
                0x9072: 0x751A,
                0x9073: 0x5C3D,
                0x9074: 0x814E,
                0x9075: 0x8A0A,
                0x9076: 0x8FC5,
                0x9077: 0x9663,
                0x9078: 0x976D,
                0x9079: 0x7B25,
                0x907A: 0x8ACF,
                0x907B: 0x9808,
                0x907C: 0x9162,
                0x907D: 0x56F3,
                0x907E: 0x53A8,
                0x9080: 0x9017,
                0x9081: 0x5439,
                0x9082: 0x5782,
                0x9083: 0x5E25,
                0x9084: 0x63A8,
                0x9085: 0x6C34,
                0x9086: 0x708A,
                0x9087: 0x7761,
                0x9088: 0x7C8B,
                0x9089: 0x7FE0,
                0x908A: 0x8870,
                0x908B: 0x9042,
                0x908C: 0x9154,
                0x908D: 0x9310,
                0x908E: 0x9318,
                0x908F: 0x968F,
                0x9090: 0x745E,
                0x9091: 0x9AC4,
                0x9092: 0x5D07,
                0x9093: 0x5D69,
                0x9094: 0x6570,
                0x9095: 0x67A2,
                0x9096: 0x8DA8,
                0x9097: 0x96DB,
                0x9098: 0x636E,
                0x9099: 0x6749,
                0x909A: 0x6919,
                0x909B: 0x83C5,
                0x909C: 0x9817,
                0x909D: 0x96C0,
                0x909E: 0x88FE,
                0x909F: 0x6F84,
                0x90A0: 0x647A,
                0x90A1: 0x5BF8,
                0x90A2: 0x4E16,
                0x90A3: 0x702C,
                0x90A4: 0x755D,
                0x90A5: 0x662F,
                0x90A6: 0x51C4,
                0x90A7: 0x5236,
                0x90A8: 0x52E2,
                0x90A9: 0x59D3,
                0x90AA: 0x5F81,
                0x90AB: 0x6027,
                0x90AC: 0x6210,
                0x90AD: 0x653F,
                0x90AE: 0x6574,
                0x90AF: 0x661F,
                0x90B0: 0x6674,
                0x90B1: 0x68F2,
                0x90B2: 0x6816,
                0x90B3: 0x6B63,
                0x90B4: 0x6E05,
                0x90B5: 0x7272,
                0x90B6: 0x751F,
                0x90B7: 0x76DB,
                0x90B8: 0x7CBE,
                0x90B9: 0x8056,
                0x90BA: 0x58F0,
                0x90BB: 0x88FD,
                0x90BC: 0x897F,
                0x90BD: 0x8AA0,
                0x90BE: 0x8A93,
                0x90BF: 0x8ACB,
                0x90C0: 0x901D,
                0x90C1: 0x9192,
                0x90C2: 0x9752,
                0x90C3: 0x9759,
                0x90C4: 0x6589,
                0x90C5: 0x7A0E,
                0x90C6: 0x8106,
                0x90C7: 0x96BB,
                0x90C8: 0x5E2D,
                0x90C9: 0x60DC,
                0x90CA: 0x621A,
                0x90CB: 0x65A5,
                0x90CC: 0x6614,
                0x90CD: 0x6790,
                0x90CE: 0x77F3,
                0x90CF: 0x7A4D,
                0x90D0: 0x7C4D,
                0x90D1: 0x7E3E,
                0x90D2: 0x810A,
                0x90D3: 0x8CAC,
                0x90D4: 0x8D64,
                0x90D5: 0x8DE1,
                0x90D6: 0x8E5F,
                0x90D7: 0x78A9,
                0x90D8: 0x5207,
                0x90D9: 0x62D9,
                0x90DA: 0x63A5,
                0x90DB: 0x6442,
                0x90DC: 0x6298,
                0x90DD: 0x8A2D,
                0x90DE: 0x7A83,
                0x90DF: 0x7BC0,
                0x90E0: 0x8AAC,
                0x90E1: 0x96EA,
                0x90E2: 0x7D76,
                0x90E3: 0x820C,
                0x90E4: 0x8749,
                0x90E5: 0x4ED9,
                0x90E6: 0x5148,
                0x90E7: 0x5343,
                0x90E8: 0x5360,
                0x90E9: 0x5BA3,
                0x90EA: 0x5C02,
                0x90EB: 0x5C16,
                0x90EC: 0x5DDD,
                0x90ED: 0x6226,
                0x90EE: 0x6247,
                0x90EF: 0x64B0,
                0x90F0: 0x6813,
                0x90F1: 0x6834,
                0x90F2: 0x6CC9,
                0x90F3: 0x6D45,
                0x90F4: 0x6D17,
                0x90F5: 0x67D3,
                0x90F6: 0x6F5C,
                0x90F7: 0x714E,
                0x90F8: 0x717D,
                0x90F9: 0x65CB,
                0x90FA: 0x7A7F,
                0x90FB: 0x7BAD,
                0x90FC: 0x7DDA,
                0x9140: 0x7E4A,
                0x9141: 0x7FA8,
                0x9142: 0x817A,
                0x9143: 0x821B,
                0x9144: 0x8239,
                0x9145: 0x85A6,
                0x9146: 0x8A6E,
                0x9147: 0x8CCE,
                0x9148: 0x8DF5,
                0x9149: 0x9078,
                0x914A: 0x9077,
                0x914B: 0x92AD,
                0x914C: 0x9291,
                0x914D: 0x9583,
                0x914E: 0x9BAE,
                0x914F: 0x524D,
                0x9150: 0x5584,
                0x9151: 0x6F38,
                0x9152: 0x7136,
                0x9153: 0x5168,
                0x9154: 0x7985,
                0x9155: 0x7E55,
                0x9156: 0x81B3,
                0x9157: 0x7CCE,
                0x9158: 0x564C,
                0x9159: 0x5851,
                0x915A: 0x5CA8,
                0x915B: 0x63AA,
                0x915C: 0x66FE,
                0x915D: 0x66FD,
                0x915E: 0x695A,
                0x915F: 0x72D9,
                0x9160: 0x758F,
                0x9161: 0x758E,
                0x9162: 0x790E,
                0x9163: 0x7956,
                0x9164: 0x79DF,
                0x9165: 0x7C97,
                0x9166: 0x7D20,
                0x9167: 0x7D44,
                0x9168: 0x8607,
                0x9169: 0x8A34,
                0x916A: 0x963B,
                0x916B: 0x9061,
                0x916C: 0x9F20,
                0x916D: 0x50E7,
                0x916E: 0x5275,
                0x916F: 0x53CC,
                0x9170: 0x53E2,
                0x9171: 0x5009,
                0x9172: 0x55AA,
                0x9173: 0x58EE,
                0x9174: 0x594F,
                0x9175: 0x723D,
                0x9176: 0x5B8B,
                0x9177: 0x5C64,
                0x9178: 0x531D,
                0x9179: 0x60E3,
                0x917A: 0x60F3,
                0x917B: 0x635C,
                0x917C: 0x6383,
                0x917D: 0x633F,
                0x917E: 0x63BB,
                0x9180: 0x64CD,
                0x9181: 0x65E9,
                0x9182: 0x66F9,
                0x9183: 0x5DE3,
                0x9184: 0x69CD,
                0x9185: 0x69FD,
                0x9186: 0x6F15,
                0x9187: 0x71E5,
                0x9188: 0x4E89,
                0x9189: 0x75E9,
                0x918A: 0x76F8,
                0x918B: 0x7A93,
                0x918C: 0x7CDF,
                0x918D: 0x7DCF,
                0x918E: 0x7D9C,
                0x918F: 0x8061,
                0x9190: 0x8349,
                0x9191: 0x8358,
                0x9192: 0x846C,
                0x9193: 0x84BC,
                0x9194: 0x85FB,
                0x9195: 0x88C5,
                0x9196: 0x8D70,
                0x9197: 0x9001,
                0x9198: 0x906D,
                0x9199: 0x9397,
                0x919A: 0x971C,
                0x919B: 0x9A12,
                0x919C: 0x50CF,
                0x919D: 0x5897,
                0x919E: 0x618E,
                0x919F: 0x81D3,
                0x91A0: 0x8535,
                0x91A1: 0x8D08,
                0x91A2: 0x9020,
                0x91A3: 0x4FC3,
                0x91A4: 0x5074,
                0x91A5: 0x5247,
                0x91A6: 0x5373,
                0x91A7: 0x606F,
                0x91A8: 0x6349,
                0x91A9: 0x675F,
                0x91AA: 0x6E2C,
                0x91AB: 0x8DB3,
                0x91AC: 0x901F,
                0x91AD: 0x4FD7,
                0x91AE: 0x5C5E,
                0x91AF: 0x8CCA,
                0x91B0: 0x65CF,
                0x91B1: 0x7D9A,
                0x91B2: 0x5352,
                0x91B3: 0x8896,
                0x91B4: 0x5176,
                0x91B5: 0x63C3,
                0x91B6: 0x5B58,
                0x91B7: 0x5B6B,
                0x91B8: 0x5C0A,
                0x91B9: 0x640D,
                0x91BA: 0x6751,
                0x91BB: 0x905C,
                0x91BC: 0x4ED6,
                0x91BD: 0x591A,
                0x91BE: 0x592A,
                0x91BF: 0x6C70,
                0x91C0: 0x8A51,
                0x91C1: 0x553E,
                0x91C2: 0x5815,
                0x91C3: 0x59A5,
                0x91C4: 0x60F0,
                0x91C5: 0x6253,
                0x91C6: 0x67C1,
                0x91C7: 0x8235,
                0x91C8: 0x6955,
                0x91C9: 0x9640,
                0x91CA: 0x99C4,
                0x91CB: 0x9A28,
                0x91CC: 0x4F53,
                0x91CD: 0x5806,
                0x91CE: 0x5BFE,
                0x91CF: 0x8010,
                0x91D0: 0x5CB1,
                0x91D1: 0x5E2F,
                0x91D2: 0x5F85,
                0x91D3: 0x6020,
                0x91D4: 0x614B,
                0x91D5: 0x6234,
                0x91D6: 0x66FF,
                0x91D7: 0x6CF0,
                0x91D8: 0x6EDE,
                0x91D9: 0x80CE,
                0x91DA: 0x817F,
                0x91DB: 0x82D4,
                0x91DC: 0x888B,
                0x91DD: 0x8CB8,
                0x91DE: 0x9000,
                0x91DF: 0x902E,
                0x91E0: 0x968A,
                0x91E1: 0x9EDB,
                0x91E2: 0x9BDB,
                0x91E3: 0x4EE3,
                0x91E4: 0x53F0,
                0x91E5: 0x5927,
                0x91E6: 0x7B2C,
                0x91E7: 0x918D,
                0x91E8: 0x984C,
                0x91E9: 0x9DF9,
                0x91EA: 0x6EDD,
                0x91EB: 0x7027,
                0x91EC: 0x5353,
                0x91ED: 0x5544,
                0x91EE: 0x5B85,
                0x91EF: 0x6258,
                0x91F0: 0x629E,
                0x91F1: 0x62D3,
                0x91F2: 0x6CA2,
                0x91F3: 0x6FEF,
                0x91F4: 0x7422,
                0x91F5: 0x8A17,
                0x91F6: 0x9438,
                0x91F7: 0x6FC1,
                0x91F8: 0x8AFE,
                0x91F9: 0x8338,
                0x91FA: 0x51E7,
                0x91FB: 0x86F8,
                0x91FC: 0x53EA,
                0x9240: 0x53E9,
                0x9241: 0x4F46,
                0x9242: 0x9054,
                0x9243: 0x8FB0,
                0x9244: 0x596A,
                0x9245: 0x8131,
                0x9246: 0x5DFD,
                0x9247: 0x7AEA,
                0x9248: 0x8FBF,
                0x9249: 0x68DA,
                0x924A: 0x8C37,
                0x924B: 0x72F8,
                0x924C: 0x9C48,
                0x924D: 0x6A3D,
                0x924E: 0x8AB0,
                0x924F: 0x4E39,
                0x9250: 0x5358,
                0x9251: 0x5606,
                0x9252: 0x5766,
                0x9253: 0x62C5,
                0x9254: 0x63A2,
                0x9255: 0x65E6,
                0x9256: 0x6B4E,
                0x9257: 0x6DE1,
                0x9258: 0x6E5B,
                0x9259: 0x70AD,
                0x925A: 0x77ED,
                0x925B: 0x7AEF,
                0x925C: 0x7BAA,
                0x925D: 0x7DBB,
                0x925E: 0x803D,
                0x925F: 0x80C6,
                0x9260: 0x86CB,
                0x9261: 0x8A95,
                0x9262: 0x935B,
                0x9263: 0x56E3,
                0x9264: 0x58C7,
                0x9265: 0x5F3E,
                0x9266: 0x65AD,
                0x9267: 0x6696,
                0x9268: 0x6A80,
                0x9269: 0x6BB5,
                0x926A: 0x7537,
                0x926B: 0x8AC7,
                0x926C: 0x5024,
                0x926D: 0x77E5,
                0x926E: 0x5730,
                0x926F: 0x5F1B,
                0x9270: 0x6065,
                0x9271: 0x667A,
                0x9272: 0x6C60,
                0x9273: 0x75F4,
                0x9274: 0x7A1A,
                0x9275: 0x7F6E,
                0x9276: 0x81F4,
                0x9277: 0x8718,
                0x9278: 0x9045,
                0x9279: 0x99B3,
                0x927A: 0x7BC9,
                0x927B: 0x755C,
                0x927C: 0x7AF9,
                0x927D: 0x7B51,
                0x927E: 0x84C4,
                0x9280: 0x9010,
                0x9281: 0x79E9,
                0x9282: 0x7A92,
                0x9283: 0x8336,
                0x9284: 0x5AE1,
                0x9285: 0x7740,
                0x9286: 0x4E2D,
                0x9287: 0x4EF2,
                0x9288: 0x5B99,
                0x9289: 0x5FE0,
                0x928A: 0x62BD,
                0x928B: 0x663C,
                0x928C: 0x67F1,
                0x928D: 0x6CE8,
                0x928E: 0x866B,
                0x928F: 0x8877,
                0x9290: 0x8A3B,
                0x9291: 0x914E,
                0x9292: 0x92F3,
                0x9293: 0x99D0,
                0x9294: 0x6A17,
                0x9295: 0x7026,
                0x9296: 0x732A,
                0x9297: 0x82E7,
                0x9298: 0x8457,
                0x9299: 0x8CAF,
                0x929A: 0x4E01,
                0x929B: 0x5146,
                0x929C: 0x51CB,
                0x929D: 0x558B,
                0x929E: 0x5BF5,
                0x929F: 0x5E16,
                0x92A0: 0x5E33,
                0x92A1: 0x5E81,
                0x92A2: 0x5F14,
                0x92A3: 0x5F35,
                0x92A4: 0x5F6B,
                0x92A5: 0x5FB4,
                0x92A6: 0x61F2,
                0x92A7: 0x6311,
                0x92A8: 0x66A2,
                0x92A9: 0x671D,
                0x92AA: 0x6F6E,
                0x92AB: 0x7252,
                0x92AC: 0x753A,
                0x92AD: 0x773A,
                0x92AE: 0x8074,
                0x92AF: 0x8139,
                0x92B0: 0x8178,
                0x92B1: 0x8776,
                0x92B2: 0x8ABF,
                0x92B3: 0x8ADC,
                0x92B4: 0x8D85,
                0x92B5: 0x8DF3,
                0x92B6: 0x929A,
                0x92B7: 0x9577,
                0x92B8: 0x9802,
                0x92B9: 0x9CE5,
                0x92BA: 0x52C5,
                0x92BB: 0x6357,
                0x92BC: 0x76F4,
                0x92BD: 0x6715,
                0x92BE: 0x6C88,
                0x92BF: 0x73CD,
                0x92C0: 0x8CC3,
                0x92C1: 0x93AE,
                0x92C2: 0x9673,
                0x92C3: 0x6D25,
                0x92C4: 0x589C,
                0x92C5: 0x690E,
                0x92C6: 0x69CC,
                0x92C7: 0x8FFD,
                0x92C8: 0x939A,
                0x92C9: 0x75DB,
                0x92CA: 0x901A,
                0x92CB: 0x585A,
                0x92CC: 0x6802,
                0x92CD: 0x63B4,
                0x92CE: 0x69FB,
                0x92CF: 0x4F43,
                0x92D0: 0x6F2C,
                0x92D1: 0x67D8,
                0x92D2: 0x8FBB,
                0x92D3: 0x8526,
                0x92D4: 0x7DB4,
                0x92D5: 0x9354,
                0x92D6: 0x693F,
                0x92D7: 0x6F70,
                0x92D8: 0x576A,
                0x92D9: 0x58F7,
                0x92DA: 0x5B2C,
                0x92DB: 0x7D2C,
                0x92DC: 0x722A,
                0x92DD: 0x540A,
                0x92DE: 0x91E3,
                0x92DF: 0x9DB4,
                0x92E0: 0x4EAD,
                0x92E1: 0x4F4E,
                0x92E2: 0x505C,
                0x92E3: 0x5075,
                0x92E4: 0x5243,
                0x92E5: 0x8C9E,
                0x92E6: 0x5448,
                0x92E7: 0x5824,
                0x92E8: 0x5B9A,
                0x92E9: 0x5E1D,
                0x92EA: 0x5E95,
                0x92EB: 0x5EAD,
                0x92EC: 0x5EF7,
                0x92ED: 0x5F1F,
                0x92EE: 0x608C,
                0x92EF: 0x62B5,
                0x92F0: 0x633A,
                0x92F1: 0x63D0,
                0x92F2: 0x68AF,
                0x92F3: 0x6C40,
                0x92F4: 0x7887,
                0x92F5: 0x798E,
                0x92F6: 0x7A0B,
                0x92F7: 0x7DE0,
                0x92F8: 0x8247,
                0x92F9: 0x8A02,
                0x92FA: 0x8AE6,
                0x92FB: 0x8E44,
                0x92FC: 0x9013,
                0x9340: 0x90B8,
                0x9341: 0x912D,
                0x9342: 0x91D8,
                0x9343: 0x9F0E,
                0x9344: 0x6CE5,
                0x9345: 0x6458,
                0x9346: 0x64E2,
                0x9347: 0x6575,
                0x9348: 0x6EF4,
                0x9349: 0x7684,
                0x934A: 0x7B1B,
                0x934B: 0x9069,
                0x934C: 0x93D1,
                0x934D: 0x6EBA,
                0x934E: 0x54F2,
                0x934F: 0x5FB9,
                0x9350: 0x64A4,
                0x9351: 0x8F4D,
                0x9352: 0x8FED,
                0x9353: 0x9244,
                0x9354: 0x5178,
                0x9355: 0x586B,
                0x9356: 0x5929,
                0x9357: 0x5C55,
                0x9358: 0x5E97,
                0x9359: 0x6DFB,
                0x935A: 0x7E8F,
                0x935B: 0x751C,
                0x935C: 0x8CBC,
                0x935D: 0x8EE2,
                0x935E: 0x985B,
                0x935F: 0x70B9,
                0x9360: 0x4F1D,
                0x9361: 0x6BBF,
                0x9362: 0x6FB1,
                0x9363: 0x7530,
                0x9364: 0x96FB,
                0x9365: 0x514E,
                0x9366: 0x5410,
                0x9367: 0x5835,
                0x9368: 0x5857,
                0x9369: 0x59AC,
                0x936A: 0x5C60,
                0x936B: 0x5F92,
                0x936C: 0x6597,
                0x936D: 0x675C,
                0x936E: 0x6E21,
                0x936F: 0x767B,
                0x9370: 0x83DF,
                0x9371: 0x8CED,
                0x9372: 0x9014,
                0x9373: 0x90FD,
                0x9374: 0x934D,
                0x9375: 0x7825,
                0x9376: 0x783A,
                0x9377: 0x52AA,
                0x9378: 0x5EA6,
                0x9379: 0x571F,
                0x937A: 0x5974,
                0x937B: 0x6012,
                0x937C: 0x5012,
                0x937D: 0x515A,
                0x937E: 0x51AC,
                0x9380: 0x51CD,
                0x9381: 0x5200,
                0x9382: 0x5510,
                0x9383: 0x5854,
                0x9384: 0x5858,
                0x9385: 0x5957,
                0x9386: 0x5B95,
                0x9387: 0x5CF6,
                0x9388: 0x5D8B,
                0x9389: 0x60BC,
                0x938A: 0x6295,
                0x938B: 0x642D,
                0x938C: 0x6771,
                0x938D: 0x6843,
                0x938E: 0x68BC,
                0x938F: 0x68DF,
                0x9390: 0x76D7,
                0x9391: 0x6DD8,
                0x9392: 0x6E6F,
                0x9393: 0x6D9B,
                0x9394: 0x706F,
                0x9395: 0x71C8,
                0x9396: 0x5F53,
                0x9397: 0x75D8,
                0x9398: 0x7977,
                0x9399: 0x7B49,
                0x939A: 0x7B54,
                0x939B: 0x7B52,
                0x939C: 0x7CD6,
                0x939D: 0x7D71,
                0x939E: 0x5230,
                0x939F: 0x8463,
                0x93A0: 0x8569,
                0x93A1: 0x85E4,
                0x93A2: 0x8A0E,
                0x93A3: 0x8B04,
                0x93A4: 0x8C46,
                0x93A5: 0x8E0F,
                0x93A6: 0x9003,
                0x93A7: 0x900F,
                0x93A8: 0x9419,
                0x93A9: 0x9676,
                0x93AA: 0x982D,
                0x93AB: 0x9A30,
                0x93AC: 0x95D8,
                0x93AD: 0x50CD,
                0x93AE: 0x52D5,
                0x93AF: 0x540C,
                0x93B0: 0x5802,
                0x93B1: 0x5C0E,
                0x93B2: 0x61A7,
                0x93B3: 0x649E,
                0x93B4: 0x6D1E,
                0x93B5: 0x77B3,
                0x93B6: 0x7AE5,
                0x93B7: 0x80F4,
                0x93B8: 0x8404,
                0x93B9: 0x9053,
                0x93BA: 0x9285,
                0x93BB: 0x5CE0,
                0x93BC: 0x9D07,
                0x93BD: 0x533F,
                0x93BE: 0x5F97,
                0x93BF: 0x5FB3,
                0x93C0: 0x6D9C,
                0x93C1: 0x7279,
                0x93C2: 0x7763,
                0x93C3: 0x79BF,
                0x93C4: 0x7BE4,
                0x93C5: 0x6BD2,
                0x93C6: 0x72EC,
                0x93C7: 0x8AAD,
                0x93C8: 0x6803,
                0x93C9: 0x6A61,
                0x93CA: 0x51F8,
                0x93CB: 0x7A81,
                0x93CC: 0x6934,
                0x93CD: 0x5C4A,
                0x93CE: 0x9CF6,
                0x93CF: 0x82EB,
                0x93D0: 0x5BC5,
                0x93D1: 0x9149,
                0x93D2: 0x701E,
                0x93D3: 0x5678,
                0x93D4: 0x5C6F,
                0x93D5: 0x60C7,
                0x93D6: 0x6566,
                0x93D7: 0x6C8C,
                0x93D8: 0x8C5A,
                0x93D9: 0x9041,
                0x93DA: 0x9813,
                0x93DB: 0x5451,
                0x93DC: 0x66C7,
                0x93DD: 0x920D,
                0x93DE: 0x5948,
                0x93DF: 0x90A3,
                0x93E0: 0x5185,
                0x93E1: 0x4E4D,
                0x93E2: 0x51EA,
                0x93E3: 0x8599,
                0x93E4: 0x8B0E,
                0x93E5: 0x7058,
                0x93E6: 0x637A,
                0x93E7: 0x934B,
                0x93E8: 0x6962,
                0x93E9: 0x99B4,
                0x93EA: 0x7E04,
                0x93EB: 0x7577,
                0x93EC: 0x5357,
                0x93ED: 0x6960,
                0x93EE: 0x8EDF,
                0x93EF: 0x96E3,
                0x93F0: 0x6C5D,
                0x93F1: 0x4E8C,
                0x93F2: 0x5C3C,
                0x93F3: 0x5F10,
                0x93F4: 0x8FE9,
                0x93F5: 0x5302,
                0x93F6: 0x8CD1,
                0x93F7: 0x8089,
                0x93F8: 0x8679,
                0x93F9: 0x5EFF,
                0x93FA: 0x65E5,
                0x93FB: 0x4E73,
                0x93FC: 0x5165,
                0x9440: 0x5982,
                0x9441: 0x5C3F,
                0x9442: 0x97EE,
                0x9443: 0x4EFB,
                0x9444: 0x598A,
                0x9445: 0x5FCD,
                0x9446: 0x8A8D,
                0x9447: 0x6FE1,
                0x9448: 0x79B0,
                0x9449: 0x7962,
                0x944A: 0x5BE7,
                0x944B: 0x8471,
                0x944C: 0x732B,
                0x944D: 0x71B1,
                0x944E: 0x5E74,
                0x944F: 0x5FF5,
                0x9450: 0x637B,
                0x9451: 0x649A,
                0x9452: 0x71C3,
                0x9453: 0x7C98,
                0x9454: 0x4E43,
                0x9455: 0x5EFC,
                0x9456: 0x4E4B,
                0x9457: 0x57DC,
                0x9458: 0x56A2,
                0x9459: 0x60A9,
                0x945A: 0x6FC3,
                0x945B: 0x7D0D,
                0x945C: 0x80FD,
                0x945D: 0x8133,
                0x945E: 0x81BF,
                0x945F: 0x8FB2,
                0x9460: 0x8997,
                0x9461: 0x86A4,
                0x9462: 0x5DF4,
                0x9463: 0x628A,
                0x9464: 0x64AD,
                0x9465: 0x8987,
                0x9466: 0x6777,
                0x9467: 0x6CE2,
                0x9468: 0x6D3E,
                0x9469: 0x7436,
                0x946A: 0x7834,
                0x946B: 0x5A46,
                0x946C: 0x7F75,
                0x946D: 0x82AD,
                0x946E: 0x99AC,
                0x946F: 0x4FF3,
                0x9470: 0x5EC3,
                0x9471: 0x62DD,
                0x9472: 0x6392,
                0x9473: 0x6557,
                0x9474: 0x676F,
                0x9475: 0x76C3,
                0x9476: 0x724C,
                0x9477: 0x80CC,
                0x9478: 0x80BA,
                0x9479: 0x8F29,
                0x947A: 0x914D,
                0x947B: 0x500D,
                0x947C: 0x57F9,
                0x947D: 0x5A92,
                0x947E: 0x6885,
                0x9480: 0x6973,
                0x9481: 0x7164,
                0x9482: 0x72FD,
                0x9483: 0x8CB7,
                0x9484: 0x58F2,
                0x9485: 0x8CE0,
                0x9486: 0x966A,
                0x9487: 0x9019,
                0x9488: 0x877F,
                0x9489: 0x79E4,
                0x948A: 0x77E7,
                0x948B: 0x8429,
                0x948C: 0x4F2F,
                0x948D: 0x5265,
                0x948E: 0x535A,
                0x948F: 0x62CD,
                0x9490: 0x67CF,
                0x9491: 0x6CCA,
                0x9492: 0x767D,
                0x9493: 0x7B94,
                0x9494: 0x7C95,
                0x9495: 0x8236,
                0x9496: 0x8584,
                0x9497: 0x8FEB,
                0x9498: 0x66DD,
                0x9499: 0x6F20,
                0x949A: 0x7206,
                0x949B: 0x7E1B,
                0x949C: 0x83AB,
                0x949D: 0x99C1,
                0x949E: 0x9EA6,
                0x949F: 0x51FD,
                0x94A0: 0x7BB1,
                0x94A1: 0x7872,
                0x94A2: 0x7BB8,
                0x94A3: 0x8087,
                0x94A4: 0x7B48,
                0x94A5: 0x6AE8,
                0x94A6: 0x5E61,
                0x94A7: 0x808C,
                0x94A8: 0x7551,
                0x94A9: 0x7560,
                0x94AA: 0x516B,
                0x94AB: 0x9262,
                0x94AC: 0x6E8C,
                0x94AD: 0x767A,
                0x94AE: 0x9197,
                0x94AF: 0x9AEA,
                0x94B0: 0x4F10,
                0x94B1: 0x7F70,
                0x94B2: 0x629C,
                0x94B3: 0x7B4F,
                0x94B4: 0x95A5,
                0x94B5: 0x9CE9,
                0x94B6: 0x567A,
                0x94B7: 0x5859,
                0x94B8: 0x86E4,
                0x94B9: 0x96BC,
                0x94BA: 0x4F34,
                0x94BB: 0x5224,
                0x94BC: 0x534A,
                0x94BD: 0x53CD,
                0x94BE: 0x53DB,
                0x94BF: 0x5E06,
                0x94C0: 0x642C,
                0x94C1: 0x6591,
                0x94C2: 0x677F,
                0x94C3: 0x6C3E,
                0x94C4: 0x6C4E,
                0x94C5: 0x7248,
                0x94C6: 0x72AF,
                0x94C7: 0x73ED,
                0x94C8: 0x7554,
                0x94C9: 0x7E41,
                0x94CA: 0x822C,
                0x94CB: 0x85E9,
                0x94CC: 0x8CA9,
                0x94CD: 0x7BC4,
                0x94CE: 0x91C6,
                0x94CF: 0x7169,
                0x94D0: 0x9812,
                0x94D1: 0x98EF,
                0x94D2: 0x633D,
                0x94D3: 0x6669,
                0x94D4: 0x756A,
                0x94D5: 0x76E4,
                0x94D6: 0x78D0,
                0x94D7: 0x8543,
                0x94D8: 0x86EE,
                0x94D9: 0x532A,
                0x94DA: 0x5351,
                0x94DB: 0x5426,
                0x94DC: 0x5983,
                0x94DD: 0x5E87,
                0x94DE: 0x5F7C,
                0x94DF: 0x60B2,
                0x94E0: 0x6249,
                0x94E1: 0x6279,
                0x94E2: 0x62AB,
                0x94E3: 0x6590,
                0x94E4: 0x6BD4,
                0x94E5: 0x6CCC,
                0x94E6: 0x75B2,
                0x94E7: 0x76AE,
                0x94E8: 0x7891,
                0x94E9: 0x79D8,
                0x94EA: 0x7DCB,
                0x94EB: 0x7F77,
                0x94EC: 0x80A5,
                0x94ED: 0x88AB,
                0x94EE: 0x8AB9,
                0x94EF: 0x8CBB,
                0x94F0: 0x907F,
                0x94F1: 0x975E,
                0x94F2: 0x98DB,
                0x94F3: 0x6A0B,
                0x94F4: 0x7C38,
                0x94F5: 0x5099,
                0x94F6: 0x5C3E,
                0x94F7: 0x5FAE,
                0x94F8: 0x6787,
                0x94F9: 0x6BD8,
                0x94FA: 0x7435,
                0x94FB: 0x7709,
                0x94FC: 0x7F8E,
                0x9540: 0x9F3B,
                0x9541: 0x67CA,
                0x9542: 0x7A17,
                0x9543: 0x5339,
                0x9544: 0x758B,
                0x9545: 0x9AED,
                0x9546: 0x5F66,
                0x9547: 0x819D,
                0x9548: 0x83F1,
                0x9549: 0x8098,
                0x954A: 0x5F3C,
                0x954B: 0x5FC5,
                0x954C: 0x7562,
                0x954D: 0x7B46,
                0x954E: 0x903C,
                0x954F: 0x6867,
                0x9550: 0x59EB,
                0x9551: 0x5A9B,
                0x9552: 0x7D10,
                0x9553: 0x767E,
                0x9554: 0x8B2C,
                0x9555: 0x4FF5,
                0x9556: 0x5F6A,
                0x9557: 0x6A19,
                0x9558: 0x6C37,
                0x9559: 0x6F02,
                0x955A: 0x74E2,
                0x955B: 0x7968,
                0x955C: 0x8868,
                0x955D: 0x8A55,
                0x955E: 0x8C79,
                0x955F: 0x5EDF,
                0x9560: 0x63CF,
                0x9561: 0x75C5,
                0x9562: 0x79D2,
                0x9563: 0x82D7,
                0x9564: 0x9328,
                0x9565: 0x92F2,
                0x9566: 0x849C,
                0x9567: 0x86ED,
                0x9568: 0x9C2D,
                0x9569: 0x54C1,
                0x956A: 0x5F6C,
                0x956B: 0x658C,
                0x956C: 0x6D5C,
                0x956D: 0x7015,
                0x956E: 0x8CA7,
                0x956F: 0x8CD3,
                0x9570: 0x983B,
                0x9571: 0x654F,
                0x9572: 0x74F6,
                0x9573: 0x4E0D,
                0x9574: 0x4ED8,
                0x9575: 0x57E0,
                0x9576: 0x592B,
                0x9577: 0x5A66,
                0x9578: 0x5BCC,
                0x9579: 0x51A8,
                0x957A: 0x5E03,
                0x957B: 0x5E9C,
                0x957C: 0x6016,
                0x957D: 0x6276,
                0x957E: 0x6577,
                0x9580: 0x65A7,
                0x9581: 0x666E,
                0x9582: 0x6D6E,
                0x9583: 0x7236,
                0x9584: 0x7B26,
                0x9585: 0x8150,
                0x9586: 0x819A,
                0x9587: 0x8299,
                0x9588: 0x8B5C,
                0x9589: 0x8CA0,
                0x958A: 0x8CE6,
                0x958B: 0x8D74,
                0x958C: 0x961C,
                0x958D: 0x9644,
                0x958E: 0x4FAE,
                0x958F: 0x64AB,
                0x9590: 0x6B66,
                0x9591: 0x821E,
                0x9592: 0x8461,
                0x9593: 0x856A,
                0x9594: 0x90E8,
                0x9595: 0x5C01,
                0x9596: 0x6953,
                0x9597: 0x98A8,
                0x9598: 0x847A,
                0x9599: 0x8557,
                0x959A: 0x4F0F,
                0x959B: 0x526F,
                0x959C: 0x5FA9,
                0x959D: 0x5E45,
                0x959E: 0x670D,
                0x959F: 0x798F,
                0x95A0: 0x8179,
                0x95A1: 0x8907,
                0x95A2: 0x8986,
                0x95A3: 0x6DF5,
                0x95A4: 0x5F17,
                0x95A5: 0x6255,
                0x95A6: 0x6CB8,
                0x95A7: 0x4ECF,
                0x95A8: 0x7269,
                0x95A9: 0x9B92,
                0x95AA: 0x5206,
                0x95AB: 0x543B,
                0x95AC: 0x5674,
                0x95AD: 0x58B3,
                0x95AE: 0x61A4,
                0x95AF: 0x626E,
                0x95B0: 0x711A,
                0x95B1: 0x596E,
                0x95B2: 0x7C89,
                0x95B3: 0x7CDE,
                0x95B4: 0x7D1B,
                0x95B5: 0x96F0,
                0x95B6: 0x6587,
                0x95B7: 0x805E,
                0x95B8: 0x4E19,
                0x95B9: 0x4F75,
                0x95BA: 0x5175,
                0x95BB: 0x5840,
                0x95BC: 0x5E63,
                0x95BD: 0x5E73,
                0x95BE: 0x5F0A,
                0x95BF: 0x67C4,
                0x95C0: 0x4E26,
                0x95C1: 0x853D,
                0x95C2: 0x9589,
                0x95C3: 0x965B,
                0x95C4: 0x7C73,
                0x95C5: 0x9801,
                0x95C6: 0x50FB,
                0x95C7: 0x58C1,
                0x95C8: 0x7656,
                0x95C9: 0x78A7,
                0x95CA: 0x5225,
                0x95CB: 0x77A5,
                0x95CC: 0x8511,
                0x95CD: 0x7B86,
                0x95CE: 0x504F,
                0x95CF: 0x5909,
                0x95D0: 0x7247,
                0x95D1: 0x7BC7,
                0x95D2: 0x7DE8,
                0x95D3: 0x8FBA,
                0x95D4: 0x8FD4,
                0x95D5: 0x904D,
                0x95D6: 0x4FBF,
                0x95D7: 0x52C9,
                0x95D8: 0x5A29,
                0x95D9: 0x5F01,
                0x95DA: 0x97AD,
                0x95DB: 0x4FDD,
                0x95DC: 0x8217,
                0x95DD: 0x92EA,
                0x95DE: 0x5703,
                0x95DF: 0x6355,
                0x95E0: 0x6B69,
                0x95E1: 0x752B,
                0x95E2: 0x88DC,
                0x95E3: 0x8F14,
                0x95E4: 0x7A42,
                0x95E5: 0x52DF,
                0x95E6: 0x5893,
                0x95E7: 0x6155,
                0x95E8: 0x620A,
                0x95E9: 0x66AE,
                0x95EA: 0x6BCD,
                0x95EB: 0x7C3F,
                0x95EC: 0x83E9,
                0x95ED: 0x5023,
                0x95EE: 0x4FF8,
                0x95EF: 0x5305,
                0x95F0: 0x5446,
                0x95F1: 0x5831,
                0x95F2: 0x5949,
                0x95F3: 0x5B9D,
                0x95F4: 0x5CF0,
                0x95F5: 0x5CEF,
                0x95F6: 0x5D29,
                0x95F7: 0x5E96,
                0x95F8: 0x62B1,
                0x95F9: 0x6367,
                0x95FA: 0x653E,
                0x95FB: 0x65B9,
                0x95FC: 0x670B,
                0x9640: 0x6CD5,
                0x9641: 0x6CE1,
                0x9642: 0x70F9,
                0x9643: 0x7832,
                0x9644: 0x7E2B,
                0x9645: 0x80DE,
                0x9646: 0x82B3,
                0x9647: 0x840C,
                0x9648: 0x84EC,
                0x9649: 0x8702,
                0x964A: 0x8912,
                0x964B: 0x8A2A,
                0x964C: 0x8C4A,
                0x964D: 0x90A6,
                0x964E: 0x92D2,
                0x964F: 0x98FD,
                0x9650: 0x9CF3,
                0x9651: 0x9D6C,
                0x9652: 0x4E4F,
                0x9653: 0x4EA1,
                0x9654: 0x508D,
                0x9655: 0x5256,
                0x9656: 0x574A,
                0x9657: 0x59A8,
                0x9658: 0x5E3D,
                0x9659: 0x5FD8,
                0x965A: 0x5FD9,
                0x965B: 0x623F,
                0x965C: 0x66B4,
                0x965D: 0x671B,
                0x965E: 0x67D0,
                0x965F: 0x68D2,
                0x9660: 0x5192,
                0x9661: 0x7D21,
                0x9662: 0x80AA,
                0x9663: 0x81A8,
                0x9664: 0x8B00,
                0x9665: 0x8C8C,
                0x9666: 0x8CBF,
                0x9667: 0x927E,
                0x9668: 0x9632,
                0x9669: 0x5420,
                0x966A: 0x982C,
                0x966B: 0x5317,
                0x966C: 0x50D5,
                0x966D: 0x535C,
                0x966E: 0x58A8,
                0x966F: 0x64B2,
                0x9670: 0x6734,
                0x9671: 0x7267,
                0x9672: 0x7766,
                0x9673: 0x7A46,
                0x9674: 0x91E6,
                0x9675: 0x52C3,
                0x9676: 0x6CA1,
                0x9677: 0x6B86,
                0x9678: 0x5800,
                0x9679: 0x5E4C,
                0x967A: 0x5954,
                0x967B: 0x672C,
                0x967C: 0x7FFB,
                0x967D: 0x51E1,
                0x967E: 0x76C6,
                0x9680: 0x6469,
                0x9681: 0x78E8,
                0x9682: 0x9B54,
                0x9683: 0x9EBB,
                0x9684: 0x57CB,
                0x9685: 0x59B9,
                0x9686: 0x6627,
                0x9687: 0x679A,
                0x9688: 0x6BCE,
                0x9689: 0x54E9,
                0x968A: 0x69D9,
                0x968B: 0x5E55,
                0x968C: 0x819C,
                0x968D: 0x6795,
                0x968E: 0x9BAA,
                0x968F: 0x67FE,
                0x9690: 0x9C52,
                0x9691: 0x685D,
                0x9692: 0x4EA6,
                0x9693: 0x4FE3,
                0x9694: 0x53C8,
                0x9695: 0x62B9,
                0x9696: 0x672B,
                0x9697: 0x6CAB,
                0x9698: 0x8FC4,
                0x9699: 0x4FAD,
                0x969A: 0x7E6D,
                0x969B: 0x9EBF,
                0x969C: 0x4E07,
                0x969D: 0x6162,
                0x969E: 0x6E80,
                0x969F: 0x6F2B,
                0x96A0: 0x8513,
                0x96A1: 0x5473,
                0x96A2: 0x672A,
                0x96A3: 0x9B45,
                0x96A4: 0x5DF3,
                0x96A5: 0x7B95,
                0x96A6: 0x5CAC,
                0x96A7: 0x5BC6,
                0x96A8: 0x871C,
                0x96A9: 0x6E4A,
                0x96AA: 0x84D1,
                0x96AB: 0x7A14,
                0x96AC: 0x8108,
                0x96AD: 0x5999,
                0x96AE: 0x7C8D,
                0x96AF: 0x6C11,
                0x96B0: 0x7720,
                0x96B1: 0x52D9,
                0x96B2: 0x5922,
                0x96B3: 0x7121,
                0x96B4: 0x725F,
                0x96B5: 0x77DB,
                0x96B6: 0x9727,
                0x96B7: 0x9D61,
                0x96B8: 0x690B,
                0x96B9: 0x5A7F,
                0x96BA: 0x5A18,
                0x96BB: 0x51A5,
                0x96BC: 0x540D,
                0x96BD: 0x547D,
                0x96BE: 0x660E,
                0x96BF: 0x76DF,
                0x96C0: 0x8FF7,
                0x96C1: 0x9298,
                0x96C2: 0x9CF4,
                0x96C3: 0x59EA,
                0x96C4: 0x725D,
                0x96C5: 0x6EC5,
                0x96C6: 0x514D,
                0x96C7: 0x68C9,
                0x96C8: 0x7DBF,
                0x96C9: 0x7DEC,
                0x96CA: 0x9762,
                0x96CB: 0x9EBA,
                0x96CC: 0x6478,
                0x96CD: 0x6A21,
                0x96CE: 0x8302,
                0x96CF: 0x5984,
                0x96D0: 0x5B5F,
                0x96D1: 0x6BDB,
                0x96D2: 0x731B,
                0x96D3: 0x76F2,
                0x96D4: 0x7DB2,
                0x96D5: 0x8017,
                0x96D6: 0x8499,
                0x96D7: 0x5132,
                0x96D8: 0x6728,
                0x96D9: 0x9ED9,
                0x96DA: 0x76EE,
                0x96DB: 0x6762,
                0x96DC: 0x52FF,
                0x96DD: 0x9905,
                0x96DE: 0x5C24,
                0x96DF: 0x623B,
                0x96E0: 0x7C7E,
                0x96E1: 0x8CB0,
                0x96E2: 0x554F,
                0x96E3: 0x60B6,
                0x96E4: 0x7D0B,
                0x96E5: 0x9580,
                0x96E6: 0x5301,
                0x96E7: 0x4E5F,
                0x96E8: 0x51B6,
                0x96E9: 0x591C,
                0x96EA: 0x723A,
                0x96EB: 0x8036,
                0x96EC: 0x91CE,
                0x96ED: 0x5F25,
                0x96EE: 0x77E2,
                0x96EF: 0x5384,
                0x96F0: 0x5F79,
                0x96F1: 0x7D04,
                0x96F2: 0x85AC,
                0x96F3: 0x8A33,
                0x96F4: 0x8E8D,
                0x96F5: 0x9756,
                0x96F6: 0x67F3,
                0x96F7: 0x85AE,
                0x96F8: 0x9453,
                0x96F9: 0x6109,
                0x96FA: 0x6108,
                0x96FB: 0x6CB9,
                0x96FC: 0x7652,
                0x9740: 0x8AED,
                0x9741: 0x8F38,
                0x9742: 0x552F,
                0x9743: 0x4F51,
                0x9744: 0x512A,
                0x9745: 0x52C7,
                0x9746: 0x53CB,
                0x9747: 0x5BA5,
                0x9748: 0x5E7D,
                0x9749: 0x60A0,
                0x974A: 0x6182,
                0x974B: 0x63D6,
                0x974C: 0x6709,
                0x974D: 0x67DA,
                0x974E: 0x6E67,
                0x974F: 0x6D8C,
                0x9750: 0x7336,
                0x9751: 0x7337,
                0x9752: 0x7531,
                0x9753: 0x7950,
                0x9754: 0x88D5,
                0x9755: 0x8A98,
                0x9756: 0x904A,
                0x9757: 0x9091,
                0x9758: 0x90F5,
                0x9759: 0x96C4,
                0x975A: 0x878D,
                0x975B: 0x5915,
                0x975C: 0x4E88,
                0x975D: 0x4F59,
                0x975E: 0x4E0E,
                0x975F: 0x8A89,
                0x9760: 0x8F3F,
                0x9761: 0x9810,
                0x9762: 0x50AD,
                0x9763: 0x5E7C,
                0x9764: 0x5996,
                0x9765: 0x5BB9,
                0x9766: 0x5EB8,
                0x9767: 0x63DA,
                0x9768: 0x63FA,
                0x9769: 0x64C1,
                0x976A: 0x66DC,
                0x976B: 0x694A,
                0x976C: 0x69D8,
                0x976D: 0x6D0B,
                0x976E: 0x6EB6,
                0x976F: 0x7194,
                0x9770: 0x7528,
                0x9771: 0x7AAF,
                0x9772: 0x7F8A,
                0x9773: 0x8000,
                0x9774: 0x8449,
                0x9775: 0x84C9,
                0x9776: 0x8981,
                0x9777: 0x8B21,
                0x9778: 0x8E0A,
                0x9779: 0x9065,
                0x977A: 0x967D,
                0x977B: 0x990A,
                0x977C: 0x617E,
                0x977D: 0x6291,
                0x977E: 0x6B32,
                0x9780: 0x6C83,
                0x9781: 0x6D74,
                0x9782: 0x7FCC,
                0x9783: 0x7FFC,
                0x9784: 0x6DC0,
                0x9785: 0x7F85,
                0x9786: 0x87BA,
                0x9787: 0x88F8,
                0x9788: 0x6765,
                0x9789: 0x83B1,
                0x978A: 0x983C,
                0x978B: 0x96F7,
                0x978C: 0x6D1B,
                0x978D: 0x7D61,
                0x978E: 0x843D,
                0x978F: 0x916A,
                0x9790: 0x4E71,
                0x9791: 0x5375,
                0x9792: 0x5D50,
                0x9793: 0x6B04,
                0x9794: 0x6FEB,
                0x9795: 0x85CD,
                0x9796: 0x862D,
                0x9797: 0x89A7,
                0x9798: 0x5229,
                0x9799: 0x540F,
                0x979A: 0x5C65,
                0x979B: 0x674E,
                0x979C: 0x68A8,
                0x979D: 0x7406,
                0x979E: 0x7483,
                0x979F: 0x75E2,
                0x97A0: 0x88CF,
                0x97A1: 0x88E1,
                0x97A2: 0x91CC,
                0x97A3: 0x96E2,
                0x97A4: 0x9678,
                0x97A5: 0x5F8B,
                0x97A6: 0x7387,
                0x97A7: 0x7ACB,
                0x97A8: 0x844E,
                0x97A9: 0x63A0,
                0x97AA: 0x7565,
                0x97AB: 0x5289,
                0x97AC: 0x6D41,
                0x97AD: 0x6E9C,
                0x97AE: 0x7409,
                0x97AF: 0x7559,
                0x97B0: 0x786B,
                0x97B1: 0x7C92,
                0x97B2: 0x9686,
                0x97B3: 0x7ADC,
                0x97B4: 0x9F8D,
                0x97B5: 0x4FB6,
                0x97B6: 0x616E,
                0x97B7: 0x65C5,
                0x97B8: 0x865C,
                0x97B9: 0x4E86,
                0x97BA: 0x4EAE,
                0x97BB: 0x50DA,
                0x97BC: 0x4E21,
                0x97BD: 0x51CC,
                0x97BE: 0x5BEE,
                0x97BF: 0x6599,
                0x97C0: 0x6881,
                0x97C1: 0x6DBC,
                0x97C2: 0x731F,
                0x97C3: 0x7642,
                0x97C4: 0x77AD,
                0x97C5: 0x7A1C,
                0x97C6: 0x7CE7,
                0x97C7: 0x826F,
                0x97C8: 0x8AD2,
                0x97C9: 0x907C,
                0x97CA: 0x91CF,
                0x97CB: 0x9675,
                0x97CC: 0x9818,
                0x97CD: 0x529B,
                0x97CE: 0x7DD1,
                0x97CF: 0x502B,
                0x97D0: 0x5398,
                0x97D1: 0x6797,
                0x97D2: 0x6DCB,
                0x97D3: 0x71D0,
                0x97D4: 0x7433,
                0x97D5: 0x81E8,
                0x97D6: 0x8F2A,
                0x97D7: 0x96A3,
                0x97D8: 0x9C57,
                0x97D9: 0x9E9F,
                0x97DA: 0x7460,
                0x97DB: 0x5841,
                0x97DC: 0x6D99,
                0x97DD: 0x7D2F,
                0x97DE: 0x985E,
                0x97DF: 0x4EE4,
                0x97E0: 0x4F36,
                0x97E1: 0x4F8B,
                0x97E2: 0x51B7,
                0x97E3: 0x52B1,
                0x97E4: 0x5DBA,
                0x97E5: 0x601C,
                0x97E6: 0x73B2,
                0x97E7: 0x793C,
                0x97E8: 0x82D3,
                0x97E9: 0x9234,
                0x97EA: 0x96B7,
                0x97EB: 0x96F6,
                0x97EC: 0x970A,
                0x97ED: 0x9E97,
                0x97EE: 0x9F62,
                0x97EF: 0x66A6,
                0x97F0: 0x6B74,
                0x97F1: 0x5217,
                0x97F2: 0x52A3,
                0x97F3: 0x70C8,
                0x97F4: 0x88C2,
                0x97F5: 0x5EC9,
                0x97F6: 0x604B,
                0x97F7: 0x6190,
                0x97F8: 0x6F23,
                0x97F9: 0x7149,
                0x97FA: 0x7C3E,
                0x97FB: 0x7DF4,
                0x97FC: 0x806F,
                0x9840: 0x84EE,
                0x9841: 0x9023,
                0x9842: 0x932C,
                0x9843: 0x5442,
                0x9844: 0x9B6F,
                0x9845: 0x6AD3,
                0x9846: 0x7089,
                0x9847: 0x8CC2,
                0x9848: 0x8DEF,
                0x9849: 0x9732,
                0x984A: 0x52B4,
                0x984B: 0x5A41,
                0x984C: 0x5ECA,
                0x984D: 0x5F04,
                0x984E: 0x6717,
                0x984F: 0x697C,
                0x9850: 0x6994,
                0x9851: 0x6D6A,
                0x9852: 0x6F0F,
                0x9853: 0x7262,
                0x9854: 0x72FC,
                0x9855: 0x7BED,
                0x9856: 0x8001,
                0x9857: 0x807E,
                0x9858: 0x874B,
                0x9859: 0x90CE,
                0x985A: 0x516D,
                0x985B: 0x9E93,
                0x985C: 0x7984,
                0x985D: 0x808B,
                0x985E: 0x9332,
                0x985F: 0x8AD6,
                0x9860: 0x502D,
                0x9861: 0x548C,
                0x9862: 0x8A71,
                0x9863: 0x6B6A,
                0x9864: 0x8CC4,
                0x9865: 0x8107,
                0x9866: 0x60D1,
                0x9867: 0x67A0,
                0x9868: 0x9DF2,
                0x9869: 0x4E99,
                0x986A: 0x4E98,
                0x986B: 0x9C10,
                0x986C: 0x8A6B,
                0x986D: 0x85C1,
                0x986E: 0x8568,
                0x986F: 0x6900,
                0x9870: 0x6E7E,
                0x9871: 0x7897,
                0x9872: 0x8155,
                0x989F: 0x5F0C,
                0x98A0: 0x4E10,
                0x98A1: 0x4E15,
                0x98A2: 0x4E2A,
                0x98A3: 0x4E31,
                0x98A4: 0x4E36,
                0x98A5: 0x4E3C,
                0x98A6: 0x4E3F,
                0x98A7: 0x4E42,
                0x98A8: 0x4E56,
                0x98A9: 0x4E58,
                0x98AA: 0x4E82,
                0x98AB: 0x4E85,
                0x98AC: 0x8C6B,
                0x98AD: 0x4E8A,
                0x98AE: 0x8212,
                0x98AF: 0x5F0D,
                0x98B0: 0x4E8E,
                0x98B1: 0x4E9E,
                0x98B2: 0x4E9F,
                0x98B3: 0x4EA0,
                0x98B4: 0x4EA2,
                0x98B5: 0x4EB0,
                0x98B6: 0x4EB3,
                0x98B7: 0x4EB6,
                0x98B8: 0x4ECE,
                0x98B9: 0x4ECD,
                0x98BA: 0x4EC4,
                0x98BB: 0x4EC6,
                0x98BC: 0x4EC2,
                0x98BD: 0x4ED7,
                0x98BE: 0x4EDE,
                0x98BF: 0x4EED,
                0x98C0: 0x4EDF,
                0x98C1: 0x4EF7,
                0x98C2: 0x4F09,
                0x98C3: 0x4F5A,
                0x98C4: 0x4F30,
                0x98C5: 0x4F5B,
                0x98C6: 0x4F5D,
                0x98C7: 0x4F57,
                0x98C8: 0x4F47,
                0x98C9: 0x4F76,
                0x98CA: 0x4F88,
                0x98CB: 0x4F8F,
                0x98CC: 0x4F98,
                0x98CD: 0x4F7B,
                0x98CE: 0x4F69,
                0x98CF: 0x4F70,
                0x98D0: 0x4F91,
                0x98D1: 0x4F6F,
                0x98D2: 0x4F86,
                0x98D3: 0x4F96,
                0x98D4: 0x5118,
                0x98D5: 0x4FD4,
                0x98D6: 0x4FDF,
                0x98D7: 0x4FCE,
                0x98D8: 0x4FD8,
                0x98D9: 0x4FDB,
                0x98DA: 0x4FD1,
                0x98DB: 0x4FDA,
                0x98DC: 0x4FD0,
                0x98DD: 0x4FE4,
                0x98DE: 0x4FE5,
                0x98DF: 0x501A,
                0x98E0: 0x5028,
                0x98E1: 0x5014,
                0x98E2: 0x502A,
                0x98E3: 0x5025,
                0x98E4: 0x5005,
                0x98E5: 0x4F1C,
                0x98E6: 0x4FF6,
                0x98E7: 0x5021,
                0x98E8: 0x5029,
                0x98E9: 0x502C,
                0x98EA: 0x4FFE,
                0x98EB: 0x4FEF,
                0x98EC: 0x5011,
                0x98ED: 0x5006,
                0x98EE: 0x5043,
                0x98EF: 0x5047,
                0x98F0: 0x6703,
                0x98F1: 0x5055,
                0x98F2: 0x5050,
                0x98F3: 0x5048,
                0x98F4: 0x505A,
                0x98F5: 0x5056,
                0x98F6: 0x506C,
                0x98F7: 0x5078,
                0x98F8: 0x5080,
                0x98F9: 0x509A,
                0x98FA: 0x5085,
                0x98FB: 0x50B4,
                0x98FC: 0x50B2,
                0x9940: 0x50C9,
                0x9941: 0x50CA,
                0x9942: 0x50B3,
                0x9943: 0x50C2,
                0x9944: 0x50D6,
                0x9945: 0x50DE,
                0x9946: 0x50E5,
                0x9947: 0x50ED,
                0x9948: 0x50E3,
                0x9949: 0x50EE,
                0x994A: 0x50F9,
                0x994B: 0x50F5,
                0x994C: 0x5109,
                0x994D: 0x5101,
                0x994E: 0x5102,
                0x994F: 0x5116,
                0x9950: 0x5115,
                0x9951: 0x5114,
                0x9952: 0x511A,
                0x9953: 0x5121,
                0x9954: 0x513A,
                0x9955: 0x5137,
                0x9956: 0x513C,
                0x9957: 0x513B,
                0x9958: 0x513F,
                0x9959: 0x5140,
                0x995A: 0x5152,
                0x995B: 0x514C,
                0x995C: 0x5154,
                0x995D: 0x5162,
                0x995E: 0x7AF8,
                0x995F: 0x5169,
                0x9960: 0x516A,
                0x9961: 0x516E,
                0x9962: 0x5180,
                0x9963: 0x5182,
                0x9964: 0x56D8,
                0x9965: 0x518C,
                0x9966: 0x5189,
                0x9967: 0x518F,
                0x9968: 0x5191,
                0x9969: 0x5193,
                0x996A: 0x5195,
                0x996B: 0x5196,
                0x996C: 0x51A4,
                0x996D: 0x51A6,
                0x996E: 0x51A2,
                0x996F: 0x51A9,
                0x9970: 0x51AA,
                0x9971: 0x51AB,
                0x9972: 0x51B3,
                0x9973: 0x51B1,
                0x9974: 0x51B2,
                0x9975: 0x51B0,
                0x9976: 0x51B5,
                0x9977: 0x51BD,
                0x9978: 0x51C5,
                0x9979: 0x51C9,
                0x997A: 0x51DB,
                0x997B: 0x51E0,
                0x997C: 0x8655,
                0x997D: 0x51E9,
                0x997E: 0x51ED,
                0x9980: 0x51F0,
                0x9981: 0x51F5,
                0x9982: 0x51FE,
                0x9983: 0x5204,
                0x9984: 0x520B,
                0x9985: 0x5214,
                0x9986: 0x520E,
                0x9987: 0x5227,
                0x9988: 0x522A,
                0x9989: 0x522E,
                0x998A: 0x5233,
                0x998B: 0x5239,
                0x998C: 0x524F,
                0x998D: 0x5244,
                0x998E: 0x524B,
                0x998F: 0x524C,
                0x9990: 0x525E,
                0x9991: 0x5254,
                0x9992: 0x526A,
                0x9993: 0x5274,
                0x9994: 0x5269,
                0x9995: 0x5273,
                0x9996: 0x527F,
                0x9997: 0x527D,
                0x9998: 0x528D,
                0x9999: 0x5294,
                0x999A: 0x5292,
                0x999B: 0x5271,
                0x999C: 0x5288,
                0x999D: 0x5291,
                0x999E: 0x8FA8,
                0x999F: 0x8FA7,
                0x99A0: 0x52AC,
                0x99A1: 0x52AD,
                0x99A2: 0x52BC,
                0x99A3: 0x52B5,
                0x99A4: 0x52C1,
                0x99A5: 0x52CD,
                0x99A6: 0x52D7,
                0x99A7: 0x52DE,
                0x99A8: 0x52E3,
                0x99A9: 0x52E6,
                0x99AA: 0x98ED,
                0x99AB: 0x52E0,
                0x99AC: 0x52F3,
                0x99AD: 0x52F5,
                0x99AE: 0x52F8,
                0x99AF: 0x52F9,
                0x99B0: 0x5306,
                0x99B1: 0x5308,
                0x99B2: 0x7538,
                0x99B3: 0x530D,
                0x99B4: 0x5310,
                0x99B5: 0x530F,
                0x99B6: 0x5315,
                0x99B7: 0x531A,
                0x99B8: 0x5323,
                0x99B9: 0x532F,
                0x99BA: 0x5331,
                0x99BB: 0x5333,
                0x99BC: 0x5338,
                0x99BD: 0x5340,
                0x99BE: 0x5346,
                0x99BF: 0x5345,
                0x99C0: 0x4E17,
                0x99C1: 0x5349,
                0x99C2: 0x534D,
                0x99C3: 0x51D6,
                0x99C4: 0x535E,
                0x99C5: 0x5369,
                0x99C6: 0x536E,
                0x99C7: 0x5918,
                0x99C8: 0x537B,
                0x99C9: 0x5377,
                0x99CA: 0x5382,
                0x99CB: 0x5396,
                0x99CC: 0x53A0,
                0x99CD: 0x53A6,
                0x99CE: 0x53A5,
                0x99CF: 0x53AE,
                0x99D0: 0x53B0,
                0x99D1: 0x53B6,
                0x99D2: 0x53C3,
                0x99D3: 0x7C12,
                0x99D4: 0x96D9,
                0x99D5: 0x53DF,
                0x99D6: 0x66FC,
                0x99D7: 0x71EE,
                0x99D8: 0x53EE,
                0x99D9: 0x53E8,
                0x99DA: 0x53ED,
                0x99DB: 0x53FA,
                0x99DC: 0x5401,
                0x99DD: 0x543D,
                0x99DE: 0x5440,
                0x99DF: 0x542C,
                0x99E0: 0x542D,
                0x99E1: 0x543C,
                0x99E2: 0x542E,
                0x99E3: 0x5436,
                0x99E4: 0x5429,
                0x99E5: 0x541D,
                0x99E6: 0x544E,
                0x99E7: 0x548F,
                0x99E8: 0x5475,
                0x99E9: 0x548E,
                0x99EA: 0x545F,
                0x99EB: 0x5471,
                0x99EC: 0x5477,
                0x99ED: 0x5470,
                0x99EE: 0x5492,
                0x99EF: 0x547B,
                0x99F0: 0x5480,
                0x99F1: 0x5476,
                0x99F2: 0x5484,
                0x99F3: 0x5490,
                0x99F4: 0x5486,
                0x99F5: 0x54C7,
                0x99F6: 0x54A2,
                0x99F7: 0x54B8,
                0x99F8: 0x54A5,
                0x99F9: 0x54AC,
                0x99FA: 0x54C4,
                0x99FB: 0x54C8,
                0x99FC: 0x54A8,
                0x9A40: 0x54AB,
                0x9A41: 0x54C2,
                0x9A42: 0x54A4,
                0x9A43: 0x54BE,
                0x9A44: 0x54BC,
                0x9A45: 0x54D8,
                0x9A46: 0x54E5,
                0x9A47: 0x54E6,
                0x9A48: 0x550F,
                0x9A49: 0x5514,
                0x9A4A: 0x54FD,
                0x9A4B: 0x54EE,
                0x9A4C: 0x54ED,
                0x9A4D: 0x54FA,
                0x9A4E: 0x54E2,
                0x9A4F: 0x5539,
                0x9A50: 0x5540,
                0x9A51: 0x5563,
                0x9A52: 0x554C,
                0x9A53: 0x552E,
                0x9A54: 0x555C,
                0x9A55: 0x5545,
                0x9A56: 0x5556,
                0x9A57: 0x5557,
                0x9A58: 0x5538,
                0x9A59: 0x5533,
                0x9A5A: 0x555D,
                0x9A5B: 0x5599,
                0x9A5C: 0x5580,
                0x9A5D: 0x54AF,
                0x9A5E: 0x558A,
                0x9A5F: 0x559F,
                0x9A60: 0x557B,
                0x9A61: 0x557E,
                0x9A62: 0x5598,
                0x9A63: 0x559E,
                0x9A64: 0x55AE,
                0x9A65: 0x557C,
                0x9A66: 0x5583,
                0x9A67: 0x55A9,
                0x9A68: 0x5587,
                0x9A69: 0x55A8,
                0x9A6A: 0x55DA,
                0x9A6B: 0x55C5,
                0x9A6C: 0x55DF,
                0x9A6D: 0x55C4,
                0x9A6E: 0x55DC,
                0x9A6F: 0x55E4,
                0x9A70: 0x55D4,
                0x9A71: 0x5614,
                0x9A72: 0x55F7,
                0x9A73: 0x5616,
                0x9A74: 0x55FE,
                0x9A75: 0x55FD,
                0x9A76: 0x561B,
                0x9A77: 0x55F9,
                0x9A78: 0x564E,
                0x9A79: 0x5650,
                0x9A7A: 0x71DF,
                0x9A7B: 0x5634,
                0x9A7C: 0x5636,
                0x9A7D: 0x5632,
                0x9A7E: 0x5638,
                0x9A80: 0x566B,
                0x9A81: 0x5664,
                0x9A82: 0x562F,
                0x9A83: 0x566C,
                0x9A84: 0x566A,
                0x9A85: 0x5686,
                0x9A86: 0x5680,
                0x9A87: 0x568A,
                0x9A88: 0x56A0,
                0x9A89: 0x5694,
                0x9A8A: 0x568F,
                0x9A8B: 0x56A5,
                0x9A8C: 0x56AE,
                0x9A8D: 0x56B6,
                0x9A8E: 0x56B4,
                0x9A8F: 0x56C2,
                0x9A90: 0x56BC,
                0x9A91: 0x56C1,
                0x9A92: 0x56C3,
                0x9A93: 0x56C0,
                0x9A94: 0x56C8,
                0x9A95: 0x56CE,
                0x9A96: 0x56D1,
                0x9A97: 0x56D3,
                0x9A98: 0x56D7,
                0x9A99: 0x56EE,
                0x9A9A: 0x56F9,
                0x9A9B: 0x5700,
                0x9A9C: 0x56FF,
                0x9A9D: 0x5704,
                0x9A9E: 0x5709,
                0x9A9F: 0x5708,
                0x9AA0: 0x570B,
                0x9AA1: 0x570D,
                0x9AA2: 0x5713,
                0x9AA3: 0x5718,
                0x9AA4: 0x5716,
                0x9AA5: 0x55C7,
                0x9AA6: 0x571C,
                0x9AA7: 0x5726,
                0x9AA8: 0x5737,
                0x9AA9: 0x5738,
                0x9AAA: 0x574E,
                0x9AAB: 0x573B,
                0x9AAC: 0x5740,
                0x9AAD: 0x574F,
                0x9AAE: 0x5769,
                0x9AAF: 0x57C0,
                0x9AB0: 0x5788,
                0x9AB1: 0x5761,
                0x9AB2: 0x577F,
                0x9AB3: 0x5789,
                0x9AB4: 0x5793,
                0x9AB5: 0x57A0,
                0x9AB6: 0x57B3,
                0x9AB7: 0x57A4,
                0x9AB8: 0x57AA,
                0x9AB9: 0x57B0,
                0x9ABA: 0x57C3,
                0x9ABB: 0x57C6,
                0x9ABC: 0x57D4,
                0x9ABD: 0x57D2,
                0x9ABE: 0x57D3,
                0x9ABF: 0x580A,
                0x9AC0: 0x57D6,
                0x9AC1: 0x57E3,
                0x9AC2: 0x580B,
                0x9AC3: 0x5819,
                0x9AC4: 0x581D,
                0x9AC5: 0x5872,
                0x9AC6: 0x5821,
                0x9AC7: 0x5862,
                0x9AC8: 0x584B,
                0x9AC9: 0x5870,
                0x9ACA: 0x6BC0,
                0x9ACB: 0x5852,
                0x9ACC: 0x583D,
                0x9ACD: 0x5879,
                0x9ACE: 0x5885,
                0x9ACF: 0x58B9,
                0x9AD0: 0x589F,
                0x9AD1: 0x58AB,
                0x9AD2: 0x58BA,
                0x9AD3: 0x58DE,
                0x9AD4: 0x58BB,
                0x9AD5: 0x58B8,
                0x9AD6: 0x58AE,
                0x9AD7: 0x58C5,
                0x9AD8: 0x58D3,
                0x9AD9: 0x58D1,
                0x9ADA: 0x58D7,
                0x9ADB: 0x58D9,
                0x9ADC: 0x58D8,
                0x9ADD: 0x58E5,
                0x9ADE: 0x58DC,
                0x9ADF: 0x58E4,
                0x9AE0: 0x58DF,
                0x9AE1: 0x58EF,
                0x9AE2: 0x58FA,
                0x9AE3: 0x58F9,
                0x9AE4: 0x58FB,
                0x9AE5: 0x58FC,
                0x9AE6: 0x58FD,
                0x9AE7: 0x5902,
                0x9AE8: 0x590A,
                0x9AE9: 0x5910,
                0x9AEA: 0x591B,
                0x9AEB: 0x68A6,
                0x9AEC: 0x5925,
                0x9AED: 0x592C,
                0x9AEE: 0x592D,
                0x9AEF: 0x5932,
                0x9AF0: 0x5938,
                0x9AF1: 0x593E,
                0x9AF2: 0x7AD2,
                0x9AF3: 0x5955,
                0x9AF4: 0x5950,
                0x9AF5: 0x594E,
                0x9AF6: 0x595A,
                0x9AF7: 0x5958,
                0x9AF8: 0x5962,
                0x9AF9: 0x5960,
                0x9AFA: 0x5967,
                0x9AFB: 0x596C,
                0x9AFC: 0x5969,
                0x9B40: 0x5978,
                0x9B41: 0x5981,
                0x9B42: 0x599D,
                0x9B43: 0x4F5E,
                0x9B44: 0x4FAB,
                0x9B45: 0x59A3,
                0x9B46: 0x59B2,
                0x9B47: 0x59C6,
                0x9B48: 0x59E8,
                0x9B49: 0x59DC,
                0x9B4A: 0x598D,
                0x9B4B: 0x59D9,
                0x9B4C: 0x59DA,
                0x9B4D: 0x5A25,
                0x9B4E: 0x5A1F,
                0x9B4F: 0x5A11,
                0x9B50: 0x5A1C,
                0x9B51: 0x5A09,
                0x9B52: 0x5A1A,
                0x9B53: 0x5A40,
                0x9B54: 0x5A6C,
                0x9B55: 0x5A49,
                0x9B56: 0x5A35,
                0x9B57: 0x5A36,
                0x9B58: 0x5A62,
                0x9B59: 0x5A6A,
                0x9B5A: 0x5A9A,
                0x9B5B: 0x5ABC,
                0x9B5C: 0x5ABE,
                0x9B5D: 0x5ACB,
                0x9B5E: 0x5AC2,
                0x9B5F: 0x5ABD,
                0x9B60: 0x5AE3,
                0x9B61: 0x5AD7,
                0x9B62: 0x5AE6,
                0x9B63: 0x5AE9,
                0x9B64: 0x5AD6,
                0x9B65: 0x5AFA,
                0x9B66: 0x5AFB,
                0x9B67: 0x5B0C,
                0x9B68: 0x5B0B,
                0x9B69: 0x5B16,
                0x9B6A: 0x5B32,
                0x9B6B: 0x5AD0,
                0x9B6C: 0x5B2A,
                0x9B6D: 0x5B36,
                0x9B6E: 0x5B3E,
                0x9B6F: 0x5B43,
                0x9B70: 0x5B45,
                0x9B71: 0x5B40,
                0x9B72: 0x5B51,
                0x9B73: 0x5B55,
                0x9B74: 0x5B5A,
                0x9B75: 0x5B5B,
                0x9B76: 0x5B65,
                0x9B77: 0x5B69,
                0x9B78: 0x5B70,
                0x9B79: 0x5B73,
                0x9B7A: 0x5B75,
                0x9B7B: 0x5B78,
                0x9B7C: 0x6588,
                0x9B7D: 0x5B7A,
                0x9B7E: 0x5B80,
                0x9B80: 0x5B83,
                0x9B81: 0x5BA6,
                0x9B82: 0x5BB8,
                0x9B83: 0x5BC3,
                0x9B84: 0x5BC7,
                0x9B85: 0x5BC9,
                0x9B86: 0x5BD4,
                0x9B87: 0x5BD0,
                0x9B88: 0x5BE4,
                0x9B89: 0x5BE6,
                0x9B8A: 0x5BE2,
                0x9B8B: 0x5BDE,
                0x9B8C: 0x5BE5,
                0x9B8D: 0x5BEB,
                0x9B8E: 0x5BF0,
                0x9B8F: 0x5BF6,
                0x9B90: 0x5BF3,
                0x9B91: 0x5C05,
                0x9B92: 0x5C07,
                0x9B93: 0x5C08,
                0x9B94: 0x5C0D,
                0x9B95: 0x5C13,
                0x9B96: 0x5C20,
                0x9B97: 0x5C22,
                0x9B98: 0x5C28,
                0x9B99: 0x5C38,
                0x9B9A: 0x5C39,
                0x9B9B: 0x5C41,
                0x9B9C: 0x5C46,
                0x9B9D: 0x5C4E,
                0x9B9E: 0x5C53,
                0x9B9F: 0x5C50,
                0x9BA0: 0x5C4F,
                0x9BA1: 0x5B71,
                0x9BA2: 0x5C6C,
                0x9BA3: 0x5C6E,
                0x9BA4: 0x4E62,
                0x9BA5: 0x5C76,
                0x9BA6: 0x5C79,
                0x9BA7: 0x5C8C,
                0x9BA8: 0x5C91,
                0x9BA9: 0x5C94,
                0x9BAA: 0x599B,
                0x9BAB: 0x5CAB,
                0x9BAC: 0x5CBB,
                0x9BAD: 0x5CB6,
                0x9BAE: 0x5CBC,
                0x9BAF: 0x5CB7,
                0x9BB0: 0x5CC5,
                0x9BB1: 0x5CBE,
                0x9BB2: 0x5CC7,
                0x9BB3: 0x5CD9,
                0x9BB4: 0x5CE9,
                0x9BB5: 0x5CFD,
                0x9BB6: 0x5CFA,
                0x9BB7: 0x5CED,
                0x9BB8: 0x5D8C,
                0x9BB9: 0x5CEA,
                0x9BBA: 0x5D0B,
                0x9BBB: 0x5D15,
                0x9BBC: 0x5D17,
                0x9BBD: 0x5D5C,
                0x9BBE: 0x5D1F,
                0x9BBF: 0x5D1B,
                0x9BC0: 0x5D11,
                0x9BC1: 0x5D14,
                0x9BC2: 0x5D22,
                0x9BC3: 0x5D1A,
                0x9BC4: 0x5D19,
                0x9BC5: 0x5D18,
                0x9BC6: 0x5D4C,
                0x9BC7: 0x5D52,
                0x9BC8: 0x5D4E,
                0x9BC9: 0x5D4B,
                0x9BCA: 0x5D6C,
                0x9BCB: 0x5D73,
                0x9BCC: 0x5D76,
                0x9BCD: 0x5D87,
                0x9BCE: 0x5D84,
                0x9BCF: 0x5D82,
                0x9BD0: 0x5DA2,
                0x9BD1: 0x5D9D,
                0x9BD2: 0x5DAC,
                0x9BD3: 0x5DAE,
                0x9BD4: 0x5DBD,
                0x9BD5: 0x5D90,
                0x9BD6: 0x5DB7,
                0x9BD7: 0x5DBC,
                0x9BD8: 0x5DC9,
                0x9BD9: 0x5DCD,
                0x9BDA: 0x5DD3,
                0x9BDB: 0x5DD2,
                0x9BDC: 0x5DD6,
                0x9BDD: 0x5DDB,
                0x9BDE: 0x5DEB,
                0x9BDF: 0x5DF2,
                0x9BE0: 0x5DF5,
                0x9BE1: 0x5E0B,
                0x9BE2: 0x5E1A,
                0x9BE3: 0x5E19,
                0x9BE4: 0x5E11,
                0x9BE5: 0x5E1B,
                0x9BE6: 0x5E36,
                0x9BE7: 0x5E37,
                0x9BE8: 0x5E44,
                0x9BE9: 0x5E43,
                0x9BEA: 0x5E40,
                0x9BEB: 0x5E4E,
                0x9BEC: 0x5E57,
                0x9BED: 0x5E54,
                0x9BEE: 0x5E5F,
                0x9BEF: 0x5E62,
                0x9BF0: 0x5E64,
                0x9BF1: 0x5E47,
                0x9BF2: 0x5E75,
                0x9BF3: 0x5E76,
                0x9BF4: 0x5E7A,
                0x9BF5: 0x9EBC,
                0x9BF6: 0x5E7F,
                0x9BF7: 0x5EA0,
                0x9BF8: 0x5EC1,
                0x9BF9: 0x5EC2,
                0x9BFA: 0x5EC8,
                0x9BFB: 0x5ED0,
                0x9BFC: 0x5ECF,
                0x9C40: 0x5ED6,
                0x9C41: 0x5EE3,
                0x9C42: 0x5EDD,
                0x9C43: 0x5EDA,
                0x9C44: 0x5EDB,
                0x9C45: 0x5EE2,
                0x9C46: 0x5EE1,
                0x9C47: 0x5EE8,
                0x9C48: 0x5EE9,
                0x9C49: 0x5EEC,
                0x9C4A: 0x5EF1,
                0x9C4B: 0x5EF3,
                0x9C4C: 0x5EF0,
                0x9C4D: 0x5EF4,
                0x9C4E: 0x5EF8,
                0x9C4F: 0x5EFE,
                0x9C50: 0x5F03,
                0x9C51: 0x5F09,
                0x9C52: 0x5F5D,
                0x9C53: 0x5F5C,
                0x9C54: 0x5F0B,
                0x9C55: 0x5F11,
                0x9C56: 0x5F16,
                0x9C57: 0x5F29,
                0x9C58: 0x5F2D,
                0x9C59: 0x5F38,
                0x9C5A: 0x5F41,
                0x9C5B: 0x5F48,
                0x9C5C: 0x5F4C,
                0x9C5D: 0x5F4E,
                0x9C5E: 0x5F2F,
                0x9C5F: 0x5F51,
                0x9C60: 0x5F56,
                0x9C61: 0x5F57,
                0x9C62: 0x5F59,
                0x9C63: 0x5F61,
                0x9C64: 0x5F6D,
                0x9C65: 0x5F73,
                0x9C66: 0x5F77,
                0x9C67: 0x5F83,
                0x9C68: 0x5F82,
                0x9C69: 0x5F7F,
                0x9C6A: 0x5F8A,
                0x9C6B: 0x5F88,
                0x9C6C: 0x5F91,
                0x9C6D: 0x5F87,
                0x9C6E: 0x5F9E,
                0x9C6F: 0x5F99,
                0x9C70: 0x5F98,
                0x9C71: 0x5FA0,
                0x9C72: 0x5FA8,
                0x9C73: 0x5FAD,
                0x9C74: 0x5FBC,
                0x9C75: 0x5FD6,
                0x9C76: 0x5FFB,
                0x9C77: 0x5FE4,
                0x9C78: 0x5FF8,
                0x9C79: 0x5FF1,
                0x9C7A: 0x5FDD,
                0x9C7B: 0x60B3,
                0x9C7C: 0x5FFF,
                0x9C7D: 0x6021,
                0x9C7E: 0x6060,
                0x9C80: 0x6019,
                0x9C81: 0x6010,
                0x9C82: 0x6029,
                0x9C83: 0x600E,
                0x9C84: 0x6031,
                0x9C85: 0x601B,
                0x9C86: 0x6015,
                0x9C87: 0x602B,
                0x9C88: 0x6026,
                0x9C89: 0x600F,
                0x9C8A: 0x603A,
                0x9C8B: 0x605A,
                0x9C8C: 0x6041,
                0x9C8D: 0x606A,
                0x9C8E: 0x6077,
                0x9C8F: 0x605F,
                0x9C90: 0x604A,
                0x9C91: 0x6046,
                0x9C92: 0x604D,
                0x9C93: 0x6063,
                0x9C94: 0x6043,
                0x9C95: 0x6064,
                0x9C96: 0x6042,
                0x9C97: 0x606C,
                0x9C98: 0x606B,
                0x9C99: 0x6059,
                0x9C9A: 0x6081,
                0x9C9B: 0x608D,
                0x9C9C: 0x60E7,
                0x9C9D: 0x6083,
                0x9C9E: 0x609A,
                0x9C9F: 0x6084,
                0x9CA0: 0x609B,
                0x9CA1: 0x6096,
                0x9CA2: 0x6097,
                0x9CA3: 0x6092,
                0x9CA4: 0x60A7,
                0x9CA5: 0x608B,
                0x9CA6: 0x60E1,
                0x9CA7: 0x60B8,
                0x9CA8: 0x60E0,
                0x9CA9: 0x60D3,
                0x9CAA: 0x60B4,
                0x9CAB: 0x5FF0,
                0x9CAC: 0x60BD,
                0x9CAD: 0x60C6,
                0x9CAE: 0x60B5,
                0x9CAF: 0x60D8,
                0x9CB0: 0x614D,
                0x9CB1: 0x6115,
                0x9CB2: 0x6106,
                0x9CB3: 0x60F6,
                0x9CB4: 0x60F7,
                0x9CB5: 0x6100,
                0x9CB6: 0x60F4,
                0x9CB7: 0x60FA,
                0x9CB8: 0x6103,
                0x9CB9: 0x6121,
                0x9CBA: 0x60FB,
                0x9CBB: 0x60F1,
                0x9CBC: 0x610D,
                0x9CBD: 0x610E,
                0x9CBE: 0x6147,
                0x9CBF: 0x613E,
                0x9CC0: 0x6128,
                0x9CC1: 0x6127,
                0x9CC2: 0x614A,
                0x9CC3: 0x613F,
                0x9CC4: 0x613C,
                0x9CC5: 0x612C,
                0x9CC6: 0x6134,
                0x9CC7: 0x613D,
                0x9CC8: 0x6142,
                0x9CC9: 0x6144,
                0x9CCA: 0x6173,
                0x9CCB: 0x6177,
                0x9CCC: 0x6158,
                0x9CCD: 0x6159,
                0x9CCE: 0x615A,
                0x9CCF: 0x616B,
                0x9CD0: 0x6174,
                0x9CD1: 0x616F,
                0x9CD2: 0x6165,
                0x9CD3: 0x6171,
                0x9CD4: 0x615F,
                0x9CD5: 0x615D,
                0x9CD6: 0x6153,
                0x9CD7: 0x6175,
                0x9CD8: 0x6199,
                0x9CD9: 0x6196,
                0x9CDA: 0x6187,
                0x9CDB: 0x61AC,
                0x9CDC: 0x6194,
                0x9CDD: 0x619A,
                0x9CDE: 0x618A,
                0x9CDF: 0x6191,
                0x9CE0: 0x61AB,
                0x9CE1: 0x61AE,
                0x9CE2: 0x61CC,
                0x9CE3: 0x61CA,
                0x9CE4: 0x61C9,
                0x9CE5: 0x61F7,
                0x9CE6: 0x61C8,
                0x9CE7: 0x61C3,
                0x9CE8: 0x61C6,
                0x9CE9: 0x61BA,
                0x9CEA: 0x61CB,
                0x9CEB: 0x7F79,
                0x9CEC: 0x61CD,
                0x9CED: 0x61E6,
                0x9CEE: 0x61E3,
                0x9CEF: 0x61F6,
                0x9CF0: 0x61FA,
                0x9CF1: 0x61F4,
                0x9CF2: 0x61FF,
                0x9CF3: 0x61FD,
                0x9CF4: 0x61FC,
                0x9CF5: 0x61FE,
                0x9CF6: 0x6200,
                0x9CF7: 0x6208,
                0x9CF8: 0x6209,
                0x9CF9: 0x620D,
                0x9CFA: 0x620C,
                0x9CFB: 0x6214,
                0x9CFC: 0x621B,
                0x9D40: 0x621E,
                0x9D41: 0x6221,
                0x9D42: 0x622A,
                0x9D43: 0x622E,
                0x9D44: 0x6230,
                0x9D45: 0x6232,
                0x9D46: 0x6233,
                0x9D47: 0x6241,
                0x9D48: 0x624E,
                0x9D49: 0x625E,
                0x9D4A: 0x6263,
                0x9D4B: 0x625B,
                0x9D4C: 0x6260,
                0x9D4D: 0x6268,
                0x9D4E: 0x627C,
                0x9D4F: 0x6282,
                0x9D50: 0x6289,
                0x9D51: 0x627E,
                0x9D52: 0x6292,
                0x9D53: 0x6293,
                0x9D54: 0x6296,
                0x9D55: 0x62D4,
                0x9D56: 0x6283,
                0x9D57: 0x6294,
                0x9D58: 0x62D7,
                0x9D59: 0x62D1,
                0x9D5A: 0x62BB,
                0x9D5B: 0x62CF,
                0x9D5C: 0x62FF,
                0x9D5D: 0x62C6,
                0x9D5E: 0x64D4,
                0x9D5F: 0x62C8,
                0x9D60: 0x62DC,
                0x9D61: 0x62CC,
                0x9D62: 0x62CA,
                0x9D63: 0x62C2,
                0x9D64: 0x62C7,
                0x9D65: 0x629B,
                0x9D66: 0x62C9,
                0x9D67: 0x630C,
                0x9D68: 0x62EE,
                0x9D69: 0x62F1,
                0x9D6A: 0x6327,
                0x9D6B: 0x6302,
                0x9D6C: 0x6308,
                0x9D6D: 0x62EF,
                0x9D6E: 0x62F5,
                0x9D6F: 0x6350,
                0x9D70: 0x633E,
                0x9D71: 0x634D,
                0x9D72: 0x641C,
                0x9D73: 0x634F,
                0x9D74: 0x6396,
                0x9D75: 0x638E,
                0x9D76: 0x6380,
                0x9D77: 0x63AB,
                0x9D78: 0x6376,
                0x9D79: 0x63A3,
                0x9D7A: 0x638F,
                0x9D7B: 0x6389,
                0x9D7C: 0x639F,
                0x9D7D: 0x63B5,
                0x9D7E: 0x636B,
                0x9D80: 0x6369,
                0x9D81: 0x63BE,
                0x9D82: 0x63E9,
                0x9D83: 0x63C0,
                0x9D84: 0x63C6,
                0x9D85: 0x63E3,
                0x9D86: 0x63C9,
                0x9D87: 0x63D2,
                0x9D88: 0x63F6,
                0x9D89: 0x63C4,
                0x9D8A: 0x6416,
                0x9D8B: 0x6434,
                0x9D8C: 0x6406,
                0x9D8D: 0x6413,
                0x9D8E: 0x6426,
                0x9D8F: 0x6436,
                0x9D90: 0x651D,
                0x9D91: 0x6417,
                0x9D92: 0x6428,
                0x9D93: 0x640F,
                0x9D94: 0x6467,
                0x9D95: 0x646F,
                0x9D96: 0x6476,
                0x9D97: 0x644E,
                0x9D98: 0x652A,
                0x9D99: 0x6495,
                0x9D9A: 0x6493,
                0x9D9B: 0x64A5,
                0x9D9C: 0x64A9,
                0x9D9D: 0x6488,
                0x9D9E: 0x64BC,
                0x9D9F: 0x64DA,
                0x9DA0: 0x64D2,
                0x9DA1: 0x64C5,
                0x9DA2: 0x64C7,
                0x9DA3: 0x64BB,
                0x9DA4: 0x64D8,
                0x9DA5: 0x64C2,
                0x9DA6: 0x64F1,
                0x9DA7: 0x64E7,
                0x9DA8: 0x8209,
                0x9DA9: 0x64E0,
                0x9DAA: 0x64E1,
                0x9DAB: 0x62AC,
                0x9DAC: 0x64E3,
                0x9DAD: 0x64EF,
                0x9DAE: 0x652C,
                0x9DAF: 0x64F6,
                0x9DB0: 0x64F4,
                0x9DB1: 0x64F2,
                0x9DB2: 0x64FA,
                0x9DB3: 0x6500,
                0x9DB4: 0x64FD,
                0x9DB5: 0x6518,
                0x9DB6: 0x651C,
                0x9DB7: 0x6505,
                0x9DB8: 0x6524,
                0x9DB9: 0x6523,
                0x9DBA: 0x652B,
                0x9DBB: 0x6534,
                0x9DBC: 0x6535,
                0x9DBD: 0x6537,
                0x9DBE: 0x6536,
                0x9DBF: 0x6538,
                0x9DC0: 0x754B,
                0x9DC1: 0x6548,
                0x9DC2: 0x6556,
                0x9DC3: 0x6555,
                0x9DC4: 0x654D,
                0x9DC5: 0x6558,
                0x9DC6: 0x655E,
                0x9DC7: 0x655D,
                0x9DC8: 0x6572,
                0x9DC9: 0x6578,
                0x9DCA: 0x6582,
                0x9DCB: 0x6583,
                0x9DCC: 0x8B8A,
                0x9DCD: 0x659B,
                0x9DCE: 0x659F,
                0x9DCF: 0x65AB,
                0x9DD0: 0x65B7,
                0x9DD1: 0x65C3,
                0x9DD2: 0x65C6,
                0x9DD3: 0x65C1,
                0x9DD4: 0x65C4,
                0x9DD5: 0x65CC,
                0x9DD6: 0x65D2,
                0x9DD7: 0x65DB,
                0x9DD8: 0x65D9,
                0x9DD9: 0x65E0,
                0x9DDA: 0x65E1,
                0x9DDB: 0x65F1,
                0x9DDC: 0x6772,
                0x9DDD: 0x660A,
                0x9DDE: 0x6603,
                0x9DDF: 0x65FB,
                0x9DE0: 0x6773,
                0x9DE1: 0x6635,
                0x9DE2: 0x6636,
                0x9DE3: 0x6634,
                0x9DE4: 0x661C,
                0x9DE5: 0x664F,
                0x9DE6: 0x6644,
                0x9DE7: 0x6649,
                0x9DE8: 0x6641,
                0x9DE9: 0x665E,
                0x9DEA: 0x665D,
                0x9DEB: 0x6664,
                0x9DEC: 0x6667,
                0x9DED: 0x6668,
                0x9DEE: 0x665F,
                0x9DEF: 0x6662,
                0x9DF0: 0x6670,
                0x9DF1: 0x6683,
                0x9DF2: 0x6688,
                0x9DF3: 0x668E,
                0x9DF4: 0x6689,
                0x9DF5: 0x6684,
                0x9DF6: 0x6698,
                0x9DF7: 0x669D,
                0x9DF8: 0x66C1,
                0x9DF9: 0x66B9,
                0x9DFA: 0x66C9,
                0x9DFB: 0x66BE,
                0x9DFC: 0x66BC,
                0x9E40: 0x66C4,
                0x9E41: 0x66B8,
                0x9E42: 0x66D6,
                0x9E43: 0x66DA,
                0x9E44: 0x66E0,
                0x9E45: 0x663F,
                0x9E46: 0x66E6,
                0x9E47: 0x66E9,
                0x9E48: 0x66F0,
                0x9E49: 0x66F5,
                0x9E4A: 0x66F7,
                0x9E4B: 0x670F,
                0x9E4C: 0x6716,
                0x9E4D: 0x671E,
                0x9E4E: 0x6726,
                0x9E4F: 0x6727,
                0x9E50: 0x9738,
                0x9E51: 0x672E,
                0x9E52: 0x673F,
                0x9E53: 0x6736,
                0x9E54: 0x6741,
                0x9E55: 0x6738,
                0x9E56: 0x6737,
                0x9E57: 0x6746,
                0x9E58: 0x675E,
                0x9E59: 0x6760,
                0x9E5A: 0x6759,
                0x9E5B: 0x6763,
                0x9E5C: 0x6764,
                0x9E5D: 0x6789,
                0x9E5E: 0x6770,
                0x9E5F: 0x67A9,
                0x9E60: 0x677C,
                0x9E61: 0x676A,
                0x9E62: 0x678C,
                0x9E63: 0x678B,
                0x9E64: 0x67A6,
                0x9E65: 0x67A1,
                0x9E66: 0x6785,
                0x9E67: 0x67B7,
                0x9E68: 0x67EF,
                0x9E69: 0x67B4,
                0x9E6A: 0x67EC,
                0x9E6B: 0x67B3,
                0x9E6C: 0x67E9,
                0x9E6D: 0x67B8,
                0x9E6E: 0x67E4,
                0x9E6F: 0x67DE,
                0x9E70: 0x67DD,
                0x9E71: 0x67E2,
                0x9E72: 0x67EE,
                0x9E73: 0x67B9,
                0x9E74: 0x67CE,
                0x9E75: 0x67C6,
                0x9E76: 0x67E7,
                0x9E77: 0x6A9C,
                0x9E78: 0x681E,
                0x9E79: 0x6846,
                0x9E7A: 0x6829,
                0x9E7B: 0x6840,
                0x9E7C: 0x684D,
                0x9E7D: 0x6832,
                0x9E7E: 0x684E,
                0x9E80: 0x68B3,
                0x9E81: 0x682B,
                0x9E82: 0x6859,
                0x9E83: 0x6863,
                0x9E84: 0x6877,
                0x9E85: 0x687F,
                0x9E86: 0x689F,
                0x9E87: 0x688F,
                0x9E88: 0x68AD,
                0x9E89: 0x6894,
                0x9E8A: 0x689D,
                0x9E8B: 0x689B,
                0x9E8C: 0x6883,
                0x9E8D: 0x6AAE,
                0x9E8E: 0x68B9,
                0x9E8F: 0x6874,
                0x9E90: 0x68B5,
                0x9E91: 0x68A0,
                0x9E92: 0x68BA,
                0x9E93: 0x690F,
                0x9E94: 0x688D,
                0x9E95: 0x687E,
                0x9E96: 0x6901,
                0x9E97: 0x68CA,
                0x9E98: 0x6908,
                0x9E99: 0x68D8,
                0x9E9A: 0x6922,
                0x9E9B: 0x6926,
                0x9E9C: 0x68E1,
                0x9E9D: 0x690C,
                0x9E9E: 0x68CD,
                0x9E9F: 0x68D4,
                0x9EA0: 0x68E7,
                0x9EA1: 0x68D5,
                0x9EA2: 0x6936,
                0x9EA3: 0x6912,
                0x9EA4: 0x6904,
                0x9EA5: 0x68D7,
                0x9EA6: 0x68E3,
                0x9EA7: 0x6925,
                0x9EA8: 0x68F9,
                0x9EA9: 0x68E0,
                0x9EAA: 0x68EF,
                0x9EAB: 0x6928,
                0x9EAC: 0x692A,
                0x9EAD: 0x691A,
                0x9EAE: 0x6923,
                0x9EAF: 0x6921,
                0x9EB0: 0x68C6,
                0x9EB1: 0x6979,
                0x9EB2: 0x6977,
                0x9EB3: 0x695C,
                0x9EB4: 0x6978,
                0x9EB5: 0x696B,
                0x9EB6: 0x6954,
                0x9EB7: 0x697E,
                0x9EB8: 0x696E,
                0x9EB9: 0x6939,
                0x9EBA: 0x6974,
                0x9EBB: 0x693D,
                0x9EBC: 0x6959,
                0x9EBD: 0x6930,
                0x9EBE: 0x6961,
                0x9EBF: 0x695E,
                0x9EC0: 0x695D,
                0x9EC1: 0x6981,
                0x9EC2: 0x696A,
                0x9EC3: 0x69B2,
                0x9EC4: 0x69AE,
                0x9EC5: 0x69D0,
                0x9EC6: 0x69BF,
                0x9EC7: 0x69C1,
                0x9EC8: 0x69D3,
                0x9EC9: 0x69BE,
                0x9ECA: 0x69CE,
                0x9ECB: 0x5BE8,
                0x9ECC: 0x69CA,
                0x9ECD: 0x69DD,
                0x9ECE: 0x69BB,
                0x9ECF: 0x69C3,
                0x9ED0: 0x69A7,
                0x9ED1: 0x6A2E,
                0x9ED2: 0x6991,
                0x9ED3: 0x69A0,
                0x9ED4: 0x699C,
                0x9ED5: 0x6995,
                0x9ED6: 0x69B4,
                0x9ED7: 0x69DE,
                0x9ED8: 0x69E8,
                0x9ED9: 0x6A02,
                0x9EDA: 0x6A1B,
                0x9EDB: 0x69FF,
                0x9EDC: 0x6B0A,
                0x9EDD: 0x69F9,
                0x9EDE: 0x69F2,
                0x9EDF: 0x69E7,
                0x9EE0: 0x6A05,
                0x9EE1: 0x69B1,
                0x9EE2: 0x6A1E,
                0x9EE3: 0x69ED,
                0x9EE4: 0x6A14,
                0x9EE5: 0x69EB,
                0x9EE6: 0x6A0A,
                0x9EE7: 0x6A12,
                0x9EE8: 0x6AC1,
                0x9EE9: 0x6A23,
                0x9EEA: 0x6A13,
                0x9EEB: 0x6A44,
                0x9EEC: 0x6A0C,
                0x9EED: 0x6A72,
                0x9EEE: 0x6A36,
                0x9EEF: 0x6A78,
                0x9EF0: 0x6A47,
                0x9EF1: 0x6A62,
                0x9EF2: 0x6A59,
                0x9EF3: 0x6A66,
                0x9EF4: 0x6A48,
                0x9EF5: 0x6A38,
                0x9EF6: 0x6A22,
                0x9EF7: 0x6A90,
                0x9EF8: 0x6A8D,
                0x9EF9: 0x6AA0,
                0x9EFA: 0x6A84,
                0x9EFB: 0x6AA2,
                0x9EFC: 0x6AA3,
                0x9F40: 0x6A97,
                0x9F41: 0x8617,
                0x9F42: 0x6ABB,
                0x9F43: 0x6AC3,
                0x9F44: 0x6AC2,
                0x9F45: 0x6AB8,
                0x9F46: 0x6AB3,
                0x9F47: 0x6AAC,
                0x9F48: 0x6ADE,
                0x9F49: 0x6AD1,
                0x9F4A: 0x6ADF,
                0x9F4B: 0x6AAA,
                0x9F4C: 0x6ADA,
                0x9F4D: 0x6AEA,
                0x9F4E: 0x6AFB,
                0x9F4F: 0x6B05,
                0x9F50: 0x8616,
                0x9F51: 0x6AFA,
                0x9F52: 0x6B12,
                0x9F53: 0x6B16,
                0x9F54: 0x9B31,
                0x9F55: 0x6B1F,
                0x9F56: 0x6B38,
                0x9F57: 0x6B37,
                0x9F58: 0x76DC,
                0x9F59: 0x6B39,
                0x9F5A: 0x98EE,
                0x9F5B: 0x6B47,
                0x9F5C: 0x6B43,
                0x9F5D: 0x6B49,
                0x9F5E: 0x6B50,
                0x9F5F: 0x6B59,
                0x9F60: 0x6B54,
                0x9F61: 0x6B5B,
                0x9F62: 0x6B5F,
                0x9F63: 0x6B61,
                0x9F64: 0x6B78,
                0x9F65: 0x6B79,
                0x9F66: 0x6B7F,
                0x9F67: 0x6B80,
                0x9F68: 0x6B84,
                0x9F69: 0x6B83,
                0x9F6A: 0x6B8D,
                0x9F6B: 0x6B98,
                0x9F6C: 0x6B95,
                0x9F6D: 0x6B9E,
                0x9F6E: 0x6BA4,
                0x9F6F: 0x6BAA,
                0x9F70: 0x6BAB,
                0x9F71: 0x6BAF,
                0x9F72: 0x6BB2,
                0x9F73: 0x6BB1,
                0x9F74: 0x6BB3,
                0x9F75: 0x6BB7,
                0x9F76: 0x6BBC,
                0x9F77: 0x6BC6,
                0x9F78: 0x6BCB,
                0x9F79: 0x6BD3,
                0x9F7A: 0x6BDF,
                0x9F7B: 0x6BEC,
                0x9F7C: 0x6BEB,
                0x9F7D: 0x6BF3,
                0x9F7E: 0x6BEF,
                0x9F80: 0x9EBE,
                0x9F81: 0x6C08,
                0x9F82: 0x6C13,
                0x9F83: 0x6C14,
                0x9F84: 0x6C1B,
                0x9F85: 0x6C24,
                0x9F86: 0x6C23,
                0x9F87: 0x6C5E,
                0x9F88: 0x6C55,
                0x9F89: 0x6C62,
                0x9F8A: 0x6C6A,
                0x9F8B: 0x6C82,
                0x9F8C: 0x6C8D,
                0x9F8D: 0x6C9A,
                0x9F8E: 0x6C81,
                0x9F8F: 0x6C9B,
                0x9F90: 0x6C7E,
                0x9F91: 0x6C68,
                0x9F92: 0x6C73,
                0x9F93: 0x6C92,
                0x9F94: 0x6C90,
                0x9F95: 0x6CC4,
                0x9F96: 0x6CF1,
                0x9F97: 0x6CD3,
                0x9F98: 0x6CBD,
                0x9F99: 0x6CD7,
                0x9F9A: 0x6CC5,
                0x9F9B: 0x6CDD,
                0x9F9C: 0x6CAE,
                0x9F9D: 0x6CB1,
                0x9F9E: 0x6CBE,
                0x9F9F: 0x6CBA,
                0x9FA0: 0x6CDB,
                0x9FA1: 0x6CEF,
                0x9FA2: 0x6CD9,
                0x9FA3: 0x6CEA,
                0x9FA4: 0x6D1F,
                0x9FA5: 0x884D,
                0x9FA6: 0x6D36,
                0x9FA7: 0x6D2B,
                0x9FA8: 0x6D3D,
                0x9FA9: 0x6D38,
                0x9FAA: 0x6D19,
                0x9FAB: 0x6D35,
                0x9FAC: 0x6D33,
                0x9FAD: 0x6D12,
                0x9FAE: 0x6D0C,
                0x9FAF: 0x6D63,
                0x9FB0: 0x6D93,
                0x9FB1: 0x6D64,
                0x9FB2: 0x6D5A,
                0x9FB3: 0x6D79,
                0x9FB4: 0x6D59,
                0x9FB5: 0x6D8E,
                0x9FB6: 0x6D95,
                0x9FB7: 0x6FE4,
                0x9FB8: 0x6D85,
                0x9FB9: 0x6DF9,
                0x9FBA: 0x6E15,
                0x9FBB: 0x6E0A,
                0x9FBC: 0x6DB5,
                0x9FBD: 0x6DC7,
                0x9FBE: 0x6DE6,
                0x9FBF: 0x6DB8,
                0x9FC0: 0x6DC6,
                0x9FC1: 0x6DEC,
                0x9FC2: 0x6DDE,
                0x9FC3: 0x6DCC,
                0x9FC4: 0x6DE8,
                0x9FC5: 0x6DD2,
                0x9FC6: 0x6DC5,
                0x9FC7: 0x6DFA,
                0x9FC8: 0x6DD9,
                0x9FC9: 0x6DE4,
                0x9FCA: 0x6DD5,
                0x9FCB: 0x6DEA,
                0x9FCC: 0x6DEE,
                0x9FCD: 0x6E2D,
                0x9FCE: 0x6E6E,
                0x9FCF: 0x6E2E,
                0x9FD0: 0x6E19,
                0x9FD1: 0x6E72,
                0x9FD2: 0x6E5F,
                0x9FD3: 0x6E3E,
                0x9FD4: 0x6E23,
                0x9FD5: 0x6E6B,
                0x9FD6: 0x6E2B,
                0x9FD7: 0x6E76,
                0x9FD8: 0x6E4D,
                0x9FD9: 0x6E1F,
                0x9FDA: 0x6E43,
                0x9FDB: 0x6E3A,
                0x9FDC: 0x6E4E,
                0x9FDD: 0x6E24,
                0x9FDE: 0x6EFF,
                0x9FDF: 0x6E1D,
                0x9FE0: 0x6E38,
                0x9FE1: 0x6E82,
                0x9FE2: 0x6EAA,
                0x9FE3: 0x6E98,
                0x9FE4: 0x6EC9,
                0x9FE5: 0x6EB7,
                0x9FE6: 0x6ED3,
                0x9FE7: 0x6EBD,
                0x9FE8: 0x6EAF,
                0x9FE9: 0x6EC4,
                0x9FEA: 0x6EB2,
                0x9FEB: 0x6ED4,
                0x9FEC: 0x6ED5,
                0x9FED: 0x6E8F,
                0x9FEE: 0x6EA5,
                0x9FEF: 0x6EC2,
                0x9FF0: 0x6E9F,
                0x9FF1: 0x6F41,
                0x9FF2: 0x6F11,
                0x9FF3: 0x704C,
                0x9FF4: 0x6EEC,
                0x9FF5: 0x6EF8,
                0x9FF6: 0x6EFE,
                0x9FF7: 0x6F3F,
                0x9FF8: 0x6EF2,
                0x9FF9: 0x6F31,
                0x9FFA: 0x6EEF,
                0x9FFB: 0x6F32,
                0x9FFC: 0x6ECC,
                0xA1: 0xFF61,
                0xA2: 0xFF62,
                0xA3: 0xFF63,
                0xA4: 0xFF64,
                0xA5: 0xFF65,
                0xA6: 0xFF66,
                0xA7: 0xFF67,
                0xA8: 0xFF68,
                0xA9: 0xFF69,
                0xAA: 0xFF6A,
                0xAB: 0xFF6B,
                0xAC: 0xFF6C,
                0xAD: 0xFF6D,
                0xAE: 0xFF6E,
                0xAF: 0xFF6F,
                0xB0: 0xFF70,
                0xB1: 0xFF71,
                0xB2: 0xFF72,
                0xB3: 0xFF73,
                0xB4: 0xFF74,
                0xB5: 0xFF75,
                0xB6: 0xFF76,
                0xB7: 0xFF77,
                0xB8: 0xFF78,
                0xB9: 0xFF79,
                0xBA: 0xFF7A,
                0xBB: 0xFF7B,
                0xBC: 0xFF7C,
                0xBD: 0xFF7D,
                0xBE: 0xFF7E,
                0xBF: 0xFF7F,
                0xC0: 0xFF80,
                0xC1: 0xFF81,
                0xC2: 0xFF82,
                0xC3: 0xFF83,
                0xC4: 0xFF84,
                0xC5: 0xFF85,
                0xC6: 0xFF86,
                0xC7: 0xFF87,
                0xC8: 0xFF88,
                0xC9: 0xFF89,
                0xCA: 0xFF8A,
                0xCB: 0xFF8B,
                0xCC: 0xFF8C,
                0xCD: 0xFF8D,
                0xCE: 0xFF8E,
                0xCF: 0xFF8F,
                0xD0: 0xFF90,
                0xD1: 0xFF91,
                0xD2: 0xFF92,
                0xD3: 0xFF93,
                0xD4: 0xFF94,
                0xD5: 0xFF95,
                0xD6: 0xFF96,
                0xD7: 0xFF97,
                0xD8: 0xFF98,
                0xD9: 0xFF99,
                0xDA: 0xFF9A,
                0xDB: 0xFF9B,
                0xDC: 0xFF9C,
                0xDD: 0xFF9D,
                0xDE: 0xFF9E,
                0xDF: 0xFF9F,
                0xE040: 0x6F3E,
                0xE041: 0x6F13,
                0xE042: 0x6EF7,
                0xE043: 0x6F86,
                0xE044: 0x6F7A,
                0xE045: 0x6F78,
                0xE046: 0x6F81,
                0xE047: 0x6F80,
                0xE048: 0x6F6F,
                0xE049: 0x6F5B,
                0xE04A: 0x6FF3,
                0xE04B: 0x6F6D,
                0xE04C: 0x6F82,
                0xE04D: 0x6F7C,
                0xE04E: 0x6F58,
                0xE04F: 0x6F8E,
                0xE050: 0x6F91,
                0xE051: 0x6FC2,
                0xE052: 0x6F66,
                0xE053: 0x6FB3,
                0xE054: 0x6FA3,
                0xE055: 0x6FA1,
                0xE056: 0x6FA4,
                0xE057: 0x6FB9,
                0xE058: 0x6FC6,
                0xE059: 0x6FAA,
                0xE05A: 0x6FDF,
                0xE05B: 0x6FD5,
                0xE05C: 0x6FEC,
                0xE05D: 0x6FD4,
                0xE05E: 0x6FD8,
                0xE05F: 0x6FF1,
                0xE060: 0x6FEE,
                0xE061: 0x6FDB,
                0xE062: 0x7009,
                0xE063: 0x700B,
                0xE064: 0x6FFA,
                0xE065: 0x7011,
                0xE066: 0x7001,
                0xE067: 0x700F,
                0xE068: 0x6FFE,
                0xE069: 0x701B,
                0xE06A: 0x701A,
                0xE06B: 0x6F74,
                0xE06C: 0x701D,
                0xE06D: 0x7018,
                0xE06E: 0x701F,
                0xE06F: 0x7030,
                0xE070: 0x703E,
                0xE071: 0x7032,
                0xE072: 0x7051,
                0xE073: 0x7063,
                0xE074: 0x7099,
                0xE075: 0x7092,
                0xE076: 0x70AF,
                0xE077: 0x70F1,
                0xE078: 0x70AC,
                0xE079: 0x70B8,
                0xE07A: 0x70B3,
                0xE07B: 0x70AE,
                0xE07C: 0x70DF,
                0xE07D: 0x70CB,
                0xE07E: 0x70DD,
                0xE080: 0x70D9,
                0xE081: 0x7109,
                0xE082: 0x70FD,
                0xE083: 0x711C,
                0xE084: 0x7119,
                0xE085: 0x7165,
                0xE086: 0x7155,
                0xE087: 0x7188,
                0xE088: 0x7166,
                0xE089: 0x7162,
                0xE08A: 0x714C,
                0xE08B: 0x7156,
                0xE08C: 0x716C,
                0xE08D: 0x718F,
                0xE08E: 0x71FB,
                0xE08F: 0x7184,
                0xE090: 0x7195,
                0xE091: 0x71A8,
                0xE092: 0x71AC,
                0xE093: 0x71D7,
                0xE094: 0x71B9,
                0xE095: 0x71BE,
                0xE096: 0x71D2,
                0xE097: 0x71C9,
                0xE098: 0x71D4,
                0xE099: 0x71CE,
                0xE09A: 0x71E0,
                0xE09B: 0x71EC,
                0xE09C: 0x71E7,
                0xE09D: 0x71F5,
                0xE09E: 0x71FC,
                0xE09F: 0x71F9,
                0xE0A0: 0x71FF,
                0xE0A1: 0x720D,
                0xE0A2: 0x7210,
                0xE0A3: 0x721B,
                0xE0A4: 0x7228,
                0xE0A5: 0x722D,
                0xE0A6: 0x722C,
                0xE0A7: 0x7230,
                0xE0A8: 0x7232,
                0xE0A9: 0x723B,
                0xE0AA: 0x723C,
                0xE0AB: 0x723F,
                0xE0AC: 0x7240,
                0xE0AD: 0x7246,
                0xE0AE: 0x724B,
                0xE0AF: 0x7258,
                0xE0B0: 0x7274,
                0xE0B1: 0x727E,
                0xE0B2: 0x7282,
                0xE0B3: 0x7281,
                0xE0B4: 0x7287,
                0xE0B5: 0x7292,
                0xE0B6: 0x7296,
                0xE0B7: 0x72A2,
                0xE0B8: 0x72A7,
                0xE0B9: 0x72B9,
                0xE0BA: 0x72B2,
                0xE0BB: 0x72C3,
                0xE0BC: 0x72C6,
                0xE0BD: 0x72C4,
                0xE0BE: 0x72CE,
                0xE0BF: 0x72D2,
                0xE0C0: 0x72E2,
                0xE0C1: 0x72E0,
                0xE0C2: 0x72E1,
                0xE0C3: 0x72F9,
                0xE0C4: 0x72F7,
                0xE0C5: 0x500F,
                0xE0C6: 0x7317,
                0xE0C7: 0x730A,
                0xE0C8: 0x731C,
                0xE0C9: 0x7316,
                0xE0CA: 0x731D,
                0xE0CB: 0x7334,
                0xE0CC: 0x732F,
                0xE0CD: 0x7329,
                0xE0CE: 0x7325,
                0xE0CF: 0x733E,
                0xE0D0: 0x734E,
                0xE0D1: 0x734F,
                0xE0D2: 0x9ED8,
                0xE0D3: 0x7357,
                0xE0D4: 0x736A,
                0xE0D5: 0x7368,
                0xE0D6: 0x7370,
                0xE0D7: 0x7378,
                0xE0D8: 0x7375,
                0xE0D9: 0x737B,
                0xE0DA: 0x737A,
                0xE0DB: 0x73C8,
                0xE0DC: 0x73B3,
                0xE0DD: 0x73CE,
                0xE0DE: 0x73BB,
                0xE0DF: 0x73C0,
                0xE0E0: 0x73E5,
                0xE0E1: 0x73EE,
                0xE0E2: 0x73DE,
                0xE0E3: 0x74A2,
                0xE0E4: 0x7405,
                0xE0E5: 0x746F,
                0xE0E6: 0x7425,
                0xE0E7: 0x73F8,
                0xE0E8: 0x7432,
                0xE0E9: 0x743A,
                0xE0EA: 0x7455,
                0xE0EB: 0x743F,
                0xE0EC: 0x745F,
                0xE0ED: 0x7459,
                0xE0EE: 0x7441,
                0xE0EF: 0x745C,
                0xE0F0: 0x7469,
                0xE0F1: 0x7470,
                0xE0F2: 0x7463,
                0xE0F3: 0x746A,
                0xE0F4: 0x7476,
                0xE0F5: 0x747E,
                0xE0F6: 0x748B,
                0xE0F7: 0x749E,
                0xE0F8: 0x74A7,
                0xE0F9: 0x74CA,
                0xE0FA: 0x74CF,
                0xE0FB: 0x74D4,
                0xE0FC: 0x73F1,
                0xE140: 0x74E0,
                0xE141: 0x74E3,
                0xE142: 0x74E7,
                0xE143: 0x74E9,
                0xE144: 0x74EE,
                0xE145: 0x74F2,
                0xE146: 0x74F0,
                0xE147: 0x74F1,
                0xE148: 0x74F8,
                0xE149: 0x74F7,
                0xE14A: 0x7504,
                0xE14B: 0x7503,
                0xE14C: 0x7505,
                0xE14D: 0x750C,
                0xE14E: 0x750E,
                0xE14F: 0x750D,
                0xE150: 0x7515,
                0xE151: 0x7513,
                0xE152: 0x751E,
                0xE153: 0x7526,
                0xE154: 0x752C,
                0xE155: 0x753C,
                0xE156: 0x7544,
                0xE157: 0x754D,
                0xE158: 0x754A,
                0xE159: 0x7549,
                0xE15A: 0x755B,
                0xE15B: 0x7546,
                0xE15C: 0x755A,
                0xE15D: 0x7569,
                0xE15E: 0x7564,
                0xE15F: 0x7567,
                0xE160: 0x756B,
                0xE161: 0x756D,
                0xE162: 0x7578,
                0xE163: 0x7576,
                0xE164: 0x7586,
                0xE165: 0x7587,
                0xE166: 0x7574,
                0xE167: 0x758A,
                0xE168: 0x7589,
                0xE169: 0x7582,
                0xE16A: 0x7594,
                0xE16B: 0x759A,
                0xE16C: 0x759D,
                0xE16D: 0x75A5,
                0xE16E: 0x75A3,
                0xE16F: 0x75C2,
                0xE170: 0x75B3,
                0xE171: 0x75C3,
                0xE172: 0x75B5,
                0xE173: 0x75BD,
                0xE174: 0x75B8,
                0xE175: 0x75BC,
                0xE176: 0x75B1,
                0xE177: 0x75CD,
                0xE178: 0x75CA,
                0xE179: 0x75D2,
                0xE17A: 0x75D9,
                0xE17B: 0x75E3,
                0xE17C: 0x75DE,
                0xE17D: 0x75FE,
                0xE17E: 0x75FF,
                0xE180: 0x75FC,
                0xE181: 0x7601,
                0xE182: 0x75F0,
                0xE183: 0x75FA,
                0xE184: 0x75F2,
                0xE185: 0x75F3,
                0xE186: 0x760B,
                0xE187: 0x760D,
                0xE188: 0x7609,
                0xE189: 0x761F,
                0xE18A: 0x7627,
                0xE18B: 0x7620,
                0xE18C: 0x7621,
                0xE18D: 0x7622,
                0xE18E: 0x7624,
                0xE18F: 0x7634,
                0xE190: 0x7630,
                0xE191: 0x763B,
                0xE192: 0x7647,
                0xE193: 0x7648,
                0xE194: 0x7646,
                0xE195: 0x765C,
                0xE196: 0x7658,
                0xE197: 0x7661,
                0xE198: 0x7662,
                0xE199: 0x7668,
                0xE19A: 0x7669,
                0xE19B: 0x766A,
                0xE19C: 0x7667,
                0xE19D: 0x766C,
                0xE19E: 0x7670,
                0xE19F: 0x7672,
                0xE1A0: 0x7676,
                0xE1A1: 0x7678,
                0xE1A2: 0x767C,
                0xE1A3: 0x7680,
                0xE1A4: 0x7683,
                0xE1A5: 0x7688,
                0xE1A6: 0x768B,
                0xE1A7: 0x768E,
                0xE1A8: 0x7696,
                0xE1A9: 0x7693,
                0xE1AA: 0x7699,
                0xE1AB: 0x769A,
                0xE1AC: 0x76B0,
                0xE1AD: 0x76B4,
                0xE1AE: 0x76B8,
                0xE1AF: 0x76B9,
                0xE1B0: 0x76BA,
                0xE1B1: 0x76C2,
                0xE1B2: 0x76CD,
                0xE1B3: 0x76D6,
                0xE1B4: 0x76D2,
                0xE1B5: 0x76DE,
                0xE1B6: 0x76E1,
                0xE1B7: 0x76E5,
                0xE1B8: 0x76E7,
                0xE1B9: 0x76EA,
                0xE1BA: 0x862F,
                0xE1BB: 0x76FB,
                0xE1BC: 0x7708,
                0xE1BD: 0x7707,
                0xE1BE: 0x7704,
                0xE1BF: 0x7729,
                0xE1C0: 0x7724,
                0xE1C1: 0x771E,
                0xE1C2: 0x7725,
                0xE1C3: 0x7726,
                0xE1C4: 0x771B,
                0xE1C5: 0x7737,
                0xE1C6: 0x7738,
                0xE1C7: 0x7747,
                0xE1C8: 0x775A,
                0xE1C9: 0x7768,
                0xE1CA: 0x776B,
                0xE1CB: 0x775B,
                0xE1CC: 0x7765,
                0xE1CD: 0x777F,
                0xE1CE: 0x777E,
                0xE1CF: 0x7779,
                0xE1D0: 0x778E,
                0xE1D1: 0x778B,
                0xE1D2: 0x7791,
                0xE1D3: 0x77A0,
                0xE1D4: 0x779E,
                0xE1D5: 0x77B0,
                0xE1D6: 0x77B6,
                0xE1D7: 0x77B9,
                0xE1D8: 0x77BF,
                0xE1D9: 0x77BC,
                0xE1DA: 0x77BD,
                0xE1DB: 0x77BB,
                0xE1DC: 0x77C7,
                0xE1DD: 0x77CD,
                0xE1DE: 0x77D7,
                0xE1DF: 0x77DA,
                0xE1E0: 0x77DC,
                0xE1E1: 0x77E3,
                0xE1E2: 0x77EE,
                0xE1E3: 0x77FC,
                0xE1E4: 0x780C,
                0xE1E5: 0x7812,
                0xE1E6: 0x7926,
                0xE1E7: 0x7820,
                0xE1E8: 0x792A,
                0xE1E9: 0x7845,
                0xE1EA: 0x788E,
                0xE1EB: 0x7874,
                0xE1EC: 0x7886,
                0xE1ED: 0x787C,
                0xE1EE: 0x789A,
                0xE1EF: 0x788C,
                0xE1F0: 0x78A3,
                0xE1F1: 0x78B5,
                0xE1F2: 0x78AA,
                0xE1F3: 0x78AF,
                0xE1F4: 0x78D1,
                0xE1F5: 0x78C6,
                0xE1F6: 0x78CB,
                0xE1F7: 0x78D4,
                0xE1F8: 0x78BE,
                0xE1F9: 0x78BC,
                0xE1FA: 0x78C5,
                0xE1FB: 0x78CA,
                0xE1FC: 0x78EC,
                0xE240: 0x78E7,
                0xE241: 0x78DA,
                0xE242: 0x78FD,
                0xE243: 0x78F4,
                0xE244: 0x7907,
                0xE245: 0x7912,
                0xE246: 0x7911,
                0xE247: 0x7919,
                0xE248: 0x792C,
                0xE249: 0x792B,
                0xE24A: 0x7940,
                0xE24B: 0x7960,
                0xE24C: 0x7957,
                0xE24D: 0x795F,
                0xE24E: 0x795A,
                0xE24F: 0x7955,
                0xE250: 0x7953,
                0xE251: 0x797A,
                0xE252: 0x797F,
                0xE253: 0x798A,
                0xE254: 0x799D,
                0xE255: 0x79A7,
                0xE256: 0x9F4B,
                0xE257: 0x79AA,
                0xE258: 0x79AE,
                0xE259: 0x79B3,
                0xE25A: 0x79B9,
                0xE25B: 0x79BA,
                0xE25C: 0x79C9,
                0xE25D: 0x79D5,
                0xE25E: 0x79E7,
                0xE25F: 0x79EC,
                0xE260: 0x79E1,
                0xE261: 0x79E3,
                0xE262: 0x7A08,
                0xE263: 0x7A0D,
                0xE264: 0x7A18,
                0xE265: 0x7A19,
                0xE266: 0x7A20,
                0xE267: 0x7A1F,
                0xE268: 0x7980,
                0xE269: 0x7A31,
                0xE26A: 0x7A3B,
                0xE26B: 0x7A3E,
                0xE26C: 0x7A37,
                0xE26D: 0x7A43,
                0xE26E: 0x7A57,
                0xE26F: 0x7A49,
                0xE270: 0x7A61,
                0xE271: 0x7A62,
                0xE272: 0x7A69,
                0xE273: 0x9F9D,
                0xE274: 0x7A70,
                0xE275: 0x7A79,
                0xE276: 0x7A7D,
                0xE277: 0x7A88,
                0xE278: 0x7A97,
                0xE279: 0x7A95,
                0xE27A: 0x7A98,
                0xE27B: 0x7A96,
                0xE27C: 0x7AA9,
                0xE27D: 0x7AC8,
                0xE27E: 0x7AB0,
                0xE280: 0x7AB6,
                0xE281: 0x7AC5,
                0xE282: 0x7AC4,
                0xE283: 0x7ABF,
                0xE284: 0x9083,
                0xE285: 0x7AC7,
                0xE286: 0x7ACA,
                0xE287: 0x7ACD,
                0xE288: 0x7ACF,
                0xE289: 0x7AD5,
                0xE28A: 0x7AD3,
                0xE28B: 0x7AD9,
                0xE28C: 0x7ADA,
                0xE28D: 0x7ADD,
                0xE28E: 0x7AE1,
                0xE28F: 0x7AE2,
                0xE290: 0x7AE6,
                0xE291: 0x7AED,
                0xE292: 0x7AF0,
                0xE293: 0x7B02,
                0xE294: 0x7B0F,
                0xE295: 0x7B0A,
                0xE296: 0x7B06,
                0xE297: 0x7B33,
                0xE298: 0x7B18,
                0xE299: 0x7B19,
                0xE29A: 0x7B1E,
                0xE29B: 0x7B35,
                0xE29C: 0x7B28,
                0xE29D: 0x7B36,
                0xE29E: 0x7B50,
                0xE29F: 0x7B7A,
                0xE2A0: 0x7B04,
                0xE2A1: 0x7B4D,
                0xE2A2: 0x7B0B,
                0xE2A3: 0x7B4C,
                0xE2A4: 0x7B45,
                0xE2A5: 0x7B75,
                0xE2A6: 0x7B65,
                0xE2A7: 0x7B74,
                0xE2A8: 0x7B67,
                0xE2A9: 0x7B70,
                0xE2AA: 0x7B71,
                0xE2AB: 0x7B6C,
                0xE2AC: 0x7B6E,
                0xE2AD: 0x7B9D,
                0xE2AE: 0x7B98,
                0xE2AF: 0x7B9F,
                0xE2B0: 0x7B8D,
                0xE2B1: 0x7B9C,
                0xE2B2: 0x7B9A,
                0xE2B3: 0x7B8B,
                0xE2B4: 0x7B92,
                0xE2B5: 0x7B8F,
                0xE2B6: 0x7B5D,
                0xE2B7: 0x7B99,
                0xE2B8: 0x7BCB,
                0xE2B9: 0x7BC1,
                0xE2BA: 0x7BCC,
                0xE2BB: 0x7BCF,
                0xE2BC: 0x7BB4,
                0xE2BD: 0x7BC6,
                0xE2BE: 0x7BDD,
                0xE2BF: 0x7BE9,
                0xE2C0: 0x7C11,
                0xE2C1: 0x7C14,
                0xE2C2: 0x7BE6,
                0xE2C3: 0x7BE5,
                0xE2C4: 0x7C60,
                0xE2C5: 0x7C00,
                0xE2C6: 0x7C07,
                0xE2C7: 0x7C13,
                0xE2C8: 0x7BF3,
                0xE2C9: 0x7BF7,
                0xE2CA: 0x7C17,
                0xE2CB: 0x7C0D,
                0xE2CC: 0x7BF6,
                0xE2CD: 0x7C23,
                0xE2CE: 0x7C27,
                0xE2CF: 0x7C2A,
                0xE2D0: 0x7C1F,
                0xE2D1: 0x7C37,
                0xE2D2: 0x7C2B,
                0xE2D3: 0x7C3D,
                0xE2D4: 0x7C4C,
                0xE2D5: 0x7C43,
                0xE2D6: 0x7C54,
                0xE2D7: 0x7C4F,
                0xE2D8: 0x7C40,
                0xE2D9: 0x7C50,
                0xE2DA: 0x7C58,
                0xE2DB: 0x7C5F,
                0xE2DC: 0x7C64,
                0xE2DD: 0x7C56,
                0xE2DE: 0x7C65,
                0xE2DF: 0x7C6C,
                0xE2E0: 0x7C75,
                0xE2E1: 0x7C83,
                0xE2E2: 0x7C90,
                0xE2E3: 0x7CA4,
                0xE2E4: 0x7CAD,
                0xE2E5: 0x7CA2,
                0xE2E6: 0x7CAB,
                0xE2E7: 0x7CA1,
                0xE2E8: 0x7CA8,
                0xE2E9: 0x7CB3,
                0xE2EA: 0x7CB2,
                0xE2EB: 0x7CB1,
                0xE2EC: 0x7CAE,
                0xE2ED: 0x7CB9,
                0xE2EE: 0x7CBD,
                0xE2EF: 0x7CC0,
                0xE2F0: 0x7CC5,
                0xE2F1: 0x7CC2,
                0xE2F2: 0x7CD8,
                0xE2F3: 0x7CD2,
                0xE2F4: 0x7CDC,
                0xE2F5: 0x7CE2,
                0xE2F6: 0x9B3B,
                0xE2F7: 0x7CEF,
                0xE2F8: 0x7CF2,
                0xE2F9: 0x7CF4,
                0xE2FA: 0x7CF6,
                0xE2FB: 0x7CFA,
                0xE2FC: 0x7D06,
                0xE340: 0x7D02,
                0xE341: 0x7D1C,
                0xE342: 0x7D15,
                0xE343: 0x7D0A,
                0xE344: 0x7D45,
                0xE345: 0x7D4B,
                0xE346: 0x7D2E,
                0xE347: 0x7D32,
                0xE348: 0x7D3F,
                0xE349: 0x7D35,
                0xE34A: 0x7D46,
                0xE34B: 0x7D73,
                0xE34C: 0x7D56,
                0xE34D: 0x7D4E,
                0xE34E: 0x7D72,
                0xE34F: 0x7D68,
                0xE350: 0x7D6E,
                0xE351: 0x7D4F,
                0xE352: 0x7D63,
                0xE353: 0x7D93,
                0xE354: 0x7D89,
                0xE355: 0x7D5B,
                0xE356: 0x7D8F,
                0xE357: 0x7D7D,
                0xE358: 0x7D9B,
                0xE359: 0x7DBA,
                0xE35A: 0x7DAE,
                0xE35B: 0x7DA3,
                0xE35C: 0x7DB5,
                0xE35D: 0x7DC7,
                0xE35E: 0x7DBD,
                0xE35F: 0x7DAB,
                0xE360: 0x7E3D,
                0xE361: 0x7DA2,
                0xE362: 0x7DAF,
                0xE363: 0x7DDC,
                0xE364: 0x7DB8,
                0xE365: 0x7D9F,
                0xE366: 0x7DB0,
                0xE367: 0x7DD8,
                0xE368: 0x7DDD,
                0xE369: 0x7DE4,
                0xE36A: 0x7DDE,
                0xE36B: 0x7DFB,
                0xE36C: 0x7DF2,
                0xE36D: 0x7DE1,
                0xE36E: 0x7E05,
                0xE36F: 0x7E0A,
                0xE370: 0x7E23,
                0xE371: 0x7E21,
                0xE372: 0x7E12,
                0xE373: 0x7E31,
                0xE374: 0x7E1F,
                0xE375: 0x7E09,
                0xE376: 0x7E0B,
                0xE377: 0x7E22,
                0xE378: 0x7E46,
                0xE379: 0x7E66,
                0xE37A: 0x7E3B,
                0xE37B: 0x7E35,
                0xE37C: 0x7E39,
                0xE37D: 0x7E43,
                0xE37E: 0x7E37,
                0xE380: 0x7E32,
                0xE381: 0x7E3A,
                0xE382: 0x7E67,
                0xE383: 0x7E5D,
                0xE384: 0x7E56,
                0xE385: 0x7E5E,
                0xE386: 0x7E59,
                0xE387: 0x7E5A,
                0xE388: 0x7E79,
                0xE389: 0x7E6A,
                0xE38A: 0x7E69,
                0xE38B: 0x7E7C,
                0xE38C: 0x7E7B,
                0xE38D: 0x7E83,
                0xE38E: 0x7DD5,
                0xE38F: 0x7E7D,
                0xE390: 0x8FAE,
                0xE391: 0x7E7F,
                0xE392: 0x7E88,
                0xE393: 0x7E89,
                0xE394: 0x7E8C,
                0xE395: 0x7E92,
                0xE396: 0x7E90,
                0xE397: 0x7E93,
                0xE398: 0x7E94,
                0xE399: 0x7E96,
                0xE39A: 0x7E8E,
                0xE39B: 0x7E9B,
                0xE39C: 0x7E9C,
                0xE39D: 0x7F38,
                0xE39E: 0x7F3A,
                0xE39F: 0x7F45,
                0xE3A0: 0x7F4C,
                0xE3A1: 0x7F4D,
                0xE3A2: 0x7F4E,
                0xE3A3: 0x7F50,
                0xE3A4: 0x7F51,
                0xE3A5: 0x7F55,
                0xE3A6: 0x7F54,
                0xE3A7: 0x7F58,
                0xE3A8: 0x7F5F,
                0xE3A9: 0x7F60,
                0xE3AA: 0x7F68,
                0xE3AB: 0x7F69,
                0xE3AC: 0x7F67,
                0xE3AD: 0x7F78,
                0xE3AE: 0x7F82,
                0xE3AF: 0x7F86,
                0xE3B0: 0x7F83,
                0xE3B1: 0x7F88,
                0xE3B2: 0x7F87,
                0xE3B3: 0x7F8C,
                0xE3B4: 0x7F94,
                0xE3B5: 0x7F9E,
                0xE3B6: 0x7F9D,
                0xE3B7: 0x7F9A,
                0xE3B8: 0x7FA3,
                0xE3B9: 0x7FAF,
                0xE3BA: 0x7FB2,
                0xE3BB: 0x7FB9,
                0xE3BC: 0x7FAE,
                0xE3BD: 0x7FB6,
                0xE3BE: 0x7FB8,
                0xE3BF: 0x8B71,
                0xE3C0: 0x7FC5,
                0xE3C1: 0x7FC6,
                0xE3C2: 0x7FCA,
                0xE3C3: 0x7FD5,
                0xE3C4: 0x7FD4,
                0xE3C5: 0x7FE1,
                0xE3C6: 0x7FE6,
                0xE3C7: 0x7FE9,
                0xE3C8: 0x7FF3,
                0xE3C9: 0x7FF9,
                0xE3CA: 0x98DC,
                0xE3CB: 0x8006,
                0xE3CC: 0x8004,
                0xE3CD: 0x800B,
                0xE3CE: 0x8012,
                0xE3CF: 0x8018,
                0xE3D0: 0x8019,
                0xE3D1: 0x801C,
                0xE3D2: 0x8021,
                0xE3D3: 0x8028,
                0xE3D4: 0x803F,
                0xE3D5: 0x803B,
                0xE3D6: 0x804A,
                0xE3D7: 0x8046,
                0xE3D8: 0x8052,
                0xE3D9: 0x8058,
                0xE3DA: 0x805A,
                0xE3DB: 0x805F,
                0xE3DC: 0x8062,
                0xE3DD: 0x8068,
                0xE3DE: 0x8073,
                0xE3DF: 0x8072,
                0xE3E0: 0x8070,
                0xE3E1: 0x8076,
                0xE3E2: 0x8079,
                0xE3E3: 0x807D,
                0xE3E4: 0x807F,
                0xE3E5: 0x8084,
                0xE3E6: 0x8086,
                0xE3E7: 0x8085,
                0xE3E8: 0x809B,
                0xE3E9: 0x8093,
                0xE3EA: 0x809A,
                0xE3EB: 0x80AD,
                0xE3EC: 0x5190,
                0xE3ED: 0x80AC,
                0xE3EE: 0x80DB,
                0xE3EF: 0x80E5,
                0xE3F0: 0x80D9,
                0xE3F1: 0x80DD,
                0xE3F2: 0x80C4,
                0xE3F3: 0x80DA,
                0xE3F4: 0x80D6,
                0xE3F5: 0x8109,
                0xE3F6: 0x80EF,
                0xE3F7: 0x80F1,
                0xE3F8: 0x811B,
                0xE3F9: 0x8129,
                0xE3FA: 0x8123,
                0xE3FB: 0x812F,
                0xE3FC: 0x814B,
                0xE440: 0x968B,
                0xE441: 0x8146,
                0xE442: 0x813E,
                0xE443: 0x8153,
                0xE444: 0x8151,
                0xE445: 0x80FC,
                0xE446: 0x8171,
                0xE447: 0x816E,
                0xE448: 0x8165,
                0xE449: 0x8166,
                0xE44A: 0x8174,
                0xE44B: 0x8183,
                0xE44C: 0x8188,
                0xE44D: 0x818A,
                0xE44E: 0x8180,
                0xE44F: 0x8182,
                0xE450: 0x81A0,
                0xE451: 0x8195,
                0xE452: 0x81A4,
                0xE453: 0x81A3,
                0xE454: 0x815F,
                0xE455: 0x8193,
                0xE456: 0x81A9,
                0xE457: 0x81B0,
                0xE458: 0x81B5,
                0xE459: 0x81BE,
                0xE45A: 0x81B8,
                0xE45B: 0x81BD,
                0xE45C: 0x81C0,
                0xE45D: 0x81C2,
                0xE45E: 0x81BA,
                0xE45F: 0x81C9,
                0xE460: 0x81CD,
                0xE461: 0x81D1,
                0xE462: 0x81D9,
                0xE463: 0x81D8,
                0xE464: 0x81C8,
                0xE465: 0x81DA,
                0xE466: 0x81DF,
                0xE467: 0x81E0,
                0xE468: 0x81E7,
                0xE469: 0x81FA,
                0xE46A: 0x81FB,
                0xE46B: 0x81FE,
                0xE46C: 0x8201,
                0xE46D: 0x8202,
                0xE46E: 0x8205,
                0xE46F: 0x8207,
                0xE470: 0x820A,
                0xE471: 0x820D,
                0xE472: 0x8210,
                0xE473: 0x8216,
                0xE474: 0x8229,
                0xE475: 0x822B,
                0xE476: 0x8238,
                0xE477: 0x8233,
                0xE478: 0x8240,
                0xE479: 0x8259,
                0xE47A: 0x8258,
                0xE47B: 0x825D,
                0xE47C: 0x825A,
                0xE47D: 0x825F,
                0xE47E: 0x8264,
                0xE480: 0x8262,
                0xE481: 0x8268,
                0xE482: 0x826A,
                0xE483: 0x826B,
                0xE484: 0x822E,
                0xE485: 0x8271,
                0xE486: 0x8277,
                0xE487: 0x8278,
                0xE488: 0x827E,
                0xE489: 0x828D,
                0xE48A: 0x8292,
                0xE48B: 0x82AB,
                0xE48C: 0x829F,
                0xE48D: 0x82BB,
                0xE48E: 0x82AC,
                0xE48F: 0x82E1,
                0xE490: 0x82E3,
                0xE491: 0x82DF,
                0xE492: 0x82D2,
                0xE493: 0x82F4,
                0xE494: 0x82F3,
                0xE495: 0x82FA,
                0xE496: 0x8393,
                0xE497: 0x8303,
                0xE498: 0x82FB,
                0xE499: 0x82F9,
                0xE49A: 0x82DE,
                0xE49B: 0x8306,
                0xE49C: 0x82DC,
                0xE49D: 0x8309,
                0xE49E: 0x82D9,
                0xE49F: 0x8335,
                0xE4A0: 0x8334,
                0xE4A1: 0x8316,
                0xE4A2: 0x8332,
                0xE4A3: 0x8331,
                0xE4A4: 0x8340,
                0xE4A5: 0x8339,
                0xE4A6: 0x8350,
                0xE4A7: 0x8345,
                0xE4A8: 0x832F,
                0xE4A9: 0x832B,
                0xE4AA: 0x8317,
                0xE4AB: 0x8318,
                0xE4AC: 0x8385,
                0xE4AD: 0x839A,
                0xE4AE: 0x83AA,
                0xE4AF: 0x839F,
                0xE4B0: 0x83A2,
                0xE4B1: 0x8396,
                0xE4B2: 0x8323,
                0xE4B3: 0x838E,
                0xE4B4: 0x8387,
                0xE4B5: 0x838A,
                0xE4B6: 0x837C,
                0xE4B7: 0x83B5,
                0xE4B8: 0x8373,
                0xE4B9: 0x8375,
                0xE4BA: 0x83A0,
                0xE4BB: 0x8389,
                0xE4BC: 0x83A8,
                0xE4BD: 0x83F4,
                0xE4BE: 0x8413,
                0xE4BF: 0x83EB,
                0xE4C0: 0x83CE,
                0xE4C1: 0x83FD,
                0xE4C2: 0x8403,
                0xE4C3: 0x83D8,
                0xE4C4: 0x840B,
                0xE4C5: 0x83C1,
                0xE4C6: 0x83F7,
                0xE4C7: 0x8407,
                0xE4C8: 0x83E0,
                0xE4C9: 0x83F2,
                0xE4CA: 0x840D,
                0xE4CB: 0x8422,
                0xE4CC: 0x8420,
                0xE4CD: 0x83BD,
                0xE4CE: 0x8438,
                0xE4CF: 0x8506,
                0xE4D0: 0x83FB,
                0xE4D1: 0x846D,
                0xE4D2: 0x842A,
                0xE4D3: 0x843C,
                0xE4D4: 0x855A,
                0xE4D5: 0x8484,
                0xE4D6: 0x8477,
                0xE4D7: 0x846B,
                0xE4D8: 0x84AD,
                0xE4D9: 0x846E,
                0xE4DA: 0x8482,
                0xE4DB: 0x8469,
                0xE4DC: 0x8446,
                0xE4DD: 0x842C,
                0xE4DE: 0x846F,
                0xE4DF: 0x8479,
                0xE4E0: 0x8435,
                0xE4E1: 0x84CA,
                0xE4E2: 0x8462,
                0xE4E3: 0x84B9,
                0xE4E4: 0x84BF,
                0xE4E5: 0x849F,
                0xE4E6: 0x84D9,
                0xE4E7: 0x84CD,
                0xE4E8: 0x84BB,
                0xE4E9: 0x84DA,
                0xE4EA: 0x84D0,
                0xE4EB: 0x84C1,
                0xE4EC: 0x84C6,
                0xE4ED: 0x84D6,
                0xE4EE: 0x84A1,
                0xE4EF: 0x8521,
                0xE4F0: 0x84FF,
                0xE4F1: 0x84F4,
                0xE4F2: 0x8517,
                0xE4F3: 0x8518,
                0xE4F4: 0x852C,
                0xE4F5: 0x851F,
                0xE4F6: 0x8515,
                0xE4F7: 0x8514,
                0xE4F8: 0x84FC,
                0xE4F9: 0x8540,
                0xE4FA: 0x8563,
                0xE4FB: 0x8558,
                0xE4FC: 0x8548,
                0xE540: 0x8541,
                0xE541: 0x8602,
                0xE542: 0x854B,
                0xE543: 0x8555,
                0xE544: 0x8580,
                0xE545: 0x85A4,
                0xE546: 0x8588,
                0xE547: 0x8591,
                0xE548: 0x858A,
                0xE549: 0x85A8,
                0xE54A: 0x856D,
                0xE54B: 0x8594,
                0xE54C: 0x859B,
                0xE54D: 0x85EA,
                0xE54E: 0x8587,
                0xE54F: 0x859C,
                0xE550: 0x8577,
                0xE551: 0x857E,
                0xE552: 0x8590,
                0xE553: 0x85C9,
                0xE554: 0x85BA,
                0xE555: 0x85CF,
                0xE556: 0x85B9,
                0xE557: 0x85D0,
                0xE558: 0x85D5,
                0xE559: 0x85DD,
                0xE55A: 0x85E5,
                0xE55B: 0x85DC,
                0xE55C: 0x85F9,
                0xE55D: 0x860A,
                0xE55E: 0x8613,
                0xE55F: 0x860B,
                0xE560: 0x85FE,
                0xE561: 0x85FA,
                0xE562: 0x8606,
                0xE563: 0x8622,
                0xE564: 0x861A,
                0xE565: 0x8630,
                0xE566: 0x863F,
                0xE567: 0x864D,
                0xE568: 0x4E55,
                0xE569: 0x8654,
                0xE56A: 0x865F,
                0xE56B: 0x8667,
                0xE56C: 0x8671,
                0xE56D: 0x8693,
                0xE56E: 0x86A3,
                0xE56F: 0x86A9,
                0xE570: 0x86AA,
                0xE571: 0x868B,
                0xE572: 0x868C,
                0xE573: 0x86B6,
                0xE574: 0x86AF,
                0xE575: 0x86C4,
                0xE576: 0x86C6,
                0xE577: 0x86B0,
                0xE578: 0x86C9,
                0xE579: 0x8823,
                0xE57A: 0x86AB,
                0xE57B: 0x86D4,
                0xE57C: 0x86DE,
                0xE57D: 0x86E9,
                0xE57E: 0x86EC,
                0xE580: 0x86DF,
                0xE581: 0x86DB,
                0xE582: 0x86EF,
                0xE583: 0x8712,
                0xE584: 0x8706,
                0xE585: 0x8708,
                0xE586: 0x8700,
                0xE587: 0x8703,
                0xE588: 0x86FB,
                0xE589: 0x8711,
                0xE58A: 0x8709,
                0xE58B: 0x870D,
                0xE58C: 0x86F9,
                0xE58D: 0x870A,
                0xE58E: 0x8734,
                0xE58F: 0x873F,
                0xE590: 0x8737,
                0xE591: 0x873B,
                0xE592: 0x8725,
                0xE593: 0x8729,
                0xE594: 0x871A,
                0xE595: 0x8760,
                0xE596: 0x875F,
                0xE597: 0x8778,
                0xE598: 0x874C,
                0xE599: 0x874E,
                0xE59A: 0x8774,
                0xE59B: 0x8757,
                0xE59C: 0x8768,
                0xE59D: 0x876E,
                0xE59E: 0x8759,
                0xE59F: 0x8753,
                0xE5A0: 0x8763,
                0xE5A1: 0x876A,
                0xE5A2: 0x8805,
                0xE5A3: 0x87A2,
                0xE5A4: 0x879F,
                0xE5A5: 0x8782,
                0xE5A6: 0x87AF,
                0xE5A7: 0x87CB,
                0xE5A8: 0x87BD,
                0xE5A9: 0x87C0,
                0xE5AA: 0x87D0,
                0xE5AB: 0x96D6,
                0xE5AC: 0x87AB,
                0xE5AD: 0x87C4,
                0xE5AE: 0x87B3,
                0xE5AF: 0x87C7,
                0xE5B0: 0x87C6,
                0xE5B1: 0x87BB,
                0xE5B2: 0x87EF,
                0xE5B3: 0x87F2,
                0xE5B4: 0x87E0,
                0xE5B5: 0x880F,
                0xE5B6: 0x880D,
                0xE5B7: 0x87FE,
                0xE5B8: 0x87F6,
                0xE5B9: 0x87F7,
                0xE5BA: 0x880E,
                0xE5BB: 0x87D2,
                0xE5BC: 0x8811,
                0xE5BD: 0x8816,
                0xE5BE: 0x8815,
                0xE5BF: 0x8822,
                0xE5C0: 0x8821,
                0xE5C1: 0x8831,
                0xE5C2: 0x8836,
                0xE5C3: 0x8839,
                0xE5C4: 0x8827,
                0xE5C5: 0x883B,
                0xE5C6: 0x8844,
                0xE5C7: 0x8842,
                0xE5C8: 0x8852,
                0xE5C9: 0x8859,
                0xE5CA: 0x885E,
                0xE5CB: 0x8862,
                0xE5CC: 0x886B,
                0xE5CD: 0x8881,
                0xE5CE: 0x887E,
                0xE5CF: 0x889E,
                0xE5D0: 0x8875,
                0xE5D1: 0x887D,
                0xE5D2: 0x88B5,
                0xE5D3: 0x8872,
                0xE5D4: 0x8882,
                0xE5D5: 0x8897,
                0xE5D6: 0x8892,
                0xE5D7: 0x88AE,
                0xE5D8: 0x8899,
                0xE5D9: 0x88A2,
                0xE5DA: 0x888D,
                0xE5DB: 0x88A4,
                0xE5DC: 0x88B0,
                0xE5DD: 0x88BF,
                0xE5DE: 0x88B1,
                0xE5DF: 0x88C3,
                0xE5E0: 0x88C4,
                0xE5E1: 0x88D4,
                0xE5E2: 0x88D8,
                0xE5E3: 0x88D9,
                0xE5E4: 0x88DD,
                0xE5E5: 0x88F9,
                0xE5E6: 0x8902,
                0xE5E7: 0x88FC,
                0xE5E8: 0x88F4,
                0xE5E9: 0x88E8,
                0xE5EA: 0x88F2,
                0xE5EB: 0x8904,
                0xE5EC: 0x890C,
                0xE5ED: 0x890A,
                0xE5EE: 0x8913,
                0xE5EF: 0x8943,
                0xE5F0: 0x891E,
                0xE5F1: 0x8925,
                0xE5F2: 0x892A,
                0xE5F3: 0x892B,
                0xE5F4: 0x8941,
                0xE5F5: 0x8944,
                0xE5F6: 0x893B,
                0xE5F7: 0x8936,
                0xE5F8: 0x8938,
                0xE5F9: 0x894C,
                0xE5FA: 0x891D,
                0xE5FB: 0x8960,
                0xE5FC: 0x895E,
                0xE640: 0x8966,
                0xE641: 0x8964,
                0xE642: 0x896D,
                0xE643: 0x896A,
                0xE644: 0x896F,
                0xE645: 0x8974,
                0xE646: 0x8977,
                0xE647: 0x897E,
                0xE648: 0x8983,
                0xE649: 0x8988,
                0xE64A: 0x898A,
                0xE64B: 0x8993,
                0xE64C: 0x8998,
                0xE64D: 0x89A1,
                0xE64E: 0x89A9,
                0xE64F: 0x89A6,
                0xE650: 0x89AC,
                0xE651: 0x89AF,
                0xE652: 0x89B2,
                0xE653: 0x89BA,
                0xE654: 0x89BD,
                0xE655: 0x89BF,
                0xE656: 0x89C0,
                0xE657: 0x89DA,
                0xE658: 0x89DC,
                0xE659: 0x89DD,
                0xE65A: 0x89E7,
                0xE65B: 0x89F4,
                0xE65C: 0x89F8,
                0xE65D: 0x8A03,
                0xE65E: 0x8A16,
                0xE65F: 0x8A10,
                0xE660: 0x8A0C,
                0xE661: 0x8A1B,
                0xE662: 0x8A1D,
                0xE663: 0x8A25,
                0xE664: 0x8A36,
                0xE665: 0x8A41,
                0xE666: 0x8A5B,
                0xE667: 0x8A52,
                0xE668: 0x8A46,
                0xE669: 0x8A48,
                0xE66A: 0x8A7C,
                0xE66B: 0x8A6D,
                0xE66C: 0x8A6C,
                0xE66D: 0x8A62,
                0xE66E: 0x8A85,
                0xE66F: 0x8A82,
                0xE670: 0x8A84,
                0xE671: 0x8AA8,
                0xE672: 0x8AA1,
                0xE673: 0x8A91,
                0xE674: 0x8AA5,
                0xE675: 0x8AA6,
                0xE676: 0x8A9A,
                0xE677: 0x8AA3,
                0xE678: 0x8AC4,
                0xE679: 0x8ACD,
                0xE67A: 0x8AC2,
                0xE67B: 0x8ADA,
                0xE67C: 0x8AEB,
                0xE67D: 0x8AF3,
                0xE67E: 0x8AE7,
                0xE680: 0x8AE4,
                0xE681: 0x8AF1,
                0xE682: 0x8B14,
                0xE683: 0x8AE0,
                0xE684: 0x8AE2,
                0xE685: 0x8AF7,
                0xE686: 0x8ADE,
                0xE687: 0x8ADB,
                0xE688: 0x8B0C,
                0xE689: 0x8B07,
                0xE68A: 0x8B1A,
                0xE68B: 0x8AE1,
                0xE68C: 0x8B16,
                0xE68D: 0x8B10,
                0xE68E: 0x8B17,
                0xE68F: 0x8B20,
                0xE690: 0x8B33,
                0xE691: 0x97AB,
                0xE692: 0x8B26,
                0xE693: 0x8B2B,
                0xE694: 0x8B3E,
                0xE695: 0x8B28,
                0xE696: 0x8B41,
                0xE697: 0x8B4C,
                0xE698: 0x8B4F,
                0xE699: 0x8B4E,
                0xE69A: 0x8B49,
                0xE69B: 0x8B56,
                0xE69C: 0x8B5B,
                0xE69D: 0x8B5A,
                0xE69E: 0x8B6B,
                0xE69F: 0x8B5F,
                0xE6A0: 0x8B6C,
                0xE6A1: 0x8B6F,
                0xE6A2: 0x8B74,
                0xE6A3: 0x8B7D,
                0xE6A4: 0x8B80,
                0xE6A5: 0x8B8C,
                0xE6A6: 0x8B8E,
                0xE6A7: 0x8B92,
                0xE6A8: 0x8B93,
                0xE6A9: 0x8B96,
                0xE6AA: 0x8B99,
                0xE6AB: 0x8B9A,
                0xE6AC: 0x8C3A,
                0xE6AD: 0x8C41,
                0xE6AE: 0x8C3F,
                0xE6AF: 0x8C48,
                0xE6B0: 0x8C4C,
                0xE6B1: 0x8C4E,
                0xE6B2: 0x8C50,
                0xE6B3: 0x8C55,
                0xE6B4: 0x8C62,
                0xE6B5: 0x8C6C,
                0xE6B6: 0x8C78,
                0xE6B7: 0x8C7A,
                0xE6B8: 0x8C82,
                0xE6B9: 0x8C89,
                0xE6BA: 0x8C85,
                0xE6BB: 0x8C8A,
                0xE6BC: 0x8C8D,
                0xE6BD: 0x8C8E,
                0xE6BE: 0x8C94,
                0xE6BF: 0x8C7C,
                0xE6C0: 0x8C98,
                0xE6C1: 0x621D,
                0xE6C2: 0x8CAD,
                0xE6C3: 0x8CAA,
                0xE6C4: 0x8CBD,
                0xE6C5: 0x8CB2,
                0xE6C6: 0x8CB3,
                0xE6C7: 0x8CAE,
                0xE6C8: 0x8CB6,
                0xE6C9: 0x8CC8,
                0xE6CA: 0x8CC1,
                0xE6CB: 0x8CE4,
                0xE6CC: 0x8CE3,
                0xE6CD: 0x8CDA,
                0xE6CE: 0x8CFD,
                0xE6CF: 0x8CFA,
                0xE6D0: 0x8CFB,
                0xE6D1: 0x8D04,
                0xE6D2: 0x8D05,
                0xE6D3: 0x8D0A,
                0xE6D4: 0x8D07,
                0xE6D5: 0x8D0F,
                0xE6D6: 0x8D0D,
                0xE6D7: 0x8D10,
                0xE6D8: 0x9F4E,
                0xE6D9: 0x8D13,
                0xE6DA: 0x8CCD,
                0xE6DB: 0x8D14,
                0xE6DC: 0x8D16,
                0xE6DD: 0x8D67,
                0xE6DE: 0x8D6D,
                0xE6DF: 0x8D71,
                0xE6E0: 0x8D73,
                0xE6E1: 0x8D81,
                0xE6E2: 0x8D99,
                0xE6E3: 0x8DC2,
                0xE6E4: 0x8DBE,
                0xE6E5: 0x8DBA,
                0xE6E6: 0x8DCF,
                0xE6E7: 0x8DDA,
                0xE6E8: 0x8DD6,
                0xE6E9: 0x8DCC,
                0xE6EA: 0x8DDB,
                0xE6EB: 0x8DCB,
                0xE6EC: 0x8DEA,
                0xE6ED: 0x8DEB,
                0xE6EE: 0x8DDF,
                0xE6EF: 0x8DE3,
                0xE6F0: 0x8DFC,
                0xE6F1: 0x8E08,
                0xE6F2: 0x8E09,
                0xE6F3: 0x8DFF,
                0xE6F4: 0x8E1D,
                0xE6F5: 0x8E1E,
                0xE6F6: 0x8E10,
                0xE6F7: 0x8E1F,
                0xE6F8: 0x8E42,
                0xE6F9: 0x8E35,
                0xE6FA: 0x8E30,
                0xE6FB: 0x8E34,
                0xE6FC: 0x8E4A,
                0xE740: 0x8E47,
                0xE741: 0x8E49,
                0xE742: 0x8E4C,
                0xE743: 0x8E50,
                0xE744: 0x8E48,
                0xE745: 0x8E59,
                0xE746: 0x8E64,
                0xE747: 0x8E60,
                0xE748: 0x8E2A,
                0xE749: 0x8E63,
                0xE74A: 0x8E55,
                0xE74B: 0x8E76,
                0xE74C: 0x8E72,
                0xE74D: 0x8E7C,
                0xE74E: 0x8E81,
                0xE74F: 0x8E87,
                0xE750: 0x8E85,
                0xE751: 0x8E84,
                0xE752: 0x8E8B,
                0xE753: 0x8E8A,
                0xE754: 0x8E93,
                0xE755: 0x8E91,
                0xE756: 0x8E94,
                0xE757: 0x8E99,
                0xE758: 0x8EAA,
                0xE759: 0x8EA1,
                0xE75A: 0x8EAC,
                0xE75B: 0x8EB0,
                0xE75C: 0x8EC6,
                0xE75D: 0x8EB1,
                0xE75E: 0x8EBE,
                0xE75F: 0x8EC5,
                0xE760: 0x8EC8,
                0xE761: 0x8ECB,
                0xE762: 0x8EDB,
                0xE763: 0x8EE3,
                0xE764: 0x8EFC,
                0xE765: 0x8EFB,
                0xE766: 0x8EEB,
                0xE767: 0x8EFE,
                0xE768: 0x8F0A,
                0xE769: 0x8F05,
                0xE76A: 0x8F15,
                0xE76B: 0x8F12,
                0xE76C: 0x8F19,
                0xE76D: 0x8F13,
                0xE76E: 0x8F1C,
                0xE76F: 0x8F1F,
                0xE770: 0x8F1B,
                0xE771: 0x8F0C,
                0xE772: 0x8F26,
                0xE773: 0x8F33,
                0xE774: 0x8F3B,
                0xE775: 0x8F39,
                0xE776: 0x8F45,
                0xE777: 0x8F42,
                0xE778: 0x8F3E,
                0xE779: 0x8F4C,
                0xE77A: 0x8F49,
                0xE77B: 0x8F46,
                0xE77C: 0x8F4E,
                0xE77D: 0x8F57,
                0xE77E: 0x8F5C,
                0xE780: 0x8F62,
                0xE781: 0x8F63,
                0xE782: 0x8F64,
                0xE783: 0x8F9C,
                0xE784: 0x8F9F,
                0xE785: 0x8FA3,
                0xE786: 0x8FAD,
                0xE787: 0x8FAF,
                0xE788: 0x8FB7,
                0xE789: 0x8FDA,
                0xE78A: 0x8FE5,
                0xE78B: 0x8FE2,
                0xE78C: 0x8FEA,
                0xE78D: 0x8FEF,
                0xE78E: 0x9087,
                0xE78F: 0x8FF4,
                0xE790: 0x9005,
                0xE791: 0x8FF9,
                0xE792: 0x8FFA,
                0xE793: 0x9011,
                0xE794: 0x9015,
                0xE795: 0x9021,
                0xE796: 0x900D,
                0xE797: 0x901E,
                0xE798: 0x9016,
                0xE799: 0x900B,
                0xE79A: 0x9027,
                0xE79B: 0x9036,
                0xE79C: 0x9035,
                0xE79D: 0x9039,
                0xE79E: 0x8FF8,
                0xE79F: 0x904F,
                0xE7A0: 0x9050,
                0xE7A1: 0x9051,
                0xE7A2: 0x9052,
                0xE7A3: 0x900E,
                0xE7A4: 0x9049,
                0xE7A5: 0x903E,
                0xE7A6: 0x9056,
                0xE7A7: 0x9058,
                0xE7A8: 0x905E,
                0xE7A9: 0x9068,
                0xE7AA: 0x906F,
                0xE7AB: 0x9076,
                0xE7AC: 0x96A8,
                0xE7AD: 0x9072,
                0xE7AE: 0x9082,
                0xE7AF: 0x907D,
                0xE7B0: 0x9081,
                0xE7B1: 0x9080,
                0xE7B2: 0x908A,
                0xE7B3: 0x9089,
                0xE7B4: 0x908F,
                0xE7B5: 0x90A8,
                0xE7B6: 0x90AF,
                0xE7B7: 0x90B1,
                0xE7B8: 0x90B5,
                0xE7B9: 0x90E2,
                0xE7BA: 0x90E4,
                0xE7BB: 0x6248,
                0xE7BC: 0x90DB,
                0xE7BD: 0x9102,
                0xE7BE: 0x9112,
                0xE7BF: 0x9119,
                0xE7C0: 0x9132,
                0xE7C1: 0x9130,
                0xE7C2: 0x914A,
                0xE7C3: 0x9156,
                0xE7C4: 0x9158,
                0xE7C5: 0x9163,
                0xE7C6: 0x9165,
                0xE7C7: 0x9169,
                0xE7C8: 0x9173,
                0xE7C9: 0x9172,
                0xE7CA: 0x918B,
                0xE7CB: 0x9189,
                0xE7CC: 0x9182,
                0xE7CD: 0x91A2,
                0xE7CE: 0x91AB,
                0xE7CF: 0x91AF,
                0xE7D0: 0x91AA,
                0xE7D1: 0x91B5,
                0xE7D2: 0x91B4,
                0xE7D3: 0x91BA,
                0xE7D4: 0x91C0,
                0xE7D5: 0x91C1,
                0xE7D6: 0x91C9,
                0xE7D7: 0x91CB,
                0xE7D8: 0x91D0,
                0xE7D9: 0x91D6,
                0xE7DA: 0x91DF,
                0xE7DB: 0x91E1,
                0xE7DC: 0x91DB,
                0xE7DD: 0x91FC,
                0xE7DE: 0x91F5,
                0xE7DF: 0x91F6,
                0xE7E0: 0x921E,
                0xE7E1: 0x91FF,
                0xE7E2: 0x9214,
                0xE7E3: 0x922C,
                0xE7E4: 0x9215,
                0xE7E5: 0x9211,
                0xE7E6: 0x925E,
                0xE7E7: 0x9257,
                0xE7E8: 0x9245,
                0xE7E9: 0x9249,
                0xE7EA: 0x9264,
                0xE7EB: 0x9248,
                0xE7EC: 0x9295,
                0xE7ED: 0x923F,
                0xE7EE: 0x924B,
                0xE7EF: 0x9250,
                0xE7F0: 0x929C,
                0xE7F1: 0x9296,
                0xE7F2: 0x9293,
                0xE7F3: 0x929B,
                0xE7F4: 0x925A,
                0xE7F5: 0x92CF,
                0xE7F6: 0x92B9,
                0xE7F7: 0x92B7,
                0xE7F8: 0x92E9,
                0xE7F9: 0x930F,
                0xE7FA: 0x92FA,
                0xE7FB: 0x9344,
                0xE7FC: 0x932E,
                0xE840: 0x9319,
                0xE841: 0x9322,
                0xE842: 0x931A,
                0xE843: 0x9323,
                0xE844: 0x933A,
                0xE845: 0x9335,
                0xE846: 0x933B,
                0xE847: 0x935C,
                0xE848: 0x9360,
                0xE849: 0x937C,
                0xE84A: 0x936E,
                0xE84B: 0x9356,
                0xE84C: 0x93B0,
                0xE84D: 0x93AC,
                0xE84E: 0x93AD,
                0xE84F: 0x9394,
                0xE850: 0x93B9,
                0xE851: 0x93D6,
                0xE852: 0x93D7,
                0xE853: 0x93E8,
                0xE854: 0x93E5,
                0xE855: 0x93D8,
                0xE856: 0x93C3,
                0xE857: 0x93DD,
                0xE858: 0x93D0,
                0xE859: 0x93C8,
                0xE85A: 0x93E4,
                0xE85B: 0x941A,
                0xE85C: 0x9414,
                0xE85D: 0x9413,
                0xE85E: 0x9403,
                0xE85F: 0x9407,
                0xE860: 0x9410,
                0xE861: 0x9436,
                0xE862: 0x942B,
                0xE863: 0x9435,
                0xE864: 0x9421,
                0xE865: 0x943A,
                0xE866: 0x9441,
                0xE867: 0x9452,
                0xE868: 0x9444,
                0xE869: 0x945B,
                0xE86A: 0x9460,
                0xE86B: 0x9462,
                0xE86C: 0x945E,
                0xE86D: 0x946A,
                0xE86E: 0x9229,
                0xE86F: 0x9470,
                0xE870: 0x9475,
                0xE871: 0x9477,
                0xE872: 0x947D,
                0xE873: 0x945A,
                0xE874: 0x947C,
                0xE875: 0x947E,
                0xE876: 0x9481,
                0xE877: 0x947F,
                0xE878: 0x9582,
                0xE879: 0x9587,
                0xE87A: 0x958A,
                0xE87B: 0x9594,
                0xE87C: 0x9596,
                0xE87D: 0x9598,
                0xE87E: 0x9599,
                0xE880: 0x95A0,
                0xE881: 0x95A8,
                0xE882: 0x95A7,
                0xE883: 0x95AD,
                0xE884: 0x95BC,
                0xE885: 0x95BB,
                0xE886: 0x95B9,
                0xE887: 0x95BE,
                0xE888: 0x95CA,
                0xE889: 0x6FF6,
                0xE88A: 0x95C3,
                0xE88B: 0x95CD,
                0xE88C: 0x95CC,
                0xE88D: 0x95D5,
                0xE88E: 0x95D4,
                0xE88F: 0x95D6,
                0xE890: 0x95DC,
                0xE891: 0x95E1,
                0xE892: 0x95E5,
                0xE893: 0x95E2,
                0xE894: 0x9621,
                0xE895: 0x9628,
                0xE896: 0x962E,
                0xE897: 0x962F,
                0xE898: 0x9642,
                0xE899: 0x964C,
                0xE89A: 0x964F,
                0xE89B: 0x964B,
                0xE89C: 0x9677,
                0xE89D: 0x965C,
                0xE89E: 0x965E,
                0xE89F: 0x965D,
                0xE8A0: 0x965F,
                0xE8A1: 0x9666,
                0xE8A2: 0x9672,
                0xE8A3: 0x966C,
                0xE8A4: 0x968D,
                0xE8A5: 0x9698,
                0xE8A6: 0x9695,
                0xE8A7: 0x9697,
                0xE8A8: 0x96AA,
                0xE8A9: 0x96A7,
                0xE8AA: 0x96B1,
                0xE8AB: 0x96B2,
                0xE8AC: 0x96B0,
                0xE8AD: 0x96B4,
                0xE8AE: 0x96B6,
                0xE8AF: 0x96B8,
                0xE8B0: 0x96B9,
                0xE8B1: 0x96CE,
                0xE8B2: 0x96CB,
                0xE8B3: 0x96C9,
                0xE8B4: 0x96CD,
                0xE8B5: 0x894D,
                0xE8B6: 0x96DC,
                0xE8B7: 0x970D,
                0xE8B8: 0x96D5,
                0xE8B9: 0x96F9,
                0xE8BA: 0x9704,
                0xE8BB: 0x9706,
                0xE8BC: 0x9708,
                0xE8BD: 0x9713,
                0xE8BE: 0x970E,
                0xE8BF: 0x9711,
                0xE8C0: 0x970F,
                0xE8C1: 0x9716,
                0xE8C2: 0x9719,
                0xE8C3: 0x9724,
                0xE8C4: 0x972A,
                0xE8C5: 0x9730,
                0xE8C6: 0x9739,
                0xE8C7: 0x973D,
                0xE8C8: 0x973E,
                0xE8C9: 0x9744,
                0xE8CA: 0x9746,
                0xE8CB: 0x9748,
                0xE8CC: 0x9742,
                0xE8CD: 0x9749,
                0xE8CE: 0x975C,
                0xE8CF: 0x9760,
                0xE8D0: 0x9764,
                0xE8D1: 0x9766,
                0xE8D2: 0x9768,
                0xE8D3: 0x52D2,
                0xE8D4: 0x976B,
                0xE8D5: 0x9771,
                0xE8D6: 0x9779,
                0xE8D7: 0x9785,
                0xE8D8: 0x977C,
                0xE8D9: 0x9781,
                0xE8DA: 0x977A,
                0xE8DB: 0x9786,
                0xE8DC: 0x978B,
                0xE8DD: 0x978F,
                0xE8DE: 0x9790,
                0xE8DF: 0x979C,
                0xE8E0: 0x97A8,
                0xE8E1: 0x97A6,
                0xE8E2: 0x97A3,
                0xE8E3: 0x97B3,
                0xE8E4: 0x97B4,
                0xE8E5: 0x97C3,
                0xE8E6: 0x97C6,
                0xE8E7: 0x97C8,
                0xE8E8: 0x97CB,
                0xE8E9: 0x97DC,
                0xE8EA: 0x97ED,
                0xE8EB: 0x9F4F,
                0xE8EC: 0x97F2,
                0xE8ED: 0x7ADF,
                0xE8EE: 0x97F6,
                0xE8EF: 0x97F5,
                0xE8F0: 0x980F,
                0xE8F1: 0x980C,
                0xE8F2: 0x9838,
                0xE8F3: 0x9824,
                0xE8F4: 0x9821,
                0xE8F5: 0x9837,
                0xE8F6: 0x983D,
                0xE8F7: 0x9846,
                0xE8F8: 0x984F,
                0xE8F9: 0x984B,
                0xE8FA: 0x986B,
                0xE8FB: 0x986F,
                0xE8FC: 0x9870,
                0xE940: 0x9871,
                0xE941: 0x9874,
                0xE942: 0x9873,
                0xE943: 0x98AA,
                0xE944: 0x98AF,
                0xE945: 0x98B1,
                0xE946: 0x98B6,
                0xE947: 0x98C4,
                0xE948: 0x98C3,
                0xE949: 0x98C6,
                0xE94A: 0x98E9,
                0xE94B: 0x98EB,
                0xE94C: 0x9903,
                0xE94D: 0x9909,
                0xE94E: 0x9912,
                0xE94F: 0x9914,
                0xE950: 0x9918,
                0xE951: 0x9921,
                0xE952: 0x991D,
                0xE953: 0x991E,
                0xE954: 0x9924,
                0xE955: 0x9920,
                0xE956: 0x992C,
                0xE957: 0x992E,
                0xE958: 0x993D,
                0xE959: 0x993E,
                0xE95A: 0x9942,
                0xE95B: 0x9949,
                0xE95C: 0x9945,
                0xE95D: 0x9950,
                0xE95E: 0x994B,
                0xE95F: 0x9951,
                0xE960: 0x9952,
                0xE961: 0x994C,
                0xE962: 0x9955,
                0xE963: 0x9997,
                0xE964: 0x9998,
                0xE965: 0x99A5,
                0xE966: 0x99AD,
                0xE967: 0x99AE,
                0xE968: 0x99BC,
                0xE969: 0x99DF,
                0xE96A: 0x99DB,
                0xE96B: 0x99DD,
                0xE96C: 0x99D8,
                0xE96D: 0x99D1,
                0xE96E: 0x99ED,
                0xE96F: 0x99EE,
                0xE970: 0x99F1,
                0xE971: 0x99F2,
                0xE972: 0x99FB,
                0xE973: 0x99F8,
                0xE974: 0x9A01,
                0xE975: 0x9A0F,
                0xE976: 0x9A05,
                0xE977: 0x99E2,
                0xE978: 0x9A19,
                0xE979: 0x9A2B,
                0xE97A: 0x9A37,
                0xE97B: 0x9A45,
                0xE97C: 0x9A42,
                0xE97D: 0x9A40,
                0xE97E: 0x9A43,
                0xE980: 0x9A3E,
                0xE981: 0x9A55,
                0xE982: 0x9A4D,
                0xE983: 0x9A5B,
                0xE984: 0x9A57,
                0xE985: 0x9A5F,
                0xE986: 0x9A62,
                0xE987: 0x9A65,
                0xE988: 0x9A64,
                0xE989: 0x9A69,
                0xE98A: 0x9A6B,
                0xE98B: 0x9A6A,
                0xE98C: 0x9AAD,
                0xE98D: 0x9AB0,
                0xE98E: 0x9ABC,
                0xE98F: 0x9AC0,
                0xE990: 0x9ACF,
                0xE991: 0x9AD1,
                0xE992: 0x9AD3,
                0xE993: 0x9AD4,
                0xE994: 0x9ADE,
                0xE995: 0x9ADF,
                0xE996: 0x9AE2,
                0xE997: 0x9AE3,
                0xE998: 0x9AE6,
                0xE999: 0x9AEF,
                0xE99A: 0x9AEB,
                0xE99B: 0x9AEE,
                0xE99C: 0x9AF4,
                0xE99D: 0x9AF1,
                0xE99E: 0x9AF7,
                0xE99F: 0x9AFB,
                0xE9A0: 0x9B06,
                0xE9A1: 0x9B18,
                0xE9A2: 0x9B1A,
                0xE9A3: 0x9B1F,
                0xE9A4: 0x9B22,
                0xE9A5: 0x9B23,
                0xE9A6: 0x9B25,
                0xE9A7: 0x9B27,
                0xE9A8: 0x9B28,
                0xE9A9: 0x9B29,
                0xE9AA: 0x9B2A,
                0xE9AB: 0x9B2E,
                0xE9AC: 0x9B2F,
                0xE9AD: 0x9B32,
                0xE9AE: 0x9B44,
                0xE9AF: 0x9B43,
                0xE9B0: 0x9B4F,
                0xE9B1: 0x9B4D,
                0xE9B2: 0x9B4E,
                0xE9B3: 0x9B51,
                0xE9B4: 0x9B58,
                0xE9B5: 0x9B74,
                0xE9B6: 0x9B93,
                0xE9B7: 0x9B83,
                0xE9B8: 0x9B91,
                0xE9B9: 0x9B96,
                0xE9BA: 0x9B97,
                0xE9BB: 0x9B9F,
                0xE9BC: 0x9BA0,
                0xE9BD: 0x9BA8,
                0xE9BE: 0x9BB4,
                0xE9BF: 0x9BC0,
                0xE9C0: 0x9BCA,
                0xE9C1: 0x9BB9,
                0xE9C2: 0x9BC6,
                0xE9C3: 0x9BCF,
                0xE9C4: 0x9BD1,
                0xE9C5: 0x9BD2,
                0xE9C6: 0x9BE3,
                0xE9C7: 0x9BE2,
                0xE9C8: 0x9BE4,
                0xE9C9: 0x9BD4,
                0xE9CA: 0x9BE1,
                0xE9CB: 0x9C3A,
                0xE9CC: 0x9BF2,
                0xE9CD: 0x9BF1,
                0xE9CE: 0x9BF0,
                0xE9CF: 0x9C15,
                0xE9D0: 0x9C14,
                0xE9D1: 0x9C09,
                0xE9D2: 0x9C13,
                0xE9D3: 0x9C0C,
                0xE9D4: 0x9C06,
                0xE9D5: 0x9C08,
                0xE9D6: 0x9C12,
                0xE9D7: 0x9C0A,
                0xE9D8: 0x9C04,
                0xE9D9: 0x9C2E,
                0xE9DA: 0x9C1B,
                0xE9DB: 0x9C25,
                0xE9DC: 0x9C24,
                0xE9DD: 0x9C21,
                0xE9DE: 0x9C30,
                0xE9DF: 0x9C47,
                0xE9E0: 0x9C32,
                0xE9E1: 0x9C46,
                0xE9E2: 0x9C3E,
                0xE9E3: 0x9C5A,
                0xE9E4: 0x9C60,
                0xE9E5: 0x9C67,
                0xE9E6: 0x9C76,
                0xE9E7: 0x9C78,
                0xE9E8: 0x9CE7,
                0xE9E9: 0x9CEC,
                0xE9EA: 0x9CF0,
                0xE9EB: 0x9D09,
                0xE9EC: 0x9D08,
                0xE9ED: 0x9CEB,
                0xE9EE: 0x9D03,
                0xE9EF: 0x9D06,
                0xE9F0: 0x9D2A,
                0xE9F1: 0x9D26,
                0xE9F2: 0x9DAF,
                0xE9F3: 0x9D23,
                0xE9F4: 0x9D1F,
                0xE9F5: 0x9D44,
                0xE9F6: 0x9D15,
                0xE9F7: 0x9D12,
                0xE9F8: 0x9D41,
                0xE9F9: 0x9D3F,
                0xE9FA: 0x9D3E,
                0xE9FB: 0x9D46,
                0xE9FC: 0x9D48,
                0xEA40: 0x9D5D,
                0xEA41: 0x9D5E,
                0xEA42: 0x9D64,
                0xEA43: 0x9D51,
                0xEA44: 0x9D50,
                0xEA45: 0x9D59,
                0xEA46: 0x9D72,
                0xEA47: 0x9D89,
                0xEA48: 0x9D87,
                0xEA49: 0x9DAB,
                0xEA4A: 0x9D6F,
                0xEA4B: 0x9D7A,
                0xEA4C: 0x9D9A,
                0xEA4D: 0x9DA4,
                0xEA4E: 0x9DA9,
                0xEA4F: 0x9DB2,
                0xEA50: 0x9DC4,
                0xEA51: 0x9DC1,
                0xEA52: 0x9DBB,
                0xEA53: 0x9DB8,
                0xEA54: 0x9DBA,
                0xEA55: 0x9DC6,
                0xEA56: 0x9DCF,
                0xEA57: 0x9DC2,
                0xEA58: 0x9DD9,
                0xEA59: 0x9DD3,
                0xEA5A: 0x9DF8,
                0xEA5B: 0x9DE6,
                0xEA5C: 0x9DED,
                0xEA5D: 0x9DEF,
                0xEA5E: 0x9DFD,
                0xEA5F: 0x9E1A,
                0xEA60: 0x9E1B,
                0xEA61: 0x9E1E,
                0xEA62: 0x9E75,
                0xEA63: 0x9E79,
                0xEA64: 0x9E7D,
                0xEA65: 0x9E81,
                0xEA66: 0x9E88,
                0xEA67: 0x9E8B,
                0xEA68: 0x9E8C,
                0xEA69: 0x9E92,
                0xEA6A: 0x9E95,
                0xEA6B: 0x9E91,
                0xEA6C: 0x9E9D,
                0xEA6D: 0x9EA5,
                0xEA6E: 0x9EA9,
                0xEA6F: 0x9EB8,
                0xEA70: 0x9EAA,
                0xEA71: 0x9EAD,
                0xEA72: 0x9761,
                0xEA73: 0x9ECC,
                0xEA74: 0x9ECE,
                0xEA75: 0x9ECF,
                0xEA76: 0x9ED0,
                0xEA77: 0x9ED4,
                0xEA78: 0x9EDC,
                0xEA79: 0x9EDE,
                0xEA7A: 0x9EDD,
                0xEA7B: 0x9EE0,
                0xEA7C: 0x9EE5,
                0xEA7D: 0x9EE8,
                0xEA7E: 0x9EEF,
                0xEA80: 0x9EF4,
                0xEA81: 0x9EF6,
                0xEA82: 0x9EF7,
                0xEA83: 0x9EF9,
                0xEA84: 0x9EFB,
                0xEA85: 0x9EFC,
                0xEA86: 0x9EFD,
                0xEA87: 0x9F07,
                0xEA88: 0x9F08,
                0xEA89: 0x76B7,
                0xEA8A: 0x9F15,
                0xEA8B: 0x9F21,
                0xEA8C: 0x9F2C,
                0xEA8D: 0x9F3E,
                0xEA8E: 0x9F4A,
                0xEA8F: 0x9F52,
                0xEA90: 0x9F54,
                0xEA91: 0x9F63,
                0xEA92: 0x9F5F,
                0xEA93: 0x9F60,
                0xEA94: 0x9F61,
                0xEA95: 0x9F66,
                0xEA96: 0x9F67,
                0xEA97: 0x9F6C,
                0xEA98: 0x9F6A,
                0xEA99: 0x9F77,
                0xEA9A: 0x9F72,
                0xEA9B: 0x9F76,
                0xEA9C: 0x9F95,
                0xEA9D: 0x9F9C,
                0xEA9E: 0x9FA0,
                0xEA9F: 0x582F,
                0xEAA0: 0x69C7,
                0xEAA1: 0x9059,
                0xEAA2: 0x7464,
                0xEAA3: 0x51DC,
                0xEAA4: 0x7199
            };
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var GenericGF_1 = __webpack_require__(1);
            var GenericGFPoly_1 = __webpack_require__(2);
            function runEuclideanAlgorithm(field, a, b, R) {
                var _a;
                // Assume a's degree is >= b's
                if (a.degree() < b.degree()) _a = [
                    b,
                    a
                ], a = _a[0], b = _a[1];
                var rLast = a;
                var r = b;
                var tLast = field.zero;
                var t = field.one;
                // Run Euclidean algorithm until r's degree is less than R/2
                while(r.degree() >= R / 2){
                    var rLastLast = rLast;
                    var tLastLast = tLast;
                    rLast = r;
                    tLast = t;
                    // Divide rLastLast by rLast, with quotient in q and remainder in r
                    if (rLast.isZero()) // Euclidean algorithm already terminated?
                    return null;
                    r = rLastLast;
                    var q = field.zero;
                    var denominatorLeadingTerm = rLast.getCoefficient(rLast.degree());
                    var dltInverse = field.inverse(denominatorLeadingTerm);
                    while(r.degree() >= rLast.degree() && !r.isZero()){
                        var degreeDiff = r.degree() - rLast.degree();
                        var scale = field.multiply(r.getCoefficient(r.degree()), dltInverse);
                        q = q.addOrSubtract(field.buildMonomial(degreeDiff, scale));
                        r = r.addOrSubtract(rLast.multiplyByMonomial(degreeDiff, scale));
                    }
                    t = q.multiplyPoly(tLast).addOrSubtract(tLastLast);
                    if (r.degree() >= rLast.degree()) return null;
                }
                var sigmaTildeAtZero = t.getCoefficient(0);
                if (sigmaTildeAtZero === 0) return null;
                var inverse = field.inverse(sigmaTildeAtZero);
                return [
                    t.multiply(inverse),
                    r.multiply(inverse)
                ];
            }
            function findErrorLocations(field, errorLocator) {
                // This is a direct application of Chien's search
                var numErrors = errorLocator.degree();
                if (numErrors === 1) return [
                    errorLocator.getCoefficient(1)
                ];
                var result = new Array(numErrors);
                var errorCount = 0;
                for(var i = 1; i < field.size && errorCount < numErrors; i++)if (errorLocator.evaluateAt(i) === 0) {
                    result[errorCount] = field.inverse(i);
                    errorCount++;
                }
                if (errorCount !== numErrors) return null;
                return result;
            }
            function findErrorMagnitudes(field, errorEvaluator, errorLocations) {
                // This is directly applying Forney's Formula
                var s = errorLocations.length;
                var result = new Array(s);
                for(var i = 0; i < s; i++){
                    var xiInverse = field.inverse(errorLocations[i]);
                    var denominator = 1;
                    for(var j = 0; j < s; j++)if (i !== j) denominator = field.multiply(denominator, GenericGF_1.addOrSubtractGF(1, field.multiply(errorLocations[j], xiInverse)));
                    result[i] = field.multiply(errorEvaluator.evaluateAt(xiInverse), field.inverse(denominator));
                    if (field.generatorBase !== 0) result[i] = field.multiply(result[i], xiInverse);
                }
                return result;
            }
            function decode(bytes, twoS) {
                var outputBytes = new Uint8ClampedArray(bytes.length);
                outputBytes.set(bytes);
                var field = new GenericGF_1.default(0x011D, 256, 0); // x^8 + x^4 + x^3 + x^2 + 1
                var poly = new GenericGFPoly_1.default(field, outputBytes);
                var syndromeCoefficients = new Uint8ClampedArray(twoS);
                var error = false;
                for(var s = 0; s < twoS; s++){
                    var evaluation = poly.evaluateAt(field.exp(s + field.generatorBase));
                    syndromeCoefficients[syndromeCoefficients.length - 1 - s] = evaluation;
                    if (evaluation !== 0) error = true;
                }
                if (!error) return outputBytes;
                var syndrome = new GenericGFPoly_1.default(field, syndromeCoefficients);
                var sigmaOmega = runEuclideanAlgorithm(field, field.buildMonomial(twoS, 1), syndrome, twoS);
                if (sigmaOmega === null) return null;
                var errorLocations = findErrorLocations(field, sigmaOmega[0]);
                if (errorLocations == null) return null;
                var errorMagnitudes = findErrorMagnitudes(field, sigmaOmega[1], errorLocations);
                for(var i = 0; i < errorLocations.length; i++){
                    var position = outputBytes.length - 1 - field.log(errorLocations[i]);
                    if (position < 0) return null;
                    outputBytes[position] = GenericGF_1.addOrSubtractGF(outputBytes[position], errorMagnitudes[i]);
                }
                return outputBytes;
            }
            exports.decode = decode;
        /***/ },
        /* 10 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.VERSIONS = [
                {
                    infoBits: null,
                    versionNumber: 1,
                    alignmentPatternCenters: [],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 7,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 19
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 10,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 13,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 13
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 17,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 9
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: null,
                    versionNumber: 2,
                    alignmentPatternCenters: [
                        6,
                        18
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 10,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 34
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 16,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 28
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 22
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: null,
                    versionNumber: 3,
                    alignmentPatternCenters: [
                        6,
                        22
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 15,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 55
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 44
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 18,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 17
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 13
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: null,
                    versionNumber: 4,
                    alignmentPatternCenters: [
                        6,
                        26
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 20,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 80
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 18,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 32
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 24
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 16,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 9
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: null,
                    versionNumber: 5,
                    alignmentPatternCenters: [
                        6,
                        30
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 108
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 43
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 18,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 11
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 12
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: null,
                    versionNumber: 6,
                    alignmentPatternCenters: [
                        6,
                        34
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 18,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 68
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 16,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 27
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 19
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 15
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x07C94,
                    versionNumber: 7,
                    alignmentPatternCenters: [
                        6,
                        22,
                        38
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 20,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 78
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 18,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 31
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 18,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 14
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 15
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 13
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 14
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x085BC,
                    versionNumber: 8,
                    alignmentPatternCenters: [
                        6,
                        24,
                        42
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 97
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 38
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 39
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 18
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 19
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 14
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 15
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x09A99,
                    versionNumber: 9,
                    alignmentPatternCenters: [
                        6,
                        26,
                        46
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 116
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 36
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 37
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 20,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 16
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 17
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 12
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 13
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x0A4D3,
                    versionNumber: 10,
                    alignmentPatternCenters: [
                        6,
                        28,
                        50
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 18,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 68
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 69
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 43
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 44
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 19
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 20
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x0BBF6,
                    versionNumber: 11,
                    alignmentPatternCenters: [
                        6,
                        30,
                        54
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 20,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 81
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 50
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 51
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 22
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 23
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 12
                                },
                                {
                                    numBlocks: 8,
                                    dataCodewordsPerBlock: 13
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x0C762,
                    versionNumber: 12,
                    alignmentPatternCenters: [
                        6,
                        32,
                        58
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 92
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 93
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 36
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 37
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 20
                                },
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 21
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 14
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 15
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x0D847,
                    versionNumber: 13,
                    alignmentPatternCenters: [
                        6,
                        34,
                        62
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 107
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 8,
                                    dataCodewordsPerBlock: 37
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 38
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 8,
                                    dataCodewordsPerBlock: 20
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 21
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 12,
                                    dataCodewordsPerBlock: 11
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 12
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x0E60D,
                    versionNumber: 14,
                    alignmentPatternCenters: [
                        6,
                        26,
                        46,
                        66
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 115
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 116
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 40
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 41
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 20,
                            ecBlocks: [
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 16
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 17
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 12
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 13
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x0F928,
                    versionNumber: 15,
                    alignmentPatternCenters: [
                        6,
                        26,
                        48,
                        70
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 87
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 88
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 41
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 42
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 12
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 13
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x10B78,
                    versionNumber: 16,
                    alignmentPatternCenters: [
                        6,
                        26,
                        50,
                        74
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 98
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 99
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 45
                                },
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 46
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 15,
                                    dataCodewordsPerBlock: 19
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 20
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 13,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x1145D,
                    versionNumber: 17,
                    alignmentPatternCenters: [
                        6,
                        30,
                        54,
                        78
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 107
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 108
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 22
                                },
                                {
                                    numBlocks: 15,
                                    dataCodewordsPerBlock: 23
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 14
                                },
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 15
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x12A17,
                    versionNumber: 18,
                    alignmentPatternCenters: [
                        6,
                        30,
                        56,
                        82
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 120
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 121
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 9,
                                    dataCodewordsPerBlock: 43
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 44
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 22
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 23
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 14
                                },
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 15
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x13532,
                    versionNumber: 19,
                    alignmentPatternCenters: [
                        6,
                        30,
                        58,
                        86
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 113
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 114
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 44
                                },
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 45
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 21
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 22
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 9,
                                    dataCodewordsPerBlock: 13
                                },
                                {
                                    numBlocks: 16,
                                    dataCodewordsPerBlock: 14
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x149A6,
                    versionNumber: 20,
                    alignmentPatternCenters: [
                        6,
                        34,
                        62,
                        90
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 107
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 108
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 41
                                },
                                {
                                    numBlocks: 13,
                                    dataCodewordsPerBlock: 42
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 15,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 15,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x15683,
                    versionNumber: 21,
                    alignmentPatternCenters: [
                        6,
                        28,
                        50,
                        72,
                        94
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 116
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 117
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 42
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 22
                                },
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 23
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 16
                                },
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 17
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x168C9,
                    versionNumber: 22,
                    alignmentPatternCenters: [
                        6,
                        26,
                        50,
                        74,
                        98
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 111
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 112
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 46
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 16,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 34,
                                    dataCodewordsPerBlock: 13
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x177EC,
                    versionNumber: 23,
                    alignmentPatternCenters: [
                        6,
                        30,
                        54,
                        74,
                        102
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 121
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 122
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 47
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 48
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 16,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x18EC4,
                    versionNumber: 24,
                    alignmentPatternCenters: [
                        6,
                        28,
                        54,
                        80,
                        106
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 117
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 118
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 45
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 46
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 16,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 30,
                                    dataCodewordsPerBlock: 16
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 17
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x191E1,
                    versionNumber: 25,
                    alignmentPatternCenters: [
                        6,
                        32,
                        58,
                        84,
                        110
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 8,
                                    dataCodewordsPerBlock: 106
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 107
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 8,
                                    dataCodewordsPerBlock: 47
                                },
                                {
                                    numBlocks: 13,
                                    dataCodewordsPerBlock: 48
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 22,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 22,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 13,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x1AFAB,
                    versionNumber: 26,
                    alignmentPatternCenters: [
                        6,
                        30,
                        58,
                        86,
                        114
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 114
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 115
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 28,
                                    dataCodewordsPerBlock: 22
                                },
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 23
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 33,
                                    dataCodewordsPerBlock: 16
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 17
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x1B08E,
                    versionNumber: 27,
                    alignmentPatternCenters: [
                        6,
                        34,
                        62,
                        90,
                        118
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 8,
                                    dataCodewordsPerBlock: 122
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 123
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 22,
                                    dataCodewordsPerBlock: 45
                                },
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 46
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 8,
                                    dataCodewordsPerBlock: 23
                                },
                                {
                                    numBlocks: 26,
                                    dataCodewordsPerBlock: 24
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 12,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 28,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x1CC1A,
                    versionNumber: 28,
                    alignmentPatternCenters: [
                        6,
                        26,
                        50,
                        74,
                        98,
                        122
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 117
                                },
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 118
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 45
                                },
                                {
                                    numBlocks: 23,
                                    dataCodewordsPerBlock: 46
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 31,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 31,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x1D33F,
                    versionNumber: 29,
                    alignmentPatternCenters: [
                        6,
                        30,
                        54,
                        78,
                        102,
                        126
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 116
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 117
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 21,
                                    dataCodewordsPerBlock: 45
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 46
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 23
                                },
                                {
                                    numBlocks: 37,
                                    dataCodewordsPerBlock: 24
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 26,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x1ED75,
                    versionNumber: 30,
                    alignmentPatternCenters: [
                        6,
                        26,
                        52,
                        78,
                        104,
                        130
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 115
                                },
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 116
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 47
                                },
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 48
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 15,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 25,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 23,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 25,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x1F250,
                    versionNumber: 31,
                    alignmentPatternCenters: [
                        6,
                        30,
                        56,
                        82,
                        108,
                        134
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 13,
                                    dataCodewordsPerBlock: 115
                                },
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 116
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 29,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 42,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 23,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 28,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x209D5,
                    versionNumber: 32,
                    alignmentPatternCenters: [
                        6,
                        34,
                        60,
                        86,
                        112,
                        138
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 115
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 23,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 35,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 35,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x216F0,
                    versionNumber: 33,
                    alignmentPatternCenters: [
                        6,
                        30,
                        58,
                        86,
                        114,
                        142
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 115
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 116
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 21,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 29,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 46,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x228BA,
                    versionNumber: 34,
                    alignmentPatternCenters: [
                        6,
                        34,
                        62,
                        90,
                        118,
                        146
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 13,
                                    dataCodewordsPerBlock: 115
                                },
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 116
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 23,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 44,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 59,
                                    dataCodewordsPerBlock: 16
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 17
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x2379F,
                    versionNumber: 35,
                    alignmentPatternCenters: [
                        6,
                        30,
                        54,
                        78,
                        102,
                        126,
                        150
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 12,
                                    dataCodewordsPerBlock: 121
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 122
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 12,
                                    dataCodewordsPerBlock: 47
                                },
                                {
                                    numBlocks: 26,
                                    dataCodewordsPerBlock: 48
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 39,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 22,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 41,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x24B0B,
                    versionNumber: 36,
                    alignmentPatternCenters: [
                        6,
                        24,
                        50,
                        76,
                        102,
                        128,
                        154
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 121
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 122
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 47
                                },
                                {
                                    numBlocks: 34,
                                    dataCodewordsPerBlock: 48
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 46,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 64,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x2542E,
                    versionNumber: 37,
                    alignmentPatternCenters: [
                        6,
                        28,
                        54,
                        80,
                        106,
                        132,
                        158
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 122
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 123
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 29,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 49,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 24,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 46,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x26A64,
                    versionNumber: 38,
                    alignmentPatternCenters: [
                        6,
                        32,
                        58,
                        84,
                        110,
                        136,
                        162
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 122
                                },
                                {
                                    numBlocks: 18,
                                    dataCodewordsPerBlock: 123
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 13,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 32,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 48,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 42,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 32,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x27541,
                    versionNumber: 39,
                    alignmentPatternCenters: [
                        6,
                        26,
                        54,
                        82,
                        110,
                        138,
                        166
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 20,
                                    dataCodewordsPerBlock: 117
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 118
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 40,
                                    dataCodewordsPerBlock: 47
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 48
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 43,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 22,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 67,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x28C69,
                    versionNumber: 40,
                    alignmentPatternCenters: [
                        6,
                        30,
                        58,
                        86,
                        114,
                        142,
                        170
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 118
                                },
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 119
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 18,
                                    dataCodewordsPerBlock: 47
                                },
                                {
                                    numBlocks: 31,
                                    dataCodewordsPerBlock: 48
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 34,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 34,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 20,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 61,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                }
            ];
        /***/ },
        /* 11 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var BitMatrix_1 = __webpack_require__(0);
            function squareToQuadrilateral(p1, p2, p3, p4) {
                var dx3 = p1.x - p2.x + p3.x - p4.x;
                var dy3 = p1.y - p2.y + p3.y - p4.y;
                if (dx3 === 0 && dy3 === 0) return {
                    a11: p2.x - p1.x,
                    a12: p2.y - p1.y,
                    a13: 0,
                    a21: p3.x - p2.x,
                    a22: p3.y - p2.y,
                    a23: 0,
                    a31: p1.x,
                    a32: p1.y,
                    a33: 1
                };
                else {
                    var dx1 = p2.x - p3.x;
                    var dx2 = p4.x - p3.x;
                    var dy1 = p2.y - p3.y;
                    var dy2 = p4.y - p3.y;
                    var denominator = dx1 * dy2 - dx2 * dy1;
                    var a13 = (dx3 * dy2 - dx2 * dy3) / denominator;
                    var a23 = (dx1 * dy3 - dx3 * dy1) / denominator;
                    return {
                        a11: p2.x - p1.x + a13 * p2.x,
                        a12: p2.y - p1.y + a13 * p2.y,
                        a13: a13,
                        a21: p4.x - p1.x + a23 * p4.x,
                        a22: p4.y - p1.y + a23 * p4.y,
                        a23: a23,
                        a31: p1.x,
                        a32: p1.y,
                        a33: 1
                    };
                }
            }
            function quadrilateralToSquare(p1, p2, p3, p4) {
                // Here, the adjoint serves as the inverse:
                var sToQ = squareToQuadrilateral(p1, p2, p3, p4);
                return {
                    a11: sToQ.a22 * sToQ.a33 - sToQ.a23 * sToQ.a32,
                    a12: sToQ.a13 * sToQ.a32 - sToQ.a12 * sToQ.a33,
                    a13: sToQ.a12 * sToQ.a23 - sToQ.a13 * sToQ.a22,
                    a21: sToQ.a23 * sToQ.a31 - sToQ.a21 * sToQ.a33,
                    a22: sToQ.a11 * sToQ.a33 - sToQ.a13 * sToQ.a31,
                    a23: sToQ.a13 * sToQ.a21 - sToQ.a11 * sToQ.a23,
                    a31: sToQ.a21 * sToQ.a32 - sToQ.a22 * sToQ.a31,
                    a32: sToQ.a12 * sToQ.a31 - sToQ.a11 * sToQ.a32,
                    a33: sToQ.a11 * sToQ.a22 - sToQ.a12 * sToQ.a21
                };
            }
            function times(a, b) {
                return {
                    a11: a.a11 * b.a11 + a.a21 * b.a12 + a.a31 * b.a13,
                    a12: a.a12 * b.a11 + a.a22 * b.a12 + a.a32 * b.a13,
                    a13: a.a13 * b.a11 + a.a23 * b.a12 + a.a33 * b.a13,
                    a21: a.a11 * b.a21 + a.a21 * b.a22 + a.a31 * b.a23,
                    a22: a.a12 * b.a21 + a.a22 * b.a22 + a.a32 * b.a23,
                    a23: a.a13 * b.a21 + a.a23 * b.a22 + a.a33 * b.a23,
                    a31: a.a11 * b.a31 + a.a21 * b.a32 + a.a31 * b.a33,
                    a32: a.a12 * b.a31 + a.a22 * b.a32 + a.a32 * b.a33,
                    a33: a.a13 * b.a31 + a.a23 * b.a32 + a.a33 * b.a33
                };
            }
            function extract(image, location) {
                var qToS = quadrilateralToSquare({
                    x: 3.5,
                    y: 3.5
                }, {
                    x: location.dimension - 3.5,
                    y: 3.5
                }, {
                    x: location.dimension - 6.5,
                    y: location.dimension - 6.5
                }, {
                    x: 3.5,
                    y: location.dimension - 3.5
                });
                var sToQ = squareToQuadrilateral(location.topLeft, location.topRight, location.alignmentPattern, location.bottomLeft);
                var transform = times(sToQ, qToS);
                var matrix = BitMatrix_1.BitMatrix.createEmpty(location.dimension, location.dimension);
                var mappingFunction = function(x, y) {
                    var denominator = transform.a13 * x + transform.a23 * y + transform.a33;
                    return {
                        x: (transform.a11 * x + transform.a21 * y + transform.a31) / denominator,
                        y: (transform.a12 * x + transform.a22 * y + transform.a32) / denominator
                    };
                };
                for(var y = 0; y < location.dimension; y++)for(var x = 0; x < location.dimension; x++){
                    var xValue = x + 0.5;
                    var yValue = y + 0.5;
                    var sourcePixel = mappingFunction(xValue, yValue);
                    matrix.set(x, y, image.get(Math.floor(sourcePixel.x), Math.floor(sourcePixel.y)));
                }
                return {
                    matrix: matrix,
                    mappingFunction: mappingFunction
                };
            }
            exports.extract = extract;
        /***/ },
        /* 12 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var MAX_FINDERPATTERNS_TO_SEARCH = 4;
            var MIN_QUAD_RATIO = 0.5;
            var MAX_QUAD_RATIO = 1.5;
            var distance = function(a, b) {
                return Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
            };
            function sum(values) {
                return values.reduce(function(a, b) {
                    return a + b;
                });
            }
            // Takes three finder patterns and organizes them into topLeft, topRight, etc
            function reorderFinderPatterns(pattern1, pattern2, pattern3) {
                var _a, _b, _c, _d;
                // Find distances between pattern centers
                var oneTwoDistance = distance(pattern1, pattern2);
                var twoThreeDistance = distance(pattern2, pattern3);
                var oneThreeDistance = distance(pattern1, pattern3);
                var bottomLeft;
                var topLeft;
                var topRight;
                // Assume one closest to other two is B; A and C will just be guesses at first
                if (twoThreeDistance >= oneTwoDistance && twoThreeDistance >= oneThreeDistance) _a = [
                    pattern2,
                    pattern1,
                    pattern3
                ], bottomLeft = _a[0], topLeft = _a[1], topRight = _a[2];
                else if (oneThreeDistance >= twoThreeDistance && oneThreeDistance >= oneTwoDistance) _b = [
                    pattern1,
                    pattern2,
                    pattern3
                ], bottomLeft = _b[0], topLeft = _b[1], topRight = _b[2];
                else _c = [
                    pattern1,
                    pattern3,
                    pattern2
                ], bottomLeft = _c[0], topLeft = _c[1], topRight = _c[2];
                // Use cross product to figure out whether bottomLeft (A) and topRight (C) are correct or flipped in relation to topLeft (B)
                // This asks whether BC x BA has a positive z component, which is the arrangement we want. If it's negative, then
                // we've got it flipped around and should swap topRight and bottomLeft.
                if ((topRight.x - topLeft.x) * (bottomLeft.y - topLeft.y) - (topRight.y - topLeft.y) * (bottomLeft.x - topLeft.x) < 0) _d = [
                    topRight,
                    bottomLeft
                ], bottomLeft = _d[0], topRight = _d[1];
                return {
                    bottomLeft: bottomLeft,
                    topLeft: topLeft,
                    topRight: topRight
                };
            }
            // Computes the dimension (number of modules on a side) of the QR Code based on the position of the finder patterns
            function computeDimension(topLeft, topRight, bottomLeft, matrix) {
                var moduleSize = (sum(countBlackWhiteRun(topLeft, bottomLeft, matrix, 5)) / 7 + // Divide by 7 since the ratio is 1:1:3:1:1
                sum(countBlackWhiteRun(topLeft, topRight, matrix, 5)) / 7 + sum(countBlackWhiteRun(bottomLeft, topLeft, matrix, 5)) / 7 + sum(countBlackWhiteRun(topRight, topLeft, matrix, 5)) / 7) / 4;
                if (moduleSize < 1) throw new Error("Invalid module size");
                var topDimension = Math.round(distance(topLeft, topRight) / moduleSize);
                var sideDimension = Math.round(distance(topLeft, bottomLeft) / moduleSize);
                var dimension = Math.floor((topDimension + sideDimension) / 2) + 7;
                switch(dimension % 4){
                    case 0:
                        dimension++;
                        break;
                    case 2:
                        dimension--;
                        break;
                }
                return {
                    dimension: dimension,
                    moduleSize: moduleSize
                };
            }
            // Takes an origin point and an end point and counts the sizes of the black white run from the origin towards the end point.
            // Returns an array of elements, representing the pixel size of the black white run.
            // Uses a variant of http://en.wikipedia.org/wiki/Bresenham's_line_algorithm
            function countBlackWhiteRunTowardsPoint(origin, end, matrix, length) {
                var switchPoints = [
                    {
                        x: Math.floor(origin.x),
                        y: Math.floor(origin.y)
                    }
                ];
                var steep = Math.abs(end.y - origin.y) > Math.abs(end.x - origin.x);
                var fromX;
                var fromY;
                var toX;
                var toY;
                if (steep) {
                    fromX = Math.floor(origin.y);
                    fromY = Math.floor(origin.x);
                    toX = Math.floor(end.y);
                    toY = Math.floor(end.x);
                } else {
                    fromX = Math.floor(origin.x);
                    fromY = Math.floor(origin.y);
                    toX = Math.floor(end.x);
                    toY = Math.floor(end.y);
                }
                var dx = Math.abs(toX - fromX);
                var dy = Math.abs(toY - fromY);
                var error = Math.floor(-dx / 2);
                var xStep = fromX < toX ? 1 : -1;
                var yStep = fromY < toY ? 1 : -1;
                var currentPixel = true;
                // Loop up until x == toX, but not beyond
                for(var x = fromX, y = fromY; x !== toX + xStep; x += xStep){
                    // Does current pixel mean we have moved white to black or vice versa?
                    // Scanning black in state 0,2 and white in state 1, so if we find the wrong
                    // color, advance to next state or end if we are in state 2 already
                    var realX = steep ? y : x;
                    var realY = steep ? x : y;
                    if (matrix.get(realX, realY) !== currentPixel) {
                        currentPixel = !currentPixel;
                        switchPoints.push({
                            x: realX,
                            y: realY
                        });
                        if (switchPoints.length === length + 1) break;
                    }
                    error += dy;
                    if (error > 0) {
                        if (y === toY) break;
                        y += yStep;
                        error -= dx;
                    }
                }
                var distances = [];
                for(var i = 0; i < length; i++)if (switchPoints[i] && switchPoints[i + 1]) distances.push(distance(switchPoints[i], switchPoints[i + 1]));
                else distances.push(0);
                return distances;
            }
            // Takes an origin point and an end point and counts the sizes of the black white run in the origin point
            // along the line that intersects with the end point. Returns an array of elements, representing the pixel sizes
            // of the black white run. Takes a length which represents the number of switches from black to white to look for.
            function countBlackWhiteRun(origin, end, matrix, length) {
                var _a;
                var rise = end.y - origin.y;
                var run = end.x - origin.x;
                var towardsEnd = countBlackWhiteRunTowardsPoint(origin, end, matrix, Math.ceil(length / 2));
                var awayFromEnd = countBlackWhiteRunTowardsPoint(origin, {
                    x: origin.x - run,
                    y: origin.y - rise
                }, matrix, Math.ceil(length / 2));
                var middleValue = towardsEnd.shift() + awayFromEnd.shift() - 1; // Substract one so we don't double count a pixel
                return (_a = awayFromEnd.concat(middleValue)).concat.apply(_a, towardsEnd);
            }
            // Takes in a black white run and an array of expected ratios. Returns the average size of the run as well as the "error" -
            // that is the amount the run diverges from the expected ratio
            function scoreBlackWhiteRun(sequence, ratios) {
                var averageSize = sum(sequence) / sum(ratios);
                var error = 0;
                ratios.forEach(function(ratio, i) {
                    error += Math.pow(sequence[i] - ratio * averageSize, 2);
                });
                return {
                    averageSize: averageSize,
                    error: error
                };
            }
            // Takes an X,Y point and an array of sizes and scores the point against those ratios.
            // For example for a finder pattern takes the ratio list of 1:1:3:1:1 and checks horizontal, vertical and diagonal ratios
            // against that.
            function scorePattern(point, ratios, matrix) {
                try {
                    var horizontalRun = countBlackWhiteRun(point, {
                        x: -1,
                        y: point.y
                    }, matrix, ratios.length);
                    var verticalRun = countBlackWhiteRun(point, {
                        x: point.x,
                        y: -1
                    }, matrix, ratios.length);
                    var topLeftPoint = {
                        x: Math.max(0, point.x - point.y) - 1,
                        y: Math.max(0, point.y - point.x) - 1
                    };
                    var topLeftBottomRightRun = countBlackWhiteRun(point, topLeftPoint, matrix, ratios.length);
                    var bottomLeftPoint = {
                        x: Math.min(matrix.width, point.x + point.y) + 1,
                        y: Math.min(matrix.height, point.y + point.x) + 1
                    };
                    var bottomLeftTopRightRun = countBlackWhiteRun(point, bottomLeftPoint, matrix, ratios.length);
                    var horzError = scoreBlackWhiteRun(horizontalRun, ratios);
                    var vertError = scoreBlackWhiteRun(verticalRun, ratios);
                    var diagDownError = scoreBlackWhiteRun(topLeftBottomRightRun, ratios);
                    var diagUpError = scoreBlackWhiteRun(bottomLeftTopRightRun, ratios);
                    var ratioError = Math.sqrt(horzError.error * horzError.error + vertError.error * vertError.error + diagDownError.error * diagDownError.error + diagUpError.error * diagUpError.error);
                    var avgSize = (horzError.averageSize + vertError.averageSize + diagDownError.averageSize + diagUpError.averageSize) / 4;
                    var sizeError = (Math.pow(horzError.averageSize - avgSize, 2) + Math.pow(vertError.averageSize - avgSize, 2) + Math.pow(diagDownError.averageSize - avgSize, 2) + Math.pow(diagUpError.averageSize - avgSize, 2)) / avgSize;
                    return ratioError + sizeError;
                } catch (_a) {
                    return Infinity;
                }
            }
            function recenterLocation(matrix, p) {
                var leftX = Math.round(p.x);
                while(matrix.get(leftX, Math.round(p.y)))leftX--;
                var rightX = Math.round(p.x);
                while(matrix.get(rightX, Math.round(p.y)))rightX++;
                var x = (leftX + rightX) / 2;
                var topY = Math.round(p.y);
                while(matrix.get(Math.round(x), topY))topY--;
                var bottomY = Math.round(p.y);
                while(matrix.get(Math.round(x), bottomY))bottomY++;
                var y = (topY + bottomY) / 2;
                return {
                    x: x,
                    y: y
                };
            }
            function locate(matrix) {
                var finderPatternQuads = [];
                var activeFinderPatternQuads = [];
                var alignmentPatternQuads = [];
                var activeAlignmentPatternQuads = [];
                var _loop_1 = function(y) {
                    var length_1 = 0;
                    var lastBit = false;
                    var scans = [
                        0,
                        0,
                        0,
                        0,
                        0
                    ];
                    var _loop_2 = function(x) {
                        var v = matrix.get(x, y);
                        if (v === lastBit) length_1++;
                        else {
                            scans = [
                                scans[1],
                                scans[2],
                                scans[3],
                                scans[4],
                                length_1
                            ];
                            length_1 = 1;
                            lastBit = v;
                            // Do the last 5 color changes ~ match the expected ratio for a finder pattern? 1:1:3:1:1 of b:w:b:w:b
                            var averageFinderPatternBlocksize = sum(scans) / 7;
                            var validFinderPattern = Math.abs(scans[0] - averageFinderPatternBlocksize) < averageFinderPatternBlocksize && Math.abs(scans[1] - averageFinderPatternBlocksize) < averageFinderPatternBlocksize && Math.abs(scans[2] - 3 * averageFinderPatternBlocksize) < 3 * averageFinderPatternBlocksize && Math.abs(scans[3] - averageFinderPatternBlocksize) < averageFinderPatternBlocksize && Math.abs(scans[4] - averageFinderPatternBlocksize) < averageFinderPatternBlocksize && !v; // And make sure the current pixel is white since finder patterns are bordered in white
                            // Do the last 3 color changes ~ match the expected ratio for an alignment pattern? 1:1:1 of w:b:w
                            var averageAlignmentPatternBlocksize = sum(scans.slice(-3)) / 3;
                            var validAlignmentPattern = Math.abs(scans[2] - averageAlignmentPatternBlocksize) < averageAlignmentPatternBlocksize && Math.abs(scans[3] - averageAlignmentPatternBlocksize) < averageAlignmentPatternBlocksize && Math.abs(scans[4] - averageAlignmentPatternBlocksize) < averageAlignmentPatternBlocksize && v; // Is the current pixel black since alignment patterns are bordered in black
                            if (validFinderPattern) {
                                // Compute the start and end x values of the large center black square
                                var endX_1 = x - scans[3] - scans[4];
                                var startX_1 = endX_1 - scans[2];
                                var line = {
                                    startX: startX_1,
                                    endX: endX_1,
                                    y: y
                                };
                                // Is there a quad directly above the current spot? If so, extend it with the new line. Otherwise, create a new quad with
                                // that line as the starting point.
                                var matchingQuads = activeFinderPatternQuads.filter(function(q) {
                                    return startX_1 >= q.bottom.startX && startX_1 <= q.bottom.endX || endX_1 >= q.bottom.startX && startX_1 <= q.bottom.endX || startX_1 <= q.bottom.startX && endX_1 >= q.bottom.endX && scans[2] / (q.bottom.endX - q.bottom.startX) < MAX_QUAD_RATIO && scans[2] / (q.bottom.endX - q.bottom.startX) > MIN_QUAD_RATIO;
                                });
                                if (matchingQuads.length > 0) matchingQuads[0].bottom = line;
                                else activeFinderPatternQuads.push({
                                    top: line,
                                    bottom: line
                                });
                            }
                            if (validAlignmentPattern) {
                                // Compute the start and end x values of the center black square
                                var endX_2 = x - scans[4];
                                var startX_2 = endX_2 - scans[3];
                                var line = {
                                    startX: startX_2,
                                    y: y,
                                    endX: endX_2
                                };
                                // Is there a quad directly above the current spot? If so, extend it with the new line. Otherwise, create a new quad with
                                // that line as the starting point.
                                var matchingQuads = activeAlignmentPatternQuads.filter(function(q) {
                                    return startX_2 >= q.bottom.startX && startX_2 <= q.bottom.endX || endX_2 >= q.bottom.startX && startX_2 <= q.bottom.endX || startX_2 <= q.bottom.startX && endX_2 >= q.bottom.endX && scans[2] / (q.bottom.endX - q.bottom.startX) < MAX_QUAD_RATIO && scans[2] / (q.bottom.endX - q.bottom.startX) > MIN_QUAD_RATIO;
                                });
                                if (matchingQuads.length > 0) matchingQuads[0].bottom = line;
                                else activeAlignmentPatternQuads.push({
                                    top: line,
                                    bottom: line
                                });
                            }
                        }
                    };
                    for(var x = -1; x <= matrix.width; x++)_loop_2(x);
                    finderPatternQuads.push.apply(finderPatternQuads, activeFinderPatternQuads.filter(function(q) {
                        return q.bottom.y !== y && q.bottom.y - q.top.y >= 2;
                    }));
                    activeFinderPatternQuads = activeFinderPatternQuads.filter(function(q) {
                        return q.bottom.y === y;
                    });
                    alignmentPatternQuads.push.apply(alignmentPatternQuads, activeAlignmentPatternQuads.filter(function(q) {
                        return q.bottom.y !== y;
                    }));
                    activeAlignmentPatternQuads = activeAlignmentPatternQuads.filter(function(q) {
                        return q.bottom.y === y;
                    });
                };
                for(var y = 0; y <= matrix.height; y++)_loop_1(y);
                finderPatternQuads.push.apply(finderPatternQuads, activeFinderPatternQuads.filter(function(q) {
                    return q.bottom.y - q.top.y >= 2;
                }));
                alignmentPatternQuads.push.apply(alignmentPatternQuads, activeAlignmentPatternQuads);
                var finderPatternGroups = finderPatternQuads.filter(function(q) {
                    return q.bottom.y - q.top.y >= 2;
                }) // All quads must be at least 2px tall since the center square is larger than a block
                .map(function(q) {
                    var x = (q.top.startX + q.top.endX + q.bottom.startX + q.bottom.endX) / 4;
                    var y = (q.top.y + q.bottom.y + 1) / 2;
                    if (!matrix.get(Math.round(x), Math.round(y))) return;
                    var lengths = [
                        q.top.endX - q.top.startX,
                        q.bottom.endX - q.bottom.startX,
                        q.bottom.y - q.top.y + 1
                    ];
                    var size = sum(lengths) / lengths.length;
                    var score = scorePattern({
                        x: Math.round(x),
                        y: Math.round(y)
                    }, [
                        1,
                        1,
                        3,
                        1,
                        1
                    ], matrix);
                    return {
                        score: score,
                        x: x,
                        y: y,
                        size: size
                    };
                }).filter(function(q) {
                    return !!q;
                }) // Filter out any rejected quads from above
                .sort(function(a, b) {
                    return a.score - b.score;
                })// Now take the top finder pattern options and try to find 2 other options with a similar size.
                .map(function(point, i, finderPatterns) {
                    if (i > MAX_FINDERPATTERNS_TO_SEARCH) return null;
                    var otherPoints = finderPatterns.filter(function(p, ii) {
                        return i !== ii;
                    }).map(function(p) {
                        return {
                            x: p.x,
                            y: p.y,
                            score: p.score + Math.pow(p.size - point.size, 2) / point.size,
                            size: p.size
                        };
                    }).sort(function(a, b) {
                        return a.score - b.score;
                    });
                    if (otherPoints.length < 2) return null;
                    var score = point.score + otherPoints[0].score + otherPoints[1].score;
                    return {
                        points: [
                            point
                        ].concat(otherPoints.slice(0, 2)),
                        score: score
                    };
                }).filter(function(q) {
                    return !!q;
                }) // Filter out any rejected finder patterns from above
                .sort(function(a, b) {
                    return a.score - b.score;
                });
                if (finderPatternGroups.length === 0) return null;
                var _a = reorderFinderPatterns(finderPatternGroups[0].points[0], finderPatternGroups[0].points[1], finderPatternGroups[0].points[2]), topRight = _a.topRight, topLeft = _a.topLeft, bottomLeft = _a.bottomLeft;
                var alignment = findAlignmentPattern(matrix, alignmentPatternQuads, topRight, topLeft, bottomLeft);
                var result = [];
                if (alignment) result.push({
                    alignmentPattern: {
                        x: alignment.alignmentPattern.x,
                        y: alignment.alignmentPattern.y
                    },
                    bottomLeft: {
                        x: bottomLeft.x,
                        y: bottomLeft.y
                    },
                    dimension: alignment.dimension,
                    topLeft: {
                        x: topLeft.x,
                        y: topLeft.y
                    },
                    topRight: {
                        x: topRight.x,
                        y: topRight.y
                    }
                });
                // We normally use the center of the quads as the location of the tracking points, which is optimal for most cases and will account
                // for a skew in the image. However, In some cases, a slight skew might not be real and instead be caused by image compression
                // errors and/or low resolution. For those cases, we'd be better off centering the point exactly in the middle of the black area. We
                // compute and return the location data for the naively centered points as it is little additional work and allows for multiple
                // attempts at decoding harder images.
                var midTopRight = recenterLocation(matrix, topRight);
                var midTopLeft = recenterLocation(matrix, topLeft);
                var midBottomLeft = recenterLocation(matrix, bottomLeft);
                var centeredAlignment = findAlignmentPattern(matrix, alignmentPatternQuads, midTopRight, midTopLeft, midBottomLeft);
                if (centeredAlignment) result.push({
                    alignmentPattern: {
                        x: centeredAlignment.alignmentPattern.x,
                        y: centeredAlignment.alignmentPattern.y
                    },
                    bottomLeft: {
                        x: midBottomLeft.x,
                        y: midBottomLeft.y
                    },
                    topLeft: {
                        x: midTopLeft.x,
                        y: midTopLeft.y
                    },
                    topRight: {
                        x: midTopRight.x,
                        y: midTopRight.y
                    },
                    dimension: centeredAlignment.dimension
                });
                if (result.length === 0) return null;
                return result;
            }
            exports.locate = locate;
            function findAlignmentPattern(matrix, alignmentPatternQuads, topRight, topLeft, bottomLeft) {
                var _a;
                // Now that we've found the three finder patterns we can determine the blockSize and the size of the QR code.
                // We'll use these to help find the alignment pattern but also later when we do the extraction.
                var dimension;
                var moduleSize;
                try {
                    _a = computeDimension(topLeft, topRight, bottomLeft, matrix), dimension = _a.dimension, moduleSize = _a.moduleSize;
                } catch (e) {
                    return null;
                }
                // Now find the alignment pattern
                var bottomRightFinderPattern = {
                    x: topRight.x - topLeft.x + bottomLeft.x,
                    y: topRight.y - topLeft.y + bottomLeft.y
                };
                var modulesBetweenFinderPatterns = (distance(topLeft, bottomLeft) + distance(topLeft, topRight)) / 2 / moduleSize;
                var correctionToTopLeft = 1 - 3 / modulesBetweenFinderPatterns;
                var expectedAlignmentPattern = {
                    x: topLeft.x + correctionToTopLeft * (bottomRightFinderPattern.x - topLeft.x),
                    y: topLeft.y + correctionToTopLeft * (bottomRightFinderPattern.y - topLeft.y)
                };
                var alignmentPatterns = alignmentPatternQuads.map(function(q) {
                    var x = (q.top.startX + q.top.endX + q.bottom.startX + q.bottom.endX) / 4;
                    var y = (q.top.y + q.bottom.y + 1) / 2;
                    if (!matrix.get(Math.floor(x), Math.floor(y))) return;
                    var lengths = [
                        q.top.endX - q.top.startX,
                        q.bottom.endX - q.bottom.startX,
                        q.bottom.y - q.top.y + 1
                    ];
                    var size = sum(lengths) / lengths.length;
                    var sizeScore = scorePattern({
                        x: Math.floor(x),
                        y: Math.floor(y)
                    }, [
                        1,
                        1,
                        1
                    ], matrix);
                    var score = sizeScore + distance({
                        x: x,
                        y: y
                    }, expectedAlignmentPattern);
                    return {
                        x: x,
                        y: y,
                        score: score
                    };
                }).filter(function(v) {
                    return !!v;
                }).sort(function(a, b) {
                    return a.score - b.score;
                });
                // If there are less than 15 modules between finder patterns it's a version 1 QR code and as such has no alignmemnt pattern
                // so we can only use our best guess.
                var alignmentPattern = modulesBetweenFinderPatterns >= 15 && alignmentPatterns.length ? alignmentPatterns[0] : expectedAlignmentPattern;
                return {
                    alignmentPattern: alignmentPattern,
                    dimension: dimension
                };
            }
        /***/ }
    ])["default"];
});


const $1a67725c098c7e16$var$$talkBack = document.getElementById('talk-back');
const $1a67725c098c7e16$var$$fitToggle = document.getElementById('fit-toggle');
const $1a67725c098c7e16$var$$muteToggle = document.getElementById('mute-toggle');
const $1a67725c098c7e16$var$$alertsToggle = document.getElementById('alerts-toggle');
const $1a67725c098c7e16$var$$melodyToggle = document.getElementById('melody-toggle');
const $1a67725c098c7e16$var$$invite = document.getElementById('invite');
const $1a67725c098c7e16$var$$inviteOverlay = document.getElementById('invite-overlay');
const $1a67725c098c7e16$var$$inviteCopy = document.getElementById('invite-copy');
const $1a67725c098c7e16$var$$othersBadge = document.getElementById('others-badge');
const $1a67725c098c7e16$var$$clientStatus = document.getElementById('client-status');
const $1a67725c098c7e16$var$$soundIndicator = document.getElementById('sound-indicator');
const $1a67725c098c7e16$var$$batteryIndicator = document.getElementById('battery-indicator');
const $1a67725c098c7e16$var$$scanVideo = document.getElementById('scan-video');
const $1a67725c098c7e16$var$$startScan = document.getElementById('start-scan');
const $1a67725c098c7e16$var$ALERT_KEY = 'peekababy:cry-alert';
// Remembers the parent's framing (fit mode + zoom + pan) per monitor so the same
// picture is restored after a reconnect or a full reload, instead of snapping
// back to the default 1× cover view.
const $1a67725c098c7e16$var$VIEW_KEY = 'peekababy:view';
// Normalised (0..1) loudness bands for the passive "time since sound" readout.
const $1a67725c098c7e16$var$SOUND_ON = 0.15;
// Leading glyphs for instructional toasts (e.g. "Add the app to your Home
// Screen"), so the parent recognises the platform action at a glance. Static,
// trusted markup — never interpolate user text into these. `ios` is the Share
// sheet glyph (tap Share → Add to Home Screen); `android` is the app-to-phone
// "install / add to Home screen" glyph.
const $1a67725c098c7e16$var$HINT_ICONS = {
    ios: '<svg class="toast-hint-ico" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 15V4"/><path d="m8 8 4-4 4 4"/><path d="M7 12H5.5A1.5 1.5 0 0 0 4 13.5v5A1.5 1.5 0 0 0 5.5 20h13a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 18.5 12H17"/></svg>',
    android: '<svg class="toast-hint-ico" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="6" y="3" width="12" height="18" rx="2.5"/><path d="M12 8.5v5M9.5 11h5"/></svg>'
};
// A dropped link usually self-heals within seconds (a Wi-Fi<->mobile handoff or
// an ICE blip), so we don't nag on every blip. If it doesn't recover we escalate
// in two stages, since a monitor that stays unreachable means no eyes on the
// baby:
//   1. After OUTAGE_SOFT_DELAY (20s) — a light, repeating heads-up (soft cue +
//      short buzz) every OUTAGE_SOFT_INTERVAL, so the parent notices without
//      being alarmed for what may still be a passing blip.
//   2. After OUTAGE_ALARM_DELAY (60s) — drop the light cue and escalate to a
//      loud, clear alarm (bright tone + strong buzz) every OUTAGE_BEEP_INTERVAL
//      until the feed recovers.
// Foreground-only: Web Audio and timers are suspended when the tab is
// backgrounded, so this covers "watching on a nearby phone"; locked-phone
// coverage needs Web Push.
const $1a67725c098c7e16$var$OUTAGE_SOFT_DELAY = 20000;
const $1a67725c098c7e16$var$OUTAGE_SOFT_INTERVAL = 20000;
const $1a67725c098c7e16$var$OUTAGE_ALARM_DELAY = 60000;
const $1a67725c098c7e16$var$OUTAGE_BEEP_INTERVAL = 10000;
// A single short buzz for the light stage — a gentle tap on the shoulder.
const $1a67725c098c7e16$var$OUTAGE_SOFT_VIBRATE = [
    180
];
// Long, insistent buzz pattern (three strong pulses) for the loud stage, so a
// sustained outage is felt clearly even with the phone in a pocket or face-down
// on a nightstand.
const $1a67725c098c7e16$var$OUTAGE_VIBRATE = [
    500,
    150,
    500,
    150,
    500
];
// After this many dial attempts that never produced a live feed, swap the
// endless "Reconnecting…" for an honest "can't reach this monitor" hint — a feed
// that never once connected is almost always a stale/expired link, not a blip.
// We keep retrying in the background so a monitor that comes up late still
// connects and clears the hint.
const $1a67725c098c7e16$var$PRELIVE_FAIL_LIMIT = 4;
// How often to check that the metadata channel is still up and reopen it if not.
// Cosmetic data (count) plus the battery warning and live-frame heartbeat ride
// it, so a few seconds of lag on recovery is fine; the poll stays cheap.
const $1a67725c098c7e16$var$DC_SUPERVISOR_MS = 3000;
// Decode-stall tolerance, in 2s liveness ticks. Normally ~8s of no new decoded
// frames means the feed is dead. But a capped encoder on a still, dark nursery
// legitimately delivers very few frames, so when the monitor's heartbeat proves
// the camera is still producing frames we wait far longer before re-dialing.
const $1a67725c098c7e16$var$STALE_TICKS_NORMAL = 4;
const $1a67725c098c7e16$var$STALE_TICKS_SOURCE_LIVE = 15;
// Parent focus (immersive) mode: after this long with no interaction on a live
// feed, fade the chrome away so only the picture and the "Live" pill remain.
const $1a67725c098c7e16$var$FOCUS_IDLE_DELAY = 20000;
// Change in acceleration magnitude (m/s²) that counts as a deliberate move —
// picking the phone up or nudging it — versus resting jitter. Comparing the
// delta works whether the browser reports gravity-free `acceleration` (rests
// near 0) or `accelerationIncludingGravity` (rests near 9.8).
const $1a67725c098c7e16$var$MOTION_WAKE_DELTA = 2.2;
class $1a67725c098c7e16$export$2e2bcd8739ae039 {
    // Show the QR scanner and make its "Open camera" button tappable. Used for the
    // initial no-host flow and as a fallback when a remembered/deep-linked monitor
    // can't be reached, so the parent always has a way to re-scan or go Back.
    revealScanner() {
        document.body.classList.add('need-scan');
        // app.js may have disabled the button while it revealed the scanner early for
        // the entry morph; it's safe to enable now that the handler is attached.
        if ($1a67725c098c7e16$var$$startScan) $1a67725c098c7e16$var$$startScan.disabled = false;
    }
    // ---- QR scanning (parent) ------------------------------------------------
    async startScan() {
        if (this.scanning) return;
        try {
            this.scanStream = await navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: 'environment'
                },
                audio: false
            });
        } catch (err) {
            this.setScanHint((0, $03c039b69e20a322$export$625550452a3fa3ec)('scan.cameraNeeded'));
            console.warn('[CLIENT] scan camera failed', err && err.name);
            return;
        }
        this.scanning = true;
        document.body.classList.add('scanning');
        if ($1a67725c098c7e16$var$$startScan) $1a67725c098c7e16$var$$startScan.textContent = (0, $03c039b69e20a322$export$625550452a3fa3ec)('scan.scanning');
        $1a67725c098c7e16$var$$scanVideo.srcObject = this.scanStream;
        $1a67725c098c7e16$var$$scanVideo.setAttribute('playsinline', '');
        try {
            await $1a67725c098c7e16$var$$scanVideo.play();
        } catch (e) {}
        const detector = 'BarcodeDetector' in window ? new window.BarcodeDetector({
            formats: [
                'qr_code'
            ]
        }) : null;
        let nativeDetector = detector;
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d', {
            willReadFrequently: true
        });
        const tick = async ()=>{
            if (!this.scanning) return;
            let text = null;
            if ($1a67725c098c7e16$var$$scanVideo.readyState >= 2 && $1a67725c098c7e16$var$$scanVideo.videoWidth) {
                if (nativeDetector) try {
                    const codes = await nativeDetector.detect($1a67725c098c7e16$var$$scanVideo);
                    if (codes && codes.length) text = codes[0].rawValue;
                } catch (e) {
                    nativeDetector = null; // fall back to jsQR
                }
                if (!text) {
                    canvas.width = $1a67725c098c7e16$var$$scanVideo.videoWidth;
                    canvas.height = $1a67725c098c7e16$var$$scanVideo.videoHeight;
                    ctx.drawImage($1a67725c098c7e16$var$$scanVideo, 0, 0, canvas.width, canvas.height);
                    const img = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    const res = (0, (/*@__PURE__*/$parcel$interopDefault($643776b5d2f2433f$exports)))(img.data, img.width, img.height, {
                        inversionAttempts: 'dontInvert'
                    });
                    if (res && res.data) text = res.data;
                }
            }
            // A code that isn't one of our links is ignored and scanning continues.
            const id = text ? this.parseHostId(text) : null;
            if (id) return this.onScanResult(id);
            this.scanRaf = requestAnimationFrame(tick);
        };
        this.scanRaf = requestAnimationFrame(tick);
    }
    onScanResult(id) {
        this.stopScan();
        (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).QR_SCANNED);
        // Scanning a different monitor: drop any channel still pointed at the old one
        // so the supervisor reopens it against the new host rather than leaving a dead
        // reference in place.
        if (this.dc && id !== this.hostId) {
            try {
                this.dc.close();
            } catch (e) {}
            this.dc = null;
        }
        this.hostId = id;
        // Cancel any retry still pending from a prior target (the scanner can be
        // shown as a fallback while a failed connect keeps retrying in the
        // background). Without this, that timer would fire placeCall() alongside the
        // one below and dial the freshly scanned monitor twice, leaking a duplicate
        // call. beginConnection -> placeCall re-arms the retry as needed.
        clearTimeout(this.retryTimer);
        this.retryTimer = null;
        // Cross-fade the scanner out to the connecting state; the logo fades with it
        // (no matching element on the live view, so it eases out cleanly).
        (0, $b68ecd39b69a2afc$export$20ac98a4b4fe8b85)(()=>document.body.classList.remove('need-scan'));
        this.beginConnection();
    }
    parseHostId(text) {
        if (!text) return null;
        const hashIdx = text.indexOf('#');
        if (hashIdx !== -1) {
            const id = text.slice(hashIdx + 1).trim();
            return id || null;
        }
        // Bare id (no URL) — accept a plausible peer id token.
        if (/^[A-Za-z0-9_-]{6,}$/.test(text.trim())) return text.trim();
        return null;
    }
    stopScan() {
        this.scanning = false;
        document.body.classList.remove('scanning');
        if (this.scanRaf) cancelAnimationFrame(this.scanRaf);
        this.scanRaf = 0;
        if (this.scanStream) {
            this.scanStream.getTracks().forEach((t)=>t.stop());
            this.scanStream = null;
        }
        try {
            $1a67725c098c7e16$var$$scanVideo.srcObject = null;
        } catch (e) {}
    }
    setScanHint(text) {
        const hint = document.getElementById('scan-hint');
        if (hint) hint.textContent = text;
    }
    // ---- Connection ----------------------------------------------------------
    beginConnection() {
        this.startDataChannelSupervisor();
        this.setStatus('connecting', (0, $03c039b69e20a322$export$625550452a3fa3ec)('status.connecting'));
        // Push-to-talk needs the mic, but a denied mic must not stop the parent from
        // watching — fall back to an empty stream so video still negotiates.
        navigator.mediaDevices.getUserMedia({
            video: false,
            audio: true
        }).then((audioStream)=>{
            this.audioStream = audioStream;
            this.setMicEnabled(false);
            this.placeCall();
        }).catch((err)=>{
            (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).MIC_ERROR, {
                name: err && err.name
            });
            console.error('[CLIENT] Could not access microphone', err);
            this.audioStream = new MediaStream();
            this.placeCall();
        });
    }
    placeCall() {
        clearTimeout(this.retryTimer);
        this.retryTimer = null;
        clearTimeout(this.watchdog);
        clearTimeout(this.disconnectGrace);
        // When this dial started, so the first 'stream' can report time-to-connect.
        this._dialStartedAt = Date.now();
        const call = this.peer.call(this.hostId, this.audioStream, {
            metadata: {
                clientId: this.identity.id,
                name: this.identity.name
            },
            constraints: {
                offerToReceiveVideo: true,
                offerToReceiveAudio: true
            }
        });
        if (!call) return this.scheduleReconnect();
        this.currentCall = call;
        // Try an in-place ICE restart before a full re-dial: on a blip this keeps the
        // picture up and skips a fresh DTLS handshake + getUserMedia. onGiveUp falls
        // back to the existing re-dial; onRecovered re-checks the (separate) data
        // channel, since no new 'stream' fires after a restart.
        this.iceRecovery = (0, $d16014fbca14af38$export$2a8b0ce368e0bd6c)(call.peerConnection, {
            peer: this.peer,
            remoteId: this.hostId,
            connectionId: call.connectionId,
            role: 'offerer',
            onGiveUp: ()=>this.scheduleReconnect(),
            onRecovered: ()=>{
                this.reconnectDelay = 1000;
                this.ensureDataChannel();
            }
        });
        this.watchdog = setTimeout(()=>this.scheduleReconnect(), 12000);
        call.on('stream', (remoteStream)=>{
            clearTimeout(this.watchdog);
            this.reconnectDelay = 1000;
            // Connected: clear any "not found" hint (and the scanner fallback) and its
            // failure streak.
            this.preLiveFailures = 0;
            document.body.classList.remove('not-found', 'need-scan');
            // Remember this monitor so a parent whose app was fully closed can rejoin
            // on reopen without going back to the room to re-scan (see app.js resume).
            (0, $b68ecd39b69a2afc$export$17fead10eae298d1)(this.hostId);
            // Make sure background alerts are subscribed under the host we actually
            // reached (fixes the scan flow, where hostId is set after init, and a host
            // that reclaimed/changed its id).
            this.maybeRefreshPush();
            // Feed is live: re-arm peer-error tracking so any *future* drop is logged
            // as a fresh outage instead of being suppressed as the last one's tail.
            (0, $4a7db14ce90fb7a4$export$733dd075a3dd9ee5)();
            $video.srcObject = remoteStream;
            (0, $b68ecd39b69a2afc$export$d6b8db0c5911d42e)(remoteStream, (level)=>this.onSoundLevel(level));
            this.playRemoteStream();
            // Re-assert the current framing on the new stream. The zoom/pan is kept
            // here; onVideoMetadata() only re-centres if the orientation flipped.
            this.applyFraming();
            // Ease the live picture in the first time it lands rather than snapping
            // it on; reconnections already have the stream up, so this is a no-op then.
            if (!document.body.classList.contains('has-stream')) (0, $b68ecd39b69a2afc$export$20ac98a4b4fe8b85)(()=>document.body.classList.add('has-stream'));
            else document.body.classList.add('has-stream');
            this.setStatus('live', (0, $03c039b69e20a322$export$625550452a3fa3ec)('status.live'));
            // A fresh live picture: reveal the controls and start the idle clock that
            // fades to the picture-only focus view (see initFocusMode).
            this.wakeControls();
            // Watch the actual media flow, not just ICE state: a WebRTC link can stay
            // "connected" while the picture silently freezes. This keeps the "Live"
            // dot honest and re-dials on a truly stalled feed.
            this.startLivenessWatch(call.peerConnection);
            this.openDataChannel();
            // Feed is back: silence any sustained-outage alarm regardless of whether
            // this is the first connect or a recovery.
            this.stopOutageAlarm();
            if (!this.connectionLive) {
                this.connectionLive = true;
                // Soft "we're back" cue on recovery only — the first connect is silent.
                if (this.everLive) (0, $1333db90c8a58227$export$3ba4ec205653abe3)();
                this.everLive = true;
                (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).STREAM_ESTABLISHED);
            }
            // Report how this connection was actually established (candidate types,
            // protocol, RTT) and how long it took. Deferred a beat so the selected
            // candidate pair is populated in getStats.
            this.reportConnection(call.peerConnection, this._dialStartedAt);
        });
        // A genuine close (remote hang-up / explicit teardown) still re-dials; but a
        // close racing an in-flight ICE restart must not, or we'd abandon the recovery.
        call.on('close', ()=>{
            if (this.iceRecovery && this.iceRecovery.isRecovering()) return;
            this.scheduleReconnect();
        });
        const pc = call.peerConnection;
        if (pc) pc.addEventListener('connectionstatechange', ()=>{
            const state = pc.connectionState;
            const recover = ()=>this.iceRecovery ? this.iceRecovery.recover('conn-' + state) : this.scheduleReconnect();
            if (state === 'failed') recover();
            else if (state === 'disconnected') {
                clearTimeout(this.disconnectGrace);
                this.disconnectGrace = setTimeout(()=>{
                    if ([
                        'disconnected',
                        'failed'
                    ].includes(pc.connectionState)) recover();
                }, 4000);
            } else if (state === 'connected') {
                clearTimeout(this.disconnectGrace);
                this.reconnectDelay = 1000;
            }
        });
    }
    teardownCall() {
        clearTimeout(this.watchdog);
        clearTimeout(this.disconnectGrace);
        this.stopLivenessWatch();
        // Drop the battery warning on any teardown; the host re-sends its state on
        // the next data channel, re-arming it if the battery is still low.
        this.clearBatteryWarning();
        if (this.iceRecovery) {
            this.iceRecovery.destroy();
            this.iceRecovery = null;
        }
        if (this.currentCall) {
            try {
                this.currentCall.close();
            } catch (e) {}
            this.currentCall = null;
        }
    }
    // ---- Liveness watchdog ---------------------------------------------------
    // Poll the peer connection's inbound stats for proof the *picture* is moving,
    // not just that some bytes are arriving. We key off decoded video frames: as
    // long as framesDecoded keeps climbing the decoder is producing pictures, so
    // the "Live" dot is truthful even for a perfectly still, sleeping baby. If it
    // stops for a stretch while the link still claims to be connected, the video
    // has frozen — drop to the reconnecting state and re-dial. (Summing raw bytes
    // wasn't enough: audio keeps bytes flowing, so a frozen picture could have
    // masqueraded as live.)
    startLivenessWatch(pc) {
        this.stopLivenessWatch();
        if (!pc || typeof pc.getStats !== 'function') return;
        this._livePc = pc;
        this._lastLiveSignal = null;
        this._staleTicks = 0;
        // Fresh call: forget the previous connection's heartbeat so a stale counter
        // can't trip the source-freeze check before new heartbeats arrive.
        this.hostFrameSeq = null;
        this.hostFrameChangedAt = 0;
        this.hostHeartbeatAt = 0;
        this.clearCameraFrozen();
        this.livenessTimer = setInterval(()=>this.checkLiveness(), 2000);
    }
    // Record a camera-frame heartbeat from the monitor. We track when a heartbeat
    // last arrived (so we only trust the check while they're actually flowing) and
    // when the counter last changed (a frozen camera stops advancing it).
    noteHostFrame(seq) {
        if (seq == null) return;
        const now = Date.now();
        this.hostHeartbeatAt = now;
        if (seq !== this.hostFrameSeq) {
            this.hostFrameSeq = seq;
            this.hostFrameChangedAt = now;
            // New frames again: the camera resumed, so leave the frozen state.
            if (this.cameraFrozen) this.exitCameraFrozen();
        }
    }
    // Enter the dedicated "monitor camera frozen" state: the link is healthy so we
    // keep it (a re-dial can't un-freeze a camera), but the picture is stuck, so
    // we say so plainly and drop the green "Live" pill to an honest warning.
    enterCameraFrozen() {
        if (this.cameraFrozen) return;
        this.cameraFrozen = true;
        document.body.classList.add('camera-frozen');
        if ($1a67725c098c7e16$var$$clientStatus) {
            $1a67725c098c7e16$var$$clientStatus.classList.remove('live');
            $1a67725c098c7e16$var$$clientStatus.classList.add('warn');
            const $t = $1a67725c098c7e16$var$$clientStatus.querySelector('.status-text');
            if ($t) $t.textContent = (0, $03c039b69e20a322$export$625550452a3fa3ec)('status.cameraStopped');
        }
        (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).CAMERA_FROZEN);
        // Surface the controls (and, via canFocus, keep focus mode from hiding them
        // while this alert is up).
        this.wakeControls();
    }
    // Camera resumed while still connected: clear the state and restore Live.
    exitCameraFrozen() {
        if (!this.cameraFrozen) return;
        this.clearCameraFrozen();
        this.setStatus('live', (0, $03c039b69e20a322$export$625550452a3fa3ec)('status.live'));
        this.wakeControls();
    }
    // Drop the frozen flag/overlay without touching the pill — used when we're
    // transitioning into another state that owns the pill (reconnect, new call).
    clearCameraFrozen() {
        if (!this.cameraFrozen) return;
        this.cameraFrozen = false;
        document.body.classList.remove('camera-frozen');
    }
    stopLivenessWatch() {
        if (this.livenessTimer) clearInterval(this.livenessTimer);
        this.livenessTimer = null;
        this._livePc = null;
        this._lastLiveSignal = null;
        this._staleTicks = 0;
    }
    async checkLiveness() {
        const pc = this._livePc;
        if (!pc || typeof pc.getStats !== 'function') return;
        // An ICE restart briefly stops decoded frames by design; don't let the stall
        // detector tear it down before it can land (the restart has its own watchdog).
        if (this.iceRecovery && this.iceRecovery.isRecovering()) {
            this._staleTicks = 0;
            return;
        }
        let videoFrames = null; // decoded video frames — the true "picture is moving" signal
        let videoBytes = 0;
        let anyBytes = 0;
        try {
            const stats = await pc.getStats();
            stats.forEach((r)=>{
                if (r.type !== 'inbound-rtp') return;
                if (typeof r.bytesReceived === 'number') anyBytes += r.bytesReceived;
                const kind = r.kind || r.mediaType;
                if (kind !== 'video') return;
                if (typeof r.bytesReceived === 'number') videoBytes += r.bytesReceived;
                if (typeof r.framesDecoded === 'number') videoFrames = (videoFrames || 0) + r.framesDecoded;
            });
        } catch (e) {
            return; // transient; try again next tick
        }
        // Guard against a race where the watch was torn down mid-await.
        if (pc !== this._livePc) return;
        // Prefer decoded video frames; fall back to video bytes, then to total bytes
        // only if the browser exposes neither (very old getStats) — so we degrade
        // gracefully but never silently drop back to the audio-can-fake-it behaviour
        // when a better signal is available.
        const signal = videoFrames !== null ? videoFrames : videoBytes > 0 ? videoBytes : anyBytes;
        // Source-side liveness: the monitor's camera-frame heartbeat is still
        // arriving (fresh within ~6s) and its counter is still climbing. Only trusted
        // while heartbeats flow, so older monitors that don't send them are never
        // considered here.
        const now = Date.now();
        const heartbeatFresh = this.hostHeartbeatAt && now - this.hostHeartbeatAt < 6000;
        const sourceAdvancing = heartbeatFresh && this.hostFrameChangedAt && now - this.hostFrameChangedAt < 6000;
        // Decode-side staleness: our inbound video (or, failing that, any media)
        // stopped progressing while the link still claims to be connected. Allow a
        // few ticks (~8s) so a brief hiccup doesn't trigger a needless reconnect.
        // When the source is provably still producing frames, be far more patient:
        // a capped encoder on a near-static nursery legitimately sends very few
        // decoded frames, and tearing that down would loop pointless re-dials. A
        // genuinely dead media path stops the heartbeat too (separate connection) or
        // trips the ICE state handler, so the longer window is a safe backstop.
        const staleLimit = sourceAdvancing ? $1a67725c098c7e16$var$STALE_TICKS_SOURCE_LIVE : $1a67725c098c7e16$var$STALE_TICKS_NORMAL;
        let decodeStalled = false;
        if (this._lastLiveSignal === null) this._lastLiveSignal = signal;
        else if (signal > this._lastLiveSignal) {
            this._lastLiveSignal = signal;
            this._staleTicks = 0;
        } else {
            this._staleTicks += 1;
            if (this._staleTicks >= staleLimit) decodeStalled = true;
        }
        // Source-side staleness: the heartbeat is fresh but its counter has stopped
        // climbing — the camera at the monitor has frozen even though frames may
        // still be decoding here. A re-dial can't fix that, so it's handled as its
        // own state below rather than as an outage.
        const sourceStalled = heartbeatFresh && this.hostFrameChangedAt && now - this.hostFrameChangedAt > 8000;
        // If we're showing the frozen state but the heartbeats that justified it have
        // themselves stopped (e.g. the data channel dropped while the media call
        // stayed up), we can no longer confirm the camera is stuck. Give the benefit
        // of the doubt and fall back to the decode-based liveness rather than pinning
        // up an unverifiable overlay; a resumed heartbeat re-detects a real freeze.
        if (this.cameraFrozen && !heartbeatFresh) this.exitCameraFrozen();
        // A decode/network stall is a real outage — reconnect (and drop any frozen
        // state, since we're now genuinely offline). A source-only stall means the
        // link is fine but the monitor's camera stopped: hold the connection and
        // show the dedicated frozen state instead of looping a pointless re-dial.
        if (decodeStalled) {
            console.warn("[CLIENT] Live video stalled \u2014 reconnecting");
            this.scheduleReconnect();
        } else if (sourceStalled) this.enterCameraFrozen();
    }
    scheduleReconnect() {
        if (this.retryTimer) return;
        // A real outage supersedes the frozen state; the reconnecting flow owns the
        // pill/overlay from here.
        this.clearCameraFrozen();
        this.teardownCall();
        if (this.connectionLive) {
            this.connectionLive = false;
            // Soft "link dropped" cue. Guarded by connectionLive so it fires once per
            // outage, and never while first connecting.
            (0, $1333db90c8a58227$export$5bd7536aa57f2374)();
            (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).CONNECTION_LOST);
            // Arm the escalating alarm for an outage that doesn't self-heal. Started
            // here (not on every retry) since this block runs once per outage.
            this.startOutageAlarm();
        }
        // A feed that has never once gone live is very likely a stale/expired link;
        // after a few failed dials, say so plainly instead of "Reconnecting…"
        // forever. We still keep retrying, so a late-arriving host clears it.
        if (!this.everLive) this.preLiveFailures += 1;
        const notFound = !this.everLive && this.preLiveFailures >= $1a67725c098c7e16$var$PRELIVE_FAIL_LIMIT;
        document.body.classList.toggle('not-found', notFound);
        // A target we never reached (stale deep link, or a remembered monitor that's
        // now off): surface the scanner so the parent can re-scan or go Back, while
        // we keep retrying in the background in case the monitor comes back.
        if (notFound) this.revealScanner();
        this.setStatus('warn', (0, $03c039b69e20a322$export$625550452a3fa3ec)(notFound ? 'status.notFound' : 'status.reconnecting'));
        // Jitter each retry by ±25% so several parents dropped by the same event
        // (e.g. a monitor restart) don't redial in lockstep and stampede it.
        const jittered = Math.round(this.reconnectDelay * (0.75 + Math.random() * 0.5));
        console.warn(`[CLIENT] Connection lost \u{2014} retrying in ${jittered}ms`);
        this.retryTimer = setTimeout(()=>{
            this.retryTimer = null;
            this.placeCall();
        }, jittered);
        this.reconnectDelay = Math.min(this.reconnectDelay * 2, 15000);
    }
    // One-shot report of how a freshly live connection was established. Best-effort
    // and privacy-safe (see webrtc-stats.js): coarse candidate types only, so it's
    // safe under the analytics rules. The short delay lets the selected candidate
    // pair settle in getStats after the first frame.
    reportConnection(pc, startedAt) {
        if (!pc) return;
        setTimeout(async ()=>{
            const desc = await (0, $779ebb5208b6fff2$export$ea89b1e82df1a14f)(pc);
            if (!desc) return;
            (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).ICE_CONNECTED, {
                local: desc.local,
                remote: desc.remote,
                protocol: desc.protocol,
                rtt: desc.rtt,
                relayed: (0, $779ebb5208b6fff2$export$1af83275ca9f024e)(desc),
                ms: startedAt ? Date.now() - startedAt : null
            });
        }, 1500);
    }
    reconnectNow() {
        if (!this.audioStream) return;
        clearTimeout(this.retryTimer);
        this.retryTimer = null;
        this.teardownCall();
        this.reconnectDelay = 1000;
        this.placeCall();
    }
    // ---- Sustained-outage escalation (parent, foreground) --------------------
    // Two-stage escalation after a drop: a light, repeating heads-up from 20s, then
    // a loud, clear alarm from 60s, each on repeat until recovery. Foreground-only
    // by nature (Web Audio/timers pause when backgrounded); a locked phone relies
    // on Web Push instead.
    startOutageAlarm() {
        this.stopOutageAlarm();
        // Stage 1 (20s): light heads-up, repeated gently until the loud alarm takes
        // over at 60s.
        this.outageSoftTimer = setTimeout(()=>{
            this.outageSoftTimer = null;
            this.outageSoftNudge();
            this.outageSoftTimer2 = setInterval(()=>this.outageSoftNudge(), $1a67725c098c7e16$var$OUTAGE_SOFT_INTERVAL);
        }, $1a67725c098c7e16$var$OUTAGE_SOFT_DELAY);
        // Stage 2 (60s): stop the light cue and escalate to a loud alarm on repeat.
        this.outageArmTimer = setTimeout(()=>{
            this.outageArmTimer = null;
            clearInterval(this.outageSoftTimer2);
            this.outageSoftTimer2 = null;
            (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).OUTAGE_ALARM);
            this.outageBeep();
            this.outageBeepTimer = setInterval(()=>this.outageBeep(), $1a67725c098c7e16$var$OUTAGE_BEEP_INTERVAL);
        }, $1a67725c098c7e16$var$OUTAGE_ALARM_DELAY);
    }
    // Light stage: a soft cue plus a single short buzz — noticeable, not alarming.
    outageSoftNudge() {
        (0, $1333db90c8a58227$export$5bd7536aa57f2374)();
        if (navigator.vibrate) try {
            navigator.vibrate($1a67725c098c7e16$var$OUTAGE_SOFT_VIBRATE);
        } catch (e) {}
    }
    // Loud stage: the bright alarm tone plus a strong, insistent buzz.
    outageBeep() {
        (0, $1333db90c8a58227$export$3f13a3f5264bdf37)();
        if (navigator.vibrate) try {
            navigator.vibrate($1a67725c098c7e16$var$OUTAGE_VIBRATE);
        } catch (e) {}
    }
    stopOutageAlarm() {
        clearTimeout(this.outageSoftTimer);
        clearInterval(this.outageSoftTimer2);
        clearTimeout(this.outageArmTimer);
        clearInterval(this.outageBeepTimer);
        this.outageSoftTimer = null;
        this.outageSoftTimer2 = null;
        this.outageArmTimer = null;
        this.outageBeepTimer = null;
    }
    // The OS reports the current network went away (typically a Wi-Fi <-> mobile
    // handoff). If we were live, show the reconnecting state immediately rather
    // than letting the frozen picture linger until ICE times out.
    onNetworkLost() {
        if (!this.hostId || !this.everLive) return;
        this.scheduleReconnect();
    }
    resumeIfNeeded() {
        if (document.visibilityState !== 'visible') return;
        if (!this.hostId) return; // still on the scan screen
        if (this.resumeGuard) return;
        this.resumeGuard = setTimeout(()=>{
            this.resumeGuard = null;
        }, 800);
        if (this.peer && this.peer.disconnected && !this.peer.destroyed) try {
            this.peer.reconnect();
        } catch (e) {}
        const pc = this.currentCall && this.currentCall.peerConnection;
        const alive = pc && pc.connectionState === 'connected';
        if (!alive) this.reconnectNow();
        else {
            // Link is fine, but a channel dropped while backgrounded is exactly the
            // gap the supervisor covers — close it now rather than after the next poll.
            this.ensureDataChannel();
            if ($video && $video.paused) this.playRemoteStream();
        }
    }
    playRemoteStream() {
        const play = ()=>$video.play();
        play().catch(()=>{
            this.setMuted(true);
            play().catch((err)=>console.warn('[CLIENT] video play blocked', err && err.name));
            const unmute = ()=>{
                this.setMuted(false);
                if ($video.paused) play().catch(()=>{});
            };
            [
                'click',
                'touchend'
            ].forEach((evt)=>document.addEventListener(evt, unmute, {
                    once: true
                }));
        });
        this.syncMuteButton();
    }
    // ---- Status pill ---------------------------------------------------------
    setStatus(kind, text) {
        if (!$1a67725c098c7e16$var$$clientStatus) return;
        const waiting = kind === 'connecting' || kind === 'warn';
        document.body.classList.toggle('connecting', waiting);
        // Only raise the full-screen "Reconnecting…" overlay once we've actually had
        // a live picture. The very first connect keeps the plain "Connecting…" pill
        // so a fresh scan/deep-link doesn't get an alarming interruption screen.
        document.body.classList.toggle('reconnecting', waiting && this.everLive);
        $1a67725c098c7e16$var$$clientStatus.classList.toggle('live', kind === 'live');
        $1a67725c098c7e16$var$$clientStatus.classList.toggle('warn', kind === 'warn' || kind === 'connecting');
        const $t = $1a67725c098c7e16$var$$clientStatus.querySelector('.status-text');
        if ($t) $t.textContent = text;
        // Anything other than a steady live feed (connecting/reconnecting) must show
        // the full chrome, so surface the controls and stop the idle clock; a return
        // to 'live' re-arms focus from the stream handler.
        if (kind !== 'live') this.wakeControls();
    }
    // ---- Focus (immersive) mode ----------------------------------------------
    // On a live feed the chrome (toolbar, push-to-talk, invite, sound pill) fades
    // away after FOCUS_IDLE_DELAY of no interaction, leaving just the picture and
    // the "Live" pill. It comes back on any interaction, on the phone being moved
    // (devicemotion), or when the app returns to the foreground.
    initFocusMode() {
        this.immersive = false;
        this.focusTimer = null;
        this.lastFocusArm = 0;
        this.motionAttached = false;
        const wake = ()=>this.wakeControls();
        // Discrete interactions: reveal controls now and restart the idle clock.
        [
            'pointerdown',
            'keydown',
            'wheel'
        ].forEach((evt)=>document.addEventListener(evt, wake, {
                passive: true
            }));
        // Pointer movement (desktop) keeps controls up, throttled so a moving mouse
        // doesn't thrash the timer.
        document.addEventListener('pointermove', ()=>{
            if (this.immersive || Date.now() - this.lastFocusArm > 1000) this.wakeControls();
        }, {
            passive: true
        });
        // Screen re-activated / app foregrounded → always show controls.
        document.addEventListener('visibilitychange', ()=>{
            if (document.visibilityState === 'visible') this.wakeControls();
        });
        window.addEventListener('focus', wake);
        this.setupMotionWake();
    }
    // Wire "moving the phone brings the controls back". Android/desktop expose
    // devicemotion straight away; iOS 13+ gates it behind a permission that must be
    // requested from a user gesture, so defer that to the first tap. Either way the
    // tap/visibility paths already cover the reveal, so a denial costs nothing.
    setupMotionWake() {
        if (typeof window.DeviceMotionEvent === 'undefined') return;
        const needsPermission = typeof window.DeviceMotionEvent.requestPermission === 'function';
        if (!needsPermission) {
            this.attachMotionWake();
            return;
        }
        const ask = async ()=>{
            try {
                const res = await window.DeviceMotionEvent.requestPermission();
                if (res === 'granted') this.attachMotionWake();
            } catch (e) {}
        };
        document.addEventListener('pointerdown', ask, {
            once: true
        });
    }
    attachMotionWake() {
        if (this.motionAttached) return;
        this.motionAttached = true;
        let lastMag = null;
        window.addEventListener('devicemotion', (e)=>{
            const a = e.acceleration && e.acceleration.x != null ? e.acceleration : e.accelerationIncludingGravity;
            if (!a) return;
            const mag = Math.hypot(a.x || 0, a.y || 0, a.z || 0);
            if (lastMag != null && Math.abs(mag - lastMag) > $1a67725c098c7e16$var$MOTION_WAKE_DELTA) // Only act while hidden; no need to thrash the timer on every wobble.
            {
                if (this.immersive) this.wakeControls();
            }
            lastMag = mag;
        });
    }
    // Focus mode only makes sense on a steady, live picture in the foreground:
    // never while connecting/reconnecting (the status must stay visible) or on the
    // scan screen.
    canFocus() {
        const b = document.body.classList;
        return b.contains('stage-client') && b.contains('has-stream') && !b.contains('reconnecting') && !b.contains('need-scan') && !b.contains('camera-frozen');
    }
    armFocusTimer() {
        clearTimeout(this.focusTimer);
        this.focusTimer = null;
        this.lastFocusArm = Date.now();
        if (!this.canFocus()) return;
        this.focusTimer = setTimeout(()=>this.enterImmersive(), $1a67725c098c7e16$var$FOCUS_IDLE_DELAY);
    }
    enterImmersive() {
        if (this.immersive || !this.canFocus()) return;
        if (document.visibilityState !== 'visible') return;
        // Don't swallow the controls out from under an open dialog (e.g. Invite) or
        // while push-to-talk is being held — re-arm and try again later instead.
        if (document.querySelector('.overlay:not([hidden])') || $1a67725c098c7e16$var$$talkBack && $1a67725c098c7e16$var$$talkBack.classList.contains('talking')) {
            this.armFocusTimer();
            return;
        }
        this.immersive = true;
        document.body.classList.add('immersive');
    }
    // Reveal the controls (if hidden) and restart the idle clock.
    wakeControls() {
        if (this.immersive) {
            this.immersive = false;
            document.body.classList.remove('immersive');
        }
        this.armFocusTimer();
    }
    // ---- Audio on/off --------------------------------------------------------
    bindMute() {
        if ($1a67725c098c7e16$var$$muteToggle) $1a67725c098c7e16$var$$muteToggle.addEventListener('click', ()=>this.setMuted(!$video.muted));
    }
    setMuted(muted) {
        $video.muted = muted;
        if (!muted && $video.volume === 0) $video.volume = 1;
        this.syncMuteButton();
    }
    syncMuteButton() {
        (0, $b68ecd39b69a2afc$export$27972cfaa3ad15e9)($1a67725c098c7e16$var$$muteToggle, $video.muted);
    }
    // ---- Video framing: fit toggle + pinch-zoom + pan ------------------------
    bindFraming() {
        if ($1a67725c098c7e16$var$$fitToggle) $1a67725c098c7e16$var$$fitToggle.addEventListener('click', ()=>this.toggleFit());
        this.bindGestures();
        this.updateFitButton();
        this.applyFraming();
        // Re-clamp/re-fit whenever the feed's intrinsic size becomes known or the
        // viewport changes (rotation, resize, on-screen keyboard, etc.).
        if ($video) $video.addEventListener('loadedmetadata', ()=>this.onVideoMetadata());
        window.addEventListener('resize', ()=>this.applyFraming());
    }
    // Called once a (re)connected stream's intrinsic size is known. Reset the
    // zoom/pan only when the feed's orientation flipped (e.g. the host rotated the
    // phone), so a plain reconnect keeps the parent's chosen framing.
    onVideoMetadata() {
        const w = $video && $video.videoWidth;
        const h = $video && $video.videoHeight;
        if (!w || !h) {
            this.applyFraming();
            return;
        }
        const orient = w > h ? 'land' : w < h ? 'port' : 'square';
        // First time we know the real dimensions this session: restore the parent's
        // remembered fit/zoom/pan. Doing it here (not on the raw 'stream' event) means
        // applyFraming clamps the pan against the true frame size, so a saved pan is
        // preserved rather than snapped to zero while dimensions are still unknown.
        if (!this._viewRestored) {
            this._viewRestored = true;
            this.loadView();
            this.updateFitButton();
            this.lastOrient = orient;
            this.applyFraming();
            return;
        }
        if (this.lastOrient && this.lastOrient !== orient) this.resetView();
        else this.applyFraming();
        this.lastOrient = orient;
    }
    // Load the remembered framing for the monitor we're watching (best-effort;
    // absent/garbled storage just leaves the defaults in place). Values are clamped
    // on apply, so a pan saved under a different viewport can't push the picture
    // into a black gap.
    loadView() {
        if (!this.hostId) return;
        const v = (0, $b68ecd39b69a2afc$export$17a1bc44f8c202b5)($1a67725c098c7e16$var$VIEW_KEY, {})[this.hostId];
        if (!v) return;
        if (v.fitMode === 'cover' || v.fitMode === 'contain') this.fitMode = v.fitMode;
        if (typeof v.zoom === 'number' && isFinite(v.zoom)) this.zoom = this.clamp(v.zoom, 1, this.maxZoom);
        if (typeof v.tx === 'number' && isFinite(v.tx)) this.tx = v.tx;
        if (typeof v.ty === 'number' && isFinite(v.ty)) this.ty = v.ty;
    }
    // Persist the current framing for this monitor. Called at the end of a
    // deliberate change (fit toggle, double-tap, or a pan/pinch gesture), never on
    // every animation frame.
    persistView() {
        if (!this.hostId) return;
        const all = (0, $b68ecd39b69a2afc$export$17a1bc44f8c202b5)($1a67725c098c7e16$var$VIEW_KEY, {}) || {};
        all[this.hostId] = {
            fitMode: this.fitMode,
            zoom: this.zoom,
            tx: this.tx,
            ty: this.ty
        };
        (0, $b68ecd39b69a2afc$export$ea0874f14a833321)($1a67725c098c7e16$var$VIEW_KEY, all);
    }
    toggleFit() {
        this.fitMode = this.fitMode === 'cover' ? 'contain' : 'cover';
        // Each fit mode starts from a clean, centred 1× view.
        this.resetView();
        this.updateFitButton();
        (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).VIDEO_FIT_CHANGED, {
            mode: this.fitMode
        });
    }
    updateFitButton() {
        if (!$1a67725c098c7e16$var$$fitToggle) return;
        const contain = this.fitMode === 'contain';
        (0, $b68ecd39b69a2afc$export$27972cfaa3ad15e9)($1a67725c098c7e16$var$$fitToggle, contain);
        const label = $1a67725c098c7e16$var$$fitToggle.querySelector('.tbtn-label');
        if (label) label.textContent = contain ? (0, $03c039b69e20a322$export$625550452a3fa3ec)('toolbar.fit') : (0, $03c039b69e20a322$export$625550452a3fa3ec)('toolbar.fill');
    }
    clamp(v, min, max) {
        return Math.min(max, Math.max(min, v));
    }
    // Geometry for the current stream + viewport. `contentW/H` is how large the
    // feed renders under object-fit:contain (letterboxed to fit the viewport);
    // `baseScale` is the extra factor that turns that into the active fit —
    // 1 for 'contain', or the ≥1 factor that fills both axes for 'cover'.
    frameMetrics() {
        const boxW = $video && $video.clientWidth || window.innerWidth;
        const boxH = $video && $video.clientHeight || window.innerHeight;
        const natW = $video && $video.videoWidth || 0;
        const natH = $video && $video.videoHeight || 0;
        if (!natW || !natH) return {
            boxW: boxW,
            boxH: boxH,
            contentW: boxW,
            contentH: boxH,
            baseScale: 1
        };
        const containScale = Math.min(boxW / natW, boxH / natH);
        const contentW = natW * containScale;
        const contentH = natH * containScale;
        const baseScale = this.fitMode === 'cover' ? Math.max(boxW / contentW, boxH / contentH) : 1;
        return {
            boxW: boxW,
            boxH: boxH,
            contentW: contentW,
            contentH: contentH,
            baseScale: baseScale
        };
    }
    // Max translation (px) on each axis that keeps the scaled picture covering the
    // viewport; 0 when the picture is smaller than the viewport there, so it stays
    // centred instead of drifting into a black gap (e.g. the letterbox axis at 1×).
    panBounds(scale, m) {
        return {
            x: Math.max(0, (m.contentW * scale - m.boxW) / 2),
            y: Math.max(0, (m.contentH * scale - m.boxH) / 2)
        };
    }
    applyFraming() {
        if (!$video) return;
        const m = this.frameMetrics();
        const scale = m.baseScale * this.zoom;
        const bounds = this.panBounds(scale, m);
        this.tx = this.clamp(this.tx, -bounds.x, bounds.x);
        this.ty = this.clamp(this.ty, -bounds.y, bounds.y);
        // Render with contain and synthesise BOTH the fill-crop and the user zoom via
        // one transform, so pan/zoom behave identically in either fit mode.
        // transform-origin is the viewport centre, so translate() is plain screen px.
        $video.style.objectFit = 'contain';
        $video.style.objectPosition = '50% 50%';
        $video.style.transformOrigin = 'center center';
        $video.style.transform = `translate(${this.tx}px, ${this.ty}px) scale(${scale})`;
        $video.classList.toggle('pannable', bounds.x > 0.5 || bounds.y > 0.5);
    }
    resetView() {
        this.zoom = 1;
        this.tx = 0;
        this.ty = 0;
        this.applyFraming();
        this.persistView();
    }
    // New translation that keeps the picture point currently under `(px, py)`
    // fixed while the scale changes from `s0` to `s1` (used by both pinch and
    // double-tap so the zoom grows out of the focal point).
    zoomAround(px, py, s0, s1, baseTx, baseTy, m) {
        const cx = m.boxW / 2;
        const cy = m.boxH / 2;
        const ratio = s0 ? s1 / s0 : 1;
        return {
            tx: px - cx - ratio * (px - cx - baseTx),
            ty: py - cy - ratio * (py - cy - baseTy)
        };
    }
    bindGestures() {
        if (!$video) return;
        const pointers = new Map(); // pointerId -> { x, y }
        let mode = null; // 'pan' | 'pinch'
        let moved = false; // a real drag/pinch happened (suppresses tap)
        let lastTapAt = 0;
        // Pan anchor.
        let panStartX = 0, panStartY = 0, panBaseTx = 0, panBaseTy = 0;
        // Pinch anchor (captured when the second finger lands).
        let pinchStartDist = 0, pinchBaseZoom = 1, pinchBaseTx = 0, pinchBaseTy = 0;
        let pinchMidX = 0, pinchMidY = 0;
        const midpoint = ()=>{
            let sx = 0, sy = 0;
            pointers.forEach((p)=>{
                sx += p.x;
                sy += p.y;
            });
            const n = pointers.size || 1;
            return {
                x: sx / n,
                y: sy / n
            };
        };
        const spread = ()=>{
            const pts = [
                ...pointers.values()
            ];
            if (pts.length < 2) return 0;
            return Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
        };
        const beginPan = ()=>{
            mode = 'pan';
            const p = [
                ...pointers.values()
            ][0];
            panStartX = p.x;
            panStartY = p.y;
            panBaseTx = this.tx;
            panBaseTy = this.ty;
        };
        const beginPinch = ()=>{
            mode = 'pinch';
            moved = true;
            pinchStartDist = spread() || 1;
            pinchBaseZoom = this.zoom;
            pinchBaseTx = this.tx;
            pinchBaseTy = this.ty;
            const mid = midpoint();
            pinchMidX = mid.x;
            pinchMidY = mid.y;
        };
        $video.addEventListener('pointerdown', (e)=>{
            pointers.set(e.pointerId, {
                x: e.clientX,
                y: e.clientY
            });
            try {
                $video.setPointerCapture(e.pointerId);
            } catch (err) {}
            $video.classList.add('panning');
            if (pointers.size === 1) {
                moved = false;
                beginPan();
            } else if (pointers.size === 2) beginPinch();
        });
        $video.addEventListener('pointermove', (e)=>{
            if (!pointers.has(e.pointerId)) return;
            pointers.set(e.pointerId, {
                x: e.clientX,
                y: e.clientY
            });
            if (mode === 'pinch' && pointers.size >= 2) {
                const m = this.frameMetrics();
                const dist = spread() || pinchStartDist;
                const zoom = this.clamp(pinchBaseZoom * (dist / pinchStartDist), 1, this.maxZoom);
                const s0 = m.baseScale * pinchBaseZoom;
                const s1 = m.baseScale * zoom;
                // Anchor the zoom to the pinch's starting midpoint, then also follow the
                // midpoint as the fingers slide together (two-finger pan).
                const mid = midpoint();
                const z = this.zoomAround(pinchMidX, pinchMidY, s0, s1, pinchBaseTx, pinchBaseTy, m);
                this.zoom = zoom;
                this.tx = z.tx + (mid.x - pinchMidX);
                this.ty = z.ty + (mid.y - pinchMidY);
                this.applyFraming();
                return;
            }
            if (mode === 'pan' && pointers.size === 1) {
                const p = pointers.get(e.pointerId);
                const dx = p.x - panStartX;
                const dy = p.y - panStartY;
                if (Math.abs(dx) > 3 || Math.abs(dy) > 3) moved = true;
                this.tx = panBaseTx + dx;
                this.ty = panBaseTy + dy;
                this.applyFraming();
            }
        });
        const removePointer = (e)=>{
            if (!pointers.has(e.pointerId)) return;
            pointers.delete(e.pointerId);
            try {
                $video.releasePointerCapture(e.pointerId);
            } catch (err) {}
            if (pointers.size === 1) // Lifting one finger of a pinch: carry on as a pan from the remaining one.
            beginPan();
            else if (pointers.size === 0) {
                $video.classList.remove('panning');
                const wasGesture = moved;
                mode = null;
                // Remember the framing after a real pan/pinch (a double-tap persists via
                // its own reset/zoom path below).
                if (wasGesture) this.persistView();
                // A quick double-tap (no drag/pinch) zooms in at the tapped point, or
                // snaps back to a centred 1× view when already zoomed.
                if (!wasGesture) {
                    const now = Date.now();
                    if (now - lastTapAt < 300) {
                        lastTapAt = 0;
                        this.handleDoubleTap(e.clientX, e.clientY);
                    } else lastTapAt = now;
                }
            }
        };
        $video.addEventListener('pointerup', removePointer);
        $video.addEventListener('pointercancel', removePointer);
    }
    handleDoubleTap(px, py) {
        // Already zoomed OR just panned (cover mode is pannable at 1×): snap back.
        if (this.zoom > 1.01 || Math.abs(this.tx) > 1 || Math.abs(this.ty) > 1) {
            this.resetView();
            return;
        }
        const m = this.frameMetrics();
        const target = Math.min(2.5, this.maxZoom);
        const z = this.zoomAround(px, py, m.baseScale * this.zoom, m.baseScale * target, this.tx, this.ty, m);
        this.zoom = target;
        this.tx = z.tx;
        this.ty = z.ty;
        this.applyFraming();
        this.persistView();
    }
    // ---- Push-to-talk --------------------------------------------------------
    setMicEnabled(enabled) {
        if (!this.audioStream) return;
        this.audioStream.getAudioTracks().forEach((track)=>{
            track.enabled = enabled;
        });
        $1a67725c098c7e16$var$$talkBack.classList.toggle('talking', enabled);
    }
    bindTalkBack() {
        const start = (e)=>{
            e.preventDefault();
            if (e.pointerId != null && $1a67725c098c7e16$var$$talkBack.setPointerCapture) try {
                $1a67725c098c7e16$var$$talkBack.setPointerCapture(e.pointerId);
            } catch (err) {}
            this.setMicEnabled(true);
            (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).TALKBACK_USED);
        };
        const end = ()=>this.setMicEnabled(false);
        $1a67725c098c7e16$var$$talkBack.addEventListener('pointerdown', start);
        $1a67725c098c7e16$var$$talkBack.addEventListener('pointerup', end);
        $1a67725c098c7e16$var$$talkBack.addEventListener('pointercancel', end);
        $1a67725c098c7e16$var$$talkBack.addEventListener('contextmenu', (e)=>e.preventDefault());
    }
    // ---- Background alerts (Web Push) ---------------------------------------
    bindAlerts() {
        if (!$1a67725c098c7e16$var$$alertsToggle) return;
        let on = !!(0, $b68ecd39b69a2afc$export$17a1bc44f8c202b5)($1a67725c098c7e16$var$ALERT_KEY, {}).enabled;
        const reflect = ()=>(0, $b68ecd39b69a2afc$export$27972cfaa3ad15e9)($1a67725c098c7e16$var$$alertsToggle, on);
        const persist = ()=>(0, $b68ecd39b69a2afc$export$ea0874f14a833321)($1a67725c098c7e16$var$ALERT_KEY, {
                enabled: on
            });
        // Silently re-subscribe if the user had alerts on and already granted
        // notification permission (host detection drives the actual alerts).
        if (on && 'Notification' in window && Notification.permission === 'granted' && this.hostId) {
            this._subscribedHostId = this.hostId;
            (0, $02d65636a04e74fb$export$a7ae20dceff8fa2e)(this.hostId).catch(()=>{});
        }
        reflect();
        let busy = false;
        $1a67725c098c7e16$var$$alertsToggle.addEventListener('click', async ()=>{
            // Ignore taps while a previous toggle is still resolving (the enable path
            // is async — permission prompt + network — so rapid taps would otherwise
            // race enable/disable and leave the button, storage and server disagreeing).
            if (busy) return;
            busy = true;
            try {
                if (on) {
                    on = false;
                    reflect();
                    persist();
                    this._subscribedHostId = null;
                    (0, $02d65636a04e74fb$export$3860423f821f687f)().catch(()=>{});
                    this.toast((0, $03c039b69e20a322$export$625550452a3fa3ec)('alerts.disabled'));
                    return;
                }
                // Optimistically show the pressed state, then confirm (or roll back)
                // once we know whether push could actually be enabled.
                on = true;
                reflect();
                const result = await (0, $02d65636a04e74fb$export$a7ae20dceff8fa2e)(this.hostId).catch(()=>'error');
                if (result === 'ok') {
                    persist();
                    this._subscribedHostId = this.hostId;
                    this.toast((0, $03c039b69e20a322$export$625550452a3fa3ec)('alerts.enabled'));
                    return;
                }
                on = false;
                reflect();
                persist();
                if (result === 'unsupported') {
                    // On iOS, Web Push only works once the app is on the Home Screen, so
                    // point the parent there (with the Share glyph so the action is
                    // recognisable) rather than saying it's flat-out unsupported.
                    if ((0, $b68ecd39b69a2afc$export$41a665f744414057)()) this.toast((0, $03c039b69e20a322$export$625550452a3fa3ec)('alerts.unsupportedIos'), {
                        icon: 'ios'
                    });
                    else this.toast((0, $03c039b69e20a322$export$625550452a3fa3ec)('alerts.unsupported'));
                } else if (result === 'denied') this.toast((0, $03c039b69e20a322$export$625550452a3fa3ec)('alerts.denied'));
                else this.toast((0, $03c039b69e20a322$export$625550452a3fa3ec)('alerts.failed'));
            } finally{
                busy = false;
            }
        });
    }
    // Ensure the push subscription is registered under the host we're actually
    // watching. Called on every (re)connect; the hostId guard makes it a no-op
    // unless alerts are on, permission is granted, and the host id has changed —
    // so it costs nothing on a normal reconnect but fixes the scan flow (hostId
    // set after init) and a host that reclaimed/rotated its id.
    maybeRefreshPush() {
        if (!this.hostId) return;
        if (!('Notification' in window) || Notification.permission !== 'granted') return;
        if (!(0, $b68ecd39b69a2afc$export$17a1bc44f8c202b5)($1a67725c098c7e16$var$ALERT_KEY, {}).enabled) return;
        if (this._subscribedHostId === this.hostId) return;
        this._subscribedHostId = this.hostId;
        (0, $02d65636a04e74fb$export$a7ae20dceff8fa2e)(this.hostId).catch(()=>{});
    }
    // Transient, non-blocking message for the parent (e.g. why alerts couldn't be
    // turned on). Auto-dismisses; a new message replaces any visible one. Pass
    // `{ icon: 'ios' | 'android' }` for instructional hints to prepend a platform
    // glyph; those stay up a little longer since there's an action to follow.
    toast(text, opts = {}) {
        const el = document.getElementById('toast');
        if (!el) return;
        const iconMarkup = opts.icon ? $1a67725c098c7e16$var$HINT_ICONS[opts.icon] : null;
        el.classList.toggle('toast--hint', !!iconMarkup);
        if (iconMarkup) {
            el.textContent = '';
            el.insertAdjacentHTML('beforeend', iconMarkup);
            const span = document.createElement('span');
            span.className = 'toast-text';
            span.textContent = text;
            el.appendChild(span);
        } else el.textContent = text;
        (0, $b68ecd39b69a2afc$export$39c365eaabfb0a68)(el);
        clearTimeout(this._toastTimer);
        this._toastTimer = setTimeout(()=>(0, $b68ecd39b69a2afc$export$c96659240d08478b)(el), iconMarkup ? 6000 : 4200);
    }
    // ---- Invite / other parents ---------------------------------------------
    bindInvite() {
        if ($1a67725c098c7e16$var$$invite) $1a67725c098c7e16$var$$invite.addEventListener('click', ()=>{
            if (!$1a67725c098c7e16$var$$inviteOverlay) return;
            this.renderInviteQR();
            $1a67725c098c7e16$var$$inviteOverlay.hidden = false;
        });
        if ($1a67725c098c7e16$var$$inviteOverlay) $1a67725c098c7e16$var$$inviteOverlay.addEventListener('click', (e)=>{
            if (e.target === $1a67725c098c7e16$var$$inviteOverlay || e.target.closest('.overlay-close')) $1a67725c098c7e16$var$$inviteOverlay.hidden = true;
        });
        if ($1a67725c098c7e16$var$$inviteCopy) $1a67725c098c7e16$var$$inviteCopy.addEventListener('click', ()=>this.copyLink());
    }
    inviteLink() {
        return (0, $b68ecd39b69a2afc$export$4e19848623c50785)(this.hostId);
    }
    renderInviteQR() {
        (0, $b68ecd39b69a2afc$export$b48da2f84c900c96)($1a67725c098c7e16$var$$inviteOverlay && $1a67725c098c7e16$var$$inviteOverlay.querySelector('.invite-qr'), this.inviteLink());
    }
    async copyLink() {
        const label = $1a67725c098c7e16$var$$inviteCopy && $1a67725c098c7e16$var$$inviteCopy.querySelector('.copy-label');
        if (await (0, $b68ecd39b69a2afc$export$8dff4cfd26f76003)(this.inviteLink(), label)) (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).LINK_COPIED);
    }
    // ---- Lullaby (shared control with the baby monitor) ----------------------
    // The lullaby plays out of the baby monitor's speaker so it reaches the baby;
    // the parent only hears it through the live stream. Here we just let the
    // parent start/stop it remotely and reflect the state the host reports back.
    bindMelody() {
        if (!$1a67725c098c7e16$var$$melodyToggle) return;
        $1a67725c098c7e16$var$$melodyToggle.addEventListener('click', ()=>{
            const next = !this.melodyOn;
            // Only act if the command actually goes out. Otherwise (data channel not
            // open yet) the tap is a no-op and the button stays honest — the host's
            // state applies as soon as we're connected.
            if (!this.sendMelodyCommand(next)) return;
            // Optimistic: light the button now; the host echoes the authoritative
            // state back and corrects us if playback couldn't start there.
            this.setMelodyState(next);
            (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).MELODY_TOGGLED, {
                playing: next,
                source: 'parent'
            });
        });
    }
    sendMelodyCommand(on) {
        try {
            if (this.dc && this.dc.open) {
                this.dc.send({
                    type: 'melody',
                    playing: on
                });
                return true;
            }
        } catch (e) {
        /* the button resyncs from the host's next broadcast */ }
        return false;
    }
    setMelodyState(on) {
        this.melodyOn = !!on;
        (0, $b68ecd39b69a2afc$export$27972cfaa3ad15e9)($1a67725c098c7e16$var$$melodyToggle, this.melodyOn);
        // Subtle top-right badge so the parent can tell the lullaby is playing.
        document.body.classList.toggle('melody-playing', this.melodyOn);
    }
    // Keep a metadata channel open for as long as we have a media call. The channel
    // is on its own peer connection, so it can fail on its own (or never come back
    // after a reconnect that reused the media path); a light poll re-establishes it.
    // Idempotent, so the poll, a fresh 'stream', a foreground resume and an ICE
    // restart can all call ensureDataChannel() without stacking channels.
    startDataChannelSupervisor() {
        if (this.dcSupervisor) return;
        this.dcSupervisor = setInterval(()=>this.ensureDataChannel(), $1a67725c098c7e16$var$DC_SUPERVISOR_MS);
    }
    stopDataChannelSupervisor() {
        if (this.dcSupervisor) clearInterval(this.dcSupervisor);
        this.dcSupervisor = null;
    }
    // Only bother while a media call is in place: with no call there's nothing to
    // annotate, and the reconnect loop will open a fresh channel once the feed is
    // back. Retained name `openDataChannel` for the 'stream' call site.
    ensureDataChannel() {
        if (this.dc || !this.hostId || !this.currentCall) return;
        // Don't open while signaling is down: peer.connect() would hand back a
        // channel that can't complete its offer and may never fire close, wedging
        // this.dc non-null so the supervisor never retries. Wait for reconnect.
        if (!this.peer || this.peer.disconnected || this.peer.destroyed) return;
        try {
            const dc = this.peer.connect(this.hostId, {
                reliable: true
            });
            this.dc = dc;
            dc.on('data', (msg)=>{
                if (!msg) return;
                if (msg.type === 'count') this.renderOthers(msg.count);
                else if (msg.type === 'melody') this.setMelodyState(!!msg.playing);
                else if (msg.type === 'battery') this.setBatteryState(msg);
                else if (msg.type === 'live') this.noteHostFrame(msg.seq);
            });
            // Null out on teardown so the supervisor reopens; guard that a late event
            // from a superseded channel can't clear a newer one.
            dc.on('close', ()=>{
                if (this.dc === dc) this.dc = null;
            });
            dc.on('error', ()=>{
                if (this.dc === dc) this.dc = null;
            });
        } catch (e) {
        /* best-effort — the supervisor retries on the next tick */ }
    }
    openDataChannel() {
        this.ensureDataChannel();
    }
    renderOthers(total) {
        const others = Math.max(0, (total || 0) - 1);
        if (!$1a67725c098c7e16$var$$othersBadge) return;
        $1a67725c098c7e16$var$$othersBadge.hidden = others === 0;
        $1a67725c098c7e16$var$$othersBadge.textContent = String(others);
    }
    // ---- Monitor battery warning --------------------------------------------
    // Driven entirely by the host's data-channel messages. On the rising edge we
    // sound a soft tone and start repeating it every 5 minutes; while low we keep
    // the percentage fresh; on recovery/charging we clear everything.
    setBatteryState({ low: low, level: level }) {
        document.body.classList.toggle('battery-low', !!low);
        if ($1a67725c098c7e16$var$$batteryIndicator && level != null) {
            const $level = $1a67725c098c7e16$var$$batteryIndicator.querySelector('.battery-level');
            if ($level) $level.textContent = (0, $03c039b69e20a322$export$625550452a3fa3ec)('battery.level', {
                level: level
            });
        }
        if (low && !this.batteryLow) {
            // Rising edge: nudge the parent now, then keep nudging every 5 minutes.
            (0, $1333db90c8a58227$export$5da07a0f010c502e)();
            clearInterval(this.batteryTimer);
            this.batteryTimer = setInterval(()=>(0, $1333db90c8a58227$export$5da07a0f010c502e)(), 300000);
        } else if (!low && this.batteryLow) this.clearBatteryWarning();
        this.batteryLow = !!low;
    }
    // Silence the repeating tone and drop the pill. Called on recovery and also
    // when the link drops (see teardownCall): a dying monitor is a likely cause of
    // the drop, but the connection-lost cue + reconnecting overlay already own
    // that moment — a lingering battery beep would only stack on top, and its real
    // cause (battery vs. plain network drop) is ambiguous once the link is gone.
    // The host re-sends battery state on the next data channel, so a still-low
    // battery re-arms the warning as soon as we're back.
    clearBatteryWarning() {
        clearInterval(this.batteryTimer);
        this.batteryTimer = null;
        this.batteryLow = false;
        document.body.classList.remove('battery-low');
    }
    // ---- Passive sound indicator --------------------------------------------
    onSoundLevel(level) {
        if (level >= $1a67725c098c7e16$var$SOUND_ON) {
            this.soundPeak = Math.max(this.soundPeak, level);
            this.lastSound = {
                at: Date.now(),
                band: this.bandFor(this.soundPeak)
            };
        }
        // Decay the peak so a brief loud spike doesn't stick forever.
        this.soundPeak *= 0.9;
    }
    bandFor(level) {
        if (level >= 0.55) return 'hard';
        if (level >= 0.3) return 'medium';
        return 'low';
    }
    startSoundClock() {
        this.soundTimer = setInterval(()=>this.renderSound(), 1000);
        this.renderSound();
    }
    // Compact meter: the icon's colour + waves carry the live level, and the tiny
    // sub-line shows only the elapsed time once sound has gone quiet (a lit icon is
    // the "now" signal, so no text is needed while sound is present). The full,
    // wordy state still goes to aria-label for screen readers.
    renderSound() {
        if (!$1a67725c098c7e16$var$$soundIndicator) return;
        const $ago = $1a67725c098c7e16$var$$soundIndicator.querySelector('.sound-ago');
        $1a67725c098c7e16$var$$soundIndicator.classList.remove('lvl-low', 'lvl-medium', 'lvl-hard');
        if (!this.lastSound) {
            if ($ago) $ago.textContent = '';
            $1a67725c098c7e16$var$$soundIndicator.setAttribute('aria-label', `${(0, $03c039b69e20a322$export$625550452a3fa3ec)('sound.quiet')} \xb7 ${(0, $03c039b69e20a322$export$625550452a3fa3ec)('sound.none')}`);
            return;
        }
        const secs = Math.round((Date.now() - this.lastSound.at) / 1000);
        const recent = secs <= 2;
        const band = this.lastSound.band;
        // Internal bands map to the i18n level keys (the loudest is "loud").
        const bandKey = {
            low: 'low',
            medium: 'medium',
            hard: 'loud'
        }[band] || 'low';
        if (recent) {
            $1a67725c098c7e16$var$$soundIndicator.classList.add(`lvl-${band}`);
            if ($ago) $ago.textContent = '';
            $1a67725c098c7e16$var$$soundIndicator.setAttribute('aria-label', (0, $03c039b69e20a322$export$625550452a3fa3ec)(`sound.level.${bandKey}`));
        } else {
            if ($ago) $ago.textContent = this.timeAgo(secs);
            $1a67725c098c7e16$var$$soundIndicator.setAttribute('aria-label', `${(0, $03c039b69e20a322$export$625550452a3fa3ec)(`sound.past.${bandKey}`)} \xb7 ${(0, $03c039b69e20a322$export$625550452a3fa3ec)('sound.ago', {
                time: this.timeAgo(secs)
            })}`);
        }
    }
    timeAgo(secs) {
        if (secs < 60) return `${secs}s`;
        const mins = Math.floor(secs / 60);
        if (mins < 60) return `${mins}m`;
        return `${Math.floor(mins / 60)}h`;
    }
    constructor(peer, hostId){
        this.peer = peer;
        this.hostId = hostId || null;
        // Stable per-device identity sent to the host so it can recognize this
        // parent across reconnects/reloads (PeerJS ids are per-load, so they can't
        // be used for this). Recognition only — never treated as authentication.
        this.identity = (0, $b68ecd39b69a2afc$export$3b0073deb71e8e8d)();
        this.audioStream = null;
        this.currentCall = null;
        // Per-call ICE restart controller (see ice-restart.js); recreated each dial.
        this.iceRecovery = null;
        this.dc = null;
        // The metadata channel rides its own RTCPeerConnection (peer.connect), so it
        // can drop while the media call stays healthy — and nothing would reopen it,
        // since openDataChannel only ran on a fresh 'stream' event. This timer polls
        // for that gap and re-establishes the channel, keeping the viewer count,
        // remote lullaby, battery warnings and the live-frame heartbeat alive.
        this.dcSupervisor = null;
        this.reconnectDelay = 1000;
        this.retryTimer = null;
        this.watchdog = null;
        this.disconnectGrace = null;
        this.resumeGuard = null;
        this.connectionLive = false;
        // Whether we've ever had a live connection. Used so the "reconnected" cue
        // only plays on an actual recovery, never on the very first connect.
        this.everLive = false;
        // Consecutive dial attempts that never reached a live feed (drives the
        // "monitor not found" hint). Reset the moment we ever go live.
        this.preLiveFailures = 0;
        // The host id our push subscription is currently registered under, so we can
        // re-subscribe when it changes (scan flow sets hostId late; a host reload can
        // change it) without redundant /subscribe calls on every reconnect.
        this._subscribedHostId = null;
        this.lastSound = null; // { at, band }
        this.soundPeak = 0;
        // Host-side "live video" heartbeat. The monitor broadcasts a counter of real
        // camera frames (see host startLiveHeartbeat); if those heartbeats keep
        // arriving but the counter stops advancing, the camera at the monitor has
        // frozen even though bytes and decoded frames may still be flowing — the one
        // case our own inbound stats can't catch. `hostHeartbeatAt` gates the check
        // so monitors that don't send it (older builds) are never wrongly flagged.
        this.hostFrameSeq = null;
        this.hostFrameChangedAt = 0;
        this.hostHeartbeatAt = 0;
        // True while we're showing the dedicated "monitor camera frozen" state: the
        // link is healthy and media may still be decoding, but the monitor's camera
        // stopped producing new frames, so reconnecting wouldn't help.
        this.cameraFrozen = false;
        // Whether the baby monitor is currently playing the lullaby. Kept in sync
        // with the host over the data channel; the parent can also toggle it.
        this.melodyOn = false;
        // Whether the monitor reported a critically low battery. While true we show
        // a subtle pill and repeat a soft warning tone (batteryTimer).
        this.batteryLow = false;
        this.batteryTimer = null;
        // Sustained-outage escalation. outageSoftTimer waits 20s after a drop, then
        // outageSoftTimer2 repeats a light heads-up; outageArmTimer waits 60s, then
        // outageBeepTimer repeats the loud alarm until the feed is back.
        this.outageSoftTimer = null;
        this.outageSoftTimer2 = null;
        this.outageArmTimer = null;
        this.outageBeepTimer = null;
        // Video framing (parent). `fitMode` is the base fit: 'cover' fills the
        // screen (cropping when host/viewer aspect ratios differ), 'contain'
        // letterboxes the whole frame. On top of that the parent can pinch to zoom
        // (`zoom` ≥ 1) and drag to pan (`tx`/`ty`, in screen px). Both work in
        // either fit mode: applyFraming() renders with object-fit:contain and folds
        // the fill-crop and the user's zoom into a single transform, clamped so the
        // picture can never be dragged into a black gap.
        this.fitMode = 'cover';
        this.zoom = 1;
        this.tx = 0;
        this.ty = 0;
        this.maxZoom = 6;
        // 'land' | 'port' | 'square' of the last stream, so we only reset the view
        // when the feed's orientation actually flips (not on every reconnect).
        this.lastOrient = null;
        // Whether we've restored the remembered framing yet this session (done once,
        // as soon as the stream's real dimensions are known — see onVideoMetadata).
        this._viewRestored = false;
        this.bindMute();
        this.bindTalkBack();
        this.bindAlerts();
        this.bindInvite();
        this.bindMelody();
        this.bindFraming();
        this.initFocusMode();
        this.startSoundClock();
        // Prime the connection-cue audio so the parent's first tap unlocks it,
        // ensuring the "lost"/"restored" tones can play on the first real drop.
        (0, $1333db90c8a58227$export$78505759b9b0302b)();
        document.addEventListener('visibilitychange', ()=>this.resumeIfNeeded());
        [
            'pageshow',
            'focus',
            'online'
        ].forEach((evt)=>window.addEventListener(evt, ()=>this.resumeIfNeeded()));
        // A network hand-off (e.g. Wi-Fi -> mobile) kills the current path instantly.
        // Surface "Reconnecting…" straight away instead of waiting up to ~12s for ICE
        // to notice; the matching 'online' event then drives the actual re-dial.
        window.addEventListener('offline', ()=>this.onNetworkLost());
        // Always wire the scanner button so "Open camera" works whenever the scan
        // screen is shown — the initial no-host flow AND the fallback we surface when
        // a remembered/deep-linked monitor can't be reached (see revealScanner).
        if ($1a67725c098c7e16$var$$startScan) $1a67725c098c7e16$var$$startScan.addEventListener('click', ()=>this.startScan());
        if (this.hostId) // Have a target (deep link, QR, or a remembered monitor): dial it. The
        // parent taps "Open camera" only if we later fall back to the scanner.
        this.beginConnection();
        else this.revealScanner();
    }
}



// Runtime ICE server configuration.
//
// Instead of hardcoding TURN credentials in the bundle (where they'd be scraped
// and abused), the app fetches short-lived credentials at runtime from our
// Cloudflare Worker (see turn-worker/). The worker returns a ready-to-use
// `iceServers` array plus a `ttl` so we know when to refresh.
//
// Everything here degrades gracefully: if the worker is unreachable we fall back
// to the last cached credentials, and failing that to STUN-only (direct P2P
// still works on most home networks; only symmetric-NAT/cellular needs relay).


const $137761e831dba805$var$CACHE_KEY = 'cammirror:ice';
const $137761e831dba805$var$REFRESH_MARGIN_MS = 300000; // refresh this long before expiry
const $137761e831dba805$var$FETCH_TIMEOUT_MS = 6000;
// Used when we have no credentials at all. Cloudflare + Google STUN for
// redundancy. No TURN here — a relay requires credentials.
const $137761e831dba805$var$STUN_FALLBACK = [
    {
        urls: [
            'stun:stun.cloudflare.com:3478',
            'stun:stun.l.google.com:19302'
        ]
    }
];
function $137761e831dba805$var$credentialsUrl() {
    const meta = document.querySelector('meta[name="turn-credentials-url"]');
    const fromMeta = meta && meta.content && meta.content.trim();
    // Priority: runtime override > <meta> tag (set to the deployed Worker URL in
    // production) > local-dev default > same-origin path (for a Pages Function
    // co-hosted with the app).
    if (window.CAMMIRROR_TURN_URL) return window.CAMMIRROR_TURN_URL;
    if (fromMeta) return fromMeta;
    // Dev convenience: `npm run dev` in turn-worker/ serves the minter on :8787,
    // so a locally-served app uses real TURN with zero extra config. This never
    // applies in production (hostname won't be localhost, and meta will be set).
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') return 'http://localhost:8787/turn-credentials';
    return '/turn-credentials';
}
function $137761e831dba805$var$readCache() {
    const parsed = (0, $b68ecd39b69a2afc$export$17a1bc44f8c202b5)($137761e831dba805$var$CACHE_KEY);
    if (!parsed || !Array.isArray(parsed.iceServers) || !parsed.expiresAt) return null;
    return parsed;
}
function $137761e831dba805$var$writeCache(iceServers, expiresAt) {
    (0, $b68ecd39b69a2afc$export$ea0874f14a833321)($137761e831dba805$var$CACHE_KEY, {
        iceServers: iceServers,
        expiresAt: expiresAt
    });
}
function $137761e831dba805$export$c676e6625b4c27d8() {
    const cached = $137761e831dba805$var$readCache();
    return cached ? cached.expiresAt : 0;
}
function $137761e831dba805$var$withTimeout(promise, ms) {
    const controller = new AbortController();
    const timer = setTimeout(()=>controller.abort(), ms);
    return {
        signal: controller.signal,
        done: ()=>clearTimeout(timer)
    };
}
async function $137761e831dba805$export$3b480dd5eaedf117({ force: force = false } = {}) {
    const now = Date.now();
    const cached = $137761e831dba805$var$readCache();
    if (!force && cached && cached.expiresAt > now + $137761e831dba805$var$REFRESH_MARGIN_MS) return cached.iceServers;
    const t = $137761e831dba805$var$withTimeout(null, $137761e831dba805$var$FETCH_TIMEOUT_MS);
    try {
        const res = await fetch($137761e831dba805$var$credentialsUrl(), {
            method: 'GET',
            signal: t.signal
        });
        t.done();
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const data = await res.json();
        const iceServers = Array.isArray(data.iceServers) ? data.iceServers : null;
        if (!iceServers || !iceServers.length) throw new Error('no iceServers in response');
        const ttlMs = (Number(data.ttl) || 86400) * 1000;
        $137761e831dba805$var$writeCache(iceServers, now + ttlMs);
        return iceServers;
    } catch (err) {
        t.done();
        console.warn('[CAMMIRROR] TURN credential fetch failed, using fallback:', err && err.message);
        (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).ICE_FALLBACK, {
            mode: cached ? 'stale' : 'stun_only'
        });
        // Stale credentials are better than none; STUN-only is the last resort.
        return cached ? cached.iceServers : $137761e831dba805$var$STUN_FALLBACK;
    }
}
// --- Keeping a live peer's credentials fresh -------------------------------
// PeerJS reads `peer.options.config` when it builds each RTCPeerConnection, so
// refreshing credentials for future calls/reconnects is just a matter of
// swapping `iceServers` on that object before the next connection. Driving this
// centrally covers both the host and the client without touching either.
let $137761e831dba805$var$refreshTimer = null;
let $137761e831dba805$var$managedPeer = null;
let $137761e831dba805$var$listenersBound = false;
function $137761e831dba805$var$applyIceServers(peer, iceServers) {
    if (peer && peer.options && peer.options.config) peer.options.config = {
        ...peer.options.config,
        iceServers: iceServers
    };
}
function $137761e831dba805$var$scheduleNext() {
    clearTimeout($137761e831dba805$var$refreshTimer);
    const expiresAt = $137761e831dba805$export$c676e6625b4c27d8();
    const now = Date.now();
    // With a cache: refresh a little before expiry. Without one (we're on the
    // STUN fallback): retry soon so we upgrade to a relay as soon as possible.
    const delay = expiresAt ? Math.max(30000, expiresAt - now - $137761e831dba805$var$REFRESH_MARGIN_MS) : 60000;
    $137761e831dba805$var$refreshTimer = setTimeout($137761e831dba805$var$runRefresh, delay);
}
async function $137761e831dba805$var$runRefresh() {
    const iceServers = await $137761e831dba805$export$3b480dd5eaedf117({
        force: true
    });
    $137761e831dba805$var$applyIceServers($137761e831dba805$var$managedPeer, iceServers);
    $137761e831dba805$var$scheduleNext();
}
async function $137761e831dba805$var$refreshIfStale() {
    const expiresAt = $137761e831dba805$export$c676e6625b4c27d8();
    if (!expiresAt || expiresAt < Date.now() + $137761e831dba805$var$REFRESH_MARGIN_MS) await $137761e831dba805$var$runRefresh();
}
function $137761e831dba805$export$b2a6d706e3dacf48(peer) {
    $137761e831dba805$var$managedPeer = peer;
    $137761e831dba805$var$scheduleNext();
    if (!$137761e831dba805$var$listenersBound) {
        $137761e831dba805$var$listenersBound = true;
        // Coming back from background / regaining network is exactly when a long
        // idle session may have crossed the expiry boundary.
        document.addEventListener('visibilitychange', ()=>{
            if (document.visibilityState === 'visible') $137761e831dba805$var$refreshIfStale();
        });
        window.addEventListener('online', $137761e831dba805$var$refreshIfStale);
    }
}


// Which signaling broker PeerJS should talk to.
//
// Left unconfigured, PeerJS silently falls back to its free public cloud at
// `0.peerjs.com` (util.CLOUD_HOST). That is fine for a hobby demo and wrong for
// a baby monitor: unlike TURN, signaling has no graceful degradation. When the
// broker is unreachable there is no pairing and no reconnect, and PeerJS reports
// the failure as `socket-error` / `server-error`, which app.js treats as fatal
// and paints over the whole UI.
//
// So we always point at our own broker (turn-worker/src/signal.js). Resolution
// mirrors ice.js: explicit override > <meta signal-url> > local dev default >
// same-origin, which is the production case since the Pages Function is
// co-hosted with the app.
function $f2793903606ddf52$var$fromUrl(urlString) {
    const url = new URL(urlString);
    const secure = url.protocol === 'https:' || url.protocol === 'wss:';
    // PeerJS builds `host + ":" + port` unconditionally, so an explicit port is
    // required even when it's the scheme default.
    const port = url.port ? Number(url.port) : secure ? 443 : 80;
    // It also expects a directory-style path: `<path>peerjs` for the socket and
    // `<path><key>/id` for the id endpoint.
    let path = url.pathname || '/';
    if (!path.endsWith('/')) path += '/';
    return {
        host: url.hostname,
        port: port,
        path: path,
        secure: secure
    };
}
function $f2793903606ddf52$export$dd793a89b5871992() {
    if (window.PEEKABABY_SIGNAL_URL) return $f2793903606ddf52$var$fromUrl(window.PEEKABABY_SIGNAL_URL);
    const meta = document.querySelector('meta[name="signal-url"]');
    const fromMeta = meta && meta.content && meta.content.trim();
    if (fromMeta) return $f2793903606ddf52$var$fromUrl(fromMeta);
    // Dev convenience, matching ice.js/push.js: `npm run dev` in turn-worker/
    // serves the broker on :8787, so a locally-served app needs no extra config.
    const { hostname: hostname, protocol: protocol, port: port } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') return {
        host: hostname,
        port: 8787,
        path: '/',
        secure: false
    };
    // Production: same origin as the app (functions/peerjs/).
    return {
        host: hostname,
        port: port ? Number(port) : protocol === 'https:' ? 443 : 80,
        path: '/',
        secure: protocol === 'https:'
    };
}


// Lightweight "Add to Home Screen" banner.
//
// On Chromium browsers we capture the `beforeinstallprompt` event and trigger
// the native install prompt on tap. iOS Safari has no such event, so there we
// fall back to a short manual hint ("tap Share, then Add to Home Screen").
//
// The banner never nags: it stays hidden once the app is already installed
// (standalone display mode) or after the user dismisses it (remembered in
// localStorage).



const $8683377c43c5fe5e$var$DISMISS_KEY = 'peekababy:install-dismissed';
function $8683377c43c5fe5e$var$isStandalone() {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
}
const $8683377c43c5fe5e$var$isDismissed = ()=>(0, $b68ecd39b69a2afc$export$43b36d76881373cf)($8683377c43c5fe5e$var$DISMISS_KEY) === '1';
const $8683377c43c5fe5e$var$rememberDismissed = ()=>(0, $b68ecd39b69a2afc$export$b6f24a8024dbaa15)($8683377c43c5fe5e$var$DISMISS_KEY, '1');
// iOS running Safari — not Chrome/Firefox/Edge on iOS, which can't add to the
// home screen anyway.
function $8683377c43c5fe5e$var$isIosSafari() {
    const ua = navigator.userAgent;
    return (0, $b68ecd39b69a2afc$export$41a665f744414057)() && /safari/i.test(ua) && !/crios|fxios|edgios/i.test(ua);
}
function $8683377c43c5fe5e$export$178efa2b7aa57400() {
    if ($8683377c43c5fe5e$var$isStandalone() || $8683377c43c5fe5e$var$isDismissed()) return;
    const banner = document.getElementById('install-banner');
    if (!banner) return;
    const text = banner.querySelector('.install-text');
    const installBtn = banner.querySelector('.install-action');
    const dismissBtn = banner.querySelector('.install-dismiss');
    const show = ()=>banner.classList.add('show');
    const hide = ()=>banner.classList.remove('show');
    dismissBtn.addEventListener('click', ()=>{
        $8683377c43c5fe5e$var$rememberDismissed();
        hide();
    });
    // Chromium: defer the browser's mini-infobar and drive it from our button.
    let deferredPrompt = null;
    window.addEventListener('beforeinstallprompt', (e)=>{
        e.preventDefault();
        deferredPrompt = e;
        installBtn.hidden = false;
        show();
        (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).PWA_INSTALL_PROMPT_SHOWN, {
            platform: 'chromium'
        });
    });
    installBtn.addEventListener('click', async ()=>{
        if (!deferredPrompt) return;
        deferredPrompt.prompt();
        try {
            await deferredPrompt.userChoice;
        } catch (e) {
        /* ignore */ }
        deferredPrompt = null;
        hide();
    });
    window.addEventListener('appinstalled', ()=>{
        (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).PWA_INSTALLED);
        $8683377c43c5fe5e$var$rememberDismissed();
        hide();
    });
    // iOS Safari can't fire beforeinstallprompt, so show manual instructions.
    if ($8683377c43c5fe5e$var$isIosSafari()) {
        text.textContent = (0, $03c039b69e20a322$export$625550452a3fa3ec)('install.iosHint');
        installBtn.hidden = true;
        show();
        (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).PWA_INSTALL_PROMPT_SHOWN, {
            platform: 'ios'
        });
    }
}


// "A new version is available" toast.
//
// The service worker no longer calls skipWaiting() on install (see sw.js), so a
// freshly-deployed build parks in the `waiting` state instead of swapping in
// silently. This watcher notices that waiting worker and shows a small,
// persistent toast inviting the user to refresh at a moment of their choosing —
// a short, deliberate interruption rather than a surprise reload mid-stream.
//
// Refreshing reloads onto the new build and reconnects the peer automatically:
// the URL hash is preserved, so a parent reconnects to the same host and the
// host reclaims its persisted id.


// Only recheck for a new build this often when the tab regains focus. Baby
// monitors stay open for hours, so a periodic nudge is what surfaces updates
// for them — but we don't want to hammer the server on every tab switch.
const $a3cbaf0e8b640ee5$var$UPDATE_CHECK_INTERVAL = 1800000; // 30 min
// Guards the single reload triggered by the user tapping Refresh. Multiple tabs
// (or a doubled controllerchange) must reload exactly once.
let $a3cbaf0e8b640ee5$var$refreshing = false;
function $a3cbaf0e8b640ee5$var$hideInstallBanner() {
    // The update toast shares the slot just above the toolbar with the host's
    // install banner; hide the banner so they never stack. No need to restore it
    // — the user is about to reload.
    const banner = document.getElementById('install-banner');
    if (banner) banner.classList.remove('show');
}
function $a3cbaf0e8b640ee5$var$applyUpdate(registration) {
    const waiting = registration.waiting;
    if (!waiting) return;
    // Attach the reload handler ONLY now, on the explicit refresh. Attaching it at
    // init would reload first-time visitors, whose very first SW fires
    // controllerchange via clients.claim().
    navigator.serviceWorker.addEventListener('controllerchange', ()=>{
        if ($a3cbaf0e8b640ee5$var$refreshing) return;
        $a3cbaf0e8b640ee5$var$refreshing = true;
        window.location.reload();
    });
    (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).APP_UPDATE_APPLIED);
    waiting.postMessage({
        type: 'SKIP_WAITING'
    });
}
let $a3cbaf0e8b640ee5$var$toastShown = false;
function $a3cbaf0e8b640ee5$var$showToast(registration) {
    const el = document.getElementById('update-toast');
    if (!el || $a3cbaf0e8b640ee5$var$toastShown) return;
    $a3cbaf0e8b640ee5$var$toastShown = true;
    $a3cbaf0e8b640ee5$var$hideInstallBanner();
    const refreshBtn = el.querySelector('.update-action');
    const dismissBtn = el.querySelector('.update-dismiss');
    if (refreshBtn) refreshBtn.addEventListener('click', ()=>$a3cbaf0e8b640ee5$var$applyUpdate(registration));
    if (dismissBtn) // Allow the toast to reappear if another update arrives this session.
    dismissBtn.addEventListener('click', ()=>(0, $b68ecd39b69a2afc$export$c96659240d08478b)(el, ()=>{
            $a3cbaf0e8b640ee5$var$toastShown = false;
        }));
    (0, $b68ecd39b69a2afc$export$39c365eaabfb0a68)(el);
    (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).APP_UPDATE_AVAILABLE);
}
function $a3cbaf0e8b640ee5$export$506a41d9003524d7(registration) {
    if (!registration) return;
    // A build may have finished installing during a previous visit and be waiting
    // already when this page loads.
    if (registration.waiting && navigator.serviceWorker.controller) $a3cbaf0e8b640ee5$var$showToast(registration);
    registration.addEventListener('updatefound', ()=>{
        const installing = registration.installing;
        if (!installing) return;
        installing.addEventListener('statechange', ()=>{
            // `installed` + an existing controller means this replaces a running SW —
            // a real update. On the very first install there's no controller, so we
            // stay quiet.
            if (installing.state === 'installed' && navigator.serviceWorker.controller) $a3cbaf0e8b640ee5$var$showToast(registration);
        });
    });
    // Long-lived tabs (the baby monitor) may not navigate for hours, so nudge the
    // browser to recheck when the tab comes back to the foreground, throttled.
    let lastCheck = Date.now();
    document.addEventListener('visibilitychange', ()=>{
        if (document.visibilityState !== 'visible') return;
        const now = Date.now();
        if (now - lastCheck < $a3cbaf0e8b640ee5$var$UPDATE_CHECK_INTERVAL) return;
        lastCheck = now;
        registration.update().catch(()=>{});
    });
}





// --- Role & flow ------------------------------------------------------------
// The app has three stages, reflected as a `stage-*` class on <body>:
//   role   — the Step 1 picker (baby monitor vs parent)
//   host   — the baby monitor (QR to connect, then the live monitor)
//   client — the parent (scan a QR, then watch)
//
// Role is no longer inferred purely from the URL. A bare URL shows the picker;
// an incoming `#<hostId>` is treated as a deep link and drops the visitor
// straight into the parent flow (scanning the QR with the phone's own camera
// still works, and so does a shared link).
const $34c7519d61f62f71$var$deepLinkHostId = window.location.hash ? window.location.hash.substring(1) : null;
// --- Persistent host identity ----------------------------------------------
// PeerJS assigns a fresh random ID on every load, which means each host reload
// mints a new ID and silently invalidates the QR code / link a viewer already
// scanned. Persisting the host's ID lets it reclaim the same address after a
// reload or crash, so an existing viewer's stored link keeps working and the
// client's auto-reconnect finds the host again without a re-scan.
const $34c7519d61f62f71$var$HOST_ID_KEY = 'cammirror:host-id';
const $34c7519d61f62f71$var$loadStoredHostId = ()=>(0, $b68ecd39b69a2afc$export$43b36d76881373cf)($34c7519d61f62f71$var$HOST_ID_KEY) || null;
const $34c7519d61f62f71$var$saveHostId = (id)=>(0, $b68ecd39b69a2afc$export$b6f24a8024dbaa15)($34c7519d61f62f71$var$HOST_ID_KEY, id);
const $34c7519d61f62f71$var$clearHostId = ()=>(0, $b68ecd39b69a2afc$export$1af2c3526d162e49)($34c7519d61f62f71$var$HOST_ID_KEY);
function $34c7519d61f62f71$var$createPeer(id, iceServers) {
    // signalOptions() pins us to our own broker. Without it PeerJS defaults to its
    // free public cloud, which has no fallback path if it goes down (see signal.js).
    const options = {
        ...(0, $f2793903606ddf52$export$dd793a89b5871992)(),
        config: {
            iceServers: iceServers
        }
    };
    return id ? new (0, $43f09feeac71c3ff$export$ecd1fc136c422448)(id, options) : new (0, $43f09feeac71c3ff$export$ecd1fc136c422448)(options);
}
let $34c7519d61f62f71$var$peer = null;
let $34c7519d61f62f71$var$currentIceServers = null;
let $34c7519d61f62f71$var$role = null; // 'host' | 'client'
let $34c7519d61f62f71$var$appStarted = false;
// How many times a host will retry reclaiming its stored id before giving up
// and minting a fresh one. The signaling broker holds the previous session's
// registration for a few seconds after a reload, so retrying the same id keeps
// existing viewer links/QRs and push subscriptions valid across a host reload.
const $34c7519d61f62f71$var$MAX_RECLAIM = 3;
let $34c7519d61f62f71$var$hostIdReclaimAttempts = 0;
// Resolves once ICE credentials have been fetched. Role selection can happen
// before the fetch finishes (the picker is interactive immediately), so we must
// not create a peer with null iceServers — that would silently drop TURN and
// break connections behind symmetric NATs. startRole() awaits this first.
let $34c7519d61f62f71$var$markIceReady;
const $34c7519d61f62f71$var$iceReady = new Promise((resolve)=>{
    $34c7519d61f62f71$var$markIceReady = resolve;
});
// Only these PeerJS error types permanently destroy the peer and warrant a
// blocking, full-screen message. Everything else is recoverable and must NOT
// tear down the UI: a single dropped ICE candidate on iOS Safari surfaces as a
// non-fatal 'webrtc' error even though the connection still completes.
const $34c7519d61f62f71$var$FATAL_ERROR_TYPES = new Set([
    'browser-incompatible',
    'invalid-id',
    'invalid-key',
    'unavailable-id',
    'ssl-unavailable',
    'server-error',
    'socket-error',
    'socket-closed'
]);
var $d8caaa9312e56e86$exports = {};
$d8caaa9312e56e86$exports = $parcel$resolve("8pkWx");


// Register the service worker so the app is installable and its shell loads
// offline. Parcel compiles ./sw.js as a separate service-worker bundle.
if ('serviceWorker' in navigator) window.addEventListener('load', ()=>{
    navigator.serviceWorker.register($d8caaa9312e56e86$exports).then((reg)=>(0, $a3cbaf0e8b640ee5$export$506a41d9003524d7)(reg)).catch((err)=>console.warn('[CAMMIRROR] Service worker registration failed:', err));
});
// App-wide globals other modules read off `this`/window (kept from the original
// design so host.js / client.js / utils.js can share the live stream + peer).
(function(globals) {
    'use strict';
    globals.profile = null; // set once a role is chosen
    globals.activeVideoStream = null;
    globals.constraints = null;
    globals.lastVolumeLevel = 50;
    globals.peer = null;
    globals.hash = window.location.hash;
    globals.$video = document.querySelector('video');
})((0, eval)('this'));
// Translate static markup as soon as this module evaluates. Module scripts are
// deferred, so the DOM is already parsed here — doing it now (rather than on
// window.onload, which waits for fonts/icons) avoids a flash of English text
// for non-English users before their language is applied.
const $34c7519d61f62f71$var$locale = (0, $03c039b69e20a322$export$8464cdd050ea8737)();

// The landing copy in #seo is pre-rendered per locale, so /de/, /nl/ and friends
// already match. The root page is the English one, but its chrome still follows
// navigator.languages — which would leave e.g. Dutch buttons sitting above
// English prose, and <html lang="nl"> on English content. Swap the copy to match.
// Dynamically imported so the other five locales' text stays out of the main
// bundle, and only fetched when it's actually needed (below the fold anyway).
if ($34c7519d61f62f71$var$locale !== 'en' && !window.location.pathname.replace(/\/+$/, '')) (parcelRequire("4TJBG")).then(({ seoInnerHtml: seoInnerHtml, content: content })=>{
    const seo = document.getElementById('seo');
    if (seo) seo.innerHTML = seoInnerHtml($34c7519d61f62f71$var$locale);
    const hint = document.querySelector('.seo-scroll-label');
    if (hint) hint.textContent = content[$34c7519d61f62f71$var$locale].scrollHint;
}).catch(()=>{
/* landing copy stays English; the app itself is unaffected */ });
// The role picker can carry an optional explainer above the buttons, but only
// when the screen is tall enough to hold it. Three lengths live in i18n
// (short, medium, long); we show the LONGEST that still clears the fixed logo,
// and hide the block entirely if even the short one won't fit. Measuring the
// live DOM (instead of hard-coding height breakpoints) keeps it correct across
// languages, fonts, dynamic browser chrome and safe-area insets.
//
// Why one geometric check is enough: only the two flexible spacers sit ABOVE the
// intro, so the buttons/safety block is always pinned to the bottom and can
// never be pushed off-screen by a longer intro. A too-long variant instead
// grows upward until its top collides with the logo. So "does it fit" reduces to
// "does its top clear the logo with a little breathing room".
const $34c7519d61f62f71$var$ROLE_INTRO_VARIANTS = [
    'long',
    'medium',
    'short'
];
const $34c7519d61f62f71$var$ROLE_INTRO_MIN_GAP = 24; // px of breathing room to keep clear under the logo
function $34c7519d61f62f71$var$fitRoleIntro() {
    const intro = document.getElementById('role-intro');
    if (!intro) return;
    // Only relevant while the role picker is the visible screen.
    if (!document.body.classList.contains('stage-role')) {
        intro.hidden = true;
        return;
    }
    const logo = document.querySelector('.brand-logo');
    const logoBottom = logo ? logo.getBoundingClientRect().bottom : 0;
    intro.hidden = false;
    let chosen = null;
    for (const variant of $34c7519d61f62f71$var$ROLE_INTRO_VARIANTS){
        intro.dataset.variant = variant;
        // Reading the rect forces the reflow, so this reflects the variant just set.
        const introTop = intro.getBoundingClientRect().top;
        if (introTop >= logoBottom + $34c7519d61f62f71$var$ROLE_INTRO_MIN_GAP) {
            chosen = variant;
            break;
        }
    }
    if (chosen) intro.dataset.variant = chosen;
    else {
        intro.hidden = true;
        delete intro.dataset.variant;
    }
}
let $34c7519d61f62f71$var$roleIntroRaf = 0;
function $34c7519d61f62f71$var$scheduleRoleIntroFit() {
    if ($34c7519d61f62f71$var$roleIntroRaf) cancelAnimationFrame($34c7519d61f62f71$var$roleIntroRaf);
    $34c7519d61f62f71$var$roleIntroRaf = requestAnimationFrame(()=>{
        $34c7519d61f62f71$var$roleIntroRaf = 0;
        $34c7519d61f62f71$var$fitRoleIntro();
    });
}
function $34c7519d61f62f71$var$setStage(stage) {
    // Mirror the stage onto <html> as well as <body>: in an installed iOS PWA the
    // safe-area insets are painted from the root element's background, so the
    // role screen's warm bottom bar is driven by html.stage-role (see styles.css).
    [
        document.documentElement,
        document.body
    ].forEach((el)=>{
        el.classList.remove('stage-role', 'stage-host', 'stage-client');
        el.classList.add(`stage-${stage}`);
    });
}
// Reset / back: reload the app at the bare path (no hash) so every peer, camera
// and timer is torn down cleanly and we land back on the role picker. Simpler
// and far more robust than unwinding live media by hand.
function $34c7519d61f62f71$var$resetToRole() {
    // Release a camera primed on the tap but never adopted (the reload below would
    // free it too, but stop it eagerly so the indicator can't linger mid-reload).
    (0, $63e260cbcedef6c4$export$249b5faa0753441b)();
    window.location.assign(window.location.pathname);
}
// Enter the parent flow already aimed at a specific monitor — a shared/scanned
// deep link, or the "Resume watching" shortcut — showing "Connecting…" straight
// away. A cold deep link sets the stage directly (there's no picker to morph
// from); a tap from the picker leaves the stage switch to startRole so it can
// morph. If the monitor is off, the client falls back to the scanner.
function $34c7519d61f62f71$var$connectToHost(hostId, { fromPicker: fromPicker = false, resumed: resumed = false } = {}) {
    if (!fromPicker) $34c7519d61f62f71$var$setStage('client');
    document.body.classList.add('connecting');
    $34c7519d61f62f71$var$startRole('client', {
        hostId: hostId,
        resumed: resumed
    });
}
function $34c7519d61f62f71$var$wirePeer(p, onOpen) {
    p.on('open', (id)=>{
        if ($34c7519d61f62f71$var$role === 'host') $34c7519d61f62f71$var$saveHostId(id);
        $34c7519d61f62f71$var$hostIdReclaimAttempts = 0; // reclaimed (or claimed) successfully
        onOpen(id);
    });
    p.on('error', (err)=>{
        if ($34c7519d61f62f71$var$role === 'host' && err.type === 'unavailable-id' && !$34c7519d61f62f71$var$appStarted) {
            const storedId = $34c7519d61f62f71$var$loadStoredHostId();
            // The broker still has our previous session's registration for a few
            // seconds after a reload. Retry the SAME id first so a host reload doesn't
            // silently orphan viewers (their stored link/QR + push subscription are
            // keyed to this id). Only mint a fresh id once reclaim clearly won't land.
            if (storedId && $34c7519d61f62f71$var$hostIdReclaimAttempts < $34c7519d61f62f71$var$MAX_RECLAIM) {
                $34c7519d61f62f71$var$hostIdReclaimAttempts += 1;
                const delay = 1500 * $34c7519d61f62f71$var$hostIdReclaimAttempts;
                console.warn(`[CAMMIRROR] Host ID busy; reclaim attempt ${$34c7519d61f62f71$var$hostIdReclaimAttempts}/${$34c7519d61f62f71$var$MAX_RECLAIM} in ${delay}ms`);
                try {
                    $34c7519d61f62f71$var$peer.destroy();
                } catch (e) {}
                setTimeout(()=>{
                    if ($34c7519d61f62f71$var$appStarted) return; // a peer opened meanwhile — nothing to do
                    $34c7519d61f62f71$var$peer = $34c7519d61f62f71$var$createPeer(storedId, $34c7519d61f62f71$var$currentIceServers);
                    window.peer = $34c7519d61f62f71$var$peer;
                    $34c7519d61f62f71$var$wirePeer($34c7519d61f62f71$var$peer, onOpen);
                    (0, $137761e831dba805$export$b2a6d706e3dacf48)($34c7519d61f62f71$var$peer);
                }, delay);
                return;
            }
            console.warn('[CAMMIRROR] Stored host ID unavailable, requesting a fresh one.');
            $34c7519d61f62f71$var$clearHostId();
            try {
                $34c7519d61f62f71$var$peer.destroy();
            } catch (e) {}
            $34c7519d61f62f71$var$peer = $34c7519d61f62f71$var$createPeer(null, $34c7519d61f62f71$var$currentIceServers);
            window.peer = $34c7519d61f62f71$var$peer;
            $34c7519d61f62f71$var$wirePeer($34c7519d61f62f71$var$peer, onOpen);
            (0, $137761e831dba805$export$b2a6d706e3dacf48)($34c7519d61f62f71$var$peer);
            return;
        }
        const fatal = $34c7519d61f62f71$var$FATAL_ERROR_TYPES.has(err.type);
        (0, $4a7db14ce90fb7a4$export$34ebde691a789a74)(err.type, fatal);
        if (fatal) {
            // The peer died before Host could adopt the primed camera — free it so it
            // doesn't stay live behind the error screen. No-op if Host already took it.
            (0, $63e260cbcedef6c4$export$249b5faa0753441b)();
            (0, $b68ecd39b69a2afc$export$bd70983939bfdb5c)((0, $03c039b69e20a322$export$625550452a3fa3ec)('error.connection'), {
                backLabel: (0, $03c039b69e20a322$export$625550452a3fa3ec)('common.back')
            });
        } else console.warn(`[CAMMIRROR] Recoverable peer error (${err.type}): ${err.message}`);
    });
    p.on('disconnected', ()=>{
        console.warn('[CAMMIRROR] Peer disconnected, attempting to reconnect...');
        p.reconnect();
    });
}
// Bring up a peer for the chosen role and start Host/Client once it opens.
async function $34c7519d61f62f71$var$startRole(chosen, opts = {}) {
    if ($34c7519d61f62f71$var$role) return; // lock in the first choice synchronously (ignores double taps)
    $34c7519d61f62f71$var$role = chosen;
    profile = chosen;
    // Reveal the chosen screen. When the tap comes from the role picker, morph
    // into it — the logo and QR card carry a shared view-transition-name — for a
    // native push feel. A deep link opens on a fresh load with no prior screen to
    // morph from, so there we just apply the stage directly.
    const fromPicker = document.body.classList.contains('stage-role');
    // The role screen is the only scrollable stage (it carries the landing copy in
    // #seo); every other stage re-locks scrolling. Rewind before the transition
    // starts, not inside it — startViewTransition snapshots the old state up front,
    // so scrolling later would cross-fade between two different scroll offsets and
    // the screen would visibly lurch. A deep link always loads at the top already.
    if (fromPicker) try {
        window.scrollTo(0, 0);
    } catch (e) {}
    const enterRole = ()=>{
        $34c7519d61f62f71$var$setStage(chosen);
        // Parent with no target yet: show the scanner in the same transition so the
        // logo morphs straight into place instead of flashing a blank frame while
        // the peer opens. Client re-adds this class idempotently once it's built.
        if (chosen === 'client' && !opts.hostId) {
            document.body.classList.add('need-scan');
            // "Open camera" can't work until the Client is constructed and wires it
            // (getUserMedia must run under the real tap, so we can't defer the tap).
            // Disable it up front so the early-revealed scanner never shows a dead
            // button; client.js re-enables it the moment the handler is attached.
            const startScan = document.getElementById('start-scan');
            if (startScan) startScan.disabled = true;
        }
    };
    if (fromPicker) (0, $b68ecd39b69a2afc$export$20ac98a4b4fe8b85)(enterRole);
    else enterRole();
    (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).APP_OPENED, {
        role: chosen
    });
    (0, $4a7db14ce90fb7a4$export$6b2a7d5132615086)((0, $4a7db14ce90fb7a4$export$fa3d5b535a2458a1).ROLE_SELECTED, {
        role: chosen,
        deepLink: !!opts.hostId,
        resumed: !!opts.resumed
    });
    if (chosen === 'host') (0, $8683377c43c5fe5e$export$178efa2b7aa57400)();
    // Never create the peer before TURN credentials are in hand.
    if (!$34c7519d61f62f71$var$currentIceServers) await $34c7519d61f62f71$var$iceReady;
    const peerId = chosen === 'host' ? $34c7519d61f62f71$var$loadStoredHostId() : null;
    $34c7519d61f62f71$var$peer = $34c7519d61f62f71$var$createPeer(peerId, $34c7519d61f62f71$var$currentIceServers);
    window.peer = $34c7519d61f62f71$var$peer;
    $34c7519d61f62f71$var$wirePeer($34c7519d61f62f71$var$peer, ()=>{
        if ($34c7519d61f62f71$var$appStarted) return;
        $34c7519d61f62f71$var$appStarted = true;
        (0, $b68ecd39b69a2afc$export$be0877e53743fab2)();
        if (chosen === 'host') new (0, $63e260cbcedef6c4$export$2e2bcd8739ae039)($34c7519d61f62f71$var$peer);
        else new (0, $1a67725c098c7e16$export$2e2bcd8739ae039)($34c7519d61f62f71$var$peer, opts.hostId || null);
    });
    (0, $137761e831dba805$export$b2a6d706e3dacf48)($34c7519d61f62f71$var$peer);
}
function $34c7519d61f62f71$var$wireRolePicker() {
    const chooseHost = document.getElementById('choose-host');
    const chooseClient = document.getElementById('choose-client');
    if (chooseHost) chooseHost.addEventListener('click', ()=>{
        // Advance to the monitor screen FIRST, so nothing about audio priming can
        // hold up the role transition (startRole's stage switch is synchronous).
        $34c7519d61f62f71$var$startRole('host');
        // Acquire the camera/mic NOW, inside this real tap, so iOS Safari shows the
        // permission prompt under user activation. Deferring it until Host is built
        // (after the async ICE fetch + peer 'open') loses the activation and iOS
        // then rejects getUserMedia with NotAllowedError. Best-effort: startCamera()
        // falls back to a fresh request if this didn't run.
        try {
            (0, $63e260cbcedef6c4$export$927a79cc45f962c6)();
        } catch (e) {}
        // Unlock the shared cry-detection AudioContext under the same activation.
        // Without this, iOS leaves it 'suspended' and the host silently never
        // analyses its mic — no cry alerts ever fire. Best-effort.
        try {
            (0, $0b811e50742f6e70$export$6af181c0eda16843)();
        } catch (e) {}
        // Then, still inside this real tap, unlock the lullaby element so a parent
        // can start it remotely later — the monitor won't have a fresh gesture at
        // that point. Best-effort: never let it break role selection.
        try {
            (0, $63e260cbcedef6c4$export$4ed10ee742b6ee53)();
        } catch (e) {}
    });
    if (chooseClient) chooseClient.addEventListener('click', ()=>$34c7519d61f62f71$var$startRole('client'));
    // Returning parent shortcut: if this device recently watched a monitor, offer a
    // one-tap resume so a parent whose app was closed rejoins the still-running
    // monitor without going back to the room to re-scan. Same connecting flow as a
    // deep link; if the monitor is off, the client falls back to the scanner.
    const resumeWatch = document.getElementById('resume-watch');
    const resumeHostId = (0, $b68ecd39b69a2afc$export$1b79c76d26fa31e6)();
    if (resumeWatch && resumeHostId) {
        resumeWatch.addEventListener('click', ()=>$34c7519d61f62f71$var$connectToHost(resumeHostId, {
                fromPicker: true,
                resumed: true
            }));
        // Only surface the shortcut once we've confirmed the monitor is still
        // checking in with the backend. A monitor that's already off would otherwise
        // drop the parent into "Connecting…" that only fails over to the scanner
        // after several dead dials. Presence unknown (backend unreachable / not
        // configured, e.g. local dev) keeps the old optimistic behaviour so the
        // shortcut still appears. Left hidden until we know, so we never flash a
        // resume for a dead monitor.
        (0, $02d65636a04e74fb$export$be60aaa86914f312)(resumeHostId).then((live)=>{
            if (live !== false) resumeWatch.hidden = false;
            // Confirmed live -> show the subtle pulsing dot. Unknown (null) still
            // reveals the shortcut optimistically, but without the dot, so we never
            // signal "live" when we couldn't actually verify it.
            if (live === true) resumeWatch.classList.add('is-live');
        });
    }
    // Scroll down to the landing copy. A button, not an <a href="#seo">, because
    // any location.hash is read as a host id (see deepLinkHostId), so a fragment
    // link would send the visitor into the parent "Connecting…" flow instead.
    const seoScroll = document.getElementById('seo-scroll');
    const seo = document.getElementById('seo');
    if (seoScroll && seo) seoScroll.addEventListener('click', ()=>{
        // Browsers don't derive scroll behaviour from prefers-reduced-motion, so an
        // explicit 'smooth' would animate for people who asked us not to.
        seo.scrollIntoView({
            behavior: (0, $b68ecd39b69a2afc$export$ff7706047246b98b)() ? 'auto' : 'smooth',
            block: 'start'
        });
    });
    // Safety explainer overlay.
    const safetyLink = document.getElementById('safety-link');
    const safetyOverlay = document.getElementById('safety-overlay');
    const openSafety = ()=>{
        if (safetyOverlay) safetyOverlay.hidden = false;
    };
    const closeSafety = ()=>{
        if (safetyOverlay) safetyOverlay.hidden = true;
    };
    if (safetyLink) safetyLink.addEventListener('click', openSafety);
    if (safetyOverlay) safetyOverlay.addEventListener('click', (e)=>{
        if (e.target === safetyOverlay || e.target.closest('.overlay-close')) closeSafety();
    });
    // Reset / back buttons (host connect card + parent scan screen).
    document.querySelectorAll('.reset-btn').forEach((btn)=>btn.addEventListener('click', $34c7519d61f62f71$var$resetToRole));
}
// Wire the picker and handle a deep link as soon as this module evaluates.
// Module scripts are deferred, so the DOM is already parsed here — doing this
// now instead of on window.onload (which waits for icons/fonts) means the role
// buttons are interactive immediately, even on a slow connection.
function $34c7519d61f62f71$var$boot() {
    $34c7519d61f62f71$var$wireRolePicker();
    // Deep link: skip the picker entirely and show "Connecting…" right away so a
    // scanned/shared link doesn't flash the role screen while ICE is fetched.
    if ($34c7519d61f62f71$var$deepLinkHostId) {
        $34c7519d61f62f71$var$connectToHost($34c7519d61f62f71$var$deepLinkHostId);
        return;
    }
    // Otherwise we stay on the role picker (body defaults to `stage-role`). A
    // returning parent gets a one-tap "Resume watching your monitor" shortcut
    // there (see wireRolePicker) so they never have to walk back to the room to
    // re-scan a still-running monitor.
    //
    // Size the optional explainer to the available space now, and keep it in sync
    // as the viewport changes (rotation, browser chrome collapsing, keyboard).
    // Re-run once fonts load too, since text metrics shift the fit.
    $34c7519d61f62f71$var$fitRoleIntro();
    window.addEventListener('resize', $34c7519d61f62f71$var$scheduleRoleIntroFit);
    window.addEventListener('orientationchange', $34c7519d61f62f71$var$scheduleRoleIntroFit);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', $34c7519d61f62f71$var$scheduleRoleIntroFit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then($34c7519d61f62f71$var$scheduleRoleIntroFit).catch(()=>{});
    // The overlap check depends on the logo's measured height, so re-fit once it
    // has actually loaded (its box is 0 before then).
    const brandLogo = document.querySelector('.brand-logo');
    if (brandLogo && !brandLogo.complete) brandLogo.addEventListener('load', $34c7519d61f62f71$var$scheduleRoleIntroFit, {
        once: true
    });
}
$34c7519d61f62f71$var$boot();
// Fetch TURN credentials in the background. startRole() awaits iceReady before
// creating any peer, so a slow/failed fetch (STUN-only fallback, see ice.js)
// never blocks the picker from being usable.
(async ()=>{
    $34c7519d61f62f71$var$currentIceServers = await (0, $137761e831dba805$export$3b480dd5eaedf117)();
    $34c7519d61f62f71$var$markIceReady();
})();


//# sourceMappingURL=cammirror.d8bac831.js.map
